
/* Roadmap v2: jeder Schritt kommt einzeln herein, sobald er beim Scrollen in den Viewport kommt -
   der großzügige Abstand zwischen den Schritten (siehe CSS margin-top) sorgt dafür, dass wirklich
   gescrollt werden muss, bevor der nächste Schritt sich zeigt; kein Timer-Burst, Tempo folgt der
   Nutzerin. Ablauf-Roadmap sitzt hinter einem <details>-Toggle und startet die Beobachtung bei jedem
   Öffnen neu; Einbau-Roadmap beobachtet ihre Schritte einmalig. */
(function(){
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canObserve='IntersectionObserver' in window;

  /* Baut aus den tatsächlichen Dot-Positionen (getBoundingClientRect) eine durchgehende, sanft ge-
     schwungene SVG-Kurve durch alle Punkte - die Zahlen sitzen also exakt AUF der Linie, ganz gleich
     wie hoch ein Schritt durch seinen Text wird. .rm-line-fill wird per stroke-dashoffset entlang der
     echten Pfadlänge animiert, synchron zum Grün-Werden der Punkte (setRoadmapFill). */
  function layoutRoadmapLine(rm){
    const svg=rm.querySelector('svg.rm-line'); if(!svg) return;
    const items=[...rm.querySelectorAll('.rm-item')]; if(!items.length) return;
    /* Messen IMMER in Endlage: die reveal-Transforms (translateY 40px + scale .96) verschieben die
       Dots waehrend der Einblendung - eine Kurve aus diesen Zwischenpositionen zielt spaeter neben
       die Nummern (User-Bug 17.07.2026 "Verzerrungen/Verschiebungen"). rm-measure schaltet die
       Transforms fuer die Messung hart aus. */
    rm.classList.add('rm-measure');
    const rmRect=rm.getBoundingClientRect();
    if(!rmRect.width){ rm.classList.remove('rm-measure'); return; } // Panel hidden - showPanel() ruft erneut
    const h=rm.scrollHeight;
    svg.setAttribute('viewBox',`0 0 ${rmRect.width} ${h}`);
    const pts=items.map(it=>{
      const r=it.querySelector('.rm-dot').getBoundingClientRect();
      return {x:r.left-rmRect.left+r.width/2, y:r.top-rmRect.top+r.height/2};
    });
    /* Pro Schritt: die Linie haelt die Dot-eigene X-Position senkrecht, bis der Text dieses Schritts
       zu Ende ist (itemBottom) - erst danach, im leeren Zwischenraum vor dem naechsten Dot, schwenkt
       sie rueber. So bleibt sie immer auf der Seite gegenueber vom Text und kreuzt ihn nie (User-Fix
       09.07.: Kurve lief vorher mitten durch "Preis und Rechenzettel"). */
    const bottoms=items.map((it,i)=>Math.max(it.getBoundingClientRect().bottom-rmRect.top, pts[i].y));
    rm.classList.remove('rm-measure');
    let d=`M ${pts[0].x} ${pts[0].y}`;
    const dotD=[d]; // Teilpfad, der exakt an Dot i endet
    for(let i=0;i<pts.length;i++){
      d+=` L ${pts[i].x} ${bottoms[i]}`;
      if(i<pts.length-1){
        const swingMidY=(bottoms[i]+pts[i+1].y)/2;
        d+=` C ${pts[i].x} ${swingMidY}, ${pts[i+1].x} ${swingMidY}, ${pts[i+1].x} ${pts[i+1].y}`;
        dotD.push(d);
      }
    }
    const track=svg.querySelector('.rm-line-track'), fill=svg.querySelector('.rm-line-fill');
    track.setAttribute('d',d); fill.setAttribute('d',d);
    rm._rmLen=fill.getTotalLength();
    /* Fuellstand rastet auf den NUMMERN ein, nicht auf Laengen-Bruchteilen: Pfadlaenge bis zu jedem
       Dot einmal exakt vermessen (Segmente sind je nach Textmenge unterschiedlich lang - Fuenftel
       der Gesamtlaenge landeten deshalb irgendwo zwischen den Nummern). */
    const temp=document.createElementNS('http://www.w3.org/2000/svg','path');
    svg.appendChild(temp);
    rm._dotLens=dotD.map(s=>{ temp.setAttribute('d',s); return temp.getTotalLength(); });
    svg.removeChild(temp);
    fill.style.strokeDasharray=String(rm._rmLen);
    /* Den Stand festhalten, zu dem diese Kurve gehoert - driveAll() vergleicht dagegen. */
    rm._rmKennung=(typeof rmKennung==='function')?rmKennung(rm):null;
    /* Nach dem Neuvermessen den zuletzt gefahrenen Stand wieder herstellen - sonst springt die
       Linie bei Resize/Font-Load auf einen Nummern-Raster zurueck. */
    if(rm._scrollDriven) driveRoadmap(rm);
    else setRoadmapFill(rm, parseInt(rm.dataset.rmIdx||'-1',10));
  }
  function setRoadmapFill(rm,idx){
    rm.dataset.rmIdx=String(idx);
    const lens=rm._dotLens;
    if(!lens) return;
    setRoadmapFillLen(rm, idx<0?0:lens[Math.min(idx,lens.length-1)]);
  }
  /* Fuellstand als LAENGE statt als Schritt-Index: nur so kann die Linie zwischen zwei Nummern
     stehen bleiben und dem Scrollen kontinuierlich folgen. Die Rasterung auf die Nummern bleibt
     trotzdem exakt, weil zwischen den GEMESSENEN Teilpfadlaengen interpoliert wird (nicht zwischen
     Bruchteilen der Gesamtlaenge - das war der Bug vom 17.07.2026). */
  function setRoadmapFillLen(rm,len){
    rm._rmFillLen=len;
    const fill=rm.querySelector('.rm-line-fill');
    if(!fill || !rm._rmLen) return;
    fill.style.strokeDashoffset=String(Math.max(0,rm._rmLen-len));
  }

  function watchSteps(rm){
    const items=[...rm.querySelectorAll('.rm-item')];
    if(reduced || !canObserve){
      /* Ohne Bewegung und ohne Observer gibt es kein "hier bist du gerade": alles ist erledigt
         sichtbar, die Linie durchgezogen. Der Fortschrittsbalken zeigt dann den Endstand. */
      items.forEach(it=>{ it.classList.add('in'); it.classList.add('is-past'); });
      setRoadmapFill(rm,items.length-1);
      ensureProgress(rm);   /* sonst haette dieser Modus gar keine Anzeige - updateProgress steigt ohne Box aus */
      updateProgress(rm,items.length-1,items);
      return;
    }
    const io=new IntersectionObserver(entries=>{
      entries.forEach(en=>{
        if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
      });
    },{threshold:.25,rootMargin:'0px 0px -25% 0px'});
    items.forEach(it=>io.observe(it));
    rm._scrollDriven=true;
  }

  /* ---- Scroll-Fuehrung (27.07.2026) ------------------------------------------------------
     Vorher war der Ablauf nach dem einmaligen Einblenden statisch: alle Punkte gleich gruen, kein
     Hinweis, wo man gerade steht. Jetzt bestimmt eine gedachte Fokuslinie im Viewport den aktiven
     Schritt; die Linie waechst kontinuierlich mit und die Anzeige oben sagt, an welchem Schritt
     man ist. Rein lesend, kein Scroll-Hijacking - der Nutzer behaelt das Tempo. */
  const FOCUS=0.58; // Anteil der Viewporthoehe: etwas ueber der Mitte, wo der Blick natuerlich liegt

  function dotCenters(items){
    return items.map(it=>{ const d=it.querySelector('.rm-dot'); const r=d.getBoundingClientRect(); return r.top+r.height/2; });
  }
  function updateProgress(rm,active,items){
    const box=rm._rmProg; if(!box) return;
    const n=items.length, cur=Math.max(0,active+1);
    box.classList.toggle('is-start', active<0);
    box.querySelector('.rm-prog-count').textContent = active<0 ? `${n} Schritte` : `Schritt ${cur} von ${n}`;
    const src = active<0 ? items[0] : items[active];
    const when = src && src.querySelector('.rm-when');
    box.querySelector('.rm-prog-when').textContent = active<0 ? 'Scroll dich durch' : (when?when.textContent.trim():'');
    box.querySelector('.rm-prog-bar i').style.width = Math.round((active<0?0:cur/n)*100)+'%';
  }
  function ensureProgress(rm){
    if(rm._rmProg && rm._rmProg.isConnected) return;
    const box=document.createElement('div');
    box.className='rm-progress';
    box.innerHTML='<span class="rm-prog-count m"></span><span class="rm-prog-when"></span><span class="rm-prog-bar"><i></i></span>';
    rm.parentElement.insertBefore(box,rm);
    rm._rmProg=box;
  }
  function driveRoadmap(rm){
    const items=[...rm.querySelectorAll('.rm-item')];
    if(!items.length || !rm._dotLens || !rm._rmLen) return;
    if(!rm.getBoundingClientRect().height) return;   // Panel zu - showPanel() ruft erneut
    ensureProgress(rm);
    const ys=dotCenters(items), focusY=window.innerHeight*FOCUS, lens=rm._dotLens;
    let active=-1;
    const kasten=rm.getBoundingClientRect();
    /* Kompaktfall (Mobil): Die ganze Liste passt in eine Bildschirmhoehe. Eine absolute
       Fokuslinie haette dann von Anfang an mehrere Punkte ueber sich - der Ablauf startete
       bei Schritt 2. Stattdessen ueber den Wanderweg der Liste durchs Bild rechnen. */
    if(kasten.height < window.innerHeight*0.9){
      const weg = kasten.height + window.innerHeight;
      const gelaufen = window.innerHeight - kasten.top;
      const anteil = Math.max(0, Math.min(1, gelaufen/weg));
      /* Erst ab einem Drittel Sichtbarkeit ueberhaupt zuenden, danach gleichmaessig
         auf die Punkte verteilen - so beginnt es zuverlaessig bei Schritt 1. */
      active = anteil <= 0.34 ? (gelaufen > 0 ? 0 : -1)
        : Math.min(items.length-1, Math.floor((anteil-0.34)/(0.66/items.length)));
    } else {
      /* 2px Toleranz: liegt ein Punkt exakt auf der Fokuslinie, entscheiden sonst Nachkommastellen
         darueber, ob er schon "erreicht" ist - die Linie waere dann voll, die Nummer aber noch nicht
         aktiv. */
      for(let i=0;i<ys.length;i++){ if(ys[i]<=focusY+2) active=i; }
    }
    /* Unter dem letzten Punkt liegt oft zu wenig Inhalt, um ihn noch auf die Fokuslinie zu
       schieben - dann bliebe ausgerechnet der Schlussschritt ("Wir uebernehmen") fuer immer
       ungezuendet. Am Seitenende deshalb hart auf den letzten Schritt klemmen, sofern der auch
       wirklich im Bild ist. */
    const doc=document.documentElement;
    if(window.scrollY+window.innerHeight >= doc.scrollHeight-4 && ys[ys.length-1] < window.innerHeight){
      active=items.length-1;
    }
    let len;
    if(active<0) len=0;
    else if(active>=items.length-1) len=lens[lens.length-1];
    else {
      const span=ys[active+1]-ys[active];
      const f=span>0 ? Math.min(1,Math.max(0,(focusY-ys[active])/span)) : 0;
      len=lens[active]+(lens[active+1]-lens[active])*f;
    }
    /* DIE KLEMME FUER DIE BUEHNE IST AM 28.09.2026 WIEDER ENTFALLEN (Vorgabe Claras: "hier
       darf die braune Linie schon noch langsam nach unten gehen, aber Betonung auf langsam").

       Sie hielt die Fuellung an, solange die Buehne die Fokuslinie ueberdeckte - eine Klemme
       gegen ein Kriechen, das aus der damaligen Bauform kam. Heute klebt die Station im Bild:
       Ihr Punkt bleibt an der Klebekante stehen, waehrend der naechste langsam naeher kommt.
       Die Fuellung rechnet damit von selbst langsam weiter, und genau das ist gewollt. */
    setRoadmapFillLen(rm,len);
    items.forEach((it,i)=>{
      it.classList.toggle('is-past', i<active);
      it.classList.toggle('is-active', i===active);
    });
    updateProgress(rm,active,items);
  }
  /* Beide Roadmaps immer frisch per ID holen: der Theme-Editor ersetzt beim Bearbeiten die ganze
     Section, festgehaltene Knoten zeigen danach ins Leere. */
  function allRoadmaps(){
    /* foerderRoadmap kam am 15.09.2026 dazu (Ablauf der Foerderung). Ohne Eintrag hier
       bliebe die Verbindungslinie ungezeichnet und die Schritte auf opacity:0 stehen -
       die Section waere da und man saehe nichts. */
    return ['ablaufRoadmap','einbauRoadmap','foerderRoadmap'].map(id=>document.getElementById(id)).filter(Boolean);
  }
  allRoadmaps().forEach(watchSteps);

  /* ---- DIE LINIE WIRD BEIM SCROLLEN NACHGEMESSEN (15.10.2026) ----

     Meldung Claras, mit Bildschirmfotos von Ablauf UND Foerderung auf einem grossen Schirm:
     Die Linie lief quer durch die Textbloecke und schwang weit unterhalb des letzten Punktes
     noch einmal aus - ueber die Ueberschrift des naechsten Abschnitts hinweg.

     ZWEI ERKLAERUNGEN HATTE ICH VORHER, UND BEIDE WAREN FALSCH. Nicht "nicht responsiv": Die
     Kurve wird aus den tatsaechlichen Positionen der Punkte gebaut. Und auch nicht nur
     veraltet: Der ResizeObserver von heute frueh meldet jede Groessenaenderung, und das Bild
     sah danach unveraendert aus.

     WAS BLEIBT, SIND VERSCHIEBUNGEN OHNE GROESSENAENDERUNG. Davon gibt es auf diesen beiden
     Seiten mehrere: die Einblend-Animation der Schritte, die klebende Fortschritts-Pille
     darueber, und auf der Ablaufseite die Buehne, in der die Unterschritte seitlich
     durchlaufen. Ein Element kann an eine andere Stelle rutschen, ohne dass sich seine
     Groesse aendert - ResizeObserver schweigt dann, und die zuletzt gezeichnete Kurve zeigt
     auf Positionen von vorhin.

     ALSO WIRD BEIM SCROLLEN GEPRUEFT, ob die Punkte noch dort sind, wo die Kurve sie vermutet.
     Verglichen wird eine kurze Kennung aus Breite, erstem und letztem Punkt und der Unterkante
     des letzten Schritts - vier Messungen, nicht zwanzig. Nur wenn sie sich geaendert hat,
     wird die Kurve neu gebaut.

     HOECHSTENS ALLE 150 ms, und das ist kein Schoenheitswert: layoutRoadmapLine() misst fuer
     jeden Punkt die Pfadlaenge einzeln (getTotalLength), das sind sechs bis acht Messungen an
     einem SVG-Pfad. Jeden Bildaufbau waere das zu teuer; 150 ms sind fuer das Auge sofort und
     fuer den Rechner ein Bruchteil der Arbeit. */
  let driveRaf=0, letzteMessung=0;
  function rmKennung(rm){
    const items=rm.querySelectorAll('.rm-item'); if(!items.length) return '';
    const ersterPunkt=items[0].querySelector('.rm-dot');
    const letzterPunkt=items[items.length-1].querySelector('.rm-dot');
    if(!ersterPunkt || !letzterPunkt) return '';
    const r=rm.getBoundingClientRect();
    const a=ersterPunkt.getBoundingClientRect(), b=letzterPunkt.getBoundingClientRect();
    const u=items[items.length-1].getBoundingClientRect();
    return [Math.round(r.width),
            Math.round(a.left-r.left), Math.round(a.top-r.top),
            Math.round(b.left-r.left), Math.round(b.top-r.top),
            Math.round(u.bottom-r.top)].join('|');
  }
  function driveAll(){
    if(driveRaf) return;
    driveRaf=requestAnimationFrame(()=>{
      driveRaf=0;
      const jetzt=(window.performance&&performance.now)?performance.now():Date.now();
      const pruefen = jetzt-letzteMessung>150;
      if(pruefen) letzteMessung=jetzt;
      allRoadmaps().forEach(rm=>{
        if(pruefen){
          const k=rmKennung(rm);
          /* _rmKennung setzt layoutRoadmapLine() selbst - sonst zoege dieser Vergleich das
             naechste Neuzeichnen gleich wieder nach sich. */
          if(k && k!==rm._rmKennung) layoutRoadmapLine(rm);
        }
        if(rm._scrollDriven) driveRoadmap(rm);
      });
    });
  }
  if(!reduced && canObserve){
    window.addEventListener('scroll',driveAll,{passive:true});
    window.addEventListener('resize',driveAll);
  }

  function layoutAllRoadmapLines(){
    allRoadmaps().forEach(rm=>{ if(!rm._scrollDriven && !reduced && canObserve) watchSteps(rm); layoutRoadmapLine(rm); });
    driveAll();
  }
  window.__layoutAllRoadmapLines=layoutAllRoadmapLines;
  let rmResizeTimer;
  const nachmessen=(ms)=>{ clearTimeout(rmResizeTimer); rmResizeTimer=setTimeout(layoutAllRoadmapLines,ms||150); };
  window.addEventListener('resize',()=>nachmessen(150));
  /* NACHMESSEN, SOBALD SICH IRGENDEINE HOEHE AENDERT (15.10.2026, Meldung Claras: "beim Reiter
     Ablauf auf einem grossen Bildschirm ist die fortlaufende Linie nicht mehr an die
     Textbloecke angepasst - mach es responsiv"; und kurz danach: "das gilt auch beim Reiter
     Foerderung").

     DIE LINIE IST NICHT "NICHT RESPONSIV", SIE IST VERALTET. Sie wird aus den tatsaechlichen
     Positionen der Nummernpunkte gebaut (getBoundingClientRect) und passt deshalb immer - zu
     dem Zustand, in dem zuletzt gemessen wurde. Gemessen wurde bisher beim Laden, nach
     fonts.ready und bei window.resize. Das deckt nicht ab:
       - ZOOM. Browser loesen beim Zoomen nicht zuverlaessig resize aus, die Textbloecke
         brechen aber anders um und werden hoeher. Genau dieser Fall steckt hinter Claras
         "grosser Bildschirm": Auf dem Bildschirmfoto ist die Seite stark vergroessert.
       - DIE SCHRITT-BUEHNE. Auf der Ablaufseite laufen die Unterschritte beim Scrollen
         seitlich durch (Einstellung buehne_an); dabei aendern sich Hoehen, ohne dass das
         Fenster etwas davon merkt.
       - Spaet geladene Bilder und nachtraeglich aufgeklappte Abschnitte.

     ResizeObserver MELDET GENAU DAS: jede Groessenaenderung des Roadmap-Kastens und jedes
     einzelnen Schritts. Beobachtet werden beide Ebenen - der Kasten allein genuegt nicht, weil
     ein Schritt hoeher werden kann, waehrend ein anderer schrumpft und die Gesamthoehe gleich
     bleibt.

     KEINE SCHLEIFENGEFAHR: layoutRoadmapLine() aendert nur das viewBox-Attribut und zwei
     Pfade im SVG, und das SVG liegt mit position:absolute ausserhalb des Flusses - an den
     beobachteten Groessen aendert sich dadurch nichts. Die Klasse rm-measure schaltet
     waehrend des Messens nur Transforms ab, und die zaehlen fuer ResizeObserver nicht.
     Die 120 ms Verzoegerung buendeln die Meldungen: Beim Zoomen kommen sie im Dutzend. */
  if('ResizeObserver' in window){
    const beobachter=new ResizeObserver(()=>nachmessen(120));
    allRoadmaps().forEach(rm=>{
      beobachter.observe(rm);
      rm.querySelectorAll('.rm-item').forEach(it=>beobachter.observe(it));
    });
  }
  /* Webfont laedt nach dem ersten Layout → Texthoehen und damit Dot-Positionen verschieben sich.
     Nach fonts.ready einmal neu vermessen, sonst zeigt die Linie auf die Fallback-Font-Positionen. */
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(()=>layoutAllRoadmapLines());
})();
/* ============ DIE ECHTE HOEHE DER KOPFLEISTE ALS VARIABLE (15.10.2026) ============

   Meldung Claras mit Bildschirmfoto: Auf dem App-Reiter war das Telefon oben angeschnitten -
   seine obere Kante lag unter der Menueleiste.

   DIE URSACHE IST EINE GESCHAETZTE ZAHL. Das Telefon klebt beim Scrollen mit top:64px, und
   64 war die Hoehe der Menueleiste allein. Ueber ihr klebt aber die ganze Section: die gelbe
   Ansageleiste und seit heute die Neuheiten-Leiste darueber. Jede neue Zeile dort schiebt den
   Kopf nach unten, und alles, was sich auf 64 verlassen hat, rutscht darunter. Es war also
   schon vor heute zu knapp und ist mit der neuen Leiste sichtbar geworden.

   GEMESSEN STATT GERECHNET, wie beim Sticky-Balken weiter unten (--stickycta-h): Die Hoehe
   haengt an Schriftgroesse, Zeilenumbruechen der Ansagen und daran, ob die Leisten im Editor
   ueberhaupt angeschaltet sind. Ein ResizeObserver haelt die Zahl aktuell - beim Zoomen, beim
   Drehen des Telefons und wenn eine Ansage auf zwei Zeilen umbricht.

   DER RUECKFALLWERT 94px IST DIE HOEHE OHNE DIE NEUE LEISTE: Wer das Stylesheet ohne dieses
   Skript bekommt, steht damit auf dem Stand von gestern und nicht auf null. */
(function kopfhoeheMessen(){
  const kopf=document.getElementById('shopify-section-billigerwaermepumpe-topbar');
  if(!kopf) return;
  const setzen=()=>{
    const h=Math.round(kopf.getBoundingClientRect().height);
    if(h>0) document.documentElement.style.setProperty('--kopf-h', h+'px');
  };
  setzen();
  if('ResizeObserver' in window) new ResizeObserver(setzen).observe(kopf);
  else window.addEventListener('resize',setzen);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(setzen);
})();

/* =====================================================================
   KONFIGURATION - alles mit "TBD_" ist Platzhalter.
   ===================================================================== */
const CONFIG = {
  SHOP_URL: "https://billigerwaermepumpe.de",
  /* n8n-Webhook: nimmt jeden submitLead() an, ordnet die Nachricht einem Thema zu, benennt den
     Kunden und schickt sie als Mail an info@billigerwaermepumpe.de. Reines Tracking
     (config_complete, checkout_start) wird dort abgezweigt und loest keine Mail aus.
     Workflow "BilligerWP - Leads aus dem Konfigurator", s43B6sG0r01IvWM5.

     Kein Token noetig - der Endpunkt nimmt nur POSTs von dieser Domain an (CORS-Sperre in n8n).
     Deshalb darf die URL hier im Klartext stehen, anders als beim Vamo-Token weiter unten.

     Die Antwort kommt erst, wenn die Mail wirklich raus ist (responseMode "lastNode"). Ein
     r.ok===true in submitLead() heisst also tatsaechlich zugestellt, nicht nur angenommen.

     ACHTUNG Staging-Instanz. Laeuft und ist getestet, aber n8n-staging ist keine Umgebung mit
     Betriebsgarantie. Fuer den Dauerbetrieb gehoert derselbe Workflow auf die Produktions-n8n,
     dann hier nur die Domain tauschen. */
  LEAD_ENDPOINT: "https://n8n-staging.getvamo.de/webhook/bwp-lead",
  /* WISSENS-CHAT (portiert 16.09.2026). Gemini antwortet sofort, aber AUSSCHLIESSLICH aus
     einer Google-Sheet-Wissensdatenbank; bei Auslegungs- und Fremdanlagen-Fragen haengt der
     Fluss serverseitig einen Haftungshinweis an. Fluss yE5eyn5ngClR2IRY.
     Leer oder TBD_ blendet nur den Bot aus - das Formular "Nachricht schreiben" bleibt. */
  CHAT_ENDPOINT: "https://n8n-staging.getvamo.de/webhook/bwp-chat",
  /* EIGENER ENDPUNKT FUER DIE NEWSLETTER-ANMELDUNG (portiert 17.09.2026).
     Der Lead-Fluss entscheidet per Switch zwischen "nur Tracking" und "Anfrage - Mail raus"
     und schickt fuer jede Anfrage eine Mail ans Postfach. Eine Anmeldung ist beides nicht:
     niemand muss sie beantworten, und sie darf das Postfach nicht fluten. Vor allem aber
     haengt am eigenen Fluss (tAaEL4TudcVElERG) das Double-Opt-in: Bestaetigungsmail, Klick,
     dann erst die Willkommensmail MIT dem Code. Ginge die Anmeldung an LEAD_ENDPOINT, bekaeme
     der Kunde seinen Rabattcode NIE - der Fluss dort kennt ihn nicht.
     Leer oder TBD_ heisst: zurueck auf LEAD_ENDPOINT, damit eine Anmeldung nie ins Leere
     laeuft, falls der Endpunkt je verschwindet. */
  RABATT_ENDPOINT: "https://n8n-staging.getvamo.de/webhook/bwp-rabatt",
  /* Vamo-Lead-API (Blueprint v1.2.1, tech-heatos@vamo-energy.com).
     ENDPOINT zeigt BEWUSST NICHT auf die Vamo-API selbst, sondern auf unseren eigenen Proxy.
     Grund: Die Vamo-API verlangt Bearer-Authentifizierung. Dieses Skript wird als Theme-Asset
     ausgeliefert und ist fuer jeden im Quelltext lesbar - ein Token hier waere oeffentlich und
     muesste sofort als kompromittiert gelten. Der Proxy haelt das Token serverseitig, setzt den
     Authorization-Header und reicht Vamos Antwort unveraendert zurueck. Siehe vamo-lead-proxy/. */
  VAMO: {
    /* AKTIV:false stellt die Lead-API zurueck, ohne eine Zeile davon zu entfernen
       (User-Entscheid 29.07.2026 - Anbindung kommt naechste Woche, die Seite geht jetzt live).
       Der Fachbetrieb-Pfad nutzt solange das schlanke Kontaktformular ueber submitLead().
       Zum Scharfschalten: AKTIV auf true, ENDPOINT auf die Proxy-URL. Sonst nichts. */
    AKTIV: false,
    ENDPOINT: "TBD_VAMO_PROXY_URL",
    VERSION: "1.2.1",
    QUELLE: "billigerwaermepumpe.de"
  },
  /* EINBRINGBARKEIT DER HYDROBOX (25.08.2026, User-Wunsch).
     "Vor dem Abschluss muessen wir unbedingt eine Pruefung machen ob die HydroBox
     ueberhaupt in den Keller einbringbar ist. Die Konditionen dazu folgen."

     Die Konditionen liegen NOCH NICHT vor. Deshalb steht hier AKTIV:false und alle
     Schwellen auf null - der Riegel ist gebaut, aber blind, und einbringUrteil() liefert
     konstant 'aus'. Das Verhalten des Shops ist damit unveraendert.

     Zum Scharfschalten: Zahlen eintragen, AKTIV auf true. Sonst nichts. Genau wie bei
     CONFIG.VAMO darueber.

     KEINE ZAHL WIRD HIER GERATEN. Das Kippmass laesst sich aus Breite und Hoehe rechnerisch
     bilden - genau das verbietet der Kommentar an COMPONENT_TECHNIK ("Wo ein Datenblatt
     schweigt, steht hier nichts. Nichts hochrechnen, nichts schaetzen."). Ein selbst
     gerechneter Wert ignoriert Fuesse, Verpackung und Ueberstaende und waere eine Zusage,
     die niemand deckt. Die Werte muessen aus dem Datenblatt kommen.

     Die Schwellen aus VAMO_LUECKEN (65 cm Wegbreite usw.) sind BEWUSST nicht uebernommen:
     die gelten fuer eine Fachbetriebs-Installation, nicht fuer diese Inneneinheit. */
  EINBRINGUNG: {
    AKTIV: false,
    KIPPMASS_MM: null,      /* Diagonalmass beim Einbringen, laut Datenblatt */
    TUER_MIN_CM: null,      /* lichte Tuerbreite */
    TREPPE_MIN_CM: null,    /* lichte Treppenbreite */
    HOEHE_MIN_CM: null,     /* lichte Hoehe auf dem gesamten Weg */
    GEWICHT_KG: null,       /* fuer die Aussage "zu zweit tragbar" */
    QUELLE: "TBD_DATENBLATT"
  },
  MODE: "deposit", // "deposit" | "full" - Entscheid 14.07.2026 (Slack Marc/Jan/Falk): zweistufig. Kunde zahlt heute nur die Reservierung; Buybox zeigt Gesamt, Anzahlung und Restbetrag ehrlich nebeneinander. Liefergebühr/Logistik bewusst offen (Falk-ToDo, "fake it till you make it").
  ANCHOR_VERGLEICH: 30000, // Handwerker-Komplettangebot als Vergleichsanker - User-Entscheid 29.07.2026 (vorher 35.000)
  /* Lesbar geschrieben, weil die Nummer auch angezeigt wird - fuer den tel:-Link werden die
     Leerzeichen beim Rendern entfernt (telLink()). */
  SUPPORT_PHONE: "+49 221 82826808",
  /* Förder-Schätzung nach KfW 458 (Recherche 07/2026: KfW-Merkblatt 458, kfw.de + Presse zum Haushaltsausschuss-Beschluss).
     MODE: "off" = versteckt · "preview" = sichtbar mit Unverbindlich-Hinweis · "live" = nach Jan-Freigabe.
     Offen (Jan): Vertrag braucht aufschiebende Bedingung (Förderzusage). Genaue Belegform für Eigenleistungs-
     Material noch mit KfW abzustimmen - Förderfähigkeit selbst ist laut Merkblatt 458 gegeben, daher unten
     schon eingerechnet (siehe eigenBetraege/EIGENLEISTUNGEN).
     KÜRZUNG BESCHLOSSEN: Haushaltsausschuss hat am 08.07.2026 zugestimmt, neue Bedingungen gelten ab 21.07.2026
     (Übergangsphase 09.–20.07.2026, kein neues BzA in der Zeit, Vertrauensschutz für bestehende BzA). Damit gibt
     es nur noch EIN Regime - der bisherige AKTUELL/REFORM-Vergleich (reformHalfSteps/foerderQuoteReform/
     foerderCapReform/renderReformCard) ist entfernt. Werte 1:1 aus billigerwaermepumpe-foerderrechner-vergleich.html (Excel
     "billigerWaermepumpe Förderrechner 3.0") + Presse. Effizienzbonus (5 %) als eigenständiger BEG-EM-Bonus addiert -
     vom User bestätigt 17.07.2026 (Excel-Basis). Local-Content-Regel ab Q1 2027 (halbe Grundförderung nur
     bei EU-Fertigung) laut User ebenfalls Excel-gedeckt; hier noch nicht abgebildet. */
  FOERDER: {
    MODE:"preview", START:"2026-07-21",
    GRUND:30,
    /* Effizienzbonus und Emissionsminderungszuschlag sind zum 21.07.2026 ersatzlos entfallen
       (Source of Truth: Vamo-Website, bestaetigt durch ADAC und die BEG-Neufassung). Der
       Rechner hatte bis 29.07.2026 weiter 5 Punkte addiert - also zu viel versprochen. */
    EFFIZIENZ:0,
    /* Zwei Deckel statt einem: 80 % nur fuer Selbstnutzende mit zvE bis 30.000 EUR, mit
       mindestens einem minderjaehrigen Kind bis 40.000 EUR. Sonst 70 %. Vorher stand hier
       pauschal 80 - fuer die Mehrheit der Haushalte deutlich zu hoch. */
    CAP:70, CAP_GERINGVERDIENER:80,
    KLIMA_START:16, KLIMA_SCHRITT:4, // 16 % ab 21.07.2026, dann halbjaehrlich -4 Pp: 12/8/4/0
    /* Ab 01.01.2027 faellt die Grundfoerderung fuer ausserhalb der EU gefertigte Waermepumpen
       auf 15 %; EU-gefertigte Geraete halten ueber den Wertschoepfungsbonus die vollen 30 %.
       Fox ESS fertigt in China - siehe PRODUCTS[...].euFertigung. */
    EU_REGEL_AB:"2027-01-01", GRUND_NICHT_EU:15,
    KOSTEN_START:28000, KOSTEN_SCHRITT:750, // Förderfähige-Kosten-Deckel (WE=1): 28.000 € ab Start, danach -750 €/Halbjahr ab Q1 2027
    // zvE-Klassenreihenfolge: b30 (≤30.000 €) · 30_40 · 40_50 · 50_60 · a60 (>60.000 €), Grenzen je Kind +10.000 €
    EK_OHNE_KIND:[40,30,10,0,0],
    EK_MIT_KIND:[40,40,30,10,0]
  },
  /* Förder-Disclaimer, hart formuliert - Stand 09.07.2026: Kürzung vom Haushaltsausschuss am 8. Juli beschlossen,
     neue Bedingungen gelten ab 21. Juli 2026. Werte in diesem Rechner sind bereits die neuen. */
  FOERDER_DISCLAIMER: "Stand 09.07.2026: Der Haushaltsausschuss hat die Kürzung am 8. Juli beschlossen, neue Förderbedingungen gelten ab 21. Juli 2026, die Werte hier sind bereits die neuen, danach sinken Klimabonus und Förderhöchstbetrag planmäßig weiter.",
  /* Energiepreise für den Amortisationsvergleich - PLATZHALTER, Jannik/Jan validieren, regional stark schwankend */
  /* ct/kWh, BDEW/Bundesnetzagentur Juli 2026. "strom" ist der HAUSHALTSSTROMPREIS und gilt fuer
     den bisherigen Energietraeger (Nachtspeicher, Direktheizung). Fuer den Betrieb der Waermepumpe
     gilt WP_STROM: eigener Tarif mit separatem Zaehler, 2026 zwischen 20 und 26 ct/kWh
     (Neukundenschnitt 20,7). Bewusst der obere Rand - die Seite macht Ersparnisaussagen, da wird
     lieber untertrieben. Bis 29.07.2026 wurde faelschlich mit 37 ct gerechnet, dadurch kam bei
     Oelkunden eine NEGATIVE Jahresersparnis heraus. */
  ENERGY_PRICES: { gas:11.1, oel:9.8, pellets:6.5, holz:6.0, strom:37.0, fernwaerme:12.0 },
  WP_STROM: 26.0,
  RULES: {
    DHW_KW_PER_PERSON: 0.2,    // WW-Spitze je Person - VALIDIEREN (Jannik)
    /* Mindestdeckung bei Norm-Aussentemperatur, ab der ein Kit als passend gilt.
       Entscheid User 28.07.2026: 80 % statt vormals 100 %. Begruendung: Der Elektroheizstab
       in der Hydro Box (9 kW laut Datenblatt) uebernimmt die Spitzen an den wenigen kaeltesten
       Tagen - genau dafuer ist eine monoenergetische Anlage ausgelegt. Gilt fuer ALLE Kits,
       nicht mehr nur fuer fox12: der Heizstab sitzt in jeder Inneneinheit. */
    BIVALENT_MIN: 0.80,
    /* HARTE OBERGRENZE FUER DEN HEIZSTAB (14.10.2026, Vorgabe Claras: "der Anteil des
       Heizstabes an der Jahresleistung darf nach VDI 4645 nicht groesser als 5 % sein. Wenn
       diese 5 % ueberschritten werden, empfehlen wir keine der angebotenen Waermepumpen. Wir
       weisen darauf hin, dass der Heizstab-Anteil sehr gross ist und dadurch Effizienz
       verloren geht").

       GEMEINT IST DER JAHRESARBEITS-ANTEIL, nicht der Leistungsanteil bei Norm-Aussentemperatur.
       Die beiden werden regelmaessig verwechselt: Bei sauberer Auslegung traegt der Heizstab
       an einem Auslegungstag durchaus 30 bis 35 % der LEISTUNG - uebers Jahr sind das trotzdem
       nur rund 5 % der ARBEIT, weil solche Tage selten sind. heizstabJahresanteil() rechnet
       genau diese Jahresgroesse, und nur sie wird hier verglichen.

       SIE IST SCHAERFER ALS DAS BIVALENZFENSTER und steht neben ihm, nicht an seiner Stelle:
       Ein Kit kann im Fenster [-8, -2] liegen und trotzdem ueber 5 % kommen - dann gibt es ab
       jetzt keine Empfehlung mehr, sondern den Hinweis. */
    HEIZSTAB_MAX_PCT: 5,
    HYBRID_BAUJAHR: "nach2016", // Gas nach 2016 → Beistell-Pfad - VALIDIEREN (Jannik)
    /* SICHTBARKEIT DES HYBRID-KITS (28.08.2026, User-Entscheid).
       Das Kit wird auf der gesamten Seite ausgeblendet, aber NICHT entfernt: PRODUCTS.hybrid,
       die Beistell-Regel, das Kit-Bild und der Bestellweg bleiben vollstaendig stehen.
       Anlass: von drei Kunden, denen der Rechner den Hybrid empfohlen hat, haben alle drei
       den kompletten Tausch gewaehlt (2 im CRM, 1 in der Bestellung vom 20.08.2026).
       Was beim Ausblenden passiert: hybridMoeglich wird false, damit faellt der Kandidat aus
       der Liste, hybridFits wird false, und die Empfehlung rutscht automatisch auf den
       Ersetzen-Weg - genau den, den ersatzEmpfehlung ohnehin parallel berechnet. Es entsteht
       also keine Luecke, der Kunde bekommt weiterhin eine Empfehlung.
       Der Wert kommt aus der Theme-Einstellung "Hybrid-Kit auf der Seite zeigen" und laesst
       sich damit ohne Push umlegen. Fehlt window.BWP_HYBRID_SICHTBAR (alter Theme-Stand im
       CDN), gilt bewusst false - lieber einmal zu wenig zeigen als ein Produkt, das gerade
       nicht gezeigt werden soll. */
    HYBRID_SICHTBAR: (typeof window!=='undefined' && window.BWP_HYBRID_SICHTBAR === true),
    /* Welche Regel bestimmt Empfehlung und Reihenfolge der Kits?
         'deckung'  = bisher: kleinstes Kit mit Deckung >= BIVALENT_MIN bei T_norm
         'bivalenz' = Vorgabe 31.07.2026: Bivalenzpunkt moeglichst nah an -5 °C (SHK)
       Beide Rechenwege laufen immer mit, sichtbar wird nur der hier gewaehlte. Umschalten
       ist ein Wort - die Bivalenz-Zahlen stehen unabhaengig davon im Lead-Datensatz.

       WARUM NOCH NICHT AKTIV: gemessen am echten Datenblatt landet der Bivalenzpunkt bei
       Heizlasten unter rund 8,5 kW bei JEDEM Kit unter -8 °C, also ausserhalb des Fensters.
       Rund die Haelfte typischer Einfamilienhaeuser bekaeme damit kein Empfohlen-Badge,
       sondern den Hinweis "Dimensionierung pruefen". Das ist kein Rechenfehler, sondern
       das Sortiment: die kleinste Fox liefert bei -5 °C schon 8,6 kW (W35), ein Haus mit
       6 kW Heizlast braucht dort 4,7 kW. Entscheidung darueber liegt beim Betreiber. */
    /* SCHARFGESCHALTET 10.08.2026 (User: "der Heizstab muss mitgerechnet werden, so wie ich das
       damals gesagt habe mit der Regel von Jannik").
       Die alte Deckungsregel verlangte 80 % Leistung aus eigener Kraft bei Norm-Aussentemperatur
       und kannte den Heizstab nicht - obwohl er in jeder Inneneinheit verbaut ist und genau fuer
       diese wenigen Tage da ist. Dadurch landeten grosse, unsanierte Haeuser auf der Warteliste,
       bei denen ein fox12 einen Bivalenzpunkt mitten im empfohlenen Fenster gehabt haette
       (gemessener Fall: 16,6 kW in Mainbernheim, -3,4 °C, Heizstab 8,5 % der Jahresarbeit).
       BEKANNTE FOLGE, bewusst in Kauf genommen: unter rund 7 kW Heizlast liegt der Bivalenzpunkt
       bei JEDEM Kit unter -8 °C, also ausserhalb des Fensters. Diese Haeuser bekommen kein
       Empfohlen-Siegel mehr, sondern den Hinweis "Dimensionierung pruefen" - sie koennen weiterhin
       jedes Kit waehlen und kaufen. */
    AUSWAHL: 'bivalenz'
  }
};

/* =====================================================================
   QUELLDATEN - 1:1 aus billigerWaermepumpe_Auslegungstool_Quelldaten.xlsx (BETA v0.1)
   ===================================================================== */
const HEIZWERT = { /* 1:1 xlsx "Heizwerte" */
  gas_kwh:{f:1,unit:"kWh",src:"direkte Eingabe"},
  gas_m3:{f:11.0,unit:"m³",src:"DVGW G 685 · Erdgas H 11,0 kWh/m³"},
  gas_m3_l:{f:9.5,unit:"m³",src:"DVGW G 685 · Erdgas L 9,5 kWh/m³"},
  gas_fluessig_l:{f:7.0,unit:"l",src:"DVGW G 260 · Flüssiggas 7,0 kWh/l"},
  oel_l:{f:10.0,unit:"l",src:"DIN 51603-1 · 10,0 kWh/l"},
  pellets_kg:{f:4.8,unit:"kg",src:"DINplus · 4,8 kWh/kg"},
  pellets_t:{f:4800,unit:"t",src:"DINplus · 4,8 kWh/kg"},
  hack_kg:{f:3.5,unit:"kg",src:"VDI 4708 · Hackschnitzel 3,5 kWh/kg"},
  holz_rm:{f:1500,unit:"rm",src:"VDI 4708 · Buche 1.500 kWh/rm"},
  holz_rm_fichte:{f:1250,unit:"rm",src:"VDI 4708 · Fichte 1.250 kWh/rm"},
  strom_kwh:{f:1,unit:"kWh",src:"direkte Eingabe"},
  fw_kwh:{f:1,unit:"kWh",src:"direkte Eingabe"}
};
/* Nutzungsgrade - kanonisch aus xlsx "Nutzungsgrade" (DIN V 18599-5 + VDI 4650/BAFA).
   KONFLIKT PDF-Herleitung ↔ xlsx, Entscheidung Jannik:
   · Pellets: PDF 0,82 / xlsx 0,85 (implementiert) · Stückholz: PDF 0,72 / xlsx 0,85
   · Strom-Direkt: PDF 1,00 / xlsx 0,98 (implementiert) · Bestands-WP: PDF pauschal 2,8 / xlsx 3,5-3,0-2,5 (implementiert)
   · Gas-BW "ab 2010: 0,98" steht nur im PDF, nicht in der xlsx
   Auto-Regel Baujahr→BW/NT-Zeile (kein Kesseltyp abgefragt): VALIDIEREN (Jannik) */
const ETA = {
  gas:   {nach2016:[0.92,"Gas-Brennwert ab 1995"], y1995_2016:[0.92,"Gas-Brennwert ab 1995"], y1980_1994:[0.82,"Gas-NT 1980–1994"], vor1980:[0.78,"Gas vor 1980"]},
  oel:   {nach2016:[0.92,"Öl-Brennwert ab 1995"],  y1995_2016:[0.92,"Öl-Brennwert ab 1995"],  y1980_1994:[0.82,"Öl-NT vor 1995"],  vor1980:[0.82,"Öl-NT vor 1980"]},
  pellets:{all:[0.85,"Pellet/Holz"]}, holz:{all:[0.85,"Pellet/Holz"]},
  strom: {all:[0.98,"Strom-Direkt"]}, fernwaerme:{all:[0.95,"Fernwärme"]},
  wp:    {nach2016:[3.5,"WP ab 2020 (JAZ)"], y1995_2016:[3.0,"WP 2010–2019 (JAZ)"], y1980_1994:[2.5,"WP vor 2010 (JAZ)"], vor1980:[2.5,"WP vor 2010 (JAZ)"]}
};
/* FEINERE NUTZUNGSGRADE FUER GAS UND OEL (14.10.2026, Vorgabe Claras: "grobe Liste wie heute,
   aber wenn man bei Gas und Oel klickt, ploppt die Frage nach der genauen Heizart auf, bei den
   anderen geht es direkt mit der naechsten Frage weiter").

   WARUM DAS UEBERHAUPT ETWAS BRINGT: ETA oben kennt nur den Energietraeger und das Baujahr und
   setzt fuer Gas ab 1995 pauschal 0,92 an - den Wert eines Brennwertkessels. Eine Gastherme ohne
   Brennwert liegt aber auch im Baujahr 2004 bei 0,80. Bei 20.000 kWh sind das rund 2.400 kWh
   weniger Nutzwaerme und damit gut 2 kW weniger Heizlast. Genau diese Spreizung fehlte bisher.

   NUR GAS UND OEL: Bei Pellets, Holz, Strom und Fernwaerme gibt es diese Spreizung nicht - ETA
   fuehrt dort ein einziges 'all'. Eine Nachfrage waere eine Frage ohne Antwortnutzen.

   DIE BAUJAHR-SPANNEN SIND DIESELBEN WIE OBEN, damit beide Tabellen am selben Schluessel haengen.
   Werte aus dem Auslegungstool (nutzungsgradHeizung), dort nach drei Baualtersbaendern:
   ab 1995 / 1980-1994 / davor.

   'unklar' STEHT ABSICHTLICH NICHT IN DER TABELLE: Wer die Bauart nicht kennt, faellt auf ETA
   zurueck - also auf genau das Ergebnis, das der Rechner vor dieser Aenderung geliefert hat. */
const ETA_DETAIL = {
  gas_bw: {nach2016:[0.92,"Gas-Brennwert ab 1995"], y1995_2016:[0.92,"Gas-Brennwert ab 1995"], y1980_1994:[0.87,"Gas-Brennwert 1980–1994"], vor1980:[0.78,"Gas-Brennwert vor 1980"]},
  gas_nt: {nach2016:[0.88,"Gas-Niedertemperatur ab 1995"], y1995_2016:[0.88,"Gas-Niedertemperatur ab 1995"], y1980_1994:[0.82,"Gas-Niedertemperatur 1980–1994"], vor1980:[0.78,"Gas-Niedertemperatur vor 1980"]},
  gas_hw: {nach2016:[0.80,"Gastherme ohne Brennwert ab 1995"], y1995_2016:[0.80,"Gastherme ohne Brennwert ab 1995"], y1980_1994:[0.76,"Gastherme ohne Brennwert 1980–1994"], vor1980:[0.72,"Gastherme ohne Brennwert vor 1980"]},
  oel_bw: {nach2016:[0.92,"Öl-Brennwert ab 1995"], y1995_2016:[0.92,"Öl-Brennwert ab 1995"], y1980_1994:[0.87,"Öl-Brennwert 1980–1994"], vor1980:[0.78,"Öl-Brennwert vor 1980"]},
  oel_nt: {nach2016:[0.88,"Ölkessel ab 1995"], y1995_2016:[0.88,"Ölkessel ab 1995"], y1980_1994:[0.82,"Ölkessel 1980–1994"], vor1980:[0.78,"Ölkessel vor 1980"]}
};
/* Welche Nachfrage gehoert zu welchem Energietraeger? Leer = keine Nachfrage, der Funnel
   ueberspringt den Schritt. */
const HEIZART_DETAIL = {
  gas:[["gas_bw","Gas-Brennwertkessel","meist ab 2000, Abgasrohr aus Kunststoff"],
       ["gas_hw","Ältere Gastherme ohne Brennwert","Abgas über den Schornstein, oft vor 2000"],
       ["gas_nt","Gas-Niedertemperaturkessel","bodenstehend, meist 1990 bis 2010"],
       ["unklar","Weiß ich nicht","dann rechnen wir wie bisher"]],
  oel:[["oel_bw","Öl-Brennwertkessel",""],
       ["oel_nt","Ölkessel (Standard oder Niedertemperatur)",""],
       ["unklar","Weiß ich nicht","dann rechnen wir wie bisher"]]
};
/* DIN 4708 - xlsx & PDF geben q_wd = 14,9 an, aber die PDF-Beispielrechnung
   (4 Pers · 365 / 0,60 = 3.626 kWh) funktioniert nur mit 1,49 → Dezimalfehler in den
   Quelldaten, implementiert: 1,49. VALIDIEREN (Jannik).
   Komfort 0,8–1,4 & eta_w 0,60/0,45/0,30 aus xlsx; Smart Default: mittel + ohne Zirkulation */
const WW = {
  /* PUNKT 2 (28.08.2026, Vamo Auslegungstool BETA v0.3).
     Vorher: qwd 1,49 * Komfortfaktor * Personen * 365 / etaw, wobei etaw von 0,60 auf 0,30
     umschaltete, sobald eine Zirkulation vorhanden war. Der Denkfehler: damit skalierte der
     Zirkulationsverlust mit der Personenzahl und der Komfortstufe. Ein Zirkulationsverlust
     haengt aber an Leitungslaenge und Pumpenlaufzeit, nicht daran, wie viele Leute duschen.
     Quelle DIN V 18599-8.
     Jetzt: Q_WW = (14,9 * q_bp * Personen + Q_zirk) / 0,85.

     ZUR EINORDNUNG IN DIESEM CODE: der Rechner fragt die Zirkulation nicht ab (A.zirk steht
     fest auf 'unklar'), der 0,30-Zweig ist hier also nie gelaufen. Die im Quelldokument
     genannte Verzerrung von 14-21 % gab es im Konfigurator nicht - wohl aber die falsche
     Kopplung an die Personenzahl, sobald die Frage einmal gestellt wird.
     ZIRK_STANDARD steht auf true, weil der Referenzfall des Dokuments von einer Zirkulation
     ausgeht und damit auf die dort erwarteten 909 kWh fuehrt. Wird die Frage spaeter
     gestellt, ersetzt die Antwort diesen Vorgabewert. */
  KOEFF: 14.9,          /* kWh je Liter Tagesbedarf und Jahr */
  ETA:   0.85,          /* Nutzungsgrad der Warmwasserbereitung, jetzt konstant */
  ZIRK_KWH: 400,        /* DIN V 18599-8: kurz/zeitgesteuert ~300, ungedaemmt/dauernd 600-800 */
  ZIRK_STANDARD: true,
  /* Tagesbedarf je Person in Litern. Das Dokument nennt drei Stufen (25/37,5/50); der
     Konfigurator kennt vier. 'niedrig' ist mit dem bisherigen Faktor 0,8 auf 20 l skaliert,
     damit die vierte Stufe nicht erfunden wirkt. */
  QBP: {niedrig:20, normal:25, hoch:37.5, premium:50}
};
/* VDI 4645 */
const SAN = { saniert:{r:0.05,tg:15,label:"saniert"}, teilsaniert:{r:0.10,tg:16,label:"teilsaniert"}, unsaniert:{r:0.15,tg:17,label:"unsaniert"} };
/* Fox ESS Performance-Matrix - 1:1 xlsx "Fox_ESS_Perf" inkl. W65 + COP.
   Routing nutzt W35/45/55; W65 (Altbau-Radiatoren 60–70 °C VL) nur Daten, Routing-Regel offen - VALIDIEREN (Jannik) */
const PERF = {
  fox8: {model:"Fox ESS HP3-8-E",  t:[-15,-7,2,7],
    W35:[6.29,8.16,10.26,11.98], W45:[6.04,7.83,9.85,11.51], W55:[5.80,7.52,9.46,11.05], W65:[5.57,7.23,9.09,10.62],
    C35:[2.59,3.17,3.82,4.81],   C45:[2.26,2.77,3.35,4.07],  C55:[1.92,2.38,2.89,3.34],  C65:[1.53,1.89,2.30,2.65]},
  fox10:{model:"Fox ESS HP3-10-E", t:[-15,-7,2,7],
    W35:[6.81,8.62,10.66,13.00], W45:[6.54,8.28,10.24,12.49], W55:[6.28,7.95,9.83,11.99], W65:[6.03,7.64,9.44,11.52],
    C35:[2.61,3.13,3.72,4.71],   C45:[2.24,2.70,3.21,3.61],  C55:[1.92,2.37,2.87,3.22],  C65:[1.61,1.98,2.41,2.70]},
  /* DIY-KIT 5 kW (13.10.2026, Vorgabe Claras: "hier stehen die Leistungsdaten der Fox 5 kW
     drin, bitte beruecksichtige diese bei dem Rechner, sodass wenn jemand auch einen Verbrauch
     hat, der zu 5 kW passt, das 5-kW-Kit empfohlen wird").

     QUELLE: 5KW-max-20260812.pdf, die MAX-Tabelle. Zwei Blaetter kamen - MIN und MAX; hier
     gehoert die MAX hin, und das ist nachgeprueft und nicht gewaehlt: Die Zeilen der drei
     HP3-Kits tragen bei +7 °C und 35 °C Vorlauf 11,98 / 13,00 / 15,86 kW, das Datenblatt der
     Aussseneinheit nennt als NENNleistung dagegen 8 / 10 / 12 kW. PERF fuehrt also die
     Maximalleistung, und die MIN-Tabelle ist die untere Modulationsgrenze - mit ihr ausgelegt
     waere jedes Kit um ein Vielfaches zu klein.

     DIE VIER SPALTEN SIND AUS DEN DREIZEHN DES DATENBLATTS GEGRIFFEN (-25 bis +20); PERF
     braucht genau -15, -7, +2, +7 wie bei den anderen Kits. Nicht interpoliert, sondern
     abgelesen: Alle vier Temperaturen stehen dort als eigene Spalten.

     W65 BEI -25 °C FEHLT IM DATENBLATT (dort steht ein Schraegstrich). Das stoert hier nicht,
     weil -25 keine der vier Stuetzstellen ist - aber wer die Reihe spaeter erweitert, findet
     an dieser Stelle keine Zahl und darf keine erfinden. */
  fox5: {model:"Fox ESS HP1-5-E",  t:[-15,-7,2,7],
    W35:[3.78,4.79,5.92,7.22], W45:[3.63,4.60,5.69,6.94], W55:[3.47,4.39,5.43,6.63], W65:[3.33,4.22,5.22,6.36],
    C35:[2.48,2.98,3.54,4.47],  C45:[2.16,2.60,3.11,3.78], C55:[1.83,2.23,2.68,3.10], C65:[1.46,1.77,2.13,2.47]},
  fox12:{model:"Fox ESS HP3-12-E", t:[-15,-7,2,7],
    W35:[9.24,11.42,13.87,15.86], W45:[8.88,10.97,13.32,15.23], W55:[8.52,10.53,12.79,14.63], W65:[8.19,10.12,12.29,14.05],
    C35:[2.61,3.09,3.62,4.18],   C45:[2.27,2.70,3.18,3.63],  C55:[1.92,2.31,2.75,3.08],  C65:[1.57,1.88,2.24,2.51]}
};
/* ================= DATENBLATTWERTE DER AUSSENEINHEIT (17.09.2026) =================
   Quelle: "HP SERIE - Luft/Wasser-Monoblock-Waermepumpe, Datenblatt V2.0 | 2026/06/12",
   Spalten HP3-8-E / HP3-10-E / HP3-12-E. Abgetippt, nicht gerechnet - wo das Datenblatt
   schweigt, steht hier nichts. Dieselbe Regel wie bei COMPONENT_TECHNIK.

   WARUM NEBEN PERF UND NICHT DARIN: PERF traegt die KENNLINIE (Leistung und COP bei -15,
   -7, +2 und +7 °C, vier Vorlauftemperaturen) und speist die Auslegung. Hier stehen die
   NENNPUNKTE des Datenblatts (A7W35, A7W55) und die physischen Daten. Beides sind richtige
   Zahlen ueber dasselbe Geraet, aber verschiedene Groessen: Bei +7 °C nennt PERF fuer das
   8-kW-Kit 11,98 kW Maximalleistung, das Datenblatt 8,00 kW Nennleistung. Wer sie in eine
   Tabelle mischt, macht aus zwei richtigen Angaben eine falsche.

   HYBRID FEHLT ABSICHTLICH: Das Beistell-Geraet ist eine andere Maschine (MHG ecoWP2 Xm)
   und hat dieses Datenblatt nicht. Wer es hier suchte, bekaeme undefined - der Aufrufer
   prueft das und laesst den Abschnitt dann weg. */
const AUSSEN_GEMEINSAM = [
  ["Stromversorgung","380–415 V 3N~50 Hz"],
  ["Kältemittel","R290, 1,5 kg Werksladung"],
  ["Inverter","doppelt rotierender DC-Inverter"],
  ["Außenlüfter","bürstenloser DC-Motor, 1 Lüfter"],
  ["Expansionsventil","elektronisch"],
  ["Wärmetauscher","luftseitig Rippenrohr, wasserseitig Plattenwärmetauscher"],
  ["Abmessungen (B×H×T)","1291 × 945 × 430 mm"],
  ["Verpackungsmaße (B×H×T)","1350 × 1165 × 520 mm"],
  ["Rohrleitungsanschlüsse","G 1\""],
  ["Betrieb Heizung","−25 bis 45 °C Außentemperatur"],
  ["Wasseraustritt Heizung","18 bis 75 °C"]
];
const AUSSEN_TECHNIK = {
  fox8:  { modell:"Fox ESS HP3-8-E",  daten:[
    ["Heizleistung A7W35","8,00 kW bei 1,60 kW Aufnahme, COP 5,00"],
    ["Heizleistung A7W55","8,00 kW bei 2,56 kW Aufnahme, COP 3,13"],
    ["SCOP","5,15 bei 35 °C Vorlauf · 3,94 bei 55 °C"],
    ["Energieeffizienzklasse","A+++ bei 35 °C Vorlauf · A+++ bei 55 °C"],
    ["Schallleistungspegel","49 dB"],
    ["Schalldruckpegel in 1 m","42 dB"],
    ["Nettogewicht","180 kg"],
    ["Bruttogewicht","200 kg"]] },
  fox10: { modell:"Fox ESS HP3-10-E", daten:[
    ["Heizleistung A7W35","10,00 kW bei 2,04 kW Aufnahme, COP 4,90"],
    ["Heizleistung A7W55","10,00 kW bei 3,31 kW Aufnahme, COP 3,02"],
    ["SCOP","4,93 bei 35 °C Vorlauf · 3,85 bei 55 °C"],
    ["Energieeffizienzklasse","A+++ bei 35 °C Vorlauf · A+++ bei 55 °C"],
    ["Schallleistungspegel","50 dB"],
    ["Schalldruckpegel in 1 m","43 dB"],
    ["Nettogewicht","180 kg"],
    ["Bruttogewicht","200 kg"]] },
  fox12: { modell:"Fox ESS HP3-12-E", daten:[
    ["Heizleistung A7W35","12,00 kW bei 2,73 kW Aufnahme, COP 4,40"],
    ["Heizleistung A7W55","12,00 kW bei 4,26 kW Aufnahme, COP 2,82"],
    ["SCOP","4,56 bei 35 °C Vorlauf · 3,58 bei 55 °C"],
    ["Energieeffizienzklasse","A+++ bei 35 °C Vorlauf · A++ bei 55 °C"],
    ["Schallleistungspegel","52 dB"],
    ["Schalldruckpegel in 1 m","45 dB"],
    ["Nettogewicht","180 kg"],
    ["Bruttogewicht","200 kg"]] },
  /* DIY-KIT 5 kW - WERTE AUS DEM DATENBLATT (13.10.2026, Vorgabe Claras: "bei den naeheren
     Infos der Aussseneinheit kannst du die Infos auch aus dem Datenblatt ziehen, das eh schon
     hinterlegt ist. Die 5 kW heisst in diesem Datenblatt Fox ESS HP1-5-E").

     QUELLE: Fox_ESS__Au_eneinheit.pdf aus den Shopify-Dateien - dieselbe HP-Serien-Tabelle
     V2.0 | 2026/06/12, aus der auch die drei HP3-Spalten stammen. Am 12.10.2026 stand hier
     noch "Sie sind nicht bekannt"; sie waren es, nur lag die Datei nicht im Repository.

     DIE SPALTENFOLGE IST NACHGEPRUEFT, NICHT ANGENOMMEN: Die Zahlenreihe hinter HP3-8-E im
     Datenblatt lautet 49 42 180 200 8,00 1,60 5,00 8,00 2,56 3,13 ... 5,15 3,94 - und genau
     diese Werte stehen seit jeher in fox8 oben. Eine Reihe, die an einem bekannten Eintrag
     aufgeht, trifft auch beim unbekannten.

     WAS NICHT UEBERNOMMEN IST, UND WARUM: Stromversorgung, Abmessungen und Kaeltemittelmenge
     stehen im Datenblatt in Zeilen mit zusammengefassten Zellen - beim Auslesen bleibt davon
     eine Werteliste ohne erkennbare Zuordnung zur Spalte. Fuer die HP3-Reihe sind sie laengst
     belegt (AUSSEN_GEMEINSAM), fuer das HP1-5-E waeren sie geraten. Dass dieses Geraet
     deutlich leichter ist (130 statt 180 kg), spricht ohnehin gegen dieselben Masse.

     ohneGemeinsam:true BLEIBT GENAU DESHALB STEHEN. Ohne das Flag haengte die Tabelle
     AUSSEN_GEMEINSAM an - also die Masse und die Kaeltemittelmenge der HP3-Reihe unter einem
     HP1, und zwar als gesicherte Datenblattzeile. */
  fox5:  { modell:"Fox ESS HP1-5-E", daten:[
    ["Heizleistung A7W35","5,00 kW bei 1,00 kW Aufnahme, COP 5,00"],
    ["Heizleistung A7W55","5,00 kW bei 1,54 kW Aufnahme, COP 3,25"],
    ["SCOP","4,84 bei 35 °C Vorlauf · 3,85 bei 55 °C"],
    ["Energieeffizienzklasse","A+++ bei 35 °C Vorlauf · A+++ bei 55 °C"],
    ["Schallleistungspegel","49 dB"],
    ["Schalldruckpegel in 1 m","42 dB"],
    ["Nettogewicht","130 kg"],
    ["Bruttogewicht","150 kg"]], ohneGemeinsam:true }
};
const AUSSEN_QUELLE = "Fox ESS HP-Serie Datenblatt V2.0 (2026/06/12)";
/* DWD TRY 2017, 8.197 PLZ - xlsx kanonisch, VALIDIEREN (Jannik) */
const PLZ_RAW = "01067,-123,105,Dresden;01069,-124,104;01097,-121,109;01099,-140,93;01108,-139,95;01109,-138,95;01127,-126,103;01129,-128,100;01139,-127,101;01156,-138,93;01157,-126,102;01159,-126,102;01169,-133,98;01187,-128,100;01189,-133,97;01217,-129,99;01219,-126,103;01237,-127,102;01239,-128,100;01257,-128,102;01259,-128,101;01277,-127,103;01279,-131,99;01307,-125,104;01309,-126,103;01324,-139,94;01326,-139,93;01328,-139,89;01445,-128,100,Radebeul;01454,-140,93,Radeberg, Wachau;01458,-136,96,Ottendorf-Okrilla;01465,-139,95,Dresden;01468,-138,96,Moritzburg;01471,-136,96,Radeburg;01477,-140,92,Arnsdorf b. Dresden;01558,-135,97,Großenhain;01561,-136,96,Großenhain, Ebersbach u.a.;01587,-133,97,Riesa;01589,-133,97;01591,-129,97;01594,-136,96,Riesa, Stauchitz, Hirschstein;01609,-133,96,Gröditz, Wülknitz, Röderaue;01612,-136,97,Nünchritz, Glaubitz;01616,-130,97,Strehla;01619,-130,96,Zeithain;01623,-136,96,Lommatzsch;01640,-130,99,Coswig;01662,-129,100,Meißen;01665,-135,95,Käbschütztal, Klipphausen, Diera-Zehren;01683,-138,93,Nossen;01689,-134,98,Weinböhla;01705,-134,95,Freital;01723,-138,90,Wilsdruff;01728,-137,91,Bannewitz;01731,-137,93,Kreischa;01734,-138,89,Rabenau;01737,-138,87,Tharandt u.a.;01738,-138,87,Dorfhain;01744,-139,81,Dippoldiswalde;01762,-146,71,Hartmannsdorf-Reichenau;01768,-140,80,Glashütte;01773,-152,58,Altenberg;01774,-139,83,Klingenberg;01776,-149,64,Hermsdorf;01778,-145,70,Altenberg;01796,-135,93,Pirna, Struppen, Dohma;01809,-138,93,Heidenau;01814,-137,90,Bad Schandau;01816,-141,80,Bad Gottleuba-Berggießhübel;01819,-137,87,Bahretal;01824,-139,85,Königstein/Sächs. Schw.;01825,-141,83,Liebstadt;01829,-136,92,Wehlen;01833,-136,91,Stolpen, Dürrröhrsdorf-Dittersbach;01844,-141,85,Neustadt i. Sa.;01847,-137,90,Lohmen;01848,-140,85,Hohnstein;01855,-137,88,Sebnitz;01877,-141,88,Bischofswerda u.a.;01896,-141,91,Pulsnitz;01900,-140,91,Großröhrsdorf, Bretnig-Hauswalde;01904,-147,80,Neukirch/Lausitz;01906,-142,91,Burkau;01909,-139,89,Großharthau, Frankenthal;01917,-141,95,Kamenz;01920,-144,94,Elstra, Oßling u.a.;01936,-141,95,Königsbrück u.a.;01945,-142,95,Ruhland;01968,-142,95,Senftenberg;01979,-135,95,Lauchhammer;01983,-142,94,Großräschen;01987,-139,95,Schwarzheide N.L.;01990,-135,96,Ortrand;01993,-143,95,Schipkau;01994,-143,94;01996,-144,95,Senftenberg;01998,-143,94,Schipkau;02625,-143,92,Bautzen;02627,-144,93,Weißenberg, Hochkirch u.a.;02633,-143,92,Göda;02681,-143,89,Wilthen;02689,-143,86,Sohland a. d. Spree;02692,-143,90,Doberschau-Gaußig, Großpostwitz, Obergurig;02694,-145,94,Großdubrau, Malschwitz;02699,-145,94,Königswartha;02708,-146,88,Löbau, Kottmar u.a.;02727,-153,79,Ebersbach-Neugersdorf;02730,-152,82;02733,-146,86,Cunewalde;02736,-149,84,Beiersdorf, Oppach;02739,-153,82,Kottmar;02742,-146,85,Neusalza-Spremberg;02747,-150,85,Herrnhut;02748,-145,89,Bernstadt;02763,-143,89,Zittau u.a.;02779,-151,84,Großschönau;02782,-151,83,Seifhennersdorf;02785,-149,86,Olbersdorf;02788,-153,83,Zittau;02791,-150,85,Oderwitz;02794,-153,82,Leutersdorf, Spitzkunnersdorf;02796,-155,78,Jonsdorf;02797,-155,79,Oybin;02799,-154,77,Großschönau;02826,-138,93,Görlitz;02827,-144,90;02828,-144,90;02829,-144,90,Markersdorf, Neißeaue u.a.;02894,-145,90,Reichenbach, Vierkirchen;02899,-146,88,Östritz, Schönau-Berzdorf;02906,-146,93,Niesky, Hohendubrau u.a.;02923,-144,92,Hähnichen, Horka, Kodersdorf;02929,-143,92,Rothenburg/O.L.;02943,-146,94,Weißwasser, Boxberg;02953,-147,93,Bad Muskau, Groß Düben, Gablenz;02956,-145,92,Rietschen;02957,-145,93,Krauschwitz, Weißkeißel;02959,-144,93,Schleife;02977,-143,95,Hoyerswerda;02979,-142,95,Spreetal, Elsterheide;02991,-141,95,Lauta;02994,-145,95,Bernsdorf;02997,-143,95,Wittichenau;02999,-143,94,Lohsa;03042,-138,97,Cottbus;03044,-134,99;03046,-133,99;03048,-139,96;03050,-135,97;03051,-138,95;03052,-140,95;03053,-140,95;03054,-140,95;03055,-140,95;03058,-139,95,Neuhausen/Spree;03096,-138,96,Burg/Spreewald u. a.;03099,-138,95,Kolkwitz;03103,-144,94,Neu-Seeland, Neupetershain;03116,-141,95,Drebkau;03119,-146,94,Welzow;03130,-144,93,Spremberg, Tschernitz u.a.;03149,-137,95,Forst/ Lausitz;03159,-143,93,Döbern;03172,-139,95,Guben, Schenkendöbern;03185,-138,95,Peitz;03197,-138,95,Jänschwalde;03205,-140,94,Calau, Bronkow;03222,-140,96,Lübbenau/ Spreewald;03226,-141,95,Vetschau;03229,-139,95,Altdöbern, Luckaitztal;03238,-138,94,Finsterwalde;03246,-138,93,Crinitz;03249,-136,94,Sonnewalde;03253,-138,93,Doberlug-Kirchhain;04103,-123,102,Leipzig;04105,-126,100;04107,-122,102;04109,-117,109;04129,-123,102;04155,-123,103;04157,-124,101;04158,-136,97;04159,-133,98;04177,-123,101;04178,-136,97;04179,-125,101;04205,-127,99;04207,-131,97;04209,-123,102;04229,-123,101;04249,-133,97;04275,-123,102;04277,-127,99;04279,-127,98;04288,-131,96;04289,-130,98;04299,-126,101;04315,-116,111;04316,-129,96;04317,-122,102;04318,-123,102;04319,-131,96;04328,-126,100;04329,-129,97;04347,-123,102;04349,-131,97;04356,-135,96;04357,-126,99;04416,-129,97,Markkleeberg;04420,-135,97,Markranstädt;04425,-133,96,Taucha;04435,-135,97,Schkeuditz;04442,-132,97,Zwenkau;04451,-131,96,Borsdorf;04463,-133,95,Großpösna;04509,-136,97,Delitzsch, Krostitz u.a.;04519,-136,97,Rackwitz;04523,-133,97,Pegau, Elstertrebnitz;04539,-132,96,Groitzsch;04552,-129,97,Borna;04564,-132,97,Böhlen;04565,-131,96,Regis-Breitingen;04567,-133,95,Kitzscher;04571,-129,96,Rötha;04575,-131,96,Neukieritzsch, Deutzen;04600,-134,95,Altenburg;04603,-135,94,Nobitz, Göhren, Windischleuba;04610,-133,95,Meuselwitz;04613,-131,96,Lucka;04617,-134,94,Rositz, Starkenberg, Treben;04618,-134,94,Langenleuba-Niederhain;04626,-142,91,Schmölln, Altkirchen, Nöbdenitz u.a.;04639,-135,94,Gößnitz;04643,-137,93,Geithain;04651,-135,95,Bad Lausick;04654,-136,94,Frohburg;04655,-136,94,Kohren-Sahlis;04657,-138,92,Narsdorf;04668,-137,94,Grimma;04680,-133,96,Colditz;04683,-130,96,Naunhof;04687,-131,96,Trebsen/Mulde;04703,-137,94,Leisnig;04720,-137,95,Döbeln, Großweitzschen u. a.;04736,-133,95,Waldheim;04741,-137,93,Roßwein;04746,-138,90,Hartha;04749,-136,96,Ostrau;04758,-136,96,Oschatz;04769,-135,96,Mügeln;04774,-137,95,Dahlen;04779,-138,94,Wermsdorf;04808,-135,95,Wurzen;04821,-131,96,Brandis;04824,-131,96;04827,-133,95,Machern;04828,-130,96,Bennewitz, Machern;04838,-134,97,Eilenburg u.a.;04849,-135,95,Bad Düben;04860,-132,95,Torgau, Dreiheide;04861,-130,95,Torgau;04862,-130,96,Mockrehna;04874,-132,96,Belgern-Schildau;04880,-133,95,Dommitzsch;04886,-133,95,Arzberg, Beilrode;04889,-131,96,Belgern-Schildau;04895,-133,95,Falkenberg/ Elster;04910,-133,96,Elsterwerda;04916,-135,94,Herzberg/ Elster;04924,-134,96,Bad Liebenwerda;04928,-135,96,Plessa, Schraden;04931,-131,96,Mühlberg, Bad Liebenwerda;04932,-133,96,Röderland, Großthiemig u.a.;04934,-138,94,Hohenleipisch;04936,-136,93,Schlieben;04938,-134,95,Uebigau-Wahrenbrück;06108,-128,103,Halle/ Saale;06110,-131,102;06112,-135,99;06114,-130,102;06116,-138,97;06118,-140,96;06120,-137,97;06122,-131,102;06124,-134,99;06126,-133,100;06128,-133,100;06130,-131,101;06132,-133,100;06179,-139,96,Teutschenthal;06184,-136,97,Kabelsketal;06188,-138,96,Landsberg;06193,-143,94,Petersberg;06198,-141,95,Salzatal;06217,-131,101,Merseburg;06231,-135,98,Bad Dürrenberg;06237,-136,97,Leuna;06242,-134,97,Braunsbedra;06246,-139,96,Bad Lauchstädt;06249,-137,95,Mücheln/ Geiseltal;06255,-139,96,Mücheln;06258,-136,98,Schkopau;06259,-135,98,Frankleben;06268,-138,92,Querfurt, Obhausen, Mücheln u.a.;06279,-135,93,Schraplau, Farnstädt;06295,-135,96,Eisleben;06308,-136,90,Klostermansfeld, Benndorf;06311,-137,91,Helbra;06313,-134,91,Hergisdorf;06317,-137,97,Seegebiet Mansfelder Land;06333,-135,90,Hettstedt, Endorf;06343,-140,83,Mansfeld;06347,-141,94,Gerbstedt;06366,-128,100,Köthen;06369,-135,96,Südliches Anhalt u. a.;06385,-133,97,Aken (Elbe);06386,-134,96,Aken, Osternienburger Land, Südliches Anhalt;06388,-133,96,Südliches Anhalt, Köthen;06406,-133,96,Bernburg (Saale);06408,-128,95,Ilberstedt;06420,-135,95,Könnern;06425,-136,95,Alsleben/Saale, Plötzkau;06429,-130,96,Nienburg (Saale);06449,-130,93,Aschersleben;06456,-137,93,Arnstein;06458,-129,92,Hedersleben;06463,-133,91,Falkenstein;06464,-130,93,Seeland;06466,-128,94;06467,-130,93;06469,-130,94;06484,-131,94,Quedlinburg;06485,-146,74,Quedlinburg, Ballenstedt;06493,-144,78,Ballenstedt, Harzgerode;06502,-142,78,Thale, Blankenburg;06526,-135,87,Sangerhausen;06528,-132,96,Wallhausen, Blankenheim;06536,-142,79,Südharz, Berga;06537,-133,95,Kelbra (Kyffhäuser);06542,-136,94,Allstedt;06543,-139,87,Falkenstein, Arnstein;06556,-130,97,Artern/ Unstrut u.a.;06567,-132,96,Bad Frankenhausen/ Kyffhäuser;06571,-130,97,Roßleben, Wiehe, Donndorf, Nausitz, Gehofen;06577,-132,96,Heldrungen;06578,-134,88,Bilzingsleben Kannawurf Oldisleben;06618,-136,94,Naumburg;06628,-135,94,Lanitz-Hassel-Tal, Molauer Land;06632,-137,94,Freyburg, Balgstädt;06636,-133,96,Laucha an der Unstrut;06638,-131,97,Karsdorf;06642,-132,95,Nebra, Kaiserpfalz;06647,-136,90,Bad Bibra, Finne u. a.;06648,-135,93,Eckartsberga;06667,-133,98,Weißenfels, Stößen;06679,-133,95,Hohenmölsen;06682,-134,95,Teuchern;06686,-135,97,Lützen;06688,-136,98,Weißenfels;06711,-133,96,Zeitz;06712,-140,91,Zeitz, Gutenborn u. a.;06721,-140,92,Meineweh, Osterfeld;06722,-133,96,Droyßig, Wetterzeube;06729,-131,97,Elsteraue;06749,-128,101,Bitterfeld-Wolfen;06766,-136,97;06772,-133,96,Gräfenhainichen;06773,-133,96;06774,-136,95,Muldestausee;06779,-133,96,Raguhn-Jeßnitz;06780,-137,96,Zörbig;06785,-131,96,Oranienbaum-Wörlitz;06792,-137,96,Sandersdorf-Brehna;06794,-138,96;06796,-138,96;06800,-136,96,Raguhn-Jeßnitz;06803,-129,101,Bitterfeld-Wolfen;06808,-136,97;06809,-137,97,Roitzsch, Petersroda;06842,-133,96,Dessau-Roßlau;06844,-133,97;06846,-133,97;06847,-133,97;06849,-134,96;06861,-131,95;06862,-131,95;06868,-128,93,Coswig (Anhalt);06869,-130,94;06886,-130,97,Wittenberg;06888,-132,97;06889,-131,92;06895,-133,96,Zahna-Elster;06901,-133,96,Kemberg;06905,-135,94,Bad Schmiedeberg;06917,-136,94,Jessen (Elster);06925,-135,95,Annaburg;07318,-136,88,Saalfeld/Saale, Wittgendorf;07330,-141,83,Probstzella;07333,-133,92,Unterwellenborn;07334,-136,89,Kamsdorf;07338,-148,78,Kaulsdorf;07343,-147,72,Wurzbach;07349,-150,68,Lehesten;07356,-148,73,Lobenstein, Neundorf;07366,-147,76,Blankenstein, Blankenberg u.a.;07368,-148,76,Remptendorf;07381,-131,95,Pößneck;07387,-137,88,Krölpa;07389,-146,81,Ranis;07407,-138,86,Rudolstadt;07422,-146,77,Bad Blankenburg, Saalfelder Höhe;07426,-138,85,Königsee-Rottenbach u.a.;07427,-141,83,Schwarzburg;07429,-147,69,Döschnitz, Sitzendorf, Rohrbach;07545,-133,99,Gera;07546,-137,95;07548,-142,89;07549,-135,95;07551,-140,90;07552,-138,93;07554,-142,91,Brahmenau;07557,-141,88,Gera, Zedlitz u.a.;07570,-139,91,Weida, Harth-Pöllnitz, Wünschendorf;07580,-142,89,Ronneburg, Braunichswalde, Großenstein u.a.;07586,-142,89,Bad Köstritz;07589,-139,88,Münchenbernsdorf, Schwarzbach, Bocka;07607,-139,90,Eisenberg, Gösen, Hainspitz;07613,-141,89,Crossen, Heideland u.a.;07616,-140,88,Bürgel u.a.;07619,-138,91,Schkölen;07629,-142,86,Hermsdorf;07639,-140,89,Bad Klosterlausnitz;07646,-137,90,Stadtroda u.a.;07743,-128,97,Jena;07745,-128,97;07747,-128,97;07749,-133,93;07751,-126,99,Jena, Bucha, Großpürschütz u.a.;07768,-131,95,Kahla;07774,-133,95,Dornburg-Camburg u.a.;07778,-132,96,Neuengönna u.a.;07806,-140,88,Neustadt/ Orla;07819,-141,87,Triptis;07907,-146,81,Schleiz;07919,-146,81,Kirschkau, Pausa-Mühltroff;07922,-147,75,Tanna;07924,-145,81,Ziegenrück;07926,-149,71,Gefell;07927,-147,77,Hirschberg;07929,-148,79,Saalburg-Ebersdorf;07937,-146,82,Zeulenroda-Triebes, Langenwolschendo rf;07950,-143,86,Zeulenroda-Triebes, Weißendorf;07952,-146,81,Pausa-Mühltroff;07955,-145,84,Auma-Weidatal;07957,-142,86,Langenwetzendorf;07958,-141,87,Hohenleuben;07973,-144,85,Greiz;07980,-137,93,Berga/Elster;07985,-138,90,Elsterberg;07987,-142,86,Mohlsdorf-Teichwolframsdorf;08056,-131,96,Zwickau;08058,-138,91;08060,-137,90;08062,-133,93;08064,-137,87;08066,-137,90;08107,-138,85,Kirchberg;08112,-136,89,Wilkau-Haßlau;08115,-140,85,Lichtentanne;08118,-138,86,Hartenstein;08132,-138,90,Mülsen;08134,-137,87,Langenweißbach, Wildenfels;08141,-137,88,Reinsdorf;08144,-138,86,Hirschfeld;08147,-147,79,Crinitzberg;08209,-147,73,Auerbach/Vogtl.;08223,-150,68,Falkenstein/Vogtl.;08228,-144,82,Rodewisch;08233,-147,81,Treuen;08236,-146,77,Ellefeld;08237,-150,68,Steinberg;08239,-148,79,Bergen;08248,-145,66,Klingenthal/Sa.;08258,-145,75,Markneukirchen;08261,-149,67,Schöneck/Vogtl.;08262,-151,59,Muldenhammer;08267,-146,64,Klingenthal;08280,-134,89,Aue;08289,-140,83,Schneeberg;08294,-141,81,Lößnitz;08297,-141,79,Zwönitz;08301,-138,85,Schlema;08304,-148,65,Schönheide;08309,-153,56,Eibenstock;08315,-138,83,Lauter-Bernsbach;08321,-147,68,Zschorlau;08324,-148,72,Bockau;08328,-147,74,Stützengrün;08340,-141,81,Schwarzenberg/Erz geb.;08344,-148,68,Grünhain;08349,-153,56,Johanngeorgensta dt;08352,-148,61,Raschau;08359,-149,60,Breitenbrunn/Erzge b.;08371,-139,91,Glauchau;08373,-138,92,Remse;08393,-140,91,Meerane;08396,-138,91,Waldenburg;08412,-138,90,Werdau;08427,-137,88,Fraureuth;08428,-140,89,Langenbernsdorf;08451,-140,91,Crimmitschau;08459,-140,91,Neukirchen/Pleiße;08468,-144,83,Reichenbach/Vogtl.;08485,-143,84,Lengenfeld;08491,-147,82,Netzschkau, Limbach;08496,-140,86,Neumark;08499,-139,89,Mylau;08523,-143,85,Plauen;08525,-145,83;08527,-146,83,Plauen, Rößnitz;08529,-143,86,Plauen;08538,-150,78,Weischlitz u.a.;08539,-148,80,Rosenbach;08541,-146,83,Neuensalz;08543,-145,83,Pöhl;08547,-146,83,Jößnitz;08548,-148,80,Rosenbach;08606,-150,78,Oelsnitz;08626,-147,74,Adorf;08645,-145,76,Bad Elster;08648,-146,73,Bad Brambach;09111,-130,97,Chemnitz;09112,-130,95;09113,-133,92;09114,-133,94;09116,-131,93;09117,-135,91;09119,-131,94;09120,-131,95;09122,-129,91;09123,-137,87;09125,-136,87;09126,-131,94;09127,-133,89;09128,-143,80;09130,-131,95;09131,-135,89;09212,-138,90,Limbach-Oberfrohna;09217,-136,91,Burgstädt;09221,-135,90,Neukirchen/Erzgeb.;09224,-135,88,Chemnitz;09228,-138,89;09232,-138,89,Hartmannsdorf;09235,-138,86,Burkhardtsdorf;09236,-136,92,Claußnitz;09241,-137,91,Mühlau;09243,-138,89,Niederfrohna;09244,-138,88,Lichtenau;09247,-136,90,Röhrsdorf;09249,-138,89,Taura b. Burgstädt;09306,-133,93,Rochlitz;09322,-138,92,Penig;09326,-135,93,Geringswalde;09328,-135,93,Lunzenau;09337,-138,88,Callenberg, Hohenstein-Ernstthal, Bernsdorf;09350,-137,89,Lichtenstein;09353,-136,91,Oberlungwitz;09355,-136,90,Gersdorf;09356,-138,91,St. Egidien;09366,-135,85,Stollberg/Erzgeb.;09376,-136,88,Oelsnitz/Erzgebirge;09380,-138,85,Thalheim/Erzgebirg e;09385,-137,89,Lugau/Erzgeb.;09387,-136,89,Jahnsdorf;09390,-140,83,Gornsdorf;09392,-146,74,Auerbach;09394,-136,88,Hohndorf;09399,-136,87,Niederwürschnitz;09405,-136,87,Zschopau, Gornau;09419,-141,79,Thum;09423,-140,79,Gelenau/Erzgeb.;09427,-146,76,Ehrenfriedersdorf;09429,-142,80,Wolkenstein;09430,-138,83,Drebach;09432,-140,80,Großolbersdorf;09434,-139,81,Großolbersdorf, Zschopau;09437,-140,85,Börnichen, Gornau;09439,-138,84,Amtsberg;09456,-148,75,Annaberg-Buchholz, Mildenau;09465,-148,62,Sehma;09468,-150,72,Geyer;09471,-149,66,Bärenstein;09474,-148,67,Crottendorf;09477,-148,66,Jöhstadt;09481,-150,72,Scheibenberg;09484,-161,44,Oberwiesenthal;09487,-145,76,Schlettau;09488,-142,80,Wiesa;09496,-151,62,Marienberg;09509,-138,82,Pockau-Lengefeld (Pockau);09514,-138,84,Pockau-Lengefeld (Lengefeld);09518,-147,76,Großrückerswalde;09526,-143,77,Olbernhau, Pfaffroda, Heidersdorf;09544,-148,70,Neuhausen/Erzgeb .;09548,-152,61,Seiffen/Erzgeb.;09557,-134,93,Flöha;09569,-137,86,Oederan;09573,-136,88,Leubsdorf, Gornau, Augustusburg;09575,-140,82,Eppendorf;09577,-136,91,Niederwiesa;09579,-137,87,Grünhainichen;09599,-133,88,Freiberg;09600,-138,86,Weißenborn, Oberschöna;09603,-138,88,Großschirma;09618,-143,76,Brand-Erbisdorf, Großhartmannsdorf;09619,-147,74,Dorfchemnitz, Mulda, Sayda;09623,-148,72,Frauenstein;09627,-141,82,Bobritzsch;09629,-137,88,Reinsberg;09633,-138,86,Halsbrücke;09634,-137,91,Reinsberg;09638,-138,84,Lichtenberg/Erzgeb .;09648,-133,94,Mittweida, Kriebstein;09661,-136,92,Hainichen, Rossau, Striegistal;09669,-138,89,Frankenberg;10115,-111,110,Berlin Mitte;10117,-113,109;10119,-112,108;10178,-112,109;10179,-112,109;10243,-118,104,Berlin Friedrichshain;10245,-117,105;10247,-113,108;10249,-118,104;10315,-120,101,Berlin Friedrichsfelde;10317,-121,100,Berlin Rummelsburg;10318,-120,101,Berlin Karlshorst;10319,-119,103,Berlin;10365,-120,101,Berlin Lichtenberg;10367,-119,102;10369,-120,102;10405,-112,108,Berlin Prenzlauer Berg;10407,-118,103;10409,-119,103;10435,-112,108;10437,-113,107;10439,-113,108;10551,-113,107,Berlin Moabit;10553,-118,103;10555,-118,104;10557,-118,104;10559,-112,108;10585,-111,109,Berlin Charlottenburg;10587,-118,103;10589,-118,103;10623,-113,107;10625,-112,108;10627,-112,109;10629,-112,108;10707,-113,107,Berlin Wilmersdorf;10709,-118,102;10711,-120,100,Berlin Halensee;10713,-113,107,Berlin Wilmersdorf;10715,-120,101,Berlin Wilhelmsdorf;10717,-118,103,Berlin Wilmersdorf;10719,-113,107;10777,-113,107;10779,-118,103,Berlin Schöneberg;10781,-113,107;10783,-113,107;10785,-118,104,Berlin Tiergarten;10787,-118,103;10789,-113,107,Berlin Schöneberg;10823,-118,103,Berlin-West;10825,-114,106,Berlin;10827,-119,101;10829,-119,101,Berlin Schöneberg;10961,-113,108,Berlin Kreuzberg;10963,-120,102;10965,-111,109,Berlin Neukölln;10967,-111,109,Berlin Kreuzberg;10969,-118,104;10997,-118,103;10999,-113,108;12043,-119,102,Berlin Neukölln;12045,-114,106;12047,-111,109,Berlin Kreuzberg;12049,-118,103,Berlin Neukölln;12051,-120,101;12053,-119,102;12055,-120,101;12057,-121,100;12059,-119,102;12099,-119,102,Berlin Tempelhof;12101,-119,102;12103,-119,101;12105,-119,101,Berlin Mariendorf;12107,-119,102;12109,-123,99;12157,-121,99,Berlin Schöneberg;12159,-120,100,Berlin Friedenau;12161,-120,100;12163,-120,99,Berlin Steglitz;12165,-120,100;12167,-120,100;12169,-121,99;12203,-120,99,Berlin Lichtenfelde;12205,-121,99;12207,-120,100;12209,-120,100;12247,-120,100,Berlin Lankwitz;12249,-121,100;12277,-120,101,Berlin;12279,-120,100;12305,-122,99;12307,-130,96;12309,-124,98;12347,-120,101,Berlin Britz;12349,-121,100,Berlin Buckow;12351,-121,100;12353,-128,97,Berlin Gropiusstadt;12355,-121,100,Berlin Rudow;12357,-122,99;12359,-121,100,Berlin Britz;12435,-123,98,Berlin Alt Treptow;12437,-120,101,Berlin Baumschulenweg;12439,-123,99,Berlin Niederschöneweide;12459,-122,99,Berlin Oberschöneweide;12487,-121,100,Berlin;12489,-121,100,Berlin Teltowkanal III;12524,-121,101,Berlin Altglienicke;12526,-126,97,Berlin Bohnsdorf;12527,-133,95,Berlin Schmöckwitz;12529,-132,95,Schönefeld;12555,-122,99,Berlin Köpenik;12557,-125,98,Berlin;12559,-132,96,Berlin Köpenick;12587,-132,95,Berlin Wiesengrund;12589,-130,95,Berlin Rahnsdorf;12619,-120,100,Berlin;12621,-124,99,Berlin Kaulsdorf;12623,-122,99,Berlin Mahlsdorf;12627,-121,101,Berlin Hellersdorf;12629,-122,99,Berlin;12679,-122,100;12681,-121,100;12683,-121,100,Berlin Biesdorf;12685,-122,100,Berlin;12687,-122,99;12689,-122,100;13051,-126,97,Berlin Neu-Schönhausen;13053,-121,100,Berlin Alt-Hohenschönhause n;13055,-120,101;13057,-121,100,Berlin Falkenberg;13059,-126,97,Berlin Wartenberg;13086,-121,100,Berlin Weißensee;13088,-121,100;13089,-120,102,Berlin Heinelsdorf;13125,-128,96,Berlin Buch;13127,-128,96,Berlin Französisch Buchholz;13129,-123,99,Berlin Blankenburg;13156,-119,102,Berlin Niederschönhause n;13158,-122,100,Berlin Rosenthal;13159,-129,96,Berlin Blankenfelde;13187,-118,103,Berlin Pankow;13189,-120,101;13347,-113,107,Berlin Wedding;13349,-113,106;13351,-120,103;13353,-113,107;13355,-118,104;13357,-112,108,Berlin Gesundbrunnen;13359,-113,107;13403,-119,103,Berlin Reinickendorf;13405,-122,100,Berlin Wedding;13407,-118,104,Berlin-West;13409,-118,103;13435,-121,101,Berlin Märkisches Viertel;13437,-120,102,Berlin Reinickendorf;13439,-120,101,Berlin Märkisches Viertel;13465,-124,97,Berlin Frohnau;13467,-122,100,Berlin Hermsdorf;13469,-123,100,Berlin Lübars;13503,-125,98,Berlin Tegel;13505,-128,97;13507,-123,100;13509,-120,102,Berlin Reinickendorf;13581,-121,101,Berlin Spandau;13583,-121,101;13585,-120,102;13587,-128,97,Berlin Hakenfelde;13589,-125,98,Berlin Falkenhagener Feld;13591,-122,100,Berlin Staaken;13593,-127,96,Berlin Wilhelmstadt;13595,-125,98,Berlin Wlhelmstadt;13597,-121,101,Berlin Spandau;13599,-121,101,Berlin Haselhorst;13627,-121,102,Berlin Charlottenburg-Nord;13629,-124,99,Berlin Siemensstadt;14050,-121,100,Berlin Westend;14052,-122,98;14053,-125,96;14055,-127,95;14057,-115,105,Berlin Charlottenburg;14059,-118,102;14089,-126,96,Berlin Gatow;14109,-126,95,Berlin Wannsee;14129,-128,96,Berlin Nikolassee;14163,-122,98,Berlin Zehlendorf;14165,-120,99;14167,-122,98;14169,-125,96;14193,-127,95,Berlin Grunewald;14195,-122,98,Berlin Dahlem;14197,-120,100,Berlin Wilmersdorf;14199,-120,99,Berlin Schmargendorf;14467,-121,100,Potsdam;14469,-126,96;14471,-125,96;14473,-126,95;14476,-127,97;14478,-124,98;14480,-124,97;14482,-122,99;14513,-128,96,Teltow;14532,-128,96,Kleinmachnow;14542,-127,97,Werder/ Havel;14547,-129,96,Beelitz;14548,-128,97,Schwielowswee;14550,-129,96,Groß Kreutz;14552,-128,96,Michendorf;14554,-130,96,Seddinger See;14558,-129,96,Nuthetal;14612,-122,100,Falkensee;14621,-128,96,Schönwalde;14624,-128,96,Dallgow-Döberitz;14641,-126,96,Nauen;14656,-128,97,Brieselang;14662,-132,94,Friesack;14669,-128,97,Ketzin;14712,-129,94,Rathenow;14715,-129,95,Milower Land, Schollene, Nennhausen u.a.;14727,-128,95,Premnitz;14728,-128,93,Rhinow;14770,-124,99,Brandenburg/ Havel;14772,-129,95;14774,-130,95;14776,-129,96;14778,-128,96,Beetzsee, Wollin, Wenzlow, Golzow u.a;14789,-131,94,Wusterwitz, Rosenau, Bensdorf;14793,-132,93,Ziesar;14797,-128,95,Lehnin;14798,-129,95,Havelsee;14806,-130,91,Belzig;14822,-130,95,Brück, Borkheide u. a;14823,-130,93,Niemegk;14827,-131,89,Wiesenburg;14828,-131,91,Görzke;14913,-135,95,Jüterbog;14929,-132,94,Treuenbrietzen;14943,-130,97,Luckenwalde;14947,-141,95,Nuthe-Urstromtal;14959,-132,96,Trebbin;14974,-130,95,Ludwigsfelde;14979,-130,96,Großbeeren;15230,-137,96,Frankfurt/ Oder;15232,-138,95;15234,-141,93;15236,-139,94,Treplin, Jacobsdorf, Frankfurt (Oder);15295,-143,95,Brieskow-Finkenheerd;15299,-138,95,Müllrose;15306,-139,93,Seelow, Lietzen u. a.;15320,-137,94,Neutrebbin, Neuhardenberg;15324,-137,95,Letschin;15326,-141,93,Zeschdorf, Podelzig, Lebus;15328,-138,94,Golzow, Zechin u. a.;15344,-128,94,Strausberg;15345,-128,95,Lichtenow, Altlandsberg u.a.;15366,-123,97,Neuenhagen, Hoppegarten;15370,-126,96,Fredersdorf-Vogelsdorf, Petershagen;15374,-136,95,Müncheberg;15377,-134,93,Oberbarnim, Märkische Höhe u. a.;15378,-131,95,Rüdersdorf;15517,-124,99,Fürstenwalde/ Spree;15518,-135,95,Briesen, Rauen u. a.;15526,-133,96,Bad Saarow-Pieskow;15528,-130,96,Spreenhagen;15537,-130,95,Erkner;15562,-128,94,Rüdersdorf;15566,-131,95,Schöneiche bei Berlin;15569,-130,95,Woltersdorf;15711,-126,97,Königs Wusterhausen;15712,-132,96;15713,-132,95;15732,-126,98,Schulzendorf b. Eichenwade;15738,-126,97,Zeuthen;15741,-137,95,Bestensee;15745,-126,97,Wildau;15746,-141,95,Groß Köris;15748,-137,95,Märkisch Buchholz;15749,-132,95,Mittenwalde;15754,-133,96,Heidesee;15755,-143,95,Teupitz;15757,-140,95,Halbe;15806,-138,95,Zossen;15827,-132,95,Blankenfelde-Mahlow;15831,-132,95,Blankenfelde-Mahlow u.a.;15834,-132,95,Rangsdorf;15837,-141,93,Baruth;15838,-142,94,Am Mellensee;15848,-135,96,Beeskow;15859,-132,96,Storkow;15864,-132,96,Wendisch Rietz;15868,-139,95,Lieberose;15890,-139,94,Eisenhüttenstadt;15898,-141,94,Neuzelle;15907,-138,96,Lübben/ Spreewald;15910,-140,94,Schönwalde;15913,-138,96,Straupitz;15926,-140,95,Luckau, Waldrehna, Heideblick, Fürstlich Drehna;15936,-137,94,Dahme u.a.;15938,-142,94,Golßen;16225,-135,94,Eberswalde;16227,-133,95;16230,-136,94,Melchow, Chorin u. a.;16244,-133,92,Schorfheide;16247,-140,91,Joachimsthal u.a.;16248,-141,90,Oderberg u.a.;16259,-135,92,Bad Freienwalde u. a.;16269,-136,94,Wriezen;16278,-144,92,Angermünde;16303,-141,94,Schwedt;16306,-142,91,Biesendahlshof, Berkholz-Meyenburg;16307,-141,90,Gartz (Oder);16321,-126,96,Bernau;16341,-126,96,Panketal;16348,-127,95,Wandlitz;16356,-129,94,Werneuchen;16359,-129,95,Biesenthal;16515,-127,96,Oranienburg, Mühlenbecker Land;16540,-127,96,Hohen Neuendorf;16547,-127,96,Birkenwerder;16548,-123,98,Glienicke/Nordbahn;16552,-128,97,Mühlenbecker Land;16556,-125,97,Borgsdorf;16559,-127,95,Liebenwalde;16562,-128,95,Hohen Neuendorf OT Bergfelde;16567,-128,96,Mühlenbecker Land;16727,-128,95,Velten, Oberkrämer;16761,-124,98,Hennigsdorf;16766,-130,95,Kremmen;16767,-127,97,Leegebruch;16775,-132,93,Gransee, Löwenberg;16792,-128,94,Zehdenick;16798,-133,91,Fürstenberg;16816,-130,94,Neuruppin;16818,-131,94,Fehrbellin, Temnitzquell, Märkisch Linden u. a.;16827,-133,93,Neuruppin;16831,-130,92,Rheinsberg;16833,-132,94,Fehrbellin;16835,-132,93,Lindow u.a.;16837,-130,91,Rheinsberg;16845,-130,93,Neustadt (Dosse) u.a.;16866,-129,92,Kyritz u.a.;16868,-130,93,Wusterhausen;16909,-130,92,Wittstock/Dosse, Heiligengrabe;16928,-127,91,Pritzwalk, Groß Pankow;16945,-125,91,Meyenburg, Kümmernitztal u.a.;16949,-127,92,Triglitz, Putlitz;17033,-132,93,Neubrandenburg;17034,-127,97;17036,-130,91;17039,-130,92,Sponholz, Neunkirchen u.a.;17087,-131,92,Altentreptow;17089,-131,92,Burow;17091,-131,92,Rosenow;17094,-132,90,Cölpin;17098,-132,93,Friedland;17099,-133,92,Friedland, Galenbeck, Datzetal;17109,-125,92,Demmin;17111,-127,92,Demmin u.a.;17121,-118,90,Loitz;17126,-121,91,Jarmen;17129,-125,91,Bentzin;17139,-125,94,Malchin;17153,-127,91,Stavenhagen;17154,-124,93,Neukalen;17159,-124,92,Dargun;17166,-123,91,Dahmen, Groß Wokern, Teterow;17168,-123,90,Jördenstorf, Prebberede u.a.;17179,-121,91,Gnoien u.a.;17192,-123,92,Waren/ Müritz;17194,-125,92,Grabowhöfe, Moltzow u.a.;17207,-126,92,Röbel/ Müritz;17209,-127,91,Wredenhagen;17213,-125,92,Malchow u.a.;17214,-125,91,Nossentiner Hütte;17217,-131,91,Penzlin;17219,-126,90,Möllenhagen;17235,-131,91,Neustrelitz;17237,-130,89,Möllenbeck;17248,-127,91,Rechlin;17252,-128,91,Mirow;17255,-130,92,Wesenberg;17258,-132,88,Feldberger Seenlandschaft;17268,-139,89,Templin, Boitzenburg u.a.;17279,-136,90,Lychen;17291,-142,92,Prenzlau u.a.;17309,-138,92,Pasewalk u.a.;17321,-137,91,Löcknitz, Rothenklempenow;17322,-138,92,Blankensee, Grambow u.a.;17326,-141,91,Brüssow;17328,-142,91,Penkun u.a.;17329,-139,90,Nadrensee u.a.;17335,-138,90,Strasburg;17337,-139,89,Uckerland, Groß Luckow, Schönhausen;17348,-133,89,Woldegk;17349,-133,90,Groß Miltzow;17358,-132,91,Torgelow;17367,-132,90,Eggesin;17373,-134,90,Ueckermünde;17375,-133,90,Vogelsang-Warsin, Meiersberg, Mönkebude u.a.;17379,-132,91,Ferdinandshof u.a.;17389,-124,91,Anklam;17390,-123,89,Klein Bünzow;17391,-128,92,Krien u.a.;17392,-132,92,Spantekow;17398,-129,91,Ducherow;17406,-124,90,Usedom u.a.;17419,-118,90,Seebad Ahlbeck;17424,-115,90,Ostseebad Heringsdorf;17429,-118,88,Benz, Heringsdorf u.a.;17438,-116,88,Wolgast;17440,-115,90,Kröslin, Krummin, Lassan u.a.;17449,-113,90,Karlshagen;17454,-115,90,Zinnowitz;17459,-114,90,Koserow;17489,-115,90,Greifswald;17491,-115,90;17493,-118,90;17495,-117,88,Karlsburg;17498,-115,90,Neuenkirchen;17506,-121,89,Gützkow;17509,-114,89,Lubmin;18055,-107,93,Rostock;18057,-102,98;18059,-118,90,Rostock, Papendorf u.a.;18069,-104,92,Rostock, Lambrechtshagen;18106,-100,95,Rostock;18107,-101,94,Elmenhorst/Lichten hagen, Rostock;18109,-100,96,Rostock;18119,-102,95;18146,-103,93;18147,-102,94;18181,-102,94,Rostock, Graal-Müritz;18182,-108,91,Rostock, Gelbensande, Rövershagen u.a.;18184,-116,90,Roggentin, Broderstorf u.a.;18190,-120,89,Sanitz;18195,-120,90,Tessin, Grammow u.a.;18196,-120,89,Dummerstorf;18198,-115,90,Stäbelow, Kritzmow;18209,-102,91,Bad Doberan, Bartenshagen-Parkentin u.a.;18211,-102,93,Retschow, Admannshagen-Bargeshagen u.a.;18225,-95,93,Kühlungsborn;18230,-100,91,Rerik, Bastorf, Biendorf;18233,-109,92,Neubukow, Ravensberg, Westenbrügge u.a.;18236,-109,91,Kröpelin, Carinerland;18239,-115,90,Satow;18246,-118,90,Bützow u.a.;18249,-118,92,Bernitt, Qualitz, Warnow, Zernin u. a.;18258,-120,91,Schwaan u.a.;18273,-121,92,Güstrow;18276,-120,91,Reimershagen, Lohmen, Zehna, Hägerfelde u.a.;18279,-122,91,Lalendorf, Langhagen;18292,-121,91,Krakow, Dobbin-Linstow u.a.;18299,-120,91,Laage, Wardow u. a.;18311,-112,91,Ribnitz-Damgarten;18314,-120,89,Löbnitz;18317,-116,89,Saal;18320,-118,88,Ahrenshagen-Daskow, Trinwillershagen u. a.;18334,-116,91,Bad Sülze;18337,-113,89,Marlow;18347,-99,93,Dierhagen;18356,-120,88,Barth;18374,-109,90,Zingst a. Darß;18375,-117,88,Prerow a. Darß;18435,-108,89,Stralsund;18437,-107,91;18439,-108,89;18442,-115,88,Niepars;18445,-113,88,Prohn;18461,-116,88,Franzburg, Richtenberg, u.a.;18465,-118,89,Tribsees;18469,-118,88,Velgast;18507,-116,90,Grimmen;18510,-115,88,Wittenhagen;18513,-118,90,Glewitz;18516,-117,89,Rakow;18519,-108,88,Miltzow u.a.;18528,-96,88,Bergen/ Rügen;18546,-95,85,Sassnitz;18551,-86,87,Sagard;18556,-79,90,Dranske;18565,-89,90,Hiddensee;18569,-95,89,Gingst;18573,-105,89,Samtens;18574,-103,89,Garz/ Rügen;18581,-102,87,Putbus;18586,-94,88,Sellin;18609,-93,89,Binz;19053,-108,96,Schwerin;19055,-113,93;19057,-113,93;19059,-112,94;19061,-113,92;19063,-114,93;19065,-115,92,Pinnow;19067,-114,92,Leezen;19069,-113,92,Lübstorf;19071,-113,92,Brüsewitz;19073,-113,92,Wittenförden u.a.;19075,-113,93,Pampow;19077,-116,92,Rastow;19079,-116,93,Banzkow, Sukow;19086,-115,92,Plate;19089,-118,90,Crivitz;19205,-111,92,Gadebusch;19209,-113,91,Lützow;19217,-112,90,Rehna, Carlow u.a.;19230,-114,93,Hagenow u.a.;19243,-111,93,Wittenburg u.a.;19246,-111,93,Zarrentin;19249,-113,95,Lübtheen;19258,-110,94,Boizenburg/ Elbe;19260,-110,93,Vellahn;19273,-112,94,Amt Neuhaus, Stapel;19288,-118,94,Ludwigslust;19294,-118,94,Neu Kaliß;19300,-123,93,Grabow u.a.;19303,-117,94,Dömitz;19306,-122,93,Neustadt-Glewe;19309,-119,94,Lenzen;19322,-123,94,Wittenberge, Rühstädt;19336,-125,94,Legde/Quitzöbel, Bad Wilsnack;19339,-125,94,Plattenburg;19348,-123,92,Perleberg, Berge u. a.;19357,-121,94,Karstädt, Dambeck, Klüß;19370,-115,97,Parchim;19372,-123,91,Spornitz;19374,-120,91,Mestlin, Severin u. a.;19376,-125,92,Siggelkow;19386,-123,90,Lübz, Passow;19395,-123,91,Plau am See;19399,-123,91,Goldberg;19406,-119,92,Sternberg;19412,-117,92,Brüel;19417,-115,92,Warin;20095,-82,106,Hamburg;20097,-93,98;20099,-91,99;20144,-92,98;20146,-92,98;20148,-90,99;20149,-92,98;20249,-92,99;20251,-92,98;20253,-92,98;20255,-92,98;20257,-92,98;20259,-92,98;20354,-91,99;20355,-87,102;20357,-90,99;20359,-90,100;20457,-93,98;20459,-89,100;20535,-92,98;20537,-94,97;20539,-97,95;21029,-98,97;21031,-103,93;21033,-102,94;21035,-102,94;21037,-103,94;21039,-105,95;21073,-94,97;21075,-97,93;21077,-98,92;21079,-93,98;21107,-98,95;21109,-99,93;21129,-98,93;21147,-98,93;21149,-96,93;21217,-101,93,Seevetal;21218,-101,92;21220,-103,93;21224,-102,90,Rosengarten;21227,-103,93,Bendestorf;21228,-103,92,Harmstorf;21244,-101,93,Buchholz in der Nordheide;21255,-101,92,Tostedt, Kakenstorf u.a.;21256,-103,92,Handeloh;21258,-100,91,Heidenau;21259,-107,92,Otter;21261,-105,92,Welle;21266,-103,93,Jesteburg;21271,-108,92,Hanstedt, Asendorf;21272,-110,91,Eggestorf;21274,-107,90,Undeloh;21279,-99,91,Hollenstedt, Drestedt u.a.;21335,-111,94,Lüneburg;21337,-107,96;21339,-109,93;21354,-109,95,Bleckede;21357,-106,95,Bardowick, Wittorf, Barum;21358,-108,95,Mechtersen;21360,-108,94,Vögelsen;21365,-110,95,Adendorf;21368,-112,93,Dahlenburg;21369,-111,91,Nahrendorf;21371,-111,91,Tosterglope;21376,-110,93,Salzhausen;21379,-108,95,Scharnebeck, Echem, Lüdersburg, Rullstorf;21380,-108,95,Artlenburg;21382,-107,95,Brietlingen;21385,-113,90,Oldendorf (Luhe), Amelinghausen, Rehlingen;21386,-113,90,Betzendorf;21388,-111,91,Soderstorf;21391,-111,93,Reppenstedt, Lüneburg;21394,-112,91,Kirchgellersen, Westergellersen, Südergellersen;21395,-106,95,Tespe;21397,-111,93,Barendorf, Vastorf;21398,-109,95,Neetze;21400,-111,92,Reinstorf;21401,-112,93,Thomasburg;21403,-110,92,Wendisch Evern;21406,-113,93,Melbeck, Barnstedt;21407,-112,94,Deutsch Evern;21409,-113,93,Embsen;21423,-105,95,Winsen;21435,-105,94,Stelle;21436,-105,95,Marschacht;21438,-106,92,Brackel;21439,-105,93,Marxen;21441,-108,93,Garstedt;21442,-108,93,Toppenstedt;21444,-109,94,Vierhöfen;21445,-107,94,Wulfsen;21447,-106,95,Handorf;21449,-108,94,Radbruch;21465,-105,92,Reinbek;21481,-109,94,Lauenburg/Elbe;21483,-108,94,Gülzow;21493,-108,92,Fuhlenhagen;21502,-107,92,Geesthacht;21509,-103,93,Glinde;21514,-108,94,Bröthen;21516,-107,94,Woltersdorf, Müssen u.a.;21521,-109,92,Aumühle;21522,-108,96,Hohnstorf (Elbe), Hittbergen;21524,-107,93,Brunstorf;21526,-108,92,Hohenhorn;21527,-108,93,Kollow;21529,-107,91,Kröppelshagen-Fahrendorf;21614,-95,93,Buxtehude;21629,-99,91,Neu Wulmstorf;21635,-98,93,Jork;21640,-98,93,Horneburg;21641,-100,90,Apensen;21643,-100,91,Beckdorf;21644,-101,91,Sauensiek;21646,-100,91,Halvesbostel;21647,-98,92,Moisburg;21649,-100,91,Regesbostel;21680,-97,93,Stade;21682,-98,94;21683,-97,93;21684,-99,92;21698,-98,92,Harsefeld;21702,-101,92,Ahlerstedt;21706,-98,93,Drochtersen;21709,-98,93,Himmelpforten;21710,-97,94,Engelschoff;21712,-96,94,Großenwörden;21714,-98,93,Hammah;21717,-98,92,Fredenbeck;21720,-99,93,Gründeich;21723,-98,93,Hollern-Twielenfleth;21726,-100,92,Oldendorf;21727,-98,93,Estorf;21729,-91,94,Freiburg (Elbe);21730,-88,95,Balje;21732,-91,94,Krummendeich;21734,-93,94,Oederquart;21737,-92,94,Wischhafen;21739,-97,91,Dollern;21745,-96,94,Hemmoor;21755,-97,93,Hechthausen;21756,-96,94,Osten;21762,-85,96,Otterndorf;21763,-91,95,Neuenkirchen;21765,-90,96,Nordleda;21769,-97,92,Lamstedt;21770,-97,94,Mittelstenahe;21772,-95,95,Stinstedt;21775,-93,95,Ihlienworth;21776,-93,95,Wanna;21781,-92,95,Cadenberge;21782,-91,95,Bülkau;21784,-92,95,Geversdorf;21785,-88,95,Neuhaus (Oste);21787,-95,94,Oberndorf;21789,-99,92,Wingst;22041,-88,102,Hamburg;22043,-95,97;22045,-93,98;22047,-93,98;22049,-92,98;22081,-92,98;22083,-93,98;22085,-94,97;22087,-91,99;22089,-92,99;22111,-92,98;22113,-96,96,Hamburg, Oststeinbek;22115,-100,94,Hamburg;22117,-99,95;22119,-93,98;22143,-97,95;22145,-103,91;22147,-96,96;22149,-96,96;22159,-95,96;22175,-93,97;22177,-93,98;22179,-95,97;22297,-93,98;22299,-92,99;22301,-92,99;22303,-97,95;22305,-91,99;22307,-93,98;22309,-93,97;22335,-95,96;22337,-97,94;22339,-93,97;22359,-99,93;22391,-95,96;22393,-95,96;22395,-100,93;22397,-102,92;22399,-95,96;22415,-93,97;22417,-97,94;22419,-96,94;22453,-95,96;22455,-93,97;22457,-94,96;22459,-97,94;22523,-92,98;22525,-94,96;22527,-93,96;22529,-93,97;22547,-93,96;22549,-94,95;22559,-93,94;22587,-97,91;22589,-98,92;22605,-93,95;22607,-92,97;22609,-92,96;22761,-92,97;22763,-93,95;22765,-93,95;22767,-93,97;22769,-92,98;22844,-100,91,Norderstedt;22846,-100,91;22848,-100,92;22850,-94,96;22851,-100,91;22869,-100,91,Schenefeld;22880,-97,94,Wedel;22885,-103,92,Barsbüttel;22889,-102,90,Tangstedt;22926,-101,94,Ahrensburg;22927,-105,91,Großhansdorf;22929,-107,90,Hamfelde, Kasseburg, Köthel, Rausdorf, Schönberg;22941,-103,91,Bargteheide, Delingsdorf u.a.;22946,-107,91,Trittau;22949,-103,91,Ammersbek;22952,-108,91,Lütjensee;22955,-106,91,Hoisdorf;22956,-108,91,Grönwohld;22958,-109,92,Kuddewörde;22959,-108,91,Linau;22961,-107,91,Hoisdorf;22962,-105,91,Siek;22964,-107,90,Steinburg;22965,-106,91,Todendorf;22967,-106,91,Tremsbüttel;22969,-108,93,Witzhave;23552,-96,103,Lübeck;23554,-98,98,Lübeck St. Lorenz Nord;23556,-107,92,Lübeck;23558,-98,99;23560,-110,91;23562,-110,91;23564,-103,94;23566,-102,94;23568,-105,91,Lübeck Schlutup/St. Gertrud;23569,-103,91,Lübeck;23570,-91,92;23611,-103,91,Bad Schwartau;23617,-108,90,Stockelsdorf;23619,-108,91,Zarpen;23623,-105,88,Ahrensbök;23626,-93,92,Ratekau;23627,-111,90,Groß Grönau;23628,-110,91,Krummesse, Klempau;23629,-101,90,Sarkwitz;23669,-87,92,Timmendorfer Strand;23683,-82,92,Scharbeutz;23684,-97,91,Scharbeutz, Süsel;23689,-97,90,Pansdorf;23701,-101,89,Eutin, Süsel;23714,-96,88,Malente, Kirchnüchel;23715,-100,88,Bosau;23717,-95,89,Kasseedorf;23719,-101,89,Glasau;23730,-83,92,Neustadt;23738,-86,91,Lensahn;23743,-84,91,Grömitz;23744,-97,86,Schönwalde am Bungsberg;23746,-85,92,Kellenhusen;23747,-85,92,Dahme;23749,-84,92,Grube;23758,-78,92,Oldenburg in Holstein;23769,-70,92,Fehmarn;23774,-73,93,Heiligenhafen;23775,-73,93,Großenbrode;23777,-81,91,Heringsdorf;23779,-78,92,Neukirchen;23795,-104,90,Bad Segeberg;23812,-101,89,Wahlstedt;23813,-102,88,Nehms;23815,-108,89,Geschendorf;23816,-105,90,Leezen;23818,-107,89,Neuengörs;23820,-105,89,Pronstorf;23821,-104,89,Rohlstorf;23823,-98,89,Seedorf;23824,-99,89,Tensfeld;23826,-104,90,Bark;23827,-103,88,Wensin;23829,-104,90,Wittenborn;23843,-104,92,Bad Oldesloe;23845,-105,90,Seth;23847,-109,90,Lasbek;23858,-108,91,Reinfeld (Holstein);23860,-109,91,Klein Wesenberg;23863,-103,91,Bargfeld-Stegen;23866,-104,91,Nahe;23867,-105,90,Sülfeld;23869,-105,91,Elmenhorst;23879,-108,93,Mölln;23881,-111,92,Breitenfelde, Lankau;23883,-110,92,Sterley;23896,-111,91,Nusse;23898,-110,91,Sandesneben u.a.;23899,-109,93,Gudow;23909,-109,92,Ratzeburg;23911,-112,90,Ziethen;23919,-110,91,Berkenthin;23923,-107,91,Schönberg;23936,-105,91,Grevesmühlen, Stepenitztal, Upahl u.a.;23942,-94,91,Dassow;23946,-97,92,Boltenhagen;23948,-96,91,Klütz;23966,-106,90,Wismar, Groß Krankow u.a.;23968,-98,91,Barnekow, Gägelow u.a.;23970,-107,90,Wismar;23972,-109,92,Dorf Mecklenburg, Lübow u.a.;23974,-100,92,Neuburg-Steinhausen, Hornstorf;23992,-113,91,Neukloster;23996,-112,90,Bad Kleinen u.a.;23999,-96,93,Insel Poel;24103,-79,96,Kiel;24105,-81,94;24106,-79,95;24107,-86,90;24109,-85,91,Melsdorf;24111,-86,91,Kiel Russee;24113,-86,91,Kiel;24114,-79,97;24116,-81,95;24118,-79,96;24119,-81,94,Kronshagen;24143,-80,96,Kiel;24145,-86,89;24146,-87,90;24147,-84,92;24148,-83,92;24149,-83,90;24159,-77,93;24161,-83,91,Altenholz;24211,-91,89,Preetz;24214,-81,91,Gettorf u.a.;24217,-82,91,Schönberg (Holstein);24220,-89,88,Flintbek;24222,-84,91,Schwentinental;24223,-88,89,Schwentinetal;24226,-83,91,Heikendorf;24229,-83,91,Dänischenhagen;24232,-85,90,Schönkirchen;24235,-83,91,Laboe;24238,-91,88,Selent;24239,-88,90,Achterwehr;24241,-91,88,Blumenthal;24242,-88,90,Felde;24244,-82,91,Felm;24245,-91,89,Kirchbarkau;24247,-88,90,Mielkendorf;24248,-83,90,Mönkeberg;24250,-92,88,Nettelsee;24251,-80,91,Osdorf;24253,-85,90,Probsteierhagen;24254,-90,89,Rumohr;24256,-86,88,Fargau-Pratjau;24257,-82,89,Hohenfelde;24259,-90,90,Westensee;24306,-93,89,Plön;24321,-85,87,Lütjenburg;24326,-95,90,Ascheberg;24327,-86,89,Blekendorf;24329,-93,88,Grebin;24340,-81,91,Eckernförde;24351,-78,91,Damp;24354,-86,90,Kosel, Rieseby u.a.;24357,-89,89,Fleckeby u.a.;24358,-88,88,Ascheffel;24360,-81,90,Barkelsby;24361,-88,89,Groß Wittensee;24363,-85,90,Holtsee;24364,-79,91,Holzdorf;24366,-81,91,Loose;24367,-89,90,Osterby;24369,-79,90,Waabs;24376,-71,91,Kappeln;24392,-86,89,Süderbrarup;24395,-71,92,Gelting;24398,-73,92,Dörphof;24399,-75,92,Arnis, Marienhof;24401,-86,89,Böel;24402,-78,90,Esgrus, Schrepperie;24404,-68,93,Maasholm, Schleimünde;24405,-86,89,Mohrkirch, Rügge;24407,-85,90,Rabenkirchen-Faulück;24409,-76,90,Stoltebüll;24534,-88,94,Neumünster;24536,-91,90;24537,-89,91;24539,-92,92;24558,-101,90,Henstedt-Ulzburg;24568,-100,91,Kaltenkirchen;24576,-96,92,Bad Bramstedt;24582,-90,90,Bordesholm;24589,-92,89,Nortorf;24594,-93,89,Hohenwestedt;24598,-98,89,Boostedt;24601,-92,88,Wankendorf;24610,-98,89,Trappenkamp;24613,-93,90,Aukrug, Wiedenborstel;24616,-96,91,Brokstedt;24619,-96,89,Börnhöved;24620,-93,90,Bönebüttel;24622,-90,90,Gnutz;24623,-97,90,Großenaspe;24625,-91,89,Großharrie;24626,-97,90,Groß Kummerfeld;24628,-100,90,Hartenholm;24629,-100,89,Kisdorf;24631,-91,89,Langwedel;24632,-99,90,Lentföhrden;24634,-96,91,Padenstedt;24635,-102,89,Rickling;24637,-91,88,Schillsdorf;24638,-98,88,Schmalensee;24640,-99,90,Schmalfeld;24641,-103,91,Sievershütten;24643,-101,91,Struvenhütten;24644,-90,90,Timmaspe;24646,-92,89,Warder;24647,-93,90,Wasbek;24649,-96,90,Wiemersdorf;24768,-86,93,Rendsburg;24782,-90,90,Büdelsdorf, Rickert;24783,-89,90,Osterrönfeld;24784,-89,90,Westerrönfeld;24787,-89,90,Fockbek;24790,-90,90,Schacht-Audorf;24791,-90,90,Alt Duvenstedt;24793,-92,89,Bargstedt, Brammer, Oldenbüttel;24794,-90,90,Borgstedt;24796,-86,90,Bredenbek;24797,-89,91,Breiholz, Tackesdorf;24799,-90,91,Meggerdorf, Friedrichsholm, Friedrichsgraben u. a.;24800,-90,90,Elsdorf-Westermühlen;24802,-91,90,Emkendorf;24803,-89,90,Erfde;24805,-88,90,Hamdorf;24806,-90,90,Hohn;24808,-88,90,Jevenstedt;24809,-89,90,Nübbel;24811,-90,90,Owschlag u.a.;24813,-88,91,Schülp bei Rendsburg;24814,-87,90,Sehestedt;24816,-89,89,Hamweddel;24817,-90,90,Tetenhusen;24819,-91,89,Todenbüttel;24837,-87,91,Schleswig;24848,-91,90,Kropp u.a.;24850,-88,90,Schuby;24852,-90,90,Eggebek, Langstedt, Sollerup, Süderhackstedt;24855,-89,90,Bollingstedt, Jübek;24857,-88,89,Fahrdorf;24860,-87,88,Böklund u.a.;24861,-89,90,Bergenhusen;24863,-91,91,Börm;24864,-88,90,Brodersby, Goltoft;24866,-90,90,Busdorf;24867,-92,90,Dannewerk;24869,-90,91,Dörpstedt;24870,-91,90,Ellingstedt;24872,-92,90,Groß Rheide;24873,-86,89,Havetoft;24876,-91,91,Hollingstedt;24878,-92,90,Jagel, Lottorf;24879,-87,88,Idstedt;24881,-88,89,Nübel;24882,-90,91,Schaalby, Geelbek;24884,-91,90,Selk, Geltdorf, Hahnekrug;24885,-87,89,Sieverstedt;24887,-90,90,Silberstedt, Schwittschau;24888,-87,89,Steinfeld;24890,-88,88,Stolk;24891,-87,89,Struxdorf, Schnarup-Thumby;24893,-88,90,Taarstedt;24894,-88,89,Tolk, Twedt;24896,-90,90,Treia, Ahrenviölfeld;24897,-88,91,Ulsnis;24899,-89,90,Wohlde;24937,-75,94,Flensburg;24939,-78,90;24941,-79,90;24943,-79,90,Flensburg, Tastrup;24944,-80,90,Flensburg;24955,-81,88,Harrislee;24960,-81,91,Glücksburg, Munkbrarup;24963,-87,89,Tarp;24966,-81,88,Sörup;24969,-91,88,Großenwiehe, Lindewitt;24972,-76,90,Steinberg, Steinbergkirche;24975,-80,89,Husby;24976,-81,89,Handewitt;24977,-81,90,Langballig;24980,-89,88,Schafflund, Meyn u.a;24983,-84,89,Handewitt;24986,-87,88,Mittelangeln;24988,-86,89,Oeversee;24989,-79,90,Dollerup;24991,-86,89,Großsolt;24992,-89,89,Jörl;24994,-89,88,Medelby;24996,-80,89,Sterup;24997,-88,89,Wanderup;24999,-81,89,Wees;25335,-99,93,Elmshorn;25336,-99,92;25337,-99,92;25348,-91,94,Glückstadt;25355,-99,91,Barmstedt;25358,-99,92,Horst;25361,-97,93,Krempe, Grevenkop, Süderau, Muchelndorf;25364,-100,91,Brande-Hörnerkirchen;25365,-98,92,Klein Offenseth-Sparrieshoop;25368,-99,93,Kiebitzreihe;25370,-99,93,Seester;25371,-95,93,Seestermühe;25373,-99,92,Ellerhoop;25376,-92,93,Borsfleth;25377,-93,93,Kollmar, Pagensand;25379,-97,93,Herzhorn, Kamerlanderdeich;25421,-95,93,Pinneberg;25436,-93,96,Uetersen;25451,-103,91,Quickborn;25462,-101,92,Rellingen;25469,-99,92,Halstenbek;25474,-102,91,Ellerbek;25479,-103,90,Ellerau;25482,-98,92,Appen;25485,-103,90,Hemdingen;25486,-103,90,Alveslohe;25488,-98,92,Holm;25489,-98,93,Haseldorf;25491,-99,93,Hetlingen;25492,-98,92,Heist;25494,-101,91,Borstel-Hohenraden;25495,-99,91,Kummerfeld;25497,-98,92,Prisdorf;25499,-101,92,Tangstedt;25524,-97,91,Itzehoe;25541,-83,95,Brunsbüttel;25548,-96,91,Kellinghusen;25551,-96,91,Hohenlockstedt;25554,-93,93,Wilster;25557,-91,90,Hanerau-Hademarschen, Seefeld u.a.;25560,-96,91,Schenefeld;25563,-98,92,Wrist;25566,-96,92,Lägerdorf;25569,-93,93,Kremperheide;25572,-91,94,Sankt Margarethen;25573,-92,93,Beidenfleth, Klein Kampen;25575,-93,90,Beringstedt;25576,-91,94,Brokdorf;25578,-95,93,Dägeling, Neuenbrook;25579,-97,91,Fitzbek;25581,-96,89,Hennstedt;25582,-96,91,Hohenaspe;25584,-94,91,Holstenniendorf;25585,-91,90,Lütjenwestedt, Tackesdorf;25587,-94,92,Münsterdorf;25588,-94,92,Oldendorf;25590,-94,91,Osterstedt;25591,-95,91,Ottenbüttel;25593,-96,90,Reher;25594,-94,92,Vaale;25596,-93,92,Wacken;25597,-94,92,Westermoor;25599,-91,94,Wewelsfleth;25693,-91,93,Sankt Michaelisdonn, Gudendorf, Volsemenhusen, Trennewurth;25704,-91,93,Meldorf;25709,-90,94,Kronprinzenkoog, Marne u.a.;25712,-92,91,Burg (Dithmarschen);25715,-88,94,Eddelak, Averlak, Dingen, Ramhusen;25718,-90,94,Friedrichskoog;25719,-91,93,Barlt, Busenwurth;25721,-93,92,Eggstedt;25724,-82,95,Neufeld, Schmedeswurth;25725,-93,91,Schafstedt, Weidenhof, Bornholt;25727,-91,92,Süderhastedt;25729,-93,92,Windbergen;25746,-88,91,Heide u.a.;25761,-86,94,Büsum;25764,-88,93,Wesselburen;25767,-90,88,Albersdorf;25770,-92,92,Hemmingstedt;25774,-84,92,Lunden;25776,-88,91,Sankt Annen, Rehm-Flehde-Bargen;25779,-86,90,Hennstedt;25782,-88,90,Tellingstedt;25785,-89,91,Nordhastedt;25786,-88,91,Dellstedt;25788,-88,91,Delve;25791,-87,91,Linden, Barkenholm;25792,-85,92,Neuenkirchen;25794,-88,91,Pahlen;25795,-88,91,Weddingstedt;25797,-91,92,Wöhrden;25799,-88,90,Wrohm;25813,-88,91,Husum, Schwesing u.a.;25821,-90,90,Bredstedt, Breklum u.a.;25826,-80,94,Sankt Peter-Ording;25832,-84,93,Tönning;25836,-82,93,Garding, Osterhever, Poppenbüll u.a.;25840,-88,91,Friedrichstadt, Koldenbüttel u.a.;25842,-90,89,Langenhorn, Ockholm u.a.;25845,-82,92,Nordstrand, Elisabeth-Sophien-Koog, Südfall;25849,-70,94,Süderoog, Pellworm;25850,-89,89,Behrendorf, Bondelum;25852,-88,89,Bordelum;25853,-91,89,Ahrenshöft;25855,-90,89,Haselund;25856,-88,91,Hattstedt u.a.;25858,-91,89,Högel;25859,-66,94,Hallig Hooge;25860,-89,90,Horstedt;25862,-90,88,Joldelund;25863,-73,93,Langeneß;25864,-91,88,Löwenstedt;25866,-90,90,Mildstedt;25867,-73,93,Oland;25868,-88,91,Norderstapel;25869,-79,91,Habel, Gröde;25870,-85,92,Oldenswort;25872,-88,88,Ostenfeld;25873,-90,89,Rantrum;25876,-89,89,Schwabstedt;25878,-88,90,Drage, Seeth;25879,-89,91,Süderstapel;25881,-82,93,Tating, Westerhever, Tümlauer Koog;25882,-85,93,Tetenbüll;25884,-90,89,Viöl;25885,-89,89,Wester-Ohrstedt;25887,-90,90,Winnert;25889,-86,92,Uelvesbüll, Witzwort;25899,-86,90,Niebüll;25917,-92,88,Leck;25920,-91,89,Risum-Lindholm, Stedesand;25923,-91,88,Süderlügum, Braderup u.a.;25924,-76,91,Rodenäs;25926,-90,88,Ladelund;25927,-85,90,Neukirchen, Aventoft;25938,-76,92,Föhr;25946,-66,94,Amrum;25980,-69,94,Sylt;25992,-68,95,List;25996,-70,94,Wenningstedt-Braderup (Sylt);25997,-71,93,Hörnum (Sylt);25999,-68,95,Kampen (Sylt);26121,-88,100,Oldenburg (Oldenburg);26122,-88,100,Oldenburg;26123,-88,99,Oldenburg (Oldenburg);26125,-95,95;26127,-88,98;26129,-90,97;26131,-91,97;26133,-88,100;26135,-93,96;26160,-95,96,Bad Zwischenahn;26169,-95,96,Friesoythe;26180,-94,96,Rastede;26188,-95,96,Edewecht;26197,-96,94,Großenkneten;26203,-96,95,Wardenburg;26209,-96,95,Hatten;26215,-96,95,Wiefelstede;26219,-96,96,Bösel;26316,-89,95,Varel;26340,-87,95,Zetel;26345,-90,96,Bockhorn;26349,-90,97,Jade;26382,-78,99,Wilhelmshaven;26384,-79,98;26386,-82,96;26388,-82,96;26389,-80,97;26409,-86,97,Wittmund;26419,-86,96,Schortens;26427,-82,97,Esens, Neuharlingersiel u. a.;26434,-81,96,Wangerland;26441,-85,96,Jever;26446,-87,95,Friedeburg;26452,-85,96,Sande;26465,-69,99,Langeoog;26474,-69,99,Spiekeroog;26486,-79,97,Wangerooge;26487,-85,97,Blomberg, Neuschoo;26489,-84,97,Ochtersum;26506,-75,98,Norden;26524,-75,98,Hage, Halbemond u.a.;26529,-86,97,Upgant-Schott, Osteel u.a.;26532,-84,97,Großheide;26548,-71,99,Norderney;26553,-75,99,Dornum;26556,-83,97,Westerholt, Schweindorf u.a.;26571,-73,99,Juist, Memmert;26579,-73,99,Baltrum;26603,-84,98,Aurich;26605,-87,96;26607,-87,96;26624,-90,97,Südbrookmerland;26629,-89,96,Großefehn;26632,-91,96,Ihlow;26639,-89,95,Wiesmoor;26655,-95,96,Westerstede;26670,-93,96,Uplengen;26676,-94,96,Barßel;26683,-95,96,Saterland;26689,-93,96,Apen;26721,-89,97,Emden;26723,-91,97;26725,-93,96;26736,-88,97,Krummhörn;26759,-93,96,Hinte;26789,-87,99,Leer;26802,-91,97,Moormerland;26810,-93,96,Westoverledingen;26817,-93,96,Rhauderfehn;26826,-91,98,Weener;26831,-93,97,Bunde;26835,-93,95,Hesel, Neukamperfehn u. a.;26842,-94,96,Ostrhauderfehn;26844,-93,97,Jemgum;26845,-93,96,Nortmoor;26847,-93,96,Detern;26849,-93,96,Filsum;26871,-93,97,Papenburg;26892,-93,98,Dörpen, Lehe, u.a.;26897,-96,96,Esterwegen u.a.;26899,-93,97,Rhede (Ems);26901,-94,97,Lorup, Rastdorf;26903,-95,97,Surwold;26904,-96,96,Börger;26906,-93,98,Dersum;26907,-93,98,Walchum;26909,-94,97,Neubörger, Neulehe;26919,-91,97,Brake;26931,-94,96,Elsfleth;26935,-91,97,Stadland;26936,-90,97;26937,-86,97;26939,-93,97,Ovelgönne;26954,-88,98,Nordenham;26969,-88,97,Butjadingen;27211,-97,96,Bassum;27232,-99,98,Sulingen;27239,-97,96,Twistringen;27243,-96,95,Harpstedt, Groß Ippener, Colnrade u.a.;27245,-103,100,Bahrenborstel, Barenburg, Kirchdorf;27246,-103,100,Borstel;27248,-98,97,Ehrenburg;27249,-102,99,Maasen, Mellinghausen;27251,-100,97,Neuenkirchen, Scholen;27252,-101,97,Schwaförden;27254,-103,99,Siedenburg, Staffhorst;27257,-98,96,Affinghausen und Sudwalde;27259,-98,99,Freistatt, Varrel, Wehrbleck;27283,-101,96,Verden;27299,-98,95,Langwedel;27305,-100,96,Bruchhausen-Vilsen, Süstedt;27308,-103,95,Kirchlinteln;27313,-105,96,Dörverden;27318,-102,97,Hoya, Hoyerhagen, Hilgermissen;27321,-96,96,Thedinghausen, Emtinghausen;27324,-105,98,Eystrup, Hassel u. a.;27327,-96,97,Martfeld, Schwarme;27330,-103,98,Asendorf;27333,-106,98,Schweringen, Warpe, Bücken;27336,-106,98,Rethem (Aller), Häuslingen, Frankenfeld;27337,-98,97,Blender;27339,-95,96,Riede;27356,-101,94,Rotenburg;27367,-99,94,Sottrum, Reeßum, Bötersen u.a.;27374,-105,93,Visselhövede;27383,-103,94,Scheeßel;27386,-101,94,Bothel, Kirchwalsede u.a.;27389,-104,93,Fintel, Lauenbrück u.a.;27404,-100,92,Zeven, Elsdorf;27412,-100,92,Tarmstedt, Breddorf u.a.;27419,-101,92,Sittensen u.a.;27432,-97,93,Bremervörde;27442,-98,93,Gnarrenburg;27446,-101,92,Selsingen;27449,-100,92,Kutenholz;27472,-77,98,Cuxhaven;27474,-79,97;27476,-84,96;27478,-88,96;27499,-83,96,Neuwerk;27568,-81,100,Bremerhaven;27570,-78,103;27572,-86,98;27574,-84,99;27576,-84,99;27578,-86,98;27580,-81,100;27607,-93,95,Geestland;27612,-92,97,Loxstedt;27616,-94,95,Beverstedt;27619,-93,96,Schiffdorf;27624,-96,95,Geestland;27628,-94,96,Hagen;27639,-91,96,Wurster Nordseeküste;27711,-97,93,Osterholz-Scharmbeck;27721,-94,95,Ritterhude;27726,-96,95,Worpswede;27729,-97,93,Hambergen, Holste u.a.;27749,-89,100,Delmenhorst;27751,-93,96;27753,-90,99;27755,-93,96;27777,-94,94,Ganderkesee;27793,-96,95,Wildeshausen;27798,-95,96,Hude (Oldenburg);27801,-96,94,Dötlingen;27804,-94,96,Berne;27809,-95,96,Lemwerder;28195,-86,101,Bremen;28197,-93,96;28199,-88,100;28201,-91,98;28203,-88,100;28205,-88,100;28207,-88,100;28209,-88,100;28211,-88,101;28213,-91,97;28215,-90,99;28217,-90,99;28219,-94,96;28237,-90,97;28239,-89,99;28259,-91,98;28277,-90,99;28279,-91,98;28307,-91,98;28309,-88,100;28325,-88,100;28327,-88,100;28329,-88,100;28355,-95,96;28357,-94,96;28359,-91,97;28717,-91,96;28719,-90,97;28755,-90,97;28757,-90,97;28759,-90,98;28777,-93,96;28779,-91,96;28790,-94,95,Schwanewede;28816,-93,96,Stuhr;28832,-97,95,Achim;28844,-92,96,Weyhe;28857,-97,95,Syke;28865,-95,96,Lilienthal;28870,-97,95,Ottersberg;28876,-96,95,Oyten;28879,-96,95,Grasberg;29221,-107,102,Celle;29223,-111,99;29225,-110,99;29227,-111,98;29229,-112,96,Celle, Wittbeck;29303,-112,91,Bergen, Lohheide u.a.;29308,-111,96,Winsen (Aller);29313,-111,97,Hambühren;29320,-113,92,Hermannsburg;29323,-112,97,Wietze;29328,-117,91,Faßberg;29331,-113,96,Lachendorf;29336,-111,98,Nienhagen;29339,-112,97,Wathlingen;29342,-111,97,Wienhausen;29345,-117,90,Unterlüß;29348,-115,92,Eschede;29351,-113,94,Eldingen;29352,-111,98,Adelheidsdorf;29353,-113,96,Ahnsbeck;29355,-113,95,Beedenbostel;29356,-112,97,Bröckel;29358,-111,97,Eicklingen;29359,-113,93,Habighorst;29361,-113,94,Höfer;29362,-113,96,Hohne;29364,-112,97,Langlingen;29365,-117,91,Sprakensehl;29367,-114,93,Steinhorst;29369,-113,95,Ummern;29378,-118,93,Wittingen;29379,-116,94;29386,-116,92,Hankensbüttel, Obernholz, Dedelstorf;29389,-118,93,Bad Bodenteich;29392,-113,95,Wesendorf;29393,-114,94,Groß Oesingen;29394,-118,93,Lüder;29396,-115,95,Schönewörde;29399,-114,95,Wahrenholz;29410,-117,96,Salzwedel;29413,-118,93,Dähre, Diesdorf, Wallstawe;29416,-118,93,Kuhfelde;29439,-116,95,Lüchow;29451,-116,95,Dannenberg;29456,-116,94,Hitzacker (Elbe);29459,-118,93,Clenze;29462,-116,94,Wustrow;29465,-118,93,Schnega;29468,-118,93,Bergen;29471,-120,94,Gartow;29472,-116,95,Damnatz;29473,-114,91,Göhrde;29475,-119,94,Gorleben;29476,-117,95,Gusborn;29478,-120,93,Höhbeck;29479,-116,94,Jameln;29481,-116,93,Karwitz;29482,-116,94,Küsten;29484,-117,94,Langendorf;29485,-118,94,Lemgow;29487,-117,94,Luckau (Wendland);29488,-117,94,Lübbow;29490,-112,92,Neu Darchau;29491,-118,94,Prezelle;29493,-121,95,Schnackenburg;29494,-118,94,Trebel;29496,-117,93,Waddeweitz;29497,-117,94,Woltersdorf;29499,-116,91,Zernien;29525,-111,95,Uelzen;29549,-116,93,Bad Bevensen;29553,-113,94,Bienenbüttel;29556,-120,91,Suderburg;29559,-118,91,Wrestedt;29562,-118,92,Suhlendorf;29565,-118,90,Wriedel;29571,-116,91,Rosche;29574,-120,91,Ebstorf;29575,-113,92,Altenmedingen;29576,-120,91,Barum;29578,-117,90,Eimke;29579,-118,93,Emmendorf;29581,-120,92,Gerdau;29582,-120,91,Hanstedt;29584,-116,92,Himbergen;29585,-117,92,Jelmstorf;29587,-118,91,Natendorf;29588,-118,93,Oetzen;29590,-120,92,Rätzlingen;29591,-116,92,Römstedt;29593,-120,92,Schwienau;29594,-117,92,Soltendiek;29597,-117,91,Stoetze;29599,-117,92,Weste;29614,-103,93,Soltau;29633,-116,91,Munster;29640,-106,91,Schneverdingen, Heimbuch;29643,-105,93,Neuenkirchen;29646,-108,91,Bispingen;29649,-111,91,Wietzendorf;29664,-106,95,Walsrode, Ostenholz;29683,-105,92,Bad Fallingbostel, Osterheide;29690,-108,98,Schwarmstedt u.a.;29693,-106,97,Hodenhagen u.a.;29699,-104,93,Bomlitz;30159,-100,109,Hannover;30161,-107,104;30163,-107,104;30165,-108,101;30167,-107,103;30169,-106,104;30171,-106,104;30173,-107,104;30175,-107,103;30177,-107,103;30179,-105,104;30419,-110,101;30449,-107,103;30451,-108,102;30453,-106,104;30455,-107,103;30457,-107,102;30459,-107,102;30519,-107,104;30521,-107,102;30539,-113,97;30559,-108,101;30625,-107,103;30627,-106,104;30629,-113,98;30655,-107,103;30657,-110,100;30659,-111,99;30669,-113,99,Langenhagen (Flughafen);30823,-108,101,Garbsen;30826,-110,100;30827,-109,100;30851,-106,104,Langenhagen;30853,-110,100;30855,-113,98;30880,-111,98,Laatzen;30890,-109,100,Barsinghausen;30900,-111,98,Wedemark;30916,-113,98,Isernhagen;30926,-111,99,Seelze;30938,-111,98,Burgwedel;30952,-111,99,Ronnenberg;30966,-110,99,Hemmingen;30974,-111,98,Wennigsen (Deister);30982,-112,98,Pattensen;30989,-111,99,Gehrden;31008,-111,97,Elze;31020,-115,94,Salzhemmendorf;31028,-112,98,Gronau (Leine);31029,-110,97,Banteln;31032,-113,94,Betheln;31033,-116,93,Brüggen;31035,-112,95,Despetal;31036,-111,96,Eime;31039,-112,95,Rheden;31061,-111,96,Alfeld (Leine);31073,-120,93,Grünenplan, Delligsen;31079,-120,89,Eberholzen, Sibbesse, Westfeld, Almstedt, Adenstedt;31084,-118,94,Freden (Leine);31085,-120,92,Everode;31087,-122,91,Landwehr;31088,-121,92,Winzenburg;31089,-122,90,Duingen;31091,-121,92,Coppengrave;31093,-118,93,Hoyershausen;31094,-118,87,Marienhagen;31096,-121,90,Weenzen;31097,-122,91,Harbarnsen;31099,-123,90,Woltershausen;31134,-107,102,Hildesheim;31135,-110,99;31137,-108,101;31139,-115,91;31141,-110,96;31157,-109,100,Sarstedt;31162,-115,96,Bad Salzdetfurth;31167,-117,96,Bockenem;31171,-112,98,Nordstemmen;31174,-111,97,Schellerten;31177,-112,97,Harsum;31180,-112,98,Giesen;31185,-113,97,Söhlde;31188,-115,96,Holle;31191,-112,98,Algermissen;31195,-122,88,Lamspringe, Neuhof;31196,-121,92,Sehlem;31199,-117,90,Diekholzen;31224,-111,98,Peine;31226,-111,98;31228,-111,98;31234,-113,97,Edemissen;31241,-111,98,Ilsede;31246,-113,97,Lahstedt;31249,-112,97,Hohenhameln;31275,-112,98,Lehrte;31303,-112,97,Burgdorf;31311,-112,97,Uetze;31319,-113,98,Sehnde;31515,-106,101,Wunstorf;31535,-108,100,Neustadt am Rübenberge;31542,-108,101,Bad Nenndorf;31547,-107,101,Rehburg-Loccum;31552,-107,99,Apelern, Rodenberg;31553,-107,101,Auhagen, Sachsenhagen;31555,-108,101,Suthfeld;31556,-107,99,Wölpinghausen;31558,-106,101,Hagenburg;31559,-108,101,Haste, Hohnhorst;31582,-105,101,Nienburg/Weser;31592,-106,102,Stolzenau;31595,-104,101,Steyerberg;31600,-103,101,Uchte;31603,-103,101,Diepenau;31604,-105,101,Raddestorf;31606,-104,101,Warmsen;31608,-108,99,Marklohe;31609,-106,100,Balge;31613,-106,99,Wietzen;31618,-106,101,Liebenau;31619,-108,100,Binnen;31621,-105,100,Pennigsehl;31622,-106,99,Heemsen;31623,-107,100,Drakenburg;31626,-106,98,Haßbergen;31627,-106,98,Rohrsen;31628,-106,101,Landesbergen;31629,-107,101,Estorf;31632,-108,101,Husum;31633,-106,102,Leese;31634,-107,99,Steimbke;31636,-108,100,Linsburg;31637,-107,99,Rodewald;31638,-110,99,Stöckse;31655,-106,100,Stadthagen;31675,-105,102,Bückeburg;31683,-108,96,Obernkirchen;31688,-104,100,Nienstädt;31691,-105,102,Helpsen, Seggebruch;31693,-105,102,Hespe;31698,-107,101,Lindhorst;31699,-107,101,Beckedorf;31700,-106,101,Heuerßen;31702,-106,101,Lüdersfeld;31707,-105,100,Heeßen, Bad Eilsen;31708,-105,102,Ahnsen;31710,-105,99,Buchholz;31711,-104,99,Luhden;31712,-106,102,Niederwöhren;31714,-106,101,Lauenhagen;31715,-105,102,Meerbeck;31717,-106,102,Nordsehl;31718,-106,102,Pollhagen;31719,-106,102,Wiedensahl;31737,-103,101,Rinteln;31749,-108,96,Auetal;31785,-103,102,Hameln;31787,-106,100;31789,-108,99;31812,-113,94,Bad Pyrmont;31832,-111,98,Springe;31840,-107,100,Hessisch Oldendorf;31848,-107,97,Bad Münder am Deister;31855,-113,92,Aerzen;31860,-111,98,Emmerthal;31863,-116,87,Coppenbrügge;31867,-108,100,Pohle, Lauenau, Messenkamp, Hülsede etc;31868,-122,85,Ottenstein;32049,-102,97,Herford;32051,-100,99;32052,-100,99;32105,-100,100,Bad Salzuflen;32107,-100,98;32108,-102,96;32120,-100,98,Hiddenhausen;32130,-99,100,Enger;32139,-99,99,Spenge;32257,-101,100,Bünde;32278,-101,98,Kirchlengern;32289,-101,98,Rödinghausen;32312,-101,101,Lübbecke;32339,-102,100,Espelkamp;32351,-98,99,Stemwede;32361,-102,100,Preußisch Oldendorf;32369,-100,100,Rahden;32423,-100,105,Minden;32425,-103,102;32427,-100,104;32429,-103,102;32457,-103,99,Porta Westfalica;32469,-104,102,Petershagen;32479,-103,101,Hille;32545,-103,97,Bad Oeynhausen;32547,-102,100;32549,-103,101;32584,-98,103,Löhne;32602,-102,97,Vlotho;32609,-101,98,Hüllhorst;32657,-100,100,Lemgo;32676,-116,91,Lügde;32683,-115,89,Barntrup;32689,-113,89,Kalletal;32694,-107,94,Dörentrup;32699,-110,94,Extertal;32756,-97,102,Detmold;32758,-103,96;32760,-107,95;32791,-103,97,Lage;32805,-111,92,Horn-Bad Meinberg;32816,-116,88,Schieder-Schwalenberg;32825,-113,90,Blomberg;32832,-106,94,Augustdorf;32839,-111,93,Steinheim;33014,-115,91,Bad Driburg;33034,-114,93,Brakel;33039,-113,91,Nieheim;33098,-96,101,Paderborn;33100,-107,94;33102,-96,103;33104,-102,99;33106,-103,100;33129,-103,100,Delbrück;33142,-111,88,Büren;33154,-101,101,Salzkotten;33161,-104,99,Hövelhof;33165,-113,88,Lichtenau;33175,-102,98,Bad Lippspringe;33178,-105,94,Borchen;33181,-113,87,Wünnenberg;33184,-113,87,Altenbeken;33189,-106,95,Schlangen;33330,-97,103,Gütersloh;33332,-95,106;33333,-99,102,Bertelsmann;33334,-97,103,Gütersloh;33335,-101,100;33378,-96,104,Rheda-Wiedenbrück;33397,-101,102,Rietberg;33415,-102,100,Verl;33428,-102,102,Harsewinkel;33442,-102,102,Herzebrock-Clarholz;33449,-101,101,Langenberg;33602,-88,109,Bielefeld;33604,-100,98;33605,-101,98;33607,-95,105;33609,-96,103;33611,-97,102;33613,-97,102;33615,-95,104;33617,-96,100;33619,-103,98;33647,-97,103;33649,-101,100;33659,-102,100;33689,-103,98;33699,-102,97;33719,-99,99;33729,-99,99;33739,-101,97;33758,-103,98,Schloß Holte-Stukenbrock;33775,-101,101,Versmold;33790,-101,100,Halle (Westfalen);33803,-103,100,Steinhagen;33813,-110,90,Oerlinghausen;33818,-101,98,Leopoldshöhe;33824,-103,97,Werther (Westf.);33829,-101,97,Borgholzhausen;34117,-101,103,Kassel;34119,-104,99;34121,-103,100;34123,-104,99;34125,-108,96;34127,-105,99;34128,-113,91;34130,-106,97;34131,-124,80;34132,-115,89;34134,-107,96;34212,-122,87,Melsungen;34225,-111,93,Baunatal;34233,-117,89,Kassel, Fuldatal;34246,-108,95,Vellmar;34253,-112,92,Lohfelden;34260,-116,91,Kaufungen;34266,-116,91,Niestetal;34270,-122,82,Schauenburg;34277,-116,92,Fuldabrück;34281,-118,91,Gudensberg;34286,-126,81,Spangenberg;34289,-117,87,Zierenberg;34292,-117,89,Ahnatal;34295,-116,91,Edermünde;34298,-123,83,Helsa;34302,-118,89,Guxhagen;34305,-121,88,Niedenstein;34308,-121,88,Bad Emstal;34311,-121,89,Naumburg;34314,-117,90,Espenau;34317,-126,77,Habichtswald;34320,-128,78,Söhrewald;34323,-123,88,Malsfeld;34326,-117,92,Morschen;34327,-117,89,Körle;34329,-119,87,Nieste;34346,-116,90,Hann. Münden, Gutsbezirk Reinhardswald;34355,-118,88,Staufenberg;34359,-112,94,Reinhardshagen;34369,-117,86,Hofgeismar;34376,-117,86,Immenhausen;34379,-115,89,Calden;34385,-116,92,Bad Karlshafen;34388,-116,89,Trendelburg;34393,-115,91,Grebenstein;34396,-113,91,Liebenau (Hessen);34399,-115,92,Oberweser;34414,-116,91,Warburg;34431,-114,89,Marsberg;34434,-115,90,Borgentreich;34439,-117,86,Willebadessen;34454,-116,88,Bad Arolsen;34466,-115,89,Wolfhagen;34471,-113,91,Volkmarsen;34474,-119,86,Diemelstadt;34477,-116,88,Twistetal;34479,-119,86,Breuna;34497,-119,84,Korbach;34508,-132,70,Willingen (Upland);34513,-121,83,Waldeck;34516,-119,85,Vöhl;34519,-117,84,Diemelsee;34537,-123,83,Bad Wildungen;34549,-120,92,Edertal;34560,-120,91,Fritzlar;34576,-120,86,Homberg;34582,-118,94,Borken;34587,-118,94,Felsberg;34590,-119,94,Wabern;34593,-128,77,Knüllwald;34596,-120,91,Bad Zwesten;34599,-117,91,Neuental;34613,-116,92,Schwalmstadt;34621,-120,87,Frielendorf;34626,-120,88,Neukirchen (Knüll);34628,-116,91,Willingshausen;34630,-121,86,Gilserberg;34632,-118,90,Jesberg;34633,-120,87,Ottrau;34637,-115,91,Schrecksbach;34639,-131,76,Schwarzenborn;35037,-115,95,Marburg;35039,-114,94;35041,-115,92;35043,-115,91;35066,-116,86,Frankenberg;35075,-112,90,Gladenbach;35080,-116,85,Bad Endbach;35083,-116,89,Wetter;35085,-115,93,Ebsdorfergrund;35088,-113,88,Battenberg;35091,-116,92,Cölbe;35094,-114,93,Lahntal;35096,-113,94,Weimar (Lahn);35099,-118,84,Burgwald;35102,-110,91,Lohra;35104,-120,82,Lichtenfels;35108,-115,88,Allendorf;35110,-118,84,Frankenau;35112,-111,96,Fronhausen;35114,-123,82,Haina;35116,-116,83,Hatzfeld;35117,-116,88,Münchhausen;35119,-117,86,Rosenthal;35216,-115,84,Biedenkopf;35232,-114,88,Dautphetal;35236,-113,83,Breidenbach;35239,-114,85,Steffenberg;35260,-118,90,Stadtallendorf;35274,-115,93,Kirchhain;35279,-118,90,Neustadt;35282,-118,89,Rauschenberg;35285,-118,90,Gemünden;35287,-116,93,Amöneburg;35288,-117,91,Wohratal;35305,-113,90,Grünberg;35315,-116,91,Homberg (Ohm);35321,-112,93,Laubach;35325,-116,91,Mücke;35327,-127,74,Ulrichstein;35329,-117,89,Gemünden (Felda);35390,-105,101,Gießen;35392,-109,97;35394,-110,96;35396,-110,96;35398,-111,97;35410,-106,99,Hungen;35415,-112,94,Pohlheim;35418,-111,93,Buseck;35423,-109,97,Lich;35428,-112,94,Langgöns;35435,-112,92,Wettenberg;35440,-111,96,Linden;35444,-113,88,Biebertal;35447,-111,95,Reiskirchen;35452,-113,95,Heuchelheim;35457,-113,93,Lollar;35460,-113,95,Staufenberg;35463,-112,94,Fernwald;35466,-113,91,Rabenau;35469,-112,94,Allendorf;35510,-108,93,Butzbach;35516,-109,98,Münzenberg;35519,-109,98,Rockenberg;35576,-106,100,Wetzlar;35578,-108,95;35579,-111,95;35580,-110,95;35581,-113,93;35582,-112,96;35583,-109,96,Wetzlar Garbeinheim;35584,-111,94,Wetzlar;35585,-112,89;35586,-110,96;35606,-107,97,Solms;35614,-111,90,Aßlar;35619,-111,95,Braunfels;35625,-111,92,Hüttenberg;35630,-109,92,Ehringshausen;35633,-113,94,Lahnau;35638,-110,94,Leun;35641,-108,92,Schöffengrund;35644,-111,90,Hohenahr;35647,-108,92,Waldsolms;35649,-112,90,Bischoffen;35683,-110,94,Dillenburg;35684,-111,86;35685,-111,87;35686,-111,86;35687,-109,90;35688,-111,88;35689,-113,86;35690,-113,83;35708,-110,90,Haiger;35713,-112,89,Eschenburg;35716,-115,77,Dietzhölztal;35719,-113,83,Angelburg;35745,-110,92,Herborn;35753,-111,87,Greifenstein;35756,-112,90,Mittenaar;35759,-111,81,Driedorf;35764,-113,94,Sinn;35767,-112,83,Breitscheid;35768,-113,84,Siegbach;35781,-108,97,Weilburg;35789,-108,93,Weilmünster;35792,-111,94,Löhnberg;35794,-109,88,Mengerskirchen;35796,-108,96,Weinbach;35799,-108,92,Merenberg;36037,-113,94,Fulda;36039,-123,84;36041,-120,90;36043,-118,91;36088,-123,90,Hünfeld;36093,-122,87,Künzell;36100,-121,89,Petersberg;36103,-120,88,Flieden;36110,-123,89,Schlitz;36115,-131,80,Hilders, Ehrenberg;36119,-121,86,Neuhof;36124,-122,87,Eichenzell;36129,-133,73,Gersfeld;36132,-126,85,Eiterfeld;36137,-121,89,Großenlüder;36142,-132,80,Tann;36145,-128,82,Hofbieber;36148,-123,83,Kalbach;36151,-125,87,Burghaun;36154,-120,87,Hosenfeld;36157,-124,84,Ebersburg;36160,-123,84,Dipperz;36163,-128,78,Poppenhausen;36166,-125,87,Haunetal;36167,-124,86,Nüsttal;36169,-126,87,Rasdorf;36179,-125,88,Bebra;36199,-125,88,Rotenburg an der Fulda;36205,-120,90,Sontra;36208,-127,87,Wildeck;36211,-118,92,Alheim;36214,-125,86,Nentershausen;36217,-126,87,Ronshausen;36219,-125,86,Cornberg;36251,-127,85,Bad Hersfeld, Ludwigsau;36266,-125,90,Heringen;36269,-126,88,Philippsthal;36272,-122,91,Niederaula;36275,-126,88,Kirchheim (Hessen);36277,-126,85,Schenklengsfeld;36280,-125,86,Oberaula;36282,-124,91,Hauneck;36284,-125,85,Hohenroda;36286,-128,81,Neuenstein (Hessen);36287,-124,88,Breitenbach am Herzberg;36289,-128,81,Friedewald;36304,-117,89,Alsfeld;36318,-118,88,Schwalmtal;36320,-120,87,Kirtorf;36323,-123,87,Grebenau;36325,-121,82,Feldatal;36326,-117,90,Antrifttal;36329,-118,87,Romrod;36341,-118,87,Lauterbach;36355,-121,82,Grebenhain;36358,-122,81,Herbstein;36364,-121,89,Bad Salzschlirf;36367,-120,90,Wartenberg;36369,-124,78,Lautertal;36381,-115,93,Schlüchtern;36391,-114,92,Sinntal;36396,-110,99,Steinau an der Straße;36399,-122,81,Freiensteinau;36404,-133,79,Vacha, Unterbreizbach;36414,-123,90,Unterbreizbach;36419,-128,83,Geisa;36433,-126,89,Bad Salzungen;36448,-132,82,Bad Liebenstein;36452,-130,83,Kaltennordheim;36456,-121,92,Barchfeld-Immelborn;36457,-125,89,Stadtlengsfeld, Weilar, Urnshausen;36460,-128,85,Krayenberggemein de, Frauensee;36466,-127,86,Dermbach, Wiesenthal;36469,-126,87,Tiefenort;37073,-106,104,Göttingen;37075,-123,89;37077,-123,86;37079,-121,89;37081,-113,97;37083,-121,93;37085,-123,87;37115,-119,92,Duderstadt;37120,-121,93,Bovenden;37124,-122,91,Rosdorf;37127,-125,83,Dransfeld u.a.;37130,-121,90,Gleichen;37133,-121,91,Friedland;37136,-120,90,Seulingen, Waake u.a.;37139,-120,91,Adelebsen;37154,-117,94,Northeim;37170,-117,91,Uslar;37176,-121,92,Nörten-Hardenberg;37181,-126,84,Hardegsen;37186,-121,88,Moringen;37191,-120,92,Katlenburg-Lindau;37194,-118,89,Bodenfelde, Wahlsburg;37197,-121,91,Hattorf;37199,-120,92,Wulften;37213,-115,92,Witzenhausen;37214,-123,87;37215,-123,87;37216,-126,79,Witzenhausen, Gutsbezirk;37217,-127,82,Witzenhausen;37218,-117,90;37235,-127,82,Hessisch Lichtenau;37242,-124,87,Bad Sooden-Allendorf;37247,-128,79,Großalmerode;37249,-120,88,Neu-Eichenberg;37269,-119,91,Eschwege;37276,-121,90,Meinhard;37281,-120,94,Wanfried;37284,-125,88,Waldkappel;37287,-118,93,Wehretal;37290,-125,87,Meißner;37293,-128,87,Herleshausen;37296,-128,85,Ringgau;37297,-122,90,Berkatal;37299,-128,88,Weißenborn;37308,-131,78,Heiligenstadt;37318,-126,84,Arenshausen, Uder u.a.;37327,-125,86,Leinefelde-Worbis, Wingerode, Hausen;37339,-132,80,Worbis;37345,-127,88,Am Ohmberg, Sonnenstein;37351,-127,86,Dingelstädt;37355,-127,87,Niederorschel u.a.;37359,-128,81,Küllstedt;37412,-123,89,Herzberg, Elbingerode, Hörden;37431,-135,77,Bad Lauterberg;37434,-119,92,Gieboldehausen, Rhumequelle;37441,-132,83,Bad Sachsa;37444,-142,62,Braunlage;37445,-130,87,Walkenried;37447,-135,79,Wieda;37449,-136,72,Zorge;37520,-129,84,Osterode am Harz;37539,-123,90,Bad Grund;37574,-121,94,Einbeck, Kreiensen;37581,-123,91,Bad Gandersheim;37586,-119,91,Dassel;37589,-123,92,Kalefeld;37603,-125,82,Holzminden;37619,-114,96,Bodenwerder, Pegestorf, Kirchbrak, Hehlen;37620,-116,95,Halle;37627,-119,88,Stadtoldendorf u.a.;37632,-121,88,Holzen, Eschershausen, Eimen;37633,-117,94,Dielmissen;37635,-118,93,Lüerdissen;37639,-116,93,Bevern;37640,-117,92,Golmbach;37642,-118,88,Holenberg;37643,-119,90,Negenborn;37647,-116,93,Brevörde, Polle, Vahlbruch;37649,-119,87,Heinsen;37671,-115,92,Höxter;37688,-116,87,Beverungen;37691,-124,83,Boffzen, Derental;37696,-116,88,Marienmünster;37697,-116,91,Lauenförde;37699,-115,89,Fürstenberg;38100,-103,108,Braunschweig;38102,-107,103;38104,-115,97;38106,-108,102;38108,-114,98;38110,-114,98;38112,-113,98;38114,-110,101;38116,-113,98;38118,-107,103;38120,-114,97;38122,-115,97;38124,-112,99;38126,-115,97;38154,-119,95,Königslutter am Elm;38159,-113,97,Vechelde;38162,-117,95,Cremlingen;38165,-116,97,Lehre;38170,-120,96,Schöppenstedt;38173,-117,96,Sickte, Dettum u.a.;38176,-113,97,Wendeburg;38179,-114,97,Schwülper;38226,-110,100,Salzgitter;38228,-114,97;38229,-115,97;38239,-114,97;38259,-119,95;38268,-112,97,Lengede;38271,-115,97,Baddeckenstedt;38272,-115,96,Burgdorf;38274,-117,96,Elbe;38275,-118,94,Haverlah;38277,-118,94,Heere;38279,-124,89,Sehlde;38300,-115,98,Wolfenbüttel;38302,-115,97;38304,-117,95;38312,-116,97,Dorstadt, Flöthe, Börßum u.a.;38315,-120,97,Schladen-Werla;38319,-120,96,Remlingen;38321,-116,97,Denkte;38322,-121,96,Hedeper;38324,-118,96,Kissenbrück;38325,-121,96,Roklum;38327,-120,96,Semmenstedt;38329,-119,95,Wittmar;38350,-119,96,Helmstedt;38364,-121,94,Schöningen;38368,-122,93,Rennau, Querenhorst, Mariental, Grasleben;38372,-122,94,Büddenstedt;38373,-121,95,Süpplingen, Frellstedt;38375,-122,93,Räbke;38376,-121,95,Süpplingenburg;38378,-122,94,Warberg;38379,-121,94,Wolsdorf;38381,-123,95,Jerxheim;38382,-122,96,Beierstedt;38384,-121,96,Gevensleben;38385,-123,95,Ingeleben;38387,-123,96,Söllingen;38388,-123,94,Twieflingen;38440,-111,100,Wolfsburg;38442,-115,97;38444,-118,95;38446,-118,95;38448,-117,96;38458,-121,95,Velpke;38459,-122,94,Bahrdorf;38461,-119,96,Danndorf;38462,-119,96,Grafhorst;38464,-121,94,Groß Twülpstedt;38465,-120,94,Brome;38467,-118,95,Bergfeld;38468,-116,95,Ehra-Lessien;38470,-118,95,Parsau;38471,-118,96,Rühen;38473,-118,96,Tiddische;38474,-119,95,Tülau;38476,-116,96,Barwedel;38477,-116,96,Jembke;38479,-116,96,Tappenbeck;38486,-122,93,Klötze, Apenburg-Winterfeld;38489,-118,94,Beetzendorf, Rohrberg, Jübar;38518,-113,97,Gifhorn;38524,-115,96,Sassenburg;38527,-115,97,Meine;38528,-114,97,Adenbüttel;38530,-113,98,Didderse;38531,-114,97,Rötgesbüttel;38533,-114,97,Vordorf;38536,-112,97,Meinersen;38539,-113,97,Müden (Aller);38542,-113,97,Leiferde;38543,-113,97,Hillerse;38547,-115,97,Calberlah;38550,-114,97,Isenbüttel;38551,-114,97,Ribbesbüttel;38553,-115,97,Wasbüttel;38554,-116,96,Weyhausen;38556,-116,96,Bokensdorf;38557,-115,96,Osloß;38559,-113,96,Wagenhoff, Ringelah;38640,-124,93,Goslar;38642,-125,94;38644,-129,88;38667,-135,80,Bad Harzburg, Torfhaus;38678,-137,70,Clausthal-Zellerfeld, Oberschulenberg;38685,-127,90,Langelsheim;38690,-123,95,Goslar;38700,-137,69,Braunlage;38704,-123,93,Liebenburg;38707,-137,76,Altenau, Schulenberg;38709,-133,81,Wildemann;38723,-122,92,Seesen;38729,-122,94,Hahausen, Lutter, Wallmoden;38820,-125,97,Halberstadt;38822,-127,94,Halberstadt, Groß Quenstedt;38828,-128,94,Wegeleben;38829,-128,94,Harsleben;38835,-127,94,Osterwieck;38836,-125,95,Badersleben u.a.;38838,-125,95,Huy;38855,-129,95,Wernigerode, Nordharz;38871,-131,94,Ilsenburg, Nordharz;38875,-138,73,Oberharz am Brocken;38877,-137,71;38879,-156,47,Wernigerode;38889,-140,77,Blankenburg, Oberharz am Brocken;38895,-132,93,Langenstein, Derenburg;38899,-142,74,Oberharz am Brocken;39104,-120,99,Magdeburg;39106,-117,101;39108,-111,106;39110,-124,95;39112,-117,102;39114,-125,96;39116,-123,95;39118,-119,99;39120,-123,94;39122,-126,94;39124,-118,99;39126,-122,96;39128,-120,98;39130,-120,98;39164,-126,94,Wanzleben-Börde;39167,-125,93,Eichenbarleben, Ochtmersleben, Irxleben, Schnarsleben, Wellen etc;39171,-126,94,Sülzetal;39175,-125,95,Gerwisch, Biederitz, Menz, Körbelitz etc;39179,-123,95,Barleben;39217,-126,95,Schönebeck (Elbe);39218,-121,98,Schönebeck;39221,-127,94,Welsleben, Biere, Eickendorf, Eggersdorf, Großmühlingen etc;39240,-128,95,Calbe, Rosenburg, Lödderitz etc;39245,-125,95,Gommern, Dannigkow;39249,-126,95,Barby;39261,-128,95,Zerbst/Anhalt;39264,-128,94,Güterglück, Lübs, Deetz, Jütrichau etc;39279,-128,93,Loburg, Leitzkau;39288,-128,95,Burg;39291,-127,93,Möckern, Schermen, Nedlitz etc;39307,-132,94,Genthin, Hohenseeden, Zabakuck u.a.;39317,-131,94,Elbe-Parey;39319,-130,94,Jerichow;39326,-125,95,Wolmirstedt u.a.;39340,-121,95,Haldensleben;39343,-123,94,Erxleben, Nordgermersleben u.a.;39345,-123,94,Haldensleben, Flechtingen, Bülstringen u.a.;39356,-121,94,Weferlingen, Behnsdorf, Belsdorf etc;39359,-121,94,Rätzlingen, Wegenstedt, Calvörde, Böddensell etc;39365,-123,93,Harbke, Sommersdorf, Wefensleben, Ummendorf, Eilsleben;39387,-123,96,Oschersleben (Bode);39393,-122,95,Hötensleben, Völpke, Ottleben, Hamersleben etc;39397,-126,95,Schwanebeck, Gröningen, Kroppenstedt;39418,-125,96,Staßfurt;39435,-126,95,Egeln, Unseburg, Wolmirsleben, Borne etc;39439,-128,95,Güsten;39443,-127,95,Staßfurt;39444,-128,92,Hecklingen;39446,-126,95,Staßfurt;39448,-126,95,Börde-Hakel;39517,-125,94,Tangerhütte u.a.;39524,-130,93,Sandau;39539,-126,94,Havelberg;39576,-125,94,Stendal;39579,-124,93,Bismark, Rochau;39590,-126,94,Tangermünde;39596,-127,94,Goldbeck, Arneburg u.a.;39599,-124,93,Bismark;39606,-124,94,Osterburg, Altmärkische Höhe;39615,-124,94,Seehausen, Werben, Leppin, Wahrenberg etc;39619,-121,94,Arendsee;39624,-122,93,Kalbe, Bismark;39629,-123,94,Bismark;39638,-123,93,Gardelegen;39646,-121,95,Oebisfelde;39649,-122,94,Gardelegen;40210,-68,119,Düsseldorf;40211,-68,119;40212,-69,118;40213,-69,118;40215,-68,121;40217,-69,120;40219,-78,113;40221,-80,110;40223,-78,112;40225,-77,113;40227,-73,116;40229,-80,110;40231,-77,113;40233,-74,115;40235,-75,114;40237,-75,114;40239,-76,114;40468,-77,113;40470,-78,113;40472,-81,110;40474,-79,111;40476,-76,115;40477,-76,114;40479,-77,113;40489,-84,108;40545,-79,111;40547,-78,113;40549,-78,113;40589,-80,110;40591,-76,114;40593,-79,109;40595,-78,111;40597,-76,113;40599,-78,112;40625,-79,111;40627,-80,110;40629,-83,105;40667,-84,108,Meerbusch;40668,-83,109;40670,-83,109;40699,-83,106,Erkrath;40721,-77,112,Hilden, Düsseldorf;40723,-77,112,Hilden;40724,-81,108;40764,-80,110,Langenfeld;40789,-81,109,Monheim am Rhein;40822,-84,104,Mettmann;40878,-79,112,Ratingen;40880,-84,108;40882,-83,104;40883,-83,105;40885,-83,106;41061,-70,117,Mönchengladbach;41063,-80,109;41065,-77,111;41066,-76,110;41068,-82,108;41069,-82,108;41169,-84,107;41179,-84,108;41189,-85,107;41199,-80,109;41236,-75,113;41238,-78,111;41239,-76,112;41334,-81,107,Nettetal;41352,-81,108,Korschenbroich;41363,-83,108,Jüchen;41366,-85,107,Schwalmtal;41372,-87,107,Niederkrüchten;41379,-86,106,Brüggen;41460,-78,112,Neuss;41462,-79,111;41464,-78,112;41466,-79,111;41468,-82,109;41469,-83,108;41470,-82,109;41472,-82,108;41515,-82,108,Grevenbroich;41516,-81,108;41517,-84,108;41539,-82,108,Dormagen;41540,-82,108;41541,-81,108;41542,-82,108;41564,-82,109,Kaarst;41569,-84,107,Rommerskirchen;41747,-77,110,Viersen;41748,-78,109;41749,-81,108;41751,-81,107;41812,-86,108,Erkelenz;41836,-86,109,Hückelhoven;41844,-87,107,Wegberg;41849,-87,108,Wassenberg;42103,-83,106,Wuppertal;42105,-81,107;42107,-83,106;42109,-83,105;42111,-87,99;42113,-85,102;42115,-82,106;42117,-82,106;42119,-86,101;42275,-78,111;42277,-84,105;42279,-92,96;42281,-84,104;42283,-83,106;42285,-83,103;42287,-89,97;42289,-85,102;42327,-83,102;42329,-85,101;42349,-90,97;42369,-87,99;42389,-85,104;42399,-97,94;42477,-98,91,Radevormwald;42489,-87,102,Wülfrath;42499,-97,94,Hückeswagen;42549,-85,102,Velbert;42551,-87,101;42553,-85,103;42555,-83,106;42579,-83,105,Heiligenhaus;42651,-83,105,Solingen;42653,-86,101;42655,-80,108;42657,-81,106;42659,-85,104;42697,-83,107;42699,-81,107;42719,-81,106;42781,-86,103,Haan;42799,-88,103,Leichlingen;42853,-88,98,Remscheid;42855,-88,101;42857,-88,101;42859,-90,101;42897,-94,93;42899,-88,97;42929,-91,101,Wermelskirchen;44135,-75,114,Dortmund;44137,-80,110;44139,-81,109;44141,-82,108;44143,-82,108;44145,-80,110;44147,-79,111;44149,-82,108;44225,-83,107;44227,-87,104;44229,-87,104;44263,-82,108;44265,-91,99;44267,-91,101;44269,-86,106;44287,-87,105;44289,-90,102;44309,-88,106;44319,-91,105;44328,-86,106;44329,-91,104;44339,-87,104;44357,-86,104;44359,-86,104;44369,-83,108;44379,-81,110;44388,-83,107;44532,-90,106,Lünen;44534,-90,104;44536,-90,104;44575,-83,108,Castrop-Rauxel;44577,-86,104;44579,-83,106;44581,-85,105;44623,-80,110,Herne;44625,-76,112;44627,-85,105;44628,-81,109;44629,-78,111;44649,-78,111;44651,-78,111;44652,-75,113;44653,-78,111;44787,-73,115,Bochum;44789,-78,110;44791,-80,108;44793,-81,108;44795,-79,109;44797,-84,105;44799,-79,109;44801,-81,107;44803,-80,108;44805,-83,106;44807,-82,107;44809,-78,111;44866,-78,111;44867,-80,109;44869,-81,107;44879,-81,107;44892,-83,107;44894,-81,109;45127,-71,116,Essen;45128,-72,115;45130,-76,110;45131,-80,107;45133,-82,105;45134,-82,106;45136,-78,110;45138,-76,110;45139,-76,110;45141,-79,109;45143,-75,113;45144,-77,111;45145,-76,111;45147,-77,110;45149,-80,107;45219,-81,107;45239,-84,104;45257,-83,106;45259,-80,108;45276,-76,112;45277,-76,111;45279,-80,109;45289,-83,106;45307,-79,109;45309,-78,110;45326,-76,112;45327,-78,111;45329,-73,114;45355,-77,111;45356,-75,113;45357,-78,110;45359,-80,108;45468,-76,113,Mülheim an der Ruhr;45470,-82,106;45472,-79,109;45473,-77,112;45475,-76,112;45476,-75,113;45478,-80,110;45479,-83,107;45481,-82,107;45525,-81,108,Hattingen;45527,-86,103;45529,-87,100;45549,-88,99,Sprockhövel;45657,-81,108,Recklinghausen;45659,-82,107;45661,-79,111;45663,-81,109;45665,-85,105;45699,-80,109,Herten;45701,-85,105;45711,-88,104,Datteln;45721,-85,104,Haltern am See;45731,-86,105,Waltrop;45739,-87,103,Oer-Erkenschwick;45768,-83,105,Marl;45770,-83,106;45772,-82,107;45879,-73,116,Gelsenkirchen;45881,-76,113;45883,-80,109;45884,-77,111,Gelsenkirchen Rotthausen;45886,-76,112,Gelsenkirchen;45888,-78,111;45889,-74,113;45891,-81,110;45892,-83,107;45894,-79,109;45896,-80,109;45897,-81,110;45899,-78,111;45964,-81,108,Gladbeck;45966,-81,108;45968,-78,112;46045,-74,114,Oberhausen;46047,-74,113;46049,-76,113;46117,-78,111;46119,-79,110;46145,-80,109;46147,-81,108;46149,-77,112;46236,-79,110,Bottrop;46238,-77,111;46240,-81,108;46242,-79,110;46244,-84,105;46282,-82,106,Dorsten;46284,-83,105;46286,-84,103;46325,-85,103,Borken;46342,-88,101,Velen;46348,-86,103,Raesfeld;46354,-87,102,Südlohn;46359,-86,101,Heiden;46395,-83,105,Bocholt;46397,-86,102;46399,-84,104;46414,-83,104,Rhede;46419,-83,105,Isselburg;46446,-81,106,Emmerich am Rhein;46459,-82,105,Rees;46483,-80,108,Wesel;46485,-81,106;46487,-82,105;46499,-83,105,Hamminkeln;46509,-82,106,Xanten;46514,-83,104,Schermbeck;46519,-83,106,Alpen;46535,-78,111,Dinslaken;46537,-80,109;46539,-83,106;46562,-82,106,Voerde (Niederrhein);46569,-83,105,Hünxe;47051,-78,112,Duisburg;47053,-77,113;47055,-81,110;47057,-81,108;47058,-79,111;47059,-71,117;47119,-78,111;47137,-76,114;47138,-78,111;47139,-79,110;47166,-78,111;47167,-76,113;47169,-76,112;47178,-81,108;47179,-78,111;47198,-78,112;47199,-82,107;47226,-78,112;47228,-78,114;47229,-78,113;47239,-80,111;47249,-79,112;47259,-83,108;47269,-84,108;47279,-83,108;47441,-81,109,Moers;47443,-79,110;47445,-80,109;47447,-82,108;47475,-82,107,Kamp-Lintfort;47495,-82,107,Rheinberg;47506,-82,108,Neukirchen-Vluyn;47509,-83,106,Rheurdt;47533,-81,106,Kleve;47546,-81,106,Kalkar;47551,-81,105,Bedburg-Hau;47559,-82,105,Kranenburg;47574,-81,107,Goch;47589,-82,105,Uedem;47608,-83,106,Geldern;47623,-82,107,Kevelaer;47624,-84,106;47625,-83,106,Kevelaer-Wetten;47626,-83,106,Kevelaer-Winnekendonk;47627,-83,106,Kevelaer-Kervenheim;47638,-82,106,Straelen;47647,-81,107,Kerken;47652,-83,106,Weeze;47661,-83,106,Issum;47665,-83,106,Sonsbeck;47669,-82,107,Wachtendonk;47798,-70,117,Krefeld;47799,-76,113;47800,-77,113;47802,-83,108;47803,-79,111;47804,-81,108;47805,-76,114;47807,-79,111;47809,-82,109;47829,-80,109;47839,-81,108;47877,-82,108,Willich;47906,-81,107,Kempen;47918,-81,108,Tönisvorst;47929,-81,108,Grefrath;48143,-79,113,Münster;48145,-87,107;48147,-85,106;48149,-88,107;48151,-86,108;48153,-88,106;48155,-88,106;48157,-92,102;48159,-92,101;48161,-92,101;48163,-93,102;48165,-93,102;48167,-93,102;48231,-97,102,Warendorf;48249,-89,102,Dülmen;48268,-91,102,Greven;48282,-88,104,Emsdetten;48291,-91,102,Telgte;48301,-92,100,Nottuln;48308,-93,102,Senden;48317,-95,102,Drensteinfurt;48324,-97,102,Sendenhorst;48329,-92,101,Havixbeck;48336,-99,102,Sassenberg;48341,-92,100,Altenberge;48346,-93,102,Ostbevern;48351,-95,101,Everswinkel;48356,-91,102,Nordwalde;48361,-100,102,Beelen;48366,-91,100,Laer;48369,-93,102,Saerbeck;48429,-83,105,Rheine;48431,-82,105;48432,-88,102;48455,-89,100,Bad Bentheim;48465,-91,101,Engden, Isterberg, Schüttorf u.a.;48477,-91,101,Hörstel;48480,-91,101,Lünne, Schapen, Spelle;48485,-89,102,Neuenkirchen;48488,-92,101,Emsbüren;48493,-91,101,Wettringen;48496,-92,101,Hopsten;48499,-90,101,Salzbergen;48527,-90,101,Nordhorn;48529,-90,101;48531,-90,101;48565,-91,100,Steinfurt;48599,-88,101,Gronau;48607,-91,101,Ochtrup;48612,-93,98,Horstmar;48619,-91,100,Heek;48624,-91,99,Schöppingen;48629,-91,100,Metelen;48653,-89,100,Coesfeld;48683,-90,100,Ahaus;48691,-88,101,Vreden;48703,-88,101,Stadtlohn;48712,-88,101,Gescher;48720,-91,99,Rosendahl;48727,-93,98,Billerbeck;48734,-87,101,Reken;48739,-90,100,Legden;49074,-85,110,Osnabrück;49076,-97,99;49078,-96,100;49080,-95,101;49082,-97,99;49084,-90,104;49086,-98,100;49088,-91,103;49090,-98,98;49124,-98,98,Georgsmarienhütte;49134,-96,99,Wallenhorst;49143,-98,99,Bissendorf;49152,-101,100,Bad Essen;49163,-96,99,Bohmte;49170,-97,98,Hagen am Teutoburger Wald;49176,-98,97,Hilter;49179,-96,99,Ostercappeln;49186,-98,99,Bad Iburg;49191,-98,97,Belm;49196,-98,100,Bad Laer;49201,-99,98,Dissen;49205,-98,99,Hasbergen;49214,-100,100,Bad Rothenfelde;49219,-95,101,Glandorf;49324,-98,100,Melle;49326,-99,98;49328,-101,99;49356,-97,98,Diepholz;49377,-97,97,Vechta;49393,-96,98,Lohne;49401,-97,97,Damme;49406,-98,98,Barnstorf, Eydelstedt, Drentwede;49413,-95,99,Dinklage;49419,-98,99,Wagenfeld;49424,-97,97,Goldenstedt;49429,-96,96,Visbek;49434,-97,97,Neuenkirchen-Vörden;49439,-97,98,Steinfeld;49448,-97,98,Lemförde u.a.;49451,-96,98,Holdorf;49453,-98,97,Barver, Dickel, Hemsloh, Rehden, Wetschen, Wehrblecker Heide;49456,-96,98,Bakum;49457,-98,98,Drebber;49459,-97,98,Lembruch;49477,-91,101,Ibbenbüren;49479,-91,101;49492,-96,99,Westerkappeln;49497,-93,100,Mettingen;49504,-96,100,Lotte;49509,-92,101,Recke;49525,-93,101,Lengerich;49536,-95,101,Lienen;49545,-97,97,Tecklenburg;49549,-93,102,Ladbergen;49565,-96,100,Bramsche;49577,-96,98,Kettenkamp, Eggermühlen, Ankum;49584,-92,100,Fürstenau;49586,-93,100,Merzen, Neuenkirchen;49593,-94,99,Bersenbrück;49594,-95,99,Alfhausen;49596,-95,99,Gehrde;49597,-95,99,Rieste;49599,-92,100,Voltlage;49610,-94,99,Quakenbrück;49624,-91,100,Löningen;49626,-93,99,Berge, Bippen;49632,-94,99,Essen (Oldenburg);49635,-95,99,Badbergen;49637,-93,100,Menslage;49638,-93,100,Nortrup;49661,-91,98,Cloppenburg;49681,-95,96,Garrel;49685,-97,96,Emstek;49688,-95,98,Lastrup;49692,-96,97,Cappeln (Oldenburg);49696,-96,97,Molbergen;49699,-93,98,Lindern (Oldenburg);49716,-88,101,Meppen;49733,-88,100,Haren;49740,-91,101,Haselünne;49744,-90,101,Geeste;49751,-93,98,Sögel u.a.;49757,-93,98,Werlte, Vrees, Lahn;49762,-91,99,Sustrum, Lathen u. a.;49767,-91,101,Twist;49770,-92,100,Herzlake, Dohren;49774,-92,100,Lähden;49777,-92,99,Stavern;49779,-90,99,Oberlangen, Niederlangen;49808,-89,101,Lingen;49809,-87,102;49811,-91,99;49824,-88,101,Ringe, Laar, Emlichheim;49828,-89,101,Esche, Georgsdorf, Lage, Neuenhaus, Osterwald;49832,-93,100,Andervenne, Beesten, Freren, Messingen, Thuine;49835,-90,101,Wietmarschen;49838,-91,100,Lengerich u.a.;49843,-90,100,Uelsen, Halle, Gölenkamp, Getelo;49844,-91,101,Bawinkel;49846,-90,101,Hoogstede;49847,-91,100,Itterbeck/Wielen;49849,-90,100,Wilsum;50126,-86,109,Bergheim;50127,-84,109;50129,-86,107;50169,-86,108,Kerpen;50170,-86,107;50171,-85,108;50181,-86,107,Bedburg;50189,-85,109,Elsdorf;50226,-87,108,Frechen;50259,-85,108,Pulheim;50321,-84,108,Brühl;50354,-85,108,Hürth;50374,-86,108,Erftstadt;50389,-80,111,Wesseling;50667,-70,120,Köln;50668,-72,119;50670,-77,114;50672,-70,121;50674,-77,115;50676,-70,121;50677,-77,114;50678,-70,121;50679,-77,114;50733,-77,114;50735,-80,111;50737,-77,113;50739,-78,113;50765,-85,108;50767,-81,110;50769,-83,109;50823,-76,115;50825,-77,113;50827,-78,112;50829,-81,111;50858,-82,110;50859,-85,109;50931,-78,115;50933,-78,113;50935,-80,113;50937,-79,113;50939,-78,113;50968,-79,113;50969,-80,112;50996,-80,112;50997,-86,108;50999,-81,111;51061,-81,110;51063,-81,112;51065,-79,113;51067,-82,110;51069,-83,109;51103,-80,112;51105,-79,113;51107,-87,108;51109,-82,109;51143,-87,108;51145,-82,110;51147,-83,109;51149,-84,109;51371,-83,109,Leverkusen;51373,-78,113;51375,-84,108;51377,-83,110;51379,-80,111;51381,-85,107;51399,-88,103,Burscheid;51427,-89,106,Bergisch Gladbach;51429,-93,101;51465,-88,105;51467,-86,105;51469,-82,111;51491,-93,102,Overath;51503,-88,105,Rösrath;51515,-93,101,Kürten;51519,-91,102,Odenthal;51545,-98,94,Waldbröl;51570,-91,104,Windeck;51580,-102,89,Reichshof;51588,-96,97,Nümbrecht;51597,-97,98,Morsbach;51598,-98,94,Friesenhagen;51643,-96,99,Gummersbach;51645,-96,98;51647,-100,91;51674,-95,100,Wiehl;51688,-99,92,Wipperfürth;51702,-100,91,Bergneustadt;51709,-101,89,Marienheide;51766,-93,102,Engelskirchen;51789,-93,99,Lindlar;52062,-71,115,Aachen;52064,-78,108;52066,-78,108;52068,-78,110;52070,-81,108;52072,-86,105;52074,-85,103;52076,-88,101;52078,-84,104;52080,-87,105;52134,-83,108,Herzogenrath;52146,-88,104,Würselen;52152,-107,82,Simmerath;52156,-108,82,Monschau;52159,-99,90,Roetgen;52222,-87,104,Stolberg (Rhld.);52223,-88,101;52224,-88,100,Stolberg;52249,-87,105,Eschweiler;52349,-80,110,Düren;52351,-83,109;52353,-86,107;52355,-87,106;52372,-85,106,Kreuzau;52379,-88,103,Langerwehe;52382,-88,107,Niederzier;52385,-91,99,Nideggen;52388,-87,107,Nörvenich;52391,-88,106,Vettweiß;52393,-95,93,Hürtgenwald;52396,-89,101,Heimbach;52399,-87,107,Merzenich;52428,-81,109,Jülich;52441,-86,109,Linnich;52445,-86,107,Titz;52457,-87,107,Aldenhoven;52459,-85,108,Inden;52477,-85,106,Alsdorf;52499,-87,107,Baesweiler;52511,-88,109,Geilenkirchen;52525,-86,109,Waldfeucht, Heinsberg;52531,-83,108,Übach-Palenberg;52538,-88,108,Gangelt, Selfkant;53111,-74,117,Bonn;53113,-83,110;53115,-79,113;53117,-82,111;53119,-81,110;53121,-83,109;53123,-81,110;53125,-89,103;53127,-87,105;53129,-81,112;53173,-80,113;53175,-83,111;53177,-91,103;53179,-84,108;53225,-81,111;53227,-81,111;53229,-86,107;53332,-88,107,Bornheim;53340,-90,103,Meckenheim;53343,-92,101,Wachtberg;53347,-89,103,Alfter;53359,-88,103,Rheinbach;53424,-90,104,Remagen;53426,-99,94,Schalkenbach, Königsfeld, Dedenbach;53474,-96,97,Bad Neuenahr-Ahrweiler;53489,-91,102,Sinzig;53498,-93,101,Bad Breisig, Waldorf, Gönnersdorf;53501,-92,101,Grafschaft;53505,-101,93,Altenahr, Berg, Kalenborn, Kirchsahr;53506,-98,97,Ahrbrück, Heckenbach, Hönningen, Kesseling, Rech;53507,-92,102,Dernau;53508,-92,101,Mayschoß;53518,-103,91,Adenau, Kottenborn u.a.;53520,-110,84,Reifferscheid, Kaltenborn, Wershofen u.a.;53533,-105,89,Antweiler, Aremberg, Dorsel, Eichenbach, Aremberg, Fuchshofen und Müsch;53534,-106,88,Barweiler, Bauler, Hoffeld, Pomster, Wiesemscheid, Wirft;53539,-110,84,Bodenbach, Kelberg, Kirsbach u.a.;53545,-89,105,Linz am Rhein, Ockenfels;53547,-94,100,Breitscheid, Dattenberg, Hausen, Hümmerich, Kasbach-Ohlenberg, Roßbach u;53557,-91,103,Bad Hönningen;53560,-98,94,Vettelschloß, Kretzhaus (Linz am Rhein);53562,-98,95,Sankt Katharinen (Landkreis Neuwied);53567,-93,99,Asbach, Buchholz;53572,-91,103,Bruchhausen, Unkel;53577,-93,101,Neustadt (Wied);53578,-94,98,Windhagen;53579,-93,101,Erpel;53604,-95,98,Bad Honnef;53619,-90,102,Rheinbreitbach;53639,-91,103,Königswinter;53721,-90,105,Siegburg;53757,-81,111,Sankt Augustin;53773,-92,102,Hennef (Sieg);53783,-90,106,Eitorf;53797,-90,106,Lohmar;53804,-94,101,Much;53809,-93,102,Ruppichteroth;53819,-92,103,Neunkirchen-Seelscheid;53840,-82,111,Troisdorf;53842,-91,106;53844,-84,109;53859,-89,108,Niederkassel;53879,-83,107,Euskirchen;53881,-87,104;53894,-93,98,Mechernich;53902,-112,82,Bad Münstereifel;53909,-87,105,Zülpich;53913,-88,105,Swisttal;53919,-86,106,Weilerswist;53925,-110,83,Kall;53937,-111,82,Schleiden;53940,-112,81,Hellenthal;53945,-105,89,Blankenheim;53947,-113,81,Nettersheim;53949,-116,79,Dahlem;54290,-88,107,Trier;54292,-90,106;54293,-94,98;54294,-92,103;54295,-93,102;54296,-95,101;54298,-98,95,Welschbillig, Igel, Aach;54306,-95,99,Kordel;54308,-94,101,Langsur;54309,-98,94,Newel;54310,-94,101,Ralingen;54311,-94,98,Trierweiler;54313,-97,95,Zemmer;54314,-98,95,Zerf;54316,-93,101,Pluwig;54317,-104,90,Osburg, Gusterath, Farschweiler, Kasel u.a.;54318,-93,102,Mertesdorf;54320,-94,99,Waldrach;54329,-93,98,Konz;54331,-93,98,Pellingen;54332,-96,97,Wasserliesch;54338,-92,103,Schweich;54340,-95,100,Leiwen u.a.;54341,-93,102,Fell;54343,-95,101,Föhren;54344,-91,103,Kenn;54346,-93,102,Mehring;54347,-95,99,Neumagen-Dhron;54349,-96,97,Trittenheim;54411,-113,85,Deuselbach, Hermeskeil, Rorodt;54413,-114,83,Gusenburg;54421,-111,86,Reinsfeld;54422,-118,81,Neuhütten;54424,-106,90,Thalfang;54426,-107,89,Malborn;54427,-110,87,Kell am See;54429,-108,88,Schillingen;54439,-98,94,Saarburg;54441,-91,103,Ayl, Trassem u.a.;54450,-98,95,Freudenburg;54451,-101,93,Irsch;54453,-95,97,Nittel;54455,-90,103,Serrig;54456,-93,99,Tawern;54457,-92,100,Wincheringen;54459,-95,98,Wiltingen;54470,-92,104,Bernkastel-Kues u. a.;54472,-106,89,Monzelfeld, Hochscheid u.a.;54483,-108,87,Kleinich;54484,-93,102,Maring-Noviand;54486,-93,102,Mülheim (Mosel);54487,-101,93,Wintrich;54492,-93,103,Zeltingen-Rachtig, Erden, Lösnich u.a.;54497,-104,92,Morbach;54498,-92,104,Piesport;54516,-93,102,Wittlich;54518,-96,98,Binsfeld, Heckenmünster;54523,-93,101,Hetzerath, Dierscheid, Heckenmünster;54524,-94,101,Klausen;54526,-100,95,Landscheid;54528,-93,102,Salmtal;54529,-100,94,Spangdahlem;54531,-106,89,Manderscheid;54533,-101,95,Bettenfeld, Niederöfflingen u.a.;54534,-99,96,Großlittgen;54536,-102,93,Kröv;54538,-111,85,Bausendorf;54539,-93,101,Ürzig;54550,-112,83,Daun;54552,-113,81,Mehren u.a.;54558,-108,88,Gillenfeld;54568,-105,90,Gerolstein;54570,-124,73,Pelm, Neroth u.a.;54574,-107,88,Birresborn;54576,-107,86,Hillesheim;54578,-110,83,Walsdorf, Nohn u. a.;54579,-105,89,Üxheim;54584,-107,86,Jünkerath;54585,-116,79,Esch;54586,-116,79,Schüller;54587,-106,87,Lissendorf;54589,-120,77,Stadtkyll;54595,-115,81,Prüm;54597,-115,80,Pronsfeld;54608,-108,85,Bleialf;54610,-113,82,Büdesheim;54611,-117,78,Hallschlag;54612,-108,87,Lasel;54614,-105,89,Schönecken;54616,-108,83,Winterspelt;54617,-107,83,Lützkampen;54619,-108,83,Üttfeld;54634,-97,97,Bitburg;54636,-97,96,Rittersdorf u.a.;54646,-96,97,Bettingen;54647,-98,98,Dudeldorf;54649,-103,90,Waxweiler;54655,-107,88,Kyllburg;54657,-98,96,Badem, Gindorf, Neidenbach;54662,-98,96,Speicher;54664,-96,96,Preist;54666,-92,103,Irrel;54668,-92,102,Ferschweiler;54669,-91,103,Bollendorf;54673,-107,86,Neuerburg u.a.;54675,-96,97,Körperich u.a.;54687,-108,86,Arzfeld;54689,-105,86,Daleiden, Preischeid u.a.;55116,-86,117,Mainz;55118,-89,114;55120,-95,110;55122,-91,111;55124,-95,108;55126,-98,104;55127,-101,102;55128,-96,108;55129,-100,105,Mainz Ebersheim, Hechtsheim;55130,-95,109,Mainz;55131,-90,113;55218,-95,108,Ingelheim am Rhein;55232,-100,104,Alzey;55234,-101,103,Albig;55237,-102,106,Flonheim;55239,-101,106,Gau-Odernheim;55246,-96,108,Wiesbaden;55252,-96,109,Mainz-Kastel;55257,-98,107,Budenheim;55262,-98,108,Heidesheim am Rhein;55263,-102,101,Wackernheim;55268,-98,107,Nieder-Olm;55270,-103,101,Ober-Olm;55271,-100,107,Stadecken-Elsheim;55276,-101,109,Oppenheim;55278,-101,106,Mommenheim;55283,-100,107,Nierstein;55286,-103,102,Wörrstadt;55288,-104,100,Armsheim;55291,-100,106,Saulheim;55294,-98,108,Bodenheim;55296,-100,106,Harxheim;55299,-100,107,Nackenheim;55411,-97,107,Bingen am Rhein;55413,-121,78,Weiler bei Bingen;55422,-105,91,Bacharach, Breitscheid;55424,-95,104,Münster-Sarmsheim;55425,-105,91,Waldalgesheim;55430,-101,96,Oberwesel;55432,-111,85,Niederburg;55435,-99,107,Gau-Algesheim;55437,-101,103,Ockenheim;55442,-105,93,Stromberg;55444,-106,91,Seibersbach;55450,-99,105,Langenlonsheim;55452,-101,99,Guldental;55457,-100,107,Gensingen;55459,-100,106,Aspisheim, Grolsheim;55469,-104,92,Simmern/Hunsrück u.a.;55471,-104,93,Tiefenbach u.a.;55481,-107,90,Kirchberg u.a.;55483,-107,89,Dickenschied u.a.;55487,-107,89,Sohren;55490,-105,93,Gemünden;55491,-108,87,Büchenbeuren;55494,-109,87,Rheinböllen;55496,-116,82,Argenthal;55497,-108,88,Ellern (Hunsrück), Schnorbach;55499,-110,87,Riesweiler;55543,-102,101,Bad Kreuznach;55545,-93,110;55546,-102,103,Hackenheim;55559,-99,106,Bretzenheim;55566,-106,92,Sobernheim;55568,-101,97,Staudernheim;55569,-103,95,Monzingen;55571,-98,99,Odernheim am Glan;55576,-100,106,Sprendlingen;55578,-101,104,Wallertheim;55583,-101,103,Bad Kreuznach;55585,-99,99,Norheim u.a.;55590,-97,102,Meisenheim;55592,-101,97,Rehborn;55593,-101,104,Rüdesheim;55595,-108,90,Hargesheim;55596,-98,100,Waldböckelheim;55597,-101,105,Wöllstein;55599,-100,105,Gau-Bickelheim;55606,-106,93,Kirn;55608,-111,87,Bergen;55618,-107,92,Simmertal;55619,-108,88,Hennweiler;55621,-108,92,Hundsbach;55624,-105,92,Rhaunen;55626,-107,89,Bundenbach;55627,-102,96,Merxheim;55629,-108,88,Seesbach;55743,-108,90,Idar-Oberstein;55756,-108,89,Herrstein;55758,-112,85,Niederwörresbach;55765,-107,89,Birkenfeld u.a.;55767,-112,85,Brücken, Oberbrombach u.a.;55768,-105,93,Hoppstädten-Weiersbach;55774,-108,89,Baumholder;55776,-108,90,Berglangenbach, Ruschberg u.a.;55777,-112,86,Berschweiler bei Baumholder;55779,-108,90,Heimbach;56068,-81,114,Koblenz;56070,-82,112;56072,-91,103;56073,-85,108;56075,-101,94;56076,-93,100;56077,-93,101;56112,-91,105,Lahnstein (ohne Exklave);56130,-90,104,Bad Ems;56132,-91,105,Dausenau, Nievern;56133,-96,99,Fachbach, Exklave Lahnstein;56154,-104,90,Boppard;56170,-93,101,Bendorf;56179,-92,103,Vallendar;56182,-88,107,Urbar (bei Koblenz);56191,-90,104,Weitersburg;56203,-95,101,Höhr-Grenzhausen;56204,-102,91,Hillscheid;56206,-98,97,Hilgert;56218,-90,107,Mülheim-Kärlich;56220,-90,104,Urmitz;56235,-97,98,Ransbach-Baumbach;56237,-99,96,Nauort;56242,-95,99,Selters (Westerwald);56244,-100,95,Freilingen, Freirachdorf u.a.;56249,-102,92,Herschbach;56253,-97,98,Treis-Karden;56254,-95,99,Müden;56269,-93,100,Dierdorf;56271,-95,97,Kleinmaischeid;56276,-96,98,Großmaischeid;56281,-108,87,Emmelshausen;56283,-101,95,Wildenbungert, Gondershausen, Nörtershausen u.a.;56288,-112,85,Kastellaun;56290,-101,94,Beltheim;56291,-113,83,Leiningen;56294,-97,98,Münstermaifeld;56295,-96,99,Lonnig;56299,-96,101,Ochtendung;56305,-94,100,Puderbach;56307,-101,93,Dürrholz;56316,-94,100,Raubach;56317,-100,94,Urbach;56321,-93,101,Rhens;56322,-92,102,Spay;56323,-101,93,Waldesch, Hünenfeld;56329,-100,97,Sankt Goar;56330,-92,102,Kobern-Gondorf;56332,-94,101,Lehmen, Niederfell, Oberfell, Wolken u. a.;56333,-92,102,Winningen;56335,-97,98,Neuhäusel;56337,-97,98,Eitelborn;56338,-101,92,Braubach;56340,-102,92,Osterspai;56341,-98,98,Kamp-Bornhofen-Filsen;56346,-100,96,Sankt Goarshausen;56348,-100,97,Bornich, Patersberg;56349,-103,91,Kaub;56355,-98,97,Nastätten u.a.;56357,-102,93,Miehlen u.a.;56368,-100,97,Katzenelnbogen;56370,-100,97,Schönborn;56377,-93,103,Nassau;56379,-93,103,Singhofen;56410,-98,97,Montabaur;56412,-98,98,Nentershausen, Hübingen, Niederelbert u.a.;56414,-103,94,Meudt, Molsberg, Hundsangen, Niederahr u.a.;56422,-98,97,Wirges, Stadt;56424,-98,98,Mogendorf, Ebernhahn, Staudt u.a.;56427,-98,97,Siershahn;56428,-101,93,Dernbach (Westerwald);56457,-105,88,Westerburg;56459,-108,84,Bellingen, Kölbingen, Gemünden etc;56462,-110,81,Höhn;56470,-109,82,Bad Marienberg (Westerwald);56472,-110,81,Nisterau u.a.;56477,-110,81,Rennerod, Zehnhausen, Nister-Möhrendorf, Waigandshain;56479,-110,81,Oberrod u.a.;56564,-81,114,Neuwied;56566,-92,107;56567,-90,105;56575,-84,110,Weißenthurm;56579,-97,98,Rengsdorf;56581,-100,95,Melsbach;56584,-101,94,Anhausen;56587,-100,94,Straßenhaus;56588,-92,104,Waldbreitbach, Hasuen;56589,-91,105,Niederbreitbach;56593,-95,97,Horhausen (Westerwald);56594,-102,91,Willroth;56598,-97,97,Rheinbrohl;56599,-95,101,Leutesdorf;56626,-93,103,Andernach;56630,-92,105,Kretz;56637,-91,106,Plaidt;56642,-94,103,Kruft;56645,-95,101,Nickenich;56648,-91,104,Saffig;56651,-99,94,Niederzissen;56653,-98,96,Wehr;56656,-93,101,Brohl-Lützing;56659,-93,101,Burgbrohl;56727,-106,88,Mayen;56729,-110,84,Ettringen;56736,-96,101,Kottenheim;56743,-95,100,Mendig;56745,-106,89,Bell;56746,-113,81,Kempenich;56751,-95,100,Polch;56753,-95,100,Mertloch, Welling u. a.;56754,-96,98,Binningen;56759,-115,80,Kaisersesch;56761,-111,85,Düngenheim;56766,-111,85,Ulmen;56767,-109,86,Uersfeld;56769,-115,80,Retterath;56812,-93,104,Cochem;56814,-93,104,Ediger-Eller;56818,-103,93,Klotten;56820,-93,100,Senheim;56821,-93,104,Ellenz-Poltersdorf;56823,-111,85,Büchel;56825,-108,87,Gevenich;56826,-107,88,Lutzerath;56828,-110,86,Alflen;56829,-98,97,Pommern;56841,-92,104,Traben-Trarbach;56843,-104,91,Irmenach;56850,-102,92,Enkirch u.a.;56856,-97,98,Zell (Mosel);56858,-105,90,Peterswald-Löffelscheid u.a.;56859,-96,99,Bullay, Alf, Zell;56861,-101,94,Reil;56862,-94,104,Pünderich;56864,-103,91,Bad Bertrich;56865,-108,88,Blankenrath u.a.;56867,-105,91,Briedel;56869,-108,87,Mastershausen;57072,-102,91,Siegen;57074,-99,94;57076,-93,100;57078,-101,92;57080,-96,97;57223,-105,89,Kreuztal;57234,-107,86,Wilnsdorf;57250,-110,85,Netphen;57258,-101,92,Freudenberg;57271,-109,85,Hilchenbach;57290,-98,96,Neunkirchen;57299,-111,80,Burbach;57319,-123,74,Bad Berleburg;57334,-117,80,Bad Laasphe;57339,-118,78,Erndtebrück;57368,-113,78,Lennestadt;57392,-111,83,Schmallenberg;57399,-104,88,Kirchhundem;57413,-106,86,Finnentrop;57439,-98,94,Attendorn;57462,-102,90,Olpe;57482,-105,87,Wenden;57489,-105,86,Drolshagen;57518,-99,93,Betzdorf;57520,-108,84,Emmerzhausen, Niederdreisbach, Steinebach;57537,-93,101,Wissen, Hövels u. a.;57539,-93,100,Fürthen;57548,-98,94,Kirchen (Sieg);57555,-94,99,Mudersbach;57562,-97,96,Herdorf;57567,-100,93,Daaden;57572,-100,94,Niederfischbach;57577,-92,102,Hamm (Sieg);57578,-106,84,Elkenroth;57580,-101,90,Gebhardshain;57581,-97,98,Katzwinkel (Sieg);57583,-103,88,Nauroth;57584,-93,101,Scheuerfeld;57586,-109,83,Weitefeld;57587,-98,95,Birken-Honigsessen;57589,-93,100,Pracht;57610,-96,99,Altenkirchen (Westerwald);57612,-95,99,Birnbach;57614,-99,94,Steimel;57627,-101,93,Hachenburg;57629,-101,93,Malberg, Norken, Höchstenbach u.a.;57632,-96,98,Flammersfeld;57635,-94,98,Weyerbusch;57636,-96,98,Mammelzen;57638,-93,101,Neitersen;57639,-99,94,Oberdreis;57641,-92,103,Oberlahr;57642,-103,87,Alpenrod;57644,-99,94,Hattert;57645,-101,90,Nister;57647,-101,92,Nistertal, Enspel;57648,-103,87,Unnau;58089,-85,105,Hagen;58091,-92,98;58093,-88,103;58095,-82,108;58097,-83,106;58099,-87,104;58119,-90,101;58135,-97,93;58239,-92,102,Schwerte;58256,-100,90,Ennepetal;58285,-90,99,Gevelsberg;58300,-87,103,Wetter (Ruhr);58313,-91,99,Herdecke;58332,-88,102,Schwelm;58339,-103,87,Breckerfeld;58452,-84,105,Witten;58453,-88,102;58454,-85,105;58455,-83,106;58456,-88,101;58507,-97,90,Lüdenscheid;58509,-99,88;58511,-98,89;58513,-104,86;58515,-102,88;58540,-108,83,Meinerzhagen;58553,-103,86,Halver;58566,-105,86,Kierspe;58579,-103,88,Schalksmühle;58636,-95,97,Iserlohn;58638,-95,95;58640,-93,100;58642,-91,100;58644,-101,90;58675,-100,91,Hemer;58706,-93,102,Menden;58708,-93,101;58710,-95,99;58730,-98,97,Fröndenberg/Ruhr;58739,-96,101,Wickede (Ruhr);58762,-93,97,Altena;58769,-108,83,Nachrodt-Wiblingwerde;58791,-96,95,Werdohl;58802,-97,94,Balve;58809,-104,87,Neuenrade;58840,-102,89,Plettenberg;58849,-106,84,Herscheid;59063,-90,108,Hamm;59065,-90,108;59067,-91,107;59069,-96,102;59071,-97,102;59073,-96,102;59075,-95,102;59077,-96,103;59174,-91,106,Kamen;59192,-93,104,Bergkamen;59199,-96,103,Bönen;59227,-97,102,Ahlen;59229,-97,102;59269,-98,101,Beckum;59302,-101,100,Oelde;59320,-100,100,Ennigerloh;59329,-100,101,Wadersloh;59348,-90,103,Lüdinghausen;59368,-91,104,Werne;59379,-91,103,Selm;59387,-96,102,Ascheberg;59394,-94,103,Nordkirchen;59399,-90,103,Olfen;59423,-94,102,Unna;59425,-91,107;59427,-96,101;59439,-93,100,Holzwickede;59457,-95,103,Werl;59469,-97,98,Ense;59494,-94,103,Soest;59505,-99,101,Bad Sassendorf;59510,-99,102,Lippetal;59514,-97,102,Welver;59519,-100,97,Möhnesee;59555,-93,106,Lippstadt;59556,-99,102;59557,-95,103;59558,-98,102;59581,-108,85,Warstein;59590,-101,100,Geseke;59597,-99,101,Erwitte;59602,-110,87,Rüthen;59609,-103,95,Anröchte;59755,-96,99,Arnsberg;59757,-100,94;59759,-97,99;59821,-96,98;59823,-106,86;59846,-103,89,Sundern;59872,-105,87,Meschede;59889,-103,89,Eslohe;59909,-105,88,Bestwig;59929,-113,84,Brilon;59939,-115,80,Olsberg;59955,-132,68,Winterberg;59964,-118,81,Medebach;59969,-121,77,Bromskirchen, Hallenberg;60306,-82,119,Frankfurt am Main, Opernturm;60308,-90,114,Frankfurt;60310,-84,117,Frankfurt am Main (Taunusturm);60311,-92,112,Frankfurt am Main;60313,-83,118;60314,-93,112;60316,-92,113;60318,-83,117;60320,-92,112;60322,-91,113;60323,-97,110;60325,-91,113;60326,-92,111;60327,-91,113;60329,-83,118;60385,-93,111;60386,-96,111;60388,-101,105;60389,-98,107;60431,-96,110;60433,-97,108;60435,-100,106;60437,-100,106;60438,-100,105;60439,-96,108;60486,-92,112;60487,-91,113;60488,-95,110;60489,-93,111;60528,-98,108;60529,-98,108;60549,-95,110;60594,-92,112;60596,-92,113;60598,-100,107;60599,-100,106;61118,-100,107,Bad Vilbel;61130,-103,103,Nidderau;61137,-102,105,Schöneck;61138,-103,105,Niederdorfelden;61169,-102,103,Friedberg (Hessen);61184,-101,106,Karben;61191,-104,100,Rosbach v.d. Höhe;61194,-103,104,Niddatal;61197,-104,103,Florstadt;61200,-106,101,Wölfersheim;61203,-105,103,Reichelsheim (Wetterau);61206,-103,104,Wöllstadt;61209,-105,102,Echzell;61231,-106,102,Bad Nauheim;61239,-107,95,Ober-Mörlen;61250,-111,91,Usingen;61267,-110,92,Neu-Anspach;61273,-110,93,Wehrheim;61276,-111,87,Weilrod;61279,-110,90,Grävenwiesbach;61348,-98,104,Bad Homburg v.d.;61350,-107,96;61352,-99,105;61381,-107,95,Friedrichsdorf;61389,-112,86,Schmitten;61440,-104,98,Oberursel (Taunus);61449,-101,103,Steinbach (Taunus);61462,-109,90,Königstein im Taunus;61476,-105,98,Kronberg im Taunus;61479,-113,86,Glashütten;63065,-96,111,Offenbach am Main;63067,-95,112;63069,-103,106;63071,-100,107;63073,-103,106;63075,-100,108;63110,-102,107,Rodgau;63128,-101,106,Dietzenbach;63150,-103,106,Heusenstamm;63165,-103,107,Mühlheim am Main;63179,-103,107,Obertshausen;63225,-98,108,Langen;63263,-98,108,Neu-Isenburg;63303,-101,105,Dreieich;63322,-103,106,Rödermark;63329,-98,108,Egelsbach;63450,-94,113,Hanau;63452,-99,109;63454,-101,107;63456,-102,108;63457,-103,107;63477,-103,106,Maintal;63486,-103,106,Bruchköbel;63500,-102,107,Seligenstadt;63505,-104,105,Langenselbold;63512,-102,107,Hainburg;63517,-105,105,Rodenbach;63526,-100,107,Erlensee;63533,-104,106,Mainhausen;63538,-99,109,Großkrotzenburg;63543,-105,102,Neuberg;63546,-104,104,Hammersbach;63549,-105,102,Ronneburg;63571,-108,100,Gelnhausen;63579,-107,101,Freigericht;63584,-109,98,Gründau;63589,-108,100,Linsengericht;63594,-104,104,Hasselroth;63599,-119,85,Biebergemünd;63607,-114,92,Wächtersbach;63619,-113,96,Bad Orb;63628,-115,92,Bad Soden-Salmünster;63633,-115,87,Birstein;63636,-107,100,Brachttal;63637,-120,85,Jossgrund;63639,-121,85,Flörsbachtal;63654,-105,104,Büdingen;63667,-105,101,Nidda;63674,-103,104,Altenstadt;63679,-116,83,Schotten;63683,-110,93,Ortenberg;63688,-115,86,Gedern;63691,-105,102,Ranstadt;63694,-106,101,Limeshain;63695,-105,103,Glauburg;63697,-113,90,Hirzenhain;63699,-113,92,Kefenrod;63739,-101,107,Aschaffenburg;63741,-98,110;63743,-107,102;63755,-105,104,Alzenau;63762,-103,106,Großostheim;63768,-110,101,Hösbach;63773,-106,102,Goldbach;63776,-111,97,Mömbris;63785,-105,106,Obernburg a.Main;63791,-103,107,Karlstein am Main;63796,-103,107,Kahl am Main;63801,-104,107,Kleinostheim;63808,-110,95,Haibach;63811,-103,106,Stockstadt am Main;63814,-103,107,Mainaschaff;63820,-108,103,Elsenfeld;63825,-115,93,Schöllkrippen, Blankenbach;63826,-112,95,Geiselbach;63828,-113,97,Kleinkahl;63829,-113,95,Krombach;63831,-120,86,Wiesen, Wiesener Forst;63834,-107,103,Sulzbach am Main;63839,-106,104,Kleinwallstadt;63840,-109,100,Hausen;63843,-105,106,Niedernberg;63846,-113,96,Laufach;63849,-113,96,Leidersbach;63853,-105,104,Mömlingen;63856,-111,99,Bessenbach;63857,-117,90,Waldaschaff, Waldaschaffer Forst;63860,-119,88,Rothenbuch, Rothenbucher Forst;63863,-113,94,Eschau;63864,-109,100,Glattbach;63867,-114,91,Johannesberg;63868,-106,105,Großwallstadt;63869,-117,89,Heigenbrücken;63871,-118,87,Heinrichsthal;63872,-113,95,Heimbuchenthal;63874,-116,93,Dammbach;63875,-119,89,Mespelbrunn;63877,-114,93,Sailauf;63879,-118,90,Weibersbrunn, Rohrbrunner Forst;63897,-115,93,Miltenberg;63906,-106,103,Erlenbach a.Main;63911,-107,105,Klingenberg a. Main;63916,-111,97,Amorbach;63920,-104,105,Großheubach;63924,-117,93,Kleinheubach, Rüdenau;63925,-110,99,Laudenbach;63927,-117,91,Bürgstadt;63928,-111,98,Eichenbühl;63930,-115,93,Neunkirchen;63931,-111,98,Kirchzell;63933,-111,99,Mönchberg;63934,-111,98,Röllbach;63936,-118,89,Schneeberg;63937,-108,102,Weilbach;63939,-110,98,Wörth a.Main;64283,-89,114,Darmstadt;64285,-98,108;64287,-102,106;64289,-100,107;64291,-100,106;64293,-95,111;64295,-100,108;64297,-101,107;64319,-101,109,Pfungstadt;64331,-98,109,Weiterstadt;64342,-103,104,Seeheim-Jugenheim;64347,-99,110,Griesheim;64354,-104,105,Reinheim;64367,-105,101,Mühltal;64372,-106,102,Ober-Ramstadt;64380,-103,105,Roßdorf;64385,-108,96,Reichelsheim (Odenwald);64390,-98,108,Erzhausen;64395,-106,100,Brensbach;64397,-110,94,Modautal;64401,-106,102,Groß-Bieberau;64404,-104,109,Bickenbach;64405,-107,100,Fischbachtal;64407,-105,101,Fränkisch-Crumbach;64409,-102,105,Messel;64521,-97,109,Groß-Gerau;64546,-97,109,Mörfelden-Walldorf;64560,-100,110,Riedstadt;64569,-97,109,Nauheim;64572,-97,109,Büttelborn;64579,-103,109,Gernsheim;64584,-102,110,Biebesheim am Rhein;64589,-101,109,Stockstadt am Rhein;64625,-103,104,Bensheim;64646,-104,101,Heppenheim (Bergstraße);64653,-106,110,Lorsch;64658,-103,104,Fürth;64665,-105,109,Alsbach-Hähnlein;64668,-101,105,Rimbach;64673,-105,109,Zwingenberg;64678,-118,87,Lindenfels;64683,-107,109,Einhausen;64686,-106,98,Lautertal (Odenwald);64689,-118,87,Grasellenbach;64711,-108,99,Erbach;64720,-116,92,Michelstadt;64732,-109,100,Bad König;64739,-108,97,Höchst i. Odw.;64743,-117,89,Beerfelden;64747,-107,101,Breuberg;64750,-109,96,Lützelbach;64753,-110,95,Brombachtal;64754,-113,96,Hesseneck;64756,-113,92,Mossautal;64757,-111,94,Rothenberg;64759,-116,90,Sensbachtal;64807,-103,106,Dieburg;64823,-105,102,Groß-Umstadt;64832,-101,108,Babenhausen;64839,-103,106,Münster;64846,-103,106,Groß-Zimmern;64850,-110,99,Schaafheim;64853,-106,100,Otzberg;64859,-103,105,Eppertshausen;65183,-88,115,Wiesbaden;65185,-84,117;65187,-93,109;65189,-90,111;65191,-95,105;65193,-104,98;65195,-105,96;65197,-95,106;65199,-105,97;65201,-99,103;65203,-91,111;65205,-98,106;65207,-104,98;65232,-108,90,Taunusstein;65239,-98,107,Hochheim am Main;65307,-109,88,Bad Schwalbach;65321,-109,87,Heidenrod;65326,-101,98,Aarbergen;65329,-105,95,Hohenstein;65343,-100,104,Eltville am Rhein;65344,-105,96;65345,-103,97;65346,-100,104;65347,-103,95;65366,-103,94,Geisenheim;65375,-115,82,Oestrich-Winkel;65385,-108,88,Rüdesheim am Rhein;65388,-111,87,Schlangenbad;65391,-106,90,Lorch;65396,-98,107,Walluf;65399,-103,96,Kiedrich;65428,-93,110,Rüsselsheim;65439,-98,107,Flörsheim am Main;65451,-95,110,Kelsterbach;65462,-97,109,Ginsheim-Gustavsburg;65468,-99,109,Trebur;65474,-97,109,Bischofsheim;65479,-98,109,Raunheim;65510,-106,93,Hünstetten, Idstein;65520,-106,93,Bad Camberg;65527,-107,93,Niedernhausen;65529,-108,89,Waldems;65549,-93,106,Limburg;65550,-99,100;65551,-100,100;65552,-99,100;65553,-100,100;65554,-101,99;65555,-100,99;65556,-97,101;65558,-101,97,Burgschwalbach;65582,-96,101,Diez, Hambach, Aull;65589,-101,99,Hadamar;65594,-101,100,Runkel;65597,-101,97,Hünfelden;65599,-102,96,Dornburg;65604,-99,100,Elz;65606,-103,98,Villmar;65611,-100,101,Brechen;65614,-105,95,Beselich;65618,-105,96,Selters;65620,-107,91,Waldbrunn;65623,-98,99,Hahnstätten u.a.;65624,-98,99,Altendiez;65626,-96,101,Birlenbach;65627,-103,96,Elbtal;65629,-98,101,Niederneisen;65719,-105,97,Hofheim am Taunus;65760,-100,105,Eschborn;65779,-103,100,Kelkheim;65795,-98,108,Hattersheim;65812,-102,101,Bad Soden am Taunus;65817,-107,95,Eppstein;65824,-95,107,Schwalbach am Taunus;65830,-95,109,Kriftel;65835,-98,106,Liederbach am Taunus;65843,-96,108,Sulzbach (Taunus);65929,-93,111,Frankfurt am Main;65931,-97,109;65933,-93,111;65934,-95,110;65936,-95,109;66111,-85,112,Saarbrücken;66113,-92,104;66115,-101,97;66117,-92,104;66119,-98,100;66121,-90,106;66123,-93,104;66125,-95,102;66126,-97,101;66127,-96,101;66128,-94,103;66129,-102,97;66130,-96,102;66131,-101,98;66132,-102,97;66133,-95,102;66265,-97,101,Heusweiler;66271,-101,98,Kleinblittersdorf;66280,-95,102,Sulzbach/Saar;66287,-102,96,Quierschied;66292,-95,102,Riegelsberg;66299,-101,97,Friedrichsthal;66333,-91,105,Völklingen;66346,-94,102,Püttlingen;66352,-95,102,Großrosseln;66359,-95,102,Bous;66386,-96,101,Sankt Ingbert;66399,-103,95,Mandelbachtal;66424,-93,103,Homburg;66440,-95,103,Blieskastel;66450,-100,98,Bexbach;66453,-101,99,Gersheim;66459,-98,99,Kirkel;66482,-92,106,Zweibrücken;66484,-100,98,Battweiler u.a.;66497,-100,99,Contwig;66500,-97,102,Hornbach;66501,-102,97,Kleinbundenbach;66503,-98,101,Dellfeld;66504,-102,97,Bottenbach;66506,-102,96,Maßweiler;66507,-100,99,Reifenberg;66509,-99,100,Rieschweiler-Mühlbach;66538,-96,103,Neunkirchen;66539,-98,100;66540,-100,99;66557,-98,99,Illingen;66564,-101,96,Ottweiler;66571,-98,98,Eppelborn;66578,-98,99,Schiffweiler;66583,-100,98,Spiesen-Elversberg;66589,-101,96,Merchweiler;66606,-96,100,Sankt Wendel;66620,-103,93,Nonnweiler;66625,-108,90,Nohfelden;66629,-106,92,Freisen;66636,-98,97,Tholey;66640,-100,97,Namborn;66646,-103,94,Marpingen;66649,-112,86,Oberthal;66663,-90,104,Merzig;66679,-96,99,Losheim;66687,-97,99,Wadern;66693,-95,99,Mettlach;66701,-97,99,Beckingen;66706,-97,97,Perl;66709,-98,97,Weiskirchen;66740,-88,108,Saarlouis;66763,-91,104,Dillingen/Saar;66773,-94,103,Schwalbach;66780,-99,97,Rehlingen-Siersburg;66787,-96,102,Wadgassen;66793,-95,101,Saarwellingen;66798,-101,96,Wallerfangen;66802,-97,100,Überherrn;66806,-91,105,Ensdorf;66809,-94,101,Nalbach;66822,-95,101,Lebach;66839,-96,99,Schmelz;66849,-103,96,Landstuhl;66851,-109,91,Mittelbrunn, Queidersbach u.a.;66862,-98,101,Kindsbach;66869,-101,96,Kusel;66871,-102,96,Pfeffelbach;66877,-98,101,Ramstein-Miesenbach;66879,-101,97,Steinwenden u.a.;66882,-97,100,Hütschenhausen;66885,-97,100,Altenglan;66887,-105,93,Rammelsbach u.a.;66892,-95,102,Bruchmühlbach-Miesau;66894,-102,96,Bechhofen;66901,-98,100,Schönenberg-Kübelberg;66903,-103,95,Altenkirchen;66904,-100,98,Brücken (Pfalz);66907,-98,99,Glan-Münchweiler;66909,-102,96,Herschweiler-Pettersheim;66914,-97,100,Waldmohr;66916,-103,94,Breitenbach;66917,-101,97,Wallhalben u.a.;66919,-104,95,Obernheim-Kirchenarnbach u. a.;66953,-102,97,Pirmasens;66954,-103,96;66955,-101,98;66957,-106,94,Vinningen, Trulben, Ruppertsweiler u.a.;66969,-104,97,Lemberg;66976,-101,99,Rodalben;66978,-106,94,Clausen;66981,-100,100,Münchweiler an der Rodalb;66987,-98,101,Thaleischweiler-Fröschen;66989,-102,97,Höheinöd, Petersberg u.a.;66994,-98,102,Dahn;66996,-99,102,Fischbach, Erfweiler u.a.;66999,-105,96,Hinterweidenthal;67059,-100,115,Ludwigshafen am Rhein;67061,-101,116;67063,-101,115;67065,-104,112;67067,-104,110;67069,-102,113;67071,-105,110;67098,-100,103,Bad Dürkheim;67105,-102,111,Schifferstadt;67112,-103,111,Mutterstadt;67117,-103,111,Limburgerhof;67122,-107,111,Altrip;67125,-103,110,Dannstadt-Schauernheim;67126,-103,110,Hochdorf-Assenheim;67127,-103,110,Rödersheim-Gronau;67133,-104,111,Maxdorf;67134,-103,110,Birkenheide;67136,-103,110,Fußgönheim;67141,-106,110,Neuhofen;67146,-98,107,Deidesheim;67147,-99,107,Forst an der Weinstraße;67149,-100,109,Meckenheim;67150,-101,109,Niederkirchen bei Deidesheim;67152,-98,108,Ruppertsberg;67157,-100,101,Wachenheim an der Weinstraße;67158,-103,109,Ellerstadt;67159,-101,108,Friedelsheim;67161,-103,109,Gönnheim;67165,-107,110,Waldsee;67166,-106,111,Otterstadt;67167,-103,109,Erpolzheim;67169,-99,107,Kallstadt;67227,-103,112,Frankenthal (Pfalz);67229,-103,109,Gerolsheim;67240,-106,110,Bobenheim-Roxheim;67245,-103,109,Lambsheim;67246,-103,109,Dirmstein;67251,-99,108,Freinsheim;67256,-99,108,Weisenheim am Sand;67258,-103,109,Heßheim;67259,-105,109,Beindersheim;67269,-101,105,Grünstadt;67271,-103,100,Kindenheim;67273,-104,96,Weisenheim am Berg;67278,-101,107,Bockenheim an der Weinstraße;67280,-102,104,Ebertsheim;67281,-98,107,Kirchheim an der Weinstraße;67283,-99,108,Obrigheim (Pfalz);67292,-107,94,Kirchheimbolanden;67294,-105,97,Bischheim u.a.;67295,-105,97,Bolanden;67297,-101,102,Marnheim;67304,-103,96,Eisenberg (Pfalz);67305,-102,98,Ramsen;67307,-102,100,Göllheim;67308,-101,100,Albisheim (Pfrimm);67310,-101,103,Hettenleidelheim;67311,-102,103,Tiefenthal;67316,-102,99,Carlsberg;67317,-102,99,Altleiningen;67319,-103,97,Wattenheim;67346,-101,112,Speyer;67354,-100,110,Römerberg;67360,-97,111,Lingenfeld;67361,-98,109,Freisbach;67363,-98,109,Lustadt;67365,-100,110,Schwegenheim;67366,-98,110,Weingarten (Pfalz);67368,-99,109,Westheim (Pfalz);67373,-100,109,Dudenhofen;67374,-100,110,Hanhofen;67376,-100,110,Harthausen;67377,-99,109,Gommersheim;67378,-98,109,Zeiskam;67433,-97,109,Neustadt an der Weinstraße;67434,-108,95;67435,-98,110;67454,-99,109,Haßloch;67459,-102,110,Böhl-Iggelheim;67466,-105,97,Lambrecht (Pfalz);67468,-100,103,Frankenstein, Neidenfels, Frankeneck;67471,-111,93,Elmstein;67472,-106,96,Esthal;67473,-100,102,Lindenberg;67475,-105,96,Weidenthal;67480,-113,92,Edenkoben;67482,-98,109,Venningen;67483,-98,108,Edesheim;67487,-108,95,Maikammer;67489,-101,103,Kirrweiler (Pfalz);67547,-101,111,Worms;67549,-102,110;67550,-105,109;67551,-103,108;67574,-103,108,Osthofen;67575,-103,109,Eich;67577,-102,106,Alsheim;67578,-102,109,Gimbsheim;67580,-103,109,Hamm;67582,-104,109,Mettenheim;67583,-102,109,Guntersblum;67585,-101,105,Dorn-Dürkheim;67586,-101,106,Hillesheim;67587,-101,104,Wintersheim;67590,-101,107,Monsheim;67591,-101,107,Offstein;67592,-100,105,Flörsheim-Dalsheim;67593,-102,107,Westhofen, Bermersheim;67595,-102,107,Bechtheim;67596,-102,105,Dittelsheim-Heßloch;67598,-100,105,Gundersheim;67599,-101,107,Gundheim;67655,-88,109,Kaiserslautern;67657,-100,99;67659,-100,100;67661,-101,98;67663,-101,98;67677,-101,98,Enkenbach-Alsenborn;67678,-102,97,Mehlingen;67680,-103,96,Neuhemsbach;67681,-103,97,Sembach;67685,-100,99,Weilerbach u.a.;67686,-100,99,Mackenbach;67688,-100,99,Rodenbach;67691,-103,96,Hochspeyer;67693,-104,96,Waldleiningen, Fischbach;67697,-103,96,Otterberg;67699,-105,94,Schneckenhausen;67700,-105,94,Niederkirchen;67701,-103,96,Schallodenbach;67705,-106,94,Trippstadt u.a.;67706,-104,96,Krickenbach;67707,-106,94,Schopp;67714,-99,100,Waldfischbach-Burgalben;67715,-103,95,Geiselberg;67716,-105,95,Heltersberg;67718,-109,92,Schmalenberg;67722,-104,97,Winnweiler;67724,-105,95,Gundersweiler, Gonbach u.a.;67725,-101,100,Börrstadt;67727,-103,99,Lohnsfeld;67728,-103,98,Münchweiler an der Alsenz;67729,-103,96,Sippersfeld;67731,-98,101,Otterbach, Otterberg;67732,-102,98,Hirschhorn;67734,-98,101,Katzweiler;67735,-102,98,Mehlbach;67737,-97,101,Olsbrücken;67742,-99,101,Lauterecken u.a.;67744,-100,98,Medard, Rathskirchen u.a.;67745,-106,94,Grumbach;67746,-110,90,Langweiler;67748,-98,102,Odenbach;67749,-98,99,Offenbach-Hundheim;67752,-101,97,Wolfstein;67753,-109,92,Rothselberg u.a.;67754,-104,95,Eßweiler;67756,-103,96,Hinzweiler;67757,-96,101,Kreimbach-Kaulbach;67759,-108,92,Nußbach;67806,-98,101,Rockenhausen, Bisterschied u.a.;67808,-107,93,Steinbach, Weitersweiler, Bennhausen, Mörsfeld, Würzweiler, Ruppertsecke;67811,-105,96,Dielkirchen;67813,-102,98,Schwarzengraben, St. Alban, Gerbach;67814,-126,78,Dannenfels;67816,-100,102,Dreisen, Standenbühl;67817,-109,92,Imsbach;67819,-106,95,Kriegsfeld;67821,-100,98,Alsenz;67822,-99,99,Winterborn, Waldgrehweiler, Niedermoschel, u. a.;67823,-98,100,Obermoschel, Schiersfeld;67824,-103,96,Feilbingert;67826,-108,92,Hallgarten;67827,-108,93,Becherbach;67829,-101,98,Callbach;68159,-105,113,Mannheim;68161,-100,116;68163,-103,113;68165,-100,117;68167,-100,117;68169,-101,115;68199,-107,112;68219,-107,111;68229,-108,110;68239,-107,111;68259,-106,113;68305,-107,111;68307,-108,110;68309,-105,113;68519,-108,109,Viernheim;68526,-110,110,Ladenburg;68535,-108,110,Edingen-Neckarhausen;68542,-110,110,Heddesheim;68549,-108,111,Ilvesheim;68623,-106,110,Lampertheim;68642,-106,110,Bürstadt;68647,-106,110,Biblis;68649,-105,110,Groß-Rohrheim;68723,-105,111,Schwetzingen;68753,-100,110,Waghäusel;68766,-104,111,Hockenheim;68775,-106,110,Ketsch;68782,-107,111,Brühl;68789,-103,110,Sankt Leon-Rot;68794,-103,111,Oberhausen-Rheinhausen;68799,-103,110,Reilingen;68804,-101,111,Altlußheim;68809,-103,110,Neulußheim;69115,-101,114,Heidelberg;69117,-118,88;69118,-103,106;69120,-105,108;69121,-103,103;69123,-107,110;69124,-105,111;69126,-104,108;69151,-107,101,Neckargemünd;69168,-101,108,Wiesloch;69181,-103,109,Leimen;69190,-103,111,Walldorf;69198,-105,102,Schriesheim;69207,-105,110,Sandhausen;69214,-106,111,Eppelheim;69221,-104,105,Dossenheim;69226,-102,107,Nußloch;69231,-103,104,Rauenberg;69234,-106,103,Dielheim;69239,-109,96,Neckarsteinach;69242,-104,105,Mühlhausen;69245,-100,107,Bammental;69250,-105,103,Schönau;69251,-108,97,Gaiberg;69253,-113,92,Heiligkreuzsteinach;69254,-101,108,Malsch;69256,-102,107,Mauer;69257,-106,104,Wiesenbach;69259,-110,95,Wilhelmsfeld;69412,-110,98,Eberbach;69427,-121,85,Mudau;69429,-121,86,Waldbrunn;69434,-111,94,Hirschhorn, Brombach, Heddesbach;69436,-109,96,Schönbrunn;69437,-106,104,Neckargerach;69439,-108,98,Zwingenberg;69469,-102,104,Weinheim;69483,-110,97,Wald-Michelbach;69488,-105,106,Birkenau;69493,-109,109,Hirschberg an der Bergstraße;69502,-106,110,Hemsbach;69509,-103,106,Mörlenbach;69514,-107,111,Laudenbach;69517,-102,104,Gorxheimertal;69518,-117,89,Abtsteinach;70173,-93,115,Stuttgart;70174,-93,115;70176,-93,114;70178,-95,113;70180,-102,108;70182,-103,108;70184,-110,99;70186,-106,106;70188,-103,108;70190,-98,111;70191,-99,111;70192,-108,103;70193,-107,104;70195,-116,95;70197,-118,92;70199,-104,107;70327,-101,110;70329,-102,109;70372,-98,111;70374,-102,109;70376,-105,107;70378,-107,105;70435,-107,106;70437,-102,109;70439,-111,103;70469,-107,105;70499,-112,101;70563,-115,95;70565,-113,97;70567,-111,98;70569,-116,94;70597,-113,95;70599,-113,96;70619,-113,95;70629,-113,97,Stuttgart/Leinfelden -Echterdingen;70734,-111,101,Fellbach;70736,-108,104;70771,-114,95,Leinfelden-Echterdingen;70794,-113,96,Filderstadt;70806,-105,107,Kornwestheim;70825,-113,101,Korntal-Münchingen;70839,-118,91,Gerlingen;71032,-119,90,Böblingen;71034,-115,94;71063,-111,99,Sindelfingen;71065,-120,90;71067,-118,92;71069,-118,91;71083,-116,93,Herrenberg;71088,-115,94,Holzgerlingen;71093,-117,91,Weil im Schönbuch;71101,-116,93,Schönaich;71106,-117,93,Magstadt;71111,-116,95,Waldenbuch;71116,-117,93,Gärtringen;71120,-116,95,Grafenau;71126,-117,92,Gäufelden;71131,-120,88,Jettingen;71134,-118,91,Aidlingen;71139,-116,94,Ehningen;71144,-117,93,Steinenbronn;71149,-117,93,Bondorf;71154,-117,92,Nufringen;71155,-120,88,Altdorf;71157,-119,91,Hildrizhausen;71159,-119,90,Mötzingen;71229,-114,97,Leonberg;71254,-117,96,Ditzingen;71263,-115,96,Weil der Stadt;71272,-116,95,Renningen;71277,-119,92,Rutesheim;71282,-114,98,Hemmingen;71287,-117,95,Weissach;71292,-118,91,Friolzheim;71296,-117,91,Heimsheim;71297,-116,95,Mönsheim;71299,-120,90,Wimsheim;71332,-105,107,Waiblingen;71334,-107,105;71336,-108,104;71364,-110,102,Winnenden;71384,-108,104,Weinstadt;71394,-109,103,Kernen im Remstal;71397,-111,102,Leutenbach;71404,-112,101,Korb;71409,-108,104,Schwaikheim;71522,-110,102,Backnang;71540,-113,99,Murrhardt;71543,-122,88,Wüstenrot, Beilstein-Stocksberg;71546,-111,101,Aspach;71549,-112,102,Auenwald;71554,-108,103,Weissach im Tal;71560,-113,98,Sulzbach an der Murr;71563,-111,102,Affalterbach;71566,-123,90,Althütte;71570,-112,99,Oppenweiler;71573,-111,101,Allmersbach im Tal;71576,-112,101,Burgstetten;71577,-123,87,Großerlach;71579,-117,93,Spiegelberg;71634,-105,107,Ludwigsburg;71636,-108,104;71638,-108,105;71640,-108,105;71642,-109,104;71665,-115,97,Vaihingen an der Enz;71672,-108,103,Marbach am Neckar;71679,-108,104,Asperg;71686,-108,105,Remseck am Neckar;71691,-109,103,Freiberg am Neckar;71696,-111,102,Möglingen;71701,-112,102,Schwieberdingen;71706,-116,99,Markgröningen;71711,-109,103,Steinheim, Murr;71717,-112,97,Beilstein;71720,-110,101,Oberstenfeld;71723,-110,103,Großbottwar;71726,-113,101,Benningen am Neckar;71729,-111,102,Erdmannhausen;71732,-112,101,Tamm;71735,-115,97,Eberdingen;71737,-111,101,Kirchberg;71739,-114,97,Oberriexingen;72070,-112,99,Tübingen;72072,-111,99;72074,-114,95;72076,-119,90;72108,-113,94,Rottenburg am Neckar;72116,-120,89,Mössingen;72119,-114,96,Ammerbuch;72124,-115,96,Pliezhausen;72127,-114,96,Kusterdingen;72131,-118,92,Ofterdingen;72135,-119,89,Dettenhausen;72138,-112,98,Kirchentellinsfurt;72141,-117,93,Walddorfhäslach;72144,-116,94,Dußlingen;72145,-116,93,Hirrlingen;72147,-114,95,Nehren;72149,-116,92,Neustetten;72160,-122,87,Horb am Neckar;72172,-115,95,Sulz am Neckar;72175,-126,83,Dornhan;72178,-125,83,Waldachtal;72181,-120,90,Starzach;72184,-117,92,Eutingen im Gäu;72186,-119,90,Empfingen;72189,-120,89,Vöhringen;72202,-117,94,Nagold;72213,-123,86,Altensteig;72218,-117,93,Wildberg;72221,-122,86,Haiterbach;72224,-119,90,Ebhausen;72226,-135,77,Simmersfeld;72227,-119,89,Egenhausen;72229,-117,94,Rohrdorf;72250,-133,76,Freudenstadt;72270,-136,70,Baiersbronn;72275,-126,83,Alpirsbach;72280,-131,80,Dornstetten;72285,-126,83,Pfalzgrafenweiler;72290,-125,83,Loßburg;72293,-118,90,Glatten;72294,-126,83,Grömbach;72296,-127,82,Schopfloch;72297,-135,75,Seewald;72299,-125,84,Wörnersberg;72336,-119,91,Balingen;72348,-124,83,Rosenfeld;72351,-121,86,Geislingen;72355,-126,82,Schömberg;72356,-124,83,Dautmergen;72358,-121,86,Dormettingen;72359,-129,79,Dotternhausen;72361,-128,79,Hausen am Tann;72362,-135,74,Nusplingen;72364,-136,72,Obernheim;72365,-127,82,Ratshausen;72367,-127,82,Weilen unter den Rinnen;72369,-123,85,Zimmern unter der Burg;72379,-117,92,Hechingen;72393,-132,75,Burladingen;72401,-120,90,Haigerloch;72406,-120,88,Bisingen;72411,-118,92,Bodelshausen;72414,-113,96,Rangendingen;72415,-120,88,Grosselfingen;72417,-123,85,Jungingen;72419,-130,79,Neufra;72458,-135,74,Albstadt;72459,-137,71;72461,-132,76;72469,-135,73,Meßstetten;72474,-128,80,Winterlingen;72475,-133,75,Bitz;72477,-133,75,Schwenningen;72479,-132,76,Straßberg;72488,-128,81,Sigmaringen;72501,-130,78,Gammertingen;72505,-126,82,Krauchenwies;72510,-130,79,Stetten am kalten Markt;72511,-129,80,Bingen;72513,-132,76,Hettingen;72514,-125,81,Inzigkofen;72516,-127,82,Scheer;72517,-125,84,Sigmaringendorf;72519,-128,80,Veringenstadt;72525,-134,76,Münsingen;72531,-131,79,Hohenstein;72532,-131,79,Gomadingen;72534,-131,79,Hayingen;72535,-135,77,Heroldstatt;72537,-133,77,Mehrstetten;72539,-132,78,Pfronstetten;72555,-112,98,Metzingen;72574,-131,79,Bad Urach;72581,-112,96,Dettingen an der Erms;72582,-131,79,Grabenstetten;72584,-131,79,Hülben;72585,-108,102,Riederich;72587,-135,75,Römerstein;72589,-136,76,Westerheim;72622,-106,106,Nürtingen;72631,-112,99,Aichtal;72636,-110,100,Frickenhausen;72639,-119,91,Neuffen;72644,-110,100,Oberboihingen;72649,-113,97,Wolfschlugen;72654,-111,100,Neckartenzlingen;72655,-111,100,Altdorf;72657,-115,95,Altenriet;72658,-112,98,Bempflingen;72660,-117,92,Beuren;72661,-114,96,Grafenberg;72663,-111,99,Großbettlingen;72664,-119,91,Kohlberg;72666,-109,102,Neckartailfingen;72667,-114,96,Schlaitdorf;72669,-108,102,Unterensingen;72760,-106,101,Reutlingen;72762,-106,103;72764,-106,103;72766,-112,99;72768,-113,97;72770,-120,90;72793,-117,93,Pfullingen;72800,-131,78,Eningen;72805,-130,79,Lichtenstein;72810,-113,95,Gomaringen;72813,-133,76,St. Johann;72818,-131,78,Trochtelfingen;72820,-131,78,Sonnenbühl;72827,-107,103,Wannweil;72829,-131,79,Engstingen;73033,-108,102,Göppingen;73035,-110,100;73037,-115,95;73054,-108,101,Eislingen/Fils;73061,-111,100,Ebersbach an der Fils;73066,-110,100,Uhingen;73072,-116,94,Donzdorf;73079,-112,97,Süßen;73084,-117,93,Salach;73087,-118,92,Bad Boll;73092,-111,97,Heiningen;73095,-113,97,Albershausen;73098,-111,99,Rechberghausen;73099,-121,90,Adelberg;73101,-113,96,Aichelberg;73102,-121,92,Birenbach;73104,-118,94,Börtlingen;73105,-113,96,Dürnau;73107,-113,96,Eschenbach;73108,-115,94,Gammelshausen;73110,-113,97,Hattenhofen;73111,-136,78,Lauterstein;73113,-115,95,Ottenbach;73114,-116,93,Schlat;73116,-119,93,Wäschenbeuren;73117,-117,94,Wangen;73119,-113,96,Zell unter Aichelberg;73207,-108,103,Plochingen;73230,-108,103,Kirchheim unter Teck;73235,-113,95,Weilheim an der Teck;73240,-105,106,Wendlingen am Neckar;73249,-110,102,Wernau (Neckar);73252,-136,76,Lenningen;73257,-110,101,Köngen;73262,-113,97,Reichenbach an der Fils;73265,-113,96,Dettingen unter Teck;73266,-128,82,Bissingen an der Teck;73268,-130,80,Erkenbrechtsweiler;73269,-111,100,Hochdorf;73271,-112,98,Holzmaden;73272,-123,86,Neidlingen;73274,-110,101,Notzingen;73275,-113,97,Ohmden;73277,-115,96,Owen;73278,-112,98,Schlierbach;73312,-128,84,Geislingen an der Steige;73326,-124,87,Deggingen;73329,-117,94,Kuchen;73333,-113,96,Gingen an der Fils;73337,-131,81,Bad Überkingen;73340,-130,82,Amstetten;73342,-135,78,Bad Ditzenbach;73344,-128,83,Gruibingen;73345,-137,75,Hohenstadt/Dracke nstein;73347,-124,86,Mühlhausen im Täle;73349,-136,76,Wiesensteig;73430,-119,94,Aalen;73431,-127,86;73432,-132,81;73433,-121,92;73434,-126,87;73441,-126,86,Bopfingen;73447,-123,88,Oberkochen;73450,-127,85,Neresheim;73453,-122,91,Abtsgmünd;73457,-129,85,Essingen;73460,-126,87,Hüttlingen;73463,-125,88,Westhausen;73466,-130,83,Lauchheim;73467,-126,87,Kirchheim am Ries;73469,-131,89,Riesbürg;73479,-128,86,Ellwangen (Jagst);73485,-126,87,Unterschneidheim;73486,-124,90,Adelmannsfelden;73488,-133,82,Ellenberg;73489,-125,90,Jagstzell;73491,-127,87,Neuler;73492,-124,89,Rainau;73494,-128,87,Rosenberg;73495,-128,86,Stödtlen;73497,-129,85,Tannhausen;73499,-127,88,Wört;73525,-112,99,Stadt Schwäbisch Gmünd;73527,-121,93,Schwäbisch Gmünd, Täferrot;73529,-118,93,Stadt Schwäbisch Gmünd;73540,-131,81,Heubach;73547,-113,99,Lorch;73550,-130,83,Waldstetten;73553,-123,90,Alfdorf, Schillinghof;73557,-118,94,Mutlangen;73560,-116,96,Böbingen an der Rems;73563,-120,92,Mögglingen;73565,-128,86,Spraitbach;73566,-132,81,Bartholomä;73568,-125,89,Durlangen, Weggen-Ziegelhütte, Leinhäusle;73569,-126,87,Eschach, Obergröningen;73571,-125,89,Göggingen;73572,-122,91,Heuchlingen;73574,-124,89,Iggingen;73575,-121,93,Leinzell;73577,-126,87,Ruppertshofen;73579,-125,88,Schechingen;73614,-110,104,Schorndorf;73630,-111,102,Remshalden;73635,-113,101,Rudersberg;73642,-125,88,Welzheim;73650,-112,101,Winterbach;73655,-115,98,Plüderhausen;73660,-111,102,Urbach;73663,-111,101,Berglen;73666,-117,93,Baltmannsweiler;73667,-127,85,Kaisersbach;73669,-117,93,Lichtenwald;73728,-103,108,Esslingen am Neckar;73730,-112,98;73732,-113,96;73733,-112,98;73734,-110,100;73760,-113,98,Ostfildern;73765,-112,99,Neuhausen auf den Fildern;73770,-112,100,Denkendorf;73773,-119,91,Aichwald;73776,-108,104,Altbach;73779,-109,102,Deizisau;74072,-100,112,Heilbronn;74074,-108,102;74076,-102,109;74078,-108,103;74080,-106,105;74081,-106,105;74172,-105,106,Neckarsulm;74177,-105,106,Bad Friedrichshall;74182,-106,105,Obersulm;74189,-106,106,Weinsberg;74193,-108,102,Schwaigern;74196,-104,106,Neuenstadt am Kocher;74199,-109,100,Untergruppenbach;74206,-107,104,Bad Wimpfen;74211,-108,104,Leingarten;74214,-111,99,Schöntal;74219,-108,103,Möckmühl;74223,-109,102,Flein;74226,-108,103,Nordheim;74229,-106,104,Oedheim;74232,-108,102,Abstatt;74235,-107,103,Erlenbach;74238,-111,99,Krautheim;74239,-107,103,Hardthausen am Kocher;74243,-107,103,Langenbrettach;74245,-108,100,Löwenstein;74246,-106,104,Eberstadt;74248,-106,105,Ellhofen;74249,-106,104,Jagsthausen;74251,-107,103,Lehrensteinsfeld;74252,-109,101,Massenbachhause n;74254,-104,106,Offenau;74255,-110,100,Roigheim;74257,-105,106,Untereisesheim;74259,-108,103,Widdern;74321,-110,102,Bietigheim-Bissingen;74336,-109,102,Brackenheim;74343,-116,97,Sachsenheim;74348,-107,105,Lauffen am Neckar;74354,-108,104,Besigheim;74357,-112,100,Bönnigheim;74360,-109,101,Ilsfeld;74363,-107,104,Güglingen;74366,-108,104,Kirchheim am Neckar;74369,-114,99,Löchgau;74372,-114,98,Sersheim;74374,-115,96,Zaberfeld;74376,-112,101,Gemmrigheim;74379,-113,101,Ingersheim;74382,-111,100,Neckarwestheim;74385,-108,104,Pleidelsheim;74388,-110,101,Talheim;74389,-112,99,Cleebronn;74391,-112,100,Erligheim;74392,-115,98,Freudental;74394,-109,103,Hessigheim;74395,-113,100,Mundelsheim;74397,-108,102,Pfaffenhofen;74399,-112,101,Walheim;74405,-115,97,Gaildorf;74417,-123,89,Gschwend;74420,-116,96,Oberrot;74423,-120,93,Obersontheim;74424,-126,88,Bühlertann;74426,-124,89,Bühlerzell;74427,-115,97,Fichtenberg;74429,-116,97,Sulzbach-Laufen;74523,-116,95,Schwäbisch Hall;74532,-123,91,Ilshofen;74535,-121,90,Mainhardt;74538,-113,97,Rosengarten;74541,-126,89,Vellberg;74542,-113,98,Braunsbach;74544,-116,96,Michelbach an der Bilz;74545,-122,90,Michelfeld;74547,-119,93,Untermünkheim;74549,-122,92,Wolpertshausen;74564,-121,94,Crailsheim;74572,-125,89,Blaufelden;74575,-126,88,Schrozberg;74579,-131,85,Fichtenau;74582,-124,90,Gerabronn;74585,-123,91,Rot am See;74586,-123,90,Frankenhardt;74589,-125,91,Satteldorf;74592,-120,94,Kirchberg an der Jagst;74594,-128,88,Kreßberg;74595,-123,90,Langenburg;74597,-127,88,Stimpfach;74599,-127,89,Wallhausen;74613,-106,103,Öhringen;74626,-106,103,Bretzfeld;74629,-106,102,Pfedelbach;74632,-108,100,Neuenstein;74635,-112,98,Kupferzell;74638,-122,89,Waldenburg;74639,-110,98,Zweiflingen;74653,-115,96,Künzelsau, Ingelfingen;74670,-112,97,Forchtenberg;74673,-113,99,Mulfingen;74676,-112,97,Niedernhall;74677,-110,101,Dörzbach;74679,-110,99,Weißbach;74706,-110,98,Osterburken;74722,-113,96,Buchen;74731,-118,91,Walldürn;74736,-112,98,Hardheim;74740,-108,103,Adelsheim;74743,-111,97,Seckach;74744,-116,95,Ahorn;74746,-118,91,Höpfingen;74747,-111,98,Ravenstein;74749,-111,98,Rosenberg;74821,-110,99,Mosbach;74831,-108,100,Gundelsheim;74834,-110,101,Elztal;74838,-118,91,Limbach;74842,-110,101,Billigheim;74847,-110,98,Obrigheim;74850,-109,98,Schefflenz;74855,-105,105,Haßmersheim;74858,-107,102,Aglasterhausen;74861,-107,104,Neudenau;74862,-109,101,Binau;74864,-112,96,Fahrenbach;74865,-110,100,Neckarzimmern;74867,-108,97,Neunkirchen;74869,-110,99,Schwarzach;74889,-105,105,Sinsheim;74906,-110,101,Bad Rappenau;74909,-105,104,Meckesheim;74912,-108,101,Kirchardt;74915,-106,103,Waibstadt;74918,-106,104,Angelbachtal;74921,-108,102,Helmstadt-Bargen;74924,-108,101,Neckarbischofshei m;74925,-108,101,Epfenbach;74927,-103,105,Eschelbronn;74928,-108,98,Hüffenhardt;74930,-106,103,Ittlingen;74931,-108,101,Lobbach;74933,-105,105,Neidenstein;74934,-109,98,Reichartshausen;74936,-111,99,Siegelsbach;74937,-107,102,Spechbach;74939,-103,106,Zuzenhausen;75015,-107,102,Bretten;75031,-106,104,Eppingen;75038,-107,103,Oberderdingen;75045,-107,103,Walzbachtal;75050,-108,102,Gemmingen;75053,-106,103,Gondelsheim;75056,-106,103,Sulzfeld;75057,-108,102,Kürnbach;75059,-106,103,Zaisenhausen;75172,-110,102,Pforzheim;75173,-107,103;75175,-113,98;75177,-116,95;75179,-113,96;75180,-117,92;75181,-118,91;75196,-105,105,Remchingen;75203,-108,101,Königsbach-Stein;75210,-107,104,Keltern;75217,-114,95,Birkenfeld;75223,-114,96,Niefern-Öschelbronn;75228,-115,95,Ispringen;75233,-117,92,Tiefenbronn;75236,-113,97,Kämpfelbach;75239,-113,97,Eisingen;75242,-120,89,Neuhausen;75245,-115,95,Neulingen;75248,-115,96,Ölbronn-Dürrn;75249,-115,95,Kieselbronn;75305,-123,84,Neuenbürg;75323,-137,75,Bad Wildbad;75328,-128,81,Schömberg;75331,-124,85,Engelsbrand;75334,-115,95,Straubenhardt;75335,-128,81,Dobel;75337,-130,80,Enzklösterle;75339,-114,96,Höfen an der Enz;75365,-113,99,Calw;75378,-117,91,Bad Liebenzell;75382,-118,89,Althengstett;75385,-123,84,Bad Teinach-Zavelstein;75387,-123,85,Neubulach;75389,-131,79,Neuweiler;75391,-118,91,Gechingen;75392,-122,87,Deckenpfronn;75394,-131,79,Oberreichenbach;75395,-121,88,Ostelsheim;75397,-121,87,Simmozheim;75399,-118,93,Unterreichenbach;75417,-115,96,Mühlacker;75428,-116,95,Illingen;75433,-115,96,Maulbronn;75438,-110,100,Knittlingen;75443,-117,97,Ötisheim;75446,-118,94,Wiernsheim;75447,-117,94,Sternenfels;75449,-118,92,Wurmberg;76131,-101,110,Karlsruhe;76133,-93,116;76135,-95,115;76137,-95,113;76139,-100,111;76149,-98,112;76185,-95,115;76187,-100,112;76189,-100,111;76199,-100,111;76227,-99,112;76228,-107,101;76229,-100,110;76275,-102,107,Ettlingen;76287,-101,111,Rheinstetten;76297,-101,110,Stutensee;76307,-112,98,Karlsbad;76316,-102,109,Malsch;76327,-102,108,Pfinztal;76332,-115,94,Bad Herrenalb;76337,-106,104,Waldbronn;76344,-100,111,Eggenstein-Leopoldshafen;76351,-100,110,Linkenheim-Hochstetten;76356,-103,108,Weingarten;76359,-108,101,Marxzell;76437,-97,113,Rastatt;76448,-100,111,Durmersheim;76456,-102,105,Kuppenheim;76461,-102,110,Muggensturm;76467,-101,111,Bietigheim;76470,-101,112,Ötigheim;76473,-101,111,Iffezheim;76474,-100,111,Au am Rhein;76476,-101,110,Bischweier;76477,-100,111,Elchesheim-Illingen;76479,-100,111,Steinmauern;76530,-101,105,Baden-Baden;76532,-100,110;76534,-110,98;76547,-101,110,Sinzheim;76549,-102,110,Hügelsheim;76571,-107,101,Gaggenau;76593,-118,91,Gernsbach;76596,-123,85,Forbach;76597,-115,94,Loffenau;76599,-108,100,Weisenbach;76646,-104,104,Bruchsal;76661,-100,111,Philippsburg;76669,-102,110,Bad Schönborn;76676,-99,110,Graben-Neudorf;76684,-106,102,Östringen;76689,-101,110,Karlsdorf-Neuthard;76694,-100,110,Forst;76698,-103,107,Ubstadt-Weiher;76703,-105,103,Kraichtal;76706,-99,110,Dettenheim;76707,-100,110,Hambrücken;76709,-101,110,Kronau;76726,-99,110,Germersheim;76744,-101,109,Wörth;76751,-99,111,Jockgrim;76756,-99,110,Bellheim;76761,-100,110,Rülzheim;76764,-100,110,Rheinzabern;76767,-100,111,Hagenbach;76768,-100,111,Berg;76770,-100,110,Hatzenbühl;76771,-99,110,Hördt;76773,-100,110,Kuhardt;76774,-99,110,Leimersheim;76776,-100,111,Neuburg am Rhein;76777,-99,111,Neupotz;76779,-101,110,Scheibenhardt;76829,-101,107,Landau in der Pfalz;76831,-100,107,Billigheim-Ingenheim, Birkweiler;76833,-102,102,Frankweiler;76835,-101,100,Rhodt u.a.;76846,-101,100,Hauenstein;76848,-116,89,Wilgartswiesen;76855,-110,94,Annweiler am Trifels;76857,-108,95,Albersweiler, Silz u. a.;76863,-100,110,Herxheim;76865,-100,108,Insheim;76870,-101,109,Kandel;76872,-101,109,Steinweiler;76877,-99,109,Offenbach an der Queich;76879,-99,109,Hochstadt;76887,-102,106,Bad Bergzabern u. a.;76889,-101,104,Klingenmünster u. a.;76891,-102,101,Bruchweiler-Bärenbach u.a.;77652,-95,109,Offenburg;77654,-95,107;77656,-88,113;77694,-94,110,Kehl;77704,-97,107,Oberkirch;77709,-112,94,Wolfach, Oberwolfach;77716,-98,106,Fischerbach, Haslach, Hofstetten;77723,-98,106,Gengenbach;77728,-108,99,Oppenau;77731,-94,110,Willstätt;77736,-107,101,Zell am Harmersbach;77740,-114,94,Bad Peterstal-Griesbach;77743,-95,109,Neuried;77746,-95,108,Schutterwald;77749,-96,108,Hohberg;77756,-102,105,Hausach;77761,-114,92,Schiltach;77767,-95,110,Appenweier;77770,-100,104,Durbach;77773,-118,90,Schenkenzell;77776,-132,78,Bad Rippoldsau-Schapbach;77781,-99,106,Biberach;77784,-108,100,Oberharmersbach;77787,-109,99,Nordrach;77790,-100,105,Steinach;77791,-97,107,Berghaupten;77793,-110,98,Gutach (Schwarzwaldbahn);77794,-108,99,Lautenbach;77796,-111,97,Mühlenbach;77797,-98,106,Ohlsbach;77799,-96,107,Ortenberg;77815,-96,108,Bühl;77830,-106,101,Bühlertal;77833,-97,110,Ottersweier;77836,-100,110,Rheinmünster;77839,-98,110,Lichtenau;77855,-93,110,Achern;77866,-96,110,Rheinau;77871,-94,109,Renchen;77876,-107,98,Kappelrodeck;77880,-116,91,Sasbach;77883,-107,99,Ottenhöfen im Schwarzwald;77886,-107,98,Lauf;77887,-133,77,Sasbachwalden;77889,-126,82,Seebach;77933,-95,110,Lahr/Schwarzwald;77948,-97,107,Friesenheim;77955,-101,105,Ettenheim;77960,-98,107,Seelbach;77963,-97,108,Schwanau;77966,-96,108,Kappel-Grafenhausen;77971,-99,105,Kippenheim;77972,-96,109,Mahlberg;77974,-95,109,Meißenheim;77975,-96,108,Ringsheim;77977,-96,108,Rust;77978,-106,97,Schuttertal;78048,-129,82,Villingen-Schwenningen;78050,-128,83;78052,-130,81;78054,-128,82;78056,-125,83;78073,-127,83,Bad Dürrheim;78078,-126,82,Niedereschach;78083,-128,81,Dauchingen;78086,-127,83,Brigachtal;78087,-130,79,Mönchweiler;78089,-131,78,Unterkirnach;78098,-133,76,Triberg im Schwarzwald;78112,-133,76,Sankt Georgen im Schwarzwald;78120,-133,73,Furtwangen im Schwarzwald;78126,-132,78,Königsfeld im Schwarzwald;78132,-121,87,Hornberg;78136,-135,72,Schonach im Schwarzwald;78141,-138,69,Schönwald im Schwarzwald;78144,-132,75,Schramberg;78147,-131,77,Vöhrenbach;78148,-135,72,Gütenbach;78166,-126,82,Donaueschingen;78176,-126,83,Blumberg;78183,-130,81,Hüfingen;78187,-133,78,Geisingen;78194,-131,78,Immendingen;78199,-130,81,Bräunlingen;78224,-98,99,Singen (Hohentwiel);78234,-105,93,Engen;78239,-95,100,Rielasingen-Worblingen;78244,-96,98,Gottmadingen;78247,-113,87,Hilzingen;78250,-113,87,Tengen;78253,-115,86,Eigeltingen;78256,-98,97,Steißlingen;78259,-100,96,Mühlhausen-Ehingen;78262,-105,93,Gailingen am Hochrhein;78266,-97,99,Büsingen am Hochrhein;78267,-103,94,Aach;78269,-97,98,Volkertshausen;78315,-96,100,Radolfzell am Bodensee;78333,-102,95,Stockach;78337,-113,89,Öhningen;78343,-98,97,Gaienhofen;78345,-96,100,Moos;78351,-93,100,Bodman-Ludwigshafen;78354,-93,101,Sipplingen;78355,-117,85,Hohenfels;78357,-120,84,Mühlingen;78359,-98,97,Orsingen-Nenzingen;78462,-91,104,Konstanz;78464,-94,101;78465,-98,96;78467,-92,104;78476,-97,96,Allensbach;78479,-93,101,Reichenau;78532,-123,85,Tuttlingen;78549,-123,85,Spaichingen;78554,-124,85,Aldingen;78559,-131,77,Gosheim;78564,-131,78,Wehingen, Reichenbach;78567,-123,84,Fridingen an der Donau;78570,-131,78,Mühlheim an der Donau;78573,-125,84,Wurmlingen;78576,-126,81,Emmingen-Liptingen;78579,-126,81,Neuhausen ob Eck;78580,-123,84,Bärenthal;78582,-126,82,Balgheim;78583,-135,74,Böttingen;78585,-135,73,Bubsheim;78586,-132,77,Deilingen;78588,-127,82,Denkingen;78589,-130,79,Dürbheim;78591,-127,82,Durchhausen;78592,-134,74,Egesheim;78594,-128,81,Gunningen;78595,-132,77,Hausen ob Verena;78597,-133,75,Irndorf;78598,-134,74,Königsheim;78600,-132,76,Kolbingen;78601,-134,75,Mahlstetten;78603,-135,74,Renquishausen;78604,-127,82,Rietheim-Weilheim;78606,-130,80,Seitingen-Oberflacht;78607,-129,81,Talheim;78609,-128,81,Tuningen;78628,-121,88,Rottweil;78647,-127,84,Trossingen;78652,-123,87,Deißlingen;78655,-126,83,Dunningen;78658,-125,84,Zimmern ob Rottweil;78661,-121,88,Dietingen;78662,-126,83,Bösingen;78664,-128,80,Eschbronn;78665,-125,84,Frittlingen;78667,-123,84,Villingendorf;78669,-123,85,Wellendingen;78713,-128,82,Schramberg;78727,-117,91,Oberndorf am Neckar;78730,-126,82,Lauterbach;78733,-127,82,Aichhalden;78736,-123,86,Epfendorf;78737,-126,83,Fluorn-Winzeln;78739,-131,78,Hardt;79098,-97,114,Freiburg im Breisgau;79100,-108,97;79102,-98,112;79104,-102,108;79106,-97,114;79108,-99,113;79110,-97,115;79111,-98,113;79112,-100,111;79114,-95,116;79115,-96,116;79117,-110,95;79183,-110,99,Waldkirch;79189,-100,109,Bad Krozingen;79194,-102,108,Gundelfingen, Heuweiler;79199,-107,102,Kirchzarten;79206,-101,110,Breisach am Rhein;79211,-101,112,Denzlingen;79215,-107,100,Elzach, Biederbach;79219,-103,105,Staufen im Breisgau;79224,-100,112,Umkirch;79227,-100,110,Schallstadt;79232,-101,112,March;79235,-101,109,Vogtsburg im Kaiserstuhl;79238,-103,106,Ehrenkirchen;79241,-102,110,Ihringen;79244,-130,80,Münstertal;79249,-102,108,Merzhausen;79252,-110,96,Stegen;79254,-136,60,Oberried;79256,-108,98,Buchenbach;79258,-100,110,Hartheim;79261,-107,97,Gutach im Breisgau;79263,-107,98,Simonswald;79268,-101,111,Bötzingen;79271,-135,72,Sankt Peter;79274,-133,75,St. Märgen;79276,-101,111,Reute;79279,-101,112,Vörstetten;79280,-105,103,Au (Breisgau);79282,-103,105,Ballrechten-Dottingen;79283,-111,94,Bollschweil;79285,-108,99,Ebringen;79286,-109,97,Glottertal;79288,-101,111,Gottenheim;79289,-111,94,Horben;79291,-101,111,Merdingen;79292,-103,105,Pfaffenweiler;79294,-106,103,Sölden;79295,-109,95,Sulzburg;79297,-105,102,Winden im Elztal;79299,-107,102,Wittnau;79312,-101,111,Emmendingen;79331,-100,112,Teningen;79336,-98,108,Herbolzheim;79341,-101,109,Kenzingen;79346,-102,109,Endingen am Kaiserstuhl;79348,-106,98,Freiamt;79350,-104,104,Sexau;79353,-100,111,Bahlingen;79356,-102,109,Eichstetten;79359,-98,110,Riegel;79361,-99,110,Sasbach am Kaiserstuhl;79362,-97,110,Forchheim;79364,-101,109,Malterdingen;79365,-96,109,Rheinhausen;79367,-96,109,Weisweil;79369,-97,110,Wyhl;79379,-98,108,Müllheim;79395,-99,109,Neuenburg am Rhein;79400,-103,100,Kandern;79410,-125,84,Badenweiler;79415,-104,102,Bad Bellingen;79418,-103,104,Schliengen;79423,-100,109,Heitersheim;79424,-99,109,Auggen;79426,-99,109,Buggingen;79427,-99,110,Eschbach;79429,-113,91,Malsburg-Marzell;79539,-100,108,Lörrach;79540,-102,101;79541,-101,106;79576,-101,108,Weil am Rhein;79585,-105,97,Steinen;79588,-103,104,Efringen-Kirchen;79589,-102,107,Binzen;79591,-102,107,Eimeldingen;79592,-102,107,Fischingen;79594,-102,101,Inzlingen;79595,-103,103,Rümmingen;79597,-102,104,Schallbach;79599,-102,105,Wittlingen;79618,-101,101,Rheinfelden (Baden);79639,-101,107,Grenzach-Wyhlen;79650,-105,97,Schopfheim;79664,-101,100,Wehr;79669,-116,90,Zell im Wiesental;79674,-138,68,Todtnau;79677,-122,86,Schönau im Schwarzwald;79682,-136,76,Todtmoos;79685,-136,75,Häg-Ehrsberg;79686,-105,97,Hasel;79688,-105,97,Hausen im Wiesental;79689,-103,103,Maulburg;79692,-125,84,Kleines Wiesental;79694,-115,90,Utzenfeld;79695,-133,76,Wieden;79713,-99,105,Bad Säckingen;79725,-100,98,Laufenburg (Baden);79730,-105,96,Murg;79733,-131,80,Görwihl;79736,-128,83,Rickenbach;79737,-136,74,Herrischried;79739,-101,100,Schwörstadt;79761,-100,97,Waldshut-Tiengen;79771,-98,100,Klettgau;79774,-106,95,Albbruck;79777,-121,86,Ühlingen-Birkendorf;79780,-116,87,Stühlingen;79787,-96,102,Lauchringen;79790,-97,101,Küssaberg;79793,-101,98,Wutöschingen;79798,-98,98,Jestetten;79801,-101,97,Hohentengen am Hochrhein;79802,-103,95,Dettighofen;79804,-97,100,Dogern;79805,-108,93,Eggingen;79807,-98,99,Lottstetten;79809,-128,84,Weilheim;79822,-136,74,Titisee-Neustadt;79837,-138,73,St. Blasien, Ibach;79843,-134,77,Löffingen;79848,-135,77,Bonndorf im Schwarzwald;79853,-136,75,Lenzkirch;79856,-137,62,Hinterzarten;79859,-141,69,Schluchsee;79862,-138,74,Höchenschwand;79865,-138,73,Grafenhausen;79868,-142,66,Feldberg;79871,-139,69,Eisenbach;79872,-137,72,Bernau im Schwarzwald;79874,-139,68,Breitnau;79875,-137,75,Dachsberg;79877,-137,72,Friedenweiler;79879,-133,79,Wutach;80331,-111,102,München;80333,-111,102;80335,-112,101;80336,-122,93;80337,-112,101;80339,-123,92;80469,-113,101;80538,-122,94;80539,-112,102;80634,-115,99;80636,-112,101;80637,-115,98;80638,-128,91;80639,-128,90;80686,-127,91;80687,-129,90;80689,-132,89;80796,-113,100;80797,-113,100;80798,-113,100;80799,-112,102;80801,-113,100;80802,-122,94;80803,-114,99;80804,-114,99;80805,-131,90;80807,-125,92;80809,-129,90;80933,-131,90;80935,-128,91;80937,-135,89;80939,-129,92;80992,-127,91;80993,-130,90;80995,-136,88;80997,-133,89;80999,-133,89;81241,-131,90;81243,-132,90;81245,-131,90;81247,-130,90;81249,-137,88;81369,-128,91;81371,-126,92;81373,-118,96;81375,-133,89;81377,-133,89;81379,-130,90;81475,-139,86;81476,-137,87;81477,-135,88;81479,-135,88;81539,-126,92;81541,-125,92;81543,-125,92;81545,-138,86;81547,-128,91;81549,-131,90;81667,-115,98;81669,-125,92;81671,-127,91;81673,-128,91;81675,-123,93;81677,-130,90;81679,-123,93;81735,-130,90;81737,-130,91;81739,-135,88;81825,-129,91;81827,-135,88;81829,-132,89;81925,-127,92;81927,-130,90;81929,-134,88;82008,-138,86,Unterhaching;82024,-140,85,Taufkirchen;82031,-141,84,Grünwald;82041,-143,82,Oberhaching;82049,-139,86,Pullach i. Isartal;82054,-143,81,Sauerlach;82057,-144,78,Icking;82061,-143,84,Neuried;82064,-143,81,Straßlach-Dingharting;82065,-143,81,Baierbrunn;82067,-143,81,Schäftlarn;82069,-146,79;82110,-138,87,Germering;82131,-142,84,Gauting;82140,-138,88,Olching;82152,-141,85,Planegg/Krailling;82166,-135,88,Gräfelfing;82178,-139,87,Puchheim;82194,-133,90,Gröbenzell;82205,-143,86,Gilching;82211,-142,87,Herrsching a. Ammersee;82216,-141,87,Maisach;82223,-142,87,Eichenau;82229,-140,84,Seefeld;82234,-142,85,Weßling;82237,-143,85,Wörthsee;82239,-143,85,Alling;82256,-142,86,Fürstenfeldbruck;82266,-141,86,Inning a. Ammersee;82269,-143,86,Geltendorf;82272,-142,85,Moorenweis;82275,-138,87,Emmering;82276,-144,86,Adelshofen;82278,-145,86,Althegnenberg;82279,-142,87,Eching a. Ammersee;82281,-143,87,Egenhofen;82284,-141,86,Grafrath;82285,-145,86,Hattenhofen;82287,-143,85,Jesenwang;82288,-141,85,Kottgeisering;82290,-143,85,Landsberied;82291,-144,86,Mammendorf;82293,-143,87,Mittelstetten;82294,-144,86,Oberschweinbach;82296,-142,87,Schöngeising;82297,-145,86,Steindorf;82299,-140,85,Türkenfeld;82319,-140,82,Starnberg;82327,-143,78,Tutzing;82335,-142,82,Berg;82340,-141,82,Feldafing;82343,-140,82,Pöcking;82346,-145,80,Andechs;82347,-141,83,Bernried;82349,-143,85,Pentenried;82362,-138,87,Weilheim i. OB;82377,-140,84,Penzberg;82380,-140,86,Peißenberg;82383,-141,79,Hohenpeißenberg;82386,-138,85,Huglfing;82387,-140,82,Antdorf;82389,-140,78,Böbing;82390,-141,81,Eberfing;82392,-138,79,Habach;82393,-139,84,Iffeldorf;82395,-138,79,Obersöchering;82396,-140,86,Pähl;82398,-139,86,Polling;82399,-138,87,Raisting;82401,-141,77,Rottenbuch;82402,-141,83,Seeshaupt;82404,-137,83,Sindelsdorf;82405,-141,82,Wessobrunn;82407,-141,86,Wielenbach;82409,-143,76,Wildsteig;82418,-141,79,Murnau a. Staffelsee;82431,-142,76,Kochel a. See;82432,-140,78,Walchensee;82433,-142,75,Bad Kohlgrub;82435,-141,77,Bayersoien;82436,-138,81,Eglfing;82438,-147,72,Eschenlohe;82439,-139,81,Großweil;82441,-142,75,Ohlstadt;82442,-153,69,Saulgrub;82444,-139,81,Schlehdorf;82445,-151,70,Schwaigen;82447,-138,79,Spatzenhausen;82449,-140,77,Uffing a. Staffelsee;82467,-153,70,Garmisch-Partenkirchen;82475,-192,1,Garmisch-Partenkirchen (Schneefernerhaus);82481,-155,56,Mittenwald;82487,-141,75,Oberammergau;82488,-148,73,Ettal;82490,-140,76,Farchant;82491,-156,64,Grainau;82493,-154,66,Krün;82494,-152,68;82496,-139,78,Oberau;82497,-141,75,Unterammergau;82499,-152,66,Wallgau;82515,-136,86,Wolfratshausen;82538,-140,83,Geretsried;82541,-142,82,Münsing;82544,-143,81,Egling;82547,-139,83,Eurasburg;82549,-138,84,Königsdorf;83022,-119,95,Rosenheim;83024,-121,94;83026,-123,92;83043,-125,89,Bad Aibling;83052,-128,87,Bruckmühl;83059,-123,90,Kolbermoor;83064,-125,88,Raubling;83071,-126,88,Stephanskirchen;83075,-125,88,Bad Feilnbach;83080,-133,78,Oberaudorf;83083,-129,85,Riedering;83088,-142,72,Kiefersfelden;83093,-126,86,Bad Endorf;83098,-139,76,Brannenburg;83101,-126,88,Rohrdorf;83104,-130,86,Tuntenhausen;83109,-125,88,Großkarolinenfeld;83112,-131,83,Frasdorf;83115,-125,89,Neubeuern;83119,-131,83,Obing;83122,-133,81,Samerberg;83123,-130,85,Amerang;83125,-128,85,Eggstätt;83126,-150,60,Flintsbach a. Inn;83128,-128,86,Halfing;83129,-131,83,Höslwang;83131,-137,75,Nußdorf a. Inn;83132,-132,83,Pittenhart;83134,-128,86,Prutting;83135,-124,89,Schechen;83137,-129,86,Schonstett;83139,-127,87,Söchtenau;83209,-127,86,Prien a. Chiemsee, Herrenchiemssee;83224,-128,85,Grassau;83229,-133,81,Aschau i. Chiemgau;83233,-128,86,Bernau a. Chiemsee;83236,-128,86,Übersee;83242,-144,66,Reit im Winkl;83246,-129,83,Unterwössen;83250,-128,85,Marquartstein;83253,-128,85,Rimsting;83254,-128,85,Breitbrunn a. Chiemsee;83256,-128,86,Chiemsee;83257,-128,84,Gstadt a. Chiemsee;83259,-140,73,Schleching;83278,-128,83,Traunstein;83301,-129,86,Traunreut;83308,-131,87,Trostberg;83313,-136,77,Siegsdorf;83317,-131,89,Teisendorf;83324,-150,51,Ruhpolding;83329,-130,88,Waging a. See;83334,-133,78,Inzell;83339,-131,85,Chieming;83342,-134,84,Tacherting;83346,-136,77,Bergen;83349,-130,85,Palling;83352,-132,85,Altenmarkt a.d. Alz;83355,-128,86,Grabenstätt;83358,-129,85,Seeon-Seebruck;83361,-131,83,Kienberg;83362,-130,85,Surberg;83364,-132,79,Neukirchen am Teisenberg;83365,-133,84,Nußdorf;83367,-132,90,Petting;83368,-131,84,St. Georgen;83370,-132,85,Seeon-Seebruck;83371,-132,85,Stein a.d. Traun;83373,-130,87,Taching a. See;83374,-131,85,Traunreut;83376,-131,86,Seeon-Seebruck;83377,-128,84,Vachendorf;83379,-132,85,Wonneberg;83395,-129,96,Freilassing;83404,-133,91,Ainring;83410,-131,91,Laufen;83413,-130,92,Fridolfing;83416,-131,90,Saaldorf;83417,-130,90,Kirchanschöring;83435,-132,90,Bad Reichenhall;83451,-136,90,Piding;83454,-129,85,Anger;83457,-135,77,Bayerisch Gmain;83458,-123,87,Schneizlreuth;83471,-146,66,Berchtesgaden & Schönau;83483,-133,79,Bischofswiesen;83486,-167,33,Ramsau b. Berchtesgaden;83487,-130,82,Marktschellenberg;83512,-127,87,Wasserburg a. Inn;83527,-136,82,Haag i. OB;83530,-133,83,Schnaitsee;83533,-129,85,Edling;83536,-134,85,Gars a. Inn;83539,-128,86,Pfaffing;83543,-127,87,Rott a. Inn;83544,-133,83,Albaching;83546,-135,85,Gars am Inn;83547,-132,84,Babensham;83549,-128,86,Eiselfing;83550,-128,87,Emmering;83553,-130,85,Frauenneuharting;83555,-135,86,Gars a. Inn;83556,-128,87,Griesstätt;83558,-138,81,Maitenbeth;83559,-136,87,Gars a. Inn;83561,-127,87,Ramerberg;83562,-131,85,Rechtmehring;83564,-129,85,Soyen;83565,-133,84,in der Gde Frauenneuharting;83567,-133,84,Unterreit;83569,-127,87,Vogtareuth;83607,-142,77,Holzkirchen;83620,-137,83,Feldkirchen-Westerham;83623,-143,77,Dietramszell;83624,-143,80,Otterfing;83626,-139,80,Valley;83627,-144,75,Warngau;83629,-139,78,Weyarn;83646,-139,81,Bad Tölz, Wackersberg;83661,-153,66,Lenggries;83666,-143,76,Waakirchen;83670,-140,81,Bad Heilbrunn;83671,-143,74,Benediktbeuern;83673,-140,80,Bichl;83674,-146,74,Gaißach;83676,-142,76,Jachenau;83677,-140,78,Reichersbeuern;83679,-141,77,Sachsenkam;83684,-140,74,Tegernsee;83700,-152,64,Rottach-Egern;83703,-141,76,Gmund a. Tegernsee;83707,-153,65,Bad Wiessee;83708,-147,72,Kreuth;83714,-139,78,Miesbach;83727,-145,72,Schliersee;83730,-140,75,Fischbachau;83734,-141,76,Hausham;83735,-146,68,Bayrischzell;83737,-138,78,Irschenberg;84028,-125,94,Landshut;84030,-135,88,Ergolding, Landshut;84032,-135,88,Landshut, Linden, Altdorf;84034,-132,91,Landshut;84036,-136,85;84048,-136,88,Mainburg;84051,-134,87,Essenbach;84056,-136,86,Rottenburg a.d. Laaber;84061,-140,85,Ergoldsbach;84066,-138,86,Mallersdorf-Pfaffenberg;84069,-138,87,Schierling;84072,-136,88,Au in der Hallertau;84076,-133,87,Pfeffenhausen;84079,-135,89,Bruckberg;84082,-137,87,Laberweinting;84085,-137,86,Langquaid;84088,-138,86,Neufahrn i. NB;84089,-134,88,Aiglsbach;84091,-136,87,Attenhofen;84092,-138,86,Bayerbach bei Ergoldsbach;84094,-133,89,Elsendorf;84095,-136,88,Furth;84097,-138,85,Herrngiersdorf;84098,-140,85,Hohenthann;84100,-137,85,Niederaichbach;84101,-136,87,Obersüßbach;84103,-136,86,Postau;84104,-137,87,Rudelzhausen;84106,-137,87,Volkenschwand;84107,-138,88,Weihmichl;84109,-136,89,Wörth a.d. Isar;84130,-135,86,Dingolfing;84137,-136,86,Vilsbiburg;84140,-135,83,Gangkofen;84144,-137,86,Geisenhausen;84149,-137,85,Velden;84152,-140,85,Mengkofen;84155,-136,84,Bodenkirchen;84160,-136,85,Frontenhausen;84163,-132,88,Marklkofen;84164,-138,86,Moosthenning;84166,-136,84,Adlkofen;84168,-140,87,Aham;84169,-134,85,Altfraunhofen;84171,-133,86,Baierbach;84172,-138,86,Buch a. Erlbach;84174,-136,89,Eching;84175,-138,86,Gerzen;84177,-136,86,Gottfrieding;84178,-136,83,Kröning;84180,-137,85,Loiching;84181,-134,85,Neufraunhofen;84183,-135,88,Niederviehbach;84184,-136,88,Tiefenbach;84186,-137,86,Vilsheim;84187,-137,87,Weng;84189,-138,84,Wurmsham;84307,-126,88,Eggenfelden;84323,-133,86,Massing;84326,-131,86,Falkenberg;84329,-128,86,Wurmannsquick;84332,-127,88,Hebertsfelden;84333,-130,87,Malgersdorf;84335,-132,87,Mitterskirchen;84337,-128,86,Schönau;84339,-132,87,Unterdietfurt;84347,-126,88,Pfarrkirchen;84359,-122,89,Simbach a. Inn;84364,-125,91,Bad Birnbach;84367,-126,87,Tann;84371,-126,88,Triftern;84375,-122,93,Kirchdorf a. Inn;84378,-125,87,Dietersburg;84381,-128,90,Johanniskirchen;84384,-125,85,Wittibreut;84385,-122,88,Egglham;84387,-126,91,Julbach;84389,-127,89,Postmünster;84405,-133,87,Dorfen;84416,-135,86,Taufkirchen (Vils);84419,-135,85,Schwindegg;84424,-137,84,Isen;84427,-138,82,Sankt Wolfgang;84428,-136,86,Buchbach;84431,-137,84,Heldenstein;84432,-136,84,Hohenpolding;84434,-138,85,Kirchberg;84435,-136,86,Lengdorf;84437,-135,84,Reichertsheim;84439,-137,86,Steinkirchen;84453,-137,87,Mühldorf a. Inn;84478,-135,87,Waldkraiburg;84489,-123,90,Burghausen;84494,-136,84,Neumarkt-Sankt Veit;84503,-131,89,Altötting;84508,-131,87,Burgkirchen an der Alz;84513,-136,88,Töging a. Inn;84518,-135,87,Garching a.d. Alz;84524,-133,87,Neuötting;84529,-129,90,Tittmoning;84533,-131,90,Marktl;84539,-136,87,Ampfing;84543,-133,89,Winhöring;84544,-135,86,Aschau a. Inn;84546,-138,85,Egglkofen;84547,-132,89,Emmerting;84549,-136,85,Engelsberg;84550,-134,85,Feichten a.d. Alz;84552,-136,85,Geratskirchen;84553,-133,86,Halsbach;84555,-137,87,Jettenbach;84556,-133,86,Kastl;84558,-131,86,Kirchweidach;84559,-135,85,Kraiburg a. Inn;84561,-130,90,Mehring;84562,-138,87,Mettenheim;84564,-136,85,Oberbergkirchen;84565,-137,85,Oberneukirchen;84567,-131,85,Erlbach;84568,-136,84,Pleiskirchen;84570,-138,86,Polling;84571,-134,85,Reischach;84573,-136,84,Schönberg;84574,-136,84,Taufkirchen;84576,-136,88,Teising;84577,-137,86,Tüßling;84579,-135,85,Unterneukirchen;85049,-133,90,Ingolstadt;85051,-133,92;85053,-127,94;85055,-123,97;85057,-125,95;85072,-127,91,Eichstätt;85077,-130,92,Manching;85080,-134,90,Gaimersheim;85084,-133,90,Reichertshofen;85088,-130,92,Vohburg a.d. Donau;85092,-130,89,Kösching;85095,-128,87,Denkendorf;85098,-131,91,Großmehring;85101,-130,90,Lenting;85104,-131,91,Pförring;85107,-133,91,Baar-Ebenhausen;85110,-126,90,Kipfenberg;85111,-132,88,Adelschlag;85113,-126,87,Böhmfeld;85114,-133,88,Buxheim;85116,-134,89,Egweil;85117,-134,89,Eitensheim;85119,-132,91,Ernsgaden;85120,-128,88,Hepberg;85122,-127,87,Hitzhofen;85123,-133,91,Karlskron;85125,-127,92,Kinding;85126,-130,92,Münchsmünster;85128,-133,89,Nassenfels;85129,-132,88,Oberdolling;85131,-130,84,Pollenfeld;85132,-133,83,Schernfeld;85134,-128,87,Stammham;85135,-129,88,Titting;85137,-125,91,Walting;85139,-131,89,Wettstetten;85221,-139,88,Dachau;85229,-143,87,Markt Indersdorf;85232,-140,87,Bergkirchen;85235,-141,88,Odelzhausen;85238,-138,88,Petershausen;85241,-138,88,Hebertshausen;85244,-141,87,Röhrmoos;85247,-143,86,Schwabhausen;85250,-142,86,Altomünster;85253,-141,88,Erdweg;85254,-143,87,Sulzemoos;85256,-142,87,Vierkirchen;85258,-141,87,Weichs;85259,-140,87,Sulzemoos;85276,-141,88,Pfaffenhofen a.d. Ilm;85283,-133,89,Wolnzach;85290,-132,91,Geisenfeld;85293,-141,86,Reichertshausen;85296,-135,89,Rohrbach;85298,-142,87,Scheyern;85301,-138,87,Schweitenkirchen;85302,-141,86,Gerolsbach;85304,-142,87,Ilmmünster;85305,-141,87,Jetzendorf;85307,-140,86,Paunzhausen;85309,-136,88,Pörnbach;85354,-135,89,Freising;85356,-135,90;85368,-131,91,Moosburg a.d. Isar;85375,-137,89,Neufahrn b. Freising;85376,-138,87;85386,-136,89,Eching;85391,-136,89,Allershausen;85395,-138,88,Attenkirchen;85399,-136,89,Hallbergmoos;85402,-140,86,Kranzberg;85405,-136,88,Nandlstadt;85406,-136,88,Zolling;85408,-137,86,Gammelsdorf;85410,-136,89,Haag a.d. Amper;85411,-137,89,Hohenkammer;85413,-137,88,Hörgertshausen;85414,-136,90,Kirchdorf a.d. Amper;85416,-136,89,Langenbach;85417,-136,89,Marzling;85419,-136,88,Mauern;85435,-136,88,Erding;85445,-135,89,Oberding;85447,-137,87,Fraunberg;85452,-137,88,Moosinning;85456,-136,90,Wartenberg;85457,-137,86,Wörth;85459,-136,90,Berglern;85461,-136,88,Bockhorn;85462,-136,90,Eitting;85464,-137,87,Finsing;85465,-136,90,Langenpreising;85467,-137,87,Neuching;85469,-137,86,Walpertskirchen;85521,-136,87,Ottobrunn/Riemerli ng;85540,-137,86,Haar;85551,-138,87,Kirchheim b. München;85560,-140,83,Ebersberg;85567,-135,84,Grafing b. München;85570,-137,87,Markt Schwaben;85579,-133,88,Neubiberg;85586,-136,87,Poing;85591,-138,86,Vaterstetten;85598,-138,85,Baldham;85599,-137,85,Parsdorf/Hergoldin g;85604,-139,84,Zorneding;85609,-138,87,Aschheim;85614,-139,84,Kirchseeon;85617,-133,84,Aßling;85622,-136,86,Feldkirchen;85625,-134,84,Glonn;85630,-139,84,Grasbrunn;85635,-141,83,Höhenkirchen-Siegertsbrunn;85640,-139,85,Putzbrunn;85643,-130,85,Steinhöring;85646,-137,86,Anzing;85649,-142,83,Brunnthal;85652,-138,87,Pliening;85653,-139,83,Aying;85656,-138,85,Buch a. Buchrain;85658,-140,82,Egmating;85659,-137,86,Forstern;85661,-136,87,Forstinning;85662,-141,84,Hohenbrunn;85664,-138,84,Hohenlinden;85665,-137,83,Moosach;85667,-140,83,Oberpframmern;85669,-136,86,Pastetten;85716,-138,88,Unterschleißheim;85737,-138,88,Ismaning;85748,-138,89,Garching b. München;85757,-137,88,Karlsfeld;85764,-138,88,Oberschleißheim;85774,-138,88,Unterföhring;85777,-140,87,Fahrenzhausen;85778,-138,88,Haimhausen;86150,-135,91,Augsburg;86152,-133,93;86153,-133,93;86154,-133,93;86156,-135,91;86157,-135,92;86159,-135,91;86161,-141,89;86163,-139,89;86165,-137,91;86167,-140,90;86169,-143,88;86179,-141,86;86199,-142,86;86316,-143,86,Friedberg;86343,-143,87,Königsbrunn;86356,-143,87,Neusäß;86368,-143,87,Gersthofen;86381,-131,86,Krumbach (Schwaben);86391,-141,87,Stadtbergen;86399,-146,85,Bobingen;86405,-137,89,Meitingen;86415,-144,86,Mering;86420,-141,88,Diedorf;86424,-135,89,Dinkelscherben;86438,-144,86,Kissing;86441,-136,89,Zusmarshausen;86444,-143,86,Affing;86447,-145,86,Aindling;86450,-136,88,Altenmünster;86453,-145,86,Dasing;86456,-143,87,Gablingen;86459,-141,87,Gessertshausen;86462,-143,88,Langweid a. Lech;86465,-139,85,Welden;86470,-135,86,Thannhausen;86473,-141,86,Ziemetshausen;86476,-132,86,Neuburg a.d. Kammel;86477,-139,86,Adelsried;86479,-137,88,Aichen;86480,-132,87,Aletshausen;86482,-142,86,Aystetten;86483,-136,88,Balzhausen;86485,-142,87,Biberbach;86486,-141,84,Bonstetten;86488,-130,88,Breitenthal;86489,-130,88,Deisenhausen;86491,-131,87,Ebershausen;86492,-146,85,Egling a.d. Paar;86494,-138,87,Emersacker;86495,-145,84,Eurasburg;86497,-138,88,Horgau;86498,-132,86,Kettershausen;86500,-141,86,Kutzenhausen;86502,-138,86,Laugna;86504,-145,86,Merching;86505,-133,87,Münsterhausen;86507,-145,86,Oberottmarshause n;86508,-143,88,Rehling;86510,-143,86,Ried;86511,-145,86,Schmiechen;86513,-135,85,Ursberg;86514,-137,88,Ustersbach;86517,-145,86,Wehringen;86519,-130,87,Wiesenbach;86529,-137,88,Schrobenhausen;86551,-140,88,Aichach;86554,-138,88,Pöttmes;86556,-139,87,Kühbach;86558,-136,90,Hohenwart;86559,-143,86,Adelzhausen;86561,-138,88,Aresing;86562,-136,89,Berg im Gau;86564,-135,89,Brunnen;86565,-141,87,Gachenbach;86567,-143,86,Hilgertshausen-Tandern;86568,-143,86,Hollenbach;86570,-138,88,Inchenhofen;86571,-135,89,Langenmosen;86573,-145,86,Obergriesbach;86574,-144,85,Petersdorf;86576,-141,86,Schiltberg;86577,-142,87,Sielenbach;86579,-137,89,Waidhofen;86609,-131,91,Donauwörth;86633,-133,90,Neuburg an der Donau;86637,-136,90,Wertingen;86641,-136,89,Rain;86643,-135,90,Rennertshofen;86647,-135,90,Buttenwiesen;86650,-130,89,Wemding;86653,-128,86,Monheim;86655,-133,86,Harburg;86657,-133,87,Bissingen;86660,-132,90,Tapfheim;86663,-133,91,Asbach-Bäumenheim;86666,-137,89,Burgheim;86668,-135,91,Karlshuld;86669,-136,90,Königsmoos;86672,-140,87,Thierhaupten;86673,-135,88,Bergheim;86674,-137,88,Baar;86675,-131,84,Buchdorf;86676,-135,89,Ehekirchen;86678,-137,88,Ehingen;86679,-137,89,Ellgau;86681,-131,87,Fünfstetten;86682,-132,90,Genderkingen;86684,-137,89,Holzheim;86685,-131,88,Huisheim;86687,-131,85,Kaisheim;86688,-135,86,Marxheim;86690,-135,90,Mertingen;86692,-137,89,Münster;86694,-133,90,Niederschönenfeld;86695,-136,90,Nordendorf;86697,-138,87,Oberhausen;86698,-135,90,Oberndorf a.Lech;86700,-129,87,Otting;86701,-135,90,Rohrenfels;86703,-130,85,Rögling;86704,-129,85,Tagmersheim;86706,-133,91,Weichering;86707,-136,88,Westendorf, Kühlenthal;86709,-129,86,Wolferstadt;86720,-130,90,Nördlingen;86732,-128,89,Oettingen i. Bay.;86733,-130,91,Alerheim;86735,-132,85,Amerdingen;86736,-127,88,Auhausen;86738,-130,90,Deiningen;86739,-133,83,Ederheim;86741,-128,90,Ehingen a. Ries;86742,-127,87,Fremdingen;86744,-131,88,Hainsfarth;86745,-131,89,Hohenaltheim;86747,-129,90,Maihingen;86748,-128,88,Marktoffingen;86750,-132,89,Megesheim;86751,-133,84,Mönchsdeggingen;86753,-129,90,Möttingen;86754,-131,90,Munningen;86756,-130,90,Reimlingen;86757,-131,89,Wallerstein;86759,-130,90,Wechingen;86807,-140,84,Buchloe;86825,-141,84,Bad Wörishofen;86830,-147,85,Schwabmünchen;86833,-145,85,Ettringen;86836,-146,85,Untermeitingen;86842,-142,85,Türkheim;86845,-146,86,Großaitingen;86850,-141,87,Fischach;86853,-143,85,Langerringen;86854,-142,85,Amberg;86856,-146,85,Hiltenfingen;86857,-144,85,Hurlach;86859,-140,86,Igling;86860,-141,84,Jengen;86862,-142,85,Lamerdingen;86863,-141,87,Langenneufnach;86865,-140,85,Markt Wald;86866,-143,86,Mickhausen;86868,-142,85,Mittelneufnach;86869,-144,82,Oberostendorf;86871,-141,85,Rammingen;86872,-143,86,Scherstetten;86874,-140,85,Tussenhausen;86875,-140,84,Waal;86877,-142,87,Walkertshofen;86879,-140,85,Wiedergeltingen;86899,-138,87,Landsberg a. Lech;86911,-142,82,Dießen a. Ammersee;86916,-141,86,Kaufering;86919,-140,86,Utting a. Ammersee;86920,-145,79,Denklingen;86922,-139,86,Eresing;86923,-139,85,Finning;86925,-145,80,Fuchstal;86926,-140,85,Greifenberg;86928,-141,83,Hofstetten;86929,-137,86,Penzing;86931,-146,86,Prittriching;86932,-141,83,Pürgen;86934,-146,79,Reichling;86935,-145,80,Rott;86937,-146,84,Scheuring;86938,-140,87,Schondorf a. Ammersee;86940,-139,85,Schwifting;86941,-140,85,Eresing;86943,-143,81,Thaining;86944,-140,84,Unterdießen;86946,-144,81,Vilgertshofen;86947,-141,86,Weil;86949,-139,84,Windach;86956,-141,81,Schongau;86971,-141,81,Peiting;86972,-143,80,Altenstadt;86974,-145,80,Apfeldorf;86975,-144,76,Bernbeuren;86977,-143,77,Burggen;86978,-143,80,Hohenfurch;86980,-141,76,Ingenried;86981,-145,80,Kinsau;86983,-143,77,Lechbruck;86984,-143,77,Prem;86986,-143,79,Schwabbruck;86987,-142,77,Schwabsoien;86989,-141,78,Steingaden;87435,-137,81,Kempten (Allgäu);87437,-142,76;87439,-142,76;87448,-144,74,Waltenhofen;87452,-146,73,Altusried;87459,-152,67,Pfronten;87463,-141,76,Dietmannsried;87466,-150,67,Oy-Mittelberg;87471,-147,72,Durach;87474,-150,68,Buchenberg;87477,-143,74,Sulzberg;87480,-151,65,Weitnau;87484,-146,70,Nesselwang;87487,-151,69,Wiggensbach;87488,-147,70,Betzigau;87490,-150,71,Haldenwang;87493,-140,78,Lauben;87494,-150,72,Rückholz;87496,-148,72,Untrasried;87497,-152,64,Wertach;87499,-148,72,Wildpoldsried;87509,-151,72,Immenstadt im Allgäu;87527,-162,69,Sonthofen;87534,-149,69,Oberstaufen;87538,-163,43,Fischen im Allgäu;87541,-161,62,Bad Hindelang;87544,-160,59,Blaichach;87545,-158,64,Burgberg im Allgäu;87547,-149,70,Missen-Wilhams;87549,-154,68,Rettenberg;87561,-167,65,Oberstdorf;87600,-142,82,Kaufbeuren;87616,-146,76,Marktoberdorf;87629,-147,74,Füssen;87634,-148,72,Obergünzburg;87637,-148,73,Seeg;87640,-143,80,Biessenhofen;87642,-150,70,Halblech;87645,-144,73,Schwangau;87647,-148,73,Unterthingau;87648,-146,75,Aitrang;87650,-143,80,Baisweil;87651,-147,77,Bidingen;87653,-147,75,Eggenthal;87654,-147,76,Friesenried;87656,-145,79,Germaringen;87657,-149,72,Görisried;87659,-148,73,Hopferau;87660,-146,76,Irsee;87662,-148,77,Kaltental;87663,-148,73,Lengenwang;87665,-146,78,Mauerstetten;87666,-144,80,Pforzen;87668,-141,83,Rieden;87669,-144,73,Rieden am Forggensee;87671,-147,74,Ronsberg;87672,-146,74,Roßhaupten;87674,-144,78,Ruderatshofen;87675,-143,74,Stötten am Auerberg;87677,-146,79,Stöttwang;87679,-143,81,Westendorf;87700,-131,84,Memmingen;87719,-135,84,Mindelheim;87724,-143,76,Ottobeuren;87727,-130,87,Babenhausen;87730,-142,76,Bad Grönenbach;87733,-141,80,Markt Rettenbach;87734,-133,83,Benningen;87736,-146,74,Böhen;87737,-132,84,Boos;87739,-133,86,Breitenbrunn;87740,-133,82,Buxheim;87742,-138,82,Apfeltrach;87743,-132,84,Egg an der Günz;87745,-140,84,Eppishausen;87746,-134,84,Erkheim;87748,-129,85,Fellheim;87749,-138,81,Hawangen;87751,-131,84,Heimertingen;87752,-133,83,Holzgünz;87754,-136,83,Kammlach;87755,-133,84,Kirchhaslach;87757,-134,87,Kirchheim in Schwaben;87758,-138,81,Kronburg;87760,-140,80,Lachen;87761,-133,84,Lauben;87763,-140,78,Lautrach;87764,-140,78,Legau;87766,-136,82,Memmingerberg;87767,-136,81,Niederrieden;87769,-133,85,Oberrieden;87770,-133,85,Oberschönegg;87772,-135,86,Pfaffenhausen;87773,-129,86,Pleß;87775,-137,86,Salgen;87776,-139,82,Sontheim;87778,-138,82,Stetten;87779,-133,83,Trunkelsberg;87781,-134,82,Ungerhausen;87782,-143,79,Unteregg;87784,-132,83,Westerheim;87785,-130,86,Winterrieden;87787,-139,79,Wolfertschwenden;87789,-138,81,Woringen;88045,-96,100,Friedrichshafen;88046,-93,102;88048,-97,98;88069,-106,91,Tettnang;88074,-96,98,Meckenbeuren;88079,-97,96,Kressbronn am Bodensee;88085,-97,97,Langenargen;88090,-96,98,Immenstaad am Bodensee;88094,-96,98,Oberteuringen;88097,-97,98,Eriskirch;88099,-111,89,Neukirch;88131,-98,96,Lindau (Bodensee);88138,-103,92,Sigmarszell;88142,-98,97,Wasserburg (Bodensee);88145,-125,84,Hergatz;88147,-105,90,Achberg;88149,-98,97,Nonnenhorn;88161,-138,77,Lindenberg im Allgäu;88167,-143,76,Röthenbach (Allgäu);88171,-129,82,Weiler-Simmerberg;88175,-132,79,Scheidegg;88178,-133,80,Heimenkirch;88179,-144,71,Oberreute;88212,-98,99,Ravensburg;88213,-105,92;88214,-100,95;88239,-124,84,Wangen im Allgäu;88250,-97,101,Weingarten;88255,-101,96,Baienfurt;88260,-133,81,Argenbühl;88263,-119,86,Horgenzell;88267,-134,80,Vogt;88271,-120,85,Wilhelmsdorf;88273,-123,86,Fronreute;88276,-107,92,Berg;88279,-123,85,Amtzell;88281,-127,83,Schlier;88284,-107,92,Wolpertswende;88285,-126,84,Bodnegg;88287,-120,86,Grünkraut;88289,-133,79,Waldburg;88299,-140,79,Leutkirch im Allgäu;88316,-141,77,Isny im Allgäu;88317,-137,81,Aichstetten;88319,-143,77,Aitrach;88326,-124,87,Aulendorf;88339,-131,83,Bad Waldsee;88348,-126,84,Bad Saulgau, Allmannsweiler;88353,-138,80,Kißlegg;88356,-128,81,Ostrach;88361,-125,84,Altshausen;88364,-135,81,Wolfegg;88367,-124,84,Hohentengen;88368,-133,83,Bergatreute;88370,-124,84,Ebenweiler;88371,-128,83,Ebersbach-Musbach;88373,-126,83,Fleischwangen;88374,-130,81,Hoßkirch;88376,-128,82,Königseggwald;88377,-123,84,Riedhausen;88379,-133,81,Unterwaldhausen;88400,-128,89,Biberach an der Riß;88410,-138,79,Bad Wurzach;88416,-133,83,Ochsenhausen;88422,-129,84,Bad Buchau;88427,-128,85,Bad Schussenried;88430,-138,79,Rot an der Rot;88433,-131,86,Schemmerhofen;88436,-135,81,Eberhardzell;88437,-130,86,Maselheim;88441,-130,85,Mittelbiberach;88444,-130,85,Ummendorf;88447,-131,84,Warthausen;88448,-131,83,Attenweiler;88450,-133,83,Berkheim;88451,-128,86,Dettingen an der Iller;88453,-131,84,Erolzheim;88454,-135,81,Hochdorf;88456,-130,85,Ingoldingen;88457,-128,85,Kirchdorf an der Iller;88459,-132,84,Tannheim;88471,-129,89,Laupheim;88477,-131,85,Schwendi;88480,-128,89,Achstetten;88481,-130,85,Balzheim;88483,-130,86,Burgrieden;88484,-129,86,Gutenzell-Hürbel;88486,-129,86,Kirchberg an der Iller;88487,-130,87,Mietingen;88489,-130,87,Wain;88499,-126,86,Riedlingen;88512,-123,86,Mengen;88515,-132,78,Langenenslingen;88518,-124,85,Herbertingen;88521,-128,85,Ertingen;88524,-130,85,Uttenweiler;88525,-128,85,Dürmentingen;88527,-128,85,Unlingen;88529,-129,82,Zwiefalten;88605,-120,84,Meßkirch, Sauldorf;88630,-125,83,Pfullendorf;88631,-122,84,Beuron;88633,-123,83,Heiligenberg;88634,-113,87,Herdwangen-Schönach;88636,-128,82,Illmensee;88637,-129,78,Leibertingen, Buchheim;88639,-123,82,Wald;88662,-108,90,Überlingen;88677,-94,99,Markdorf;88682,-94,99,Salem;88690,-95,99,Uhldingen-Mühlhofen;88693,-104,92,Deggenhausertal;88696,-115,86,Owingen;88697,-95,99,Bermatingen;88699,-98,96,Frickingen;88709,-98,96,Meersburg;88718,-102,94,Daisendorf;88719,-95,98,Stetten;89073,-121,94,Ulm;89075,-125,89;89077,-121,93;89079,-123,90;89081,-127,84;89129,-124,89,Langenau;89134,-128,82,Blaustein;89143,-124,88,Blaubeuren;89150,-135,77,Laichingen;89155,-128,88,Erbach;89160,-130,82,Dornstadt;89165,-130,86,Dietenheim;89168,-127,89,Niederstotzingen;89171,-125,88,Illerkirchberg;89173,-128,82,Lonsee;89174,-128,84,Altheim (Alb);89176,-125,89,Asselfingen;89177,-127,85,Ballendorf;89179,-128,84,Beimerstetten;89180,-130,80,Berghülen;89182,-127,86,Bernstadt;89183,-128,85,Breitingen;89185,-128,88,Hüttisheim;89186,-131,86,Illerrieden;89188,-132,80,Merklingen;89189,-127,85,Neenstetten;89191,-132,80,Nellingen;89192,-125,89,Rammingen;89194,-130,86,Schnürpflingen;89195,-130,87,Staig;89197,-130,82,Weidenstetten;89198,-127,85,Westerstetten;89231,-120,95,Neu-Ulm;89233,-123,90;89250,-124,89,Senden;89257,-125,90,Illertissen;89264,-127,87,Weißenhorn;89269,-126,89,Vöhringen;89275,-123,90,Elchingen;89278,-123,90,Nersingen;89281,-129,85,Altenstadt;89284,-124,89,Pfaffenhofen a.d. Roth;89287,-128,88,Bellenberg;89290,-130,86,Buch;89291,-123,89,Holzheim;89293,-130,84,Kellmünz a.d. Iller;89294,-130,85,Oberroth;89296,-129,86,Osterberg;89297,-128,88,Roggenburg;89299,-131,84,Unterroth;89312,-126,90,Günzburg;89331,-128,89,Burgau;89335,-126,89,Ichenhausen;89340,-123,90,Leipheim;89343,-131,87,Jettingen-Scheppach;89344,-133,89,Aislingen;89346,-126,88,Bibertal;89347,-126,89,Bubesheim;89349,-131,87,Burtenbach;89350,-131,88,Dürrlauingen;89352,-128,88,Ellzee;89353,-134,88,Glött;89355,-132,87,Gundremmingen;89356,-131,87,Haldenwang;89358,-130,87,Kammeltal;89359,-126,90,Kötz;89361,-136,86,Landensberg;89362,-127,90,Offingen;89364,-129,88,Rettenbach;89365,-131,87,Röfingen;89367,-127,88,Waldstetten;89368,-133,88,Winterbach;89407,-135,90,Dillingen a.d. Donau;89415,-131,90,Lauingen (Donau);89420,-135,90,Höchstädt a.d. Donau;89423,-128,90,Gundelfingen a.d. Donau;89426,-132,89,Wittislingen;89428,-130,87,Syrgenstein;89429,-128,88,Bachhagel;89431,-128,90,Bächingen a.d. Brenz;89434,-134,90,Blindheim;89435,-133,88,Finningen;89437,-130,87,Haunsheim;89438,-135,87,Holzheim;89440,-133,86,Lutzingen;89441,-130,88,Medlingen;89443,-133,90,Schwenningen;89446,-131,89,Ziertheim;89447,-130,86,Zöschingen;89518,-123,89,Heidenheim an der Brenz;89520,-132,81;89522,-127,85;89537,-127,89,Giengen an der Brenz;89542,-124,87,Herbrechtingen;89547,-128,83,Gerstetten;89551,-128,83,Königsbronn;89555,-131,82,Steinheim am Albuch;89558,-133,79,Böhmenkirch;89561,-131,86,Dischingen;89564,-130,81,Nattheim;89567,-127,90,Sontheim an der Brenz;89568,-127,90,Hermaringen;89584,-129,87,Ehingen (Donau), Lauterach;89597,-129,87,Munderkingen;89601,-134,78,Schelklingen;89604,-131,85,Allmendingen;89605,-131,84,Altheim;89607,-128,88,Emerkingen;89608,-128,89,Griesingen;89610,-129,88,Oberdischingen;89611,-130,84,Obermarchtal;89613,-130,87,Oberstadion;89614,-129,87,Öpfingen;89616,-129,88,Rottenacker;89617,-130,86,Untermarchtal;89619,-130,88,Unterstadion;90402,-113,106,Nürnberg;90403,-113,106;90408,-122,100;90409,-122,100;90411,-132,94;90419,-121,101;90425,-126,97;90427,-132,94;90429,-122,100;90431,-122,101;90439,-120,102;90441,-121,102;90443,-112,107;90449,-123,100;90451,-127,98;90453,-133,94;90455,-137,93;90459,-112,107;90461,-123,101;90469,-130,96;90471,-127,98;90473,-133,93;90475,-136,90;90478,-123,100;90480,-133,94;90482,-132,94;90489,-112,106;90491,-127,97;90513,-134,94,Zirndorf;90518,-136,88,Altdorf bei Nürnberg;90522,-132,95,Oberasbach;90530,-137,91,Wendelstein;90537,-134,90,Nürnberg-Feucht, Feuchter Forst;90542,-135,91,Eckental;90547,-135,93,Stein;90552,-136,93,Röthenbach an der Pegnitz;90556,-136,92,Cadolzburg;90559,-136,87,Burgthann;90562,-137,90,Heroldsberg;90571,-136,91,Schwaig b. Nürnberg, Behringersdorfer Forst;90574,-134,89,Roßtal;90579,-135,92,Langenzenn;90584,-138,88,Allersberg;90587,-134,93,Veitsbronn;90592,-135,90,Schwarzenbruck;90596,-136,90,Schwanstetten;90599,-132,91,Dietenhofen;90602,-138,87,Pyrbaum;90607,-136,93,Rückersdorf;90610,-135,89,Winkelhaid;90613,-135,93,Großhabersdorf;90614,-135,93,Ammerndorf;90616,-131,90,Neuhof a.d.Zenn;90617,-138,90,Puschendorf;90619,-130,92,Trautskirchen;90762,-118,102,Fürth;90763,-121,101;90765,-130,96;90766,-124,99;90768,-133,94;91052,-123,100,Erlangen;91054,-124,98;91056,-131,94;91058,-132,95;91074,-132,94,Herzogenaurach;91077,-134,91,Neunkirchen a. Brand;91080,-131,94,Uttenreuth, Marloffstein;91083,-128,95,Baiersdorf;91085,-133,92,Weisendorf;91086,-133,93,Aurachtal;91088,-130,95,Bubenreuth;91090,-134,91,Effeltrich;91091,-132,93,Großenseebach;91093,-132,94,Heßdorf;91094,-132,93,Langensendelbach;91096,-132,93,Möhrendorf/Mark;91097,-134,91,Oberreichenbach;91099,-128,94,Poxdorf;91126,-135,90,Schwabach;91154,-137,90,Roth;91161,-137,88,Hilpoltstein;91166,-136,90,Georgensgmünd;91171,-134,88,Greding;91174,-133,91,Spalt;91177,-136,87,Thalmässing;91180,-134,90,Heideck;91183,-136,89,Abenberg;91186,-137,89,Büchenbach;91187,-135,91,Röttenbach;91189,-134,90,Rohr;91207,-136,91,Lauf an der Pegnitz;91217,-136,93,Hersbruck;91220,-138,90,Schnaittach;91224,-142,82,Pommelsbrunn;91227,-135,88,Leinburg;91230,-139,81,Happurg;91233,-137,91,Neunkirchen am Sand;91235,-141,85,Velden/Hartenstein;91236,-140,82,Alfeld;91238,-139,90,Engelthal/Offenhau sen;91239,-137,92,Henfenfeld;91241,-142,83,Kirchensittenbach;91242,-138,91,Ottensoos;91244,-137,88,Reichenschwand;91245,-141,82,Simmelsdorf;91247,-143,83,Vorra;91249,-143,84,Weigendorf;91257,-139,83,Pegnitz;91275,-138,85,Auerbach i.d. OPf.;91278,-136,87,Pottenstein;91281,-141,78,Kirchenthumbach;91282,-141,81,Betzenstein;91284,-138,87,Neuhaus a.d. Pegnitz;91286,-140,81,Obertrubach;91287,-142,84,Plech;91289,-140,82,Schnabelwaid;91301,-126,95,Forchheim;91315,-128,93,Höchstadt a.d. Aisch;91320,-136,87,Ebermannstadt;91322,-139,83,Gräfenberg;91325,-130,93,Adelsdorf;91327,-141,82,Gößweinstein;91330,-131,92,Eggolsheim;91332,-136,86,Heiligenstadt i. OFr.;91334,-133,92,Hemhofen;91336,-133,91,Heroldsbach;91338,-135,87,Igensdorf;91341,-132,93,Röttenbach;91344,-140,84,Waischenfeld;91346,-140,84,Wiesenttal;91347,-135,81,Aufseß;91349,-138,87,Egloffstein;91350,-130,93,Gremsdorf;91352,-132,93,Hallerndorf;91353,-130,94,Hausen;91355,-142,80,Hiltpoltstein;91356,-137,88,Kirchehrenbach;91358,-134,91,Kunreuth;91359,-141,81,Leutenbach;91361,-130,92,Pinzberg;91362,-133,90,Pretzfeld;91364,-137,87,Unterleinleiter;91365,-133,91,Weilersbach;91367,-136,87,Weißenohe;91369,-133,91,Wiesenthau;91413,-124,94,Neustadt a.d. Aisch;91438,-123,95,Bad Windsheim;91443,-128,91,Scheinfeld;91448,-135,92,Emskirchen;91452,-133,91,Wilhermsdorf;91456,-128,94,Diespeck;91459,-133,89,Markt Erlbach;91460,-124,93,Baudenbach;91462,-129,94,Dachsbach;91463,-126,93,Dietersheim;91465,-122,92,Ergersheim;91466,-131,93,Gerhardshofen;91468,-133,90,Gutenstetten;91469,-135,89,Hagenbüchach;91471,-126,93,Illesheim;91472,-123,93,Ipsheim;91474,-123,94,Langenfeld;91475,-129,93,Lonnerstadt;91477,-123,93,Markt Bibart;91478,-125,93,Markt Nordheim;91480,-132,89,Markt Taschendorf;91481,-133,90,Münchsteinach;91483,-123,92,Oberscheinfeld;91484,-124,92,Sugenheim;91486,-131,93,Uehlfeld;91487,-131,91,Vestenbergsgreuth;91489,-135,91,Wilhelmsdorf;91522,-130,91,Ansbach;91541,-123,91,Rothenburg ob der Tauber;91550,-128,87,Dinkelsbühl;91555,-128,89,Feuchtwangen;91560,-134,89,Heilsbronn;91564,-136,88,Neuendettelsau;91567,-127,90,Herrieden;91572,-131,87,Bechhofen;91575,-135,89,Windsbach;91578,-131,87,Leutershausen;91580,-135,87,Petersaurach;91583,-128,89,Schillingsfürst;91586,-133,88,Lichtenau;91587,-123,91,Adelshofen;91589,-131,85,Aurach;91590,-132,90,Bruckberg;91592,-129,89,Buch a. Wald;91593,-123,94,Burgbernheim;91595,-130,87,Burgoberbach;91596,-129,87,Burk;91598,-132,85,Colmberg;91599,-130,87,Dentlein a. Forst;91601,-129,87,Dombühl;91602,-129,86,Dürrwangen;91604,-131,86,Flachslanden;91605,-124,91,Gallmersgarten;91607,-123,92,Gebsattel;91608,-129,89,Geslau;91610,-124,91,Insingen;91611,-131,89,Lehrberg;91613,-124,92,Marktbergel;91614,-126,88,Mönchsroth;91616,-127,88,Neusitz;91617,-130,89,Oberdachstetten;91619,-128,91,Obernzenn;91620,-123,91,Ohrenbach;91622,-133,89,Rügland;91623,-132,90,Sachsen b. Ansbach;91625,-128,88,Schnelldorf;91626,-129,86,Schopfloch;91628,-125,91,Steinsfeld;91629,-132,90,Weihenzell;91631,-125,91,Wettringen;91632,-129,88,Wieseth;91634,-126,88,Wilburgstetten;91635,-128,89,Windelsbach;91637,-128,88,Wörnitz;91639,-135,88,Wolframs-Eschenbach;91710,-131,91,Gunzenhausen;91717,-131,87,Wassertrüdingen;91719,-133,82,Heidenheim;91720,-137,86,Absberg;91722,-132,86,Arberg;91723,-132,90,Dittenheim;91725,-130,86,Ehingen;91726,-127,89,Gerolfingen;91728,-131,87,Gnotzheim;91729,-136,88,Haundorf;91731,-128,87,Langfurth;91732,-134,89,Merkendorf;91734,-134,89,Mitteleschenbach;91735,-133,91,Muhr a. See;91737,-133,91,Ornbau;91738,-135,89,Pfofeld;91740,-129,88,Röckingen;91741,-134,88,Theilenhofen;91743,-130,89,Unterschwaningen;91744,-126,89,Weiltingen;91746,-133,88,Weidenbach;91747,-128,88,Westheim;91749,-127,87,Wittelshofen;91757,-133,85,Treuchtlingen;91781,-137,84,Weißenburg i. Bay.;91785,-136,91,Pleinfeld;91788,-135,86,Pappenheim;91790,-133,84,Nennslingen;91792,-133,90,Ellingen;91793,-131,92,Alesheim;91795,-131,89,Dollnstein;91796,-136,88,Ettenstatt;91798,-132,92,Höttingen;91799,-133,85,Langenaltheim;91801,-133,90,Markt Berolzheim;91802,-133,90,Meinheim;91804,-131,84,Mörnsheim;91805,-131,83,Polsingen;91807,-133,90,Solnhofen;91809,-133,88,Wellheim;92224,-136,93,Amberg;92237,-140,87,Sulzbach-Rosenberg;92242,-138,85,Hirschau;92245,-144,86,Kümmersbruck;92249,-139,86,Vilseck;92253,-134,84,Schnaittenbach;92256,-143,86,Hahnbach;92259,-144,82,Neukirchen b. Sulzbach-Rosen;92260,-145,84,Ammerthal;92262,-141,79,Birgland;92263,-145,85,Ebermannsdorf;92265,-143,80,Edelsfeld;92266,-144,85,Ensdorf;92268,-142,82,Etzelwang;92269,-143,87,Fensterbach;92271,-137,83,Freihung;92272,-146,84,Freudenberg;92274,-143,83,Gebenbach;92275,-143,85,Hirschbach;92277,-142,86,Hohenburg;92278,-145,82,Illschwang;92280,-141,85,Kastl;92281,-143,81,Königstein;92283,-139,79,Lauterhofen;92284,-144,86,Poppenricht;92286,-143,85,Rieden;92287,-141,89,Schmidmühlen;92289,-144,80,Ursensollen;92318,-130,90,Neumarkt i.d. OPf.;92331,-137,85,Parsberg;92334,-135,83,Berching;92339,-130,87,Beilngries;92342,-136,89,Freystadt;92345,-129,92,Dietfurt a.d. Altmühl;92348,-136,85,Berg b. Neumarkt i. d. OPf.;92353,-137,86,Postbauer-Heng;92355,-143,80,Velburg;92358,-138,82,Seubersdorf i.d. OPf.;92360,-136,89,Mühlhausen;92361,-137,88,Berngau;92363,-136,86,Breitenbrunn;92364,-137,82,Deining;92366,-143,84,Hohenfels;92367,-143,78,Pilsach;92369,-136,88,Sengenthal;92421,-136,91,Schwandorf;92431,-140,83,Neunburg vorm Wald;92436,-137,89,Bruck i.d. OPf.;92439,-140,86,Bodenwöhr;92442,-143,86,Wackersdorf;92444,-138,82,Rötz;92445,-137,79,Neukirchen-Balbini;92447,-139,87,Schwarzhofen;92449,-141,87,Steinberg;92507,-140,86,Nabburg;92521,-140,89,Schwarzenfeld;92526,-137,76,Oberviechtach;92533,-135,87,Wernberg-Köblitz;92536,-138,86,Pfreimd;92539,-140,73,Schönsee;92540,-141,83,Altendorf;92542,-141,81,Dieterskirchen;92543,-140,82,Guteneck;92545,-141,82,Niedermurach;92546,-144,84,Schmidgaden;92548,-142,81,Schwarzach b. Nabburg;92549,-144,70,Stadlern;92551,-142,87,Stulln;92552,-139,79,Teunz;92554,-138,81,Thanstein;92555,-137,82,Trausnitz;92557,-143,71,Weiding;92559,-137,79,Winklarn;92637,-128,89,Weiden in der OPf., Theisseil;92648,-137,77,Vohenstrauß;92655,-142,80,Grafenwöhr;92660,-133,86,Neustadt a.d. Waldnaab;92665,-138,81,Altenstadt a.d. Waldnaab;92670,-139,82,Windischeschenba ch;92676,-137,84,Eschenbach i.d. OPf.;92681,-139,78,Erbendorf;92685,-140,80,Floß;92690,-140,79,Pressath;92693,-135,79,Eslarn;92694,-133,86,Etzenricht;92696,-145,70,Flossenbürg;92697,-143,73,Georgenberg;92699,-133,84,Bechtsried;92700,-138,82,Kaltenbrunn;92702,-135,83,Kohlberg;92703,-140,80,Krummennaab;92705,-137,81,Leuchtenberg;92706,-133,85,Luhe-Wildenau;92708,-133,84,Mantel;92709,-137,77,Moosbach;92711,-141,80,Parkstein;92712,-133,84,Pirk;92714,-136,79,Pleystein;92715,-138,82,Püchersreuth;92717,-140,80,Reuth b. Erbendorf;92718,-133,85,Schirmitz;92720,-135,84,Schwarzenbach;92721,-137,83,Störnstein;92723,-139,76,Tännesberg;92724,-137,83,Trabitz;92726,-138,77,Waidhaus;92727,-138,78,Waldthurn;92729,-133,84,Weiherhammer;93047,-118,100,Regensburg;93049,-128,94;93051,-126,93;93053,-133,88;93055,-132,91;93057,-133,87;93059,-130,88;93073,-136,91,Neutraubling;93077,-137,88,Bad Abbach;93080,-137,85,Pentling;93083,-137,88,Obertraubling;93086,-138,86,Wörth an der Donau;93087,-137,88,Alteglofsheim;93089,-137,87,Aufhausen;93090,-136,90,Bach an der Donau;93092,-136,90,Barbing;93093,-138,87,Donaustauf;93095,-139,87,Hagelstadt;93096,-138,89,Köfering;93098,-135,90,Mintraching;93099,-137,90,Mötzing;93101,-136,88,Pfakofen;93102,-133,90,Pfatter;93104,-137,89,Sünching;93105,-134,90,Tegernheim;93107,-138,87,Thalmassing;93109,-140,83,Wiesent;93128,-140,86,Regenstauf;93133,-144,86,Burglengenfeld;93138,-138,86,Lappersdorf;93142,-141,87,Maxhütte-Haidhof;93149,-138,88,Nittenau;93152,-135,83,Nittendorf;93155,-137,84,Hemau;93158,-139,89,Teublitz;93161,-137,88,Sinzing;93164,-135,83,Laaber, Brunn;93167,-135,78,Falkenstein;93170,-138,84,Bernhardswald;93173,-138,88,Wenzenbach;93176,-137,83,Beratzhausen;93177,-135,83,Altenthann;93179,-138,78,Brennberg;93180,-135,85,Deuerling;93182,-136,84,Duggendorf;93183,-141,87,Kallmünz;93185,-140,73,Michelsneukirchen;93186,-136,85,Pettendorf;93188,-135,85,Pielenhofen;93189,-139,87,Reichenbach;93191,-140,75,Rettenbach;93192,-138,80,Wald;93194,-139,87,Walderbach;93195,-140,85,Wolfsegg;93197,-137,89,Zeitlarn;93199,-138,82,Zell;93309,-133,90,Kelheim;93326,-133,88,Abensberg;93333,-131,92,Neustadt a.d. Donau;93336,-133,88,Altmannstein;93339,-131,90,Riedenburg;93342,-135,88,Saal a.d. Donau;93343,-134,86,Essing;93345,-136,89,Hausen;93346,-138,83,Ihrlerstein;93348,-134,87,Kirchdorf;93349,-132,89,Mindelstetten;93351,-139,82,Painten;93352,-137,86,Rohr i. NB;93354,-133,89,Siegenburg;93356,-138,86,Teugn;93358,-133,89,Train;93359,-134,88,Wildenberg;93413,-132,88,Cham;93426,-137,87,Roding;93437,-132,86,Furth i. Wald;93444,-135,84,Kötzting;93449,-138,78,Waldmünchen;93453,-133,77,Neukirchen b. Hl. Blut;93455,-138,83,Traitsching;93458,-132,83,Eschlkam;93462,-135,75,Lam;93464,-137,79,Tiefenbach;93466,-136,78,Chamerau;93468,-136,84,Miltach;93470,-137,71,Lohberg;93471,-133,76,Arnbruck;93473,-134,83,Arnschwang;93474,-137,73,Arrach;93476,-135,84,Blaibach;93477,-136,82,Gleißenberg;93479,-135,84,Grafenwiesen;93480,-133,78,Hohenwarth;93482,-136,85,Pemfling;93483,-133,88,Pösing;93485,-133,77,Rimbach;93486,-135,85,Runding;93488,-136,82,Schönthal;93489,-135,86,Schorndorf;93491,-138,84,Stamsried;93492,-136,77,Treffelstein;93494,-137,82,Waffenbrunn;93495,-133,86,Weiding;93497,-135,86,Willmering;93499,-137,77,Zandt;94032,-109,98,Passau;94034,-118,89;94036,-118,92;94051,-123,86,Hauzenberg;94060,-122,94,Pocking;94065,-125,83,Waldkirchen;94072,-122,94,Bad Füssing;94078,-135,74,Freyung;94081,-119,90,Fürstenzell;94086,-123,86,Griesbach i. Rottal;94089,-140,70,Neureichenau;94094,-123,89,Rotthalmünster;94099,-121,90,Ruhstorf a.d. Rott;94104,-120,86,Tittling;94107,-125,83,Untergriesbach;94110,-131,76,Wegscheid;94113,-120,89,Tiefenbach;94116,-121,86,Hutthurm;94118,-131,76,Jandelsbrunn;94121,-119,88,Salzweg;94124,-121,88,Büchlberg;94127,-120,89,Neuburg a. Inn;94130,-125,83,Obernzell;94133,-123,85,Röhrnbach;94136,-119,89,Thyrnau;94137,-123,91,Bayerbach;94139,-135,73,Breitenberg;94140,-123,91,Ering;94142,-123,85,Fürsteneck;94143,-141,65,Grainet;94145,-142,65,Haidmühle;94146,-146,64,Hinterschmiding;94148,-122,93,Kirchham;94149,-125,88,Kößlarn;94151,-146,64,Mauth;94152,-121,94,Neuhaus a. Inn;94154,-123,86,Neukirchen vorm Wald;94157,-126,82,Perlesreut;94158,-148,58,Philippsreut;94160,-122,85,Ringelai;94161,-121,87,Ruderting;94163,-126,82,Saldenburg;94164,-143,65,Sonnen;94166,-123,86,Stubenberg;94167,-123,92,Tettenweis;94169,-123,85,Thurmansbang;94209,-138,74,Regen;94227,-141,70,Zwiesel;94234,-135,79,Viechtach;94239,-141,71,Zachenberg;94244,-137,74,Teisnach;94249,-141,66,Bodenmais;94250,-141,66,Achslach;94252,-145,64,Bayerisch Eisenstein;94253,-139,68,Bischofsmais;94255,-141,71,Böbrach;94256,-141,71,Drachselsried;94258,-141,67,Frauenau;94259,-137,70,Kirchberg;94261,-136,71,Kirchdorf i. Wald;94262,-133,80,Kollnburg;94264,-138,73,Langdorf;94265,-133,77,Patersdorf;94267,-138,74,Prackenbach;94269,-138,73,Rinchnach;94315,-129,95,Straubing;94327,-137,90,Bogen;94330,-138,90,Aiterhofen;94333,-136,88,Geiselhöring;94336,-137,90,Hunderdorf;94339,-139,87,Leiblfing;94342,-138,90,Straßkirchen;94344,-141,73,Wiesenfelden;94345,-137,90,Aholfing;94347,-136,89,Ascha;94348,-138,90,Atting;94350,-139,82,Falkenfels;94351,-138,89,Feldkirchen;94353,-136,80,Haibach;94354,-136,84,Haselbach;94356,-137,90,Kirchroth;94357,-136,77,Konzell;94359,-136,85,Loitzendorf;94360,-136,85,Mitterfels;94362,-138,82,Neukirchen;94363,-139,87,Oberschneiding;94365,-138,91,Parkstetten;94366,-137,83,Perasdorf;94368,-138,90,Perkam;94369,-138,90,Rain;94371,-140,72,Rattenberg;94372,-138,84,Rattiszell;94374,-136,84,Schwarzach;94375,-136,85,Stallwang;94377,-138,90,Steinach;94379,-145,67,Sankt Englmar;94405,-136,86,Landau a.d. Isar;94419,-132,86,Reisbach;94424,-130,86,Arnstorf;94428,-131,89,Eichendorf;94431,-136,89,Pilsting;94436,-132,85,Simbach;94437,-136,86,Mamming;94439,-126,86,Roßbach;94447,-133,91,Plattling;94469,-131,91,Deggendorf;94474,-123,91,Vilshofen an der Donau;94481,-131,75,Grafenau;94486,-133,91,Osterhofen;94491,-133,90,Hengersberg;94496,-122,92,Ortenburg;94501,-125,92,Aldersbach;94505,-138,78,Bernried;94508,-125,85,Schöllnach;94513,-124,83,Schönberg;94518,-147,64,Spiegelau;94522,-136,90,Wallersdorf;94526,-135,91,Metten;94527,-136,91,Aholming;94529,-120,90,Aicha vorm Wald;94530,-134,90,Auerbach;94532,-125,89,Außernzell;94533,-135,90,Buchhofen;94535,-122,88,Eging a. See;94536,-135,72,Eppenschlag;94538,-123,84,Fürstenstein;94539,-141,71,Grafling;94541,-133,77,Grattersdorf;94542,-121,90,Haarbach;94544,-123,86,Hofkirchen;94545,-138,70,Hohenau;94547,-123,86,Iggensbach;94548,-132,74,Innernzell;94550,-130,90,Künzing;94551,-127,85,Lalling;94553,-137,91,Mariaposching;94554,-134,91,Moos;94556,-148,64,Neuschönau;94557,-134,92,Niederalteich;94559,-137,91,Niederwinkling;94560,-137,89,Offenberg;94562,-136,90,Oberpöring;94563,-137,90,Otzing;94566,-140,67,Riedlhütte;94568,-142,66,Sankt Oswald;94569,-137,90,Stephansposching;94571,-133,82,Schaufling;94572,-142,66,Schöfweg;94574,-135,89,Wallerfing;94575,-121,88,Windorf;94577,-131,92,Winzer;94579,-123,85,Zenting;95028,-146,78,Hof;95030,-150,73;95032,-149,74;95100,-143,75,Selb;95111,-148,75,Rehau;95119,-148,71,Naila;95126,-146,76,Schwarzenbach a. d. Saale;95131,-145,72,Schwarzenbach a. Wald;95138,-146,73,Bad Steben;95145,-147,77,Oberkotzau;95152,-148,74,Selbitz;95158,-146,72,Kirchenlamitz;95163,-143,72,Weißenstadt;95168,-142,76,Marktleuthen;95173,-149,69,Schönwald;95176,-149,74,Konradsreuth;95179,-146,72,Geroldsgrün;95180,-150,71,Berg;95182,-148,77,Döhlau;95183,-150,74,Feilitzsch;95185,-151,73,Gattendorf;95186,-145,73,Höchstädt;95188,-148,72,Issigau;95189,-150,73,Köditz;95191,-148,71,Leupoldsgrün;95192,-148,74,Lichtenberg;95194,-148,76,Regnitzlosau;95195,-143,75,Röslau;95197,-146,76,Schauenstein;95199,-144,76,Thierstein;95213,-146,76,Münchberg;95233,-148,68,Helmbrechts;95234,-145,73,Sparneck;95236,-145,73,Stammbach;95237,-146,76,Weißdorf;95239,-146,70,Zell;95326,-123,88,Kulmbach;95336,-123,90,Mainleus;95339,-126,86,Neuenmarkt;95346,-128,85,Stadtsteinach;95349,-130,83,Thurnau;95352,-141,76,Marktleugast;95355,-144,72,Presseck;95356,-143,75,Grafengehaig;95358,-136,79,Guttenberg;95359,-128,84,Kasendorf;95361,-124,87,Ködnitz;95362,-140,77,Kupferberg;95364,-126,86,Ludwigschorgast;95365,-128,84,Rugendorf;95367,-133,82,Trebgast;95369,-131,83,Untersteinach;95444,-113,99,Bayreuth;95445,-120,93;95447,-124,91;95448,-130,87;95460,-132,84,Bad Berneck im Fichtelgebirge;95463,-128,87,Bindlach;95466,-140,81,Weidenberg, Kirchenpingarten;95469,-138,82,Speichersdorf;95473,-137,83,Creußen;95478,-138,81,Kemnath;95482,-141,79,Gefrees;95485,-140,75,Warmensteinach;95488,-132,83,Eckersdorf;95490,-132,85,Mistelgau;95491,-137,84,Ahorntal;95493,-145,70,Bischofsgrün;95494,-133,85,Gesees;95496,-133,84,Glashütten;95497,-141,77,Goldkronach;95499,-127,87,Harsdorf;95500,-126,88,Heinersreuth;95502,-126,87,Himmelkron;95503,-137,81,Hummeltal;95505,-143,71,Immenreuth;95506,-139,81,Kastl;95508,-143,75,Kulmain;95509,-136,79,Marktschorgast;95511,-133,85,Mistelbach;95512,-126,88,Neudrossenfeld;95514,-139,80,Neustadt a. Kulm;95515,-133,87,Plankenfels;95517,-137,83,Emtmannsberg;95519,-138,83,Vorbach;95615,-142,78,Marktredwitz;95632,-142,77,Wunsiedel;95643,-142,79,Tirschenreuth;95652,-146,80,Waldsassen;95659,-146,78,Arzberg;95666,-145,79,Mitterteich;95671,-141,76,Bärnau;95676,-143,79,Wiesau;95679,-142,75,Waldershof;95680,-145,72,Bad Alexandersbad;95682,-142,74,Brand;95683,-142,77,Ebnath;95685,-141,79,Falkenberg;95686,-144,70,Fichtelberg;95688,-143,72,Friedenfels;95689,-145,70,Fuchsmühl;95691,-146,74,Hohenberg a.d. Eger;95692,-145,75,Konnersreuth;95694,-143,73,Mehlmeisel;95695,-145,73,Mähring;95697,-143,72,Nagel;95698,-146,78,Neualbenreuth;95700,-143,73,Neusorg;95701,-144,77,Pechbrunn;95703,-140,77,Plößberg;95704,-143,72,Pullenreuth;95706,-148,78,Schirnding;95707,-144,76,Thiersheim;95709,-143,72,Tröstau;96047,-127,96,Bamberg;96049,-133,89;96050,-137,92;96052,-127,96;96103,-135,93,Hallstadt;96106,-120,90,Ebern;96110,-128,89,Scheßlitz;96114,-135,93,Hirschaid;96117,-132,92,Memmelsdorf;96120,-132,90,Bischberg;96123,-131,87,Litzendorf;96126,-123,84,Maroldsweisach;96129,-131,88,Strullendorf;96132,-130,89,Schlüsselfeld;96135,-133,92,Stegaurach;96138,-131,92,Burgebrach;96142,-130,85,Hollfeld;96145,-120,88,Seßlach;96146,-133,92,Altendorf;96148,-126,88,Baunach;96149,-133,91,Breitengüßbach;96151,-122,89,Breitbrunn;96152,-127,92,Burghaslach;96154,-127,90,Burgwindheim;96155,-136,84,Buttenheim;96157,-123,91,Ebrach;96158,-133,91,Frensdorf;96160,-130,89,Geiselwind;96161,-124,89,Gerach;96163,-135,92,Gundelsheim;96164,-135,92,Kemmern;96166,-124,87,Kirchlauter;96167,-131,81,Königsfeld;96169,-128,89,Lauter;96170,-125,92,Lisberg;96172,-131,91,Mühlhausen;96173,-131,91,Oberhaid;96175,-137,92,Pettstadt;96176,-121,89,Pfarrweisach;96178,-130,92,Pommersfelden;96179,-127,91,Rattelsdorf;96181,-126,88,Rauhenebrach;96182,-128,92,Reckendorf;96184,-124,90,Rentweinsdorf;96185,-126,92,Schönbrunn i. Steigerwald;96187,-131,81,Stadelhofen;96188,-131,92,Stettfeld;96190,-121,90,Untermerzbach;96191,-132,92,Viereth-Trunstadt;96193,-128,92,Wachenroth;96194,-128,90,Walsdorf;96196,-130,80,Wattendorf;96197,-131,81,Wonsees;96199,-130,91,Zapfendorf;96215,-120,91,Lichtenfels;96224,-126,85,Burgkunstadt;96231,-122,88,Staffelstein;96237,-121,87,Ebersdorf b. Coburg;96242,-123,85,Sonnefeld;96247,-120,91,Michelau i. OFr.;96250,-127,91,Ebensfeld;96253,-118,91,Untersiemau;96257,-120,91,Redwitz a.d. Rodach;96260,-128,81,Weismain;96264,-121,90,Altenkunstadt;96268,-121,88,Mitwitz;96269,-120,88,Großheirath;96271,-121,88,Grub a. Forst;96272,-121,88,Hochstadt a. Main;96274,-120,91,Itzgrund;96275,-121,91,Marktzeuln;96277,-120,88,Schneckenlohe;96279,-121,89,Weidhausen b. Coburg;96317,-127,85,Kronach;96328,-121,90,Küps;96332,-126,84,Pressig;96337,-143,74,Ludwigsstadt;96342,-122,87,Stockheim;96346,-137,78,Wallenfels;96349,-137,77,Steinwiesen;96352,-138,75,Wilhelmsthal;96355,-151,66,Tettau;96358,-143,73,Teuschnitz;96361,-144,73,Steinbach a. Wald;96364,-127,83,Marktrodach;96365,-137,79,Nordhalben;96367,-143,74,Tschirn;96369,-125,85,Weißenbrunn;96450,-110,96,Coburg;96465,-120,88,Neustadt b. Coburg;96472,-123,86,Rödental;96476,-118,89,Rodach b. Coburg;96479,-118,90,Weitramsdorf;96482,-120,88,Ahorn;96484,-121,86,Meeder;96486,-128,81,Lautertal;96487,-118,90,Dörfles-Esbach;96489,-118,91,Niederfüllbach;96515,-145,70,Sonneberg, Judenbach;96523,-137,76,Steinach;96524,-122,87,Neuhaus-Schierschnitz;96528,-126,83,Frankenblick, Schalkau, Bachfeld;97070,-101,108,Würzburg;97072,-104,106;97074,-112,99;97076,-112,99;97078,-114,98;97080,-110,101;97082,-113,98;97084,-113,99;97199,-115,97,Ochsenfurt;97204,-113,97,Höchberg;97209,-115,97,Veitshöchheim;97215,-121,94,Uffenheim;97218,-116,96,Gerbrunn;97222,-117,92,Rimpar;97225,-113,95,Zellingen;97228,-114,98,Rottendorf;97230,-114,97,Estenfeld;97232,-115,96,Giebelstadt;97234,-116,96,Reichenberg, Guttenberger Wald;97236,-116,96,Randersacker;97237,-113,97,Altertheim;97239,-115,97,Aub;97241,-115,96,Bergtheim, Oberpleichfeld;97243,-116,96,Bieberehren;97244,-116,96,Bütthard;97246,-111,101,Eibelstadt;97247,-114,97,Eisenheim;97249,-116,93,Eisingen;97250,-116,94,Erlabrunn;97252,-116,96,Frickenhausen;97253,-113,98,Gaukönigshofen;97255,-116,96,Gelchsheim, Sonderhofen;97256,-116,95,Geroldshausen;97258,-118,94,Ippesheim;97259,-118,91,Greußenheim;97261,-114,97,Güntersleben;97262,-114,94,Hausen b. Würzburg;97264,-114,95,Helmstadt;97265,-115,94,Hettstadt;97267,-113,96,Himmelstadt;97268,-116,96,Kirchheim;97270,-118,92,Kist, Irtenberger Wald;97271,-116,94,Kleinrinderfeld;97273,-115,97,Kürnach;97274,-115,94,Leinach;97276,-115,94,Margetshöchheim;97277,-114,95,Neubrunn;97279,-116,96,Prosselsheim;97280,-113,95,Remlingen;97282,-114,94,Retzstadt;97283,-117,94,Riedenheim;97285,-115,97,Röttingen, Tauberrettersheim;97286,-111,102,Winterhausen;97288,-116,96,Theilheim;97289,-111,97,Thüngen;97291,-115,94,Thüngershem;97292,-110,98,Üttingen, Holzkirchen;97294,-116,96,Unterpleichfeld;97295,-114,95,Waldbrunn, Irtenberger Wald;97297,-114,95,Waldbüttelbrunn;97299,-114,97,Zell a. Main;97318,-113,99,Kitzingen;97320,-111,101,Albertshofen;97332,-113,99,Volkach;97334,-116,95,Sommerach;97337,-116,96,Dettelbach;97340,-115,96,Marktbreit;97342,-114,97,Obernbreit;97346,-118,95,Iphofen;97348,-114,98,Rödelsee;97350,-114,98,Mainbernheim;97353,-115,96,Wiesentheid;97355,-116,96,Kleinlangheim;97357,-115,96,Prichsenstadt;97359,-113,99,Schwarzach a. Main;97421,-107,100,Schweinfurt;97422,-113,94;97424,-108,101;97437,-122,94,Haßfurt;97440,-115,95,Werneck;97447,-115,96,Gerolzhofen;97450,-113,93,Arnstein;97453,-116,87,Schonungen;97456,-116,87,Dittelbrunn;97461,-119,92,Hofheim i. UFr.;97464,-113,96,Niederwerrn;97469,-116,95,Gochsheim;97475,-121,89,Zeil a. Main;97478,-121,92,Knetzgau;97483,-126,87,Eltmann;97486,-121,88,Königsberg i. Bay.;97488,-116,90,Stadtlauringen;97490,-113,93,Poppenhausen;97491,-117,90,Aidhausen;97493,-114,97,Bergrheinfeld;97494,-118,89,Bundorf;97496,-120,90,Burgpreppach;97497,-117,94,Dingolshausen;97499,-118,94,Donnersdorf;97500,-123,90,Ebelsbach;97502,-115,91,Euerbach;97503,-118,90,Gädheim;97505,-113,96,Geldersheim;97506,-115,97,Grafenrheinfeld;97508,-117,94,Grettstadt;97509,-115,96,Kolitzheim;97511,-116,96,Lülsfeld;97513,-119,88,Michelau i. Steigerwald, Hundelshausen;97514,-130,85,Oberaurach;97516,-118,93,Oberschwarzach;97517,-115,88,Rannungen;97519,-120,90,Riedbach;97520,-114,97,Röthlein;97522,-121,90,Sand a. Main;97523,-114,96,Schwanfeld;97525,-115,96,Schwebheim;97526,-115,96,Sennfeld;97528,-118,88,Sulzdorf a.d. Lederhecke;97529,-116,96,Sulzheim;97531,-120,91,Theres;97532,-117,87,Üchtelhausen;97534,-114,96,Waigolshausen;97535,-114,91,Wasserlosen;97537,-113,98,Wipfeld;97539,-122,94,Wonfurt;97616,-109,94,Bad Neustadt an der Saale;97618,-110,93,Hohenroth;97631,-116,89,Bad Königshofen i. Grabfeld;97633,-113,91,Sulzfeld;97638,-113,91,Mellrichstadt;97640,-113,90,Oberstreu;97645,-122,84,Ostheim v.d. Rhön;97647,-123,84,Nordheim v.d. Rhön;97650,-127,83,Fladungen;97653,-123,82,Bischofsheim a.d. Rhön;97654,-118,88,Bastheim;97656,-135,75,Oberelsbach;97657,-123,85,Sandberg;97659,-121,82,Schönau a.d. Brend;97688,-108,94,Bad Kissingen;97702,-117,87,Münnerstadt;97705,-123,83,Burkardroth;97708,-108,94,Bad Bocklet;97711,-114,89,Maßbach;97714,-113,89,Oerlenbach;97717,-108,94,Euerdorf;97720,-111,91,Nüdlingen;97723,-113,89,Oberthulba;97724,-113,88,Burglauer;97725,-108,94,Elfershausen;97727,-113,90,Fuchsstadt;97729,-115,88,Ramsthal;97737,-110,99,Gemünden a. Main;97753,-115,93,Karlstadt;97762,-112,91,Hammelburg;97769,-119,89,Bad Brückenau;97772,-136,70,Wildflecken;97773,-120,84,Aura i. Sinngrund;97775,-110,96,Burgsinn;97776,-110,98,Eußenheim;97778,-114,91,Fellen;97779,-129,76,Geroda;97780,-109,99,Gössenheim;97782,-112,93,Gräfendorf;97783,-112,96,Karsbach;97785,-113,93,Mittelsinn;97786,-124,81,Motten;97788,-123,85,Neuendorf;97789,-120,84,Oberleichtersbach;97791,-116,90,Obersinn;97792,-134,73,Riedenberg;97794,-116,90,Rieneck;97795,-120,85,Schondra;97797,-117,87,Wartmannsroth;97799,-121,85,Zeitlofs;97816,-118,89,Lohr a. Main;97828,-115,93,Marktheidenfeld;97833,-115,92,Frammersbach;97834,-111,98,Birkenfeld;97836,-121,87,Bischbrunn;97837,-114,94,Erlenbach b. Marktheidenfeld;97839,-116,92,Esselbach;97840,-113,95,Hafenlohr, Rothenbuch;97842,-112,97,Karbach;97843,-125,83,Neuhütten;97845,-121,86,Neustadt a. Main;97846,-113,94,Partenstein;97848,-120,88,Rechtenbach;97849,-115,93,Roden;97851,-120,90,Rothenfels;97852,-118,90,Schollbrunn;97854,-116,93,Steinfeld;97855,-108,100,Triefenstein;97857,-112,96,Urspringen;97859,-114,93,Wiesthal;97877,-108,99,Wertheim;97892,-112,96,Kreuzwertheim;97896,-120,88,Freudenberg, Collenberg;97900,-116,93,Külsheim;97901,-123,85,Altenbuch;97903,-115,93,Collenberg;97904,-110,100,Dorfprozelten;97906,-108,99,Faulbach;97907,-110,97,Hasloch;97909,-115,93,Stadtprozelten;97922,-108,102,Lauda-Königshofen;97941,-109,100,Tauberbischofshei m;97944,-114,96,Boxberg;97947,-116,95,Grünsfeld;97950,-115,96,Großrinderfeld;97953,-113,96,Königheim;97956,-116,94,Werbach;97957,-112,99,Wittighausen;97959,-113,97,Assamstadt;97980,-115,97,Bad Mergentheim;97990,-112,101,Weikersheim;97993,-116,96,Creglingen;97996,-121,92,Niederstetten;97999,-117,95,Igersheim;98527,-129,80,Suhl;98528,-137,73;98529,-129,80;98530,-125,82,Suhl, Marisfeld, Rohr u.a.;98544,-137,75,Zella-Mehlis;98547,-134,76,Viernau u.a.;98553,-123,83,Schleusingen u.a.;98554,-124,83,Benshausen;98559,-150,62,Oberhof;98574,-123,90,Schmalkalden;98587,-142,69,Steinbach-Hallenberg;98590,-129,81,Schwallungen;98593,-135,78,Floh-Seligenthal;98596,-133,79,Brotterode-Trusetal;98597,-122,92,Breitungen/Werra;98617,-123,83,Meiningen;98630,-118,88,Römhild;98631,-121,85,Grabfeld;98634,-136,75,Wasungen;98639,-121,87,Walldorf;98646,-127,81,Hildburghausen;98660,-123,85,Themar;98663,-120,87,Bad Colberg-Heldburg;98666,-151,64,Biberau, Masserberg;98667,-143,70,Schleusegrund;98669,-125,85,Veilsdorf;98673,-128,80,Eisfeld, Auengrund;98678,-136,76,Sachsenbrunn;98693,-143,73,Ilmenau;98701,-146,70,Großbreitenbach;98704,-139,81,Langewiesen;98708,-143,78,Gehren;98711,-146,66,Schmiedefeld, Frauenwald, Suhl;98714,-143,70,Stützerbach;98716,-143,72,Geschwenda;98724,-149,66,Neuhaus am Rennweg, Lauscha;98739,-151,66,Lichte;98743,-144,77,Gräfenthal;98744,-151,66,Oberweißbach u.a.;98746,-149,67,Katzhütte;99084,-119,102,Erfurt;99085,-126,97;99086,-123,99;99087,-128,96;99089,-122,99;99090,-136,87;99091,-128,96;99092,-135,88;99094,-133,91;99095,-130,95;99096,-133,92;99097,-138,85;99098,-132,93;99099,-134,90;99100,-133,92,Großfahner, Dachwig u.a.;99102,-138,82,Rockhausen, Klettbach;99189,-129,95,Gebesee;99192,-134,89,Nesse-Apfelstädt, Nottleben;99195,-129,95,Großrudestedt, Schloßvippach u.a.;99198,-130,93,Udestedt, Mönchenholzhause n u.a.;99310,-136,87,Arnstadt;99326,-141,80,Stadtilm, Ilmtal;99330,-140,79,Gräfenroda;99334,-132,91,Elleben, Wachsenburg;99338,-135,86,Arnstadt;99423,-126,95,Weimar;99425,-129,93;99427,-137,85;99428,-134,88;99438,-134,88,Bad Berka u.a.;99439,-133,92,Berlstedt;99441,-136,87,Lehnstedt u.a.;99444,-138,85,Blankenhain;99448,-134,87,Kranichfeld u.a.;99510,-131,93,Apolda;99518,-132,97,Bad Sulza;99610,-130,95,Sömmerda;99625,-131,94,Kölleda;99628,-130,95,Buttstädt;99631,-128,96,Weißensee;99634,-130,95,Straußfurt;99636,-132,92,Rastenberg;99638,-130,94,Kindelbrück;99706,-135,82,Sondershausen;99707,-130,94,Kyffhäuserland;99713,-135,87,Ebeleben;99718,-132,90,Greußen Clingen Großenehrich;99734,-128,92,Nordhausen;99735,-132,88,Werther Hohenstein Wolkramshausen;99752,-128,89,Bleicherode;99755,-131,86,Ellrich;99759,-129,86,Sollstedt;99762,-136,81,Neustadt/Harz u.a.;99765,-128,94,Heringen/ Helme;99768,-139,76,Harztor;99817,-122,95,Eisenach;99819,-129,87,Marksuhl, Krauthausen u.a.;99820,-134,88,Hörselberg-Hainich;99826,-126,92,Mihla;99830,-123,92,Treffurt;99831,-130,85,Creuzburg, Ifta;99834,-127,88,Gerstungen;99837,-125,91,Berka/ Werra;99842,-141,70,Ruhla;99846,-131,86,Seebach;99848,-128,90,Wutha-Farnroda;99867,-131,90,Gotha;99869,-131,90,Drei Gleichen;99880,-132,88,Waltershausen;99885,-136,83,Luisenthal, Ohrdruf, Wolfis;99887,-142,73,Georgenthal/ Thür. Wald;99891,-140,78,Tabarz/ Thür. Wald;99894,-136,81,Leinatal;99897,-143,69,Tambach-Dietharz/ Thür.;99947,-127,94,Bad Langensalza;99955,-131,93,Bad Tennstedt;99958,-131,92,Großvargula, Tonna;99974,-127,92,Mühlhausen, Unstruttal;99976,-128,88,Rodeberg, Dünwald u.a.;99986,-128,90,Vogtei, Kammerforst u.a.;99988,-128,82,Südeichsfeld;99991,-127,94,Großengottern, Heroldishausen;99994,-133,90,Schlotheim;99996,-133,85,Menteroda, Obermehler;99998,-129,92,Körner, Weinbergen";
const KLIMA = (()=>{ const m=new Map(); let ort=""; PLZ_RAW.split(";").forEach(e=>{ const p=e.split(","); if(p[3]!==undefined) ort=p[3]; m.set(p[0],{tn:+p[1]/10,tm:+p[2]/10,ort}); }); return m; })();
function klimaLookup(plz){
  if(KLIMA.has(plz)) return {...KLIMA.get(plz), exact:true};
  const pre=plz.slice(0,3); let n=0,tn=0,tm=0,ort="";
  KLIMA.forEach((v,k)=>{ if(k.startsWith(pre)){n++;tn+=v.tn;tm+=v.tm;ort=v.ort;} });
  if(n>0) return {tn:Math.round(tn/n*10)/10, tm:Math.round(tm/n*10)/10, ort, exact:false};
  return null;
}

/* ============================== PRODUKTE (Shopify) ============================== */
const IMG = { hybrid:window.__BWP_IMG_URLS.hybrid, fox8:window.__BWP_IMG_URLS.fox8, fox10:window.__BWP_IMG_URLS.fox10, fox12:window.__BWP_IMG_URLS.fox12, fox5:window.__BWP_IMG_URLS.fox5 };
const PRODUCTS = {
  /* Preise = "VK Locked" aus der DIY-VK-Pakete-Tabelle (User, 16.07.2026, Zielmarge 45 %).
     "Preis vorläufig"-Tag komplett entfernt (User 17.07.2026); vorlaeufig-Flag wäre bei Bedarf wieder anschaltbar.
     ACHTUNG: Shopify-Produktpreise müssen per Admin/CSV nachgezogen werden, sonst weicht die
     Kasse im Full-Modus ab (Deposit-Modus zeigt nur diese Code-Preise). */
  /* kiBild: die Produktabbildungen dieses Kits sind KI-generiert. Das Flag steuert das
     Sternchen am Namen und die Fussnote darunter - siehe kiStern() und KI_FUSSNOTE. */
  /* sub ist die Modellzeile, genau wie bei den Fox-Kits. Die Beistell-WP ist von MHG und muss
     ueberall als solche erkennbar sein (User 14.08.2026) - sonst sieht der Kunde vier Kits
     und denkt, alle vier kaemen vom selben Hersteller. Typbezeichnung aus der Einbauanleitung
     (HeatKit_Hybrid_Einbauanleitung_ecoWP2Xm), vom User bestaetigt 14.08.2026. */
  hybrid: {name:"Hybrid-Kit", marke:"MHG", euFertigung:true, /* MHG fertigt in Deutschland - User 29.07.2026 */ sub:"MHG ecoWP2 Xm", price:3990, variantId:"58585763643737", kiBild:true, handle:'hybrid-kit', sku:'BWP-KIT-HYB-001'},
  fox8:   {name:"DIY-Kit 8 kW", marke:"Fox ESS", euFertigung:false,  sub:"Fox ESS HP3-8-E",  price:6399, variantId:"58585763709273", handle:'diy-kit-8-kw', sku:'BWP-KIT-008-001'},
  fox10:  {name:"DIY-Kit 10 kW", marke:"Fox ESS", euFertigung:false, sub:"Fox ESS HP3-10-E", price:6699, variantId:"58585763774809", handle:'diy-kit-10-kw', sku:'BWP-KIT-010-001'},
  fox12:  {name:"DIY-Kit 12 kW", marke:"Fox ESS", euFertigung:false, sub:"Fox ESS HP3-12-E", price:6999, variantId:"58585763807577", handle:'diy-kit-12-kw', sku:'BWP-KIT-012-001'},
  /* DIY-KIT 5 kW (12.10.2026, Vorgabe Claras: "bei der Kit-Uebersicht unten noch einen Kasten
     hinzufuegen fuer das Produkt DIY-Kit 5 kW ... und da, wo es kit-spezifische Infos sind,
     diese noch nicht uebernehmen").

     BEWUSST OHNE sub: Die Modellbezeichnung des Geraets ist hier nicht bekannt. "Fox ESS
     HP3-5-E" waere die naheliegende Fortschreibung des Musters - und damit geraten. Eine
     erfundene Typbezeichnung auf einer Produktseite ist schlimmer als keine; ohne sub laesst
     die Karte die Modellzeile einfach weg.

     EBENSO OHNE sku: Das Produkt traegt im Shop keine, und ein erfundener Wert saehe aus wie
     eine Zuordnung und waere keine.

     PREIS UND VARIANTE STAMMEN AUS DEM SHOP, nachgesehen in /products.json. ACHTUNG: Die
     6.999 EUR sind dort der Wert des 12-kW-Kits - das Produkt ist eine Kopie davon, der Preis
     ist noch nicht gepflegt. Er steht hier trotzdem so, damit Seite und Kasse dasselbe sagen;
     sobald er im Admin richtig steht, zieht die Bruecke (bwp-katalog-bruecke) ihn ohnehin von
     dort, denn das Produkt liegt in der Kollektion bwp-katalog.

     DER HANDLE IST AM 16.10.2026 GEZOGEN WORDEN. Bis dahin trug das Produkt die Adresse der
     12-kW-Kopie, aus der es entstanden ist; jetzt lautet sie /products/diy-kit-5-kw. Die
     Aenderung kam aus dem Theme (jemand hat sie dort eingetragen) und ist hier uebernommen -
     nachgeprueft am Abruf: die kurze Adresse antwortet mit 200 und traegt den Titel
     "DIY-Kit 5 kW", die alte mit 301. templates/product.liquid fuehrt beide Handles und
     brauchte deshalb nichts. */
  /* 6.099 UND NICHT 6.999 (berichtigt am 13.10.2026, Meldung Claras: "passe ueberall den
     richtigen Preis fuer das DIY-Kit 5 kW an, so wie es in Shopify hinterlegt ist - das steht
     im Warenkorb noch anders").

     NACHGESEHEN, NICHT UEBERNOMMEN: Die Variante 59860224606553 steht in Shopify auf 6.099,00
     EUR. Die 6.999 stammen vom 12.10.2026, als das Produkt als Kopie des 12-kW-Kits angelegt
     war - und dessen Preis ist bis heute 6.999, beides also fuer sich richtig und zusammen
     falsch.

     WARUM ES NUR AUF DER PRODUKTSEITE AUFFIEL: bwp-katalog-bruecke zieht Preise zur Laufzeit
     aus Shopify und ueberschreibt diese Tabelle - auf der Kits-Seite und der Startseite stand
     deshalb laengst 6.099. Die PRODUKTSEITE rendert die Bruecke nicht, dort gilt allein dieser
     Wert. Siehe die Anmerkung dazu in meiner Antwort an Clara. */
  /* HANDLE GEZOGEN (16.10.2026, fremde Aenderung im Theme, hier uebernommen): Das Produkt
     trug bis dahin den Handle der 12-kW-Kopie, aus der es entstanden ist. Jetzt heisst es
     diy-kit-5-kw; nachgeprueft am Abruf - die kurze Adresse antwortet mit 200 und traegt den
     Titel "DIY-Kit 5 kW", die alte mit 301 (Shopify leitet weiter). */
  fox5:   {name:"DIY-Kit 5 kW", marke:"Fox ESS", euFertigung:false, sub:"Fox ESS HP1-5-E", price:6099, variantId:"59860224606553", handle:'diy-kit-5-kw'},
  /* WARMWASSERSPEICHER auf die Paketpreise umgestellt (14.09.2026). Sie standen auf 1.499
     und 1.999, waehrend der Zubehoer-Reiter 1.400 und 2.200 zeigte - dieselben Speicher zu
     zwei Preisen. Preis UND variantId zeigen jetzt auf die neu angelegten Produkte
     (Warmwasserspeicher 200l / 300 l), sonst haette die Kasse wieder etwas anderes
     eingezogen als die Seite nennt.

     Sie liegen in PRODUCTS und nicht bei den Extras, weil der Speicher eine eigene Frage im
     Rechner ist - speicher() entscheidet ihn, nicht chosenExtras. Deshalb stehen die Werte
     hier von Hand statt ueber ausPaket(): PRODUCTS wird vor ZUBEHOER_PAKETE definiert.
     Quelle bleiben die Pakete p79 und p82; beim Nachziehen dort hier mitziehen.

     handle zeigt weiter auf die ALTEN Produktseiten - die neuen haben keine gepflegten
     Inhalte, und die Produktseite ist nur ein Verweisziel, kein Kaufweg. */
  sp200:  {name:"Warmwasserspeicher 200 l", price:1390, variantId:"59420058976601", handle:'200l-warmwasserspeicher', sku:'SHK-000377'},
  sp300:  {name:"Warmwasserspeicher 300 l", price:2190, variantId:"59420070510937", handle:'300l-warmwasserspeicher', sku:'SHK-000378'},
  /* 490 -> 199 am 10.08.2026 (User-Entscheid). Das Shopify-Produkt stand beim Nachmessen
     bereits auf 199,00 € - der Code hinkte hinterher und die Seite warb noch mit 490 €.
     MERKE: Diese Zahl und der Shopify-Variantenpreis muessen IMMER zusammen geaendert werden,
     sonst wirbt die Seite mit dem einen und die Kasse bucht das andere. */
  deposit:{name:"Anzahlung", price:199, variantId:"58586628456793", handle:'reservierung', sku:'BWP-RES-001'} /* BWP-RES-001, angelegt 14.07.2026 - Shopify-Produkttitel im Admin ebenfalls auf "Anzahlung" umbenennen (siehe Topic-3-Plan) */
};
/* DIE REIHENFOLGE DER KITS - eine Liste, alle Ansichten (17.09.2026).

   Aufsteigend nach Leistung, das Beistell-Geraet zuletzt: Es hat keinen eigenen
   Auslegungspunkt und laesst sich mit den drei Fox-Kits nicht der Groesse nach vergleichen.

   Vorher stand diese Reihenfolge nur in renderKitDeep(), und der Rechner-Vergleich sortierte
   nach etwas anderem. Genau das war der Fehler, den Clara am 17.09.2026 gemeldet hat:
   Dieselben vier Kits standen auf zwei Seiten in zwei Reihenfolgen. */
/* fox5 steht VORN (Vorgabe Claras vom 12.10.2026, zweiter Anlauf: "stell die neue Kachel
   bitte nach vorne, also vor die 8 kW"). Damit laufen die Kits wieder aufsteigend nach
   Leistung - 5, 8, 10, 12 -, was die Liste von selbst erklaert. Zuerst stand es hinten,
   solange es als "das Neue ohne Daten" gedacht war.

   Das Hybrid-Kit bleibt am Ende: Es ist der Sonderfall fuer bestehende Gasheizungen und
   gehoert nicht in die Leistungsreihe. */
const KIT_REIHE=['fox5','fox8','fox10','fox12','hybrid'];
function kitRang(k){ const i=KIT_REIHE.indexOf(k); return i<0 ? KIT_REIHE.length : i; }
/* ============ SHOPIFY UEBERSCHREIBT DEN KATALOG (03.09.2026) ============
   window.BWP_SHOPIFY kommt aus snippets/bwp-katalog-bruecke.liquid und traegt die Wahrheit aus
   dem Admin: Preis, Varianten-ID, Titel, Bild, Verfuegbarkeit - verknuepft ueber das Feld
   handle, das jeder Katalogeintrag seit heute traegt.

   WAS UEBERSCHRIEBEN WIRD und was nicht:
     price, variantId, bild, verfuegbar, url  <- aus Shopify. Das sind Handelsdaten.
     name, group, perUnit, max, xgroup, only  <- bleiben im Code. Das ist Auslegungslogik und
                                                 Oberflaechentext, der nicht in den Admin gehoert.

   Der Name bleibt bewusst im Code: die Shop-Titel heissen "Oberirdische Monoblock
   Hauseinfuehrung", im Konfigurator steht "oberirdisch (Monoblock)" unter der Gruppen-
   ueberschrift "Hauseinfuehrung". Beides ist richtig an seiner Stelle.

   ABWEICHUNGEN WERDEN GEMELDET, NICHT VERSCHWIEGEN. Weicht ein Preis ab, gewinnt Shopify - und
   die Konsole sagt, welcher Eintrag im Code veraltet ist. So faellt die naechste Preisaenderung
   sofort auf, statt wochenlang als falsche Werbung stehen zu bleiben.

   OHNE BRUECKE laeuft alles unveraendert auf den Werten im Code weiter. */
function katalogAusShopify(){
  var S = (typeof window!=='undefined' && window.BWP_SHOPIFY) || null;
  if(!S || !Object.keys(S).length){
    if(typeof console!=='undefined' && console.warn)
      console.warn('[katalog] Keine Shopify-Daten - Kollektion "bwp-katalog" fehlt oder ist leer.'
        +' Preise und Varianten-IDs stammen aus dem Code und koennen veraltet sein.');
    return;
  }
  var abweichungen=[], ohneTreffer=[];
  [PRODUCTS, EXTRAS, SERVICES].forEach(function(kat){
    Object.keys(kat).forEach(function(k){
      var e=kat[k]; if(!e || !e.handle) return;
      var sp=S[e.handle];
      if(!sp){ ohneTreffer.push(k+' ('+e.handle+')'); return; }
      if(typeof sp.preis==='number' && typeof e.price==='number' && Math.abs(sp.preis-e.price)>0.005){
        abweichungen.push(k+': Code '+e.price+' -> Shop '+sp.preis);
        e.price=sp.preis;
      }
      if(sp.variantId){
        var neu=String(sp.variantId);
        if(e.variantId && e.variantId!=='GELOESCHT' && String(e.variantId)!==neu)
          abweichungen.push(k+': Varianten-ID '+e.variantId+' -> '+neu);
        e.variantId=neu;
      }
      e.url=sp.url; e.bild=sp.bild; e.verfuegbar=sp.verfuegbar; e.shopTitel=sp.titel;
    });
  });
  if(abweichungen.length && console && console.warn)
    console.warn('[katalog] Shopify weicht vom Code ab - Shopify gilt. Bitte im Code nachziehen:\n  '
      +abweichungen.join('\n  '));
  if(ohneTreffer.length && console && console.warn)
    console.warn('[katalog] Nicht in der Kollektion "bwp-katalog": '+ohneTreffer.join(', ')
      +' - diese Positionen laufen weiter auf den Werten im Code.');
}

/* ============ VERWEIS AUF DIE PRODUKTSEITE (03.09.2026, Alignment-Punkt d) ============
   Bis hierher fuehrte von dieser Seite KEIN einziger Link auf /products/. Kits, Bauteile und
   Material wurden ausschliesslich in eigenen Ansichten erklaert - die Shopify-Produktseiten
   existierten daneben, unverlinkt und damit fuer Suchmaschinen wie fuer Kunden unsichtbar.

   Die Adresse kommt aus Shopify (e.url, gesetzt von der Katalog-Bruecke daneben) und faellt
   auf den Handle im Code zurueck. Fehlt beides, entsteht KEIN Link statt eines toten - eine
   Position ohne Produktseite soll nichts anbieten, was ins Leere fuehrt.

   Bewusst nur hier in JavaScript und nicht in den erzeugten Snippets: bwp-inhalt-kitDeep und
   bwp-inhalt-bauteileList tragen "ERZEUGT - NICHT VON HAND BEARBEITEN", und ihr Generator
   werkzeug/inhalte-erzeugen.js liegt nicht im Theme. Sie bleiben der Rueckfall ohne
   JavaScript; konfigurator.js baut dieselben Bereiche ohnehin beim Laden neu auf. */
function produktEintrag(key){
  if(typeof PRODUCTS==='object' && PRODUCTS[key]) return PRODUCTS[key];
  if(typeof EXTRAS==='object'   && EXTRAS[key])   return EXTRAS[key];
  if(typeof SERVICES==='object' && SERVICES[key]) return SERVICES[key];
  return null;
}
function produktUrl(key){
  const e=produktEintrag(key);
  if(!e) return null;
  if(e.url) return e.url;
  return e.handle ? '/products/'+e.handle : null;
}
function produktLinkHtml(key, text){
  const u=produktUrl(key);
  if(!u) return '';
  return `<a class="produktlink" href="${esc(u)}" onclick="track('produktseite_klick',{key:${JSON.stringify(String(key))}})">${esc(text||'Alle Details zum Produkt')} &rarr;</a>`;
}
/* Fuer Zeilen, deren Raster keinen zusaetzlichen Link vertraegt: der Name selbst wird zum
   Verweis. Ohne Produktseite bleibt es beim reinen Text, das Raster aendert sich nicht. */
function produktNameHtml(key, name){
  const u=produktUrl(key);
  if(!u) return esc(name);
  return `<a class="produktlink-name" href="${esc(u)}" onclick="track('produktseite_klick',{key:${JSON.stringify(String(key))}})">${esc(name)}</a>`;
}

/* ============ KAUFMODUS AUS DER THEME-EINSTELLUNG (A/B-Test, 18.08.2026) ============
   Variante B verkauft dieselbe Reservierung zu 0 EUR statt 199 EUR. Es ist DERSELBE Ablauf -
   eine Position mit allen Details als Eigenschaften - nur Produkt, Preis und Beschriftung
   unterscheiden sich. Deshalb bleibt CONFIG.MODE auf "deposit" und es wird lediglich das
   Produkt ausgetauscht; ein eigener zweiter Modus haette jede der sechs Verzweigungen verdoppelt.

   Die Werte kommen aus dem Theme-Editor (Section "Design (Farbe/BG)" -> Kaufmodus), damit
   Shopify Rollouts sie in seiner Theme-Kopie umschalten kann, ohne dass Code angefasst wird.

   Ohne Einstellung oder ohne Varianten-ID bleibt alles wie gehabt - Variante A. */
function kaufmodusAnwenden(){
  var k=window.BWP_KAUF;
  /* HALB EINGERICHTETES B IST EIN FEHLER, KEIN ZUSTAND (02.09.2026)
     Gemessen am 02.09.2026 im ausliefernden Arm "Free Reservation" (Theme 205321175385):
       modus: "anzahlung", variantId: "58892079563097",
       name: "Kostenfreie Vorbestellung", cta: "Jetzt kostenfrei vorbestellen →"
     Drei von vier B-Feldern gepflegt, nur der Schalter stand auf A. Die Bedingung unten
     griff also nicht, und der Arm lieferte Variante A aus - unter dem Namen "Free
     Reservation" und ohne dass irgendwo etwas davon zu sehen war. Der A/B-Test verglich
     damit A gegen A.

     Genau das ist das gefaehrliche Muster: der Ruecksprung auf Variante A ist der RICHTIGE
     Rueckfall (lieber die bezahlte Reservierung als ein kaputter 0-EUR-Kauf), aber er darf
     nicht schweigen, wenn jemand B offensichtlich EINRICHTEN WOLLTE. Eine hinterlegte
     Varianten-ID ohne passenden Modus ist keine gueltige Konfiguration, sondern eine
     vergessene Haelfte.

     Bewusst nur eine Warnung und kein Umschalten: welcher Modus laeuft, ist eine
     kaufmaennische Entscheidung (199 EUR Anzahlung gegen 0 EUR), die im Theme-Editor
     getroffen wird und nicht hier. Der Code darf sie sichtbar machen, nicht faellen. */
  if(k && k.variantId && k.modus!=="frei"){
    console.warn('[kaufmodus] Variante B ist halb eingerichtet: variantId="'+k.variantId+'"'
      +' ist hinterlegt, aber modus="'+(k.modus||'')+'" statt "frei".'
      +' Dieser Arm liefert Variante A aus. Umschalten im Theme-Editor:'
      +' Section "Design (Farbe/BG)" -> Kaufmodus.');
  }
  if(!k || k.modus!=="frei" || !k.variantId) return;
  PRODUCTS.deposit={
    name: k.name || "Kostenfreie Reservierung",
    price: 0,
    variantId: String(k.variantId),
    ctaText: k.cta || "Jetzt kostenfrei reservieren →"
  };
}
/* ============ WAS LIEGT IM WARENKORB? (03.09.2026, Betreiber-Entscheid) ============
   Vorgabe woertlich: "der Kunde soll nur kostenfrei reservieren koennen, aber trotzdem
   sehen, welche Produkte er kauft".

   Bis hierher lag EINE Sammelposition im Warenkorb - erst die Anzahlung, in Variante B die
   kostenfreie Vorbestellung - und alles andere stand als Line-Item-Eigenschaft darunter.
   Der Kunde sah seine Positionen also als Text, nicht als Positionen: keine Preise je Zeile,
   keine Zwischensumme, kein Bestand, keine brauchbare Kommissionierliste.

   "echt" legt stattdessen die WIRKLICHEN Varianten in den Warenkorb, zu ihren WIRKLICHEN
   Preisen. Bezahlt wird trotzdem nichts: die Kasse laeuft ueber eine manuelle Zahlungsart
   ("Reservierung - Zahlung nach Auftragsbestaetigung"), Shopify legt die Bestellung mit
   Status "Zahlung ausstehend" an und bucht nicht ab.

   WARUM NICHT 0-EUR-KOPIEN DER PRODUKTE: eine Ware mit 6.399 EUR Wert als "0,00 EUR"
   auszuzeichnen ist eine Preisangabe im Sinne der PAngV, ganz unabhaengig davon, ob dabei
   ein Vertrag zustande kommt. Der echte Preis mit ausstehender Zahlung sagt dasselbe
   wirtschaftlich und ist dabei schlicht wahr.

   DIESER SCHALTER STEHT AUS, BIS DIE ZAHLUNGSART EINGERICHTET IST. Das ist kein Zoegern,
   sondern die Reihenfolge: ohne die manuelle Zahlungsart landet der Kunde in einer Kasse,
   die 11.723,99 EUR per Karte verlangt. Erst Zahlungsart anlegen, andere Anbieter
   abschalten, dann hier umlegen. */
var __echtGewarnt=false;
function echtePositionen(){
  if(!(window.BWP_KAUF && window.BWP_KAUF.positionen==='echt')) return false;
  /* ECHTE POSITIONEN OHNE KOSTENFREIEN MODUS WAERE EIN VOLLKAUF, KEINE RESERVIERUNG.
     Ohne diesen Riegel entstuende genau die eine Kombination, die niemand will: die echten
     Produkte zu echten Preisen im Warenkorb UND keine Anzahlungsposition - der Kunde
     bekaeme an der Kasse die volle Summe vorgelegt und muesste sie heute zahlen.
     Gleiche Haltung wie beim Kaufmodus daneben: der Code faellt auf das sichere Verhalten
     zurueck und sagt laut, dass hier eine Haelfte fehlt. */
  if(PRODUCTS.deposit.price>0){
    if(!__echtGewarnt && console && console.warn){
      __echtGewarnt=true;
      console.warn('[warenkorb] positionen="echt" verlangt Kaufmodus B (kostenfrei).'
        +' Aktuell ist eine Anzahlung von '+PRODUCTS.deposit.price+' EUR eingestellt -'
        +' die Sammelposition bleibt aktiv. Umschalten im Theme-Editor:'
        +' Theme-Einstellungen -> Kaufmodus (A/B-Test).');
    }
    return false;
  }
  return true;
}
/* Baut die Warenkorbzeilen aus dem, was der Kunde zusammengestellt hat. Dieselbe Auswahl,
   aus der auch checkoutPositionen() die Textliste baut - eine Quelle, zwei Darstellungen.
   Unbrauchbare Varianten werden UEBERSPRUNGEN statt zu scheitern: die drei toten
   Hydraulik-Services tragen variantId "GELOESCHT", und Platzhalter beginnen mit "TBD_".
   Eine einzige davon wuerde /cart/add.js komplett ablehnen und den Kauf abbrechen. */
/* REIHENFOLGE WIE IM KONFIGURATOR (01.10.2026, Meldung Claras: "wenn bestellt wird und in
   Shopify die Bestellung eingeht, wird es noch falsch sortiert dargestellt - bitte so sortiert
   darstellen, wie es auch im Konfigurator steht").

   WAS DIE REIHENFOLGE BISHER BESTIMMT HAT: die Reihenfolge des ANKLICKENS. chosenServices ist
   ein Set und chosenExtras ein Objekt - beide behalten, in welcher Folge etwas hineinkam. Wer
   erst die Erdleitung und dann die Wanddurchfuehrung nahm, bekam sie in der Bestellung genau
   so; wer umgekehrt klickte, umgekehrt. Dieselbe Konfiguration sah also je nach Klickweg
   anders aus, und keine der beiden Fassungen entsprach der Liste auf dem Bildschirm.

   WAS SIE JETZT BESTIMMT: dieselben Tabellen, aus denen der Konfigurator seine Liste zeichnet.
     Services - zuerst nach Gruppe (SERVICE_GRUPPEN: Pflicht fuer die Foerderung, gesetzlich
       vorgeschrieben, freiwillig), innerhalb der Gruppe nach der Reihenfolge in SERVICES.
       Genau so baut renderServices() die beiden Listen auf.
     Material - nach der Reihenfolge in EXTRAS. Genau so baut der Konfigurator seine Gruppen:
       Object.entries(EXTRAS) der Reihe nach, gruppiert nach e.group.

   KEINE ZWEITE SORTIERTABELLE: Wer eine eigene Liste anlegte ("erst Hauseinfuehrung, dann
   Pumpengruppen ..."), muesste sie beim naechsten neuen Paket mitpflegen - und genau das
   vergisst man. Die Anzeige und die Bestellung lesen jetzt dieselbe Quelle.

   Object.keys WIRD BEIM AUFRUF GEHOLT, nicht beim Laden der Datei: Diese Funktionen stehen
   weit vor SERVICES und EXTRAS. Function-Deklarationen werden hochgezogen, const-Tabellen
   nicht - ein Zugriff beim Laden liefe in den Fehler "cannot access before initialization".
   Beim Aufruf, also an der Kasse, sind sie laengst da. */
function svcSortiert(svcSet){
  const reihe=Object.keys(SERVICES);
  const gruppe=k=>{
    const g=serviceGruppe(k);
    const i=SERVICE_GRUPPEN.findIndex(paar=>paar[0]===g);
    return i<0 ? 99 : i;
  };
  return [...(svcSet||chosenServices)].filter(k=>SERVICES[k])
    .sort((a,b)=> (gruppe(a)-gruppe(b)) || (reihe.indexOf(a)-reihe.indexOf(b)));
}
function extrasSortiert(){
  const reihe=Object.keys(EXTRAS);
  return Object.entries(chosenExtras||{}).filter(([k,q])=>EXTRAS[k]&&q)
    .sort((a,b)=> reihe.indexOf(a[0])-reihe.indexOf(b[0]));
}

function warenkorbPositionen(kitKey,svcSet){
  const items=[], fehlend=[];
  const nimm=(schluessel,v,menge)=>{
    const id=String(v||'');
    if(!id || id==='GELOESCHT' || id.startsWith('TBD_')){ fehlend.push(schluessel); return; }
    if(!(menge>0)) return;
    items.push({id:Number(id),quantity:menge});
  };
  if(PRODUCTS[kitKey]) nimm(kitKey,PRODUCTS[kitKey].variantId,1);
  const spKey=speicher(); if(spKey&&PRODUCTS[spKey]) nimm(spKey,PRODUCTS[spKey].variantId,1);
  svcSortiert(svcSet).forEach(k=>nimm(k,SERVICES[k].variantId,1));
  extrasSortiert().forEach(([k,q])=>nimm(k,EXTRAS[k].variantId,q));
  if(fehlend.length && console && console.warn)
    console.warn('[warenkorb] Ohne Varianten-ID und deshalb NICHT im Warenkorb: '+fehlend.join(', ')
      +' - diese Positionen stehen nur in den Eigenschaften der ersten Zeile.');
  return items;
}
/* Rueckfall, wenn die Cart-API nicht antwortet. Der Permalink kann keine Eigenschaften
   tragen, deshalb reist die Konfiguration hier als note mit - genau wie im alten Weg. */
function warenkorbPermalink(items,noteText){
  return '/cart/'+items.map(i=>i.id+':'+i.quantity).join(',')+'?note='+encodeURIComponent(noteText);
}
/* Beschriftung des Kaufknopfes: in Variante B nennt sie keinen Betrag, weil dort keiner
   anfaellt - "Jetzt reservieren: 0 EUR" liest sich wie ein Fehler. */
/* Grosser Kaufknopf. In Variante A nennt er den Anzahlungsbetrag, in Variante B keinen -
   "Jetzt reservieren: 0 EUR" liest sich wie ein Rechenfehler. Die Unterzeile zieht mit:
   "erstattbar" ergibt nur Sinn, wenn ueberhaupt etwas gezahlt wurde. */
function kaufKnopfGross(){
  if(PRODUCTS.deposit.ctaText)
    return PRODUCTS.deposit.ctaText+"<small>keine Zahlung heute &middot; keine Bindung</small>";
  return "Jetzt reservieren: "+eur(PRODUCTS.deposit.price)+"<small>100 % erstattbar &middot; keine Bindung</small>";
}
function kaufKnopfText(){
  return PRODUCTS.deposit.ctaText || ("Jetzt reservieren: "+eur(PRODUCTS.deposit.price)+" · erstattbar →");
}
/* ============ ABSCHLUSS-HINWEIS ("Closer", 27.08.2026, Idee CCO) ============
   NUR NOCH IN DER MAIL (User-Entscheid 27.08.2026). Der Hinweis stand einen halben Tag
   ueber dem Kaufknopf, in Kaufbox und Direktkauf-Fenster. Er ist dort auf Wunsch wieder
   entfernt worden: Markup, CSS (.closer) und das closer_view-Ereignis sind raus, ebenso
   das Merkmal closer_aktiv an den GTM-Ereignissen - ein Seitenereignis, das eine Anzeige
   meldet, die es auf der Seite nicht gibt, waere eine Falschmeldung.

   Was bleibt, ist diese Berechnung: sie speist ueber paketSchnappschuss() ausschliesslich
   die Konfigurations-Mail. Wer den Hinweis wieder auf die Seite holen will, braucht eine
   Render-Funktion und je eine Zeile in den beiden Kaufwegen - die Zustandslogik hier
   traegt beides unveraendert.

   DIE FRIST IST ECHT ODER SIE IST NICHT DA. Diese Funktion kann eine Frist nicht
   verlaengern und nicht zuruecksetzen: nach Ablauf liefert sie null, das Feld im
   Schnappschuss ist dann null und die Mail laesst den Block weg. Es gibt keinen Ersatzwert,
   auf den sie fallen koennte. Ein Countdown, der nach Ablauf weiterlaeuft oder sich auf ein
   neues Datum stellt, ist nach Paragraf 5 UWG irrefuehrend und in Deutschland gut
   abmahnfaehig - dagegen hilft kein Vorsatz, sondern nur eine Mechanik, die es nicht kann.

   ROTATIONSDATUM IST NICHT GLEICH FRIST. Jedes Fenster im Wochenplan hat ein Enddatum,
   aber das ist nur die Rotation: wie lange dieser Text laufen soll. Ob er eine FRIST
   behauptet, sagt allein frist_echt - nur dann nennt die Mail ueberhaupt ein Enddatum.

   {rest} wird zu "bis 31. August" und NICHT zu einem Tageszaehler. Eine Mail wird oft Tage
   nach dem Versand gelesen; ein eingefrorener Zaehler waere dann nachweislich falsch, das
   Datum bleibt richtig. Deshalb gibt es hier auch keine Seitenfassung mehr. */
const CLOSER=(function(){
  var c=window.BWP_CLOSER||{};
  if(!c.aktiv) return null;
  var heute=new Date(); heute.setHours(0,0,0,0);
  var MONATE=['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
  /* Datum lesen und pruefen. Faengt den 31.02. ab: JS rollt so ein Datum still in den
     Maerz weiter, und in der Mail stuende ein Tag, den es im Kalender nicht gibt. */
  function lies(bis){
    var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(String(bis||'').trim());
    if(!m) return null;
    var jahr=+m[1], monat=+m[2], tag=+m[3];
    var ende=new Date(jahr,monat-1,tag); ende.setHours(0,0,0,0);
    if(isNaN(ende.getTime()) || ende.getDate()!==tag || ende.getMonth()!==monat-1) return null;
    return {ende:ende, iso:m[0], datum:tag+'. '+MONATE[monat-1]};
  }
  function baue(d, titel, zusatz, fristEcht){
    var tage=Math.round((d.ende-heute)/86400000);
    if(tage<0) return null;                              /* vorbei -> das Feld wird null */
    if(!String(titel||'').trim()) return null;           /* leerer Titel = Pausenfenster */
    /* Ohne echte Frist gibt es keine ehrliche Restzeit einzusetzen. Dann faellt der
       Platzhalter weg statt irgendetwas zu behaupten; das Satzzeichen, das an ihm hing,
       wird mit aufgeraeumt ("Nur noch {rest}: X" wuerde sonst als "Nur noch : X" enden). */
    function fuelle(txt){
      var t=String(txt||'').replace(/\{datum\}/g, d.datum);
      t = fristEcht ? t.replace(/\{rest\}/g, 'bis '+d.datum) : t.replace(/\s*\{rest\}\s*/g, ' ');
      return t.replace(/\s{2,}/g,' ').replace(/\s+([:,;.])/g,'$1')
              .replace(/^[\s:,–-]+/,'').trim();
    }
    return {
      tage:tage, frist:d.iso, datum:d.datum, frist_echt:!!fristEcht,
      titel: fuelle(titel), zusatz: fuelle(zusatz)
    };
  }
  /* WOCHENPLAN. Nach Enddatum sortieren und den ersten nehmen, der noch laeuft - damit
     loesen sich die Fenster von selbst ab. Ueberschneidungen und Luecken sind gar nicht
     erst moeglich, weil ein Fenster implizit dort beginnt, wo das vorige endet. */
  var plan=Array.isArray(c.plan)?c.plan:[];
  var fenster=[];
  plan.forEach(function(e){ if(!e) return; var d=lies(e.bis); if(d) fenster.push({d:d,e:e}); });
  if(fenster.length){
    fenster.sort(function(x,y){ return x.d.ende-y.d.ende; });
    for(var i=0;i<fenster.length;i++){
      if(fenster[i].d.ende>=heute){
        return baue(fenster[i].d, fenster[i].e.titel, fenster[i].e.zusatz, fenster[i].e.frist_echt);
      }
    }
    return null;   /* Plan durchgelaufen -> nichts. Er faellt NICHT auf die Einzelfrist
                      zurueck: ein abgelaufener Plan darf keine alte Frist wiederbeleben. */
  }
  /* Kein Plan hinterlegt -> Einzelfrist. Die ist immer eine echte Frist, dafuer wurde sie gebaut. */
  var d=lies(c.frist);
  if(!d) return null;
  return baue(d, c.titel||'Jetzt Einführungspreis bis {datum} sichern', c.zusatz, true);
})();
/* Preise/IDs Stand 14.07.2026 aus dem Katalog-Import (shopify_products_import (2).csv, 30 % Zielmarge).
   xgroup: nur EINE Position der Gruppe wählbar (Radio-Verhalten in Buybox + Direktkauf-Modal).
   buyable:false: bleibt als Info im Förderung-Tab, ist aber nicht (mehr) kaufbar. */
const SERVICES = {
  /* Service-Preise = "VK Locked" (User-Tabelle 16.07.2026). foerder hatte KEINEN Locked-Wert:
     bleibt bei 285 bis das Team entscheidet (evtl. 0 €/inklusive?). */
  vot:    {name:"Technische Planung + Machbarkeit", price:999, variantId:"58585663209817", rec:()=>true, handle:'technische-planung-machbarkeit', sku:'BWP-SERV-PLAN-001'}, /* Vor-Ort-Termin (VOT) + raumweise Heizlastberechnung nach DIN EN 12831.
       Foerderrelevant, aber NICHT foerder-pflichtig im Sinne von FOERDER_CRITICAL: die
       Berechnung ist Voraussetzung, darf aber in Eigenleistung erbracht werden - deshalb
       wird der Service gekennzeichnet und nicht vorausgewaehlt. */
  foerder:{name:"Förderantrag (bis 80 % Zuschuss)", price:0, variantId:"58585663537497", rec:()=>true, handle:'foerderantrag-service', sku:'BWP-SERV-FOE-001'}, /* BWP-SERV-FOE-001, User-Entscheid 17.07.2026: 0 € (inklusive); ob das Shop-Produkt ganz raus soll, wird noch gefactcheckt */
  /* EMPFOHLEN SEIT DEM 25.09.2026 (Vorgabe Claras: "der Anlagencheck in dem Konfigurator ist
     auch empfohlen"). Er stand als einziger der drei Foerder-Pflichtservices ohne das gruene
     Zeichen da - neben Technischer Planung und Foerderantrag, die es tragen. Dabei haengt an
     ihm die Auszahlung: Ohne Bestaetigung nach Durchfuehrung und Fachunternehmererklaerung
     gibt es kein Geld, und beides kommt aus diesem Service. rec() steuert nur das Zeichen,
     nicht den Haken - ausgewaehlt wird weiter ueber FOERDER_CRITICAL. */
  ibn:    {name:"Anlagencheck & Inbetriebnahme", price:999, variantId:"58585663242585", rec:()=>true, handle:'anlagencheck-inkl-inbetriebnahme', sku:'BWP-SERV-IBN-001'}, /* inkl. Abnahmeprotokoll + Fachunternehmererklärung/BnD */
  zs:     {name:"Elektroanschluss inkl. Verdrahtung", price:1999, variantId:"58585663340889", rec:()=>false, handle:'elektroanschluss-inkl-verdrahtung', sku:'BWP-SERV-ELEK-001'}, /* exkl. Zusatzarbeiten am Zählerschrank/Hauselektrik */
  /* Öltank-Entsorgung: wieder 4 EINZELNE Services (finale User-Tabelle 17.07.2026, je Material/Größe
     eigener Locked-VK - kehrt den Merge vom 16.07. um). xgroup 'oel' = Radio-Verhalten, nur einer wählbar.
     Shop-Produkte per preisupdate2_import.csv reaktivieren/umbenennen. */
  oel_ku_le:{name:"Öltank-Entsorgung Kunststoff ≤ 5.000 l", price:2499, variantId:"58585663439193", rec:()=>false, only:(a)=>a.energy==='oel', xgroup:'oel', handle:'entsorgung-oeltank-kunststoff-5000l', sku:'BWP-SERV-ENTS-002'},
  oel_ku_gt:{name:"Öltank-Entsorgung Kunststoff > 5.000 l", price:3299, variantId:"58585663373657", rec:()=>false, only:(a)=>a.energy==='oel', xgroup:'oel', handle:'entsorgung-oeltank-kunststoff-groesser-5000l', sku:'BWP-SERV-ENTS-001'},
  oel_st_le:{name:"Öltank-Entsorgung Stahl ≤ 5.000 l", price:2899, variantId:"58585663504729", rec:()=>false, only:(a)=>a.energy==='oel', xgroup:'oel', handle:'entsorgung-oeltank-stahl-5000l', sku:'BWP-SERV-ENTS-004'},
  oel_st_gt:{name:"Öltank-Entsorgung Stahl > 5.000 l", price:3399, variantId:"58585663471961", rec:()=>false, only:(a)=>a.energy==='oel', xgroup:'oel', handle:'entsorgung-oeltank-stahl-groesser-5000l', sku:'BWP-SERV-ENTS-003'},
  /* NETZMANAGEMENT IST AM 28.10.2026 AUS DER AUSWAHL GENOMMEN (Vorgabe Claras: "Elektro-
     anschluss inkl. Verdrahtung ist eine Voraussetzung fuer Netzmanagement. Wenn die Kunden
     den Elektroanschluss nicht buchen, koennen sie auch das Netzmanagement ueber uns nicht
     buchen. Nimm das deswegen bitte raus beim Konfigurator bei Services").

     buyable:false STATT LOESCHEN. Der Eintrag traegt Name und Preis, und beides wird noch
     gebraucht: fuer Warenkoerbe und Bestellungen, in denen 'netz' schon steht, und fuer den
     Foerderung-Tab, der die Leistung weiter als Information fuehrt. Ein geloeschter Schluessel
     haette dort eine namenlose Position hinterlassen. Dieselbe Loesung wie bei hydS/M/L.

     WARUM NICHT only:(a)=>chosenServices.has('zs'): Das waere die woertliche Regel - buchbar,
     sobald der Elektroanschluss im Korb liegt. Clara hat aber die einfachere Variante gewaehlt:
     Die Leistung haengt ohnehin untrennbar am Elektrobetrieb und wird deshalb gar nicht mehr
     einzeln verkauft, sondern beim Elektroanschluss erklaert. Eine Abhaengigkeit zwischen zwei
     Haekchen waere eine Regel, die der Kunde erst beim Scheitern bemerkt. */
  netz:   {name:"Netzmanagement (An- & Abmeldung Netzbetreiber)", price:199, variantId:"58585663635801", buyable:false, rec:()=>false, handle:'netzmanagement-fuer-an-und-abmeldung', sku:'BWP-SERV-NETZ-001'}, /* BWP-SERV-NETZ-001 */
  /* Baubegleitung: Produkt kommt per preisupdate_import.csv (BWP-SERV-BAUB-001), dann ID eintragen.
     Deposit-Checkout funktioniert auch ohne, Services reisen als Properties mit. */
  baub:   {name:"Digitale Baubegleitung (inkl. 2 Std.)", price:199, variantId:"58604231557465", rec:()=>false, handle:'digitale-baubegleitung', sku:'BWP-SERV-BAUB-001'},
  /* JAEHRLICHE WARTUNG (02.10.2026, Vorgabe Claras: "fuege bitte das Produkt, das ich gerade bei
     Shopify hinzugefuegt habe, in den Konfigurator bei Services hinzu - das ist die Jaehrliche
     Wartung (Vertrag)").

     DIE WERTE SIND AUS DEM SHOP GEHOLT, nicht abgeschrieben: Handle jahrliche-wartung, Variante
     59674914488665, 399 EUR - nachgesehen in /products.json, nicht aus dem Namen geraten. Das
     Produkt heisst dort "Jaehrliche Wartung"; das "(Vertrag)" aus Claras Nachricht steht nicht
     im Shop und deshalb auch nicht hier.

     KEIN sku: Das Produkt hat im Shop keine, und ein erfundener Wert waere schlimmer als keiner -
     er sieht aus wie eine Zuordnung und ist keine.

     GRUPPE "FREIWILLIG", und zwar von selbst: serviceGruppe() setzt alles auf 'frei', was weder
     in FOERDER_CRITICAL steht noch in SERVICE_KATEGORIE eingetragen ist. Fuer eine Wartung ist
     das richtig - sie ist weder Foerderbedingung noch gesetzlich vorgeschrieben.

     rec()=>false: kein gruenes Zeichen. Empfohlen werden die Services, ohne die etwas nicht
     funktioniert oder nicht gefoerdert wird; eine Wartung ist eine Entscheidung des Kunden.

     ACHTUNG, OFFENER PUNKT: Das Produkt liegt NICHT in der Kollektion "bwp-katalog". Die Bruecke
     (bwp-katalog-bruecke.liquid) liest nur aus dieser Kollektion und zieht Preis und Varianten-ID
     aus dem Shop nach; was dort fehlt, haengt allein an den Werten hier. Aendert jemand im Admin
     den Preis, merkt es der Konfigurator nicht. Clara ist darauf hingewiesen - der Weg dorthin
     ist ein Haken im Admin, keine Zeile Code. */
  wartung:{name:"Jährliche Wartung", price:399, variantId:"59674914488665", rec:()=>false, handle:'jahrliche-wartung', preisZusatz:'pro Jahr'},
  /* Hyd. Abgleich: neuer Katalog hat nur Einzelkomponenten - bis zum Entscheid Komponenten-Modell
     nicht kaufbar (User 14.07.2026). Alte Preise nur noch für nichts verwendet, IDs tot. */
  hydS:   {name:"Hydraulischer Abgleich S (bis 8 HK)", price:690,  variantId:"GELOESCHT", buyable:false, rec:(a)=>a.radiators==='r8',  only:(a)=>a.radiators==='r8'},
  hydM:   {name:"Hydraulischer Abgleich M (9–15 HK)", price:990,  variantId:"GELOESCHT", buyable:false, rec:(a)=>a.radiators==='r15', only:(a)=>a.radiators==='r15'},
  hydL:   {name:"Hydraulischer Abgleich L (16+ HK)",  price:1390, variantId:"GELOESCHT", buyable:false, rec:(a)=>a.radiators==='r16', only:(a)=>a.radiators==='r16'}
};
/* ÖLTANK-ENTSORGUNG: EINE ZEILE, VIER MÖGLICHKEITEN (02.10.2026, Vorgabe Claras: "nicht nur als
   ein Produkt, sondern wenn man das will klickt man das an und es öffnet sich ein Dropdown, bei
   dem man dann zwischen den vier Optionen entscheiden muss").

   DIE VIER SERVICES BLEIBEN, WIE SIE SIND - jeder mit eigenem Preis, eigener Varianten-ID und
   eigenem Shop-Produkt. Zusammengefasst wird allein die ANZEIGE. Intern steht weiterhin genau
   einer der vier Schlüssel in chosenServices bzw. directServices, und deshalb laufen Summe,
   Förderbasis, Warenkorb und Checkout unverändert weiter - es gibt keine zweite Preisquelle.

   WARUM ÜBERHAUPT: Vier Zeilen mit vier Preisen zwischen 2.499 und 3.399 € standen bisher
   nebeneinander, und wer nicht weiß, ob sein Tank aus Stahl oder Kunststoff ist und wie viel er
   fasst, kann zwischen ihnen nicht wählen - er sieht nur eine Liste, in der drei Angaben falsch
   sind. Eine Zeile plus Auswahlfeld stellt erst die Frage und dann die Varianten.

   Reihenfolge wie in Claras Nachricht: erst Stahl, dann Kunststoff, je klein vor groß.

   xgroup 'oel' BLEIBT an den vier Einträgen stehen: Sie ist das Netz darunter, falls die Zeilen
   anderswo doch einzeln gerendert werden, und sie steuert zugleich die Preisspanne auf der
   Förderseite (renderServiceDeep) und den Rückfall im Service-Fenster. */
const OEL_KEYS=['oel_st_le','oel_st_gt','oel_ku_le','oel_ku_gt'];
const OEL_SAMMEL='oel';
const OEL_NAME='Öltank-Entsorgung';
function istOelKey(k){ return OEL_KEYS.indexOf(k)>=0; }
/* Welcher der vier steckt gerade in dieser Auswahl? (chosenServices bzw. directServices) */
function oelGewaehlt(set){
  for(let i=0;i<OEL_KEYS.length;i++){ if(set.has(OEL_KEYS[i])) return OEL_KEYS[i]; }
  return null;
}
/* "Stahl ≤ 5.000 l" - der Name ohne das, was schon in der Zeile darüber steht. */
function oelKurz(k){ return SERVICES[k].name.replace(OEL_NAME+' ',''); }
function oelSpanne(){
  const p=OEL_KEYS.map(k=>SERVICES[k].price);
  return eur(Math.min(...p))+' – '+eur(Math.max(...p));
}
/* Das Auswahlfeld. Der leere erste Eintrag ist Absicht: Clara will, dass man sich entscheidet -
   ein vorbelegter Wert wäre eine Entscheidung, die niemand getroffen hat, und sie kostet bis zu
   3.399 €. Der Preis steht an jeder Möglichkeit, damit die Wahl nicht blind getroffen wird. */
function oelSelectHtml(gewaehlt){
  return `<select class="oel-select" aria-label="${esc(OEL_NAME)}: Material und Größe wählen">`
    + `<option value=""${gewaehlt?'':' selected'}>Bitte wählen …</option>`
    + OEL_KEYS.map(k=>`<option value="${k}"${gewaehlt===k?' selected':''}>${esc(oelKurz(k))} · ${eur(SERVICES[k].price)}</option>`).join('')
    + '</select>';
}
/* Der Block unter der Zeile: Auswahlfeld plus der Hinweis, solange nichts gewählt ist.
   Zugeklappt, solange nichts gewählt ist - das Aufklappen übernimmt der Haken. */
function oelWahlHtml(set){
  const g=oelGewaehlt(set);
  return `<div class="oel-wahl"${g?'':' hidden'}>${oelSelectHtml(g)}`
    + `<p class="oel-hinweis"${g?' hidden':''}>Wähl aus, welcher Tank raus soll – erst dann rechnen wir die Entsorgung mit.</p></div>`;
}
/* Die Sammelzeile selbst. form 'modal' baut die Zeile des Direktkauf-Dialogs (.svcline mit dem
   Preis IM Label), alles andere die der Kaufbox (.buyline mit .svc-right daneben) - dieselben
   zwei Formen, die die übrigen Service-Zeilen auch haben.

   Kein "Empfohlen": rec() ist bei allen vier false, und eine Entsorgung empfiehlt sich nicht von
   selbst - sie hängt daran, ob überhaupt ein Tank im Keller steht. */
function oelZeileHtml(set, form, delay){
  const g=oelGewaehlt(set);
  const preis=g?zeilenPreis(SERVICES[g].price,true):'';
  const box=`<input type="checkbox" data-oel="1"${g?' checked':''}>`;
  const kopf = form==='modal'
    ? `<div class="svcline"><label class="svcchoice">${box}<span>${esc(OEL_NAME)}</span><span class="price m">${preis}</span></label>${svcFensterKnopfHtml(OEL_SAMMEL)}</div>`
    : `<div class="buyline"><label>${box}<span>${esc(OEL_NAME)}</span></label><span class="svc-right"><span class="price">${preis}</span>${svcFensterKnopfHtml(OEL_SAMMEL)}</span></div>`;
  const stil = (delay==null) ? '' : ` style="animation-delay:${delay*40}ms"`;
  return `<div class="svc-row oel-row"${stil}>${kopf}${oelWahlHtml(set)}</div>`;
}
/* Verdrahtet eine Öltank-Sammelzeile. Beide Kaufwege benutzen dieselbe Funktion - sie
   unterscheiden sich nur in der Menge, in die geschrieben wird, und in dem, was danach neu
   gerechnet werden muss. Genau deshalb steht das hier und nicht zweimal weiter unten. */
function oelZeileVerdrahten(row, set, neuRechnen, pfad){
  const box=row.querySelector('input[data-oel]');
  const wahl=row.querySelector('.oel-wahl');
  const sel=row.querySelector('.oel-select');
  const hinweis=row.querySelector('.oel-hinweis');
  if(!box||!wahl||!sel) return;
  /* Immer alle vier wegnehmen, bevor einer gesetzt wird: Es darf nie mehr als eine
     Tankentsorgung im Warenkorb liegen, und ein Wechsel im Auswahlfeld ist genau das - ein
     Tausch, kein Hinzufügen. */
  const raeumen=()=>OEL_KEYS.forEach(k=>set.delete(k));
  box.addEventListener('change',()=>{
    if(box.checked){
      wahl.hidden=false;
      if(sel.value){ raeumen(); set.add(sel.value); }
      /* Noch nichts gewählt: Das Auswahlfeld bekommt den Blick, sonst klappt unten etwas auf,
         ohne dass klar wird, dass dort jetzt eine Entscheidung ansteht. */
      else setTimeout(()=>{ try{ sel.focus(); }catch(e){} },0);
    } else {
      wahl.hidden=true; sel.value=''; if(hinweis) hinweis.hidden=false;
      raeumen();
      try{ track('service_removed',{service:OEL_SAMMEL,pflicht:false,path:pfad}); }catch(e){}
    }
    neuRechnen();
  });
  sel.addEventListener('change',()=>{
    raeumen();
    if(sel.value){ set.add(sel.value); try{ track('service_added',{service:sel.value,path:pfad}); }catch(e){} }
    if(hinweis) hinweis.hidden=!!sel.value;
    if(!box.checked) box.checked=true;
    neuRechnen();
  });
}
/* Eigenleistung-Material: Kosten, die der Kunde außerhalb von uns selbst trägt (z. B. Fundament-Beton),
   aber laut KfW-458-Merkblatt mit Beleg zur förderfähigen Investitionssumme zählen. Kein SERVICES-Preis,
   kein Warenkorb-Posten - nur Basis für die Förder-Schätzung (siehe updateTotal). VALIDIEREN (Jan): exakte
   Belegform/Nachweis gegenüber KfW. */
const EIGENLEISTUNGEN = [
  {k:'fundament', name:'Fundament / Unterbau', hint:'Beton, Bewehrung, Schwingungsdämpfer'},
  {k:'erdarbeiten', name:'Erdarbeiten & Rohrgraben', hint:'Aushub, Leitungsgraben, Kabelschutzrohr'},
  {k:'sonstiges', name:'Weitere Eigenleistung', hint:'Alles andere, was du selbst besorgst'}
];
/* Material-Extras - GRUPPIERT, kurz vor dem Checkout (User-Entscheid 14.07.2026 abends):
   Auswahl bewusst NICHT in den Funnel-Fragen (Jan: schreckt ab), sondern zugeklappt am Ende der
   Buybox (Marc/Joey: "kurz vor Checkout, als Dropdown"). Berechnet wird pro Einzelprodukt, DARGESTELLT
   (Buybox-Gruppentitel + Checkout-Zeilen) wird die GRUPPE (= CSV-Spalte Type).
   Regeln: Fertigfundament gewählt → Eigenleistungs-Zeile "Fundament" entfällt (baut er ja nicht selbst);
   Hauseinführung ober/unter = entweder/oder; Erdleitung in METERN; Pumpengruppe gem./ungem. = entweder/oder;
   Systemtrennung seit finaler Tabelle 17.07.2026 DRIN (2.399, Hinweis "FBH vor 1990"); Werkzeug raus aus MVP. */
/* ZUBEHOER-PAKETE (Reiter "Zubehoer", fruehere Bauteile-Liste) - erzeugt aus
   "Warenkoerbe DIY (7).xlsx", Blatt "Produkte", Spalten D/E/F/G/H/L/M.

   BEWUSST GETRENNT von PRODUCTS/EXTRAS/COMPONENTS: Diese Pakete werden nur ANGEZEIGT. Sie
   tragen keine variantId, koennen also gar nicht in den Warenkorb gelangen - das ist keine
   Regel, die jemand vergessen kann, sondern eine fehlende Voraussetzung.

   price = Spalte L (aufgerundeter VK-Preis) und gilt fuer das ganze Paket. Die Einzelpreise
   aus Spalte I/J/K stehen bewusst NICHT hier: Vorgabe, nur Paketpreise zu zeigen.
   bereit = Spalte M. q = Spalte F (Anzahl), n = Spalte G (Produkt), a = Spalte H (Art.-Nr.).
   img = Dateiname des Bildes aus Spalte E, eingebettet in der Tabelle, ausgelesen und als
   Theme-Asset abgelegt; URL ueber ZUB_IMG (Liquid, siehe bwp-seite-kopf).

   info = Schluessel in COMPONENT_DETAILS/COMPONENT_TECHNIK, wo Beschreibung, Montagehinweis
   und Datenblattwerte des Hauptprodukts liegen. VON HAND zugeordnet, siehe erzeuge.py:
   ein Namensabgleich per Skript griff bei Zeile 79 auf ein Nebenteil zu und lieferte
   peri_basic statt sp200. Pakete ohne Text zeigen den "folgt in Kuerze"-Platzhalter.

   ERZEUGT von werkzeug-zubehoer/einbauen.py - nicht von Hand bearbeiten.
   Welche Zeilen ein Paket bilden, steht in erzeuge.py (TITEL, POSITIONEN_NUR). */
const ZUB_IMG = window.__BWP_ZUB_IMG_URLS || {};
/* Adressen der Kachelbilder, die in den Shopify-Dateien liegen statt im Theme (29.09.2026).
   Gefuellt in bwp-katalog-bilder.liquid, dort steht auch das Warum. */
const ZUB_DATEI = window.__BWP_ZUB_DATEI_URLS || {};
const ZUBEHOER_PAKETE = [
  /* Zeile 30 */
  {key:"p30", name:"Erdleitung DN40 (Zentral)", price:90, bereit:"Dazu bestellbar", info:null, pos:[
    {n:"SR PEX Wärmepumpenrohr 2x40/145 mit KSR 2x40x3,7+KSR da/di 32/24+25/20 mm/145 mm", q:1, img:"kb-sr-pex-warmepumpenrohr-2x40-145-mi.jpg", a:"STPEWPR440"},
  ]},
  /* Zeile 31 */
  {key:"p31", name:"Paket: Wanddurchführung UI Zentral (für DN40)", price:390, bereit:"Dazu bestellbar", info:"haus_unter", pos:[
    {n:"Dichteinsatz Curaflex Nova Senso DN200 f. 139-141 mm Doyma", q:1, img:"kb-dichteinsatz-curaflex-nova-senso-d.jpg", a:"DOCNUMS20096"},
    {n:"Grundierung-Aquagard 1/3 Ltr. Doyma", q:1, img:"kb-grundierung-aquagard-1-3-ltr-doyma.jpg", a:"DOGR033"},
    {n:"Speziallack-Aquagard 1/3 Ltr. Doyma", q:1, img:"kb-grundierung-aquagard-1-3-ltr-doyma.jpg", a:"DOLA033"},
  ]},
  /* Zeile 35 */
  {key:"p35", name:"Paket: Anschluss UI Zentral (für DN40)", price:690, bereit:"Dazu bestellbar", info:null, pos:[
    {n:"T-Stueck Rotguss 1 1/­4\"", q:2, img:"kb-t-stueck-rotguss-1-1-4.jpg", a:"313032"},
    {n:"Reduzierstueck Rotguss 1 1/4\" x 1/2\"", q:2, img:"kb-reduzierstueck-rotguss-1-1-4-x-1-2.jpg", a:"32413215"},
    {n:"Doppelnippel Rotguss 1 1/4\"", q:2, img:"kb-doppelnippel-rotguss-1-1-4.jpg", a:"328032"},
    {n:"TRINNITY KFE-Kugelhahn 1/2\" vernickelt selbstdichtend mit Schlauchtülle u.Kappe", q:2, img:"kb-trinnity-kfe-kugelhahn-1-2-vernick.jpg", a:"KFEKUNI"},
    {n:"TRINNITY Kugelhahn 1 1/4\" m.verlängertem T-Griff, Pressmessing", q:2, img:"kb-trinnity-kugelhahn-1-1-4-m-verlang.png", a:"KHHM32IIVGN"},
    {n:"SR Schrumpfendkappe Vierfachrohr SB da 4x64-18 / DA 160-70 mm", q:2, img:"kb-sr-schrumpfendkappe-vierfachrohr-s.jpg", a:"STSEKVR464"},
    {n:"SR PEX Klemm-Übergang 40-1 1/4\" AG - PN6 40x3,7 mm - R1 1/4\" AG", q:4, img:"kb-sr-pex-klemm-ubergang-40-1-1-4-ag.jpg", a:"STPKU4032A"},
    {n:"PVC-Isolierband elastisch / UV-beständig Typ 128, L:25m B:50mm D:0,15mm, Farbe sw", q:1, img:"kb-pvc-isolierband-elastisch-uv-besta.jpg", a:"Q1280155025CE"},
    {n:"Red-Muffennippel 1\"AG x11/4\"IG schwer messing", q:2, img:"kb-red-muffennippel-1-ag-x11-4-ig-sch.jpg", a:"246MS2532"},
    {n:"CONEL FLEX EL Schlauchisolierung 100% 35 x 38mm ungeschl. Länge: 2m", q:2, img:"kb-conel-flex-el-schlauchisolierung-1.jpg", a:"COFEL3536"},
    {n:"Armaflex Fastlink DN25 2m, Anschlussset", q:1, img:"kb-armaflex-fastlink-dn25-2m-anschlus.jpg", a:"FL-AV-19X25/E02"},
  ]},
  /* Zeile 47 */
  {key:"p47", name:"Paket: Wanddurchführung OI Zentral", price:990, bereit:"Dazu bestellbar", info:"haus_ober", pos:[
    {n:"DOYMAfix HP/O für DN 200 für 22, 28 oder 35 mm", q:1, img:"kb-doymafix-hp-o-fur-dn-200-fur-22-28.jpg", a:"DOFIXHPO"},
    {n:"Armaflex Fastlink DN25 (FL-AV-19X25/E02)", q:1, img:"kb-armaflex-fastlink-dn25-2m-anschlus.jpg", a:"FL-AV-19X25/E02"},
  ]},
  /* Zeile 75 */
  {key:"p75", name:"Paket: Füllstation", price:990, bereit:"Dazu bestellbar", info:null, pos:[
    {n:"Füllstation CLEAR PRO FILL All-in-One CONEL", q:1, img:"kb-fullstation-clear-pro-fill-all-in.jpg", a:"CLEARPFSA"},
    {n:"Entsalzungskartusche CLEAR PRO FILL Plus CONEL m. pH-Wert Stabilisierung 7 l", q:1, img:"kb-entsalzungskartusche-clear-pro-fil.jpg", a:"CLEARPESP7"},
  ]},
  /* Zeile 78 */
  /* PREIS AUF 59 € (29.09.2026, Vorgabe Claras: "veraender den Preis der Daempfungssockel
     ueberall in 59 €"). Vorher 35. Die Zahl steht an drei Stellen: hier, im Kommentar an der
     Varianten-Kennung und im vorgerenderten Zwilling - alle drei sind mitgezogen.
     WAS DIESE ZAHL NICHT AENDERT: den Preis der Shopify-Variante. Die Kasse rechnet mit dem,
     was im Shopify-Admin am Produkt steht - siehe den Hinweis an PAKET_VARIANTE. */
  {key:"p78", name:"Dämpfungssockel", price:59, bereit:"Dazu bestellbar", info:null, pos:[
    {n:"Set a 2 Stück Dämpfungssockel Sumo SM 600x110x90mm inkl. Schrauben-Set Max.Bel.je Fuß:200", q:1, img:"kb-set-a-2-stuck-dampfungssockel-sumo.jpg", a:"GDSSSM600"},
  ]},
  /* Zeile 79 */
  {key:"p79", name:"Warmwasserspeicher 200l", price:1390, bereit:"Dazu bestellbar", info:"sp200", pos:[
    {n:"AE Hochleistungsspeicher für Wärmepumpen BWS-WP + 200 B", q:1, img:"kb-ae-hochleistungsspeicher-fur-warme.jpg"},
    {n:"Caleffi Sical-Center 12 ltr. 3/4\" 10 bar", q:1, img:"kb-caleffi-sical-center-12-ltr-3-4-10.png"},
  ]},
  /* Zeile 82 */
  {key:"p82", name:"Warmwasserspeicher 300 l", price:2190, bereit:"Dazu bestellbar", info:"sp300", pos:[
    {n:"Lapesa HL-Speicher 300 Ltr. Emailliert Typ CV-300-HL WT 3,1qm", q:1, img:"kb-lapesa-hl-speicher-300-ltr-emailli.png"},
    {n:"Caleffi Sical-Center 12 ltr. 3/4\" 10 bar", q:1, img:"kb-caleffi-sical-center-12-ltr-3-4-10.png"},
  ]},
  /* Zeile 85 */
  {key:"p85", name:"Gemischte Pumpengruppe", price:590, bereit:"Dazu bestellbar", info:"pump_gem", pos:[
    {n:"COSMO 3.0 Pumpengruppe gemischt DN 25, COSMO Pumpe CPH 2.0 6-25", q:1, img:"kb-cosmo-3-0-pumpengruppe-gemischt-dn.jpg"},
    {n:"COSMO Anlegethermostat 30-90 Grad C mit Arretierung", q:1, img:"kb-cosmo-anlegethermostat-30-90-grad.jpg"},
  ]},
  /* Zeile 88 */
  {key:"p88", name:"Ungemischte Pumpengruppe", price:390, bereit:"Dazu bestellbar", info:"pump_ungem", pos:[
    {n:"COSMO 3.0 Pumpengruppe­ ungemischt DN 25, COSMO Pumpe CPH 2.0 6-25", q:1, img:"kb-cosmo-3-0-pumpengruppe-ungemischt.jpg"},
  ]},
  /* Zeile 90 */
  {key:"p90", name:"Gemischter Kreis mit Systemtrennung", price:1790, bereit:"Dazu bestellbar", info:"systr", pos:[
    {n:"COSMO 3.0 Pumpengruppe gemischt DN 25, COSMO Pumpe CPH 2.0 6-25", q:1, img:"kb-cosmo-3-0-pumpengruppe-gemischt-dn.jpg"},
    {n:"Anschluss-Verschraubung Sanpress flachd. 28mm Pressanschl. x 1 1/2\" G ÜW, Rotguss", q:2, img:"kb-anschluss-verschraubung-sanpress-f.jpg"},
    {n:"TRINNITY Kappenventil 3/4\" x 3/4\" Messing m. KFE-Hahn", q:1, img:"kb-trinnity-kappenventil-3-4-x-3-4-me.jpg"},
    {n:"COSMO Anlegethermostat 30-90 Grad C mit Arretierung", q:1, img:"kb-cosmo-anlegethermostat-30-90-grad.jpg"},
    {n:"COSMO 3.0 Trennsystem mit Wärmetauscher mit Wilo Yonos Pico, DN 25, 18 kW", q:1, img:"kb-cosmo-3-0-trennsystem-mit-warmetau.jpg"},
    {n:"COSMO Premium Ausdehnungsgefäß 35 Liter / 1,5 (3 bar) NEU", q:1, img:"kb-cosmo-premium-ausdehnungsgefass-35.jpg"},
  ]},
  /* Zeile 97 */
  {key:"p97", name:"Homematic Control Unit", price:290, bereit:"Dazu bestellbar", info:"homematic", pos:[
    {n:"Homematic IP Home Control Unit HmIP-HCU1 (eQ-3)", q:1, img:"kb-homematic-ip-home-control-unit-hmi.jpg"},
  ]},
  /* Zeile 98 */
  {key:"p98", name:"EQ3 Heizkörperthermostat", price:49, bereit:"Dazu bestellbar", info:"eq3_hk", pos:[
    {n:"Homematic IP Heizkörperthermostat kompakt HmIP-eTRV-C-2", q:1, img:"kb-homematic-ip-heizkorperthermostat.jpg"},
  ]},
  /* Zeile 99 */
  {key:"p99", name:"EQ3 FBH-Stellmotor", price:19, bereit:"Dazu bestellbar", info:"eq3_stell", pos:[
    {n:"Homematic IP Stellantrieb motorisch HmIP-VDMOT", q:1, img:"kb-homematic-ip-stellantrieb-motorisc.jpg"},
  ]},
  /* Zeile 100 */
  {key:"p100", name:"EQ3 Regelklemmleiste WK", price:190, bereit:"Dazu bestellbar", info:"eq3_klemm", pos:[
    {n:"Homematic IP Fußbodenheizungscontroller 8 Kanäle, motorisch HmIP-FALMOT-C8", q:1, img:"kb-homematic-ip-fussbodenheizungscont.jpg"},
  ]},
  /* Zeile 101 */
  {key:"p101", name:"EQ3 Schaltsteckdose / Verstärker", price:49, bereit:"Dazu bestellbar", info:"eq3_dose", pos:[
    {n:"Homematic IP Schaltsteckdose HmIP-PS-2", q:1, img:"kb-homematic-ip-schaltsteckdose-hmip.jpg"},
  ]},
];

/* AUSWAHL IM KONFIGURATOR = DIE ZUBEHOER-PAKETE (Umbau 14.09.2026).

   Bis hierher stand hier eine eigene Liste mit eigenen Preisen. Sie lief neben den
   Zubehoer-Paketen her und widersprach ihnen in elf von dreizehn Positionen - die
   Systemtrennung stand auf 2.399 statt 1.800, die oberirdische Hauseinfuehrung auf 599 statt
   950. Zwei Wahrheiten fuer dieselbe Sache. Name und Preis kommen deshalb jetzt aus
   ZUBEHOER_PAKETE; sie stehen nur noch an einer Stelle.

   DIE SCHLUESSEL BLEIBEN. Ein erster Versuch benannte sie nach den Paketen (p47 statt
   haus_ober) - das haette 65 Stellen gebrochen, die daran haengen: hauseinfuehrungAus(),
   die Pumpengruppen-Empfehlung, Foerderlogik, Eigenleistung, gespeicherte Staende im
   Browser. Der Schluessel ist hier eine Rolle im Konfigurator, nicht der Name des Produkts.

   KEINE variantId MEHR. Entscheid 14.09.2026: "erst mal nur anzeigen, spaeter echt". Das ist
   nicht nur Umsetzung der Vorgabe, sondern noetig - die alten IDs zeigen auf Shopify-Produkte
   mit den ALTEN Preisen. Mit neuem Preis im Konfigurator und altem an der Kasse haette der
   Kunde etwas anderes bezahlt, als hier steht. warenkorbPositionen() ueberspringt Positionen
   ohne gueltige ID und protokolliert sie; Kit und Services bleiben bestellbar. Sobald je
   Paket ein Shopify-Produkt mit dem richtigen Preis existiert, kommt hier "variantId" dazu.

   ENTFALLEN: Fertigfundament und Basic Peripherie-Set (Entscheid 14.09.2026) - zu beiden gibt
   es kein Paket in der Tabelle. */
const PAKET_VON = Object.fromEntries(ZUBEHOER_PAKETE.map(p=>[p.key,p]));
/* VARIANTEN-IDS DER PAKETE. Leer heisst: noch kein Shopify-Produkt vorhanden. Die Position
   wird dann angezeigt, aber nicht berechnet - warenkorbPositionen() ueberspringt sie und
   protokolliert das; ausgewaehlt bleibt sie trotzdem, sie reist als Eigenschaft an der
   ersten Warenkorbzeile und in der Bestellnotiz mit.

   EINTRAGEN nach dem Produktimport (werkzeug-zubehoer/shopify-produkte.csv): je Paket die
   Varianten-ID als Zeichenkette. Danach ist die Position eine echte, bepreiste Warenkorbzeile.
   Die ID findest du im Admin in der Adresszeile der Variante (…/variants/<ID>) oder in einem
   Produktexport.

   NUR IN DIESEM THEME: Das Live-Theme kennt diese Tabelle nicht - dort bleibt alles wie es
   ist, selbst wenn die Produkte im Shop existieren.

   ACHTUNG bei den Preisen: Die ID muss auf ein Produkt zeigen, dessen Preis mit dem Paket
   uebereinstimmt. Die ALTEN Produkte tun das nicht (Systemtrennung 2.399 statt 1.800,
   Hauseinfuehrung oberirdisch 599 statt 950) - deshalb stehen sie hier bewusst nicht drin.
   Sonst zeigte der Konfigurator einen Preis und die Kasse zoege einen anderen ein. */
const PAKET_VARIANTE = {
  p30:  '59419056636249',  /* Erdleitung DN40                    95,00 */
  p31:  '59419329659225',  /* Wanddurchführung UI               385,00 */
  p35:  '59419339522393',  /* Anschluss UI                      700,00 */
  p47:  '59419367571801',  /* Wanddurchführung OI               950,00 */
  p75:  '59419372421465',  /* Füllstation                     1.200,00 */
  p78:  '59419374518617',  /* Dämpfungssockel                    59,00 */
  p85:  '59420082405721',  /* Gemischte Pumpengruppe            600,00 */
  p88:  '59420085387609',  /* Ungemischte Pumpengruppe          400,00 */
  p90:  '59420089778521',  /* Systemtrennung                  1.800,00 */
  p97:  '59420096004441',  /* Homematic Control Unit            320,00 */
  p98:  '59420100297049',  /* EQ3 Heizkörperthermostat           50,00 */
  p99:  '59420103803225',  /* EQ3 FBH-Stellmotor                 20,00 */
  p100: '59420109406553',  /* EQ3 Regelklemmleiste              210,00 */
  p101: '59420114026841',  /* EQ3 Schaltsteckdose                45,00 */
};
/* Holt Name und Preis aus dem Paket und legt die Konfigurator-Rolle darueber. Fehlt das
   Paket - etwa weil die Tabelle neu gezogen wurde und eine Zeile weggefallen ist -, faellt
   der Eintrag lieber ganz weg, statt mit "undefined" und NaN im Preis weiterzulaufen. */
function ausPaket(key, rolle){
  const p=PAKET_VON[key];
  if(!p){ if(console&&console.warn) console.warn('[extras] Paket fehlt: '+key); return null; }
  /* variantId bewusst VOR der Rolle: so kann eine Rolle sie im Einzelfall ueberschreiben,
     ohne dass die Tabelle oben angefasst werden muss. Fehlt sie, bleibt das Feld leer und
     nimm() in warenkorbPositionen() ueberspringt die Position - String(undefined||'') ist
     der leere String, nicht "undefined". */
  return Object.assign({name:p.name, price:p.price, paket:key, variantId:PAKET_VARIANTE[key]||''}, rolle);
}
const EXTRAS = Object.fromEntries(Object.entries({
  /* HAUSEINFUEHRUNG. Welche Bauart zur Antwort passt, entscheidet die Frage "Wo soll die
     Aussseneinheit stehen?" - sie setzt die HAKEN (siehe AUTOWAHL_AUFSTELLORT).

     ANGEZEIGT WIRD SEIT DEM 16.09.2026 ALLES (Vorgabe). Vorher blendete ein only-Filter die
     unpassende Bauart aus; wer noch nicht geantwortet hatte, sah eine fast leere Gruppe und
     konnte nicht erkennen, was es ueberhaupt gibt. Jetzt stehen alle Pakete da, und die
     Antwort entscheidet nur, welche angehakt sind. Wer es besser weiss, hakt selbst um. */
  /* OHNE MENGE seit dem 15.09.2026 (Vorgabe): nur noch anhaken, kein Regler. Die
     unterirdische Variante darunter behaelt ihren vorerst - dort wurde nichts gesagt. */
  haus_ober:  ausPaket('p47', {group:'Hauseinführung', xgroup:'haus'}),
  /* OHNE MENGE seit dem 16.09.2026 (Vorgabe), wie die oberirdische Variante darueber. */
  haus_unter: ausPaket('p31', {group:'Hauseinführung', xgroup:'haus'}),
  /* Der Innenanschluss gehoert zur unterirdischen Fuehrung. */
  anschluss_ui: ausPaket('p35', {group:'Hauseinführung'}),
  /* ERDLEITUNG: SICHTBAR IMMER, GEHAKT NUR BEI "weiter weg im Garten".

     Zwei verschiedene Dinge, die hier schon einmal durcheinandergerieten:
       - ob das Paket in der Liste STEHT  -> immer, seit dem 16.09.2026 ("alles anzeigen",
         wer es besser weiss, hakt selbst um). Deshalb kein only-Filter mehr.
       - ob es angehakt IST               -> entscheidet AUTOWAHL_AUFSTELLORT, und dort steht
         es seit dem 18.09.2026 nur noch bei 'weit' (Vorgabe).

     Der Filter only:a=>a.aufstellort!=='nah' waere der falsche Weg zurueck: Er wuerde das
     Paket wieder ganz verstecken, statt es nur nicht vorzuwaehlen. */
  erdleitung: ausPaket('p30', {group:'Hauseinführung', perMeter:true}),

  /* PERIPHERIE. Pumpengruppe gemischt oder ungemischt - die Sperre gilt bei einem Heizkreis,
     bei zwei getrennt geregelten duerfen beide gewaehlt werden (Betreiber-Entscheid
     18.08.2026, siehe die bestehende Ausnahme zu xgroup 'pumpe').

     WELCHE der beiden gehakt wird, entscheidet die Heizart (siehe AUTOWAHL_HEIZART): Eine
     gemischte Pumpengruppe regelt einen eigenen Vorlauf und gehoert zur Fussbodenheizung,
     eine ungemischte foerdert ohne Mischung und gehoert zu Heizkoerpern.

     SICHTBAR SIND BEIDE, immer (Vorgabe 16.09.2026) - auch vor der Antwort und auch die,
     die nicht zur Antwort passt. Die Entweder/Oder-Sperre bleibt davon unberuehrt: Wer von
     Hand umhakt, loest die andere ab, ausser bei "beides" (pumpenSperreAktiv). */
  /* Der Daempfungssockel steht seit dem 14.09.2026 hier statt bei der Peripherie (Vorgabe):
     Er gehoert zur Aufstellung der Aussseneinheit, also zu derselben Entscheidung wie die
     Durchfuehrung und die Leitung dorthin. */
  daempfung:  ausPaket('p78', {group:'Hauseinführung'}),

  /* PUMPENGRUPPEN. Gemischt oder ungemischt - die Sperre gilt bei einem Heizkreis, bei zwei
     getrennt geregelten duerfen beide gewaehlt werden (Betreiber-Entscheid 18.08.2026,
     siehe die bestehende Ausnahme zu xgroup 'pumpe').

     WELCHE der beiden angeboten wird, haengt seit dem 14.09.2026 an der Heizart - genau wie
     die Hauseinfuehrung am Aufstellort haengt (Vorgabe: erst die Frage, dann die Auswahl).
     Die Zuordnung stand fachlich laengst fest, sie war nur nirgends wirksam: eine gemischte
     Pumpengruppe regelt einen eigenen Vorlauf und gehoert zur Fussbodenheizung, eine
     ungemischte foerdert ohne Mischung und gehoert zu Heizkoerpern. Vorher standen beide
     nebeneinander, und der Kunde musste den Unterschied selbst kennen.

     Bei "beides" erscheinen beide - dann gibt es zwei getrennt geregelte Kreise, und genau
     fuer diesen Fall ist die Entweder/Oder-Sperre ohnehin schon aufgehoben
     (pumpenSperreAktiv). Vor der Antwort erscheint keine von beiden.

     Die Systemtrennung steht mit dabei, obwohl die Vorgabe sie nicht nennt: Sie arbeitet
     ausschliesslich zusammen mit der gemischten Pumpengruppe (siehe vorauswahlPlan), und
     als einzige Position einer eigenen Gruppe stuende sie ohne Bezug da. */
  /* MENGE SEIT DEM 25.09.2026: "2x gemischt" aus der Heizkreis-Nachfrage bedeutet zwei
     gemischte Pumpengruppen (Grafik "BWP Customer Journey"). Ohne Regler stuende dort ein
     Haken und der einfache Preis, waehrend die Summe zwei zaehlt - ein stiller Widerspruch
     zwischen Zeile und Gesamtbetrag. */
  /* SIE ENTFAELLT, SOBALD DAS TRENNSYSTEM NOETIG IST (Vorgabe Claras 25.09.2026: "wenn
     Fussbodenheizung aelter als 1990, dann brauchen wir nur den gemischten Kreis mit
     Systemtrennung und nicht die gemischte Pumpengruppe").

     DER GRUND STEHT IN DER STUECKLISTE: Paket p90 "Gemischter Kreis mit Systemtrennung" fuehrt
     als erste Position genau dieselbe "COSMO 3.0 Pumpengruppe gemischt DN 25" wie p85. Wer
     beide anhakte, kaufte die Pumpengruppe zweimal - einmal fuer 590 Euro einzeln und einmal
     im Trennsystem fuer 1790. Das war bis heute moeglich und faellt auf der Rechnung nur
     jemandem auf, der beide Stuecklisten nebeneinanderlegt.

     ZWEI MECHANISMEN, WEIL ES ZWEI DINGE SIND: only() blendet die Zeile aus, SCHLIESST_AUS
     raeumt einen schon gesetzten Haken weg. Ohne das zweite bliebe ein frueher gesetzter Haken
     unsichtbar in der Summe stehen. */
  pump_gem:   ausPaket('p85', {group:'Pumpengruppen', xgroup:'pumpe', perUnit:'Heizkreis', max:4,
                               only:()=>!systemtrennungNoetig()}),
  /* MENGENREGLER AUCH BEI DER UNGEMISCHTEN (Vorgabe Claras 25.09.2026: "bei ungemischte
     Pumpengruppe dann noch einen Stueckzaehler machen, wenn man bei Heizkreise 2x ungemischt
     angibt"). Bis dahin trug nur die gemischte einen - bei zwei Heizkoerperkreisen stand hier
     eine Zeile ohne Zahl, und wer eine zweite Gruppe brauchte, konnte es nicht sagen.

     DER REGLER STEHT IMMER DA, nicht nur nach dieser einen Antwort: perUnit ist eine
     Eigenschaft des Postens, keine Bedingung. Beides zu bauen hiesse, die Heizart-Logik ein
     zweites Mal in die Zeilendarstellung zu schreiben. Er faellt auch nicht auf - bei einem
     einzelnen Kreis steht schlicht "1 Stk.", und bei Heizkoerpern ist die ganze Gruppe weg.

     VORAUSGEWAEHLT BLEIBT 1 (Grafik "BWP Customer Journey": 2x ungemischt -> EINE ungemischte
     Pumpengruppe). Wer zwei braucht, stellt sie jetzt selbst ein. */
  pump_ungem: ausPaket('p88', {group:'Pumpengruppen', xgroup:'pumpe', perUnit:'Heizkreis', max:4}),
  /* WANN DIE SYSTEMTRENNUNG UEBERHAUPT ERSCHEINT, steht in systemtrennungWaehlbar() - drei
     Faelle, in denen es sie nicht zu waehlen gibt. Die beiden Pumpengruppen regelt
     paketAusgeblendet() ueber AUTOWAHL_HEIZART; die Systemtrennung steht in keiner dieser
     Listen und braucht deshalb ihre eigene Regel.

     VON HAND ANGEHAKTES BLEIBT SICHTBAR - dieselbe Ausnahme, die paketAusgeblendet() macht.
     Eine versteckte Zeile mit Haken zaehlte weiter in jeder Summe mit, und niemand faende
     heraus, woher der Betrag kommt. */
  systr:      ausPaket('p90', {group:'Pumpengruppen', perUnit:'Heizkreis', max:4,
                               only:()=>systemtrennungWaehlbar() || chosenExtras.systr>0}),

  /* HYDRAULISCHER ABGLEICH. Mengen wie gehabt: je Heizkoerper, je Heizkreis, je Verteiler.
     Die Fuellstation kam am 14.09.2026 dazu (Vorgabe) - gefuellt und gespuelt wird beim
     Abgleich, sie gehoert zu diesem Arbeitsschritt. */
  homematic:  ausPaket('p97',  {group:'Hydraulischer Abgleich'}),
  eq3_hk:     ausPaket('p98',  {group:'Hydraulischer Abgleich', perUnit:'Heizkörper', max:30}),
  eq3_stell:  ausPaket('p99',  {group:'Hydraulischer Abgleich', perUnit:'Heizkreis', max:24}),
  /* MIT MENGE seit dem 21.09.2026: Eine Regelklemmleiste steuert die Stellmotoren EINES
     Verteilerkastens, und Haeuser haben oft einen je Etage. Als Ja/Nein-Zeile liess sich das
     nicht ausdruecken - die Frage "Wie viele Verteilerkaesten hast du?" haette auf eine Zeile
     gezeigt, die nur 1 oder 0 kennt. */
  eq3_klemm:  ausPaket('p100', {group:'Hydraulischer Abgleich', perUnit:'Verteilerkasten', max:6}),
  eq3_dose:   ausPaket('p101', {group:'Hydraulischer Abgleich', perUnit:'Verteiler', max:6}),
  /* EIGENE GRUPPE SEIT DEM 18.09.2026 (Vorgabe: "nicht zu dem Hydraulischen Abgleich
     setzen, sondern einen eigenen Bereich mit Titel daraus machen").

     Sie stand beim Abgleich, weil beides am selben Tag passiert - gefuellt und gespuelt wird
     beim Abgleich. Gemeinsam ist aber nur der Zeitpunkt, nicht die Sache: Der Abgleich
     verteilt das Wasser richtig, die Fuellstation entscheidet, WELCHES Wasser hineinkommt.

     DER TITEL IST "Befuellung" (Vorgabe 18.09.2026). Er stand einen Tag lang auf "Befuellen
     und Wasseraufbereitung", was beide Bestandteile des Pakets nannte - Fuellstation und
     Entsalzungskartusche. Das eine Wort reicht: Neben "Hauseinfuehrung" und "Pumpengruppen"
     ist es dieselbe knappe Form, und was die Station leistet, steht im ⓘ daneben.

     DIE GRUPPE STEHT ZULETZT, weil EXTRAS in der Reihenfolge der Definition gelesen wird
     (siehe die groups-Schleifen in renderBuyBox und renderCartModalIncluded). Wer sie
     woandershin will, verschiebt diesen Eintrag - es gibt keine zweite Reihenfolgenliste. */
  fuellstation: ausPaket('p75', {group:'Befüllung'}),
}).filter(([,v])=>v));



/* ============ START DER BEIDEN KATALOG-SCHRITTE (03.09.2026, Fehlerbehebung) ============
   Beide Bloecke standen bis heute als sofort ausgefuehrte IIFE oben bei ihrem Kommentar -
   also VOR SERVICES (781) und EXTRAS (824). Sobald die Kollektion "bwp-katalog" wirklich
   Produkte lieferte, lief katalogAusShopify() in
     ReferenceError: Cannot access 'EXTRAS' before initialization
   und damit brach das gesamte Skript ab: kein Rechner, keine Pfad-Weiche, keine Kit-Karten -
   die Seite zeigte nur noch Hintergrundfarben. Bis dahin verdeckte der Leer-Rueckfall den
   Fehler ("Keine Shopify-Daten ... return"), weshalb er erst mit dem Befuellen der Kollektion
   sichtbar wurde und nicht beim Einbau.

   Beide sind jetzt Funktionsdeklarationen und werden HIER gerufen, nach allen drei Katalogen.
   DIE REIHENFOLGE IST NICHT BELIEBIG: PRODUCTS.deposit traegt den Handle "reservierung",
   katalogAusShopify() setzt darauf also den Shopify-Preis. kaufmodusAnwenden() ueberschreibt
   ihn in Variante B mit 0 EUR. Umgedreht wuerde die kostenfreie Reservierung wieder 199 EUR
   kosten. */
katalogAusShopify();
kaufmodusAnwenden();
/* Komponenten-/Stückliste je Artikelnummer, aus Components.csv (Quelle: SHK-Warenwirtschaft).
   Nur Produkte mit Artikelnummer in der Pricing-CSV können hier einen Eintrag haben - Kits,
   Fundament, Erdleitung und alle Services haben dort keine Artikelnummer und bleiben bewusst ohne
   Komponenten-Aufschlüsselung. EQ3 Wandthermostat (SHK-000536) ist in Components.csv vorhanden,
   aber nicht im EXTRAS-Katalog (siehe Kommentar oben "Wandthermostat bewusst raus") - daher hier
   ebenfalls ausgelassen. */
const COMPONENTS = {
  "SHK-000365": [ /* Hauseinführung OI */
    {name:"DOYMAfix HP/O für DN 200 für 22, 28 oder 35 mm", qty:1, price:365.37},
  ],
  "SHK-000366": [ /* Hauseinführung UI */
    {name:"Dichteinsatz Curaflex Nova Senso DN200 f. 139-141 mm Doyma", qty:1, price:178.4},
    {name:"Grundierung-Aquagard 1/3 Ltr. Doyma", qty:1, price:14.81},
    {name:"Speziallack-Aquagard 1/3 Ltr. Doyma", qty:1, price:18.27},
    {name:"Heizkörperpinsel 52mm", qty:1, price:0.98},
  ],
  "SHK-000371": [
    {name:"COSMO 3.0 Pumpengruppe ungemischt DN 25, COSMO Pumpe CPH 2.0 6-25", qty:1},
    {name:"Anschluss-Verschraubung Sanpress flachdichtend 28mm Pressanschluss x 1 1/2\" G ÜW, Rotguss", qty:2},
    {name:"Übergangsstück B-press 28mm x 1\"AG Rotguss P4243G", qty:2},
    {name:"T-Stück B-press 28mm x 1/2\" IG x 28mm Rotguss P4130G", qty:2},
    {name:"TRINNITY KFE-Kugelhahn 1/2\" vernickelt selbstdichtend mit Schlauchtülle u. Kappe", qty:2},
  ],
  "SHK-000372": [
    {name:"COSMO 3.0 Pumpengruppe gemischt DN 25, COSMO Pumpe CPH 2.0 6-25", qty:1},
    {name:"COSMO Anlegethermostat 30-90 °C mit Arretierung", qty:1, note:"für gemischte PG"},
    {name:"TRINNITY KFE-Kugelhahn 1/2\" vernickelt selbstdichtend mit Schlauchtülle u. Kappe", qty:2},
    {name:"T-Stück B-press 28mm x 1/2\" IG x 28mm Rotguss P4130G", qty:2},
    {name:"Übergangsstück B-press 28mm x 1\"AG Rotguss P4243G", qty:2},
    {name:"Anschluss-Verschraubung Sanpress flachdichtend 28mm Pressanschluss x 1 1/2\" G ÜW, Rotguss", qty:2},
  ],
  "SHK-000374": [
    {name:"COSMO 3.0 Pumpengruppe gemischt DN 25, COSMO Pumpe CPH 2.0 6-25", qty:1},
    {name:"COSMO 3.0 Trennsystem mit Wärmetauscher mit Wilo Yonos Pico, DN 25, 18 kW", qty:1},
    {name:"COSMO Premium Ausdehnungsgefäß 35 Liter / 1,5 (3 bar)", qty:1},
    {name:"COSMO Anlegethermostat 30-90 °C mit Arretierung", qty:1},
    {name:"Anschluss-Verschraubung Sanpress flachdichtend 28mm Pressanschluss x 1 1/2\" G ÜW, Rotguss", qty:2},
    {name:"TRINNITY Kappenventil 3/4\" x 3/4\" Messing m. KFE-Hahn", qty:1},
    {name:"Übergangsstück B-press 28mm x 1\"AG Rotguss P4243G", qty:2},
    {name:"Übergangsstück B-press 28mm x 3/4\"AG Rotguss P4243G", qty:1},
    {name:"T-Stück B-press 28mm x 1/2\" IG x 28mm Rotguss P4130G", qty:4},
    {name:"TRINNITY KFE-Kugelhahn 1/2\" vernickelt selbstdichtend mit Schlauchtülle u. Kappe", qty:4},
  ],
  "SHK-000377": [ /* Warmwasserspeicher 200L Cu */
    {name:"Übergangsstück B-press 28mm x 1\"AG Rotguss P4243G", qty:2, price:4.4},
    {name:"T-Stück B-press 28mm x 1/2\" IG x 28mm Rotguss P4130G", qty:2, price:9.48},
    {name:"KFE-Kugelhahn 1/2\" DIN-DVGW matt-chrom f.Trinkwasser m.Schlauchtülle u.Kappe", qty:1, price:6.72},
    {name:"Übergangsstück B-press 28mm x 3/4\"IG Rotguss P4270G", qty:1, price:8.36},
    {name:"Übergangsstück B-press 28mm x 3/4\"AG Rotguss P4243G", qty:1, price:7.15},
    {name:"Übergangsstück B-press 28mm x 1\"IG Rotguss P4270G", qty:3, price:4.73},
    {name:"Reduzierstück B-press 28 x 15mm Kupfer P5243", qty:1, price:3.23},
    {name:"TRINNITY KFE-Kugelhahn 1/2\" vernickelt selbstdichtend mit Schlauchtülle u.Kappe", qty:1, price:2.46},
    {name:"Caleffi Sical-Center 12 ltr. 3/4\" 10 bar", qty:1, price:166.08},
    {name:"AE Hochleistungsspeicher für Wärmepumpen BWS-WP + 200 B", qty:1, price:580.0},
  ],
  "SHK-000378": [ /* Warmwasserspeicher 300L Cu */
    {name:"Lapesa HL-Speicher 300 Ltr. Emailliert Typ CV-300-HL WT 3,1qm", qty:1, price:1026.0},
    {name:"Übergangsstück B-press 28mm x 1\"AG Rotguss P4243G", qty:2, price:4.4},
    {name:"T-Stück B-press 28mm x 1/2\" IG x 28mm Rotguss P4130G", qty:2, price:9.48},
    {name:"KFE-Kugelhahn 1/2\" DIN-DVGW matt-chrom f.Trinkwasser m.Schlauchtülle u.Kappe", qty:1, price:6.72},
    {name:"Übergangsstück B-press 28mm x 3/4\"IG Rotguss P4270G", qty:1, price:8.36},
    {name:"Übergangsstück B-press 28mm x 3/4\"AG Rotguss P4243G", qty:1, price:7.15},
    {name:"Übergangsstück B-press 28mm x 1\"IG Rotguss P4270G", qty:3, price:4.73},
    {name:"Reduzierstück B-press 28 x 15mm Kupfer P5243", qty:1, price:3.23},
    {name:"TRINNITY KFE-Kugelhahn 1/2\" vernickelt selbstdichtend mit Schlauchtülle u.Kappe", qty:1, price:2.46},
    {name:"Caleffi Sical-Center 12 ltr. 3/4\" 10 bar", qty:1, price:166.08},
  ],
  "SHK-000400": [ /* Monoset Hydro Non-Modular */
    {name:"Caleffi Schlammabscheider XF 11/4\" mit größeren Durchfluss", qty:1, price:163.8},
    {name:"Caleffi Isol. für Schlammabscheider XF passend für 22mm bis 11/4\"", qty:1, price:17.32},
    {name:"TRINNITY Kappenventil 3/4\" x 3/4\" Messing m. KFE-Hahn", qty:1, price:5.99},
    {name:"Übergangsstück B-press 28mm x 3/4\"AG Rotguss P4243G", qty:1, price:7.15},
    {name:"T-Stück B-press 28 x 15 x 28mm Kupfer P5130", qty:2, price:6.84},
    {name:"Übergangsstück B-press 15mm x 1/2\"IG Rotguss P4270G", qty:2, price:1.65},
    {name:"TRINNITY KFE-Kugelhahn 1/2\" vernickelt selbstdichtend mit Schlauchtülle u.Kappe", qty:2, price:2.46},
    {name:"T-Stück B-press 35mm x 1/2\" IG x 35mm Rotguss P4130G", qty:2, price:13.88},
    {name:"Caleffi FüllKombi BA Plus, 1/2\" inkl. Kartusche 0,75 ltr.", qty:1, price:282.24},
    {name:"Selbstklebeband FLEX HT CONEL 50x3mm UV-beständig L: 15m, schwarz", qty:1, price:75.8},
    {name:"CONEL FLEX EL Schlauchisolierung 100% 35 x 38mm ungeschl. Länge: 2m", qty:4, price:7.88},
    {name:"TRINNITY Kugelhahn 1 1/4\" m.verlängertem T-Griff, Pressmessing", qty:2, price:8.3},
    {name:"Übergangsstück B-press 35mm x 1 1/4\"AG Rotguss P4243G", qty:4, price:9.81},
    {name:"VA Wellrohr, 175mm Vaillant-Nr. 8000019518", qty:2, price:37.92},
    {name:"T-Stück B-press 35 x 28 x 35mm Kupfer P5130", qty:1, price:9.75},
    {name:"Doppelnippel Rotguss 1 1/4\" 3280", qty:1, price:3.94},
    {name:"COSMO Premium Ausdehnungsgefäß 50 Liter / 1,5 (3 bar) NEU", qty:1, price:52.14},
  ],
  "SHK-000533": [ /* EQ3 Home Control Unit WK */
    {name:"EQ3 Home Control Unit", qty:1, price:173.92},
  ],
  "SHK-000534": [ /* EQ3 Schaltsteckdose / Verstärker WK */
    {name:"EQ3 Schaltsteckdose / Verstärker", qty:1, price:24.84},
  ],
  "SHK-000535": [ /* EQ3 HK Thermostat (ST) WK */
    {name:"EQ3 HK Thermostat (ST)", qty:1, price:28.96},
  ],
  "SHK-000537": [ /* EQ3 Regelklemmleiste WK */
    {name:"EQ3 Regelklemmleiste", qty:1, price:115.94},
  ],
  "SHK-000538": [ /* EQ3 FB Stellmotoren WK */
    {name:"EQ3 FB Stellmotoren", qty:1, price:11.56},
  ],
  /* Hydraulikstation (Inneneinheit) - kein Artikelnummer-Match in der Pricing-CSV (nicht separat
     bepreist, Teil des Kits), daher synthetischer Key statt SHK-Nummer. Quelle: Datenblatt
     "Zubehoer-Konfiguration-Hydro_box_3.0.pdf" (Herstellerangaben zur Hydro Box). Durchgestrichene
     Punkte im PDF (8L Ausdehnungsgefäß Warmwasser, Druckminderer m. Rückflussverhinderer) sind NICHT
     enthalten, deshalb hier ausgelassen. */
  "HYDROBOX-INNENEINHEIT": [
    {name:"50L Pufferspeicher, mit Fühler", qty:1},
    {name:"Elektroheizung 9 kW, mit Übertemperaturschutz", qty:1},
    {name:"Ausdehnungsgefäß 20L für Heizsystem", qty:1},
    {name:"3-Wege-Umschaltventil (manuell u. automatisch)", qty:1},
    {name:"Elektrokasten mit RCD-Schutz, Leistungsschalter und Schnittstellen", qty:1},
    {name:"Magnet-/Schlammabscheider", qty:1},
    {name:"Primäre Umwälzpumpe zwischen Außen- und Inneneinheit", qty:1},
    {name:"Sekundäre Umwälzpumpe für Heizkreis 1 mit Heizkörpern", qty:1},
    {name:"Heizkreis 2, freie Verbindung für Pumpengruppe FBH", qty:1},
    {name:"Entlüfter (am Pufferspeicher und am höchsten Punkt der Inneneinheit)", qty:2},
    {name:"Überdruckventil mit Ablauf", qty:2},
    {name:"Absperrventil an allen Rohranschlüssen der Inneneinheit", qty:1},
    {name:"Wasserdruckanzeige (analog und digital)", qty:1},
    {name:"Füllstation, konform mit VDI 2035", qty:1},
    {name:"Systemtrenner BA", qty:1},
    {name:"Dichtung G1\"", qty:10, note:"Zubehör"},
    {name:"Dichtung G3/4\"", qty:2, note:"Zubehör"},
    {name:"WiFi-Antenne, 1,5 m", qty:1, note:"Zubehör"},
    {name:"Fühler TWT (Warmwasserspeicher), 5 m", qty:1, note:"Zubehör"},
    {name:"Fühler TZ2 (Heizkreis 2), 5 m", qty:1, note:"Zubehör"},
    {name:"Fühler TW1 (Zirkulationspumpe), 5 m", qty:1, note:"Zubehör"},
    {name:"Fühler TW2 (Solarthermie), 10 m", qty:1, note:"Zubehör"},
    {name:"Fühler TW3 (Wetterkompensation), 10 m", qty:1, note:"Zubehör"},
    {name:"Öffner für den Schlammabscheider", qty:1, note:"Zubehör"},
    {name:"Öffner für die Füllstation", qty:1, note:"Zubehör"},
    {name:"Absperrventil G1\"", qty:2, note:"Zubehör"},
    {name:"Kommunikationskabel zw. Außen- und Inneneinheit, 15 m", qty:1, note:"Zubehör"},
    {name:"Anleitung", qty:1, note:"Zubehör"},
  ],
};
/* Sternchen hinter dem Produktnamen, wenn dessen Abbildung KI-generiert ist.
   Bewusst als eigener Helfer: die Namen laufen ueberall durch esc(), das Sternchen ist
   Markup und muss deshalb daneben stehen, nicht im String. */
function kiStern(key){
  return (PRODUCTS[key] && PRODUCTS[key].kiBild) ? '<span class="ki-stern" aria-hidden="true">*</span>' : '';
}
const KI_FUSSNOTE = '* Die Abbildungen des Hybrid-Kits wurden mit Hilfe von KI erzeugt und zeigen eine beispielhafte Darstellung. Die technischen Angaben stammen unverändert aus dem Herstellerdatenblatt.';
/* Haengt die Fussnote an einen Container, aber nur wenn dort ueberhaupt ein KI-Bild steht. */
function kiFussnoteHtml(keys){
  return keys.some(k=>PRODUCTS[k] && PRODUCTS[k].kiBild)
    ? `<p class="ki-fussnote">${esc(KI_FUSSNOTE)}</p>` : '';
}
function skuOf(key){ const e=EXTRAS[key]||PRODUCTS[key]; return e&&e.sku; }
function hasComponents(key){ const s=skuOf(key); return !!s && !!(COMPONENTS[s]&&COMPONENTS[s].length); }
/* Zeigt die Zeile einen ⓘ-Knopf? (02.09.2026)
   Eine Stueckliste zu HABEN heisst nicht, dass sie den Kunden an dieser Stelle weiterbringt.
   Bei den Pumpengruppen ist der Knopf gestrichen: die Entscheidung dort lautet "gemischt oder
   ungemischt und wie viele", nicht "welche Einzelteile stecken drin". Das Feld ohneInfo an der
   EXTRAS-Position schaltet ihn ab; die Stueckliste selbst bleibt erhalten und ist im
   Bauteile-Bereich weiterhin zu sehen. */
/* JEDE MATERIALZEILE BEKOMMT EINEN ⓘ (02.09.2026)
   Vorher hing der Knopf an hasComponents() - Positionen ohne hinterlegte Stueckliste hatten
   keinen. Zwei Folgen: die rechte Kante der Liste sprang von Zeile zu Zeile (dafuer gab es
   sogar einen 46px-Ausgleich im CSS, der nur einen Teil der Faelle traf), und ausgerechnet
   die erklaerungsbeduerftigen Posten - "Systemtrennung", "Regelklemmleiste" - standen ohne
   jede Erklaerung da.
   Jetzt hat jede Zeile einen Knopf. Wo eine Stueckliste existiert, zeigt er sie wie bisher;
   wo keine da ist, greift extraEssenzHtml() mit dem Wesentlichen: wozu die Position gehoert,
   wofuer sie da ist, wonach sich die Menge bemisst. */
function zeigtBauteilInfo(key){ return !!EXTRAS[key] || hasComponents(key); }

/* Die Essenz je Materialposition - ein Satz, der die Frage "warum steht das hier?" beantwortet.
   Bewusst hier und nicht in COMPONENT_DETAILS: das sind Verkaufs- und Einordnungstexte, keine
   Herstellerangaben, und sie sollen auch dann stehen, wenn es gar keine Stueckliste gibt. */
const EXTRA_ZWECK = {
  fundament:  'Fertiges Betonfundament fuer die Aussenheit - geliefert statt selbst gegossen.',
  haus_ober:  'Wanddurchfuehrung oberirdisch: die Leitung geht direkt durch die Hauswand.',
  haus_unter: 'Wanddurchfuehrung unterirdisch: die Leitung kommt aus dem Erdreich ins Haus.',
  erdleitung: 'Vorgedaemmte Leitung fuers Erdreich, wenn die Aussenheit weiter weg steht.',
  peri_basic: 'Grundausstattung des Hydraulikkreises: Absperrungen, Sicherheitsgruppe, Anschluesse.',
  pump_gem:   'Regelt einen Heizkreis auf eine eigene Vorlauftemperatur - noetig bei Fussbodenheizung.',
  pump_ungem: 'Foerdert einen Heizkreis ohne eigene Mischung - der Fall bei Heizkoerpern.',
  systr:      'Trennt Anlagen- und Heizkreis. Noetig bei Fussbodenheizung vor 1990, weil dort Sauerstoff durch die Rohre diffundiert.',
  homematic:  'Die Zentrale fuer die Funk-Thermostate. Einmal pro Anlage, nicht pro Raum.',
  eq3_hk:     'Funk-Thermostat je Heizkoerper - die Stellgroesse fuer den hydraulischen Abgleich.',
  eq3_stell:  'Stellmotor je Heizkreis am Verteiler der Fussbodenheizung.',
  eq3_klemm:  'Regelklemmleiste je Verteiler - sie verbindet die Stellmotoren mit der Zentrale.',
  eq3_dose:   'Schaltsteckdose beziehungsweise Funkverstaerker je Verteiler.'
};
function extraEssenzHtml(key){
  const e=EXTRAS[key]; if(!e) return '';
  const menge = e.perMeter ? 'Wird nach Metern berechnet.'
              : e.perUnit  ? ('Wird je '+esc(e.perUnit)+' berechnet.')
              : 'Einmal pro Anlage.';
  return `<div class="bt-detail-head"><h3>${esc(e.name)}</h3></div>
    <div class="bt-detail-body">
      <div class="bt-modell">Gehoert zu: ${esc(e.group)}</div>
      <p>${esc(EXTRA_ZWECK[key]||'Beschreibung folgt in Kuerze.')}</p>
      <h4>Preis und Menge</h4>
      <p>${eur(e.price)}${e.perMeter?' pro Meter':e.perUnit?(' je '+esc(e.perUnit)):''}. ${menge}</p>
      ${e.hint?`<p><b>Hinweis:</b> ${esc(e.hint)}</p>`:''}
    </div>`;
}
function componentsFor(key){ const s=skuOf(key); return (s&&COMPONENTS[s])||[]; }
function componentCatalog(){
  const fromCatalog = [...Object.entries(PRODUCTS),...Object.entries(EXTRAS)]
    .filter(([k])=>hasComponents(k))
    .map(([k,e])=>({key:k,name:e.name,price:e.price,sku:e.sku,components:componentsFor(k)}));
  /* Lieferumfang-Positionen ohne eigenen Verkaufspreis (z. B. Hydraulikstation/Inneneinheit) können
     trotzdem eine Stückliste haben - LU_DETAILS trägt dafür optional ein sku-Feld, positionsgleich
     mit LIEFERUMFANG. key bekommt ein "lu_"-Präfix, damit er nie mit einem EXTRAS/PRODUCTS-Key
     kollidiert (siehe bt-<key>-IDs im Bauteile-Panel). */
  const fromLieferumfang = (LIEFERUMFANG||[]).map((row,i)=>({row,detail:LU_DETAILS[i]}))
    .filter(x=>x.detail && x.detail.sku && COMPONENTS[x.detail.sku] && COMPONENTS[x.detail.sku].length)
    .map(x=>({key:'lu_'+x.detail.sku, name:x.row[1], price:null, sku:x.detail.sku, components:COMPONENTS[x.detail.sku]}));
  return [...fromCatalog,...fromLieferumfang];
}
/* Bauteil-Produktseiten (Topic 2): Bild/Beschreibung/Montageanleitung je componentCatalog()-Key.
   Inhalte existieren noch nicht - bewusst leer angelegt, handgepflegt wie PRODUCTS/EXTRAS. Fehlende
   Felder zeigen einen "folgt in Kürze"-Platzhalter statt eine leere Seite (siehe renderBauteileDetail).
   Beispiel-Shape, wenn befuellt: sp200:{image:"https://...",description:"...",anleitung:"..."} */
/* Bilder kommen wie die Kit-Bilder aus Liquid (asset_url), siehe konfigurator-page.liquid. */
const KB_IMG = window.__BWP_KB_IMG_URLS || {};
/* Bilder einzelner Stücklisten-Positionen. Schlüssel = Anfang des Positionsnamens, damit die
   langen Herstellerbezeichnungen nicht doppelt gepflegt werden müssen. Es gibt nur für die
   Hauptkomponenten Herstellerbilder, Fittings und Kleinteile bleiben bewusst ohne. */
const POSITION_IMG = [
  ["Caleffi Schlammabscheider XF",        KB_IMG.schlammabscheider],
  ["Caleffi Isol. für Schlammabscheider", KB_IMG.schlamm_iso],
  ["Caleffi Sical-Center",                KB_IMG.sical],
  ["AE Hochleistungsspeicher",            KB_IMG.sp200],
  ["Lapesa HL-Speicher",                  KB_IMG.sp300],
  ["COSMO 3.0 Pumpengruppe ungemischt",   KB_IMG.pump_ungem],
  ["COSMO 2.0 Pumpengruppe DN 25 gemischt", KB_IMG.pump_gem],
  ["COSMO 3.0 Trennsystem",               KB_IMG.systr],
  ["DOYMAfix HP/O",                       KB_IMG.haus_ober],
  ["Dichteinsatz Curaflex Nova Senso",    KB_IMG.haus_unter]
];
function positionImg(name){
  const t=POSITION_IMG.find(([p])=>String(name).startsWith(p));
  return t && t[1] ? t[1] : null;
}

/* Technische Daten je Bauteil, ausschliesslich aus den Herstellerdatenblaettern im Ordner
   "DIY Produktdatenblaetter" (Abgleich 29.07.2026). Getrennt von COMPONENT_DETAILS gehalten,
   damit Beschreibungstext und Messwerte nicht vermischt werden - die Werte hier duerfen nie
   umformuliert werden, der Text darf es.
   Aufbau je Eintrag: modell (Herstellerbezeichnung), daten (Label/Wert-Paare), norm (Pruefungen
   und Normen), quelle (Dateiname des Datenblatts, damit jede Zahl rueckverfolgbar bleibt).
   WICHTIG: Wo ein Datenblatt schweigt, steht hier nichts. Nichts hochrechnen, nichts schaetzen. */
const COMPONENT_TECHNIK = {
  "lu_HYDROBOX-INNENEINHEIT":{ modell:"Fox ESS HP3 Box-E-WL",
    daten:[["Stromversorgung","380–415 V 3N~50 Hz"],["Nennleistung","9.510 W"],
      ["Nennstrom","14,5 A"],["Elektroheizstab","9 kW"],
      ["Interner Wasserinhalt","50 l"],
      ["Abmessungen (B×H×T)","650 × 1600 × 560 mm"],
      ["Nettogewicht","145 kg"],["Bruttogewicht","171 kg"],
      ["Pumpe zur Außeneinheit","DC-Inverter-Hocheffizienzpumpe"],
      ["Sicherungsgruppe","BA-Rückflussverhinderer und Druckminderungsventil"],
      ["Kommunikation","Wi-Fi und LAN zum Netzwerk, RS485 zur Außeneinheit"],
      ["Bedienung","kabelgebundener Controller, App, Webportal"],
      ["Anschlüsse","Heizkreise und Speicher G 1\" · Trinkwasser G 3/4\""],
      ["Umgebungstemperatur","5 bis 45 °C"]],
    norm:"Enthält die Sicherheitskomponenten, die sonst einzeln gesetzt werden müssten: Schmutzabscheider, Sicherheitsventil sowie Füll- und Nachspeiseeinheit mit Wasseraufbereitung.",
    quelle:"Fox ESS Hydro Box Datenblatt V2.0 (2026/06/12)" },
  sp200:{ modell:"AE BWS-1 200 B, Standspeicher",
    daten:[["Tatsächlicher Inhalt","207 l"],["Wärmetauscherfläche","0,92 m²"],
      ["Energieeffizienzklasse","B (ErP)"],["Zapfprofil","XL"],
      ["Zulässiger Betriebsdruck","max. 10 bar"],["Schutzanode","Magnesium 1¼\" nach DIN 4753-3"],
      ["Wärmetauscher","elliptisches Rohr, große Übertragungsfläche"],
      ["Anschlüsse","Kaltwasser 1\" AG · Warmwasser 1\" IG · Vor-/Rücklauf 1\" IG · Zirkulation ¾\" IG"],
      ["Zusatzmuffe","1½\" auf ca. halber Höhe für einen Elektro-Einschraubheizkörper"]],
    norm:"DIN 4753-3 (Anode) · ErP-Klasse B",
    quelle:"AE Hochleistungsspeicher BWS-WP + 200 B" },

  sp300:{ modell:"Lapesa CV-300-HL, emailliert",
    daten:[["Nenninhalt","300 l"],["Wärmetauscherfläche","3,1 m²"],
      ["Ausführung","emailliert, Hochleistungsspeicher"],
      ["Anschlüsse","Kaltwasser-Eintritt und Zirkulation 1\" AG · Vor-/Rücklauf Wärmetauscher 1\" IG · Warmwasser 1\""],
      ["EAN","8430352607565"]],
    quelle:"Lapesa CV-300-HL Datenblatt" },

  haus_ober:{ modell:"DOYMAfix HP/O DN 200",
    daten:[["Kernbohrung / Futterrohr","Ø 199–204 mm, max. 220 mm"],
      ["Wanddicke","120–500 mm, per Segment beliebig verlängerbar"],
      ["Innen- und Außenabdichtung","Ø 300 mm"],
      ["Kupferrohre","max. 2 Leitungen je 22, 28, 35 oder 42 mm"],
      ["Kabel","max. 4 Leitungen je 5–17 mm"],
      ["Kältemittelleitungen (Zubehör)","¼\", ⅜\", ½\", ⅝\""],
      ["Besonderheit","Spannungs- und Steuerleitungen getrennt geführt, thermisch getrennt gegen Wärmebrücken"]],
    norm:"GEG-konform · Luftdichtheit nach EN 12114, bewertet nach DIN 4108-2 · Schlagregendichtheit in Anlehnung an EN 1027 · Schalldämmung nach DIN EN ISO 10140-2 · gasdicht, dadurch Installation im R290-Schutzbereich möglich",
    quelle:"DOYMAfix HP/O DN 200 Datenblatt" },

  haus_unter:{ modell:"DOYMA Curaflex Nova Senso DN 200",
    daten:[["Nennweite","DN 200"],["Medienrohr-Durchmesser","139–141 mm"],
      ["Dichtbreite","45 mm"],["Abwinklung der Medienrohre","bis 8°"],
      ["Dichtring","EPDM mit Butyl-Einlage (DOYMA-Grip)"],
      ["Schrauben","Edelstahl A4"],
      ["Wartung","dauerhaft dicht ohne Nachspannen"],
      ["Einsatz","bauseitiges Futterrohr oder Kernbohrung in WU-Beton (Weiße Wanne)"]],
    norm:"Geprüft nach FHRK-Prüfgrundlage GE 101 in DN 200 ohne radiale Last (Nr. G 30 322-2-8, FHRK 45 D10) · gas- und wasserdicht · radondicht nach FHRK-Merkblatt MB 101, erfüllt die Anforderungen für Radonvorsorgegebiete",
    quelle:"Curaflex Nova Senso DN 200 Datenblatt" },

  peri_basic:{ modell:"Caleffi XF Serie 577 + Caleffi SiCal-Center Serie 5288",
    daten:[["Schlammabscheider","Caleffi XF 1¼\" IG, dreistufig: Trenngewebe, Zentralmagnet, Schmutzfänger"],
      ["Siebmaschenweite","160 µm"],["Magnetische Stärke","3 × 0,475 T"],
      ["Inhalt des Körpers","0,53 l"],["Betriebsdruck Abscheider","max. 3 bar"],
      ["Temperaturbereich Abscheider","0–90 °C"],["Max. Glykolgehalt","30 %"],
      ["Sicherheitscenter","Ausdehnungsgefäß 12 l, Vordruck 4 bar, Anschluss ¾\" IG"],
      ["Sicherheitsventil","10 bar, TÜV-geprüft"],
      ["Betriebsdruck Sicherheitscenter","max. 10 bar, max. 70 °C"],
      ["Max. Heizleistung Warmwasserbereiter","150 kW"],
      ["Wartung","interne Reinigungsbürsten, ohne die Anlage abzuschalten"]],
    norm:"Sicherheitsgruppe nach DIN EN 1488 · Ausdehnungsgefäß nach DIN 4807 · Warmwasseranlage nach DIN 1988",
    quelle:"Caleffi XF Serie 577 · Caleffi SiCal-Center 12 l" },

  pump_gem:{ modell:"COSMO 3.0 Pumpengruppe DN 25, gemischt, mit COSMO CPH 2.0 6-25",
    daten:[["Nennweite","DN 25"],["Pumpe","COSMO CPH 2.0 6-25, Hocheffizienz"],
      ["Mischer","3-Wege, mit Stellantrieb CSM1"],
      ["Stellantrieb","230 V, 120 s für 90° Drehwinkel, 6 Nm"],
      ["Anlegethermostat","30–90 °C, im Lieferumfang"],
      ["Anschluss","28 mm Press auf 1½\" Überwurf"],
      ["Montage","schallentkoppelte COSMO-Wandhalterung"]],
    quelle:"COSMO 3.0 Pumpengruppe gemischt DN 25, Montageanleitung" },

  pump_ungem:{ modell:"COSMO 3.0 Pumpengruppe DN 25, ungemischt, mit COSMO CPH 2.0 6-25",
    daten:[["Nennweite","DN 25"],["Pumpe","COSMO CPH 2.0 6-25, Hocheffizienz"],
      ["Mischer","keiner - Kreis läuft direkt auf Vorlauftemperatur der Wärmepumpe"],
      ["Anschluss","28 mm Press auf 1½\" Überwurf"]],
    quelle:"COSMO 3.0 Pumpengruppe ungemischt DN 25, Montage- und Betriebsanleitung" },

  systr:{ modell:"COSMO 3.0 Trennsystem DN 25 mit Plattenwärmetauscher, Pumpe Wilo Yonos Pico",
    daten:[["Nennweite","DN 25"],["Leistung Wärmetauscher","18 kW"],
      ["kvs-Wert","3,9 m³/h primär · 3,7 m³/h sekundär"],
      ["Max. Temperatur","95 °C"],["Pumpe","Wilo Yonos Pico"],
      ["Aufbau","ungemischte Pumpengruppe kombiniert mit Plattenwärmetauscher"],
      ["Erweiterbar","sekundärseitig um einen zusätzlichen Kreis"]],
    quelle:"COSMO 3.0 Trennsystem DN 25, 18 kW, Montage- und Betriebsanleitung" },

  homematic:{ modell:"Homematic IP Home Control Unit HmIP-HCU1 (eQ-3)",
    daten:[["Versorgung","Steckernetzteil 5,1 V DC (SELV), Eingang 100–240 V AC / 50 Hz"],
      ["Leistungsaufnahme im Ruhebetrieb","2,0 W"],["Stromaufnahme","max. 2600 mA"],
      ["Abmessungen (B×H×T)","96 × 173 × 96 mm"],["Gewicht","510 g"],
      ["Funk-Frequenzband","868,0–868,6 MHz und 869,4–869,65 MHz"],
      ["Funk-Freifeldreichweite","typ. 400 m"],
      ["WLAN","2,4 GHz (802.11b/g/n, 150 Mbit/s) und 5 GHz (802.11n/ac, max. 433 Mbit/s)"],
      ["Netzwerk","10/100 Mbit/s, Auto-MDIX"],["USB","2 × USB-Host"],
      ["Schutzart","IP20"],["Umgebungstemperatur","5 bis 40 °C"],
      ["Artikelnummer","160322A0 (weiß) · 160692A0 (anthrazit)"]],
    quelle:"Homematic IP HmIP-HCU1 Datenblatt" },

  eq3_hk:{ modell:"Homematic IP Heizkörperthermostat kompakt HmIP-eTRV-C-2",
    daten:[["Versorgung","2 × 1,5 V LR06/AA"],["Batterielebensdauer","typ. 5 Jahre"],
      ["Stromaufnahme","max. 100 mA"],["Gewindeanschluss","M30 × 1,5 mm, inkl. Demontageschutz"],
      ["Abmessungen (B×H×T)","51 × 98 × 48 mm"],["Gewicht","172 g inkl. Batterien"],
      ["Funk-Frequenzband","868,0–868,6 MHz und 869,4–869,65 MHz"],
      ["Funk-Freifeldreichweite","typ. 250 m"],
      ["Schutzart","IP20"],["Umgebungstemperatur","0 bis 50 °C"],
      ["Bedienung","ausschließlich per App, Wandthermostat oder Sprachsteuerung - geschlossenes Gehäuse gegen Verstellen"]],
    quelle:"Homematic IP HmIP-eTRV-C-2 Produktdatenblatt" },

  eq3_stell:{ modell:"Homematic IP Stellantrieb motorisch HmIP-VDMOT",
    daten:[["Versorgungsspannung","3,3 V DC (SELV)"],["Stromaufnahme","max. 120 mA"],
      ["Ventiladapter","VA 80, Gewindemaß M30 × 1,5 mm"],
      ["Regelung","stufenlos über den Fußbodenheizungscontroller"],
      ["Betrieb","zusammen mit dem Fußbodenheizungscontroller, wahlweise ohne Zentrale"]],
    quelle:"Homematic IP HmIP-VDMOT Produktdatenblatt" },

  eq3_klemm:{ modell:"Homematic IP Fußbodenheizungscontroller 8 Kanäle, motorisch HmIP-FALMOT-C8",
    daten:[["Versorgungsspannung","230 V / 50 Hz"],["Stromaufnahme","max. 500 mA"],
      ["Anzahl Heizzonen","8"],["Abmessungen (B×H×T)","135 × 85 × 52 mm"],
      ["Gewicht","247,2 g"],["Schutzklasse","II"],["Schutzart","IP20"],
      ["Umgebungstemperatur","0 bis 50 °C"],
      ["Funk-Frequenzband","868,0–868,6 MHz und 869,4–869,65 MHz"],
      ["Funk-Freifeldreichweite","typ. 340 m"],
      ["Besonderheit","automatischer hydraulischer Abgleich der angeschlossenen Heizkreise"]],
    quelle:"Homematic IP HmIP-FALMOT-C8 Produktdatenblatt" },

  eq3_dose:{ modell:"Homematic IP Schaltsteckdose HmIP-PS-2",
    daten:[["Versorgungsspannung","230 V / 50 Hz"],["Stromaufnahme","max. 13 A"],
      ["Max. Schaltleistung","2990 W (ohmsche Last)"],
      ["Leistungsaufnahme im Ruhebetrieb","< 0,2 W"],
      ["Relais","1 × Schließer, 1-polig, µ-Kontakt"],
      ["Abmessungen (B×H×T)","70 × 70 × 39 mm ohne Netzstecker"],["Gewicht","154 g"],
      ["Schutzklasse","I"],["Schutzart","IP20"],["Umgebungstemperatur","-10 bis +35 °C"],
      ["Funk-Freifeldreichweite","typ. 400 m"]],
    quelle:"Homematic IP HmIP-PS-2 Produktdatenblatt" }
};

/* Bauteil-Detailseiten. Alle Angaben stammen aus den Herstellerdatenblättern im Ordner
   "DIY Produktdatenblätter" (Abgleich 28.07.2026). Nichts hier ist frei formuliert - wo ein
   Datenblatt schweigt, steht nichts. Fehlende Felder zeigen weiterhin den "folgt"-Hinweis. */
const COMPONENT_DETAILS = {
  /* Der Schluessel traegt das lu_-Praefix, weil die Hydraulikstation keinen eigenen
     Verkaufspreis hat und ueber LIEFERUMFANG/LU_DETAILS in den Katalog kommt. */
  "lu_HYDROBOX-INNENEINHEIT":{
    description:"Die Inneneinheit des Kits. Sie fasst zusammen, was sonst einzeln an die Wand müsste: Pufferspeicher, Ausdehnungsgefäß für den Heizkreis, Elektroheizstab, Schmutzabscheider, Sicherheitsventil, Füll- und Nachspeiseeinheit sowie die hydraulische Verteilung auf Direkt- und Mischkreis. Alles vorkonfiguriert, damit beim Einbau nur noch die Rohre angeschlossen werden.",
    anleitung:"Wandmontage. Angeschlossen werden Vor- und Rücklauf zur Außeneinheit, Heizkreis 1 direkt, Heizkreis 2 über die Pumpengruppe sowie Vor- und Rücklauf zum Warmwasserspeicher - alle in G 1\", der Trinkwasseranschluss in G 3/4\". Die Steuerung läuft über den kabelgebundenen Controller, die App oder das Webportal; Wi-Fi und LAN sind eingebaut, zur Außeneinheit geht ein RS485-Kabel."},
  sp200:{ image:KB_IMG.sp200,
    description:"Brauchwasserspeicher AE BWS-1 200 B. Laut Datenblatt 207 Liter tatsächlicher Inhalt, Wärmetauscherfläche 0,92 m², Energieeffizienzklasse B, Zapfprofil XL. Elliptischer Wärmetauscher für kurze Aufheizzeiten, Magnesiumanode 1¼\" nach DIN 4753-3, zulässiger Betriebsdruck bis 10 bar.",
    anleitung:"Standspeicher mit verstellbaren Füßen. Anschlüsse: Kaltwasser 1\" AG, Warmwasser 1\" IG, Vor- und Rücklauf Wärmeübertrager 1\" IG, Zirkulation 3/4\" IG. Serienmäßige 1½\"-Muffe auf halber Höhe für einen Elektro-Einschraubheizkörper. Kippmaß beim Einbringen: 1414 mm."},
  sp300:{ image:KB_IMG.sp300,
    description:"Lapesa Hochleistungsspeicher CV-300-HL, emailliert, 300 Liter. Wärmetauscherfläche 3,1 m² - mehr als das Dreifache des 200er, was bei den niedrigen Vorlauftemperaturen einer Wärmepumpe zählt.",
    anleitung:"Anschlüsse laut Datenblatt: Kaltwasser und Warmwasser 1\", Vor- und Rücklauf Wärmetauscher 1\" IG, Zirkulation 1\" AG."},
  haus_ober:{ image:KB_IMG.haus_ober,
    description:"DOYMAfix HP/O DN 200: schlagregendichte Wanddurchführung für oberirdische Gebäudeaußenwände, ausdrücklich für Luft-Wasser-Wärmepumpen. Integrierte Wärmedämmung erfüllt die GEG-Forderung. Rohre und Kabel werden getrennt geführt, Spannungs- und Steuerleitung separat.",
    anleitung:"Segmentbauweise, die Länge lässt sich an den Wandaufbau anpassen. Laut Hersteller als Ein-Personen-Montage ausgelegt, Einbau direkt nach Fertigstellung der Wand möglich, in allen gängigen Wandaufbauten einsetzbar."},
  haus_unter:{ image:KB_IMG.haus_unter,
    description:"Doyma Curaflex Nova Senso DN 200 für 139-141 mm: Dichteinsatz für die Durchdringung, geeignet für drückendes und nichtdrückendes Wasser. Einsatz im bauseitigen Futterrohr oder in einer Kernbohrung in WU-Beton. Gas- und wasserdicht, geprüft nach FHRK-Prüfgrundlage GE 101 in DN 200.",
    anleitung:"Das ITL-System stellt den Anpressdruck her und lässt sich mit dem Akkuschrauber montieren. Die STS-Ausführung dichtet schonend ab und ist damit für flexible vorisolierte Rohre gemacht. Dauerhaft dicht ohne Nachspannen, also wartungsfrei."},
  peri_basic:{ image:KB_IMG.schlammabscheider,
    description:"Das Peripherie-Set bündelt die Armaturen rund um die Hydraulik. Kernstück ist der Caleffi XF der Serie 577: ein selbstreinigender Schmutzfänger und Schlammabscheider, der das Wasser in drei Stufen behandelt - erst ein Trenngewebe, dann ein zentraler Magnet, zuletzt ein Schmutzfänger im Auslass.",
    anleitung:"Der Abscheider ist drehbar und passt damit auf waagrechte wie senkrechte Leitungen. Die Wartung erfolgt über interne Reinigungsbürsten, ohne die Anlage abzuschalten. Dazu kommen im Set Füllkombination, Kugelhähne, Wellrohre und die Isolierung."},
  pump_gem:{ image:KB_IMG.pump_gem,
    description:"COSMO Pumpengruppe DN 25, gemischt, mit COSMO-Pumpe CPH 2.0 6-25 und Mischer. Für einen Heizkreis, dessen Vorlauftemperatur geregelt werden soll, etwa eine Fußbodenheizung neben Heizkörpern.",
    anleitung:"Der 3-Punkt-Stellantrieb CSM1 arbeitet mit 230 V, braucht 120 Sekunden für 90 Grad Drehwinkel und bringt 6 Nm. Montage auf der schallentkoppelten COSMO-Wandhalterung, Anlegethermostat 30-90 °C liegt bei."},
  pump_ungem:{ image:KB_IMG.pump_ungem,
    description:"COSMO Pumpengruppe DN 25, ungemischt, mit COSMO-Pumpe CPH 2.0 6-25. Für einen Heizkreis, der direkt mit der Vorlauftemperatur der Wärmepumpe gefahren wird.",
    anleitung:"Ohne Mischer und ohne Stellantrieb, entsprechend weniger Teile als die gemischte Gruppe. Anschluss über Verschraubungen 28 mm Press auf 1½\" Überwurf."},
  systr:{ image:KB_IMG.systr,
    description:"COSMO Trennsystem DN 25 mit Plattenwärmetauscher und Wilo-Pumpe Yonos Pico, ausgelegt auf 18 kW. Trennt den Kreis der Wärmepumpe hydraulisch vom Bestandskreis - sinnvoll, wenn die vorhandene Anlage nicht zum Wasser der neuen passt.",
    anleitung:"Die Montage- und Betriebsanleitung des Herstellers umfasst 40 Seiten und behandelt unter anderem Umkehrbarkeit des Aufbaus, Position und Temperatur des Ausdehnungsgefäßes sowie den Einbau der Sicherheitsgruppe. Der Pumpentausch ist dort ausdrücklich als Arbeit mit Fachkenntnissen gekennzeichnet."},
  homematic:{
    description:"Homematic IP Home Control Unit HmIP-HCU1 von eQ-3: die Zentrale, die alle Funk-Komponenten verbindet. Steuerung über die Homematic IP App, wahlweise über die Cloud oder rein lokal. Lokale Datensicherung und Messdatenspeicherung sind möglich.",
    anleitung:"Systemvoraussetzung laut Datenblatt: ein Router mit WLAN oder freiem LAN-Port sowie eine Internetverbindung für die Erstinbetriebnahme. Danach ist auch lokaler Betrieb möglich."},
  eq3_hk:{
    description:"Homematic IP Heizkörperthermostat. Ersetzt den vorhandenen Thermostatkopf am Heizkörper und regelt ihn über die Home Control Unit."},
  eq3_stell:{
    description:"Homematic IP Stellantrieb für die Fußbodenheizung. Sitzt am Heizkreisverteiler und öffnet oder schließt den einzelnen Heizkreis."},
  eq3_klemm:{
    description:"Homematic IP Regelklemmleiste für den Wandaufbau. Bindet die Stellantriebe am Heizkreisverteiler zusammen und schaltet sie."},
  eq3_dose:{
    description:"Homematic IP Schaltsteckdose, die zugleich als Verstärker im Funknetz arbeitet. Hilft, wenn die Zentrale einzelne Komponenten nicht zuverlässig erreicht."}
};
let chosenExtras={}; /* k → 1 (Checkbox/Radio) bzw. Meter (Erdleitung) */
function extrasSumme(){ return Object.entries(chosenExtras).reduce((a,[k,q])=>a+(EXTRAS[k]?EXTRAS[k].price*q:0),0); }
/* Gruppen-Sicht für Checkout-Zeilen: {Gruppe: {sum, teile:[...]}} */
function extrasGruppen(){
  const g={};
  Object.entries(chosenExtras).forEach(([k,q])=>{
    const e=EXTRAS[k]; if(!e||!q) return;
    if(!g[e.group]) g[e.group]={sum:0,teile:[]};
    g[e.group].sum+=e.price*q;
    g[e.group].teile.push(e.perMeter?`${q} m ${e.name}`:(e.perUnit?`${q}× ${e.name}`:e.name));
  });
  return g;
}
/* Fertigfundament gekauft → Fundament-Eigenleistung zählt nicht mehr (man baut es nicht selbst) */
function eigenleistungSumme(){ return Object.entries(eigenBetraege).reduce((a,[k,v])=>a+((k==='fundament'&&chosenExtras.fundament)?0:(v||0)),0); }
/* DIE ABHOLUNG IST AM 28.10.2026 ENTFALLEN (Vorgabe Claras: "entferne ausserdem die
   Moeglichkeit der Abholung, also auch dass man da einen Button auswaehlen muss, sondern es
   soll einfach da stehen, dass die Lieferung den Betrag kostet"). Es gibt nur noch die
   Lieferung zu 239,99 EUR, und sie wird nicht mehr gewaehlt, sondern angesagt.

   DIE GEBUEHR HAENGT NICHT MEHR AN A.delivery - DAS IST DER SICHERHEITSGURT. Rund zwanzig
   Stellen rechnen mit deliveryFee(): Kaufbox, Direktkauf, Warenkorb, Zahlungsplan, Kassen-
   Eigenschaften, Amortisation. Haette die Funktion weiter auf das Feld gesehen, waere jeder
   alte Stand mit delivery:'abholung' - aus localStorage, aus einem geteilten Link, aus einem
   liegengebliebenen Warenkorb - mit kostenloser Lieferung durchgelaufen. Jetzt kostet sie
   immer, egal was im Feld steht.

   BEWUSST NICHT Teil der Förderbasis (siehe updateTotal/checkout: deliveryFee() fließt NUR in die
   angezeigte/gebuchte Gesamtsumme, nie in die KfW-458-Berechnungsgrundlage - Logistik ist nicht foerderfähig). */
const DELIVERY_FEE=239.99;
/* Der Abholort stand ueberall dort, wo Abholung auftauchte - Rechenzettel, Kaufbox,
   Erklaertour, Kassenzeile. Die Konstante bleibt als Lagerangabe stehen, wird aber seit dem
   28.10.2026 nirgends mehr angezeigt. */
const ABHOLORT='59425 Unna';
function deliveryFee(){ return DELIVERY_FEE; }
/* MIT CENT, AN EINER STELLE. eur() rundet auf volle Euro (fmt ohne Nachkommastellen) - aus
   239,99 wuerde dort "240 €". Solange der Betrag als fester Text im Code stand, fiel das nicht
   auf; seit er am 28.10.2026 aus der Konstante kommt, haetten drei Anzeigen auf einmal einen
   falschen Preis gezeigt. Gefunden beim Durchlauf, nicht beim Lesen. */
function lieferPreisText(){ return fmt(DELIVERY_FEE,2)+' €'; }

/* ================= RABATTCODE (15.09.2026, Betreiber-Entscheid) =================
   Ein Code fuer alle, im Format XXXXX-XXXXX-10BWP. Er sieht zufaellig aus, ist aber ein
   fester Wert aus den Theme-Einstellungen - austauschbar ohne Push.

   OFFEN GESAGT: ein Code, der im Browser geprueft wird, steht im ausgelieferten Skript.
   Wer ihn sucht, findet ihn. Fuer einen Marketing-Code ist das vertretbar; er ist ein
   Anreiz, kein Schloss. Was zaehlt, ist die Gegenprobe gegen das CRM bei der Rechnung.

   WO DER ABZUG ANGREIFT: auf der Summe VOR der Liefergebuehr. Logistik wird nicht
   rabattiert - dieselbe Grenze, die schon fuer die Foerderbasis gilt (siehe deliveryFee()).

   DIE FOERDERBASIS SINKT MIT. Das ist eine bewusste Entscheidung und keine Nachlaessigkeit:
   bliebe sie stehen, zeigte die Seite einen Zuschuss auf Kosten, die der Kunde nie hatte -
   und bei kleinem Warenkorb laege der "Preis nach Foerderung" UEBER dem rabattierten
   Gesamtpreis. Zwei Zeilen untereinander, die sich widersprechen.
   Folge, die man aussprechen muss: der Kunde spart real weniger als die genannten Prozente.
   Bei 70 % Foerderquote bleiben von 10 % Rabatt rund 3 % Ersparnis. Deshalb darf die Seite
   "10 % Rabatt" sagen und niemals "10 % sparen" - das waere nach Paragraf 5 UWG angreifbar.

   EINE RUNDUNGSREGEL FUER ALLE: volle Euro. Sechs Summenstellen rechnen im Bestand
   unabhaengig voneinander dasselbe nach; unterschiedliche Rundung waere ein Widerspruch
   zwischen zwei Zahlen auf demselben Bildschirm.

   DIE FRIST IST ECHT ODER SIE IST NICHT DA - dieselbe Mechanik wie beim CLOSER. Nach
   Fristablauf liefert rabattProzent() 0, und zwar ueberall zugleich, auch bei einem alten
   Kauflink. Es gibt keinen Ersatzwert, auf den etwas zurueckfallen koennte. */
const RABATT = (function(){
  var r = (typeof window!=='undefined' && window.BWP_RABATT) || {};
  var p = parseFloat(r.prozent);
  if(!r.aktiv || !(p>0) || !String(r.code||'').trim()) return null;
  return { code: String(r.code).trim().toUpperCase(), prozent: p,
           gueltig_bis: String(r.gueltig_bis||'').trim() || null,
           /* versand=false: der Ablauf laeuft vollstaendig durch und zeigt den Code, aber es
              geht kein Lead raus. Fuer den Aufbau, bevor die Gegenstelle in n8n steht. */
           versand: r.versand===true,
           bezug: String(r.bezug||'').trim() || null };
})();
/* Wird gesetzt durch die Eingabe im Kaufweg, durch den gespeicherten Stand oder durch den
   Kauflink aus der Mail. NIE als Startwert true - ein Rabatt, den niemand eingeloest hat,
   waere eine Preissenkung und keine Aktion. */
let rabattAktiv=false;
/* ============ ZWEITER CODE: FESTER BETRAG AB MINDESTWERT (28.09.2026, Betreiber-Entscheid) ============
   Kooperationscode DIY-FACHWERKER: 1.300 EUR fest ab 8.000 EUR Warenkorb. Gepflegt wie der
   Prozentcode in der Section billigerwaermepumpe-rabatt-balken (window.BWP_RABATT.koop) - Code,
   Betrag, Mindestwert, Frist und Anzeigename sind ohne Push austauschbar.

   EIN CODE ZUR ZEIT. Die beiden addieren sich nicht. Eingeloest ist genau einer
   (rabattGewaehlt), und alles, was rechnet, fragt ueber rabattWirksam() nach genau diesem.
   rabattGewaehlt=null heisst weiterhin "der Prozentcode" - so wirkt jede Stelle, die nur
   rabattAktiv setzt, unveraendert, und der Prozentpfad rechnet Cent fuer Cent wie vorher.

   DER MINDESTWERT HAENGT AN DERSELBEN SUMME, VON DER DER RABATT ABGEHT: Kit, Speicher,
   Services und Zubehoer, OHNE Lieferung (Logistik ist weder rabattiert noch foerderfaehig,
   siehe deliveryFee()). Jede Anzeige prueft auf ihrer eigenen Summe - Kette, Schublade und
   Kasse gehen damit jede fuer sich auf, statt einen Abzug zu zeigen, dessen Bedingung auf dem
   Bildschirm nicht erfuellt ist. Folge im Hardware-Schritt: ein Kit ohne Speicher liegt dort
   unter 8.000 EUR, obwohl die fertige Bestellung mit den Pflichtservices darueber liegt
   (fox8 + Pflichtservices 8.397 EUR). Der Hinweis in rabattZeileAnzeigen() sagt das dazu.

   DIE FOERDERBASIS SINKT UM DEN VOLLEN BETRAG - sie ist an allen Stellen genau die Summe, von
   der der Abzug abgeht. Begruendung wie oben: keine Foerderung auf Kosten, die nie entstehen.

   UNTER DEM MINDESTWERT bleibt der Code eingeloest und zieht nichts ab. Wer Zubehoer
   dazunimmt oder in den Services-Schritt wechselt, soll ihn nicht ein zweites Mal tippen. */
/* "1.300" und "8.000" sind im Theme-Editor Tausender, keine Dezimalstellen - parseFloat laese
   daraus 1,3 und 8 EUR. */
function euroAusEinstellung(s){
  var t=String(s==null?'':s).replace(/[\s€]/g,'').replace(/\.(?=\d{3}(?:\D|$))/g,'').replace(',','.');
  return parseFloat(t);
}
const RABATT_KOOP = (function(){
  var w = (typeof window!=='undefined' && window.BWP_RABATT) || {};
  var r = w.koop || {};
  var b = Math.round(euroAusEinstellung(r.betrag)), m = euroAusEinstellung(r.mindest);
  if(!r.aktiv || !(b>0) || !String(r.code||'').trim()) return null;
  return { art:'fest', code: String(r.code).trim().toUpperCase(), betrag: b, mindest: (m>0 ? m : 0),
           gueltig_bis: String(r.gueltig_bis||'').trim() || null,
           name: String(r.name||'').trim() || null,
           /* Bezug wie beim Prozentcode: verrechnet wird beides auf der Schlussrechnung. */
           bezug: String(w.bezug||'').trim() || null };
})();
const RABATT_CODES = [RABATT, RABATT_KOOP].filter(Boolean);
let rabattGewaehlt=null;
/* Was checkout()/cartAddDirect() zuletzt als Abzug gebucht haben - fuer das Bestell-Attribut
   des festen Codes, siehe attrAttributes(). */
let rabattGebucht=0;
function codeFristOffen(c){
  if(!c || !c.gueltig_bis) return true;
  var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(c.gueltig_bis);
  if(!m) return false;                     /* unlesbare Frist = keine Aktion, nicht "unbefristet" */
  var jahr=+m[1], monat=+m[2], tag=+m[3];
  var ende=new Date(jahr,monat-1,tag); ende.setHours(23,59,59,999);
  /* Faengt den 31.02. ab: JS rollt so ein Datum still in den Maerz weiter. */
  if(isNaN(ende.getTime()) || ende.getDate()!==tag || ende.getMonth()!==monat-1) return false;
  return new Date() <= ende;
}
/* Frist des Prozentcodes - daran haengt der Balken der Startseite. */
function rabattFristOffen(){ return codeFristOffen(RABATT); }
/* Der eingeloeste Code, solange seine Frist laeuft - sonst null. */
function rabattWirksam(){
  if(!rabattAktiv) return null;
  var c = rabattGewaehlt || RABATT;
  return (c && codeFristOffen(c)) ? c : null;
}
function rabattProzent(){ var c=rabattWirksam(); return (c && c.art!=='fest') ? c.prozent : 0; }
function rabattBetrag(basis){
  var c=rabattWirksam();
  if(!c || !(basis>0)) return 0;
  if(c.art==='fest') return basis>=c.mindest ? Math.min(c.betrag, Math.floor(basis)) : 0;
  return Math.round(basis*c.prozent/100);
}
function rabattCode(){ var c=rabattWirksam(); return c ? c.code : (RABATT ? RABATT.code : null); }
/* Was neben dem Abzug steht: "10 %" beim Prozentcode, Name oder Code beim festen Betrag -
   jeweils mit dem Bezug. Beim Prozentcode Zeichen fuer Zeichen der Text von vorher; luecke,
   weil die Schublade vor dem % ein geschuetztes Leerzeichen setzt und alle anderen Stellen
   ein normales. */
function rabattText(luecke){
  var c=rabattWirksam(); if(!c) return '';
  return (c.art==='fest' ? (c.name||c.code) : c.prozent+(luecke||' ')+'%') + (c.bezug ? ' · '+c.bezug : '');
}
/* Vergleich bewusst grosszuegig: Gross-/Kleinschreibung und Leerzeichen egal. Wer den Code
   aus einer Mail kopiert, bringt haeufig ein Leerzeichen mit - daran soll nichts scheitern. */
function codeNorm(s){ return String(s||'').trim().toUpperCase().replace(/\s+/g,''); }
function codeFinden(eingabe){
  var e=codeNorm(eingabe); if(!e) return null;
  for(var i=0;i<RABATT_CODES.length;i++){ if(codeNorm(RABATT_CODES[i].code)===e) return RABATT_CODES[i]; }
  return null;
}
/* Einloesen und Zuruecknehmen. BEWUSST Funktionen und kein direkter Zugriff auf
   rabattAktiv: der Zustand haengt an drei Quellen - Eingabefeld, gespeicherter Stand und
   Kauflink aus der Mail - und darf nur ueber einen Weg gesetzt werden, sonst laufen sie
   auseinander. Gibt true zurueck, wenn der Code gegriffen hat. */
function rabattEinloesen(eingabe){
  var c=codeFinden(eingabe);
  if(!c || !codeFristOffen(c)) return false;
  rabattGewaehlt=c; rabattAktiv=true;
  return true;
}
function rabattZuruecknehmen(){ rabattAktiv=false; rabattGewaehlt=null; }
function rabattCodePasst(eingabe){ var c=codeFinden(eingabe); return !!(c && codeFristOffen(c)); }
/* Rabattlage in Token und gespeichertem Stand (rb): 0 = keiner, 1 = der Prozentcode - so seit
   dem 16.09.2026, alte Links bleiben gueltig -, beim festen Betrag der Code selbst. Nie Satz
   oder Betrag: die kommen immer frisch aus den Einstellungen. */
function rabattRb(){
  if(!rabattAktiv) return 0;
  var c=rabattGewaehlt||RABATT;
  return (c && c.art==='fest') ? c.code : 1;
}
/* Umkehrung. null bei keinem Code - oder bei einem, den es nicht mehr gibt: dann rechnet der
   Rueckkehrer ohne Abzug, die Preisdrift-Pruefung schlaegt an, und er sieht seine Kaufbox statt
   der Kasse. */
function rabattAusRb(rb){
  if(!rb) return null;
  return typeof rb==='string' ? codeFinden(rb) : RABATT;
}
/* ============ RABATTCODE AUS DER ADRESSZEILE (16.09.2026) ============
   Die Willkommensmail verlinkte bis heute nur "Zum Rechner" und bat den Kunden, den Code
   einzutippen. Er kam damit mit dem Code in der Zwischenablage auf der Startseite an - und
   ein Eingabefeld gibt es erst in der Kaufbox, also mehrere Schritte spaeter. Genau dort, wo
   er gerade bestaetigt hat und kaufen will, stand er vor einer Seite ohne Feld.

   Jetzt traegt der Link den Code: ?rabatt=<CODE>. Dass er offen in der Adresszeile steht, ist
   unkritisch - es ist ein geteilter Code, der ohnehin im ausgelieferten Skript steht. Das
   Eingabefeld bleibt als Rueckfallebene fuer den, der abtippt.

   ZWEI SCHREIBWEISEN, weil Mailprogramme und Kunden Links weiterreichen: ?rabatt= und ?code=.

   HIER STAND BIS ZUM 24.09.2026 "NICHT BEI ?k=": Der Kauflink traegt seine eigene Rabattlage
   in rb und die damals gerechnete Summe in gs. Ein zusaetzlich eingeloester Code haette die
   Summe veraendert und die Preisdrift-Pruefung anschlagen lassen. Deshalb wurde ?rabatt=
   neben ?k= stillschweigend VERWORFEN - der Kunde landete ohne Rabatt in seiner Konfiguration.

   DAS AENDERT SICH MIT DEM ENTSCHEID VOM 24.09.2026. Die Nachfass-Mail an Kunden mit
   gespeicherter Konfiguration traegt beides in EINEM Link: ?k=<Konfiguration>&rabatt=<Code>.
   Wuerde der Code hier weiter verworfen, bekaeme genau der Kunde, dem die Mail 10 % verspricht,
   seine Konfiguration zum vollen Preis gezeigt.

   Die Preisdrift-Pruefung ist dafuer nicht abgeschaltet, sondern hat gelernt, womit sie
   vergleicht: direktZurKasse() rechnet die Vergleichssumme unter DERSELBEN Rabattlage, unter
   der der Token entstand (ausLinkRabatt), und erst danach gilt wieder die heutige. Eine echte
   Preisaenderung faellt damit weiter auf; ein frisch eingeloester Code nicht mehr. */
let rabattKamAusLink=false;
function rabattAusAdresszeile(){
  if(!RABATT_CODES.length) return '';
  try{
    const q=new URLSearchParams(location.search);
    return (q.get('rabatt') || q.get('code') || '').trim();
  }catch(e){ return ''; }
}
/* Loest den Code aus der Adresszeile ein. Wird VOR ladeAusLink()/ladeStand() gerufen, damit
   jede spaetere Zeichnung den Abzug schon kennt - eine Einloesung nach dem ersten Rendern
   haette eine Kaufbox mit veralteten Zahlen stehen lassen. */
function rabattLinkEinloesen(){
  const roh=rabattAusAdresszeile();
  if(!roh) return false;
  /* Frist je Code (28.09.2026): ein abgelaufener Prozentcode ist kein Grund, den festen
     abzuweisen - und umgekehrt. */
  const codeTreffer=codeFinden(roh);
  if(codeTreffer && !codeFristOffen(codeTreffer)){ track('rabatt_link_abgelaufen',{}); return false; }
  if(!rabattEinloesen(roh)){ track('rabatt_link_falsch',{}); return false; }
  rabattKamAusLink=true;
  track('rabatt_link_ok',{prozent:rabattProzent(), code:rabattCode()});
  return true;
}
/* ================= PREIS ERST BEI AUSWAHL (User-Entscheid 13.08.2026) =================
   Bis heute stand neben jeder waehlbaren Position ihr Preis, auch wenn sie gar nicht gewaehlt war.
   In einer Liste aus zehn Positionen liest sich das wie eine Rechnung ueber alles zusammen - der
   Kunde entscheidet dann gegen den Preis statt fuer das, was er braucht.
   Jetzt: der Betrag erscheint in dem Moment, in dem er die Position anhakt, und verschwindet beim
   Abwaehlen wieder. Die Gesamtsumme oben und unten aendert sich unveraendert mit, es wird also
   nichts verschleiert - der Preis ist einen Klick entfernt und sofort sichtbar.
   AUSNAHME 0 EUR: "inklusive" bleibt immer stehen. Das ist kein abschreckender Preis, sondern
   ein Argument - und ohne die Angabe saehe die Zeile aus, als fehle etwas.
   Die Mengen-Positionen (EQ3, Erdleitung) verhalten sich schon laenger so: dort steht die Summe
   erst ab Stueckzahl 1, der Einzelpreis bleibt im Tag, weil man ihn zum Mengenwaehlen braucht. */
/* zusatz: eine Angabe ZUM Preis, kein Teil von ihm - "pro Jahr" bei der Wartung (02.10.2026,
   Vorgabe Claras: "bei Jaehrliche Wartung bei dem Preis bitte den Preis und dahinter dann 'pro
   Jahr' schreiben, aber erst, wenn man es auch auswaehlt und der Preis erscheint").

   ER HAENGT AM PREIS UND NICHT AM NAMEN, deshalb steht er hier und nicht in der Zeile darueber:
   Ungewaehlt zeigt die Spalte gar nichts an - dann soll auch kein "pro Jahr" dastehen, sonst
   stuende dort eine Angabe ohne Zahl, auf die sie sich bezieht. Genau das hat Clara gemeint.

   DER WERT KOMMT AUS SERVICES[k].preisZusatz, derselbe Schluessel, den die Karte auf der
   Foerderseite schon liest. Eine zweite Stelle fuer dieselbe Angabe liefe beim naechsten Mal
   auseinander.

   ALS TEXT UND NICHT ALS MARKUP: Die Spalte wird an zwei Stellen ueber textContent gesetzt;
   ein <small> waere dort als Zeichenkette sichtbar geworden. */
function zeilenPreis(preis, gewaehlt, zusatz){
  if(!preis) return 'inklusive';
  if(!gewaehlt) return '';
  return '+ '+eur(preis)+(zusatz ? ' '+zusatz : '');
}
/* Haelt die Preisspalten an den Auswahl-Zeilen aktuell. Bewusst zentral und nicht in den einzelnen
   change-Handlern: es gibt vier davon (Services/Extras je Kaufweg), und einer wird beim naechsten
   Umbau garantiert vergessen. Laeuft bei jedem updateTotal mit, also bei jeder Aenderung. */
function syncZeilenPreise(scope){
  /* GELTUNGSBEREICH AUCH IM RECHNER-WEG (02.09.2026)
     Ohne scope stand hier "document" - die Funktion schrieb also in JEDE Zeile im Dokument,
     auch in die des anderen Kaufwegs. Das fiel bisher nicht auf, weil die beiden Wege auf
     verschiedenen SEITEN leben: die Rechner-Kaufbox auf der Startseite, der Direktkauf-Dialog
     auf /pages/produkt. Sobald beide Einstiege nebeneinander auf der Startseite stehen -
     genau das ist beschlossen - liegen beide Kauffaechen gleichzeitig im DOM, und updateTotal()
     wuerde die Preiszeilen des Dialogs mit dem Stand des Funnels ueberschreiben.
     #app ist die Wurzel des Rechner-Wegs (dieselbe, die auch die Erklaertour benutzt).
     Auf den heutigen Seiten aendert das nichts: dort stehen ohnehin alle Zeilen darin. */
  const wurzel = scope==='cm'
    ? document.getElementById('cartModalBody')
    : (document.getElementById('app') || document);
  if(!wurzel) return;
  wurzel.querySelectorAll('input[type=checkbox][data-k]').forEach(inp=>{
    const s=SERVICES[inp.dataset.k]; if(!s) return;
    const feld=(inp.closest('.buyline')||inp.closest('.svcline')||inp.parentElement)?.querySelector('.price');
    if(feld) feld.textContent=zeilenPreis(s.price, inp.checked, s.preisZusatz);
  });
  /* Die Öltank-Sammelzeile hat kein data-k - ihr Preis haengt am Auswahlfeld darunter, nicht
     am Haken davor. Ohne diesen Block bliebe dort der Betrag der zuletzt gewaehlten Variante
     stehen, auch nachdem im Feld auf eine andere umgestellt wurde. */
  wurzel.querySelectorAll('input[type=checkbox][data-oel]').forEach(inp=>{
    const row=inp.closest('.oel-row'); if(!row) return;
    const sel=row.querySelector('.oel-select');
    const k=sel && sel.value;
    const feld=(inp.closest('.buyline')||inp.closest('.svcline')||inp.parentElement)?.querySelector('.price');
    if(feld) feld.textContent = (k && SERVICES[k]) ? zeilenPreis(SERVICES[k].price, true) : '';
  });
  wurzel.querySelectorAll('input[type=checkbox][data-x]').forEach(inp=>{
    const k=inp.dataset.x, e=EXTRAS[k]; if(!e) return;
    const feld=(inp.closest('.buyline')||inp.parentElement)?.querySelector('.price');
    if(!feld) return;
    /* MENGEN-POSITIONEN ZEIGEN DIE SUMME, NICHT DEN EINZELPREIS (Fehlerbehebung 18.09.2026,
       von Clara gemeldet: "wenn ich die Meterzahl erhoehe, dann auch hier den Preis
       erhoehen").

       Der Regler rechnete richtig - set() schrieb '+ '+eur(q*e.price) in die Zeile. Nur rief
       er danach cmUpdateTotal(), und diese Funktion hier lief als Letzte und schrieb den
       EINZELPREIS darueber. Bei 2 m Erdleitung stand deshalb 95 € statt 190 €. Ein stiller
       Fehler: Die Gesamtsumme war immer richtig, nur die Zeile daneben log.

       Genau dafuer gibt es diese Funktion - "einer wird beim naechsten Umbau garantiert
       vergessen", siehe den Kommentar darueber. Sie muss die Menge also selbst kennen, statt
       sich darauf zu verlassen, dass eine andere Stelle sie vorher hineingeschrieben hat.

       Ungewaehlt bleibt der Einzelpreis stehen: zeilenPreis() gibt dann ohnehin eine leere
       Zeichenkette zurueck, und mit 0 statt e.price bekaeme eine kostenlose Position
       faelschlich "inklusive". */
    const q=chosenExtras[k]||0;
    const betrag=((e.perMeter||e.perUnit) && q>0) ? e.price*q : e.price;
    feld.textContent=zeilenPreis(betrag, inp.checked);
  });
}
function deliveryLabel(){ return `Lieferung deutschlandweit · ${lieferPreisText()}`; }
/* Komplettes Paket als Gruppen-Liste - EINE Quelle für die Bullet-Übersicht in der Buybox UND die
   Checkout-Zeilen (User-Entscheid 14.07.2026: jede Gruppierung sichtbar aufgelistet). So können
   Anzeige und Kassenzeilen nie auseinanderlaufen. */
function paketGruppen(kitKey){
  const z=[['Kit',`${PRODUCTS[kitKey].name} · ${eur(PRODUCTS[kitKey].price)}`]];
  const spKey=speicher();
  if(spKey) z.push(['Warmwasserspeicher',`${PRODUCTS[spKey].name.replace('Warmwasserspeicher ','')} · ${eur(PRODUCTS[spKey].price)}`]);
  z.push(['Services',[...chosenServices].map(k=>`${SERVICES[k].name} (${SERVICES[k].price?eur(SERVICES[k].price):'inklusive'})`).join(', ')||'keine']);
  Object.entries(extrasGruppen()).forEach(([g,info])=>z.push([g,`${info.teile.join(' + ')} · ${eur(info.sum)}`]));
  z.push(['Lieferung',deliveryLabel()]);
  /* Der Wunschstart als eigene Zeile, direkt hinter der Versandart - beides sind Angaben zum
     WANN und WIE, nicht zum WAS. Ohne Angabe keine Zeile. In BEIDEN Kaufwegen, sonst zeigte
     "Dein Paket im Detail" je nach Weg etwas anderes. */
  const startTextDetail=startWunschText();
  if(startTextDetail) z.push(['Start',startTextDetail]);
  return z;
}
/* Lieferumfang - 1:1 Montageanleitung v0.1 S.3 */
/* Abgesichert am 14.09.2026 - dieselbe Falle wie bei window.__BWP_IMG_URLS: Die Daten kommen
   aus der Section 'billigerwaermepumpe-lieferumfang'. Fehlt sie auf einer Seite, war
   LIEFERUMFANG undefined und effektiverLU() warf beim ersten .map() - mitten in
   renderCartModalIncluded, NACH dem Setzen der Huelle. Auf der Produktseite stand deshalb der
   Rahmen samt Schrittsteuerung da, aber keine einzige Position darin.
   Leer ist hier die richtige Notloesung: Die Auswahl funktioniert weiter, nur die Liste
   "Was drin ist" bleibt leer - statt dass die ganze Seite ohne Konfigurator dasteht. */
const LIEFERUMFANG = window.LIEFERUMFANG || [];
/* Zusatzinfos je Lieferumfang-Position für die Lieferumfang-Popup-Ansicht (Bild-Platzhalter + wofür's
   gebraucht wird). Reihenfolge 1:1 wie LIEFERUMFANG. PLATZHALTER: Fotos durch echtes Bildmaterial ersetzen. */
const LU_DETAILS = [
  {img:"Außeneinheit", purpose:"Die Wärmepumpe selbst, steht fertig befüllt vor dem Haus."},
  {img:"Hydraulikstation", sku:"HYDROBOX-INNENEINHEIT", purpose:"Verbindet Wärmepumpe, Speicher und Heizkreis, kommt an die Wand - Pufferspeicher ist laut Hydro-Box-Datenblatt schon eingebaut.", sku:"HYDROBOX-INNENEINHEIT"},
  {img:"Warmwasser­speicher", purpose:"Warmes Wasser aus der Leitung, Größe je nach Haushalt."}
];
/* Bugfix 23.07.2026: Warmwasserspeicher ist nicht im Kit enthalten, sondern ein separat bepreister
   Buyline-Posten (siehe PRODUCTS.sp200/sp300) - er darf in der Lieferumfang-Liste nur auftauchen,
   wenn der Kunde tatsächlich einen gewählt hat (speicher()!=null), vorher stand er dort immer drin.
   Zeigt außerdem die tatsächlich gewählte Größe (200 l oder 300 l) statt der generischen
   "200-300 l"-Platzhalter-Bezeichnung aus dem Lieferumfang-Block (User-Wunsch 23.07.2026). */
function effektiverLU(){
  const spKey = speicher();
  const spAktiv = !!spKey;
  const keep = LIEFERUMFANG.map(([q,n]) => spAktiv || !/Warmwasser/i.test(n));
  const list = LIEFERUMFANG.filter((_,i)=>keep[i]).map(([q,n])=>
    (spAktiv && /Warmwasser/i.test(n)) ? [q, PRODUCTS[spKey].name] : [q,n]
  );
  return { list, details: LU_DETAILS.filter((_,i)=>keep[i]) };
}

/* ---------- Live-Lieferumfang (User-Idee 12.08.2026) ----------
   Waehrend der Kunde Services und Material an- und abwaehlt, sieht er Preise, aber nirgends,
   WAS er dafuer bekommt. Die Liste stand bisher nur zugeklappt hinter "Dein Paket im Detail",
   also genau da, wo niemand nachsieht, der ohnehin zoegert.

   Bewusst OHNE Preise: die Zahl steht genau einmal, in der Kaufspalte. Dieses Feld beantwortet
   die andere Frage - "was bekomme ich?" - und soll ihr nicht mit einer vierten Summe ins Wort
   fallen. Was etwas kostet, steht Zeile fuer Zeile links daneben.

   Quellen sind dieselben wie in paketGruppen(): effektiverLU(), chosenServices, extrasGruppen(),
   deliveryLabel(). Wer dort einen Posten ergaenzt, sieht ihn hier automatisch - nur eine ganz
   neue Kategorie muesste an beiden Stellen nachgezogen werden.
   Eigenleistung steht bewusst NICHT drin: was der Kunde selbst baut, liefern wir nicht. */
function lieferumfangZeilen(kitKey){
  if(!kitKey || !PRODUCTS[kitKey]) return null;
  const gruppen=[];
  gruppen.push({titel:'Hardware', zeilen:effektiverLU().list.map(([q,n])=>({menge:String(q).trim(), name:n}))});
  const svc=[...chosenServices].filter(k=>SERVICES[k]).map(k=>({menge:'', name:SERVICES[k].name}));
  if(svc.length) gruppen.push({titel:'Services', zeilen:svc});
  const mat=Object.entries(extrasGruppen()).map(([g,info])=>({menge:'', name:g, teile:info.teile.join(' + ')}));
  if(mat.length) gruppen.push({titel:'Material', zeilen:mat});
  const anzahl=gruppen.reduce((a,g)=>a+g.zeilen.length,0);
  return {gruppen, anzahl, lieferung:deliveryLabel(), start:startWunschText()};
}
/* Die Liste als Markup. Sitzt zugeklappt unten in der Kaufbox, direkt ueber dem Kaufknopf.
   ZWISCHENSTAND 12.08.2026 verworfen: kurzzeitig stand dasselbe als klebende Spalte rechts neben
   der Kaufbox und als eingeblendete Leiste am unteren Rand. Beides ist wieder raus - es machte die
   Seite voller statt klarer, und genau davon soll hier weniger sein (User). Wer die Liste sehen
   will, klappt sie auf; wer nicht, sieht eine Zeile. */
function luListeHtml(d){
  return d.gruppen.map(g=>`<div class="lu-g">
      <div class="lu-g-t">${esc(g.titel)}</div>
      ${g.zeilen.map(z=>`<div class="lu-z"><span class="lu-q m">${esc(z.menge||'·')}</span><span class="lu-n">${esc(z.name)}${z.teile?`<small>${esc(z.teile)}</small>`:''}</span></div>`).join('')}
    </div>`).join('')
    + `<div class="lu-f">${esc(d.lieferung)}</div>`
    /* Zweite Fusszeile fuer den Wunschstart - dieselbe Form wie die Versandzeile darueber,
       weil es dieselbe Art Angabe ist. Ohne Angabe keine Zeile. */
    + (d.start ? `<div class="lu-f">Start: ${esc(d.start)}</div>` : '');
}

/* Smart Defaults: typische Jahresverbräuche EFH ~150 m² - Richtwerte, VALIDIEREN (Jannik) */
const TYPICAL = {
  'gas:gas_kwh':18000,'gas:gas_m3':1600,'oel:oel_l':2500,
  'pellets:pellets_kg':4500,'pellets:pellets_t':4.5,'holz:holz_rm':15,
  'strom:strom_kwh':12000,'fernwaerme:fw_kwh':15000,'wp:strom_kwh':4500
};
function typicalFor(){ return TYPICAL[`${A.energy}:${A.unit}`] ?? null; }

/* ============================== ICONS ============================== */
const I=(p)=>`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${p}</svg>`;
const ICONS = {
  gas:I('<path d="M12 3c3 4 6 6.6 6 10a6 6 0 0 1-12 0c0-2 1-3.8 2.5-5.5C9.5 9 12 10 12 12"/>'),
  oel:I('<path d="M12 3c3.5 4.4 6 7.2 6 10.4A6 6 0 0 1 6 13.4C6 10.2 8.5 7.4 12 3z"/><path d="M9 14a3 3 0 0 0 3 3"/>'),
  pellets:I('<circle cx="8" cy="8" r="2.2"/><circle cx="16" cy="8" r="2.2"/><circle cx="8" cy="16" r="2.2"/><circle cx="16" cy="16" r="2.2"/>'),
  holz:I('<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="4.5"/><circle cx="12" cy="12" r="1.2"/>'),
  strom:I('<path d="M13 2 4 14h6l-1 8 9-12h-6l1-8z"/>'),
  fw:I('<path d="M4 20V8h10v12M14 12h6v8M7 12h4M7 16h4"/>'),
  wp:I('<rect x="3" y="7" width="18" height="12" rx="2"/><circle cx="10" cy="13" r="3.5"/><path d="M17 10v.01M17 13v.01"/>'),
  frage:I('<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.6 2.2c-.8.4-1.1 1-1.1 1.8"/><path d="M12 17h.01"/>'),
  hk:I('<rect x="4" y="6" width="16" height="12" rx="1.5"/><path d="M8 6v12M12 6v12M16 6v12"/>'),
  fbh:I('<path d="M4 18h16M4 14c2 0 2-2 4-2s2 2 4 2 2-2 4-2 2 2 4 2M4 9c2 0 2-2 4-2s2 2 4 2 2-2 4-2 2 2 4 2"/>'),
  mix:I('<rect x="4" y="5" width="7" height="10" rx="1"/><path d="M6.5 5v10M9 5v10M4 19h16M14 15c2 0 2-2 3-2s2 2 3 2"/>'),
  ww:I('<path d="M7 3v13a3 3 0 0 0 6 0V3"/><path d="M7 7h6M15 8c2 1 3 2.6 3 4.5"/>'),
  heizung:I('<path d="M5 21V8l7-5 7 5v13"/><path d="M9 21v-6h6v6"/>'),
  /* EIN STRICHSYMBOL FUER DIE WEICHE (14.10.2026).

     ES LAEUFT UEBER I() WIE ALLE ANDEREN (Vorgabe Claras: "ich moechte nicht, dass es genauso
     aussieht wie in der HTML, sondern dass es auch mit rechts und links ist, aber in dem Design
     vom alten Rechner"). Hier standen kurz zwei grosse, gefuellte Marken aus der Vorlage - in
     einem 34-px-Quadrat neben einer Zeile Text waeren deren Flaechen zu Flecken geworden. Das
     Blatt mit dem Haken steht fuer die fertige Berechnung; fuer den zweiten Weg genuegt
     ICONS.heizung, das Haus gibt es laengst. */
  blattHaken:I('<path d="M5 3h9l5 5v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/><path d="M14 3v5h5"/><path d="M8 13.5l2.4 2.4L16 10.3"/>')
};

/* ============================== TRACKING & STATE ============================== */
window.dataLayer = window.dataLayer || [];
/* track(event, data, fertig)

   Mit dritter Angabe wartet der Aufrufer, bis GTM seine Tags abgearbeitet hat. Das ist fuer
   das letzte Ereignis vor einem Seitenwechsel entscheidend (Messung 30.07.2026): nach dem Klick
   auf die Anzahlung gingen die Messanfragen erst bei +72 ms (Google Ads), +171 ms (Doubleclick)
   und +603 ms (GA4) raus. Wer direkt danach window.location.href setzt, bricht genau diese
   Anfragen ab - das wichtigste Ereignis des Funnels waere dann das unzuverlaessigste.
   eventCallback ist GTMs eigener Weg dafuer; eventTimeout begrenzt die Wartezeit, und der
   setTimeout darunter greift, wenn GTM fehlt, blockiert ist oder gar nicht antwortet. */
/* Beim Wiederherstellen einer gespeicherten Kaufauswahl laufen dieselben Zeichenfunktionen wie
   beim echten Klick - und die melden. Ohne diese Sperre zaehlte jeder Seitenwechsel ein
   zusaetzliches candidate_select und package_view, und der Trichter waere nicht mehr lesbar.
   Sie steht nur waehrend stelleKaufWiederHer() an, also einmal beim Seitenaufbau. */
let stummeWiederherstellung=false;
/* EINE E-Mail-Pruefung fuer alle Formulare (18.08.2026).
   Vorher stand derselbe Ausdruck ACHT MAL im File. Eine der acht Kopien war kaputt:
   /^[^@s]+@[^@s]+.[^@s]+$/ - dort fehlten die Backslashes, also hiess die Klasse
   "nicht @ und nicht der Buchstabe s". Jede Adresse mit einem s wurde abgelehnt,
   test@web.de und hans@gmx.de eingeschlossen; dafuer ging a@b_c durch.
   Ein Ausdruck an einer Stelle kann nicht mehr einzeln verrutschen. */
/* ============ WAS EINE ADRESSE HIER BESTEHEN MUSS (verschaerft am 16.10.2026) ============

   Vorgabe Claras: "muss eine echte E-Mail sein und keine Testmail, die man angibt - also die
   E-Mail muss existieren und keine test@test.de sein koennen."

   WAS VON HIER AUS GEHT UND WAS NICHT, und das gehoert dazu: Ob ein Postfach WIRKLICH
   existiert, kann kein Skript im Browser feststellen. Das beantwortet erst eine Mail, die
   ankommt - also ein Double-Opt-in - oder ein Pruefdienst auf dem Server. Was hier steht,
   faengt die Faelle ab, die offensichtlich keine sind: kaputte Form, erfundene Endungen und
   die ueblichen Wegwerfadressen.

   DREI STUFEN:
     1. Die FORM, jetzt enger als vorher. Alt war /^[^@\s]+@[^@\s]+\.[^@\s]+$/ - daran kam
        "a@b.c" vorbei, ebenso "..@x.de" oder "a@-b.de". Neu: erlaubte Zeichen im Namen, ein
        Punkt weder am Anfang noch am Ende und nicht doppelt, Bindestriche nur innerhalb eines
        Domainteils, und eine Endung aus mindestens zwei Buchstaben.
     2. Die ENDUNG muss plausibel sein: Buchstaben, 2 bis 24 Zeichen. ".local", ".test" und
        ".invalid" sind nach RFC 2606 ausdruecklich NICHT aufloesbar und fallen raus.
     3. Eine LISTE offensichtlicher Platzhalter. Sie ist kurz gehalten und bewusst keine
        Dauerpflege: test.de, test.com, example.*, beispiel.de und die haeufigsten
        Wegwerfdienste. Wer eine Adresse faelschen WILL, schafft das ohnehin - diese Liste ist
        gegen das versehentliche "test@test.de" bei einem Probelauf, nicht gegen Absicht.

   EIN NAME, DER SELBST "test" HEISST, BLEIBT ERLAUBT: Gesperrt ist die Domain, nicht der Teil
   davor - "test@firma.de" kann eine echte Funktionsadresse sein. */
const EMAIL_MUSTER=/^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,24}$/;
const EMAIL_SPERRE=[
  'test.de','test.com','test.net','test.org','testmail.com',
  'example.com','example.de','example.org','example.net',
  'beispiel.de','domain.com','email.com','mail.com',
  'mailinator.com','trashmail.com','wegwerfmail.de','10minutemail.com',
  'guerrillamail.com','yopmail.com','tempmail.com','sharklasers.com',
  'localhost','local','test','invalid'
];
function istEmail(v){
  const t=String(v||'').trim();
  if(!EMAIL_MUSTER.test(t)) return false;
  const dom=t.slice(t.lastIndexOf('@')+1).toLowerCase();
  if(EMAIL_SPERRE.indexOf(dom)>-1) return false;
  /* Auch die Endung allein pruefen: *.test, *.local, *.invalid sind laut RFC 2606 reserviert
     und werden nie aufgeloest - gleich welche Domain davorsteht. */
  const endung=dom.slice(dom.lastIndexOf('.')+1);
  if(['test','local','invalid','example','localhost'].indexOf(endung)>-1) return false;
  return true;
}

/* ============ VARIANTEN-KENNUNG FUER GTM (26.08.2026) ============
   Das Layout schickt bereits ein 'theme_info' beim Seitenaufbau (theme_id, theme_name,
   theme_role, theme_experiment) - das feuert VOR gtm.js und sagt, aus welchem Theme die
   Auslieferung kommt. Was dort fehlt, ist die eigentliche Testvariable: WAS der Kunde
   zahlen soll. Die steht erst fest, nachdem kaufmodusAnwenden() gelaufen ist, und die
   Theme-Einstellung dafuer liegt in einer Section - das Layout kommt gar nicht heran.

   Deshalb haengt sie hier an JEDEM Ereignis statt nur an einem. Zwar behaelt GTM einmal
   gepushte dataLayer-Werte, aber damit haengt die Zuordnung einer Conversion daran, dass
   der frueheste Push wirklich durchkam. Vier zusaetzliche Felder pro Ereignis sind der
   billigere Preis: jedes Ereignis ist fuer sich lesbar, auch in einem rohen dataLayer-Auszug.

   theme_role ist der belastbare Wert: Shopify setzt ihn im Experiment-Arm auf 'treatment',
   im Live-Theme auf 'main'. kauf_modus sagt zusaetzlich, WAS sich unterschied - ein
   spaeterer Test kann eine andere Variable haben, dann steht sie hier statt einer blossen
   Theme-Nummer, die niemand mehr zuordnen kann.

   UMGEBAUT 27.08.2026 - NICHT MEHR SELBST ZUSAMMENGEBAUT:
   Vorher stand hier eine feste Liste aus vier Feldern, und dieselben Felder standen ein
   zweites Mal im theme_info-Push des Layouts. Zwei Listen, die dasselbe meinen, laufen
   auseinander - beim naechsten Test haette jemand eine davon vergessen.

   Jetzt ist window.BWP_VARIANTE (aus billigerwaermepumpe-tracking.liquid, laeuft im <head>
   und damit lange vor dieser Datei) die einzige Quelle. Hier kommt nur noch dazu, was das
   Layout GAR NICHT wissen kann: der Kaufmodus steht in einer SECTION-Einstellung, und an
   Section-Einstellungen kommt der <head> nicht heran - deshalb konnte diese Variable nie
   nach oben wandern.

   Die Uebernahme laeuft per Schleife. Ein Feld, das im Layout dazukommt, haengt damit
   automatisch an allen rund 45 track()-Ereignissen, ohne dass diese Datei angefasst wird.
   Faellt BWP_VARIANTE aus (altes Layout im Cache, Snippet nicht gerendert), traegt der
   Rueckfall wenigstens Theme-ID und -Rolle nach, damit eine laufende Messung nicht
   stillschweigend blind wird. */
const GTM_VARIANTE=(function(){
  var th=(window.Shopify && window.Shopify.theme) || {};
  var basis=window.BWP_VARIANTE || {};
  var v={};
  for(var k in basis){ if(Object.prototype.hasOwnProperty.call(basis,k)) v[k]=basis[k]; }
  if(v.theme_id==null)      v.theme_id=th.id||null;
  if(v.theme_role==null)    v.theme_role=th.role||null;
  if(v.test_variante==null) v.test_variante=(th.role==='treatment')?'B':'A';
  /* Nur hier erreichbar, siehe Kommentar oben. */
  v.kauf_modus=(PRODUCTS.deposit && PRODUCTS.deposit.price===0) ? 'frei' : 'anzahlung';
  v.anzahlung_betrag=PRODUCTS.deposit ? PRODUCTS.deposit.price : null;
  return v;
})();
/* ============ KORBSTAND AN JEDEM EREIGNIS (27.08.2026) ============
   Google Analytics zeigt seit Wochen, dass rund 90 % der Besucher in der Kaufbox
   abspringen - also dort, wo Hardware und Services zusammenkommen. Was es NICHT zeigt,
   ist der Preis, bei dem sie gehen. Kein einziges Ereignis trug bisher die laufende
   Summe, deshalb liess sich nie vergleichen: standen die Abspringer bei 17.000 EUR und
   die Käufer bei 11.000, oder ist der Preis gar nicht der Punkt?

   Genau diese Frage beantwortet der Anhang hier - und zwar rückwirkend für ALLE rund
   45 track()-Ereignisse, ohne dass eines davon angefasst wird. Wer die Seite einfach
   schliesst, hinterlässt sein letztes Ereignis mitsamt Korbstand; ein eigenes
   Abbruch-Ereignis über beforeunload braucht es dafür nicht (und es wäre auf Mobile
   ohnehin unzuverlässig).

   Läuft bei jedem Ereignis, darf also NIE werfen und nie teuer sein: ein try/catch um
   alles, und nur Zahlen statt Namenslisten. Ist noch kein Kit gewählt, kommt null
   zurück - der Spread von null ergibt ein leeres Objekt und hängt nichts an. */
function korbStand(){
  try{
    const imDirekt = typeof directCand!=='undefined' && directCand;
    const kitKey = imDirekt ? directCand : (chosenCandidate ? chosenCandidate.kit : null);
    if(!kitKey || !PRODUCTS[kitKey]) return null;
    const svcSet = imDirekt ? directServices : chosenServices;
    let svcAnzahl=0, svcSumme=0;
    (svcSet||new Set()).forEach(k=>{ if(SERVICES[k]){ svcAnzahl++; svcSumme+=SERVICES[k].price; } });
    let exAnzahl=0, exSumme=0;
    Object.entries(chosenExtras||{}).forEach(([k,menge])=>{
      if(EXTRAS[k]){ exAnzahl++; exSumme+=EXTRAS[k].price*menge; }
    });
    const spKey=speicher();
    /* RABATT AUCH IM TRACKING (portiert 16.09.2026). korb_summe ist die Zahl, an der GTM den
       Warenkorbwert misst. Bliebe sie brutto, meldete das Tracking einen anderen Wert, als der
       Kunde auf dem Bildschirm sieht - und die Auswertung widerspraeche der Seite. */
    const brutto=PRODUCTS[kitKey].price+(spKey?PRODUCTS[spKey].price:0)+svcSumme+exSumme;
    const rab=rabattBetrag(brutto);
    const summe=brutto-rab;
    const gesamt=summe+deliveryFee();
    const quote=foerderQuote(kitKey)||0;
    const zuschuss=quote?Math.round(Math.min(summe,foerderKostenCap())*quote/100):0;
    return {
      korb_kit:kitKey,
      korb_summe:gesamt,
      korb_rabatt:rab,
      korb_nach_foerderung:Math.max(gesamt-zuschuss,0),
      /* Der Faktor gegenüber dem blossen Kit-Preis - die Zahl, mit der der Kunde
         hergekommen ist. Sagt in einem Wert, wie weit sich der Korb von seiner
         Erwartung entfernt hat. */
      korb_faktor:Math.round(gesamt/PRODUCTS[kitKey].price*100)/100,
      korb_services:svcAnzahl,
      korb_extras:exAnzahl,
      korb_schritt:(typeof activeBbStep==='function' ? (activeBbStep(imDirekt?'cm':'bb')||null) : null)
    };
  }catch(e){ return null; }
}
/* WELCHE KAUFOBERFLAECHE GERADE OFFEN IST (portiert und erweitert 16.09.2026).
   Bei uns gab es zwei Wege - Kaufbox im Rechner und Direktkauf-Dialog. Clara hat einen
   DRITTEN gebaut: dieselbe Kaufbox, inline auf der Produktseite statt als Overlay. Sie
   unterscheidet das selbst an #cartModal.kauf-inline und nennt es "imKasten" - dieselbe
   Unterscheidung wird hier uebernommen, damit Code und Auswertung dieselbe Sprache sprechen.

   Ohne diesen dritten Wert liefen Produktseite und Direktkauf-Dialog in der Auswertung
   zusammen: beide rendern ueber renderCartModalIncluded und schicken dieselben Ereignisnamen.
   Genau die Frage "kaufen die Leute ueber die Produktseite oder ueber den Dialog" waere dann
   nicht zu beantworten - und das ist die Frage, wegen der Clara die Produktseite gebaut hat.

   Aus dem DOM abgeleitet, nicht aus einem Merker: das Markup IST der Zustand. */
function kaufwegAktiv(){
  try{
    if(document.querySelector('#cartModal.kauf-inline')) return 'produktseite';
    const m=document.getElementById('cartModal');
    if(m && !m.classList.contains('hidden')) return 'direkt';
    if(document.querySelector('.buybox')) return 'rechner';
  }catch(e){}
  return null;
}
/* LAUFENDE NUMMER JE SEITENAUFRUF. Zeitstempel allein ordnen nicht: mehrere Ereignisse aus
   demselben Bildaufbau tragen dieselbe Millisekunde. */
let ereignisNr=0;
function track(event,data={},fertig){
  if(stummeWiederherstellung){ if(typeof fertig==='function') fertig(); return; }
  /* KENNUNG, SEITE UND REIHENFOLGE AN JEDES EREIGNIS (portiert 16.09.2026).
     seite kommt neu dazu und ist in Claras Aufbau unverzichtbar: der Rechner ist eine eigene
     Seite, die Kits haben eigene Seiten. Ein Kundenweg umfasst damit MEHRERE Seitenaufrufe,
     und ereignis_nr beginnt bei jedem von vorn. Erst lead_ref + seite + ereignis_nr ergeben
     zusammen eine lesbare Reihenfolge ueber den ganzen Weg.
     leadRefVorhanden() und NICHT leadRef(): hier darf keine Kennung entstehen. */
  const weg=kaufwegAktiv();
  const kennung=leadRefVorhanden();
  let seite=''; try{ seite=location.pathname||''; }catch(e){}
  ereignisNr++;
  const eintrag={event,...GTM_VARIANTE,...korbStand(),
    ...(weg?{kaufweg:weg}:{}), ...(kennung?{lead_ref:kennung}:{}),
    seite:seite, ereignis_nr:ereignisNr, ...data};
  if(typeof fertig==='function'){
    let gerufen=false;
    const einmal=()=>{ if(gerufen) return; gerufen=true; fertig(); };
    eintrag.eventCallback=einmal;
    eintrag.eventTimeout=1200;
    window.dataLayer.push(eintrag);
    setTimeout(einmal,1300);
  } else {
    window.dataLayer.push(eintrag);
  }
  console.log("[track]",event,data);
}
const A = {
  /* EINBRINGUNG (25.08.2026). Muessen im A-Literal stehen, sonst uebernimmt ladeStand()
     sie nicht - es kopiert ausschliesslich Schluessel, die hier bereits deklariert sind.
     Genau dieser Fehler ist bei 'fundament' schon einmal passiert.
     Werte in cm, als Zahl oder null. Befuellt werden sie erst, wenn die Konditionen da
     sind und der Funnel-Schritt dazu existiert - bis dahin bleiben sie null, und
     einbringUrteil() liefert wegen AKTIV:false ohnehin 'aus'. */
  einbringTuer:null, einbringTreppe:null, einbringHoehe:null, fbhVor1990:null,   /* 'ja' | 'nein' | 'unklar' - nur bei Baujahr-Spanne 1980-1994 gefragt */
  gefuehrt:null,        /* 'ja' = wir waehlen vor | 'nein' = Kunde konfiguriert selbst */
  aufstellort:null,     /* 'nah' | 'weit' | 'unklar' - entscheidet ueber die Hauseinfuehrung */
  kreiseUngemischt:null,/* Sonderfall zweier ungemischter Kreise - der Funnel leitet die Kreise aus der Heizflaechen-Frage ab, siehe pumpengruppeFuer() */
  systemtrennung:null,  /* 'ja' nur relevant zusammen mit der gemischten Pumpengruppe */
  hlbWeg:null, /* 'service' | 'eigen' | null - Weg zur raumweisen Heizlastberechnung, siehe hlbGeklaert() */
  fundament:null,       /* 'selbst' | 'fertig' - stand frueher NICHT hier, sondern wurde erst von
                           renderFundament() angelegt. Beim Wiederherstellen des Standes fiel es
                           dadurch durchs Raster, weil ladeStand() nur bekannte Felder uebernimmt. */
  installMode:null, energy:null, baujahr:null, hlgate:null, unit:null, consumptionValue:null, heizlastDirect:null,
            /* NEUE FELDER AUS DEM AUSLEGUNGSTOOL (14.10.2026, Vorgabe Claras: "eine neue Version
               des Kitgroessenrechners mit mehr Fragen, die die Auswahl spezifischer machen").

               SIE MUESSEN HIER STEHEN, NICHT NUR BEIM RENDERER: ladeStand() und ladeAusLink()
               uebernehmen ausschliesslich Schluessel, die in diesem Objekt angelegt sind - siehe
               den Vermerk zu 'fundament' und 'delivery' darunter. Ein Feld, das erst zur Laufzeit
               entsteht, reist im Token mit und wird beim Zurueckkommen stumm verworfen.

               heizartDetail  Nachfrage nach der genauen Bauart, nur bei Gas und Oel (Vorgabe
                              Claras: "bei den anderen geht es direkt mit der naechsten Frage
                              weiter"). Sie trifft den Nutzungsgrad - eine alte Gastherme liegt
                              bei 0,76, ein Brennwertkessel bei 0,92.
               baujahrHaus    GENAUE Jahreszahl (Vorgabe). Sie entscheidet ueber die
                              Systemtrennung. Das alte Feld 'baujahr' meint ab jetzt nur noch die
                              HEIZUNG - bis heute war es beides zugleich, siehe
                              systemtrennungNoetig().
               wohnflaeche    beheizte Flaeche in m2. Traegt die Plausibilitaetswarnung und fuellt
                              das gleichnamige Feld im Beratungsformular vor (vgFlaeche).
               keller/..      Kellerstatus und -flaeche gehen in dieselbe Warnung ein.
               verbrauch2/3   zweites und drittes Verbrauchsjahr. Der Rechner mittelt, damit ein
                              einzelner milder oder harter Winter nicht durchschlaegt.
               wwImVerbrauch  'ja'|'nein' - steckt das Warmwasser ueberhaupt im Zaehlerstand?
                              Bei 'nein' darf es nicht abgezogen werden.
               kamin/holzRm   zusaetzlich verbranntes Holz, in Raummetern. */
            heizartDetail:null, baujahrHaus:null, baujahrHeizung:null, wohnflaeche:null,
            kellerstatus:null, kellerflaeche:null,
            verbrauch2:null, verbrauch3:null, wwImVerbrauch:null, kamin:null, holzRm:null,
            dhw:null, persons:null, komfort:'normal', zirk:'unklar',
            sanierung:null, heating:null, radiators:null, zve:null, zveChoice:null, kinder:null, plz:null, email:null,
            /* DIESELBE FALLE WIE BEI 'fundament' - gefunden im Review am 24.08.2026.
               Beide Felder wurden erst vom jeweiligen Chip-Handler zur Laufzeit angelegt
               (A.delivery in renderBuyBox/Direktkauf-Dialog, A.speicherChoice ebenso). Sie
               reisen im Token und im gespeicherten Stand zwar MIT - JSON.stringify(A) nimmt
               sie ja -, aber ladeAusLink() und ladeStand() uebernehmen ausschliesslich
               Schluessel, die HIER stehen. Was hier fehlt, wird beim Zurueckkommen
               stillschweigend verworfen.

               Was das kostet, wenn es fehlt:
                 delivery       - SEIT DEM 28.10.2026 NICHTS MEHR. Die Abholung ist entfallen,
                                  deliveryFee() gibt die Gebuehr unabhaengig von diesem Feld
                                  zurueck und deliveryLabel() immer "Lieferung". Das Feld
                                  bleibt im Stand stehen, damit alte Links und gespeicherte
                                  Staende weiter sauber einlesen - gelesen wird es nicht mehr.
                                  Bis dahin war das die gefaehrlichste Luecke der Liste: Der
                                  Kunde hatte Lieferung gewaehlt und bestaetigt bekommen, die
                                  Bestellung sagte Abholung und war 239,99 EUR billiger -
                                  niemand haette die Spedition beauftragt.
                 speicherChoice - speicher() faellt auf die Empfehlung zurueck
                                  ((A.persons<=2)?'sp200':'sp300'). Wer bewusst gegen die
                                  Empfehlung gewaehlt hat, bekommt den anderen Speicher:
                                  je nach Richtung 500 EUR zu viel berechnet oder 500 EUR
                                  zu wenig Ware.

               null bleibt der Startwert - es gibt seit dem 28.10.2026 keinen Leser mehr,
               der daraus etwas ableitet. */
            speicherChoice:null, delivery:null,
            /* WUNSCHSTART (13.10.2026, Vorgabe Claras: "unter Abholung oder Lieferung noch ein
               Kalender, in dem man auswaehlen kann, ab wann der Bau bzw. die Lieferung oder
               Abholung erfolgen soll - das ist kein konkretes Startdatum, sondern nur eine
               Angabe zur Orientierung").

               ER STEHT HIER UND NICHT NUR IM FELD, aus genau dem Grund, der zwei Zeilen
               darueber steht: ladeStand() uebernimmt ausschliesslich Schluessel, die hier
               stehen. Was fehlt, wird beim Zurueckkommen stillschweigend verworfen - und ein
               Kunde, der sein Datum nach einer Unterbrechung wieder eintippen muss, merkt
               genau das. */
            /* KEINE VORAUSWAHL MEHR (21.10.2026, Vorgabe Claras: "ich moechte bitte, dass
               man auswaehlen muss, ab wann man starten moechte").

               DAMIT FAELLT DIE VORGABE VOM 13.10.2026 ("standardmaessig 'ich weiss es nicht'
               auswaehlen"). Sie hatte einen guten Grund - "ich weiss es nicht" ist eine
               Aussage, eine leere Auswahl eine uebersehene Frage - aber sie machte die
               Pflichtpruefung vom 19.10.2026 wirkungslos: Die prueft !A.startWunsch, und das
               war mit 'unklar' nie wahr. Der Kunde kam also durch, ohne die Frage je gesehen
               zu haben, und in der Bestellung stand "noch offen" als haette er das gesagt.

               "Ich weiss es nicht" BLEIBT WAEHLBAR - wer es nicht weiss, sagt das weiterhin.
               Es ist nur keine Antwort mehr, die jemand anders fuer ihn gegeben hat. */
            /* startMonat seit dem 14.10.2026 (Vorgabe Claras: "fueg bei der Auswahlmoeglichkeit,
               wann man starten moechte, hinzu, dass man einen bestimmten Monat angeben kann").
               Es MUSS hier stehen, sonst verwirft ladeStand() es beim Zurueckkommen - siehe den
               Vermerk zu 'fundament' weiter unten. */
            startWunsch:'', startWoche:null, startDatum:null, startMonat:null,
            /* Stueckzahlen fuer den hydraulischen Abgleich (21.09.2026). Jede entscheidet die
               Menge genau eines Bauteils; welche davon ueberhaupt gefragt wird, haengt an der
               Heizart. heizkoerperAnzahl steht neben radiators, nicht statt dessen: jene Frage
               liefert eine Spanne zum Einordnen, diese die Zahl zum Zaehlen. Siehe MENGEN_FRAGEN. */
            heizkoerperAnzahl:null, heizkreisAnzahl:null, verteilerAnzahl:null,
            /* Baujahr der Fussbodenheizung, im Kaufweg erfragt (23.09.2026) - siehe
               fbhBaujahrChipsHtml. Neben A.baujahr/A.fbhVor1990 aus dem Rechner, nicht
               statt ihnen: Wer direkt kauft, durchlaeuft den Rechner nie. */
            fbhBaujahr:null,
            /* Nur bei "Zwei oder mehr Heizkreise": welche Kombination (25.09.2026, Grafik
               "BWP Customer Journey"). Siehe kreiseChipsHtml. */
            kreise:null,
            /* Telefon reiste bisher nur als Extrafeld im Lead mit und war weg, sobald der
               Versand scheiterte. Fuer einen Rueckruf ist das der falsche Speicherort -
               jetzt gehoert es zum Stand und ueberlebt einen Seitenwechsel. */
            tel:null };
let stepIndex=0, configStarted=false, finished=false, completeTracked=false;

/* =====================================================================
   STAND MERKEN (User-Entscheid 10.08.2026)
   Bis dahin ging jede Antwort verloren, sobald der Kunde die Seite verliess - auch beim
   Rueckweg aus der Kasse. Wer weiterkaufen wollte, stand wieder bei Frage 1. Die Oberflaeche
   hat dabei ausdruecklich das Gegenteil versprochen ("Deine Antworten bleiben auf diesem
   Geraet gespeichert"), das Versprechen ist jetzt eingeloest.

   Gespeichert werden NUR die Antworten und der Fortschritt - keine Service- oder Material-
   auswahl. Die leitet die Kaufbox beim Rendern ohnehin neu aus den Antworten ab; eine alte,
   eingefrorene Auswahl waere schlimmer als gar keine, weil sich Preise und Foerderregeln
   aendern koennen.

   14 Tage, danach faellt der Stand weg. Das deckt die Bedenkzeit ab, ohne dass jemand nach
   Monaten mit veralteten Preisen weitermacht.

   BEWUSST NICHT beim Start des Checkouts geleert: ob der Kauf durchging, weiss der Browser
   nicht - die Danke-Seite gehoert Shopify, nicht uns. Wer abbricht, braucht seinen Stand
   dringender, als ein Kaeufer ihn los sein muss. Das Ablaufdatum raeumt auf.
   ===================================================================== */
const STAND_SCHLUESSEL='bwp_stand';
const STAND_TAGE=14;
/* RUECKWEG VOM KIT AUF DIE ERGEBNISSEITE (14.10.2026, Vorgabe Claras). Gesetzt wird der
   Schluessel beim Verlassen der Ergebnisseite, gelesen auf der Produktseite (der Verweis
   "Zurueck zu den Kits" wird dort umgehaengt) und beim Zurueckkommen auf die Rechnerseite
   (dann steht die Auswahl wieder da, statt des E-Mail-Riegels).
   sessionStorage: Es gilt fuer diesen Besuch und nicht fuer einen weitergegebenen Link. */
const ERG_RUECKWEG='bwp_erg_rueckweg';
/* =====================================================================
   KAUFAUSWAHL UEBER ECHTE SEITENWECHSEL RETTEN (Umbau auf Unterseiten, 12.08.2026)

   Bis hierher lagen alle sieben Reiter im selben Dokument. Wer vom Rechner zu "Bauteile"
   sprang, kam mit unveraenderter Kaufbox zurueck - es wurde ja nie eine Seite neu geladen.
   Mit echten URLs ist der Arbeitsspeicher bei jedem Klick weg. Gemessen am 12.08.2026:
   Antworten und "fertig" ueberlebten, Kit, Services und Material nicht - aus einer Kaufbox
   ueber 16.292 EUR wurde nach einem Ausflug auf /pages/produkt ein Knopf "Deinen Vergleich
   ansehen". Der Kunde muesste seine komplette Auswahl neu zusammenstellen.

   Gespeichert werden ausschliesslich SCHLUESSEL, nie Betraege: Preise, Foerdersaetze und
   Pflicht-Services holt die Kaufbox beim Zeichnen immer frisch aus den Tabellen. Ein alter
   Stand kann damit keine veralteten Zahlen in den Warenkorb tragen - genau die Sorge, die
   den urspruenglichen Entscheid vom 10.08.2026 begruendet hat, hier oben im Kommentar.

   Kurze Haltbarkeit, waehrend die Antworten 14 Tage halten: Angaben ueber das Haus altern
   nicht, eine Warenkorb-Auswahl schon.
   ===================================================================== */
const KAUF_MINUTEN=90;
/* Der WARENKORB lebt laenger als die Kaufbox (15.09.2026, Vorgabe: "auch Tage spaeter sollen
   die Dinge noch drin liegen"). KAUF_MINUTEN entscheidet weiterhin, ob jemand beim
   Wiederkommen unmittelbar in seine halb fertige Kaufbox zurueckgesetzt wird - das waere nach
   Tagen uebergriffig. Was er ausgewaehlt hat, ist davon unabhaengig und bleibt in der
   Schublade stehen, bis er es selbst entfernt oder die Frist ablaeuft. */
const KORB_TAGE=30;
let standKauf=null;     /* aus dem Speicher gelesen, wartet auf stelleKaufWiederHer() */
let standDirekt=null;   /* dasselbe fuer den Express-Weg, wartet auf renderCartModalIncluded() */
function kaufStand(){
  if(!chosenCandidate) return null;
  return {
    kit:      chosenCandidate.kit,
    services: [...chosenServices],
    extras:   Object.assign({},chosenExtras),
    /* Was die Vorauswahl selbst gesetzt hat, muss mitwandern - sonst kann sie beim naechsten
       Antwort-Wechsel ihre eigenen Positionen nicht mehr zurueckziehen. */
    vgesetzt: vorauswahlGesetzt.slice(),
    vgruende: Object.assign({},vorauswahlGruende),
    ts:       Date.now()
  };
}
/* Derselbe Gedanke fuer den Express-Weg ("Ich weiss es schon"): der laeuft im Dialog auf
   /pages/produkt und hat seinen eigenen Zustand, der am Rechner-Funnel vorbeilaeuft.
   Wieder nur Schluessel, nie Betraege. */
function direktStand(){
  if(!directCand) return null;
  return { kit:directCand, services:[...directServices],
           extras:Object.assign({},chosenExtras), ts:Date.now() };
}
function speichereStand(){
  try{
    localStorage.setItem(STAND_SCHLUESSEL, JSON.stringify({
      /* v:2 seit dem 14.10.2026 - siehe die Begruendung in ladeStand(): Die Schrittnummer eines
         v:1-Standes zeigt nach dem Umbau der Reihenfolge auf eine andere Frage. */
      v:2, ts:Date.now(), antworten:A, schritt:stepIndex, fertig:finished, begonnen:configStarted,
      /* Nur das JA, nie der Prozentsatz: der Satz kommt immer frisch aus RABATT, sonst
         rechnete ein Rueckkehrer mit einem Satz weiter, den der Betreiber laengst gesenkt hat.
         Seit dem 28.09.2026 beim festen Betrag der Code selbst statt 1 - siehe rabattRb(). */
      rb: rabattRb(),
      kauf:kaufStand(), direkt:direktStand()
    }));
  }catch(e){ /* privater Modus oder voller Speicher - dann eben nicht, kein Grund abzustuerzen */ }
  /* DER HEIZKOSTEN-RECHNER ZIEHT MIT (13.10.2026). Hier und nicht an einer der zwanzig
     Stellen, die Antworten setzen: speichereStand() laeuft bei jeder davon, es ist die eine
     Stelle, an der "etwas hat sich geaendert" schon feststeht. Die Funktion selbst steigt
     sofort aus, wenn es den Rechner auf der Seite nicht gibt, und zeichnet nur neu, wenn sich
     wirklich ein Wert geaendert hat. */
  try{ if(typeof bwpHkrVorbelegen==='function') bwpHkrVorbelegen(); }catch(e){}
}
/* ============ KONFIGURATION IM LINK (18.08.2026) ============
   Der Kauflink in der Konfigurations-Mail fuehrte zuerst auf einen Shopify-Permalink.
   Der legt aber nur das Reservierungsprodukt in den Warenkorb - die Positionen reisten
   bloss als Notiztext mit. Ein Permalink KANN keine Positions-Eigenschaften setzen, das
   geht ausschliesslich ueber /cart/add.js im Browser. Die Bestellung sah damit anders aus
   als beim Kauf auf der Seite, und genau das hat der Betreiber bemerkt.

   Jetzt traegt der Link die Konfiguration selbst. Der Kunde landet im Rechner, die Kaufbox
   steht fertig gefuellt da, und der normale Kaufweg erzeugt dieselbe Bestellung wie immer -
   mit allen Eigenschaften. Ein Klick mehr, dafuer kein zweiter Bestellweg, der auseinanderlaeuft.

   Der Token ist derselbe Datensatz, den auch der gespeicherte Stand fuehrt. Damit greift
   die vorhandene, getestete Wiederherstellung (stelleKaufWiederHer) unveraendert - und der
   Link funktioniert auch auf einem Geraet, auf dem nichts gespeichert ist.

   NACHGEZOGEN 24.08.2026 (Betreiber: "koennen wir nicht direkt in diesen Checkout View
   reinkommen"): der Link traegt zusaetzlich &kasse=1 und springt nach dem Wiederherstellen
   selbsttaetig in die Shopify-Kasse - der Umweg ueber die Seite bleibt, ist aber nur noch
   eine Durchreiche von rund einer Sekunde. Der Kunde landet damit im echten Checkout MIT
   allen Positions-Eigenschaften, was ein Permalink nie koennte.

   Die urspruengliche Sorge ("er steht vor einer Bestellung, die er nie gesehen hat") ist
   nicht weg, sondern beantwortet: direktZurKasse() springt nur, wenn wirklich alles steht,
   und die Durchreiche zeigt eine Abbruchmoeglichkeit. Die Bedingungen stehen dort. */
/* gesamt: die Summe, die in der Mail steht. Wird nur mitgegeben, wenn der Aufrufer sie
   ohnehin schon berechnet hat - der Token soll keine zweite Rechenstelle werden. */
function kaufToken(gesamt){
  const k=kaufStand();
  if(!k) return null;
  try{
    /* az = was der Kunde HEUTE zahlt, zum Zeitpunkt des Mailversands. Nur dafuer da, den
       A/B-Variantenwechsel zu erkennen: die Mail nennt einen Betrag ("Heute zahlst du
       nichts" oder "199 EUR Anzahlung"), und der Rollout-Test kann den Kunden beim
       naechsten Besuch in den anderen Arm werfen. Dann darf NICHT durchgereicht werden -
       er stuende sonst vor einer Zahlungsaufforderung, die seiner Mail widerspricht.
       Bewusst nur der Heute-Betrag und kein Preis: Preise holt die Kaufbox ohnehin frisch,
       ein gespeicherter Preis waere die zweite Wahrheit, die dieser Token gerade vermeidet. */
    /* KURZ HALTEN - das ist kein Feinschliff, sondern eine Fehlerbehebung (26.08.2026).
       Eine Mail-Zeile darf nach RFC 5322 hoechstens 998 Zeichen haben. Der Link war 1.904
       Zeichen lang; Clients und Gateways haben ihn gekappt, dann scheiterte atob(), und der
       Kunde landete auf der blanken Startseite - genau die Meldung "der Knopf geht nur
       zurueck zur Startseite". Zwei Posten machten den Loewenanteil aus:

         vgruende  654 Zeichen reiner Anzeigetext ("Deine Fussbodenheizung braucht eine
                   eigene, geregelte Vorlauftemperatur ..."). Der laesst sich aus derselben
                   Quelle neu berechnen, aus der er kam - vorauswahlPlan(). Er reist deshalb
                   nicht mehr mit; stelleKaufWiederHer() holt ihn zurueck.
         Nullen    11 von 30 Antwortfeldern sind leer. Sie muessen nicht uebertragen werden:
                   ladeAusLink() uebernimmt nur vorhandene Schluessel, alles andere behaelt
                   seinen Startwert - und der ist fuer diese Felder ohnehin null.

       Ergebnis: 1.870 -> rund 700 Zeichen. AELTERE LINKS BLEIBEN GUELTIG: sie tragen
       vgruende weiterhin, und der Leser nimmt es dann von dort.

       komfort und zirk stehen IMMER drin, auch wenn leer: die beiden sind die einzigen
       Felder, die mit einem Startwert ungleich null BEGINNEN und spaeter null werden koennen
       ('normal' bzw. 'unklar'). Waeren sie weggelassen, kaeme statt eines leeren Wertes der
       Startwert zurueck.

       startWunsch braucht den Sonderfall NICHT, obwohl sein Startwert seit dem 21.10.2026
       ebenfalls nicht null ist: Er ist der leere String, und der faellt schon durch die erste
       Bedingung ('' !== null). Er reist also ohnehin mit und ueberschreibt drueben richtig. */
    const antw={};
    Object.keys(A).forEach(x=>{
      if(A[x]!==null && A[x]!==undefined) antw[x]=A[x];
      else if(x==='komfort' || x==='zirk') antw[x]=A[x];
    });
    const nutz={ v:1, antworten:antw, az:(PRODUCTS.deposit?PRODUCTS.deposit.price:null),
      gs:(typeof gesamt==='number'?gesamt:null),
      /* RABATTLAGE IN DEN TOKEN (portiert 16.09.2026). Ohne dieses eine Zeichen rechnet der
         Rueckkehrer aus der Mail ohne Rabatt, die Summe weicht von gs ab, und die
         Preisdrift-Pruefung laesst ihn STILL nicht in die Kasse - nur ein Tracking-Event.
         Seit dem 28.09.2026 traegt rb beim festen Betrag den Code selbst - siehe rabattRb(). */
      rb:rabattRb(),
      kauf:{ kit:k.kit, services:k.services, extras:k.extras,
      vgesetzt:k.vgesetzt, ts:Date.now() } };
    /* btoa kann kein Unicode - Umlaute in den Begruendungstexten wuerden werfen. */
    const roh=unescape(encodeURIComponent(JSON.stringify(nutz)));
    return btoa(roh).replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,"");
  }catch(e){ return null; }
}
/* Liest den Token aus der Adresszeile und setzt denselben Zustand wie ladeStand().
   Gewinnt gegen den gespeicherten Stand: wer aus seiner Mail kommt, will DIESE Konfiguration. */
/* Wird von ladeAusLink() gesetzt und einmal beim Seitenaufbau ausgewertet. Absichtlich eine
   eigene Variable und kein Feld im Token: das Kennzeichen sagt, WOHIN der Klick fuehren soll,
   und gehoert damit zum Link, nicht zur Konfiguration. Alte Links ohne das Kennzeichen
   verhalten sich unveraendert. */
let ausLinkZurKasse=false;
/* Heute-Betrag aus dem Token, null bei aelteren Links ohne das Feld. */
let ausLinkAnzahlung=null;
/* Paketsumme, die in der Mail stand. null bei aelteren Links ohne das Feld. */
let ausLinkGesamt=null;
/* Rabattlage, unter der ausLinkGesamt gerechnet wurde (24.09.2026). Seit ?rabatt= neben ?k=
   eingeloest wird, koennen beide auseinanderfallen: Token ohne Rabatt, Kunde mit Rabatt. Die
   Preisdrift-Pruefung braucht deshalb beides getrennt. Aeltere Links ohne rb entstanden vor
   dem Rabatt, also ohne ihn.
   Seit dem 28.09.2026 der Code selbst statt nur ja/nein (rabattAusRb) - null heisst ohne. */
let ausLinkRabatt=null;
function ladeAusLink(){
  let roh, kasse=false;
  try{
    const q=new URLSearchParams(location.search);
    roh=q.get("k"); kasse=q.get("kasse")==="1";
  }catch(e){ return false; }
  if(!roh) return false;
  let d;
  try{
    const b=roh.replace(/-/g,"+").replace(/_/g,"/");
    d=JSON.parse(decodeURIComponent(escape(atob(b))));
  }catch(e){ return false; }
  if(!d || d.v!==1 || !d.antworten || !d.kauf || !d.kauf.kit) return false;
  Object.keys(A).forEach(k=>{ if(Object.prototype.hasOwnProperty.call(d.antworten,k)) A[k]=d.antworten[k]; });
  finished=true; completeTracked=true; configStarted=true;
  standKauf=d.kauf; standDirekt=null;
  /* AUF DER PRODUKTSEITE FUELLT DER LINK CLARAS KAUFWEG (24.09.2026, Betreiber-Entscheid).
     Dort gibt es kein #app und damit keine alte Kaufbox; stelleKaufWiederHer() steigt aus.
     Der Kit-Konfigurator (renderCartModalIncluded, Zweig "zurueck") liest seinen Stand aus
     standDirekt - und wendet in diesem Zweig die Vorauswahl NICHT an. Damit steht genau die
     Zusammenstellung aus dem Token im Kasten und in der Schublade.
     OHNE ts: ladeStand() verwirft einen Direkt-Stand nach KAUF_MINUTEN. Der Token traegt den
     Zeitpunkt seiner Erzeugung - jede Mail, die aelter als 90 Minuten ist, fiele sonst durch.
     servicesErreicht: ohne den Merker laesst die Schublade die Services weg, cartAddDirect()
     bucht sie aber trotzdem - zwei Summen fuer denselben Kauf. Wer aus dem Link kommt, hat den
     Services-Schritt laengst hinter sich (Vorbild: ladeStand, gleicher Grund). */
  if(!app){
    standDirekt={ kit:d.kauf.kit, services:Array.isArray(d.kauf.services)?d.kauf.services:[],
      extras:(d.kauf.extras && typeof d.kauf.extras==='object')?d.kauf.extras:{} };
    if(standDirekt.services.length) servicesErreicht=true;
  }
  ausLinkZurKasse=kasse;
  ausLinkAnzahlung=(typeof d.az==='number')?d.az:null;
  ausLinkGesamt=(typeof d.gs==='number')?d.gs:null;
  /* BIS ZUM 24.09.2026 GEWANN HIER DER LINK, auch wenn er NEIN sagte (rabattAktiv=!!d.rb):
     ein alter Kauflink ohne Rabatt traegt in gs eine unrabattierte Summe, und ein zusaetzlich
     aktiver Code haette die Preisdrift zwei verschiedene Betraege finden lassen.

     JETZT: Rabatt, wenn der Token ihn traegt ODER derselbe Link ?rabatt= mitbringt. Die
     Nachfass-Mail verschickt genau diese Kombination - alte Konfiguration, neuer Code. Was
     die Preisdrift braucht, haelt ausLinkRabatt getrennt fest.

     Bewusst NUR rabattKamAusLink und nicht rabattAktiv allgemein: Vor diesem Aufruf kann
     rabattAktiv ausschliesslich ueber rabattLinkEinloesen() true werden - die Bedingung ist
     also dieselbe, nur ausdruecklich. Faende jemand spaeter einen weiteren Weg, rabattAktiv
     vorher zu setzen, soll der hier nicht stillschweigend mitgenommen werden.
     Seit dem 28.09.2026 mit dem Code aus dem Token (rabattAusRb). Bringt der Link selbst einen
     mit, gilt dieser - derselbe Vorrang wie bisher. */
  ausLinkRabatt=rabattAusRb(d.rb);
  if(!rabattKamAusLink){ rabattAktiv=!!ausLinkRabatt; rabattGewaehlt=ausLinkRabatt; }
  /* ziel seit dem 24.09.2026 mit dem neuen Kaufweg - sonst stuende in der Auswertung
     "rechner" fuer Kunden, die auf der Produktseite gelandet sind. */
  track("konfiguration_aus_link",{kit:d.kauf.kit,ziel:kasse&&app?'kasse':(app?'rechner':'produktseite')});
  /* Token aus der Adresszeile raeumen: er ist lang, und ein geteilter Link wuerde sonst
     die Konfiguration eines Fremden mitschleppen. */
  try{ history.replaceState(null,"",location.pathname); }catch(e){}
  return true;
}
function ladeStand(){
  let roh;
  try{ roh=localStorage.getItem(STAND_SCHLUESSEL); }catch(e){ return false; }
  if(!roh) return false;
  let d; try{ d=JSON.parse(roh); }catch(e){ return false; }
  if(!d || !(d.v===1||d.v===2) || !d.antworten) return false;
  const alter=Date.now()-(d.ts||0);
  if(alter > STAND_TAGE*24*60*60*1000){
    try{ localStorage.removeItem(STAND_SCHLUESSEL); }catch(e){}
    return false;
  }
  /* Nur bekannte Felder uebernehmen: ein alter Stand aus einer frueheren Fassung darf keine
     Schluessel einschleusen, die es heute nicht mehr gibt. */
  Object.keys(A).forEach(k=>{ if(Object.prototype.hasOwnProperty.call(d.antworten,k)) A[k]=d.antworten[k]; });
  /* DIE SCHRITTNUMMER GILT NUR INNERHALB DERSELBEN FASSUNG (14.10.2026).

     Am 14.10.2026 ist die Fragenreihenfolge umgebaut worden. Eine gespeicherte 7 hiess vorher
     "Warmwasser" und heisst jetzt "Hast du einen Keller?" - wer nach der Aenderung zurueckkommt,
     landete also mitten in einem anderen Abschnitt, ohne dass irgendetwas kaputt aussieht. Genau
     die Sorte stiller Fehler, vor der CLAUDE.md warnt.

     DESHALB TRAEGT DER STAND SEIT HEUTE v:2. Die ANTWORTEN eines alten Standes werden weiter
     uebernommen - sie haengen an Feldnamen und nicht an Positionen, und sie wegzuwerfen waere
     der groessere Schaden. Nur die Position wird neu bestimmt: Ein fertiger Stand springt ans
     Ende (die alte Zahl 16 laege im neuen Funnel mittendrin), ein unfertiger an den Anfang.
     Durchklicken geht schnell, jede Frage zeigt die eigene Antwort schon an. */
  stepIndex = (d.v===2 && typeof d.schritt==='number') ? d.schritt
            : (d.fertig ? STEPS.length : 0);
  finished=!!d.fertig; completeTracked=finished; configStarted=!!d.begonnen;
  /* ODER statt SETZEN - anders als in ladeAusLink(). Dort wird die Summe gegengeprueft, hier
     nicht: der gespeicherte Stand ist nur aelter als die Adresszeile. Wer mit ?rabatt= aus der
     Willkommensmail kommt, verlaere den Rabatt sonst im selben Augenblick, in dem er ihn bekommt.
     Seit dem 28.09.2026 mit dem Code aus dem Stand (rabattAusRb), gleiche Regel: ein schon
     eingeloester Code bleibt. */
  if(!rabattAktiv){
    const ausRb=rabattAusRb(d.rb);
    if(ausRb){ rabattAktiv=true; rabattGewaehlt=ausRb; }
  }
  /* Die Kaufauswahl hat ihre eigene, kuerzere Frist. Sie wird hier nur vorgemerkt, nicht
     angewendet: dafuer braucht es die Routing-Ergebnisse und das fertige DOM der Kaufbox. */
  standKauf=null;
  if(d.kauf && d.kauf.kit && Date.now()-(d.kauf.ts||0) <= KAUF_MINUTEN*60*1000) standKauf=d.kauf;
  standDirekt=null;
  if(d.direkt && d.direkt.kit && Date.now()-(d.direkt.ts||0) <= KAUF_MINUTEN*60*1000) standDirekt=d.direkt;
  /* DEN WARENKORB SOFORT HERSTELLEN, auf jeder Seite (15.09.2026).

     Vorher passierte das ausschliesslich in renderCartModalIncluded() - also nur, wenn der
     Kasten oder der Kauf-Dialog fuer genau dieses Kit aufgebaut wurde. Auf jeder anderen Seite
     standen directCand, chosenExtras und directServices auf Werk, und die Schublade war leer.
     Uebrig blieb allein der Warmwasserspeicher: Der wird nicht gespeichert, sondern aus den
     Antworten abgeleitet (speicher() liest A.dhw/A.persons) - und die Antworten wurden schon
     immer wiederhergestellt. Genau dieses eine Ding im sonst leeren Warenkorb war das Symptom.

     Eigene, laengere Frist: siehe KORB_TAGE. */
  if(d.direkt && d.direkt.kit && PRODUCTS[d.direkt.kit]
     && Date.now()-(d.direkt.ts||0) <= KORB_TAGE*24*60*60*1000){
    directCand=d.direkt.kit;
    chosenExtras={};
    Object.entries(d.direkt.extras||{}).forEach(([k,v])=>{ if(EXTRAS[k]&&v) chosenExtras[k]=v; });
    directServices=new Set();
    /* buyable!==false auch hier: siehe stelleKaufWiederHer(). Ein zurueckgezogener Service
       darf aus einem alten Link so wenig zurueckkommen wie aus einem alten Stand. */
    (d.direkt.services||[]).forEach(k=>{ if(SERVICES[k] && SERVICES[k].buyable!==false) directServices.add(k); });
    /* Ohne diesen Merker blieben wiederhergestellte Services unsichtbar - er gibt sie erst
       frei, wenn jemand den Services-Schritt erreicht hat. Wer sie gespeichert hat, war dort. */
    if(directServices.size) servicesErreicht=true;
  }
  return true;
}
function vergissStand(){ try{ localStorage.removeItem(STAND_SCHLUESSEL); }catch(e){} }
function markStarted(origin){ if(!configStarted){ configStarted=true; track("config_start",{origin}); } syncResume(); }

/* ============================== BERECHNUNG - 1:1 Herleitung (BETA v0.1) ============================== */
function fmt(n,dec=0){ return n.toLocaleString('de-DE',{minimumFractionDigits:dec,maximumFractionDigits:dec}); }
function etaFor(){
  /* Die Nachfrage nach der genauen Bauart schlaegt die grobe Tabelle (14.10.2026). Sie steht
     nur bei Gas und Oel zur Verfuegung und ist ueberspringbar - ohne sie bleibt alles beim
     Alten, deshalb der Rueckfall auf ETA und nicht etwa ein Vorgabewert. */
  const d = A.heizartDetail && A.heizartDetail!=='unklar' ? ETA_DETAIL[A.heizartDetail] : null;
  const e = d || ETA[A.energy]; if(!e) return null;
  const row = e.all || e[A.baujahr] || e.y1995_2016;
  return row ? {v:row[0], label:row[1]} : null;
}
function calc(){
  const c={};
  c.klima = A.plz ? klimaLookup(A.plz) : null;
  c.san = A.sanierung ? SAN[A.sanierung] : null;
  if(A.dhw==='ja' && A.persons){
    /* PUNKT 2: Grundbedarf je Person plus EIN fester Zirkulationsbetrag, nicht mitskaliert. */
    const qbp   = WW.QBP[A.komfort] != null ? WW.QBP[A.komfort] : WW.QBP.normal;
    const zirkAn = (A.zirk === 'ohne') ? false
                 : (A.zirk === 'lang' || A.zirk === 'puffer') ? true
                 : WW.ZIRK_STANDARD;   /* 'unklar' - der Rechner fragt es (noch) nicht ab */
    c.zirk_an = zirkAn;
    c.qww = Math.round((WW.KOEFF * qbp * A.persons + (zirkAn ? WW.ZIRK_KWH : 0)) / WW.ETA);
    c.pww = A.persons * CONFIG.RULES.DHW_KW_PER_PERSON;
  } else if(A.dhw==='nein'){ c.qww=0; c.pww=0; }
  if(A.heizlastDirect){
    c.mode='din'; c.phl=A.heizlastDirect; c.r=0;
    c.pausl = (c.pww!==undefined) ? Math.round((c.phl + c.pww)*10)/10 : null;
    return c;
  }
  c.mode='verbrauch';
  /* MITTEL AUS BIS ZU DREI JAHREN (14.10.2026, aus dem Auslegungstool).

     Ein einzelner Winter weicht leicht um ein Siebtel vom Mittel ab, und genau dieses Siebtel
     stand bisher ungedaempft in der Heizlast. Wer nur ein Jahr eintraegt, bekommt unveraendert
     die bisherige Rechnung - der Mittelwert aus einem Wert IST dieser Wert. */
  const jahre=[A.consumptionValue,A.verbrauch2,A.verbrauch3].map(Number).filter(v=>isFinite(v)&&v>0);
  if(A.unit && jahre.length){
    c.hw=HEIZWERT[A.unit];
    c.jahre=jahre.length;
    c.vmittel=jahre.reduce((a,b)=>a+b,0)/jahre.length;
    c.ein=c.vmittel*c.hw.f;
  }
  c.eta=etaFor();
  if(c.ein!==undefined && c.eta) c.qnutz=c.ein*c.eta.v;
  /* KAMINHOLZ KOMMT MIT SEINEM EIGENEN NUTZUNGSGRAD DAZU (14.10.2026).

     ABWEICHUNG VOM AUSLEGUNGSTOOL, UND ZWAR ABSICHTLICH: Dort wird das Holz auf den
     Jahresverbrauch addiert und die Summe mit dem Nutzungsgrad der HAUPTHEIZUNG multipliziert.
     Bei einem Gas-Brennwertkessel waeren das 0,92 fuer einen Kaminofen - der liegt real bei gut
     0,85 (ETA.holz, DIN V 18599-5). Der Unterschied geht in die falsche Richtung: Er rechnet
     die Waerme aus dem Ofen zu hoch und damit die Heizlast zu gross.

     DER OFEN ZAEHLT VOLL MIT, obwohl er nach dem Umbau vielleicht kalt bleibt. Das ist die
     sichere Seite: Die Waermepumpe muss das Haus auch dann warm halten, wenn niemand Holz
     nachlegt. */
  if(A.kamin==='ja' && A.holzRm>0){
    c.eholz=A.holzRm*HEIZWERT.holz_rm.f;
    c.qholz=c.eholz*ETA.holz.all[0];
    if(c.qnutz!==undefined) c.qnutz+=c.qholz;
  }
  /* WARMWASSER NUR ABZIEHEN, WENN ES AUCH DRINSTECKT (14.10.2026).

     Bisher wurde es immer abgezogen. Wer sein Wasser ueber einen Durchlauferhitzer macht,
     verlor damit rund 2.000 kWh, die nie auf der Gasrechnung standen - und bekam eine zu kleine
     Heizlast, ohne dass irgendetwas darauf hingewiesen haette. Ohne Antwort bleibt es beim
     Abzug: Das ist der haeufige Fall und das bisherige Verhalten. */
  if(c.qnutz!==undefined && c.qww!==undefined){
    c.wwAbzug=(A.wwImVerbrauch==='nein')?0:c.qww;
    c.qheiz=Math.max(0,c.qnutz-c.wwAbzug);
  }
  /* PUNKT 4: derselbe T_grenz wie in der Kennlinie - siehe BIV.T_GRENZ_KURVE. */
  c.tgrenz = heizgrenze(c.san);
  if(c.klima && (c.san || BIV.T_GRENZ_KURVE))
    c.bvh=Math.round(8760*(c.tgrenz-c.klima.tm)/(c.tgrenz-c.klima.tn));
  if(c.qheiz!==undefined && c.bvh) c.phl=Math.round(c.qheiz/c.bvh*100)/100;
  if(c.phl!==undefined && c.san) c.r=c.san.r;
  if(c.phl!==undefined && c.r!==undefined && c.pww!==undefined)
    c.pausl=Math.round((c.phl*(1+c.r)+c.pww)*10)/10;
  return c;
}
/* ===== MINDESTLEISTUNG UND TAKTGRENZE (14.10.2026) =====

   Gebraucht fuer die neue Ergebnisseite (Vorgabe Claras: "in der HTML, die ich dir geschickt
   habe, gibt es auch die Ergebnisseite ... kannst du bitte die jetzige Seite nach dem
   E-Mail-Gate zu der Ergebnisseite der HTML-Datei umwandeln").

   WAS DIE MINDESTLEISTUNG AUSSAGT: Eine Waermepumpe moduliert nur bis zu einem bestimmten
   Punkt herunter. Faellt der Waermebedarf des Hauses darunter, geht sie an und aus - sie
   taktet. Das kostet Effizienz und Lebensdauer, und es ist der Grund, warum das groesste Kit
   nicht automatisch das beste ist. Ohne diese Zahl kann die Ergebnisseite "taktet ab X °C"
   nicht sagen, und der Satz waere eine Behauptung.

   ZWEI EINSCHRAENKUNGEN DER QUELLE, die hier stehen muessen, weil man sie den Zahlen nicht
   ansieht:
     1. HP3-8, HP3-10 und HP3-12 teilen sich EINE Tabelle. So steht es im Auslegungstool
        (minPerformanceMatrix: FOX_MIN_MATRIX fuer alle drei). Real unterscheidet sich die
        untere Modulationsgrenze der drei Geraete; eine eigene Tabelle je Geraet gibt die
        Quelle nicht her.
     2. Die Werte der 5 kW sind ABGELEITET, nicht gemessen: Sie sind durchgaengig das
        0,556-Fache der grossen Tabelle (4,62 -> 2,569 usw.), also mit 5/9 skaliert. Wer ein
        MIN-Datenblatt der HP1-5 bekommt, ersetzt sie hier.

   DIE STUETZSTELLEN SIND DIE VON PERF (-15/-7/2/7 °C, W35/W45/W55/W65) - nicht die volle
   13x7-Matrix des Auslegungstools. Sonst gaebe es im selben Code zwei verschiedene Raster fuer
   dieselben Geraete, und interpAt() koennte nicht beide bedienen. Die Werte sind aus der
   Matrix an genau diesen Punkten abgelesen, nicht interpoliert. */
const PERF_MIN = {
  /* HP3-8 / HP3-10 / HP3-12, gemeinsame Tabelle - siehe Einschraenkung 1 oben. */
  gemeinsam:{t:[-15,-7,2,7], W35:[4.62,4.96,2.90,3.25], W45:[4.59,4.95,2.68,3.00],
                             W55:[4.56,4.88,2.52,2.82], W65:[4.54,4.85,2.37,2.66]},
  /* HP1-5, abgeleitet - siehe Einschraenkung 2 oben. */
  fox5:     {t:[-15,-7,2,7], W35:[2.57,2.76,1.61,1.81], W45:[2.55,2.75,1.49,1.67],
                             W55:[2.53,2.71,1.40,1.57], W65:[2.52,2.70,1.32,1.48]}
};
/* Lineare Interpolation wie interpAt(), nur auf der MIN-Tabelle. Ausserhalb der Stuetzstellen
   wird gehalten statt extrapoliert: Die Kurve ist nicht monoton (bei -7 liegt die
   Mindestleistung HOEHER als bei +2), eine Verlaengerung waere also geraten. */
function kitMinPowerAt(kit,tn){
  const tab=PERF_MIN[kit]||PERF_MIN.gemeinsam, col=tab[vlCol()], t=tab.t;
  if(!col) return null;
  const x=Math.max(t[0],Math.min(t[t.length-1],tn));
  for(let i=0;i<t.length-1;i++){
    if(x<=t[i+1]){ const f=(x-t[i])/(t[i+1]-t[i]); return Math.round((col[i]+f*(col[i+1]-col[i]))*100)/100; }
  }
  return col[col.length-1];
}
/* Ab welcher Aussentemperatur faellt der Waermebedarf unter die Mindestleistung? Oberhalb
   davon taktet das Geraet. null = nie (es moduliert bis zur Heizgrenze durch). */
function taktgrenze(kit,pausl,tnorm,tgrenz){
  if(!(pausl>0)) return null;
  for(let T=tnorm; T<=tgrenz; T+=0.5){
    const pMin=kitMinPowerAt(kit,T);
    if(pMin==null) return null;
    if(gebaeudeLast(pausl,tnorm,T,tgrenz) < pMin) return Math.round(T*10)/10;
  }
  return tgrenz;
}
/* ===== HEIZSTAB: STUFE UND JAHRESSTROM =====
   Die Hydrobox der HP3-Kits laesst 3, 6 oder 9 kW zu; die HP1-5 nur 3. Gewaehlt wird die
   kleinste Stufe, die den Fehlbetrag bei T_norm deckt. */
const HEIZSTAB_STUFEN={fox5:[3], fox8:[3,6,9], fox10:[3,6,9], fox12:[3,6,9]};
function heizstabStufe(kit,bedarfKw){
  const st=HEIZSTAB_STUFEN[kit]||[3,6,9];
  if(!(bedarfKw>0)) return {stufe:0, reicht:true};
  for(const s of st) if(s>=bedarfKw) return {stufe:s, reicht:true};
  return {stufe:st[st.length-1], reicht:false};
}
/* Jahresarbeit des Heizstabs in kWh: sein Jahresanteil mal der Jahresheizwaerme des Hauses.
   Die Jahresheizwaerme ist Heizlast x Vollbenutzungsstunden - beide stehen in calc(), und zwar
   OHNE Warmwasser. Das ist Absicht: Der Heizstab springt fuer die Heizung ein; was er fuers
   Warmwasser tut, haengt an der Speicherladung und nicht am Bivalenzpunkt. */
function heizstabKwhJahr(c,anteilPct){
  if(!c || !(c.phl>0) || !(c.bvh>0) || !(anteilPct>0)) return 0;
  return Math.round(c.phl*c.bvh*anteilPct/100/10)*10;
}
function vlCol(){ return A.heating==='fbh'?'W35':(A.heating==='mix'?'W45':'W55'); }
function interpAt(kit,colName,tn){
  const p=PERF[kit], col=p[colName], t=p.t;
  const x=Math.max(t[0],Math.min(t[t.length-1],tn));
  for(let i=0;i<t.length-1;i++){
    if(x<=t[i+1]){ const f=(x-t[i])/(t[i+1]-t[i]); return Math.round((col[i]+f*(col[i+1]-col[i]))*100)/100; }
  }
  return col[col.length-1];
}
function kitPowerAt(kit,tn){ return interpAt(kit,vlCol(),tn); }
/* Seit dem Kit-Overview-Umbau (11.08.2026) OHNE AUFRUFER: der einzige war die COP-Angabe in der
   Beleg-Box von renderBuyBox(). Bewusst nicht geloescht - die Funktion ist der einzige benannte
   Zugang zum COP an einer konkreten Aussentemperatur (seasonalCOP() geht direkt ueber interpAt).
   Wer den Wert wieder ausgeben will - etwa im Rechenzettel - greift hier an. */
function kitCopAt(kit,tn){ return interpAt(kit,'C'+vlCol().slice(1),tn); }

/* =====================================================================
   BIVALENZPUNKT-AUSLEGUNG (User-Vorgabe 31.07.2026)

   Ziel: Bivalenzpunkt moeglichst nah an -5 °C. Dort deckt die Waermepumpe rund 90-95 %
   der Jahresarbeit, den Rest uebernimmt der Heizstab an den wenigen kaeltesten Tagen.

   Wichtig zur Einordnung: der LEISTUNGSanteil des Heizstabs bei T_norm (bei SHK-optimaler
   Auslegung 30-35 %) ist NICHT der Wert, auf den sich VDI 4645 bezieht. VDI 4645 meint den
   JAHRESENERGIE-Anteil, und der liegt bei Bivalenzpunkt -5 °C bei rund 5 %, also deutlich
   unter der 25-%-Grenze. Der Leistungsanteil ist hier deshalb nur Information, nie
   Ausschlusskriterium.
   ===================================================================== */
const BIV = {
  T_INNEN: 20,        /* Raumtemperatur - Nullpunkt der Gebaeudekennlinie */
  ZIEL: -5,           /* SHK-Empfehlung */
  FENSTER: [-8,-2],   /* nur hierin gibt es das Empfohlen-Badge */
  SUCHE_MIN: -40,     /* untere Suchgrenze; wer hier noch deckt, ist grob ueberdimensioniert */
  /* Ersatz-Heizgrenztemperatur, wenn der Sanierungsstand nicht bekannt ist. Das ist kein
     Randfall: die Frage "Zustand vom Haus?" wird uebersprungen, sobald jemand seine Heizlast
     direkt in kW eingibt (skip:()=>A.hlgate==='ja') - also gerade bei den gut vorbereiteten
     Kunden mit eigener Heizlastberechnung. Ohne Ersatzwert bliebe der Heizstab-Jahresanteil
     bei genau diesen Anfragen leer. 16 °C ist die Mitte der drei VDI-4645-Staende (15/16/17).
     Der Bivalenzpunkt selbst ist davon nicht betroffen - er braucht nur P_ausl und T_norm. */
  T_GRENZ_ERSATZ: 16,
  /* PUNKT 4 (28.08.2026). Die Gebaeudekennlinie lief bisher gegen T_INNEN (20 °C) - die
     klassische Form, bei der der Waermebedarf erst bei Raumtemperatur null wird. Das
     Quelldokument gibt stattdessen P_bedarf(T) = P_ausl * (T_grenz - T)/(T_grenz - T_norm)
     mit T_grenz = 15 °C vor, also die Heizgrenze statt der Raumtemperatur.

     WIRKUNG: die Kennlinie wird steiler, der Bedarf oberhalb T_norm sinkt, und damit
     wandert JEDER Bivalenzpunkt nach unten - die Kits wirken groesser.

     OHNE QUELLENANGABE IM DOKUMENT. Ueberall sonst ist es sorgfaeltig belegt (SHK Info,
     DIN V 18599-8, DIN 4708); ausgerechnet dieser Wert steht ohne Norm da, und er hat den
     groessten Einzeleffekt der ganzen Liste. Deshalb EINE Konstante fuer alle drei
     Verwendungen (Kennlinie, Belastungsgrad, Heizstabanteil): Janniks Antwort ist damit
     eine Zeile, kein Umbau. Zurueck auf VDI 4645 heisst: hier null setzen, dann greift
     wieder SAN.tg (15/16/17 nach Sanierungsstand). */
  T_GRENZ_KURVE: 15
};
/* Welche Heizgrenze gilt - eine Stelle fuer Kennlinie, Belastungsgrad und Heizstabanteil. */
function heizgrenze(san){
  if(BIV.T_GRENZ_KURVE) return BIV.T_GRENZ_KURVE;
  return san ? san.tg : BIV.T_GRENZ_ERSATZ;
}
/* Gebaeudeheizlast bei Aussentemperatur t: bei T_norm die volle Auslegungslast,
   bei Raumtemperatur null. P_ausl enthaelt Warmwasser und Sicherheitsaufschlag (siehe calc()). */
function gebaeudeLast(pausl,tnorm,t,tgrenz){
  const tg = tgrenz || heizgrenze(null);
  return Math.max(0, pausl*(tg-t)/(tg-tnorm));
}
/* Schnittpunkt von WP-Leistungskurve und Gebaeudekennlinie.
   f(t) = P_wp(t) - P_geb(t) waechst streng monoton - P_wp steigt mit der Aussentemperatur,
   P_geb faellt. Es gibt also genau eine Nullstelle, und Bisektion findet sie zuverlaessig
   ohne Startwert-Raterei. 60 Halbierungen sind weit mehr als die 0,1 K, die wir ausgeben. */
function bivalenzpunkt(kit,pausl,tnorm,tgrenz){
  if(!pausl||tnorm===undefined||tnorm===null) return null;
  const col=vlCol();
  const tg=tgrenz||heizgrenze(null);
  const f=t=>interpAt(kit,col,t)-gebaeudeLast(pausl,tnorm,t,tg);
  /* PUNKT 4, Suchbereich: das Dokument verlangt Start bei T_norm-15, damit eine
     Ueberdimensionierung ueberhaupt erkennbar wird. SUCHE_MIN=-40 liegt darunter (bei
     T_norm -10,3 waeren es -25,3) und erfuellt die Forderung damit strenger. Statt
     0,5-K-Schritten laeuft eine Bisektion ueber 60 Halbierungen, also feiner als gefordert. */
  let lo=BIV.SUCHE_MIN, hi=tg;
  if(f(lo)>=0) return BIV.SUCHE_MIN;
  for(let i=0;i<60;i++){ const m=(lo+hi)/2; if(f(m)<0) lo=m; else hi=m; }
  return Math.round(((lo+hi)/2)*10)/10;
}
/* Jahresenergie-Anteil des Heizstabs: ((t_biv - t_norm)/(t_grenz - t_norm))^2
   Beispiel Berlin (T_norm -11, T_grenz 15): Biv -5 -> 5 %, Biv -3 -> 10 %, Biv 0 -> 18 %. */
function heizstabJahresanteil(tbiv,tnorm,tgrenz){
  if(tbiv==null||tnorm==null||tgrenz==null||tgrenz<=tnorm) return null;
  if(tbiv<=tnorm) return 0;
  const a=(tbiv-tnorm)/(tgrenz-tnorm);
  return Math.min(100, Math.round(a*a*1000)/10);
}
/* Bewertung: 1000 Punkte am Ziel, 50 Punkte Abzug je Kelvin Abstand.
   -500 wenn der Bivalenzpunkt ueber 0 °C liegt (WP zu klein - der Heizstab traegt dann
   einen erheblichen Teil der Jahresarbeit).
   Ueberdimensioniert (Bivalenzpunkt mehr als 2 K unter T_norm): 100 Punkte Grundabzug plus
   50 je weiterem Kelvin. Die Vorgabe nennt "-100+"; ohne den wachsenden Anteil bekaeme eine
   absurd grosse Maschine denselben Abzug wie eine knapp zu grosse. */
function bivalenzScore(tbiv,tnorm){
  if(tbiv==null||tnorm==null) return null;
  let s=1000-Math.abs(tbiv-BIV.ZIEL)*50;
  if(tbiv>0) s-=500;
  if(tbiv<tnorm-2) s-=100+(tnorm-2-tbiv)*50;
  return Math.round(s);
}
/* Nennleistung eines Kits in kW - Sortierschluessel der Gleichstandsregel (Punkt 6).
   Kommt aus dem Schluessel (fox8 -> 8), weil PERF nur Kennlinienpunkte fuehrt und keine
   Nennangabe. Rueckfall auf die Leistung bei Normaussentemperatur, falls je ein Kit ohne
   Zahl im Schluessel dazukommt - fuer die Reihenfolge unter drei Fox-Kits gleichwertig. */
function nennleistung(kand){
  const m = /(\d+)/.exec(kand && kand.kit || '');
  if(m) return parseInt(m[1],10);
  return (kand && kand.kitKw) != null ? kand.kitKw : Infinity;
}
const imBivFenster = t => t!=null && t>=BIV.FENSTER[0] && t<=BIV.FENSTER[1];
/* Abstand zum Ziel - Sortier- und Auswahlschluessel. Kandidaten ohne Bivalenzpunkt
   (Hybrid) landen hinten, nicht vorne. */
const bivAbstand = t => t==null ? Infinity : Math.abs(t-BIV.ZIEL);
/* routeAll(): liefert ALLE anwendbaren Kandidaten statt nur der ersten passenden Empfehlung (Punkt 1).
   Kits, die nicht reichen (Deckung unter der Schwelle BIVALENT_MIN) ODER die Beistell-WP, wenn sie technisch nicht passt,
   werden nicht versteckt, sondern mit sichtbarem Hinweis gezeigt - der Kunde sieht auch, warum wir
   etwas nicht empfehlen, und behält trotzdem alle vier Auswahlmöglichkeiten.
   type:'waitlist' bleibt für den echten Extremfall (Sonstiges-Energieträger, fox12 unter der Schwelle ohne
   passenden Hybrid-Pfad, oder fehlende Daten) - Kandidaten bleiben dabei trotzdem sichtbar. */
function routeAll(){
  const c=calc();
  if(A.energy==='sonstiges') return {type:"waitlist",reason:"Für deinen Heizungstyp haben wir noch kein Kit.",c,candidates:[],recommended:null};
  /* HYBRID BEI ZWEI HEIZKREISEN AUSGESCHLOSSEN (Betreiber-Entscheid 18.08.2026)
     Wer Fussbodenheizung UND Heizkoerper hat, braucht zwei getrennt geregelte Kreise. Das
     Hybrid-Kit deckt das nicht ab, und eine saubere Loesung dafuer gibt es derzeit nicht.
     Die Karte wird deshalb gar nicht erst erzeugt - anders als bei den Fox-Kits, die bei
     Nichteignung sichtbar bleiben und den Grund nennen (siehe Kommentar oben). Das ist eine
     bewusste Umkehr fuer genau diesen Fall: hier gibt es keine Variante, die trotzdem ginge.
     hybridMoeglich fliesst AUCH in hybridFits ein, nicht nur in den Push - sonst wirbt der
     "Zwei Wege"-Block weiter fuer ein Kit, das nicht mehr auf der Seite steht. */
  /* Ausgeblendet (CONFIG.RULES.HYBRID_SICHTBAR=false) verhaelt sich der Rechner so, als gaebe
     es das Beistell-Geraet nicht: kein Kandidat, kein Siegel, kein Zwei-Wege-Block. */
  const hybridMoeglich = CONFIG.RULES.HYBRID_SICHTBAR && A.heating!=='mix';
  const hybridFits = hybridMoeglich && (A.energy==='gas' && A.baujahr===CONFIG.RULES.HYBRID_BAUJAHR);
  /* Nur wer den Hybrid sonst BEKOMMEN haette, bekommt den Hinweis samt Warteliste. Sonst
     erklaerte man jedem Kunden mit zwei Heizkreisen ein Produkt weg, das ihm ohnehin nie
     angeboten worden waere - und die drei Fox-Kits stehen ja weiterhin zur Wahl. */
  /* Der Banner erklaert, WARUM es keine Hybrid-Loesung gibt - und nennt sie dabei. Solange das
     Kit ausgeblendet ist, waere das der einzige Ort, an dem der Kunde ueberhaupt davon erfaehrt. */
  const hybridEntfallen = CONFIG.RULES.HYBRID_SICHTBAR
    && !hybridMoeglich && A.energy==='gas' && A.baujahr===CONFIG.RULES.HYBRID_BAUJAHR;
  const candidates=[];
  if(hybridMoeglich) candidates.push({
    kit:"hybrid", c, kitKw:null, coverage:null, sufficient:hybridFits, bivalent:false,
    note: hybridFits
      ? "Deine Gasheizung ist jung, die Wärmepumpe übernimmt die Grundlast, Gas nur an den kältesten Tagen."
      : "Ergänzt eine Gasheizung ab Baujahr 2016, für dein aktuelles Setup keine passende Lösung."
  });
  if(!c.pausl){
    return {type:"waitlist",reason:"Ohne vollständige Daten keine seriöse Auslegung für die Fox-Kits.",c,candidates,recommended:hybridFits?'hybrid':null,hybridEntfallen};
  }
  if(!c.klima){
    return {type:"waitlist",reason:"PLZ nicht erkannt, Fox-Kits können ohne Klimadaten nicht ausgelegt werden.",c,candidates,recommended:hybridFits?'hybrid':null,hybridEntfallen};
  }
  const tn=c.klima.tn;
  /* Heizgrenztemperatur: kommt aus dem Sanierungsstand (VDI 4645: 15/16/17 °C), NICHT aus
     dem PLZ-Datensatz - der fuehrt nur Norm- und Jahresmitteltemperatur. Siehe SAN.
     Fehlt der Sanierungsstand (Heizlast wurde direkt eingegeben), greift der Ersatzwert. */
  const tgGeschaetzt = !c.san && !BIV.T_GRENZ_KURVE;
  const tg = heizgrenze(c.san);
  /* DIE KANDIDATEN KOMMEN AUS KIT_REIHE, NICHT AUS EINER EIGENEN LISTE (13.10.2026). Hier
     stand ['fox8','fox10','fox12'] - die dritte getippte Reihenfolge neben KIT_REIHE, und die
     einzige, die wirklich wehtat: Sie entschied, welche Kits der Rechner ueberhaupt in
     Betracht zieht. Das 5-kW-Kit konnte deshalb nie empfohlen werden, auch nachdem es Daten
     hatte.

     AUFSTEIGEND NACH LEISTUNG, und darauf verlaesst sich die Auswahl weiter unten: find()
     liefert das kleinste passende Kit. KIT_REIHE ist genau so sortiert (5, 8, 10, 12) - das
     steht dort auch als Begruendung.

     WER KEINE KENNLINIE HAT, IST KEIN KANDIDAT: Ohne PERF liesse sich weder die Leistung bei
     Normaussentemperatur noch der Bivalenzpunkt rechnen. Das Hybrid-Kit faellt ueber dieselbe
     Bedingung heraus und bekommt seinen Kandidaten weiter oben eigens gebaut. */
  /* VOLLBENUTZUNGSSTUNDEN AUCH IM HEIZLAST-WEG (14.10.2026).

     calc() rechnet sie nur im Verbrauchsweg - dort braucht die Rechnung sie, um aus der
     Jahresenergie die Heizlast zu machen. Wer seine Heizlast direkt eingibt, steigt vorher aus
     (c.mode==='din'), und c.bvh bleibt leer. Fuer die Ergebnisseite ist die Jahreswaerme aber
     in BEIDEN Wegen noetig: Ohne sie laesst sich der Heizstab-Strom nicht in kWh und damit
     nicht in Euro ausdruecken, und genau das ist die Zahl, an der sich die Kits unterscheiden.

     HIER UND NICHT IN calc(): Die Rechnung selbst bleibt damit Zeile fuer Zeile die, die sie
     vor dem Umbau war - nachgewiesen an 740 Faellen. Eine zusaetzliche Zahl im Rueckgabewert
     waere folgenlos gewesen, aber sie haette genau diesen Nachweis zerschossen. Dieselbe
     Formel wie in calc(), 8760 Stunden mal dem Verhaeltnis der Temperaturdifferenzen. */
  const jahresBvh = c.bvh || (c.klima ? Math.round(8760*(tg-c.klima.tm)/(tg-c.klima.tn)) : 0);
  KIT_REIHE.filter(k=>k!=='hybrid' && PERF[k]).forEach(k=>{
    const kw=kitPowerAt(k,tn), coverage=Math.round((kw/c.pausl)*1000)/1000;
    /* Beide Auslegungswege werden immer gerechnet - welcher die Anzeige bestimmt, entscheidet
       CONFIG.RULES.AUSWAHL. So stehen die Bivalenz-Zahlen auch dann im Lead-Datensatz, wenn
       die Anzeige noch nach Deckung laeuft. */
    const tbiv=bivalenzpunkt(k,c.pausl,tn,tg);
    candidates.push({kit:k,c,kitKw:kw,coverage,
      sufficient: coverage>=CONFIG.RULES.BIVALENT_MIN,
      /* bivalent = reicht, aber nur mit Heizstab-Unterstuetzung an den kaeltesten Tagen */
      bivalent: (coverage<1 && coverage>=CONFIG.RULES.BIVALENT_MIN),
      tbiv,
      heizstabPct: heizstabJahresanteil(tbiv,tn,tg),
      tgGeschaetzt,
      bivScore: bivalenzScore(tbiv,tn),
      imFenster: imBivFenster(tbiv),
      /* FUER DIE ERGEBNISSEITE (14.10.2026). Sie stehen am Kandidaten und nicht erst beim
         Zeichnen: So tragen sie auch der Lead-Datensatz und ein gespeicherter Stand, und es
         gibt nur eine Stelle, an der sie entstehen.
           taktAb         ab welcher Aussentemperatur das Geraet an und aus geht
           heizstabKwh    Jahresarbeit des Heizstabs in kWh
           hsStufe        kleinste Stufe der Hydrobox, die den Fehlbetrag bei T_norm deckt */
      taktAb: taktgrenze(k,c.pausl,tn,tg),
      heizstabKwh: heizstabKwhJahr({phl:c.phl, bvh:jahresBvh}, heizstabJahresanteil(tbiv,tn,tg)),
      hsStufe: heizstabStufe(k, Math.max(0,(c.pausl||0)-kw))});
  });
  const nachBivalenz = CONFIG.RULES.AUSWAHL==='bivalenz';
  /* candidates ist aufsteigend nach Leistung befuellt - find() liefert also das kleinste passende Kit. */
  /* Die 5-%-Grenze aus VDI 4645 (14.10.2026, Vorgabe Claras) - siehe CONFIG.RULES.
     Kandidaten ohne Jahresanteil (das Hybrid-Kit) fallen nicht durch diese Pruefung: Dort gibt
     es keinen Bivalenzpunkt in diesem Sinn, und eine fehlende Zahl ist kein Verstoss. */
  const heizstabOk = x => x.heizstabPct==null || x.heizstabPct <= CONFIG.RULES.HEIZSTAB_MAX_PCT;
  const foxSufficient=candidates.find(x=>x.kit!=='hybrid' && x.sufficient && heizstabOk(x));
  /* Bivalenz-Regel: unter den Kits im Fenster [-8 °C, -2 °C] gewinnt das mit dem kleinsten
     Abstand zu -5 °C. Liegt keines im Fenster, gibt es KEIN Badge - stattdessen der Hinweis
     "Dimensionierung pruefen". Bewusst kein Ausweichen auf das naechstbeste: ein Badge ausserhalb
     des Fensters waere genau die Empfehlung, die die Vorgabe verhindern will. */
  const imFenster=candidates.filter(x=>x.imFenster && heizstabOk(x)).sort((a,b)=>bivAbstand(a.tbiv)-bivAbstand(b.tbiv));
  /* PUNKT 6 - GLEICHSTANDSREGEL (28.08.2026, Vamo Auslegungstool BETA v0.3).
     Bei praktisch gleicher Zielnaehe gewinnt die KLEINERE Maschine: sie laeuft im milden
     Bereich, wo die meisten Jahresstunden liegen, naeher an ihrer Mindestleistung und taktet
     weniger. Die Reserve fuer die wenigen kalten Tage traegt der Heizstab.

     Bewusst als Reduce und nicht als Sortier-Comparator: "a schlaegt b, wenn fast gleich und
     kleiner" ist nicht transitiv - das Ergebnis haenge sonst von der Eingangsreihenfolge ab.

     Die 2,0-K-Obergrenze ist zwingend. Ohne sie zieht eine Kette von Beinahe-Gleichstaenden
     (1,7 -> 2,2 -> 2,7) eine Maschine herein, die das Ziel deutlich verfehlt. */
  const bivBest = (function(){
    if(!imFenster.length) return null;
    const dMin = Math.min(...imFenster.map(x=>bivAbstand(x.tbiv)));
    const gleichwertig = imFenster.filter(x=>{
      const d = bivAbstand(x.tbiv);
      return d <= dMin + 0.5 && d <= 2.0;
    });
    const pool = gleichwertig.length ? gleichwertig : imFenster;
    return pool.reduce((a,b)=> (nennleistung(b) < nennleistung(a) ? b : a));
  })();

  /* Was die Bivalenz-Regel entschieden HAETTE - unabhaengig davon, welche Regel gerade laeuft.
     Genau das ist die Zahl, an der sich spaeter beurteilen laesst, ob die Regel scharfgeschaltet
     werden soll. Geht mit ins Tracking, weil der Lead-Weg mangels Webhook noch nichts liefert. */
  const bivEmpfehlung = bivBest ? bivBest.kit : null;
  let recommended=null;
  if(hybridFits) recommended='hybrid';
  else if(nachBivalenz) recommended = bivBest ? bivBest.kit : null;
  else if(foxSufficient) recommended=foxSufficient.kit;
  /* ZWEI WEGE BEI JUNGER GASHEIZUNG (User-Vorgabe 07.08.2026).
     Bisher hat hybridFits alles ueberstimmt: das Empfohlen-Siegel klebte auf dem Hybrid-Kit,
     und welches Fox-Kit beim vollstaendigen Ersetzen passen wuerde, wurde zwar gerechnet,
     aber nirgends gezeigt. Der Kunde sah vier Produkte und eine Empfehlung - nicht, dass
     dahinter zwei verschiedene Entscheidungen stehen (Gasheizung bleibt vs. Gasheizung raus).
     ersatzEmpfehlung traegt jetzt den Ersetzen-Weg, damit beide Wege ein Siegel haben.
     Nur belegt, wenn der Hybrid ueberhaupt in Frage kommt - sonst IST recommended bereits
     der Ersetzen-Weg und ein zweites Siegel waere Doppelung. */
  const ersatzEmpfehlung = hybridFits
    ? (nachBivalenz ? (bivBest?bivBest.kit:null) : (foxSufficient?foxSufficient.kit:null))
    : null;
  /* Kein fox12-Sonderweg mehr noetig: sufficient beruecksichtigt die 80-%-Schwelle bereits,
     foxSufficient findet damit das KLEINSTE ausreichende Kit statt automatisch das groesste. */
  /* PUNKT 6, zweiter Teil (28.08.2026): der Empfohlene gehoert an die erste Position - eine
     Reihenfolge, die dem Abzeichen widerspricht, fuehrt laut Quelldokument zu Fehlbestellungen.
     BEWUSST NACH recommended UND NICHT NACH bivBest: bei junger Gasheizung gewinnt der Hybrid,
     bivBest ist dann nur der Ersetzen-Weg. Wuerde man bivBest vorziehen, staende ein Fox-Kit
     vor dem Kit, das das Abzeichen traegt - genau der Fehler, den die Vorgabe ausschliesst. */
  if(recommended){
    const i = candidates.findIndex(x=>x.kit===recommended);
    if(i > 0) candidates.unshift(candidates.splice(i,1)[0]);
  }
  /* Die 5-%-Grenze hat zugeschlagen (14.10.2026, Vorgabe Claras): Es gibt keine Empfehlung,
     und der Grund ist NICHT das Bivalenzfenster, sondern der Heizstab-Jahresanteil. Gemessen
     wird am besten erreichbaren Wert - schafft nicht einmal das groesste Kit die 5 %, dann
     traegt kein Angebot von uns dieses Haus.
     Das Hybrid-Kit zaehlt hier nicht mit: Es hat keinen Heizstab in diesem Sinn, und wo es
     passt, steht es ohnehin als Empfehlung da. */
  const hsKand = candidates.filter(x=>x.kit!=='hybrid' && x.heizstabPct!=null);
  const heizstabMinPct = hsKand.length ? Math.min(...hsKand.map(x=>x.heizstabPct)) : null;
  const heizstabZuHoch = !recommended && heizstabMinPct!=null
    && heizstabMinPct > CONFIG.RULES.HEIZSTAB_MAX_PCT;
  /* dimPruefen weicht dem Heizstab-Hinweis: Beide Baender sagen "keine Empfehlung", aber nur
     eines nennt den richtigen Grund. Stuenden sie zusammen, laese es sich als zwei getrennte
     Probleme - es ist eines. */
  const dimPruefen = nachBivalenz && !hybridFits && !bivBest && !heizstabZuHoch;
  /* Warteliste bleibt dem echten Extremfall vorbehalten. Im Bivalenz-Modus ist "kein Kandidat
     im Fenster" ausdruecklich KEIN Extremfall - der Kunde sieht alle Kits samt Hinweis und
     kann weiterhin waehlen. Abgebrochen wird nur, wenn die Heizlast das groesste Kit sprengt.

     Im Bivalenz-Modus darf dieser Zweig NICHT mehr an der Deckungsschwelle haengen. Sonst
     ueberstimmt die alte 80-%-Regel die neue Empfehlung: bei 14,8 kW Heizlast liegt fox12
     mit -3,8 °C sauber im Fenster, kaeme aber ueber foxSufficient nie an - der Kunde saehe
     weder ein Badge noch den Hinweis. Genau die Vermischung, die die Vorgabe ausschliesst
     ("Leistungsanteil ist nur informativ, nicht Ausschlusskriterium").
     Massstab hier: kein einziges Kit schafft einen Bivalenzpunkt bei oder unter 0 °C, ist
     also selbst im mildesten Fall zu klein fuer das Haus. */
  const extremfall = nachBivalenz
    ? (!hybridFits && !candidates.some(x=>x.kit!=='hybrid' && x.tbiv!=null && x.tbiv<=0))
    : (!hybridFits && !foxSufficient);
  if(extremfall) return {type:"waitlist",reason:`${fmt(c.pausl,1)} kW liegt über unserem größten Kit.`,c,candidates,recommended:null,dimPruefen,bivEmpfehlung,hybridEntfallen,heizstabZuHoch,heizstabMinPct};
  return {type:"comparison",candidates,recommended,c,dimPruefen,bivEmpfehlung,hybridFits,ersatzEmpfehlung,hybridEntfallen,heizstabZuHoch,heizstabMinPct};
}
function speicher(){ if(A.dhw!=='ja') return null; return A.speicherChoice || ((A.persons<=2)?'sp200':'sp300'); }
function speicherRec(){ if(A.dhw!=='ja') return null; return (A.persons<=2)?'sp200':'sp300'; }
/* zvE-Klassenreihenfolge, 1:1 aus billigerwaermepumpe-foerderrechner-vergleich.html übernommen */
const ZVE_ORDER=['b30','30_40','40_50','50_60','a60'];
function zveIndex(){ return A.zve ? ZVE_ORDER.indexOf(A.zve) : -1; } // -1 bei "keine Angabe" oder noch unbeantwortet
/* Halbjahresschritte seit CONFIG.FOERDER.START (0 = Startdatum, negativ wird auf 0 geklemmt) */
function foerderHalfSteps(){
  const start=new Date(CONFIG.FOERDER.START), now=new Date();
  const months=(now.getFullYear()-start.getFullYear())*12+(now.getMonth()-start.getMonth());
  return Math.max(0,Math.floor(months/6));
}
/* EIN Regime seit der Kürzung vom 08.07.2026 (in Kraft 21.07.2026): 30 Grund + 5 Effizienz (natürliches
   Kältemittel, für Fox bestätigt 17.07.2026) + degressiver Klimabonus (fossile Altheizung, startet bei 20 %, sinkt
   alle 6 Monate um 4 Punkte, Boden 0) + gestaffelter Einkommensbonus (zvE-Klasse × Kinderstatus, bis 40 %).
   Ohne zvE-Angabe: konservative Schätzung ohne Einkommensbonus statt gar keiner Zahl - Punkt "trotzdem volle
   Förderung zeigen" wiegt hier mehr als Präzision. Cap 80. 1:1 aus billigerwaermepumpe-foerderrechner-vergleich.html (Excel
   "billigerWaermepumpe Förderrechner 3.0") + Haushaltsausschuss-Beschluss. */
/* Grundfoerderung ab dem 01.01.2027 abhaengig vom Fertigungsort. Ohne bekanntes Kit wird
   der guenstigere Fall NICHT unterstellt - dann gilt weiter die volle Grundfoerderung, weil
   der Kunde an dieser Stelle noch gar kein Geraet gewaehlt hat. */
function grundfoerderung(kitKey){
  const F=CONFIG.FOERDER;
  if(new Date() < new Date(F.EU_REGEL_AB)) return F.GRUND;
  const kit = kitKey && PRODUCTS[kitKey];
  if(kit && kit.euFertigung === false) return F.GRUND_NICHT_EU;
  return F.GRUND;
}
/* Der 80-%-Deckel gilt nur fuer Selbstnutzende mit niedrigem zu versteuerndem Einkommen:
   bis 30.000 EUR, mit mindestens einem minderjaehrigen Kind bis 40.000 EUR. */
function foerderCap(){
  const F=CONFIG.FOERDER;
  const hoch = A.kinder==='ja' ? ['b30','30_40'] : ['b30'];
  return hoch.includes(A.zve) ? F.CAP_GERINGVERDIENER : F.CAP;
}
function foerderQuote(kitKey){
  const F=CONFIG.FOERDER; if(F.MODE==='off') return null;
  let q=grundfoerderung(kitKey)+F.EFFIZIENZ;
  if(['gas','oel'].includes(A.energy)) q+=Math.max(0,F.KLIMA_START-F.KLIMA_SCHRITT*foerderHalfSteps());
  const i=zveIndex();
  if(i>=0) q+=(A.kinder==='ja'?F.EK_MIT_KIND:F.EK_OHNE_KIND)[i];
  return Math.min(q,foerderCap());
}
/* ============ WAS FEHLT FUER DIE FOERDERQUOTE? (14.10.2026) ============

   Vorgabe Claras: "wenn ein Kunde den Rechner nicht durchgemacht hat und sich den Warenkorb
   einfach so zusammenstellt, dann hat man ja nicht die Infos fuer die Prozent der Foerderung,
   und im Warenkorb wird dann der geringste Prozentsatz angezeigt. Schreib beim Warenkorb einen
   kleinen Hinweis dazu, sodass sie wissen, dass das der Fall ist."

   DER UNTERSCHIED IST ALLES ANDERE ALS KLEIN. foerderQuote() rechnet ohne Angaben nur die
   Grundfoerderung - derzeit 30 %. Mit Klimabonus (fossile Altheizung) und Einkommensbonus sind
   bis zu 80 moeglich. Auf ein Paket von 20.000 EUR sind das 10.000 EUR Unterschied, und der
   Kunde sieht die kleinere Zahl, ohne zu erfahren, warum sie klein ist.

   "KEINE ANGABE" IST EINE ANTWORT UND KEINE LUECKE: Wer im Rechner beim Einkommen ausdruecklich
   "Keine Angabe" gewaehlt hat (A.zveChoice==='ka'), hat entschieden. Den soll der Warenkorb
   nicht bei jedem Blick daran erinnern. Deshalb wird zveChoice geprueft und nicht nur A.zve -
   die beiden sind genau fuer diese Unterscheidung getrennt gefuehrt. */
function foerderLuecken(){
  const l=[];
  if(!A.energy) l.push('heizung');
  if(zveIndex()<0 && A.zveChoice!=='ka') l.push('einkommen');
  return l;
}
/* Die Quote, die mit allen Angaben hoechstens herauskaeme - fuer den Satz "bis zu X %".

   DER HOEHERE DECKEL IST HIER RICHTIG: 80 % gelten nur fuer Selbstnutzende mit zvE bis 30.000
   EUR - und genau diese Klasse traegt auch den hoechsten Einkommensbonus. Wer das Maximum
   erreicht, erreicht es also unter dem Deckel, der dazu passt. */
function foerderQuoteMoeglich(kitKey){
  const F=CONFIG.FOERDER; if(F.MODE==='off') return null;
  const q = grundfoerderung(kitKey) + F.EFFIZIENZ
    + Math.max(0,F.KLIMA_START-F.KLIMA_SCHRITT*foerderHalfSteps())
    + Math.max.apply(null, F.EK_MIT_KIND.concat(F.EK_OHNE_KIND));
  return Math.min(q, F.CAP_GERINGVERDIENER);
}
/* Förderfähige-Kosten-Deckel (WE=1): 28.000 € ab Start, danach -750 € je Halbjahr ab Q1 2027.
   Reduktion nur für WE=1 in der Excel-Quelle belegt - User 17.07.2026: Excel-Basis passt. */
function foerderKostenCap(){
  const F=CONFIG.FOERDER;
  return Math.max(0, F.KOSTEN_START - F.KOSTEN_SCHRITT*foerderHalfSteps());
}

/* ============================== AMORTISATION ============================== */
/* Die Fox-Matrix hat COP nur an 4 diskreten Außentemperatur-Punkten (−15/−7/2/7 °C) - eine
   Auslegungs-Matrix, keine Saison-Kennzahl. Ein reiner Durchschnitt würde die kalten Extremwerte
   übergewichten (Deutschland hat weit mehr Heizstunden bei 2–7 °C als bei −15 °C) und die reale
   Effizienz unterschätzen. Vereinfachte Bin-Gewichtung nach VDI-4650-Logik statt nacktem Mittelwert:
   COP_saison ≈ 0,40×COP(7°C) + 0,35×COP(2°C) + 0,18×COP(−7°C) + 0,07×COP(−15°C)
   Explizit als Näherung - VALIDIEREN (Jannik): durch echte EN-14825-SCOP-Werte ersetzen, sobald vorhanden. */
const COP_BINS=[[7,0.40],[2,0.35],[-7,0.18],[-15,0.07]];
function seasonalCOP(kit){
  const col='C'+vlCol().slice(1);
  return COP_BINS.reduce((sum,[t,w])=>sum+interpAt(kit,col,t)*w,0);
}
/* Rechenpipeline:
   Alt: E_in (kWh, aus calc()) × Brennstoffpreis[A.energy]                      → €/Jahr alt
   Neu: (Q_heiz + Q_WW) / COP_saison(Kit) × Strompreis                         → €/Jahr neu
   Investition: Kit-Preis (+Speicher) − Förderbetrag (foerderQuote())
   Amortisation = Investition / max(0, €/Jahr alt − €/Jahr neu)
   Harter Edge Case: DIN-Modus (Heizlast direkt eingegeben) hat keine Altkosten-Basis -
   kein stiller Fallback auf falsche Zahlen, siehe Aufrufer (Karte wird nicht gerendert). */
/* investFoerderfaehig = zusaetzlich konfigurierte Positionen, die in die Foerderbasis zaehlen
   (Services, Material-Extras, Eigenleistungs-Material).
   investOhneFoerderung = Positionen, die der Kunde zahlt, die aber nicht foerderfaehig sind -
   aktuell die Lieferung. Sie erhoehen die Investition, nicht den Zuschuss. */
/* Foerderbetrag zu einer beliebigen Investitionssumme - gedeckelt auf die foerderfaehigen
   Hoechstkosten. Wird fuer beide Seiten des Vergleichs gebraucht: Der Handwerker-Anker
   schoepft den Deckel aus, unser guenstigeres Paket nicht. Deshalb kuerzt sich die
   Foerderung im Vergleich NICHT weg. */
function foerderBetragFuer(basis,kitKey){
  const q=foerderQuote(kitKey);
  if(!q||!basis) return 0;
  return Math.round(Math.min(basis,foerderKostenCap())*q/100);
}
function amortizationFor(cand,investExtra=0,investOhneFoerderung=0){
  const c=cand.c;
  if(!c || c.mode==='din' || cand.kit==='hybrid') return null;
  if(c.ein===undefined || !A.energy || CONFIG.ENERGY_PRICES[A.energy]===undefined) return null;
  const kostenAlt = c.ein * CONFIG.ENERGY_PRICES[A.energy]/100;
  const qGesamt = (c.qheiz||0) + (c.qww||0);
  const copS = seasonalCOP(cand.kit);
  if(!copS) return null;
  const kostenNeu = (qGesamt/copS) * CONFIG.WP_STROM/100;
  const ersparnisJahr = kostenAlt - kostenNeu;
  const quote=foerderQuote();
  const spKey=speicher(), spPreis=spKey?PRODUCTS[spKey].price:0;
  const kitPreis = PRODUCTS[cand.kit].price + spPreis + investExtra;
  const foerderBetrag = quote ? Math.round(Math.min(kitPreis,foerderKostenCap())*quote/100) : 0;
  const investitionNetto = kitPreis - foerderBetrag + investOhneFoerderung;
  return {kostenAlt,kostenNeu,ersparnisJahr,kitPreis,foerderBetrag,investitionNetto,
    jahre: ersparnisJahr>0 ? investitionNetto/ersparnisJahr : null,
    copS};
}

/* ============================== RECHENZETTEL - live Tracker mit Flash ============================== */
let lastVals = {};
function rrow(key,state,label,val,src,cls=""){
  return {key,state,val:state?val:'–',html:`<div class="rrow ${state?'':'pending'} ${cls}" data-k="${key}"><span class="rl"><b>${label}</b>${src?`<span class="src">${src}</span>`:''}</span><span class="rv m">${state?val:'–'}</span></div>`};
}
/* ===== PLAUSIBILITAET IN WATT JE QUADRATMETER (14.10.2026) =====

   Vorgabe Claras zu Wohnflaeche und Keller: "als Warnung + Vorbelegung".

   WAS DIESE PRUEFUNG KANN UND WAS NICHT: Sie aendert die Heizlast nicht - sie sagt nur, ob das
   Ergebnis zur Groesse und zum Zustand des Hauses passt. Genau dafuer taugt der Wert je
   Quadratmeter: Ein unsaniertes Haus liegt bei 60 bis 120 W/m2, ein durchsaniertes bei 25 bis
   50. Wer 18 W/m2 herausbekommt, hat sich fast immer bei Wohnflaeche oder Verbrauch vertan -
   und wuerde sonst ein zu kleines Kit bestellen, ohne dass irgendetwas darauf hinweist.

   SIE SCHWEIGT, WENN ALLES STIMMT. Ein Zettel, der nur dann etwas sagt, wenn etwas nicht
   stimmt, wird gelesen; einer, der jedes Mal ein gruenes Haekchen zeigt, nicht mehr.

   IM HEIZLASTWEG GIBT ES KEINEN SANIERUNGSSTAND (die Frage wird dort uebersprungen). Dann
   gelten nur die absoluten Grenzen - alles andere waere geraten.

   Korridore aus dem Auslegungstool (HEIZLAST_KORRIDOR). */
const HL_KORRIDOR = {
  saniert:    {min:25, gruenMax:50,  gelbMax:70,  wort:'rundum modernisiertes'},
  teilsaniert:{min:40, gruenMax:80,  gelbMax:110, wort:'teilweise modernisiertes'},
  unsaniert:  {min:60, gruenMax:120, gelbMax:160, wort:'kaum modernisiertes'}
};
const HL_ABSOLUT_MIN=25, HL_ABSOLUT_MAX=160;
/* Beheizte Flaeche = Wohnflaeche plus der beheizte Teil des Kellers. Halb beheizt zaehlt halb -
   dieselbe Naeherung wie im Auslegungstool (kellerBeheizterAnteil). */
function beheizteFlaeche(){
  const wf=Number(A.wohnflaeche)||0;
  if(!(wf>0)) return 0;
  const kf=Number(A.kellerflaeche)||0;
  return wf + (A.kellerstatus==='voll' ? kf : A.kellerstatus==='teil' ? kf*0.5 : 0);
}
function plausiHinweis(c){
  const flaeche=beheizteFlaeche();
  const hl=(c && c.phl)||0;
  if(!(flaeche>0) || !(hl>0)) return null;
  const spez=Math.round(hl*1000/flaeche);
  const k=HL_KORRIDOR[A.sanierung]||null;
  const w=`<b>${fmt(spez)} W/m²</b>`;
  if(spez<HL_ABSOLUT_MIN)
    return `${w} sind für ein bewohntes Haus sehr wenig. Bitte prüf noch einmal Wohnfläche und Jahresverbrauch - mit diesem Wert wäre das Kit zu klein.`;
  if(k && spez<k.min)
    return `${w} liegen unter dem, was ein ${k.wort} Haus üblicherweise braucht (${k.min} bis ${k.gelbMax} W/m²). Das passiert, wenn Räume kalt bleiben oder nachts stark abgesenkt wird - dann rechnet der Verbrauch die Heizlast zu klein. Im Zweifel eine Größe höher wählen oder die Heizlast berechnen lassen.`;
  if(spez>(k?k.gelbMax:HL_ABSOLUT_MAX))
    return `${w} sind viel${k?` für ein ${k.wort} Haus (üblich sind ${k.min} bis ${k.gelbMax} W/m²)`:''}. Erfasst der Zähler vielleicht noch eine zweite Wohnung, oder ist die Wohnfläche zu klein angegeben? Sonst wird das Kit größer als nötig.`;
  if(k && spez>k.gruenMax)
    return `${w} liegen im oberen Bereich für ein ${k.wort} Haus (üblich sind ${k.min} bis ${k.gelbMax} W/m²). Das kann stimmen - prüf aber kurz, ob der Zustand des Hauses richtig eingeschätzt ist.`;
  return null;
}
function renderLedger(){
  const c=calc(); const rows=[];
  /* Der Hinweis haengt am Rechenzettel und nicht am Ergebnis: Er soll schon waehrend des
     Ausfuellens erscheinen, solange sich die Eingabe leicht berichtigen laesst. */
  const warnEl=document.getElementById('rWarn');
  if(warnEl){
    const h=plausiHinweis(c);
    if(h){ warnEl.innerHTML=h; warnEl.hidden=false; } else { warnEl.innerHTML=''; warnEl.hidden=true; }
  }
  if(c.mode==='din'){
    rows.push(rrow('din',true,"Heizlast (DIN EN 12831)",fmt(A.heizlastDirect,1)+" kW","direkt · kein Aufschlag"));
    rows.push(rrow('pww',c.pww!==undefined,"+ Warmwasser-Spitze",c.pww!==undefined?fmt(c.pww,1)+" kW":"",A.dhw==='ja'?(A.persons?`${A.persons} Pers.`:""):(A.dhw==='nein'?"entfällt":"")));
  } else {
    /* Die Herkunftszeile nennt seit dem 14.10.2026 den MITTELWERT, nicht mehr das erste Jahr -
       sonst stuende dort eine Zahl, mit der die Zeile daneben nicht zu erklaeren ist. */
    const einQuelle = c.hw ? ((c.jahre>1?`Mittel aus ${c.jahre} Jahren · `:'')
      + (c.hw.f!==1?`${fmt(Math.round(c.vmittel))} ${c.hw.unit} × ${fmt(c.hw.f,1)} · ${c.hw.src}`:c.hw.src)) : "";
    rows.push(rrow('ein',c.ein!==undefined,"Jahresverbrauch",c.ein!==undefined?fmt(c.ein)+" kWh":"",einQuelle));
    rows.push(rrow('eta',!!c.eta&&c.ein!==undefined,(A.energy==='wp'?"× Arbeitszahl":"× Nutzungsgrad"),c.eta?fmt(c.eta.v,2).replace('.',','):"",c.eta?c.eta.label+" · DIN V 18599-5":""));
    rows.push(rrow('holz',c.qholz!==undefined,"+ Kaminholz",c.qholz!==undefined?fmt(Math.round(c.qholz))+" kWh":"",
      c.eholz!==undefined?`${fmt(A.holzRm,1).replace('.',',')} rm × ${fmt(HEIZWERT.holz_rm.f)} kWh × 0,85`:""));
    rows.push(rrow('qnutz',c.qnutz!==undefined,"= Nutzwärme",c.qnutz!==undefined?fmt(Math.round(c.qnutz))+" kWh":""));
    /* DIE BEIDEN WARMWASSER-ZEILEN SAGEN SEIT DEM 14.10.2026, WARUM SIE LEER SIND.

       Im Verbrauchsweg entscheidet eine einzige Antwort ueber beide (Vorgabe Claras, siehe
       renderWwVerbrauch): "Nein, Durchlauferhitzer oder Boiler" heisst, dass nichts abgezogen
       wird UND dass die Waermepumpe das Warmwasser nicht uebernimmt. Ohne Begruendung stuende
       im Zettel zweimal "entfaellt" - und der Kunde muesste raten, ob er etwas falsch
       angegeben hat oder ob das so gemeint ist. */
    /* ZWEI VERSCHIEDENE GRUENDE FUER ZWEI LEERE ZEILEN, seit die Fragen wieder getrennt sind:
       Der Abzug entfaellt, wenn das Warmwasser nie im Zaehlerstand steckte; die Spitze
       entfaellt, wenn die Waermepumpe es kuenftig nicht macht. Beides kann einzeln eintreten -
       ein gemeinsames Merkmal waere hier wieder genau die Verwechslung, die Clara gemeldet
       hat. */
    const wwNichtDrin = A.wwImVerbrauch==='nein';
    const wwNurHeizen = A.dhw==='nein';
    rows.push(rrow('qww',c.qww!==undefined,"− Warmwasser",
      c.qww!==undefined?((c.wwAbzug>0)?fmt(c.wwAbzug)+" kWh":"entfällt"):"",
      wwNichtDrin?"nicht im Verbrauch enthalten":(A.dhw==='ja'?(A.persons?`DIN 4708 · ${A.persons} Pers.`:"DIN 4708"):"")));
    rows.push(rrow('qheiz',c.qheiz!==undefined,"= Heizenergie",c.qheiz!==undefined?fmt(Math.round(c.qheiz))+" kWh":""));
    rows.push(rrow('bvh',!!c.bvh,"÷ Volllaststunden",c.bvh?fmt(c.bvh)+" h":"",c.klima&&c.san?`DWD TRY 2017 · ${c.klima.ort}`:"PLZ + Zustand"));
    rows.push(rrow('phl',c.phl!==undefined,"= Heizlast",c.phl!==undefined?fmt(c.phl,2).replace('.',',')+" kW":""));
    rows.push(rrow('res',c.r!==undefined&&c.phl!==undefined,`+ Reserve ${c.san?Math.round(c.san.r*100)+" %":""}`,c.r!==undefined&&c.phl!==undefined?fmt(Math.round(c.phl*c.r*10)/10,1)+" kW":"",c.san?`VDI 4645 · ${c.san.label}`:""));
    rows.push(rrow('pww',c.pww!==undefined,"+ Warmwasser-Spitze",
      c.pww!==undefined?(c.pww>0?fmt(c.pww,1)+" kW":"entfällt"):"",
      wwNurHeizen?"Wärmepumpe heizt nur":(A.dhw==='ja'&&A.persons?`${A.persons} Pers. · ${fmt(CONFIG.RULES.DHW_KW_PER_PERSON,1).replace('.',',')} kW je Person`:"")));
  }
  const totalRow=rrow('pausl',!!c.pausl,"Auslegungsheizlast",c.pausl?fmt(c.pausl,1)+" kW":"","","total");
  /* Symmetrie zur Frage-Karte: der Rechenzettel zeigt nicht sofort alle Zeilen als Skelett,
     sondern wächst mit dem Funnel-Fortschritt (+ immer 1 Vorschau-Zeile über den letzten
     beantworteten Punkt hinaus), bis er am Ende komplett ist. */
  const act=activeSteps();
  const curIdx=Math.max(0,act.findIndex(s=>s===STEPS[Math.min(stepIndex,STEPS.length-1)]));
  const frac=stepIndex>=STEPS.length?1:curIdx/Math.max(1,act.length);
  const answeredCount=rows.filter(r=>r.state).length;
  const revealN=finished?rows.length:Math.min(rows.length,Math.max(answeredCount+1,Math.ceil(frac*rows.length)));
  const visibleRows=rows.slice(0,revealN);
  const R=document.getElementById('rRows');
  const prevKeys=new Set([...R.querySelectorAll('.rrow')].map(e=>e.dataset.k));
  R.innerHTML=visibleRows.map(r=>r.html).join("")+totalRow.html;
  /* Flash für Zeilen, die gerade real wurden oder sich geändert haben (Endowment sichtbar);
     Enter-Animation für Zeilen, die gerade neu sichtbar werden (Rechenzettel wächst) */
  [...visibleRows,totalRow].forEach(r=>{
    const el=R.querySelector(`[data-k="${r.key}"]`);
    if(el && !prevKeys.has(r.key)) el.classList.add('enter');
    if(r.state && lastVals[r.key]!==r.val){
      if(el) el.classList.add('flash');
    }
    lastVals[r.key]=r.state?r.val:undefined;
  });
  const top=document.getElementById('rTotalTop'), nv=c.pausl?fmt(c.pausl,1)+" kW":"– kW";
  if(top.textContent!==nv){ top.textContent=nv; top.classList.remove('bump'); void top.offsetWidth; top.classList.add('bump'); }
  syncResume();
}
function openLedger(){
  const rc=document.getElementById('receipt');
  /* Doppelmeldung vermeiden: der toggle-Horcher unten wuerde sonst zusaetzlich feuern. */
  if(typeof ledgerStumm==='function') ledgerStumm();
  rc.open=true;
  rc.scrollIntoView({behavior:'smooth',block:'nearest'});
  track("ledger_open",{step:stepIndex,via:'link'});
}

/* ============================== WIZARD ============================== */
const app=document.getElementById('app');
function esc(s){return String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]))}
/* Hinweis (Messung 30.07.2026): hier steht ein geschuetztes Leerzeichen (U+00A0) zwischen
   Betrag und Waehrung. Darauf ist im Layout aber KEIN Verlass - der ausgelieferte Asset wird
   minifiziert, und im Browser kommt an dieser Stelle ein normales Leerzeichen (Code 32) an.
   Umbruchschutz fuer Preise gehoert deshalb ins CSS, nicht in dieses Zeichen. */
function eur(n){return fmt(n)+" €"}
/* ---------------------------------------------------------------------
   Gefuehrter Modus + Aufstellort (User-Entscheid 29.07.2026).
   Wer sich fuehren laesst, bekommt die technisch notwendigen Positionen vorausgewaehlt,
   statt sie aus einer Liste zusammensuchen zu muessen. Wer Bescheid weiss, konfiguriert
   selbst - die Positionen bleiben dieselben, nur ohne Vorauswahl.
   --------------------------------------------------------------------- */
/* renderGefuehrt() ist mit seiner Frage entfallen - siehe den Vermerk bei STEPS. */

/* Aufstellort: entscheidet ueber die Hauseinfuehrung. Nah an der Wand geht oberirdisch,
   weiter weg muss die Leitung in den Boden. "Weiss ich noch nicht" ist ausdruecklich
   erlaubt - die Entscheidung laesst sich nach dem Kauf nachreichen. */
/* Nur bei der Spanne 1980-1994 sichtbar: sie liegt teils vor, teils nach 1990, und davon
   haengt ab, ob die Systemtrennung eingeplant wird. */
function renderFbhAlter(el){
  optGrid(el,[
    ["ja","Vor 1990 verlegt","Rohre aus der Zeit sind oft nicht diffusionsdicht – dann brauchst du eine Systemtrennung"],
    ["nein","1990 oder später","dann brauchst du keine Systemtrennung"],
    ["unklar","Weiß ich nicht","Dann planen wir sie erst mal nicht ein - im Checkout kannst du sie dazunehmen"]
  ],v=>{A.fbhVor1990=v; track("fbh_alter",{wert:v}); setTimeout(next,200);},'',A.fbhVor1990);
}
function renderAufstellort(el){
  optGrid(el,[
    ["nah","Direkt an der Hauswand","bis etwa 2 m - oberirdische Durchführung möglich"],
    ["weit","Weiter weg im Garten","ab etwa 2 m - die Leitung muss unterirdisch geführt werden"],
    ["unklar","Weiß ich noch nicht","Kannst du uns auch nach dem Kauf sagen"]
  ],v=>{
    A.aufstellort=v;
    /* Wer ueber "Antworten aendern" auf "direkt an der Hauswand" wechselt, sieht die
       Erdleitung nicht mehr - bezahlt die bereits gewaehlten Meter aber weiter, weil
       extrasSumme() und der Checkout nicht nach Aufstellort filtern. Stiller Fehler,
       gefunden am 18.08.2026. Hier ausdruecklich abraeumen. */
    if(v==='nah' && chosenExtras.erdleitung) delete chosenExtras.erdleitung;
    track("aufstellort_select",{ort:v});
    setTimeout(next,200);
  },'',A.aufstellort);
}

/* Welche Hauseinfuehrung folgt aus dem Aufstellort? null = noch nicht entscheidbar. */
function hauseinfuehrungAus(ort){
  if(ort==='nah')  return 'haus_ober';
  if(ort==='weit') return 'haus_unter';
  return null;
}

/* ENTWEDER/ODER DER PUMPENGRUPPEN GILT NICHT MEHR BEI ZWEI HEIZKREISEN
   (Betreiber-Entscheid 18.08.2026: "Pumpengruppe muss bei zwei Heizkreisen beide
   ausgewaehlt werden koennen").

   Bei genau einem Heizkreis bleibt die Sperre: dort ist die Wahl zwischen gemischt und
   ungemischt ein Entweder/Oder, und zwei angehakte Gruppen waeren schlicht ein Fehler.
   Bei 'mix' sind es zwei getrennt geregelte Kreise - dann darf der Kunde beide waehlen.

   BEWUSST NUR DIE SPERRE, NICHT DIE VORAUSWAHL: die Stueckliste der Inneneinheit fuehrt
   in HYDROBOX bereits eine "Sekundaere Umwaelzpumpe fuer Heizkreis 1 mit Heizkoerpern"
   und laesst nur eine "freie Verbindung fuer Pumpengruppe FBH" offen. Eine zweite,
   ungemischte Gruppe waere danach eine Pumpe in Reihe zur eingebauten. Deshalb bleibt
   vorausgewaehlt weiterhin nur die gemischte; waehlbar ist ab jetzt beides. */
/* Seit dem 02.09.2026 tragen die Pumpengruppen kein xgroup mehr, damit beide gleichzeitig
   waehlbar sind. Diese beiden Funktionen bleiben BEWUSST stehen: xgroupSperrt() bedient
   weiterhin die Gruppen 'haus' und 'oel', und der Pumpen-Zweig kostet nichts. Wer das
   Entweder/Oder je zurueckholen will, setzt xgroup:'pumpe' wieder in EXTRAS - hier ist
   dann nichts nachzuziehen. */
/* DIE SPERRE FAELLT BEI "1x FUSSBODENHEIZUNG + 1x HEIZKOERPER" (Vorgabe Claras 25.09.2026:
   "wenn man bei Heizkreise 1x Fussbodenheizung und 1x Heizkoerper auswaehlt, kommt bisher nur
   die gemischte Pumpe, da brauchen wir aber auch die ungemischte Pumpengruppe").

   Sie war seit heute frueh immer aktiv - damals hiess es, auch dieser Fall brauche nur die
   gemischte. Zwei getrennt geregelte Kreise brauchen aber zwei Pumpen, eine je Kreis; das
   Entweder/Oder haette die zweite jedes Mal wieder abgeraeumt, auch die von Hand gesetzte.

   IN ALLEN ANDEREN FAELLEN BLEIBT SIE: Bei einem einzelnen Kreis ist genau eine Bauart richtig,
   und zwei nebeneinander waeren ein Fehlkauf, der erst auf der Rechnung auffaellt. */
function pumpenSperreAktiv(){ return !(A.heating==='mix' && A.kreise==='gem_ungem'); }
/* true = fuer diesen Schluessel gilt das Entweder/Oder gerade. */
function xgroupSperrt(xg){ return !!xg && (xg!=='pumpe' || pumpenSperreAktiv()); }

/* WAS EINANDER AUSSCHLIESST, UEBER DIE xgroup HINAUS (Vorgabe 21.09.2026).

   Die xgroup 'haus' macht schon ein Entweder/Oder aus den beiden Wanddurchfuehrungen: Wer
   die oberirdische anhakt, verliert die unterirdische. Der ANSCHLUSS UI gehoert aber auch
   zur unterirdischen Fuehrung und blieb bisher stehen - man hatte dann eine oberirdische
   Durchfuehrung und den Anschluss fuer die unterirdische im Warenkorb.

   Er traegt bewusst KEINE xgroup 'haus': Mit haus_unter zusammen ist er richtig, die beiden
   gehoeren zueinander. Ein Entweder/Oder wuerde ihn ausgerechnet dann werfen, wenn er passt.
   Deshalb diese eigene Tabelle - sie sagt nicht "eins von diesen", sondern "dieses schliesst
   jenes aus".

   NUR IN EINE RICHTUNG, wie vorgegeben: haus_ober raeumt anschluss_ui weg. Umgekehrt bleibt
   haus_ober stehen, wenn jemand den Anschluss anhakt. Wer das auch will, traegt hier
   anschluss_ui:['haus_ober'] nach. */
/* systr -> pump_gem (25.09.2026): Das Trennsystem enthaelt die gemischte Pumpengruppe bereits
   als erste Position seiner Stueckliste. Ohne diesen Eintrag bliebe ein frueher gesetzter Haken
   an der einzelnen Gruppe stehen - unsichtbar, weil only() die Zeile ausblendet, und trotzdem
   mit 590 Euro in der Summe. */
const SCHLIESST_AUS = { haus_ober: ['anschluss_ui'], systr: ['pump_gem'] };
/* weg(key) hakt den Haken im DOM ab - nur dort noetig, wo die Liste schon steht. */
function raeumeAusgeschlossene(key, weg){
  (SCHLIESST_AUS[key]||[]).forEach(o=>{
    if(chosenExtras[o]){ delete chosenExtras[o]; if(weg) weg(o); }
  });
}

/* Pumpengruppen-Bedarf, abgeleitet AUS DER HEIZFLAECHEN-FRAGE. Der User hat am 29.07.2026
   ausdruecklich bestaetigt, dass diese eine Frage die Heizkreise vollstaendig beschreibt:
     "Heizkoerper"        = 1 ungemischter Kreis  -> keine zusaetzliche Pumpengruppe
     "Fussbodenheizung"   = 1 gemischter Kreis    -> 1 gemischte Pumpengruppe
     "Beides"             = 1 ungemischt + 1 gemischt -> 1 gemischte Pumpengruppe
   Der zweite Parameter deckt den Sonderfall zweier ungemischter Kreise ab (dann braucht es
   eine ungemischte Pumpengruppe). Er wird vom Funnel nicht befuellt, weil die Anzahl der
   Kreise bewusst nicht abgefragt wird - die Regel bleibt trotzdem hinterlegt, falls ein
   Vertriebsfall sie einmal ueber einen anderen Weg setzt. */
function pumpengruppeFuer(heizflaechen, anzahlUngemischt){
  /* anzahlUngemischt stammt aus dem Rechner und bleibt der Sonderfall zweier ungemischter
     Kreise; im Kaufweg sagt das dieselbe Sache die Nachfrage (A.kreise==='2ungem'). */
  if(heizflaechen==='fbh') return 'pump_gem';
  if(heizflaechen==='mix'){
    if(A.kreise==='2ungem') return 'pump_ungem';
    return 'pump_gem';
  }
  if(heizflaechen==='hk') return (anzahlUngemischt>=2) ? 'pump_ungem' : null;
  return null;
}

/* Alles, was der gefuehrte Modus vorauswaehlt, an einer Stelle - mit dem Grund, der dem
   Kunden angezeigt wird. Reine Beschreibung, kein Nebeneffekt: das Anwenden passiert in
   wendeVorauswahlAn(), damit die Regeln getestet werden koennen, ohne DOM zu brauchen. */
/* BRAUCHT ES EINE SYSTEMTRENNUNG? Eine Regel, eine Stelle (16.09.2026 herausgezogen).

   Zwei Bedingungen zusammen: eine Fussbodenheizung im Haus UND Rohre von vor 1990. Alte
   Fussbodenheizungen sind oft nicht diffusionsdicht; die Trennung haelt den Kreis der
   Waermepumpe vom Sauerstoff frei. Ohne Fussbodenheizung braucht es sie nicht, und bei
   neuen Rohren auch nicht.

   Die Spanne 1980-1994 liegt genau auf der Grenze - dafuer fragt der Rechner gezielt nach
   (Schritt "fbhalter").

   "WEISS ICH NICHT" PLANT SIE SEIT DEM 25.09.2026 NICHT MEHR EIN (Vorgabe Claras: "wenn jemand
   weiss ich nicht auswaehlt, ist die Standardauswahl der gemischte Kreis mit Systemtrennung
   NICHT ausgewaehlt"). Bis dahin zaehlte die Antwort wie "vor 1990" - lieber eingeplant als
   fehlend. Der Preis dafuer war ein Posten von einigen hundert Euro, den niemand angefordert
   hatte und der nur auffiel, wenn man die Liste Zeile fuer Zeile durchging. Wer es nicht weiss,
   bekommt jetzt die gemischte Pumpengruppe ohne Trennung; dazunehmen laesst sie sich mit einem
   Haken.

   A.systemtrennung ist die ausdrueckliche Uebersteuerung und sticht die Rechnung.

   Sie stand bis heute nur in vorauswahlPlan() und griff damit ausschliesslich im gefuehrten
   Modus. Jetzt lesen auch die beiden Kaufwege sie - wer den Rechner ausgefuellt hat, findet
   den Haken gesetzt oder eben nicht, unabhaengig davon, ob er sich fuehren liess. */
function systemtrennungNoetig(){
  if(A.systemtrennung==='ja') return true;
  /* Ein gemischter Kreis IST die Fussbodenheizung. Bei "zwei oder mehr" sagt erst die
     Nachfrage, ob einer dabei ist - "2x ungemischt" sind zwei Heizkoerperkreise, und dort gibt
     es keine diffusionsoffenen Rohre im Estrich. Solange die Nachfrage offen ist, wird zu
     Gunsten der Trennung entschieden: lieber eingeplant und abwaehlbar als fehlend. */
  var fussboden = (A.heating==='fbh');
  if(A.heating==='mix' && A.kreise!=='2ungem') fussboden = true;
  if(!fussboden) return false;
  /* DIE ANTWORT AUS DEM KAUFWEG SCHLAEGT DIE HERLEITUNG AUS DEM RECHNER (23.09.2026): Sie
     ist die Angabe zur Fussbodenheizung selbst, waehrend A.baujahr das Alter des HAUSES
     meint - in ein Haus von 1960 kann eine Fussbodenheizung von 2015 eingebaut worden sein.
     Wer sie ausdruecklich beantwortet hat, soll nicht vom Baujahr des Hauses ueberstimmt
     werden. Nur "Vor 1990" plant die Trennung ein - "Weiss ich nicht" nicht mehr, siehe den
     Kommentar ueber dieser Funktion. */
  if(A.fbhBaujahr) return A.fbhBaujahr==='vor1990';
  /* DIE ANTWORT AUS DEM FUNNEL KOMMT VOR JEDER HERLEITUNG (14.10.2026). Sie ist die Angabe zur
     Fussbodenheizung selbst; das Baujahr des Hauses ist nur ein Indiz dafuer. Im Heizlastweg
     gibt es ueberhaupt kein Baujahr mehr, dort ist sie die einzige Quelle - siehe die
     wegabhaengige skip-Bedingung am Schritt "fbhalter". "Weiss ich nicht" plant die Trennung
     seit dem 25.09.2026 NICHT ein, deshalb der Vergleich auf 'ja' und nicht auf !=='nein'. */
  if(A.fbhVor1990) return A.fbhVor1990==='ja';
  /* Seit dem 14.10.2026 steht hier eine genaue Jahreszahl statt einer Spanne. Die Grenzen sind
     dieselben geblieben: vor 1980 gilt die Fussbodenheizung als alt, ab 1995 als dicht, und
     dazwischen fragt der Funnel nach - nur dass "dazwischen" jetzt 1980 bis 1994 heisst und
     nicht mehr y1980_1994. */
  const bjHaus=Number(A.baujahrHaus)||0;
  if(bjHaus) return bjHaus<1980;
  return A.baujahr==='vor1980'
    || (A.baujahr==='y1980_1994' && A.fbhVor1990==='ja');
}
function vorauswahlPlan(){
  const plan=[];
  const pg=pumpengruppeFuer(A.heating, A.kreiseUngemischt);
  /* Die gemischte Gruppe faellt aus dem Plan, wenn das Trennsystem kommt - es enthaelt sie
     bereits (siehe only() an pump_gem). Sonst stuende ihr Begruendungstext an einer Zeile, die
     gar nicht mehr erscheint. */
  const pgEntfaellt = (pg==='pump_gem' && systemtrennungNoetig());
  if(pg && !pgEntfaellt){
    plan.push({key:pg, grund: pg==='pump_gem'
      ? 'Deine Fußbodenheizung braucht eine eigene, geregelte Vorlauftemperatur - dafür sorgt die gemischte Pumpengruppe.'
      : 'Zwei Heizkörperkreise: einen versorgt die Pumpe in der Hydrobox, für den zweiten kommt eine ungemischte Pumpengruppe dazu.'});
  }
  /* Systemtrennung: drei Bedingungen zusammen (User-Regel 29.07.2026) - eine Fussbodenheizung,
     Baujahr vor 1990 und eine gemischte Pumpengruppe. Alte Fussbodenheizungen sind oft nicht
     diffusionsdicht; die Trennung schuetzt den Kreis der Waermepumpe vor Sauerstoffeintrag.
     A.systemtrennung bleibt als manuelle Uebersteuerung erhalten.
     Die Spanne "1980 - 1994" liegt genau auf der Grenze - dafuer fragt der Funnel seit dem
     29.07.2026 gezielt nach (Schritt "fbhalter"), statt zu schaetzen. "Weiß ich nicht" plant
     sie seit dem 25.09.2026 NICHT mehr ein (Vorgabe) - die Regel steht in
     systemtrennungNoetig(), hier wird sie nur gelesen. */
  if(pg==='pump_gem' && systemtrennungNoetig()){
    plan.push({key:'systr', grund:'Deine Fußbodenheizung stammt aus der Zeit vor 1990 - solche Rohre sind oft nicht diffusionsdicht. Die Systemtrennung hält den Kreis der Wärmepumpe davon frei. Die gemischte Pumpengruppe steckt darin schon drin - du brauchst sie nicht zusätzlich.'});
  }
  /* peri_basic und fundament sind am 14.09.2026 aus EXTRAS entfallen - zu beiden gibt es
     kein Zubehoer-Paket. Ihre Vorauswahl-Eintraege stehen deshalb nicht mehr hier: Die
     Anwendung unten ueberspringt unbekannte Schluessel zwar folgenlos, aber ein Plan, der
     Gruende fuer nicht existierende Positionen vorbereitet, fuehrt beim Lesen in die Irre.
     FOLGE, die bewusst so ist: Wer im Rechner sagt, wir sollen das Fundament liefern,
     bekommt jetzt nichts vorausgewaehlt - es gibt kein Fundament-Produkt mehr. Das
     Fundament zaehlt damit immer als Eigenleistung (siehe eigenleistungSumme). */
  const he=hauseinfuehrungAus(A.aufstellort);
  if(he){
    plan.push({key:he, grund: he==='haus_ober'
      ? 'Die Außeneinheit steht direkt an der Wand - dann reicht die oberirdische Durchführung.'
      : 'Bei einem Aufstellort weiter weg vom Haus muss die Leitung unterirdisch geführt werden.'});
  }
  return plan;
}

/* Wendet den Plan auf chosenExtras an und merkt sich die Begruendungen fuer die Anzeige.
   Nur im gefuehrten Modus - wer "Ich weiß Bescheid" gewaehlt hat, bekommt nichts gesetzt. */
let vorauswahlGruende={};
/* Was WIR gesetzt haben - noetig, um es bei geaenderten Antworten wieder zuruecknehmen zu
   koennen, ohne dem Kunden seine eigenen Haken wegzuraeumen. Das Fundament steht bewusst
   NICHT darin: dessen Haken gehoert der Funnel-Frage, nicht der Vorauswahl. */
let vorauswahlGesetzt=[];
function wendeVorauswahlAn(){
  /* Erst die eigene alte Vorauswahl abraeumen. Ohne das bleiben Positionen stehen, die zu
     einer frueheren Antwort gehoerten - wer von Fussbodenheizung auf Heizkoerper wechselt,
     haette sonst weiter die gemischte Pumpengruppe im Warenkorb. */
  vorauswahlGesetzt.forEach(k=>{ delete chosenExtras[k]; });
  vorauswahlGesetzt=[];
  vorauswahlGruende={};
  if(A.gefuehrt!=='ja') return [];
  const plan=vorauswahlPlan();
  plan.forEach(p=>{
    const e=EXTRAS[p.key]; if(!e) return;
    /* xgroup = Radio-Verhalten: erst die Geschwister raeumen, sonst haengen zwei drin. */
    if(xgroupSperrt(e.xgroup)) Object.keys(EXTRAS).forEach(o=>{
      if(o!==p.key && EXTRAS[o].xgroup===e.xgroup) delete chosenExtras[o];
    });
    raeumeAusgeschlossene(p.key);
    chosenExtras[p.key]=1;
    vorauswahlGruende[p.key]=p.grund;
    if(p.key!=='fundament') vorauswahlGesetzt.push(p.key);
  });
  if(plan.length) track('vorauswahl_gesetzt',{keys:plan.map(p=>p.key)});
  return plan;
}

/* ===== DIE ABSCHNITTE DER FORTSCHRITTSLEISTE (14.10.2026) =====

   Vorgabe Claras: "vor allem die Fortschrittsleiste oben mit den Themen, zu denen die Fragen
   gerade sind, auch uebernehmen - das ist ja unterschiedlich zu schon Heizlast kennen und
   nicht kennen."

   DER ERSTE ABSCHNITT HEISST IN BEIDEN WEGEN ANDERS, weil er anderes enthaelt: Wer seine
   Heizlast kennt, traegt sie ein und ist mit dem Haus durch; wer sie nicht kennt, beschreibt
   es erst. Trotzdem ist es EIN Abschnitt mit zwei Beschriftungen und nicht zwei - sonst
   stuenden in den beiden Wegen an derselben Stelle unterschiedlich viele Punkte, und die
   Leiste wuerde beim Wechsel der Antwort springen.

   "Dein Verbrauch" GIBT ES NUR IM ZWEITEN WEG. Die Leiste zeigt ohnehin nur Abschnitte, in
   denen nach dem aktuellen Antwortstand wenigstens eine Frage uebrig ist - das rechnet
   phasenStand() aus denselben skip-Funktionen aus, aus denen auch activeSteps() kommt. Eine
   zweite Liste, welche Phase wann gilt, waere die sicherste Art, beide auseinanderlaufen zu
   lassen. */
const PHASEN=[
  {id:'start',       label:()=>A.hlgate==='ja'?'Deine Heizlast':'Dein Haus'},
  {id:'verbrauch',   label:()=>'Dein Verbrauch'},
  {id:'heizung',     label:()=>'Deine Heizung'},
  {id:'foerderung',  label:()=>'Förderung'},
  {id:'aufstellung', label:()=>'Aufstellung'}
];

/* DIE REIHENFOLGE FOLGT DEM AUSLEGUNGSTOOL (14.10.2026, Vorgabe Claras: "die Struktur und
   Reihenfolge der Fragen an der neuen Datei orientieren").

   WAS SICH DAMIT GEDREHT HAT:
     - "Kennst du deine Heizlast?" steht jetzt GANZ VORN statt an vierter Stelle. Sie muss das:
       Sie entscheidet, welche Abschnitte es ueberhaupt gibt, und die Leiste kann erst danach
       stehen.
     - Die Postleitzahl ist von hinten nach vorn gewandert. Ihr Knopf hiess deshalb bis heute
       "Rechnung abschliessen" - das steht jetzt in renderPlz auf "Weiter".
     - Die Personenzahl wird unabhaengig vom Warmwasser gefragt (Vorgabe Claras: "ganz vorn,
       wie in der neuen Datei"). renderWw raeumt sie deshalb nicht mehr ab.
     - "Wie willst du vorgehen?" ist entfallen (Vorgabe). renderInstallMode bleibt stehen und
       wird von nirgends mehr aufgerufen: A.installMode haengt an elf Stellen im Kaufweg und
       im Lead, der Renderer ist der einzige benannte Zugang dazu, falls die Frage je
       zurueckkommt. */
const STEPS=[
 /* SIE GEHOERT IN DEN ERSTEN ABSCHNITT (14.10.2026, Vorgabe Claras: "bei der ersten Frage ist
    irgendwie die Fortschrittsleiste oben nicht da, mach die trotzdem schonmal hin").

    VORHER STAND SIE OHNE PHASE, und die Leiste blieb bei ihr leer. Der Gedanke war: Solange
    die Weiche offen ist, steht nicht fest, ob es vier oder fuenf Abschnitte gibt - eine
    Leiste, die sich beim ersten Klick umbaut, waere schlechter als gar keine. In der Praxis
    ist der leere Streifen aber schlechter: Die erste Frage ist die, bei der man wissen will,
    wie lang der Weg wird.

    GEZEIGT WIRD DER LAENGERE WEG, und zwar ohne Zutun: Mit unbeantworteter Weiche greifen
    genau die skip-Regeln des Verbrauchswegs, activeSteps() liefert also dessen Schritte. Wer
    "Heizlast bekannt" waehlt, sieht "Dein Verbrauch" im selben Augenblick verschwinden und den
    ersten Abschnitt in "Deine Heizlast" umbenannt. Das ist die Antwort auf seine Wahl und
    keine Unruhe. */
 {id:"hlgate",phase:"start",q:"Kennst du deine Heizlast?",sub:"Beide Wege führen zum passenden Kit - mit einer vorhandenen Berechnung bist du nur schneller durch.",render:renderHlgate},

 /* ---------- Abschnitt 1: Deine Heizlast / Dein Haus ---------- */
 {id:"hldirect",phase:"start",q:"Deine Heizlast in kW?",sub:"DIN-Wert = kein Sicherheitsaufschlag nötig.",render:renderHldirect,skip:()=>A.hlgate!=='ja'},
 {id:"plz",phase:"start",q:"Deine Postleitzahl?",sub:"Sie bestimmt, wie kalt es bei dir am Auslegungstag wird - und damit, wie viel Leistung dein Kit braucht.",render:renderPlz},
 {id:"personen",phase:"start",q:"Wie viele Personen leben im Haushalt?",render:renderPersonen},
 {id:"wohnflaeche",phase:"start",q:"Wie groß ist die beheizte Wohnfläche?",sub:"Ohne Garage und unbeheizten Dachboden. Wir prüfen damit, ob das Ergebnis zur Größe deines Hauses passt.",render:renderWohnflaeche},
 {id:"baujahrHaus",phase:"start",q:"Baujahr des Hauses?",sub:"Als Jahreszahl - ungefähr reicht. Davon hängt unter anderem ab, ob wir eine Systemtrennung einplanen.",render:renderBaujahrHaus,skip:()=>A.hlgate==='ja'},
 {id:"sanierung",phase:"start",q:"Zustand vom Haus?",render:renderSanierung,skip:()=>A.hlgate==='ja'},
 {id:"keller",phase:"start",q:"Hast du einen Keller?",render:renderKeller,skip:()=>A.hlgate==='ja'},
 {id:"kellerflaeche",phase:"start",q:"Wie groß ist der beheizte Teil des Kellers?",render:renderKellerflaeche,
   skip:()=>A.hlgate==='ja'||!(A.kellerstatus==='teil'||A.kellerstatus==='voll')},

 /* ---------- Abschnitt 2: Dein Verbrauch (Weg 2) bzw. Teil von "Deine Heizung" (Weg 1) ----------
    DIESE DREI FRAGEN STEHEN IN BEIDEN WEGEN, aber unter verschiedener Ueberschrift: Im
    Verbrauchsweg sind sie die Grundlage der Rechnung, im Heizlastweg nur noch Angaben zur
    Bestandsheizung - gebraucht fuer den Kostenvergleich und die Hybrid-Empfehlung. Deshalb
    ist phase hier eine Funktion und kein fester Name. */
 {id:"energy",phase:()=>A.hlgate==='ja'?'heizung':'verbrauch',q:"Womit heizt du?",render:renderEnergy},
 {id:"heizartDetail",phase:()=>A.hlgate==='ja'?'heizung':'verbrauch',q:"Welche Bauart genau?",sub:"Davon hängt ab, wie viel von der eingekauften Energie überhaupt als Wärme ankommt.",render:renderHeizartDetail,
   skip:()=>!HEIZART_DETAIL[A.energy]},
 /* DIE FRAGE NACH DEM BAUJAHR DER HEIZUNG IST AM 16.10.2026 AUS DEM FRAGEBOGEN GENOMMEN
    (Vorgabe Claras: "entferne die Frage Baujahr der Heizung aus dem Rechner").

    WAS DAMIT AUSFAELLT - nachgesehen, nicht vermutet, denn an A.baujahr hingen vier Stellen:

      1. DER NUTZUNGSGRAD DER ALTEN HEIZUNG (etaFor -> ETA_DETAIL). Ohne Angabe greift der
         vorhandene Rueckfall auf die Spanne 1995-2016, also einen mittleren Kessel. Das ist
         die eine echte Folge: Wer eine sehr alte oder eine sehr junge Heizung hat, bekommt
         jetzt denselben Nutzungsgrad angesetzt wie der Durchschnitt. Bei Gas und Oel fragt
         der Fragebogen die genaue Heizart aber weiterhin ab (heizartDetail), und die traegt
         den groesseren Teil des Unterschieds.
      2. DIE HYBRID-REGEL (hybridFits: Gas UND Baujahr ab 2016). Sie kann damit nie mehr
         zutreffen. Das aendert heute nichts: hybrid_sichtbar steht auf dem Vorgabewert "aus",
         das Hybrid-Kit erscheint nirgends. WER ES WIEDER EINSCHALTET, MUSS DIESE FRAGE
         ZURUECKHOLEN - sonst ist das Kit sichtbar und wird nie empfohlen.
      3. DIE SYSTEMTRENNUNG. Unberuehrt: systemtrennungNoetig() fragt zuerst A.fbhVor1990 und
         dann das Baujahr des HAUSES, beides steht weiter im Fragebogen. A.baujahr war dort
         nur der letzte Rueckfall.
      4. DER LEAD AN VAMO (VAMO_BAUJAHR). Das Feld bleibt leer statt falsch - es ist dort
         optional.

    renderBaujahr() und baujahrSpanne() BLEIBEN STEHEN: In der Kaufbox fragt
    fbhBaujahrChipsHtml() weiterhin nach dem Alter der Fussbodenheizung, und wer die
    Heizungsfrage zurueckholen will, braucht beide unveraendert. Entfernt ist die Zeile, die
    sie in den Fragebogen haengt - mehr nicht. */
 {id:"verbrauch",phase:"verbrauch",q:"Dein Jahresverbrauch?",sub:"Steht auf der Jahresabrechnung. Zwei oder drei Jahre machen es genauer - ein einzelner Winter ist mal mild, mal hart.",render:renderVerbrauch,skip:()=>A.hlgate==='ja'},
 {id:"wwverbrauch",phase:"verbrauch",q:"Steckt dein Warmwasser in diesem Verbrauch?",sub:"Gemeint ist deine jetzige Heizung - wir ziehen das Warmwasser sonst von einer Zahl ab, in der es nie enthalten war.",render:renderWwVerbrauch,skip:()=>A.hlgate==='ja'},
 {id:"kamin",phase:"verbrauch",q:"Heizt du zusätzlich mit einem Kaminofen?",render:renderKamin,skip:()=>A.hlgate==='ja'},
 {id:"holz",phase:"verbrauch",q:"Wie viel Holz verbrennst du im Jahr?",sub:"In Raummetern. Ein Raummeter Buche sind rund 1.500 kWh Wärme, die sonst in der Rechnung fehlen.",render:renderHolz,
   skip:()=>A.hlgate==='ja'||A.kamin!=='ja'},

 /* ---------- Abschnitt 3: Deine Heizung ---------- */
 {id:"heizflaechen",phase:"heizung",q:"Heizkörper oder Fußboden?",render:renderHeizflaechen},
 {id:"radiators",phase:"heizung",q:"Wie viele Heizkörper?",render:renderRadiators,skip:()=>A.heating==='fbh'},
 /* Haengt an ZWEI Antworten und steht deshalb hinter beiden.

    DIE BEDINGUNG IST SEIT DEM 14.10.2026 WEGABHAENGIG. Im Verbrauchsweg fragen wir nur in der
    Spanne 1980 bis 1994 nach: Davor gilt die Fussbodenheizung als alt, danach als dicht - so
    war es auch vorher schon, nur mit einer Baujahr-Spanne statt einer Jahreszahl. Im
    Heizlastweg gibt es gar kein Baujahr des Hauses, also waere jede Herleitung geraten; dort
    wird immer gefragt, sobald eine Fussbodenheizung im Spiel ist. Ohne diesen Zweig fiele die
    Systemtrennung in diesem Weg still aus - ein Fehler ohne Meldung, genau die Sorte, die in
    CLAUDE.md steht. */
 {id:"fbhalter",phase:"heizung",q:"Ist deine Fußbodenheizung von vor 1990?",sub:"Rohre aus der Zeit sind oft nicht diffusionsdicht. Davon hängt ab, ob wir eine Systemtrennung einplanen.",render:renderFbhAlter,
   skip:()=>{
     if(!(A.heating==='fbh'||A.heating==='mix')) return true;
     if(A.hlgate==='ja') return false;
     const bj=Number(A.baujahrHaus)||0;
     return !(bj>=1980 && bj<1995);
   }},
 /* SIE HIESS BIS ZUM 14.10.2026 "Macht sie auch Warmwasser?" - und genau daran lag die
    Verwechslung mit "Steckt dein Warmwasser in diesem Verbrauch?". "Sie" konnte die alte
    Heizung sein oder die neue Anlage; zwei Fragen in Folge, die beide nach Warmwasser klingen,
    liest niemand als zwei verschiedene. Jetzt nennt sie ihr Subjekt beim Namen und das Wort
    "kuenftig" den Zeitpunkt. Die Frage davor sagt ihrerseits "deine jetzige Heizung".

    SIE STEHT IN BEIDEN WEGEN und bleibt im Abschnitt "Deine Heizung": Dort geht es um die
    Anlage, die kommt. Im Verbrauchsweg waere sie neben ihrer Zwillingsfrage zwar leichter zu
    unterscheiden - sie gehoerte dann aber unter die Ueberschrift "Dein Verbrauch", also zur
    Vergangenheit, und im Heizlastweg stuende sie trotzdem woanders. Ein Schritt, ein Platz. */
 {id:"ww",phase:"heizung",q:"Soll die Wärmepumpe dein Warmwasser künftig mitmachen?",sub:"Unabhängig davon, woher es heute kommt. Mit Warmwasser braucht dein Kit einen Speicher und etwas mehr Leistung.",render:renderWw},

 /* ---------- Abschnitt 4: Förderung ----------
    EIGENER ABSCHNITT AUF VORGABE (14.10.2026). Im Auslegungstool gibt es diese Fragen gar
    nicht; sie zusammen mit der Technik unter eine Ueberschrift zu stellen hiesse, Geld neben
    Rohrdurchmesser zu setzen. Mit eigenem Namen ist in der Leiste zu sehen, worum es geht -
    und dass es nur zwei Fragen sind. */
 {id:"einkommen",phase:"foerderung",q:"Euer zu versteuerndes Haushaltseinkommen?",sub:"Optional: bestimmt deinen Einkommensbonus in der Förder-Schätzung.",render:renderEinkommen,skip:()=>CONFIG.FOERDER.MODE==='off'},
 {id:"kinder",phase:"foerderung",q:"Mindestens ein minderjähriges Kind im Haushalt?",sub:"Erhöht deinen Einkommensbonus, wenn ihr als Familie knapp über einer Einkommensgrenze liegt.",render:renderKinder,skip:()=>CONFIG.FOERDER.MODE==='off'||zveIndex()<0},

 /* ---------- Abschnitt 5: Aufstellung ----------
    Ganz am Ende, weil die Antwort nur noch die Hauseinfuehrung steuert und niemanden aufhalten
    soll: "Weiß ich noch nicht" ist eine vollwertige Antwort.

    KURZ AUSGEBAUT UND AM 02.09.2026 ZURUECKGENOMMEN. Die Frage war testweise per skip aus dem
    Funnel genommen ("Funnel kuerzen" aus dem Alignment). Betreiber-Entscheid: der Funnel bleibt
    vollstaendig - die Abbruchzahlen geben eine Kuerzung nicht her, wer ihn betritt kommt
    ueberwiegend auch am Ende an.

    Die Chip-Reihe im Kaufweg (aufstellortChipsHtml) bleibt trotzdem bestehen: sie erscheint nur,
    wenn A.aufstellort noch offen ist. Nach dem Funnel ist sie das nie - im DIREKTKAUF dagegen
    schon, denn dort wurde nie gefragt. Genau deshalb liefen die beiden Sortimentsfilter
    (Hauseinfuehrung, Erdleitung) in diesem Weg bisher ins Leere. */
 {id:"aufstellort",phase:"aufstellung",q:"Weißt du schon, wo die Außeneinheit stehen soll?",sub:"Davon hängt ab, ob die Leitung oberirdisch durch die Wand geht oder unterirdisch verlegt werden muss.",render:renderAufstellort},
 /* Die letzte Frage "Sollen wir dich an die Hand nehmen?" ist am 16.09.2026 entfallen
    (Vorgabe). Sie entschied, ob technisch noetige Positionen vorausgewaehlt werden - das
    uebernehmen seit dem 15./16.09. die Antworten selbst: Aufstellort und Heizart setzen ihre
    Pakete ueber AUTOWAHL_*, die Systemtrennung ueber systemtrennungNoetig(). Damit fragte sie
    nach einer Entscheidung, die niemand mehr treffen muss.

    A.gefuehrt bleibt im Antwort-Objekt und damit auf null. Folgen, beide gewollt:
      - wendeVorauswahlAn() steigt sofort aus (es verlangt 'ja'). Es deckte Pumpengruppe und
        Hauseinfuehrung ab, die jetzt ueber die Tabellen kommen.
      - Die Erklaertour laeuft weiter; sie schweigt nur bei ausdruecklichem 'nein'. */
];
/* Zu welchem Abschnitt gehoert ein Schritt? phase darf eine Funktion sein (siehe energy). */
function phaseVon(s){ return typeof s.phase==='function' ? s.phase() : (s.phase||null); }
function activeSteps(){ return STEPS.filter(s=>!s.skip||!s.skip()); }
/* Welche Abschnitte gibt es nach dem AKTUELLEN Antwortstand, und in welchem stehen wir?

   SIE WERDEN AUS activeSteps() ABGELEITET und nicht nebenher gefuehrt: Ein Abschnitt existiert
   genau dann, wenn in ihm noch eine Frage steht, die nicht uebersprungen wird. Damit kann die
   Leiste gar nicht erst etwas anderes behaupten als der Funnel tut - und wer im Verbrauchsweg
   nachtraeglich auf "Heizlast bekannt" umschwenkt, sieht "Dein Verbrauch" im selben Augenblick
   verschwinden. */
function phasenStand(){
  const act=activeSteps();
  const liste=PHASEN.filter(ph=>act.some(s=>phaseVon(s)===ph.id));
  const jetzt=(stepIndex>=0 && stepIndex<STEPS.length) ? phaseVon(STEPS[stepIndex]) : null;
  return {liste, jetzt};
}
function zeichnePhasen(){
  const el=document.getElementById('phasen'); if(!el) return;
  const fertig = stepIndex>=STEPS.length;
  const act=activeSteps();
  const liste=PHASEN.filter(ph=>act.some(s=>phaseVon(s)===ph.id));
  const jetztStep=(stepIndex>=0 && stepIndex<STEPS.length) ? STEPS[stepIndex] : null;
  const jetzt=jetztStep ? phaseVon(jetztStep) : null;
  /* VOR DER WEICHE BLEIBT DIE LEISTE LEER, und das ist kein Versehen: Solange "Kennst du deine
     Heizlast?" offen ist, hat der eine Weg vier Abschnitte und der andere fuenf. Eine Leiste,
     die sich beim ersten Klick umbaut, waere schlechter als gar keine. */
  if(!jetzt && !fertig){ el.innerHTML=''; el.hidden=true; return; }
  el.hidden=false;
  const idxJetzt=liste.findIndex(ph=>ph.id===jetzt);
  /* DIE ABSCHNITTE SIND SO BREIT WIE IHRE FRAGENZAHL (14.10.2026, Vorgabe Claras: "insgesamt
     soll die Leiste innerhalb der Themenbereiche auch anteilweise vorruecken - also wenn mehr
     Fragen, rueckt der langsamer vor; wenn in dem Themenbereich besonders viele Fragen sind,
     ist der Fortschrittsbalken da auch groesser").

     VORHER WAREN ALLE GLEICH BREIT. Damit bewegte sich die Leiste in "Dein Haus" (sieben
     Fragen) je Frage nur ein Siebtel eines Fuenftels, in "Aufstellung" (eine Frage) dagegen
     mit einem Schlag ein ganzes Fuenftel. Mit flex:Anzahl ist ein Schritt ueberall gleich
     weit - die Leiste wird damit zum echten Gesamtfortschritt, der nebenbei sagt, worum es
     gerade geht.

     DER PREIS: "Aufstellung" ist eine von rund zwanzig Fragen und bekommt entsprechend
     fuenf Prozent der Breite. Da passt kein Wort hinein. Beschriftungen unter zwoelf Prozent
     Anteil bleiben deshalb weg - ausser beim Abschnitt, in dem man gerade steht, der behaelt
     sie immer und bekommt dafuer eine Mindestbreite. */
  const gesamt=Math.max(1,act.length);
  el.innerHTML=liste.map((ph,i)=>{
    const inPh=act.filter(s=>phaseVon(s)===ph.id);
    const anteil=inPh.length/gesamt;
    let zustand='', fuell=0;
    if(fertig || (idxJetzt>-1 && i<idxJetzt)){ zustand='done'; fuell=100; }
    else if(i===idxJetzt){
      zustand='now';
      const j=inPh.indexOf(jetztStep);
      /* MINDESTENS EIN ACHTEL, auch bei der ersten Frage des Abschnitts: Ein leerer Balken
         unter der Ueberschrift, in der man gerade steht, sieht aus wie "hier passiert nichts".
         Dieselbe Ueberlegung wie beim alten Gesamtbalken, der nie bei null anfing. */
      fuell=Math.max(12, Math.round((j<0?0:j)/Math.max(1,inPh.length)*100));
    }
    const zahl = zustand==='now' ? ` (${Math.max(1,inPh.indexOf(jetztStep)+1)} von ${inPh.length})` : '';
    const schmal = (zustand!=='now' && anteil<0.12) ? ' schmal' : '';
    return `<li class="${zustand}${schmal}" style="flex:${inPh.length}"${i===idxJetzt&&!fertig?' aria-current="step"':''}>`
      +`<i><b style="width:${fuell}%"></b></i>`
      +`<span>${esc(ph.label())}</span>`
      +`<span class="vh">${esc(ph.label())}${zahl}</span></li>`;
  }).join('');
}
/* EINE LEISTE STATT ZWEI (14.10.2026, Vorgabe Claras: "bei der Fortschrittsleiste bitte nur
   eine machen, die in die 3 oder 4 Themenabschnitte geteilt ist und dort auch einen
   Fortschritt innerhalb dieser Themenabschnitte zeigt").

   DER DUENNE GESAMTBALKEN IST DAMIT ENTFALLEN - samt #pbar im Markup und seiner CSS. Er sagte
   dasselbe noch einmal, nur ungenauer: Wie weit man ist, steht jetzt im gefuellten Abschnitt,
   und wie viel insgesamt bleibt, sagt der Zaehler rechts daneben.

   DIE ABSCHNITTE BLEIBEN GLEICH BREIT, obwohl sie verschieden viele Fragen haben. Proportional
   waere die ganze Leiste ein wahrer Gesamtfortschritt - dann bekaeme "Foerderung" mit zwei
   Fragen aber ein Zehntel der Breite, und die Beschriftung passte nicht mehr hinein. Claras
   Vorgabe nennt den Fortschritt INNERHALB des Abschnitts; den zeigt jedes Feld fuer sich, und
   dafuer braucht es keine gemeinsame Skala. */
function setProgress(){
  zeichnePhasen();
  const act=activeSteps(), idx=Math.max(0,act.findIndex(s=>s===STEPS[Math.min(stepIndex,STEPS.length-1)]));
  const sc=document.getElementById('stepcount');
  /* FERTIG ZEIGT DIE ZAHL, NICHT DAS WORT (16.09.2026, Betreiber-Entscheid).
     Hier stand 'Fertig'. Der Kunde sieht auf der Auslegungsseite lieber, wie viele Fragen er
     wirklich beantwortet hat - und die Zahl ist von Weg zu Weg verschieden, weil uebersprungene
     Fragen nicht mitzaehlen. act.length ist genau diese Anzahl, nicht STEPS.length. */
  if(stepIndex>=STEPS.length){ sc.textContent=act.length+'/'+act.length; sc.classList.add('goalgrad'); return; }
  const left=act.length-(idx+1);
  if(left===0){ sc.textContent='Letzte Frage'; sc.classList.add('goalgrad'); }
  else if(left<=2){ sc.textContent=`Nur noch ${left===1?'1 Frage':'2 Fragen'}`; sc.classList.add('goalgrad'); }
  else { sc.textContent=`${idx+1}/${act.length}`; sc.classList.remove('goalgrad'); }
}
/* Welche Antwort gehoert zu welchem Schritt - fuer das config_answer-Ereignis.

   WARUM (30.07.2026): config_step trug nur den Schrittnamen ({step:"baujahr"}). In GA4 sah man
   dadurch, WO jemand abbricht, aber bei 13 von 17 Fragen nicht, WAS er geantwortet hat. Nur
   installMode, aufstellort, gefuehrt und fbhalter hatten ein eigenes Antwort-Ereignis. Fuer
   Auswertungen wie "welche Heizungsart bricht am haeufigsten ab" oder "wie verteilen sich die
   Heizflaechen" fehlte damit die halbe Grundlage.

   BEWUSST NICHT DABEI: einkommen und kinder. Das eine ist ein Einkommensband, das andere die
   Haushaltszusammensetzung - beide existieren im Funnel nur, um den Einkommensbonus der Foerderung
   zu rechnen, und beide fallen unter finanzielle bzw. persoenliche Verhaeltnisse. Googles
   Richtlinie zu sensiblen Daten untersagt so etwas in GA4-Parametern. Die Schritte selbst werden
   weiter als config_step gezaehlt, die Abbruchquote bleibt also messbar - nur die Werte bleiben
   draussen. Falls das anders gewuenscht ist: hier eintragen, nicht irgendwo verstreut.
   fundament ist kein Frage-Feld, sondern eine Kaufposition - die meldet extra_added. */
const ANTWORT_FELD={
  installMode:'installMode', energy:'energy', baujahr:'baujahr', hlgate:'hlgate',
  hldirect:'heizlastDirect', verbrauch:'consumptionValue', ww:'dhw', personen:'persons',
  sanierung:'sanierung', heizflaechen:'heating', radiators:'radiators', fbhalter:'fbhVor1990',
  plz:'plz', aufstellort:'aufstellort', gefuehrt:'gefuehrt',
  /* Neu seit dem 14.10.2026. BEWUSST OHNE wohnflaeche, baujahrHaus und kellerflaeche: Das sind
     Angaben zum Wohnobjekt einer einzelnen Person. Dieselbe Ueberlegung wie bei einkommen und
     kinder - die Schritte selbst werden weiter als config_step gezaehlt, die Abbruchquote
     bleibt also messbar, nur die Werte bleiben aus GA4 draussen. */
  heizartDetail:'heizartDetail', wwverbrauch:'wwImVerbrauch', kamin:'kamin', keller:'kellerstatus'
};
function meldeAntwort(schrittId){
  const feld=ANTWORT_FELD[schrittId]; if(!feld) return;
  const wert=A[feld]; if(wert===null||wert===undefined||wert==='') return;
  const nutzlast={schritt:schrittId, antwort:wert};
  /* Beim Verbrauch ist die Zahl ohne Einheit wertlos (2.500 l Oel vs. 2.500 kWh Gas). */
  if(schrittId==='verbrauch' && A.unit) nutzlast.einheit=A.unit;
  track('config_answer',nutzlast);
}
function show(i){
  const vorher = (stepIndex>=0 && stepIndex<STEPS.length) ? STEPS[stepIndex].id : null;
  while(i>=0&&i<STEPS.length&&STEPS[i].skip&&STEPS[i].skip()) i+= (i>=stepIndex?1:-1);
  if(i<0) i=0;
  /* Nur vorwaerts melden: beim Zuruecksprung ist die Antwort schon einmal gezaehlt worden. */
  if(configStarted && vorher && i>stepIndex) meldeAntwort(vorher);
  stepIndex=i;
  currentCand=null; syncSticky();
  /* ZWEI SPALTEN, SOBALD EINE FRAGE STEHT (Fehlerbehebung 22.09.2026).
     Die Klasse "done" schaltet das Raster auf EINE breite Spalte - richtig fuer das Ergebnis,
     wo die Kaufbox die volle Breite braucht. Gesetzt wird sie an zwei Stellen: von finish()
     und beim Wiederherstellen eines gespeicherten Standes. Entfernt wurde sie bisher nur in
     funnelOeffnen().

     Damit blieb sie haengen, wenn jemand mit fertigem Stand auf die Seite kam und von dort
     ZURUECK in die Fragen ging: Fragekarte und Rechenzettel standen dann untereinander statt
     nebeneinander. Genau so gemeldet - "mach das Rechner-Tool wieder nebeneinander", mit
     einem Warenkorb voller Positionen im Bild, also einem wiederhergestellten Stand.

     Die Zeile gehoert hierher und nicht in den Zurueck-Knopf: show() ist die EINE Stelle, die
     eine Frage auf den Schirm bringt - egal ueber welchen Weg. Wer kuenftig einen neuen Weg
     in die Fragen baut, bekommt das richtige Raster geschenkt. */
  const gitterFrage=document.getElementById('funnelGrid');
  if(gitterFrage) gitterFrage.classList.remove('done');
  /* ZURUECK BLEIBT AUF DER AUSLEGUNGSSEITE (16.09.2026, gemeldet vom Betreiber). Hier stand
     zusaetzlich i>=STEPS.length - der Knopf verschwand also genau dort, wo der Kunde am
     ehesten noch etwas korrigieren will: nachdem er seine Heizlast gesehen hat. show(stepIndex-1)
     springt von dort sauber auf die letzte wirklich gestellte Frage zurueck, weil die
     Skip-Schleife in show() rueckwaerts genauso arbeitet wie vorwaerts. */
  document.getElementById('backBtn').classList.toggle('hidden',i<=0);
  setProgress(); renderLedger();
  if(i>=STEPS.length) return finish();
  const s=STEPS[i];
  /* Position mitgeben: ohne nr/gesamt kann GTM keinen Funnel-Bericht bauen, weil die Schrittzahl
     wegen der uebersprungenen Fragen von Weg zu Weg unterschiedlich ist. */
  if(configStarted){
    const aktiv=STEPS.filter(x=>!x.skip||!x.skip());
    track("config_step",{step:s.id, nr:aktiv.findIndex(x=>x.id===s.id)+1, gesamt:aktiv.length});
  }
  rechnerFuss(true);
  app.innerHTML=`<div class="step"><h2>${s.q}</h2>${s.sub?`<p class="sub">${s.sub}</p>`:''}<div id="body"></div></div>`;
  s.render(document.getElementById('body'));
}
function next(){
  markStarted('rechner'); renderLedger();
  show(stepIndex+1);
  speichereStand();   /* nach jeder Antwort - next() ist der gemeinsame Weg aller Fragen */
  if(window.matchMedia('(max-width:920px)').matches){
    const q=document.querySelector('.qcard');
    if(q) q.scrollIntoView({behavior:'smooth',block:'start'});
  }
}
/* Ohne Pruefung stirbt das Skript hier: Auf den Unterseiten (/pages/produkt, /pages/bauteile, ...)
   gibt es die Rechner-Karte nicht und damit auch keinen Zurueck-Knopf. Ein null-Zugriff auf
   oberster Ebene reisst ALLES mit, was danach kommt - Topbar-Menue, FAQ-Aufklapper, Warenkorb,
   Panel-Router. Genau das ist am 12.08.2026 passiert. */
const backBtnEl=document.getElementById('backBtn');
if(backBtnEl) backBtnEl.onclick=()=>show(stepIndex-1);
/* `current` = bereits gegebene Antwort. Der Zurück-Button hat die Auswahl bisher nicht mehr
   angezeigt (jede Frage kam blank zurück) - bei 13 Fragen heißt das: wer eine Antwort korrigieren
   will, weiß nicht mehr, was vorher dranstand, und muss raten. Jetzt ist die alte Wahl markiert. */
/* DER ANDERE WEG UNTER DEM RECHNER (15.10.2026, Vorgabe Claras: "wenn man beim Rechner das
   Ergebnis hat, also die E-Mail eingegeben hat und zur Ergebnisseite kommt, entferne dann den
   Knopf 'oder direkt Kit konfigurieren'").

   Der Knopf kommt aus bwp-rechner.liquid und steht ausserhalb von #app - er ueberlebt also
   jedes app.innerHTML und muss ausdruecklich geschaltet werden. Versteckt wird er genau auf
   der Ergebnisseite; beim E-Mail-Riegel davor und bei jeder Frage steht er wieder da, auch
   nach "Antworten aendern".

   Lautlos, wenn es ihn nicht gibt: Auf den Unterseiten wird der Rechner ohne diesen Fuss
   gerendert (mit_weiche), und renderComparison laeuft auch dort. */
function rechnerFuss(zeigen){
  const f=document.querySelector('.rechner-fuss');
  if(f) f.hidden=!zeigen;
}
function optGrid(el,items,onpick,cols='cols2',current=null){
  const div=document.createElement('div'); div.className='options '+cols;
  items.forEach(([val,label,sub,icon,cta])=>{
    const isSel = current!=null && val===current;
    const b=document.createElement('button'); b.className='opt'+(isSel?' sel':'');
    if(isSel) b.setAttribute('aria-current','true');
    /* FUENFTES FELD: ein Aufruf am unteren Rand der Kachel (15.10.2026, Vorgabe Claras zur
       Heizlast-Weiche: "die Frage nach der Heizlast bitte nicht in dem Stil wie der Screenshot
       machen, aber die Aufteilung wie in diesem Screenshot"). Es ist ein <span> und kein
       zweiter Knopf - ein button im button waere ungueltiges Markup, und die ganze Kachel
       loest ohnehin aus. Wer kein fuenftes Feld mitgibt, bekommt die Kachel wie bisher. */
    b.innerHTML=(icon?`<span class="oi">${icon}</span>`:'')+`<span>${esc(label)}${sub?`<small>${esc(sub)}</small>`:''}</span>`
      +(cta?`<span class="opt-cta">${esc(cta)}</span>`:'');
    b.onclick=()=>{div.querySelectorAll('.opt').forEach(x=>{x.classList.remove('sel');x.removeAttribute('aria-current')});b.classList.add('sel');onpick(val);};
    div.appendChild(b);
  });
  el.appendChild(div); return div;
}
/* Auto-Fokus nur auf Desktop: auf dem Handy schiebt die aufspringende Tastatur den "Weiter"-Button
   aus dem Bild, bevor der Kunde die Frage gelesen hat. */
function focusIfDesktop(inp){ if(window.matchMedia('(min-width:921px)').matches) inp.focus(); }

/* ---- Steps ---- */
/* Step 0 - einzige zusätzliche Frage für die komplette 2×2-Matrix (Install-Methode × Scope).
   Die Scope-Frage (Beistell vs. Komplett) wird nicht gefragt - sie ergibt sich später aus der
   Kartenwahl in der Vergleichsansicht (routeAll). */
/* DIESE FRAGE IST AM 14.10.2026 AUS DEM FUNNEL GENOMMEN (Vorgabe Claras: "von dem jetzigen
   Rechner erstmal alle Fragen uebernehmen, nur nicht die erste 'Wie willst du vorgehen'").

   FOLGE, DIE CLARA KENNT UND DIE HIER STEHEN MUSS: A.installMode bleibt damit auf null, und
   das ist die einzige Stelle im ganzen Code, die es je auf 'pro' setzt. Der Weg "Fachbetrieb
   beauftragen" ist aus dem Rechner damit nicht mehr erreichbar - renderProLead() wird von
   6379 und 14210 nur bei 'pro' aufgerufen. Wer ueber den Rechner kommt, geht ab jetzt immer
   den Weg "selbst einbauen".

   ES HAENGT MEHR DARAN ALS DIE FRAGE SELBST, und das ist beim Aufraeumen leicht zu uebersehen:
   An 'pro' haengt die GANZE VAMO-LEAD-STRECKE - renderProLead() und dahinter renderVamoGaps(),
   also das Kurzformular mit Name, Telefon, Adresse und Wohnflaeche, das die Anfrage per
   Schnittstelle an Vamo weiterreicht. Beide sind ueber keinen anderen Weg erreichbar. Mit der
   Frage ist also nicht nur eine Antwortmoeglichkeit entfallen, sondern der Weg, ueber den
   Installationsanfragen bei Vamo landeten. Die Wohnflaechen-Vorbelegung in renderVamoGaps
   laeuft damit vorerst ins Leere - sie bleibt trotzdem stehen, aus demselben Grund wie alles
   Uebrige hier.

   NICHTS DAVON LOESCHEN (Vorgabe Claras am 14.10.2026 auf genau diese Nachfrage: "loesch die
   nicht, ich sage dir in den naechsten Wochen, wo du das integrieren sollst"). Es sind rund
   200 Zeilen, die derzeit von nirgends aufgerufen werden und beim naechsten Durchsehen wie
   Altlast aussehen - sie sind keine. Der Einstieg kommt zurueck, nur an anderer Stelle; wo,
   entscheidet Clara. Bis dahin steht hier alles unveraendert.

   WENN ES SO WEIT IST, genuegt ein Aufrufer, der A.installMode setzt: ein Schritt in STEPS
   oder ein Knopf neben dem Ergebnis. Der Rest der Strecke haengt allein an diesem Feld. */
function renderInstallMode(el){
  optGrid(el,[
    ["diy","Selbst einbauen","Kit liefern, du baust: Anleitung & Support inklusive"],
    ["pro","Fachbetrieb beauftragen","Wir vermitteln dich an einen Fachbetrieb in deiner Nähe"]
  ],v=>{A.installMode=v; track("install_mode_select",{mode:v}); setTimeout(next,200);},'',A.installMode);
}
/* DIE WEICHE STEHT LINKS UND RECHTS (14.10.2026, Vorgabe Claras mit Bildschirmfoto, dann
   praezisiert: "ich moechte nicht, dass es genauso aussieht wie in der HTML, sondern dass es
   auch mit rechts und links ist, aber in dem Design vom alten Rechner").

   ALSO optGrid MIT cols2 UND KEINE EIGENE BAUFORM. Hier standen kurz nachgebaute Karten aus
   der Vorlage - schwarzer Rand, 18 px Radius, gelbe Pille unten. Sie sahen gut aus und
   trotzdem falsch: Im Rechner ist das die einzige Frage gewesen, die anders aussah als die
   sechzehn danach. Dass hinter den beiden Antworten verschieden lange Wege liegen, muss der
   TEXT tragen, nicht eine zweite Formensprache.

   DIE AUSFUEHRLICHEN TEXTE AUS DEM BILDSCHIRMFOTO BLEIBEN. Genau sie waren der Grund fuer
   Claras Hinweis: "Ja, in kW" gegen "Nein" sagte nichts darueber, worauf man sich einlaesst -
   wer hier falsch klickt, merkt es erst drei Fragen spaeter. Jetzt nennt die Kachel die
   Voraussetzung und was danach kommt, in der Form, die der Rechner ohnehin hat. */
function renderHlgate(el){
  optGrid(el,[
    ["ja","Ich habe bereits eine Heizlast",
     "Du hast eine Heizlastberechnung, zum Beispiel vom Energieberater. Dann brauchen wir nur noch wenige Angaben.",
     ICONS.blattHaken,"Mit meiner Heizlast starten →"],
    ["nein","Ich möchte meine Heizlast überschlägig berechnen",
     "Wir schätzen die Heizlast aus deinem bisherigen Gas-, Öl- oder Stromverbrauch. Du brauchst nur deine letzte Jahresabrechnung.",
     ICONS.heizung,"Aus meinem Verbrauch berechnen →"]
  ],v=>{
    A.hlgate=v;
    /* Den Wert des anderen Weges abraeumen: Wer von "Verbrauch" auf "Heizlast" wechselt, haette
       sonst beide im Stand, und calc() nimmt stumm den DIN-Zweig. */
    if(v==='ja'){A.consumptionValue=null;} else {A.heizlastDirect=null;}
    setTimeout(next,200);
  /* "weiche" neben cols2 (14.10.2026, Vorgabe Claras: "du kannst bei der Frage 'Kennst du deine
     Heizlast' die zwei Antworten gerne groesser nach unten hin machen und sie somit etwas
     verzerren"). optGrid haengt diese Zeichenkette unveraendert an die Klasse des Rasters -
     damit laesst sich genau diese eine Liste ansprechen, ohne eine zweite Bauform einzufuehren. */
  },'cols2 weiche',A.hlgate);
}

/* WIEDERHERGESTELLT AM 14.10.2026, nachdem sie beim Umbau der Weiche versehentlich
   mitgeloescht wurde (Meldung Claras: "die Frage 'Deine Heizlast in kW?' funktioniert nicht,
   ich kann nicht auf Weiter klicken").

   WAS PASSIERT WAR: Der Weichen-Block wurde ueber Anfangs- und Endmarke ersetzt - von seinem
   Kommentar bis zu "function renderHldirect". Genau DAZWISCHEN stand diese Funktion. Sie fiel
   damit heraus, und zwar lautlos: Eine fehlende Funktion ist kein Syntaxfehler, node --check
   meldet nichts, der theme check auch nicht. Erst beim Klick auf "Weiter" bricht der Handler
   mit "zahlAus is not defined" ab - und ein abgebrochener Handler sieht aus wie ein Knopf, der
   nichts tut.

   ES HING MEHR DARAN ALS DIESE EINE FRAGE: zahlAus wird an 13 Stellen gerufen - Heizlast,
   Jahresverbrauch samt beider Vorjahre und alle vier Zahlenfragen ueber zahlSchritt
   (Wohnflaeche, Baujahr, Kellerflaeche, Holz). Keines dieser Felder liess sich bestaetigen.

   MERKSATZ: Beim Ersetzen ueber Marken erst nachsehen, was zwischen ihnen steht. Und eine
   Pruefung, die nur die Syntax liest, beweist hier nichts - gefunden hat es erst ein Lauf, der
   den Knopf wirklich drueckt. */
/* Deutsche Zahleneingabe robust auswerten (Korrektur 30.07.2026).

   Die beiden Zahlenfelder im Funnel waren <input type="number">. Der Browser verwirft dort
   jede Eingabe, die nicht dem englischen Zahlenformat entspricht - und liefert dann still
   einen LEEREN Wert zurueck, obwohl im Feld etwas zu stehen scheint. Getroffen hat das genau
   das, was ein deutscher Nutzer tippt:
     Heizlast  "8,5"      -> Komma  -> Wert leer, "Weiter" wirkte kaputt
     Verbrauch "18.000"   -> Punkt als Tausendertrenner -> Wert leer
     Verbrauch "18 000"   -> Leerzeichen -> Wert leer   (genau so stand es im Platzhalter!)
   Beide Felder sind jetzt type="text" mit inputmode, und diese Funktion liest den Wert.
   Regel: das LETZTE Trennzeichen ist das Dezimaltrennzeichen, alles davor sind Tausender. */
function zahlAus(roh){
  if(roh==null) return NaN;
  let s=String(roh).trim().replace(/\s| |'|­/g,'');
  if(!s) return NaN;
  const letztesKomma=s.lastIndexOf(','), letzterPunkt=s.lastIndexOf('.');
  const trenner=Math.max(letztesKomma,letzterPunkt);
  if(trenner>-1){
    const nachkomma=s.length-trenner-1;
    /* Genau drei Stellen hinter dem einzigen Trenner: das ist ein Tausenderpunkt (18.000),
       kein Dezimaltrenner - ausser es steht auch noch ein zweiter Trenner davor. */
    const nurEiner=(letztesKomma===-1)!==(letzterPunkt===-1);
    if(nurEiner && nachkomma===3 && s.length>4) s=s.replace(/[.,]/g,'');
    else s=s.slice(0,trenner).replace(/[.,]/g,'')+'.'+s.slice(trenner+1);
  }
  const v=parseFloat(s);
  return isNaN(v)?NaN:v;
}
function renderHldirect(el){
  const TYP_HL=8.0;
  el.innerHTML=`<div class="field"><input type="text" id="dInput" class="zahlfeld" inputmode="decimal" autocomplete="off" placeholder="8,0" aria-label="Heizlast in kW"></div>
   <button class="typ-default" id="dTyp" type="button">Typisch fürs Einfamilienhaus: ${fmt(TYP_HL,1).replace('.',',')} kW · übernehmen</button>
   <button class="btn" id="dGo">Weiter →</button>
   <div class="feldfehler" id="dErr" role="alert" hidden></div>`;
  const d=el.querySelector('#dInput');
  const err=el.querySelector('#dErr');
  if(A.heizlastDirect) d.value=String(A.heizlastDirect).replace('.',','); /* Rücksprung: eigener Wert bleibt sichtbar */
  focusIfDesktop(d);
  el.querySelector('#dTyp').onclick=()=>{ d.value=String(TYP_HL); A.heizlastDirect=TYP_HL; A.consumptionValue=null; track("typical_default_used",{unit:'heizlast_kw',value:TYP_HL}); renderLedger(); d.focus(); };
  /* Vorher lief das Feld in zwei Sackgassen: leer oder unter 1 kW setzte nur den Fokus - auf dem
     Handy sieht man davon nichts ausser einer aufspringenden Tastatur, der Knopf wirkte kaputt.
     Und nach oben gab es gar keine Pruefung: das max="30" im Markup ist nur ein Hinweis, 18.000
     wanderte ungebremst in die Auslegung. Jetzt beides benannt, in Worten statt stumm. */
  const meldung=t=>{ if(t){err.textContent=t; err.hidden=false;} else {err.hidden=true;} };
  el.querySelector('#dGo').onclick=()=>{
    const roh=d.value.trim();
    const v=zahlAus(roh);
    if(!roh){ meldung('Bitte trag deine Heizlast ein - oder nimm den typischen Wert darüber.'); d.focus(); return; }
    if(isNaN(v)){ meldung('Das ist keine Zahl. Beispiel: 8,0'); d.focus(); return; }
    if(v<1){ meldung('Unter 1 kW passt keine Wärmepumpe. Steht da vielleicht die Wohnfläche?'); d.focus(); return; }
    if(v>30){ meldung('Über 30 kW liegt außerhalb unserer Kits. Ruf uns an: '+CONFIG.SUPPORT_PHONE); d.focus(); return; }
    meldung(''); A.heizlastDirect=v; A.consumptionValue=null; next();
  };
  d.addEventListener('input',()=>{const v=zahlAus(d.value); A.heizlastDirect=(v>0&&v<=30)?v:null; meldung(''); renderLedger();});
  d.addEventListener('keydown',e=>{if(e.key==='Enter')el.querySelector('#dGo').click();});
}
function renderEinkommen(el){
  optGrid(el,[
    ["b30","bis 30.000 €",""],
    ["30_40","30.000 – 40.000 €",""],
    ["40_50","40.000 – 50.000 €",""],
    ["50_60","50.000 – 60.000 €",""],
    ["a60","über 60.000 €",""],
    ["ka","Keine Angabe","Schätzung dann ohne Einkommensbonus"]
  /* A.zve ist bei "Keine Angabe" null - das ist nicht von "noch nicht beantwortet" zu unterscheiden.
     A.zveChoice merkt sich die Klick-Antwort nur für die Wiederanzeige, die Rechenlogik bleibt an A.zve. */
  ],v=>{A.zveChoice=v; A.zve=(v==='ka'?null:v); setTimeout(next,200);},'',A.zveChoice);
}
function renderKinder(el){
  optGrid(el,[
    ["nein","Nein",""],
    ["ja","Ja","mind. 1 minderjähriges Kind"]
  ],v=>{A.kinder=v; setTimeout(next,200);},'',A.kinder);
}
/* Fundament schon im Funnel wählbar (User-Entscheid 14.07.2026): "fertig" setzt das Material-Extra
   chosenExtras.fundament (fließt in Summe + Checkout-Gruppe "Fundament"), "selbst" hält die
   Eigenleistungs-Zeile in der Buybox. Die Buybox-Checkbox bleibt als zweiter Schalter - beide
   wirken auf denselben Zustand. */
/* renderFundament() ist mit der Frage entfallen - siehe den Vermerk bei STEPS. A.fundament
   bleibt im Antwort-Objekt stehen: Der Fachbetrieb-Pfad liest es fuer das Lead-Feld
   statusOfFoundationConstruction, und dort ist "nicht gesetzt" die richtige Auskunft - in
   jenem Pfad baut Vamo die Anlage und damit auch das Fundament. */
function setEnergy(v){
  const old=A.energy;
  A.energy=v==='anderes'?'sonstiges':v;
  A.unit=({gas:'gas_kwh',oel:'oel_l',pellets:'pellets_kg',holz:'holz_rm',strom:'strom_kwh',fernwaerme:'fw_kwh',wp:'strom_kwh'})[A.energy]||null;
  /* Träger gewechselt → alter Verbrauchswert wäre in der neuen Einheit Unsinn (User-Bug 17.07.2026:
     2.500 l Öl blieben nach Wechsel auf Gas als 2.500 kWh im Rechenzettel stehen). */
  if(old && old!==A.energy) A.consumptionValue=null;
  /* Dasselbe gilt fuer die Nachfrage nach der Bauart und die Vorjahre (14.10.2026): Ein
     'gas_hw' passt nach dem Wechsel auf Oel zu nichts mehr, und zwei Vorjahreszahlen in der
     alten Einheit waeren derselbe Fehler wie der Hauptwert. */
  if(old && old!==A.energy){ A.heizartDetail=null; A.verbrauch2=null; A.verbrauch3=null; }
}
const ENERGY_ITEMS=[
  ["gas","Gas","",ICONS.gas],["oel","Öl","",ICONS.oel],
  ["pellets","Pellets","",ICONS.pellets],["holz","Holz","",ICONS.holz],
  ["strom","Strom","",ICONS.strom],["fernwaerme","Fernwärme","",ICONS.fw],
  ["wp","Wärmepumpe","",ICONS.wp],["anderes","Anderes","",ICONS.frage]
];
function renderEnergy(el){
  /* setEnergy() mappt "anderes" auf A.energy='sonstiges' - für die Wiederanzeige zurückmappen. */
  optGrid(el,ENERGY_ITEMS,v=>{setEnergy(v); setTimeout(next,200);},'cols2',A.energy==='sonstiges'?'anderes':A.energy);
}
/* AUS DER JAHRESZAHL WIRD DIE SPANNE, DIE DIE RECHNUNG BRAUCHT (14.10.2026, Vorgabe Claras:
   "die Frage nach Baujahr der Heizung bitte Feld zum Ausfuellen und nicht Auswaehlen machen").

   A.baujahr BLEIBT, WAS ES WAR. An dem Schluessel haengen ETA und ETA_DETAIL (Nutzungsgrad),
   die Hybrid-Regel, VAMO_BAUJAHR fuer den Lead und der Rueckfall in systemtrennungNoetig() -
   zusammen ein gutes Dutzend Stellen. Die Jahreszahl kommt daneben in ein eigenes Feld
   (A.baujahrHeizung) und wird hier in die Spanne uebersetzt. Haette ich stattdessen ueberall
   auf die Jahreszahl umgestellt, waere aus einer Formularfrage ein Umbau der halben Rechnung
   geworden - und die Spannen stehen so auch im Datenblatt der Nutzungsgrade.

   DIE GRENZEN SIND DIE DER ALTEN KACHELN, auf den Tag genau: nach 2016, 1995 bis 2016, 1980
   bis 1994, davor. Wer vorher "1995 - 2016" angeklickt hat und jetzt 2004 eintraegt, bekommt
   denselben Nutzungsgrad wie bisher. */
function baujahrSpanne(jahr){
  const j=Number(jahr)||0;
  if(!j) return null;
  if(j>2016)   return 'nach2016';
  if(j>=1995)  return 'y1995_2016';
  if(j>=1980)  return 'y1980_1994';
  return 'vor1980';
}
function renderBaujahr(el){
  const jetzt=new Date().getFullYear();
  zahlSchritt(el,{feld:'baujahrHeizung', ph:'2004', aria:'Baujahr der Heizung', max4:true,
    min:1950, max:jetzt,
    leer:'Bitte trag das Baujahr als Jahreszahl ein - ungefähr reicht.',
    ausserhalb:`Bitte eine Jahreszahl zwischen 1950 und ${jetzt}.`,
    dann:v=>{ A.baujahr=baujahrSpanne(v); }});
}
function renderVerbrauch(el){
  const units={gas:[["gas_kwh","kWh"],["gas_m3","m³ (H-Gas)"],["gas_m3_l","m³ (L-Gas)"],["gas_fluessig_l","l Flüssiggas"]],
    oel:[["oel_l","Liter"]],
    pellets:[["pellets_kg","kg"],["pellets_t","Tonnen"]],
    holz:[["holz_rm","rm Buche"],["holz_rm_fichte","rm Fichte"],["hack_kg","kg Hackschnitzel"]],
    strom:[["strom_kwh","kWh"]],fernwaerme:[["fw_kwh","kWh"]],wp:[["strom_kwh","kWh Strom"]],sonstiges:[["gas_kwh","kWh"]]};
  const u=units[A.energy]||units.sonstiges;
  /* ZWEI ZUSAETZLICHE JAHRE (14.10.2026, aus dem Auslegungstool uebernommen).

     WARUM SIE SICHTBAR SIND UND NICHT HINTER EINEM "MEHR ANZEIGEN": Sie sind der billigste
     Weg zu einem besseren Ergebnis, den dieser Funnel hat. Ein einzelner Winter weicht leicht
     um 15 Prozent vom Mittel ab, und dieselben 15 Prozent stehen am Ende in der Heizlast. Wer
     die Abrechnung in der Hand hat, hat die Vorjahreszahl meist daneben stehen.

     LEER BLEIBEN IST AUSDRUECKLICH ERLAUBT. Der Rechner mittelt ueber das, was dasteht - mit
     einem Jahr rechnet er wie bisher. Deshalb tragen die Felder kein eigenes "optional"-Label,
     sondern sagen es im Platzhalter. */
  el.innerHTML=`<div class="field"><input type="text" id="cInput" class="zahlfeld" inputmode="numeric" autocomplete="off" placeholder="18.000" aria-label="Jahresverbrauch im letzten Jahr"></div>
   <div class="unitchips" id="uChips"></div>
   <button class="typ-default hidden" id="cTyp" type="button"></button>
   <div class="field zwei-jahre">
     <input type="text" id="cInput2" class="zahlfeld" inputmode="numeric" autocomplete="off" placeholder="Vorjahr" aria-label="Jahresverbrauch im Vorjahr">
     <input type="text" id="cInput3" class="zahlfeld" inputmode="numeric" autocomplete="off" placeholder="Jahr davor" aria-label="Jahresverbrauch vor zwei Jahren">
   </div>
   <button class="btn" id="cGo">Weiter →</button>
   <div class="feldfehler" id="cErr" role="alert" hidden></div>
   <div class="ghostrow">
     <button class="btn quiet" id="cNone">Abrechnung nicht da</button>
   </div><div id="cAlt"></div>`;
  const chips=el.querySelector('#uChips'), inp=el.querySelector('#cInput');
  const inp2=el.querySelector('#cInput2'), inp3=el.querySelector('#cInput3');
  const typBtn=el.querySelector('#cTyp');
  function syncTyp(){
    const t=typicalFor(), hwu=HEIZWERT[A.unit];
    if(t&&hwu){ inp.placeholder=fmt(t,t<10?1:0); typBtn.textContent=`Typisch fürs Einfamilienhaus: ${fmt(t,t<10?1:0)} ${hwu.unit} · übernehmen`; typBtn.classList.remove('hidden'); }
    else typBtn.classList.add('hidden');
  }
  /* Zurücksprung: die zuletzt gewählte Einheit muss die markierte bleiben. Vorher wurde immer die
     erste (kWh) markiert UND A.unit hart darauf zurückgesetzt - der behaltene Zahlenwert stand dann
     plötzlich in einer anderen Einheit da (2.500 l Öl wurden zu 2.500 kWh). */
  const keep = u.some(([k])=>k===A.unit) ? A.unit : u[0][0];
  u.forEach(([k,label],idx)=>{ const b=document.createElement('button'); b.className='chipbtn'+(k===keep?' sel':''); b.textContent=label;
    /* Einheiten-Wechsel: alten Zahlenwert leeren - 18.000 kWh dürfen nicht als 18.000 m³ stehen bleiben
       (User-Bug 17.07.2026), der typische Wert wechselt über syncTyp() als Placeholder mit. */
    /* Beim Einheitenwechsel muessen ALLE DREI Jahre weg, nicht nur das erste: 18.000 kWh
       duerfen nicht als 18.000 m3 stehen bleiben (User-Bug 17.07.2026) - und das gilt fuer
       das Vorjahr genauso. */
    b.onclick=()=>{chips.querySelectorAll('.chipbtn').forEach(x=>x.classList.remove('sel'));b.classList.add('sel');A.unit=k;
      inp.value='';inp2.value='';inp3.value='';A.consumptionValue=null;A.verbrauch2=null;A.verbrauch3=null;syncTyp();renderLedger();};
    chips.appendChild(b); });
  A.unit=keep; syncTyp();
  if(A.consumptionValue) inp.value=A.consumptionValue; /* Rücksprung: eigener Wert bleibt sichtbar */
  if(A.verbrauch2) inp2.value=A.verbrauch2;
  if(A.verbrauch3) inp3.value=A.verbrauch3;
  focusIfDesktop(inp);
  typBtn.onclick=()=>{ const t=typicalFor(); if(!t)return; inp.value=t; A.consumptionValue=t; track("typical_default_used",{unit:A.unit,value:t}); renderLedger(); inp.focus(); };
  /* Wie beim Heizlast-Feld: keine stille Sackgasse mehr, sondern eine benannte Meldung. */
  const cErr=el.querySelector('#cErr');
  const cMeldung=t=>{ if(t){cErr.textContent=t; cErr.hidden=false;} else {cErr.hidden=true;} };
  el.querySelector('#cGo').onclick=()=>{
    const roh=inp.value.trim(), v=zahlAus(roh);
    if(!roh){ cMeldung('Bitte trag deinen Jahresverbrauch ein - oder nimm den typischen Wert darüber.'); inp.focus(); return; }
    if(isNaN(v)){ cMeldung('Das ist keine Zahl. Beispiel: 18.000'); inp.focus(); return; }
    if(v<1){ cMeldung('Das kann nicht stimmen. Schau noch mal auf deine Abrechnung.'); inp.focus(); return; }
    /* Die beiden Vorjahre duerfen leer sein - aber nicht falsch. Ein Tippfehler im Vorjahr
       zoege den Mittelwert sonst stumm nach unten. */
    for(const [feld,name] of [[inp2,'Vorjahr'],[inp3,'Jahr davor']]){
      const r=feld.value.trim(); if(!r) continue;
      const w=zahlAus(r);
      if(isNaN(w)||w<1){ cMeldung(`Der Wert fürs ${name} ist keine brauchbare Zahl. Lass das Feld leer, wenn du ihn nicht hast.`); feld.focus(); return; }
    }
    cMeldung('');
    A.consumptionValue=v;
    A.verbrauch2=zahlAus(inp2.value.trim())>0?zahlAus(inp2.value.trim()):null;
    A.verbrauch3=zahlAus(inp3.value.trim())>0?zahlAus(inp3.value.trim()):null;
    A.heizlastDirect=null; next();
  };
  inp.addEventListener('input',()=>{const v=zahlAus(inp.value); A.consumptionValue=(v>0)?v:null; cMeldung(''); renderLedger();});
  inp2.addEventListener('input',()=>{const v=zahlAus(inp2.value); A.verbrauch2=(v>0)?v:null; cMeldung(''); renderLedger();});
  inp3.addEventListener('input',()=>{const v=zahlAus(inp3.value); A.verbrauch3=(v>0)?v:null; cMeldung(''); renderLedger();});
  [inp,inp2,inp3].forEach(f=>f.addEventListener('keydown',e=>{if(e.key==='Enter')el.querySelector('#cGo').click();}));
  el.querySelector('#cNone').onclick=()=>{
    track("reminder_view",{});
    el.querySelector('#cAlt').innerHTML=`<div class="field"><input type="email" id="remEmail" placeholder="du@beispiel.de" aria-label="E-Mail für Erinnerung">
      <button class="btn" id="remGo">Link schicken, später weitermachen</button><div id="remDone"></div></div>`;
    el.querySelector('#remGo').onclick=async()=>{
      const v=el.querySelector('#remEmail').value, done=el.querySelector('#remDone');
      if(!istEmail(v)){ done.innerHTML=`<div class="banner warn">Bitte gib eine gültige E-Mail-Adresse an.</div>`; return; }
      A.email=v; speichereStand(); track("reminder_signup",{});
      done.innerHTML=`<div class="banner ok">Wird gesendet …</div>`;
      const ok=await submitLead("reminder");
      done.innerHTML= ok ? `<div class="banner ok">Unterwegs. Deine Antworten bleiben auf diesem Gerät gespeichert.</div>`
        : `<div class="banner warn">Das hat gerade nicht geklappt, deine Antworten bleiben aber auf diesem Gerät gespeichert.</div>`;
      el.querySelector('#remGo').disabled=ok;
    };
  };
}
function renderWw(el){
  /* A.persons WIRD HIER NICHT MEHR GELEERT (14.10.2026). Die Personenzahl steht seit dem Umbau
     im ersten Abschnitt und damit VOR dieser Frage (Vorgabe Claras: "ganz vorn, wie in der
     neuen Datei"). Wer hier "nein" waehlt und es sich anders ueberlegt, haette seine Antwort
     sonst verloren - rechnerisch ist das Leeren ohnehin folgenlos, calc() liest die
     Personenzahl nur bei A.dhw==='ja'. */
  optGrid(el,[["ja","Ja","",ICONS.ww],["nein","Nein, nur Heizung","",ICONS.heizung]],v=>{
    A.dhw=v; setTimeout(next,200);
  },'',A.dhw);
}
function renderPersonen(el){
  const div=document.createElement('div'); div.className='chips';
  [1,2,3,4,5,6].forEach(n=>{ const b=document.createElement('button'); b.className='chipbtn'+(A.persons===n?' sel':''); b.textContent=n===6?"6+":n;
    b.onclick=()=>{div.querySelectorAll('.chipbtn').forEach(x=>x.classList.remove('sel'));b.classList.add('sel');A.persons=n;setTimeout(next,200);};
    div.appendChild(b); });
  el.appendChild(div);
}
function renderSanierung(el){
  optGrid(el,[
    ["saniert","Saniert","Neubau / komplett saniert"],
    ["teilsaniert","Teilsaniert","Fenster oder Fassade neu"],
    ["unsaniert","Unsaniert","Originalzustand"]
  ],v=>{A.sanierung=v;setTimeout(next,200);},'',A.sanierung);
}
function renderHeizflaechen(el){
  optGrid(el,[
    ["hk","Heizkörper","",ICONS.hk],
    ["fbh","Fußbodenheizung","",ICONS.fbh],
    ["mix","Beides","",ICONS.mix]
  ],v=>{A.heating=v; if(v==='fbh')A.radiators=null; setTimeout(next,200);},'',A.heating);
}
function renderRadiators(el){
  optGrid(el,[["r8","1 – 8",""],["r15","9 – 15",""],["r16","16 +",""]],v=>{A.radiators=v;setTimeout(next,200);},'cols2',A.radiators);
}
function renderPlz(el){
  el.innerHTML=`<div class="field"><input type="text" id="zInput" inputmode="numeric" maxlength="5" pattern="[0-9]{5}" placeholder="50667" aria-label="Postleitzahl"></div>
   <div class="feedback" id="zFound"></div>
   <button class="btn" id="zGo">Weiter →</button>`;
  const inp=el.querySelector('#zInput'), found=el.querySelector('#zFound');
  const sync=()=>{
    if(/^\d{5}$/.test(inp.value)){
      const k=klimaLookup(inp.value);
      if(k){ A.plz=inp.value; found.textContent=`✓ ${k.ort} · ${fmt(k.tn,1).replace('.',',')} °C Norm-Außentemperatur`; renderLedger(); }
      else { A.plz=null; found.textContent='PLZ nicht gefunden.'; }
    } else { A.plz=null; found.textContent=''; }
  };
  /* Rücksprung: PLZ und die bestätigte Ortszeile wieder herstellen, sonst wirkt die Frage
     unbeantwortet und der "Rechnung abschließen"-Button blockiert scheinbar grundlos. */
  if(A.plz){ inp.value=A.plz; sync(); }
  focusIfDesktop(inp);
  inp.addEventListener('input',sync);
  el.querySelector('#zGo').onclick=()=>{ if(!A.plz){inp.focus();return;} next(); };
  inp.addEventListener('keydown',e=>{if(e.key==='Enter')el.querySelector('#zGo').click();});
}

/* =====================================================================
   NEUE FRAGEN AUS DEM AUSLEGUNGSTOOL (14.10.2026)

   Vorgabe Claras: "eine neue Version des Kitgroessenrechners mit mehr Fragen, die die Auswahl
   spezifischer machen ... die neuen Fragen nicht in dem Aufbau der neuen Datei machen, sondern
   so wie es jetzt im Rechner schon ist."

   DESHALB KEIN FORMULAR MIT ZEHN FELDERN, sondern eine Frage je Bildschirm wie bisher - mit
   optGrid fuer Auswahlfragen und zahlSchritt fuer Zahlen. Die Vorlage dafuer ist
   renderHldirect: Zahlenfeld, benannte Fehlermeldung statt stummem Fokussprung, Rueckgabe des
   eigenen Werts beim Zuruecksspringen.
   ===================================================================== */

/* EIN HELFER FUER VIER ZAHLENFRAGEN (Wohnflaeche, Baujahr, Kellerflaeche, Holz).

   WARUM NICHT VIERMAL ABSCHREIBEN: An renderHldirect haengen drei Dinge, die man beim Kopieren
   verliert und die jedes Mal einzeln als Fehler zurueckkommen - die deutsche Zahlenlesung
   (zahlAus, siehe den Vermerk dort), der wiederhergestellte Wert beim Zuruecksspringen und die
   benannte Meldung statt eines stummen Fokussprungs. Einmal richtig ist hier vier Pflegestellen
   weniger.

   o.frei SETZT DAS FELD AUSDRUECKLICH AUF LEER und geht weiter. Das ist nicht dasselbe wie
   "noch nicht beantwortet": Wer die Kellerflaeche nicht kennt, soll nicht haengen bleiben. */
function zahlSchritt(el,o){
  /* DIE EINHEIT STEHT IM FELD (14.10.2026, Vorgabe Claras: "bei 'Wie viel Holz verbrennst du
     im Jahr' mit die Raummeter mit in das Ausfuellfeld geben, also damit man weiss, was der
     Wert ist, ohne nachlesen zu muessen").

     NEBEN DER ZAHL UND NICHT IM PLATZHALTER: Ein Platzhalter verschwindet, sobald jemand
     tippt - also genau dann, wenn die Frage "in welcher Einheit eigentlich?" aufkommt. Die
     Einheit bleibt stehen.

     SIE IST KEIN BESTANDTEIL DER EINGABE: pointer-events:none und aria-hidden, damit sie weder
     anklickbar ist noch zweimal vorgelesen wird - im aria-label des Feldes steht sie schon. */
  const einheit = o.einheit ? `<span class="zf-einheit" aria-hidden="true">${esc(o.einheit)}</span>` : '';
  el.innerHTML=`<div class="field${o.einheit?' hat-einheit':''}"><input type="text" id="zfIn" class="zahlfeld" inputmode="${o.dez?'decimal':'numeric'}"
      autocomplete="off" ${o.max4?'maxlength="4"':''} placeholder="${esc(o.ph)}" aria-label="${esc(o.aria)}">${einheit}</div>
   <button class="btn" id="zfGo">Weiter &rarr;</button>
   ${o.frei?`<div class="ghostrow"><button class="btn quiet" id="zfSkip">${esc(o.frei)}</button></div>`:''}
   <div class="feldfehler" id="zfErr" role="alert" hidden></div>`;
  const inp=el.querySelector('#zfIn'), err=el.querySelector('#zfErr');
  const meldung=t=>{ if(t){err.textContent=t; err.hidden=false;} else {err.hidden=true;} };
  const vorher=A[o.feld];
  if(vorher!==null&&vorher!==undefined&&vorher!=='') inp.value=String(vorher).replace('.',',');
  focusIfDesktop(inp);
  /* o.dann LAEUFT NACH JEDEM SETZEN, auch beim Tippen. Gebraucht wird es vom Baujahr der
     Heizung: Dort steht im Feld eine Jahreszahl, die Rechnung arbeitet aber mit Spannen
     (ETA/ETA_DETAIL). Die Ableitung gehoert an die Stelle, die den Wert setzt - sonst gibt es
     irgendwann einen Weg, auf dem die Jahreszahl ankommt und die Spanne nicht. */
  const setzen=v=>{ A[o.feld]=v; if(o.dann) o.dann(v); };
  const uebernehmen=()=>{
    const roh=inp.value.trim(), v=zahlAus(roh);
    if(!roh){ meldung(o.leer); inp.focus(); return; }
    if(isNaN(v)){ meldung('Das ist keine Zahl. Beispiel: '+o.ph); inp.focus(); return; }
    if(v<o.min||v>o.max){ meldung(o.ausserhalb); inp.focus(); return; }
    meldung(''); setzen(v); renderLedger(); next();
  };
  el.querySelector('#zfGo').onclick=uebernehmen;
  inp.addEventListener('input',()=>{ const v=zahlAus(inp.value); setzen((v>=o.min&&v<=o.max)?v:null); meldung(''); renderLedger(); });
  inp.addEventListener('keydown',e=>{ if(e.key==='Enter') uebernehmen(); });
  if(o.frei) el.querySelector('#zfSkip').onclick=()=>{ setzen(null); next(); };
}

/* Nur bei Gas und Oel - HEIZART_DETAIL fuehrt fuer die uebrigen Traeger nichts, und der Schritt
   wird dann uebersprungen (Vorgabe Claras: "bei den anderen geht es direkt weiter"). */
function renderHeizartDetail(el){
  const liste=HEIZART_DETAIL[A.energy]||[];
  optGrid(el,liste,v=>{A.heizartDetail=v; renderLedger(); setTimeout(next,200);},'',A.heizartDetail);
}

/* GENAUE JAHRESZAHL STATT SPANNE (Vorgabe Claras: "beim Baujahr des Hauses bitte die neue
   nehmen und eine genaue Angabe machen").

   SIE MEINT DAS HAUS, NICHT DIE HEIZUNG. Bis heute gab es dafuer nur ein einziges Feld
   (A.baujahr), das beides zugleich sein musste: den Nutzungsgrad der alten Heizung UND das
   Alter des Hauses fuer die Systemtrennung. In ein Haus von 1960 kann eine Gastherme von 2010
   eingebaut sein - die eine Antwort konnte nie fuer beides stimmen. */
function renderBaujahrHaus(el){
  const jetzt=new Date().getFullYear();
  zahlSchritt(el,{feld:'baujahrHaus', ph:'1975', aria:'Baujahr des Hauses', max4:true,
    min:1800, max:jetzt+1,
    leer:'Bitte trag das Baujahr als Jahreszahl ein. Ungefähr reicht.',
    ausserhalb:`Bitte eine Jahreszahl zwischen 1800 und ${jetzt+1}.`});
}

/* Die Wohnflaeche traegt zwei Dinge: die Plausibilitaetswarnung (Watt je Quadratmeter) und die
   Vorbelegung des gleichnamigen Felds im Beratungsformular. */
function renderWohnflaeche(el){
  zahlSchritt(el,{feld:'wohnflaeche', ph:'140', aria:'Beheizte Wohnfläche in Quadratmetern',
    min:20, max:2000,
    leer:'Bitte trag die beheizte Wohnfläche ein - ungefähr reicht.',
    ausserhalb:'Bitte eine Fläche zwischen 20 und 2.000 m².',
    frei:'Weiß ich nicht genau'});
}
function renderKeller(el){
  optGrid(el,[
    ["nicht","Kein Keller oder unbeheizt",""],
    ["teil","Teilweise beheizt","zum Beispiel ein Hobbyraum"],
    ["voll","Komplett beheizt","Wohnräume im Keller"]
  ],v=>{A.kellerstatus=v; if(v==='nicht')A.kellerflaeche=null; setTimeout(next,200);},'',A.kellerstatus);
}
function renderKellerflaeche(el){
  zahlSchritt(el,{feld:'kellerflaeche', ph:'60', aria:'Kellerfläche in Quadratmetern',
    min:5, max:1000,
    leer:'Bitte trag die Kellerfläche ein - oder geh ohne Angabe weiter.',
    ausserhalb:'Bitte eine Fläche zwischen 5 und 1.000 m².',
    frei:'Weiß ich nicht'});
}

/* OHNE DIESE FRAGE RECHNET DER RECHNER FALSCH, UND ZWAR STILL: Er zieht das Warmwasser
   grundsaetzlich vom Jahresverbrauch ab. Wer sein Wasser ueber einen Durchlauferhitzer macht,
   verliert damit rund 2.000 kWh, die nie in der Gasrechnung standen - und bekommt eine zu
   kleine Heizlast. Vorgabewert bleibt "ja", das ist der haeufige Fall und das bisherige
   Verhalten. */
function renderWwVerbrauch(el){
  /* SIE BLICKT NUR ZURUECK (14.10.2026). Kurzzeitig hat diese Antwort auch A.dhw gesetzt -
     also mitentschieden, ob die Waermepumpe das Warmwasser kuenftig uebernimmt. Clara hat das
     nach dem Hinweis auf den Unterschied zurueckgenommen: "ah jetzt verstehe ich, bitte fueg
     eine Frage hinzu, ob die Waermepumpe dann auch das Warmwasser mitmachen soll."

     ES SIND ZWEI VERSCHIEDENE DINGE, und jetzt stehen sie auch so da: Hier geht es um den
     Zaehlerstand der ALTEN Heizung, im Schritt "ww" um die NEUE Anlage. Wer heute einen
     Durchlauferhitzer hat, kann das Warmwasser trotzdem auf die Waermepumpe legen wollen. */
  optGrid(el,[
    ["ja","Ja, aus derselben Heizung",""],
    ["nein","Nein, Durchlauferhitzer oder Boiler","dann ist es nicht im Verbrauch enthalten"]
  ],v=>{A.wwImVerbrauch=v; renderLedger(); setTimeout(next,200);},'',A.wwImVerbrauch);
}
function renderKamin(el){
  optGrid(el,[
    ["nein","Nein",""],
    ["ja","Ja","die Wärme fehlt sonst in der Rechnung"]
  ],v=>{A.kamin=v; if(v==='nein')A.holzRm=null; renderLedger(); setTimeout(next,200);},'',A.kamin);
}
function renderHolz(el){
  zahlSchritt(el,{feld:'holzRm', ph:'3', aria:'Holzverbrauch in Raummetern je Jahr', dez:true,
    einheit:'Raummeter',
    min:0.5, max:30,
    leer:'Bitte trag ein, wie viele Raummeter du im Jahr verbrennst.',
    ausserhalb:'Bitte einen Wert zwischen 0,5 und 30 Raummetern.'});
}

/* ============================== LEAD ============================== */
/* First-Touch-Attribution: UTM-Parameter & Referrer beim allerersten Besuch einfrieren,
   damit jeder Lead und jede Bestellung ihrer Kampagne zuordenbar bleibt. */
const ATTR=(()=>{try{
  const KEY='bwp_attr', stored=localStorage.getItem(KEY);
  if(stored) return JSON.parse(stored);
  const q=new URLSearchParams(location.search), a={};
  ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','fbclid'].forEach(k=>{const v=q.get(k); if(v)a[k]=v;});
  if(document.referrer && !document.referrer.includes(location.hostname)) a.referrer=document.referrer;
  a.first_visit=new Date().toISOString();
  localStorage.setItem(KEY,JSON.stringify(a));
  return a;
}catch(e){ return {}; }})();
function attrShort(){ return ATTR.utm_source ? ` | src ${ATTR.utm_source}${ATTR.utm_campaign?'/'+ATTR.utm_campaign:''}` : (ATTR.referrer?` | ref ${ATTR.referrer.replace(/^https?:\/\//,'').slice(0,40)}`:''); }
/* Strukturierte Cart-Attributes (Shopify Order "Zusätzliche Details"/note_attributes) zusätzlich
   zum Freitext-Anhang oben - macht die Kampagnen-Zuordnung auswertbar statt nur lesbar (User-Wunsch
   23.07.2026). Nur tatsächlich vorhandene Werte werden mitgeschickt, keine leeren Attribute-Zeilen. */
function attrAttributes(){
  const out={};
  ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','fbclid','referrer','first_visit'].forEach(k=>{
    if(ATTR[k]) out[k]=ATTR[k];
  });
  /* VARIANTE MIT IN DIE BESTELLUNG (26.08.2026, erweitert 27.08.2026). Unsere Ereignisse
     enden beim checkout_start - der Kauf selbst passiert in der Shopify-Kasse, einem anderen
     Kontext, in dem theme_role nicht mehr existiert. Ohne das hier laesst sich ein A/B-Test
     nur auf Sitzungen auswerten, nicht auf echte Bestellungen. Als Bestell-Attribut steht
     die Variante dagegen dauerhaft an der Order - in Shopify, im Export und im CRM.

     Bewusst eine feste Auswahl und nicht der ganze GTM_VARIANTE-Satz: Bestell-Attribute sind
     im Shopify-Admin an jeder Bestellung sichtbar und werden in den Rechnungsablauf gereicht.
     Was dort landet, soll gelesen werden koennen - theme_name und anzahlung_betrag gehoeren
     nicht dazu. test_id und test_variante schon: sie sagen, welcher Test lief und in welchem
     Arm gekauft wurde, und sind damit die einzige Bruecke von der Bestellung zurueck zum Test. */
  if(typeof GTM_VARIANTE==='object' && GTM_VARIANTE){
    ['theme_role','kauf_modus','test_id','test_variante'].forEach(k=>{
      if(GTM_VARIANTE[k]) out[k]=String(GTM_VARIANTE[k]);
    });
  }
  /* DIE BRUECKE ZUM LEAD (27.08.2026). Dieselbe Kennung, die schon am Lead haengt, faehrt
     als Bestell-Attribut mit in die Kasse. Damit trifft sich beides im CRM ueber ein
     eindeutiges Feld statt ueber eine E-Mail-Adresse, die der Kunde an der Kasse auch
     wechseln darf. Siehe leadRef() - hier wird nichts Neues gesetzt, was nicht ohnehin
     schon existiert, sobald jemand bis hierher gekommen ist. */
  out.lead_ref=leadRef();
  /* DER RABATT ALS BESTELL-ATTRIBUT. Einzige Bruecke zur Rechnung: in der Kasse liegt nur die
     Vorbestellung, der Abzug wird erst auf der Schlussrechnung verrechnet. Wer sie schreibt,
     muss an der Bestellung sehen, dass ein Code eingeloest war. Nur wenn wirklich einer greift -
     ein leeres Feld an jeder Bestellung waere Laerm im Admin.
     FESTER BETRAG (28.09.2026): nur, wenn er auf DIESER Bestellung abgeht - unter dem
     Mindestwert ist der Code eingeloest, verrechnet wird aber nichts, und die Rechnungsstelle
     darf dann auch nichts abziehen. Der Betrag kommt aus der Rechnung, die checkout() bzw.
     cartAddDirect() gerade gebucht hat (rabattGebucht), nicht aus einer dritten.
     rabatt_code ist zugleich das Merkmal, an dem sich Bestellungen ueber den Kooperationscode
     zaehlen lassen. */
  const rabattJetzt=rabattWirksam();
  if(rabattJetzt && rabattJetzt.art==='fest'){
    if(rabattGebucht>0){
      out.rabatt_code=rabattJetzt.code;
      out.rabatt_art='fest';
      out.rabatt_betrag=String(rabattGebucht);
    }
  } else if(rabattProzent()>0){
    out.rabatt_code=rabattCode();
    out.rabatt_prozent=String(rabattProzent());
  }
  return out;
}
/* =====================================================================
   VAMO-LEAD-API v1.2.1 - Mapping und Versand
   Ziel: Alles, was der Kunde im Rechner schon beantwortet hat, laeuft automatisch mit.
   Nachgefragt wird ausschliesslich, was der Rechner gar nicht erhebt (siehe VAMO_LUECKEN).
   ===================================================================== */

/* Vamo kennt nur eine geschlossene Werteliste je Feld - freie Strings werden mit 400 abgelehnt.
   Jede Map hier ist deshalb 1:1 aus dem Blueprint abgeschrieben, nicht sinngemaess. */
const VAMO_SYSTEM_TYPE = {
  gas:"Erdgas", oel:"Heizöl", pellets:"Pellet-/Holzheizung", holz:"Pellet-/Holzheizung",
  strom:"Sonstiges", fernwaerme:"Fernwärme", wp:"Wärmepumpe", sonstiges:"Sonstiges"
};
const VAMO_BAUJAHR = {
  nach2016:"nach 2016", y1995_2016:"1995 - 2016", y1980_1994:"1980 - 1994", vor1980:"vor 1980"
};
const VAMO_TYPE_OF_HEATING = { hk:"Heizkörper", fbh:"Fußbodenheizung", mix:"Heizkörper + Fußbodenheizung" };
/* Der Rechner fragt Spannen ab, Vamo will eine Zahl. Bewusst der jeweils UNTERE Randwert:
   lieber untertreiben als eine Genauigkeit vorspiegeln, die die Antwort nicht hergibt. */
const VAMO_RADIATORS = { r8:8, r15:9, r16:16 };
/* Vamo unterscheidet nur ober-/unterhalb 40k. b30 und 30_40 liegen sicher darunter,
   40_50 beginnt exakt auf der Grenze und zaehlt damit als darueber. */
const VAMO_INCOME = {
  b30:"less_than_40k_gross", "30_40":"less_than_40k_gross",
  "40_50":"more_than_40k_gross", "50_60":"more_than_40k_gross", a60:"more_than_40k_gross"
};

/* Vamo akzeptiert als Verbrauchseinheit NUR "Liter (l)" oder "Kilowattstunden (kWh)".
   Der Rechner kennt daneben m3, kg, Tonnen, Raummeter und Hackschnitzel. Alles ausser
   Heizoel wird deshalb ueber die vorhandene HEIZWERT-Tabelle in kWh umgerechnet -
   dieselbe Tabelle, mit der auch die Heizlast gerechnet wird, also kein zweiter Wahrheitsstand. */
function vamoVerbrauch(){
  const wert = A.consumptionValue, einheit = A.unit;
  if(!wert || !einheit || !HEIZWERT[einheit]) return null;
  if(einheit === 'oel_l') return { consumption: Math.round(wert), consumptionUnit: "Liter (l)" };
  return { consumption: Math.round(wert * HEIZWERT[einheit].f), consumptionUnit: "Kilowattstunden (kWh)" };
}

/* Leere Werte muessen RAUS statt als null mitzureisen: Vamo validiert die gelieferten Felder,
   ein null in einem Enum-Feld ist ein Validierungsfehler, ein fehlendes Feld ist erlaubt. */
function vamoClean(obj){
  if(Array.isArray(obj)) return obj;
  const out = {};
  Object.keys(obj).forEach(k=>{
    const v = obj[k];
    if(v === null || v === undefined || v === '') return;
    if(typeof v === 'object' && !Array.isArray(v)){
      const tief = vamoClean(v);
      if(Object.keys(tief).length) out[k] = tief;
      return;
    }
    out[k] = v;
  });
  return out;
}

/* Eigene Lead-ID: Vamo nutzt sie zur Doppelerkennung (409) und wir koennen einen Lead
   im Support-Fall eindeutig benennen, ohne die E-Mail durchzugeben. */
function vamoLeadId(){
  return 'bwp-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2,8);
}

/* Baut den kompletten Request-Body. g = Antworten aus dem Kurzformular (renderVamoGaps). */
function buildVamoLead(cand, g){
  const verbrauch = vamoVerbrauch() || {};
  const adresse = vamoClean({
    street: g.strasse, city: g.ort, postalCode: A.plz || g.plz, countryCode: "DE"
  });
  return vamoClean({
    version: CONFIG.VAMO.VERSION,
    id: g.leadId,
    contact: {
      contactInformation: {
        /* Optional laut Blueprint, aber ohne sie raet Vamos Angebotsschreiben die Anrede. */
        salutation: g.anrede,
        firstName: g.vorname,
        lastName: g.nachname,
        phone: g.telefon,
        email: g.email,
        newsletterSingleOptIn: false,
        digitalAssistanceSingleOptIn: !!g.assistent
      },
      address: adresse
    },
    building: {
      /* Rechnungs- und Gebaeudeadresse sind im DIY-Geschaeft praktisch immer dieselbe -
         der Kunde steht in dem Haus, um das es geht. Deshalb eine Eingabe, zwei Felder. */
      address: adresse,
      buildingInformation: {
        immoType: g.immoType,
        heritageProtection: g.denkmal,
        residentialUnits: g.wohneinheiten,
        livingSpace: g.wohnflaeche,
        boilerRoomSize: g.heizraumFlaeche,
        installationLocationCeilingHeight: g.heizraumHoehe,
        widthPathway: g.wegBreite,
        heightPathway: g.wegHoehe,
        personsHousehold: A.persons
      },
      ownershipRelationships: {
        ownerOccupiedHousing: g.selbstbewohnt === 'ja' ? true : (g.selbstbewohnt === 'nein' ? false : null)
      },
      energyRelevantInformation: {
        heatedArea: g.wohnflaeche,
        typeOfHeating: VAMO_TYPE_OF_HEATING[A.heating],
        locationHeating: g.heizraumEtage
      }
    },
    heatingSystem: {
      systemType: VAMO_SYSTEM_TYPE[A.energy],
      consumption: verbrauch.consumption,
      consumptionUnit: verbrauch.consumptionUnit,
      constructionYearHeatingSystemString: VAMO_BAUJAHR[A.baujahr],
      numberOfRadiators: A.heating === 'fbh' ? null : VAMO_RADIATORS[A.radiators],
      domesticHotWaterByHeatpump: A.dhw === 'ja',
      /* Der Rechner fragt die Zirkulationspumpe nicht ab (A.zirk steht fest auf 'unklar') -
         "unknown" ist hier die ehrliche Antwort, nicht geraten. */
      domesticHotWaterCirculationPump: "unknown"
    },
    project: {
      timeline: g.zeitraum,
      householdIncome: VAMO_INCOME[A.zveChoice] || "no_answer",
      /* Im Fachbetrieb-Pfad baut Vamo die Anlage, also auch das Fundament - ausser der
         Kunde hat im Rechner ausdruecklich gesagt, dass er es selbst macht. */
      statusOfFoundationConstruction: A.fundament === 'selbst' ? "Kunde" : "Vamo",
      fullReplacementOfHeatingSystemPlanned: true,
      infosLeadsource: [
        CONFIG.VAMO.QUELLE,
        cand ? ('Kit-Vorschlag: ' + (PRODUCTS[cand.kit] ? PRODUCTS[cand.kit].name : cand.kit)) : null,
        cand && cand.c && cand.c.pausl ? ('Heizlast lt. Rechner: ' + fmt(cand.c.pausl,1) + ' kW') : null,
        A.sanierung ? ('Sanierungsstand: ' + A.sanierung) : null,
        /* attrShort() liefert bereits mit " | " praefixiert - hier abschneiden, sonst doppelt. */
        (attrShort() || '').replace(/^\s*\|\s*/, '') || null
      ].filter(Boolean).join(' | ')
    }
  });
}

/* Sendet an den Proxy und gibt Vamos Antwort strukturiert zurueck.
   Wirft NIE - der Aufrufer entscheidet anhand von .ok, was der Kunde sieht. */
function submitVamoLead(body){
  if(CONFIG.VAMO.ENDPOINT.startsWith('TBD_')){
    console.warn('[vamo] kein Proxy konfiguriert - Lead waere gewesen:', body);
    return Promise.resolve({ ok:false, grund:'nicht_konfiguriert' });
  }
  return fetch(CONFIG.VAMO.ENDPOINT,{
    method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)
  }).then(res=>res.text().then(text=>{
    let daten = null;
    try{ daten = text ? JSON.parse(text) : null; }catch(e){ /* Vamo antwortet bei 405 mit Klartext */ }
    if(res.status === 201) return { ok:true, status:res.status, daten };
    return { ok:false, status:res.status, daten,
      grund: res.status === 409 ? 'konflikt' : (res.status === 400 ? 'validierung' : 'fehler') };
  })).catch(e=>{ console.error('[vamo]',e); return { ok:false, grund:'netzwerk' }; });
}

/* ============ LEAD-KENNUNG (27.08.2026) ============
   Anfrage und Bestellung liessen sich bisher nur ueber die E-Mail-Adresse zusammenfuehren -
   der Warenkorb trug gar keine Kennung (steht so auch in der Canvas-Notiz des Bestell-
   Workflows). Das geht schief, sobald jemand im Rechner eine andere Adresse eintippt als
   an der Kasse, und genau das passiert oft: privat im Rechner, geschaeftlich beim Bezahlen.
   Dann steht der Lead im CRM und die Bestellung daneben, ohne dass jemand sie verbindet.

   BEWUSST KEINE BESUCHER-ID. Die Kennung entsteht ERST, wenn jemand einen Lead abschickt
   oder in die Kasse geht - also in dem Moment, in dem er ohnehin Daten hinterlaesst und das
   auch weiss. Wer nur liest, bekommt nichts gesetzt und nichts gespeichert. Eine Kennung
   schon beim Seitenaufruf waere ein Wiedererkennungsmerkmal fuer anonyme Besucher und
   braeuchte nach TTDSG eine Einwilligung; diese hier haengt an einer Handlung des Kunden.

   Sie traegt nichts Personenbezogenes - Zeit und Zufall, kurz genug zum Vorlesen am Telefon.

   Ohne localStorage (Privatmodus, gesperrte Speicherung) liefert die Funktion bei jedem
   Aufruf eine neue Kennung. Dann greift wieder die E-Mail-Zuordnung wie bisher - schlechter
   als vorher wird es also nie. */
const LEAD_REF_SCHLUESSEL='bwp_lead_ref';
/* NUR LESEN, NIE ERZEUGEN (portiert 16.09.2026). Der Entscheid ueber leadRef() bleibt
   unangetastet: die Kennung entsteht erst mit einer HANDLUNG des Kunden, weil eine Kennung
   schon beim Seitenaufruf ein Wiedererkennungsmerkmal fuer anonyme Besucher waere und nach
   TTDSG eine Einwilligung braeuchte. Diese Fassung schaut nur nach, ob schon eine da ist.
   In Claras Aufbau wiegt das schwerer als bisher: der Weg fuehrt jetzt ueber MEHRERE
   Seitenaufrufe (Start -> Rechnerseite -> Produktseite), und ohne gemeinsame Kennung zerfaellt
   er in unverbundene Bruchstuecke. */
function leadRefVorhanden(){
  try{ return localStorage.getItem(LEAD_REF_SCHLUESSEL) || null; }catch(e){ return null; }
}
function leadRef(){
  try{
    const vorhanden=localStorage.getItem(LEAD_REF_SCHLUESSEL);
    if(vorhanden) return vorhanden;
  }catch(e){}
  let zufall;
  try{
    const b=new Uint8Array(5); crypto.getRandomValues(b);
    zufall=Array.from(b).map(x=>x.toString(36)).join('').slice(0,6);
  }catch(e){ zufall=Math.random().toString(36).slice(2,8); }
  const ref='bwp-'+Date.now().toString(36)+'-'+zufall;
  try{ localStorage.setItem(LEAD_REF_SCHLUESSEL,ref); }catch(e){}
  return ref;
}
/* ============ EINWILLIGUNG (27.08.2026) ============
   EINE Quelle fuer den Wortlaut. Art. 7 Abs. 1 DSGVO verlangt, dass sich die Einwilligung
   NACHWEISEN laesst - dazu gehoert, WORIN eingewilligt wurde. Stuende der Satz an zwei
   Stellen im Code, liesse sich spaeter nicht mehr sagen, welchen ein bestimmter Kunde
   gesehen hat. Er reist deshalb mit jedem Lead mit, nicht nur der Haken.

   BEWUSST OPTIONAL, an beiden Stellen. Wer nicht anhakt, kommt trotzdem weiter - sonst
   waere es nach Art. 7 Abs. 4 DSGVO (Kopplungsverbot) keine freiwillige Einwilligung und
   damit gar keine. */
/* Nutzen statt Erlaubnis (27.08.2026). Die erste Fassung lautete "Ihr duerft mich zu meiner
   Konfiguration beraten" - grammatikalisch eine Erlaubnis, die der Kunde erteilt, ohne dass
   dabeisteht, was er davon hat. In der ersten Stunde nach dem Scharfschalten hakte 1 von 16
   an. Die Einwilligung bleibt genauso spezifisch und unmissverstaendlich - sie sagt jetzt nur
   zusaetzlich, wofuer. Das ist erlaubt und aendert nichts an ihrer Wirksamkeit; unzulaessig
   waere das Gegenteil, also Verschleiern oder Vorbelegen. */
/* WORTLAUT GEAENDERT AM 02.09.2026 (Alignment-Entscheid, Meeting-Punkt h).
   Vorher stand hier woertlich:
     'Ja, meldet euch bei mir – per Mail oder Telefon –, wenn ihr seht, dass in meiner
      Konfiguration etwas fehlt.'
   Der Satz hat uns eine Pruefpflicht aufgeladen, die wir gar nicht erfuellen koennen: er
   liest sich als Zusage, jede Konfiguration durchzusehen und uns nur dann zu melden, wenn
   etwas fehlt. Umgekehrt hiess Schweigen fuer den Kunden 'alles in Ordnung' - und es fehlt
   praktisch immer etwas, weil Rohre und Kleinteile ohnehin selbst zu besorgen sind.
   Der neue Satz holt eine Kontakterlaubnis ein und verspricht keine Pruefung.
   ALTBESTAND BLEIBT UNTERSCHEIDBAR: der Wortlaut reist als einwilligung_text an jedem Lead
   mit. Bestandsleads tragen weiterhin den alten Satz, neue den neuen - im CRM ist damit
   ohne Zusatzfeld erkennbar, worauf jemand zugestimmt hat (Art. 7 Abs. 1 DSGVO).
   RECHTLICH GEGENLESEN LASSEN. */
const EINWILLIGUNG_TEXT='Ja, ihr dürft mich zu meiner Konfiguration kontaktieren – per E-Mail oder Telefon.';
/* WERBE-EINWILLIGUNG - GETRENNT, NICHT MITBENUTZT (02.09.2026, Meeting-Punkt i).
   Bewusst eine eigene Konstante und ein eigenes Haekchen. Die Einwilligung oben deckt
   Rueckfragen zur Konfiguration ab, nicht Werbung; wer beides in einen Haken packt, hat
   fuer keinen der zwei Zwecke eine belastbare Zustimmung. Der Satz nennt den Werbezweck
   deshalb ausdruecklich und ist nicht als Serviceversprechen formulierbar.
   OHNE GEGENSTELLE SAMMELT DAS NUR ZUSTIMMUNGEN, DIE NIRGENDS ANKOMMEN: n8n muss
   werbung_ok/werbung_text/werbung_ts entgegennehmen, ein CRM-Feld fuellen und einen
   Abmeldeweg bereitstellen. RECHTLICH GEGENLESEN LASSEN. */
const WERBUNG_TEXT='Ja, ihr dürft mir gelegentlich Angebote, Praxisberichte und Neuigkeiten rund um den Selbsteinbau per E-Mail schicken. Abmeldung jederzeit.';

function leadPayload(extra={}){
  const r=routeAll();
  /* Bivalenzpunkte aller Kits mitschicken - unabhaengig davon, welche Regel gerade die Anzeige
     bestimmt. Damit laesst sich an echten Leads nachrechnen, wie die Bivalenz-Auslegung
     entschieden HAETTE, bevor sie scharfgeschaltet wird. */
  const biv={};
  (r.candidates||[]).forEach(x=>{ if(x.tbiv!=null) biv[x.kit]={tbiv:x.tbiv,heizstab_pct:x.heizstabPct,tg_geschaetzt:!!x.tgGeschaetzt,score:x.bivScore,im_fenster:x.imFenster}; });
  /* WELCHES PAKET GILT (27.08.2026). Der E-Mail-Riegel reicht sein Vorschlagspaket ueber
     extra herein - zu dem Zeitpunkt hat der Kunde noch nichts angeklickt, paketSchnappschuss()
     lieferte also null. Vorher gewann das ueber ...extra am Ende zwar trotzdem, aber das
     Routing-Etikett darunter hat den falschen Stand gelesen. Jetzt eine Zeile, beide Wege. */
  const paket = (extra.paket !== undefined) ? extra.paket : paketSchnappschuss();
  /* ROUTING-ETIKETT (27.08.2026). Vorher stand hier r.recommended||'waitlist' - und das war
     an echten Leads nachweislich falsch. Liegt kein Kit im Bivalenzfenster [-8,-2], bleibt
     recommended absichtlich null (siehe dimPruefen weiter oben): der Rechner gibt dann KEIN
     Siegel aus. Der Kunde bekommt aber sehr wohl ein vollstaendiges, bepreistes Paket samt
     Kauflink - vorschlagsPaket() sorgt genau dafuer.
     Gemessen am 27.08.2026: 49 von 113 Personen standen im CRM auf "waitlist", obwohl sie
     ein Angebot in der Hand hatten. Beispiel Ausfuehrung 13848 - routing "waitlist", im
     selben Datensatz fox8 fuer 13.383 EUR mit Kauflink.
     "waitlist" heisst ab jetzt wieder, was es sagen soll: es gibt gar nichts anzubieten.
     Fehlt nur das Siegel, steht das Kit da, das der Kunde tatsaechlich gesehen hat -
     dim_pruefen daneben sagt weiterhin, dass es keine formale Empfehlung war. */
  const routing = r.recommended || (paket && paket.kit) || 'waitlist';
  return {ts:new Date().toISOString(),...A,heizlast_kw:r.c&&r.c.pausl||null,routing,
    auswahlregel:CONFIG.RULES.AUSWAHL, bivalenz:Object.keys(biv).length?biv:null, dim_pruefen:!!r.dimPruefen,
    heizstab_zu_hoch:!!r.heizstabZuHoch, heizstab_min_pct:r.heizstabMinPct!=null?r.heizstabMinPct:null,
    empfehlung_formal:!!r.recommended,
    mode:CONFIG.MODE,attribution:ATTR,lead_ref:leadRef(),paket,...extra};
}
/* =====================================================================
   PAKET-SCHNAPPSCHUSS (User-Entscheid 10.08.2026)
   Bis hierher trug ein Lead nur die Antworten und das gewaehlte Kit - nicht, WAS im Paket
   steckte. Bei einer Preis-Absage liess sich dadurch nicht nachrechnen, woraus die Summe
   entstand; die Services standen ausschliesslich in den Shopify-Eigenschaften, also erst
   ab dem Checkout. Konkreter Fall: ein Kunde mit vorhandener Waermepumpe hatte 4.787 EUR
   Hydraulik im Paket, die er laengst besitzt - sichtbar war das nirgends.

   Faengt beide Kaufwege ab: im Rechner zaehlen chosenServices/chosenExtras, im Direktkauf-
   Dialog directServices. Ist noch nichts gewaehlt (z. B. Chat vor der Kit-Wahl), kommt null
   zurueck statt eines leeren Geruests. */
function paketSchnappschuss(){
  const imDirekt = typeof directCand!=='undefined' && directCand;
  const kitKey = imDirekt ? directCand : (chosenCandidate ? chosenCandidate.kit : null);
  if(!kitKey || !PRODUCTS[kitKey]) return null;
  const svcSet = imDirekt ? directServices : chosenServices;
  const services=[];
  (svcSet||new Set()).forEach(k=>{ if(SERVICES[k]) services.push({k, name:SERVICES[k].name, preis:SERVICES[k].price}); });
  const extras=[];
  Object.entries(chosenExtras||{}).forEach(([k,menge])=>{
    if(!EXTRAS[k]) return;
    extras.push({k, name:EXTRAS[k].name, gruppe:EXTRAS[k].group, menge, preis:EXTRAS[k].price*menge});
  });
  const spKey=speicher();
  let summe=PRODUCTS[kitKey].price + (spKey?PRODUCTS[spKey].price:0);
  services.forEach(x=>summe+=x.preis);
  extras.forEach(x=>summe+=x.preis);
  /* RABATT VOR DER FOERDERUNG (portiert 16.09.2026). Der Abzug senkt summe, und ALLES
     darunter - Zuschuss, gesamt_mit_lieferung, nach_foerderung, Restzahlung, Kauflink -
     rechnet damit von selbst richtig weiter.
     DAS IST ZUGLEICH DIE HAELFTE DER PREISDRIFT-PRUEFUNG: direktZurKasse() vergleicht den Wert
     gs aus dem Kauflink EXAKT gegen gesamt_mit_lieferung. Wirkt der Rabatt hier und nicht auch
     beim Wiederherstellen, bricht die Durchreiche in die Kasse STILL ab.
     Die Foerderbasis sinkt bewusst mit: sonst zeigte die Seite eine Foerderung auf Kosten, die
     nie entstanden sind, und "Preis nach Foerderung" koennte ueber dem Gesamtpreis liegen. */
  const rabattBrutto=summe;
  const rabBetrag=rabattBetrag(rabattBrutto);
  const rabProzent=rabattProzent();
  summe = summe - rabBetrag;
  const quote=foerderQuote(kitKey)||0;
  const zuschuss=quote?Math.round(Math.min(summe,foerderKostenCap())*quote/100):0;
  const eigen = typeof eigenleistungSumme==='function' ? eigenleistungSumme() : 0;
  return {
    kit:kitKey, kit_preis:PRODUCTS[kitKey].price,
    /* Die Anzeigenamen reisen mit, seit der Schnappschuss auch eine Mail AN DEN KUNDEN
       speist (18.08.2026). Ohne sie stuende dort "fox8" statt "DIY-Kit 8 kW", und n8n
       muesste die Produkttabelle nachbauen - eine zweite Wahrheit, die garantiert driftet. */
    kit_name:PRODUCTS[kitKey].name,
    summe_vor_rabatt:rabattBrutto, rabatt_prozent:rabProzent, rabatt_betrag:rabBetrag,
    rabatt_code:rabBetrag>0?rabattCode():null,
    speicher:spKey, speicher_preis:spKey?PRODUCTS[spKey].price:0,
    speicher_name:spKey?PRODUCTS[spKey].name:null,
    services, services_summe:services.reduce((a,x)=>a+x.preis,0),
    extras, extras_summe:extras.reduce((a,x)=>a+x.preis,0),
    eigenleistung:eigen,
    lieferung:'Lieferung', liefergebuehr:deliveryFee(),
    /* Der Wunschstart reist auch in die Mail: Wer sich auf einen Kunden zurueckmeldet, soll
       nicht erst in der Bestellung nachsehen muessen, wann der starten wollte. Roh als
       JJJJ-MM-TT fuer die Weiterverarbeitung, daneben die lesbare Fassung fuer den Text. */
    start_wunsch: A.startWunsch || null,
    start_wunsch_woche: A.startWoche || null,
    start_wunsch_tag: A.startDatum || null,
    start_wunsch_monat: A.startMonat || null,
    start_wunsch_text: startWunschText() || null,
    summe, gesamt_mit_lieferung:summe+deliveryFee(),
    foerder_quote:quote, foerder_betrag:zuschuss, nach_foerderung:summe-zuschuss,
    anzahlung:PRODUCTS.deposit.price, restzahlung:Math.max(0,summe+deliveryFee()-PRODUCTS.deposit.price),
    /* ABSCHLUSS-HINWEIS MIT IN DIE MAIL (27.08.2026). Die Frist reist im Schnappschuss
       mit, statt in n8n ein zweites Mal getippt zu werden - dieselbe Ueberlegung wie bei
       den Anzeigenamen darueber. Waere sie dort hinterlegt, muesste sie jemand an zwei
       Stellen aendern, und die Mail wuerde nach dem Abschalten des Hinweises auf der
       Seite noch tagelang eine abgelaufene Frist versprechen. So endet beides zugleich:
       ist der Hinweis auf der Seite weg, ist dieses Feld null und die Mail laesst ihn weg. */
    closer: (typeof CLOSER!=='undefined' && CLOSER) ? {
      frist:CLOSER.frist, datum:CLOSER.datum, tage:CLOSER.tage,
      /* Entscheidet in der Mail, ob ueberhaupt ein Enddatum genannt wird - dieselbe
         Trennung wie auf der Seite. Ohne dieses Feld wuerde die Mail aus einem blossen
         Textwechsel eine Frist machen. */
      frist_echt:CLOSER.frist_echt,
      titel:CLOSER.titel, zusatz:CLOSER.zusatz
    } : null,
    /* DIREKTER KAUFLINK FUER DIE KONFIGURATIONS-MAIL (18.08.2026)
       Der Kunde soll aus der Mail heraus kaufen koennen, ohne den Rechner nochmal zu
       durchlaufen - notfalls von einem anderen Geraet, wo sein gespeicherter Stand fehlt.
       Shopify-Warenkorb-Permalink: Variante + Menge, dazu die Konfiguration als note.
       Die note traegt dieselbe Zeile, die auch beim Kauf auf der Seite an die Bestellung
       geht - das Team sieht also dasselbe.
       BEWUSST die deposit-Variante: kaufmodusAnwenden() hat sie im A/B-Test ggf. schon
       gegen die kostenfreie Vorbestellung getauscht, der Link folgt damit automatisch
       der Variante, die der Kunde auch auf der Seite gesehen haette.
       EINSCHRAENKUNG, die man kennen muss: ein Permalink kann keine Positions-Eigenschaften
       setzen (das geht nur ueber /cart/add.js im Browser). Die Einzelposten stehen deshalb
       nur in der note, nicht als aufgeschluesselte Zeilen wie beim Kauf auf der Seite. */
    kauf_link: (function(){
      const v=PRODUCTS.deposit && PRODUCTS.deposit.variantId;
      if(!v || String(v).startsWith('TBD_')) return null;
      const teile=[];
      teile.push(PRODUCTS[kitKey].name);
      if(spKey) teile.push(PRODUCTS[spKey].name);
      services.forEach(x=>teile.push(x.name));
      extras.forEach(x=>teile.push(x.name+(x.menge>1?' x'+x.menge:'')));
      const note='Aus der Konfigurations-Mail: '+teile.join(' | ')
        +' | Lieferung'
        +(A.plz?' | PLZ '+A.plz:'')
        +' | Paket '+eur(summe);
      const tok=kaufToken(summe+deliveryFee());
      /* &kasse=1: nicht nur wiederherstellen, sondern durchreichen bis in die Kasse.
         Ohne Token bleibt nur der alte Permalink - der kann das nicht und faehrt
         deshalb auch nicht so. */
      return tok ? 'https://billigerwaermepumpe.de/?k='+tok+'&kasse=1'
                 : 'https://billigerwaermepumpe.de/cart/'+v+':1?note='+encodeURIComponent(note);
    })(),
    /* Eine Zeile zum Vorlesen am Telefon, damit niemand die Liste erst zusammensuchen muss. */
    kurz: PRODUCTS[kitKey].name
      + (spKey?' + '+PRODUCTS[spKey].name:'')
      + (services.length?' + '+services.length+' Services':'')
      + (extras.length?' + '+extras.length+' Material-Positionen':'')
      + ' = ' + eur(summe)
  };
}
/* Liefert ein Promise<boolean>: true nur, wenn der Lead nachweislich rausging.
   Der Webhook antwortet erst nach dem Mailversand, ein true ist also belastbar.
   false heisst: nicht zugestellt - der Aufrufer muss dann einen echten Ausweg zeigen
   (vorbereitete Mail, Telefon), nie eine Erfolgsmeldung.
   Faellt LEAD_ENDPOINT je wieder auf TBD zurueck, wird nur lokal geloggt - siehe unten. */
function submitLead(stage,extra={}){
  const payload=leadPayload({stage,...extra});
  /* Ziel nach Art der Nachricht, nicht nach Aufrufer: die Newsletter-Anmeldung geht an ihren
     eigenen Fluss, alles andere an den Lead-Fluss. Siehe RABATT_ENDPOINT. */
  const rb=String(CONFIG.RABATT_ENDPOINT||"");
  const ziel = (stage==="rabatt_anmeldung" && rb && !rb.startsWith("TBD_"))
    ? rb : CONFIG.LEAD_ENDPOINT;
  if(!ziel.startsWith("TBD_")){
    return fetch(ziel,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(payload)})
      .then(r=>r.ok).catch(e=>{console.error("[lead]",e);return false;});
  }
  /* Kein Webhook = kein automatischer Versand. Frueher stand hier ein fetch auf Shopifys
     /contact. Das konnte nie funktionieren und hat den Fehler nur verdeckt (Messung 30.07.2026):
       - fetch("/contact")  -> 403, Cloudflare-Challenge
       - echtes Formular    -> 400 "Missing CAPTCHA token"
     Shopify haengt den Spamschutz-Token nur ueber sein eigenes Skript an, und das wird auf
     unserem Layout gar nicht ausgeliefert. Ergebnis war ein stiller Totalausfall: die
     Oberflaeche meldete Erfolg oder wich auf mailto aus, angekommen ist nie etwas.
     Jetzt ehrlich: ohne LEAD_ENDPOINT meldet die Funktion sauber false, und die Oberflaeche
     zeigt die Wege, die wirklich funktionieren (vorbereitete Mail, Telefon).
     Der Endpunkt selbst liegt fertig in vamo-lead-proxy/worker.js - er muss nur deployt und
     hier eingetragen werden. */
  console.warn("[lead] kein LEAD_ENDPOINT gesetzt - Nachricht wird nicht automatisch zugestellt:",payload);
  return Promise.resolve(false);
}

/* ============================== ERGEBNIS - sofort, ohne E-Mail-Gate ============================== */
/* Förder-relevante Zusatzinfo direkt an der Kaufentscheidung (Checkout), nicht nur weiter unten im
   Wissens-Bereich (siehe DEEP-Array in renderServiceDeep). Bewusst redundant zu DEEP: kurze, auf den
   Punkt gebrachte "Warum"-Sätze statt der ausführlichen Was/Wann/Warum-Spalten, damit die Checkbox-Liste
   nicht überladen wirkt. FOERDER_CRITICAL = Services, ohne die laut KfW 458 keine Auszahlung möglich ist;
   nur diese lösen die Risiko-Warnung aus (zs/oel_k5 sind Rechtspflicht bzw. Sonderfall, aber keine
   Förder-Voraussetzung, deshalb bewusst nicht in der Warnung). */
/* Ein Satz, eine Quelle: die Heizlast-Aussage steht an mehreren Stellen im UI und darf
   nirgends abweichen. Kernunterscheidung - die BERECHNUNG ist Foerdervoraussetzung, der
   SERVICE nicht: nach DIN EN 12831 darf sie auch selbst erstellt werden. */
const HLB_HINWEIS = "Die raumweise Heizlastberechnung nach DIN EN 12831 ist Voraussetzung für die Förderung (Grundlage des hydraulischen Abgleichs nach Verfahren B). Du darfst sie auch selbst erstellen - dann brauchst du diesen Service nicht.";
const HLB_KURZ = "Pflicht für die Förderung. Erfassen und rechnen darfst du selbst - die fertige Berechnung muss aber in die Nachweisdokumentation deines Fachbetriebs eingehen.";

const SERVICE_FOERDER_INFO={
  foerder:{pflicht:"Pflicht für Förderung", warum:"Ohne Bestätigung zum Antrag (BzA) vor Baubeginn verfällt der Zuschuss komplett. Die Heizlastberechnung ist hier NICHT enthalten - sie ist trotzdem Fördervoraussetzung und kommt entweder aus der Technischen Planung oder von dir selbst."},
  ibn:    {pflicht:"Pflicht für Förderung", warum:"Ohne Bestätigung nach Durchführung (BnD) + Fachunternehmererklärung gibt's keine Auszahlung."},
  hydS:   {pflicht:"Pflicht für Förderung", warum:"Hydraulischer Abgleich (Verfahren B) ist Pflicht; das VdZ-Formular darf nur der Fachhandwerker ausfüllen. Umsetzen kannst du ihn auf zwei Wegen: mit unserem EQ3-System, das die Heizkreise elektronisch einregelt, oder indem du die Thermostatventile selbst gegen voreinstellbare tauschst."},
  hydM:   {pflicht:"Pflicht für Förderung", warum:"Hydraulischer Abgleich (Verfahren B) ist Pflicht; das VdZ-Formular darf nur der Fachhandwerker ausfüllen. Umsetzen kannst du ihn auf zwei Wegen: mit unserem EQ3-System, das die Heizkreise elektronisch einregelt, oder indem du die Thermostatventile selbst gegen voreinstellbare tauschst."},
  hydL:   {pflicht:"Pflicht für Förderung", warum:"Hydraulischer Abgleich (Verfahren B) ist Pflicht; das VdZ-Formular darf nur der Fachhandwerker ausfüllen. Umsetzen kannst du ihn auf zwei Wegen: mit unserem EQ3-System, das die Heizkreise elektronisch einregelt, oder indem du die Thermostatventile selbst gegen voreinstellbare tauschst."},
  vot:    {pflicht:"Pflicht für Förderung", warum:"Enthält den Vor-Ort-Termin und die raumweise Heizlastberechnung nach DIN EN 12831 - die Grundlage für den hydraulischen Abgleich nach Verfahren B. Deshalb ist der Service vorausgewählt. "+HLB_KURZ},
  zs:     {pflicht:"Gesetzlich vorgeschrieben", warum:"Nur durch einen eingetragenen Elektro-Fachbetrieb erlaubt, unabhängig von der Förderung."},
  oel_ku_le:{pflicht:"Nur bei Ölheizung", warum:"Alttanks dürfen nicht einfach stillgelegt werden; der Entsorgungsnachweis gehört in deine Unterlagen. Festpreis für Ausbau, Reinigung und zertifizierte Entsorgung."},
  oel_ku_gt:{pflicht:"Nur bei Ölheizung", warum:"Alttanks dürfen nicht einfach stillgelegt werden; der Entsorgungsnachweis gehört in deine Unterlagen. Festpreis für Ausbau, Reinigung und zertifizierte Entsorgung."},
  oel_st_le:{pflicht:"Nur bei Ölheizung", warum:"Alttanks dürfen nicht einfach stillgelegt werden; der Entsorgungsnachweis gehört in deine Unterlagen. Festpreis für Ausbau, Reinigung und zertifizierte Entsorgung."},
  oel_st_gt:{pflicht:"Nur bei Ölheizung", warum:"Alttanks dürfen nicht einfach stillgelegt werden; der Entsorgungsnachweis gehört in deine Unterlagen. Festpreis für Ausbau, Reinigung und zertifizierte Entsorgung."},
  netz:   {pflicht:"Fachbetrieb vorgeschrieben", warum:"Die Anmeldung beim Netzbetreiber muss ein eingetragener Elektrofachbetrieb ausführen oder abnehmen - genau wie den Anschluss am Zählerkasten. Wir übernehmen den Papierkram und die Abnahme."},
  baub:   {pflicht:"Optional", warum:"2 Stunden Video-Support durch unsere Techniker inklusive; danach flexibel in 10-Minuten-Blöcken (9,99 €) dazubuchbar."}
};
/* hydS/M/L raus aus der Warnung: nicht mehr kaufbar (buyable:false) - eine Warnung über einen
   nicht buchbaren Service wäre unauflösbar. Inhaltlich bleibt der Abgleich KfW-Pflicht (Förderung-Tab). */
/* vot ist seit 29.07.2026 dabei: die enthaltene raumweise Heizlastberechnung nach
   DIN EN 12831 ist Voraussetzung fuer den Verfahren-B-Abgleich und damit fuer die
   Auszahlung. Anders als foerder und ibn darf der Kunde sie aber SELBST erbringen -
   diesen Unterschied traegt hlbBlockHtml(), nicht die generische Warnung. */
const FOERDER_CRITICAL=['foerder','ibn','vot'];
/* EINTEILUNG DER SERVICES (Vorgabe 15.09.2026): drei Gruppen statt einer Liste.

   "Pflicht fuer die Foerderung" ergibt sich aus FOERDER_CRITICAL - ohne diese drei zahlt die
   KfW nicht aus. Was hier NICHT steht, gilt als freiwillig; die mittlere Gruppe wird von Hand
   gepflegt, weil sie eine rechtliche Aussage trifft und keine technische.

   ZU PRUEFEN: Die Zuordnung unten ist mein Vorschlag, nicht bestaetigt. Angemeldet werden muss
   die Waermepumpe beim Netzbetreiber, und ein stillgelegter Oeltank muss fachgerecht entsorgt
   werden - beides steht im Gesetz. Der Elektroanschluss gehoert in der Sache dazu (Arbeiten an
   der Hausinstallation darf nur eine eingetragene Fachkraft ausfuehren), heisst aber nicht,
   dass er bei UNS gekauft werden muss. Wer das anders sieht, aendert diese eine Tabelle. */
const SERVICE_KATEGORIE = {
  /* BERICHTIGT 15.09.2026 nach Ruecksprache: Nur der Elektroanschluss ist vorgeschrieben -
     Arbeiten an der Hausinstallation darf ausschliesslich eine eingetragene Fachkraft
     ausfuehren. Netzmanagement und Oeltank-Entsorgung standen hier als meine Annahme und zur
     Bestaetigung; die Antwort ist nein. Sie gelten damit als freiwillig.
     Dieselbe Einteilung steht in renderServiceDeep (GESETZLICH) fuer den Foerderung-Reiter. */
  zs:'gesetz'
};
/* LEISTUNGEN, DIE NICHT ANGEKLICKT WERDEN (30.09.2026, Vorgabe Claras: "in der Konfiguration
   bei Services bitte 'Förderantrag (bis 80 % Zuschuss)' als anklickbares Produkt entfernen.
   Setze stattdessen unter den Titel 'Pflicht für Förderung' eine kurze Beschreibung").

   Der Foerderantrag kostet 0 EUR und ist vorausgewaehlt - eine Zeile mit Haken, die man nicht
   abwaehlen soll und die nichts kostet, sieht aus wie eine Wahl und ist keine. Der Satz unter
   der Gruppenueberschrift sagt dasselbe in einem Zug.

   DER SERVICE BLEIBT IN SERVICES UND IN chosenServices: Er ist Teil der Bestellung, steht in
   FOERDER_CRITICAL und traegt eine echte Varianten-ID. Verschwindet er aus den Daten, faellt
   er auch aus dem Warenkorb - und damit aus dem, was tatsaechlich beauftragt wird. Er
   verschwindet nur aus der Liste zum Anklicken.

   NICHT buyable:false: Das bedeutet in dieser Datei "gibt es nicht mehr zu kaufen" (die alten
   Abgleich-Pakete) und schliesst den Service auch aus der Foerder-Warnung aus. Hier geht es um
   die Darstellung, nicht um die Verfuegbarkeit - deshalb eine eigene Karte. */
const SERVICE_INKLUSIVE = {
  foerder: 'Förderantrag (bis 80 % Zuschuss) ist inklusive und muss nicht extra dazugebucht werden.'
};

const SERVICE_GRUPPEN = [
  ['foerder','Pflicht für die Förderung'],
  ['gesetz','Gesetzlich vorgeschrieben'],
  ['frei',   'Freiwillig']
];
/* Welche Materialgruppe welchen Erklaertext bekommt. Ueber den ANZEIGENAMEN und nicht ueber
   einen eigenen Schluessel: Die Gruppe entsteht in EXTRAS aus genau diesem Namen, ein zweiter
   Schluessel waere eine zweite Wahrheit ueber dieselbe Sache. */
const GRUPPEN_INFO = {
  'Hauseinführung':'info_gruppe_haus',
  'Pumpengruppen':'info_gruppe_pumpe',
  'Warmwasserspeicher':'info_gruppe_speicher',
  'Hydraulischer Abgleich':'info_gruppe_abgleich',
  'Befüllung':'info_gruppe_fuellen'
};
function gruppenInfoHtml(name){
  const k=GRUPPEN_INFO[name]; if(!k) return '';
  return `<button type="button" class="kb-info" data-key="${k}" aria-label="Warum ${esc(name)} jetzt zu entscheiden ist">ⓘ</button>`;
}
/* INFO-KNOPF AN JEDEM PRODUKTPAKET (Vorgabe 24.09.2026: "hinter jedem einzelnen Produktpaket
   ein kleines i, das ein Pop-up wird - kurze Beschreibung und Bildchen").

   KEIN NEUES POP-UP: Die Blase gibt es seit dem 29.07.2026 (openBauteilBlase), sie zeigt
   genau das - Bild, Beschreibung, Montage, technische Daten und die Stueckliste. Sie haengt
   an .kb-info[data-key] und wird von einem Klick-Horcher am Dokument bedient; ein zweiter
   Mechanismus daneben waere ein zweites Aussehen und ein zweites Verhalten.

   DER SCHLUESSEL IST DAS PAKET, nicht der EXTRAS-Schluessel: bauteilInhaltHtml() sucht im
   Bauteil-Katalog, und der kennt die p-Nummern. Pakete ohne Katalogeintrag fallen dort auf
   extraEssenzHtml() zurueck - die Blase bleibt also nie leer.

   DIE RASTERSPALTE DAFUER GIBT ES SCHON. .buyline.xrow hat fuenf Spalten, die letzte ist
   26px breit und war fuer genau diesen Knopf vorgesehen ("seit jede Zeile einen hat", steht
   im Stylesheet). Sie stand bisher leer. */
/* PREIS EINER MENGEN-ZEILE (Vorgabe 24.09.2026: "wenn mehr als 1 ausgewaehlt ist, noch den
   Stueckpreis dazuschreiben").

   ERST AB ZWEI. Bei einem Stueck ist der Einzelpreis dieselbe Zahl wie die Summe - sie ein
   zweites Mal darunterzuschreiben erklaert nichts und macht die Zeile nur hoeher.

   Der Einzelpreis steht zurueckgenommen unter der Summe, nicht daneben: Rechts steht sonst
   zweimal Fettes, und welche der beiden Zahlen in die Gesamtsumme eingeht, waere nicht mehr
   auf einen Blick klar. */
function mengenPreisHtml(q,e,ohneEinzel){
  if(!(q>0)) return '';
  const gesamt='+ '+eur(q*e.price);
  /* ohneEinzel: kein "38 € je Meter" unter der Summe (30.09.2026, Vorgabe Claras: "bei den
     Bauteilen kannst du den Preis je Stueck oder je Meter weglassen").

     NUR AUF DER BAUTEILE-SEITE. Im Konfigurator bleibt die Zeile stehen - sie ist dort am
     24.09.2026 auf Claras eigene Vorgabe hinzugekommen ("wenn mehr als 1 ausgewaehlt ist,
     noch den Einzelpreis"). Dort stehen die Pakete untereinander und werden verglichen; auf
     der Bauteile-Seite steht der Regler allein in seiner Kachel, unter einem Paketpreis, der
     ohnehin schon dasteht. */
  /* BEI METERWARE STEHT DIE EINHEIT IMMER DA, auch bei einem einzigen Meter (02.10.2026,
     Vorgabe Claras: "Erdleitung pro Meter auch im Konfigurator ergaenzen").

     DIE SCHWELLE VON ZWEI STUECK STAMMT VOM 24.09.2026 ("wenn mehr als 1 ausgewaehlt ist, noch
     den Einzelpreis") und hat ihren guten Grund: Bei einem Stueck ist der Einzelpreis die
     Summe, und beides untereinander zu schreiben sagt zweimal dasselbe.

     BEI METERN IST DAS ANDERS. "+ 95,00 EUR" ohne Zusatz liest sich wie der Preis der Leitung,
     nicht wie der eines Meters - und es sind beides verschiedene Zahlen, sobald jemand den
     Regler bewegt. Die Zeile sagt hier also nicht dasselbe noch einmal, sondern etwas, das sonst
     fehlt. Bei Stueckware bleibt die Schwelle, wie sie war.

     "pro Meter" UND NICHT "je Meter": dieselbe Formulierung wie auf der Bauteile-Kachel, die
     Clara am selben Tag vorgegeben hat. Zwei Woerter fuer dieselbe Sache auf zwei Seiten waeren
     genau die Sorte Unterschied, die spaeter niemand mehr erklaeren kann. */
  if(ohneEinzel) return gesamt;
  if(q<2 && !e.perMeter) return gesamt;
  /* DER EINZELPREIS STEHT VOR DER SUMME (12.10.2026, Vorgabe Claras: "wenn beim Stueckregler
     oder Meterregler mehr als 1 ausgewaehlt wird, davor dann den Stueckpreis anzeigen").

     Bis heute stand er darunter. Vorangestellt liest sich die Spalte als Rechnung von oben
     nach unten - erst der Preis je Stueck, dann was daraus wird. Die Summe bleibt die fette
     Mono-Zahl: Sie ist die, die in die Gesamtsumme eingeht. */
  return `<span class="xr-einzel">${eur(e.price)} ${e.perMeter?'pro Meter':'je Stück'}</span>${gesamt}`;
}
function paketInfoHtml(e){
  if(!e || !e.paket) return '';
  return `<button type="button" class="kb-info xr-info" data-key="${e.paket}" aria-label="Was steckt in ${esc(e.name)}?">ⓘ</button>`;
}
/* WEG ZUR PAKETSEITE, direkt aus dem Konfigurator (30.09.2026, Vorgabe Claras: "neben jedes
   Produktpaket ein kleines Info-i machen oder eine Verlinkung, mit der man auf die
   Produktpaketseite kommt, wo mit den aufklappbaren Erklaerungen alle Inhalte erklaert
   werden").

   NEBEN DAS ⓘ UND NICHT AN SEINE STELLE: Die beiden tun Verschiedenes. Das ⓘ oeffnet die
   Blase - man bleibt im Konfigurator und verliert die angefangene Auswahl nicht. Der Pfeil
   fuehrt auf die Paketseite, wo jede Position ihre eigene Beschreibung und ihr Datenblatt
   hat. Wer nur nachsehen will, was drin ist, soll die Seite nicht verlassen muessen.

   ↗ UND NICHT NOCH EIN BUCHSTABE: Das Zeichen sagt "fuehrt woandershin", und genau das ist
   der Unterschied zum ⓘ daneben.

   OHNE DIE KLASSE kb-info (berichtigt 30.09.2026): Er trug sie zuerst, um dasselbe Aussehen zu
   bekommen - und war damit tot. Der Klick-Horcher am Dokument fasst jedes .kb-info ab und ruft
   preventDefault(); der Browser kam nie dazu, dem Verweis zu folgen. Das Aussehen kommt jetzt
   aus dem Stylesheet, wo .xr-seite neben .kb-info steht. */
/* WANN ES KOMMT (30.09.2026, Vorgabe Claras: "in der Konfiguration bei Lieferung bitte einen
   Hinweis hinzufuegen, der sagt 'Die Lieferung erfolgt ab 5 Wochen nach dem
   Bestellen'").

   EINE KONSTANTE UND ZWEI EINBAUSTELLEN: Die Wahl zwischen Abholung und Lieferung gibt es
   zweimal - in der Kaufbox der Kit-Seite und im Warenkorb-Dialog. Denselben Satz zweimal zu
   tippen heisst, ihn beim naechsten Mal einmal zu aendern.

   AB FUENF WOCHEN, nicht "in fuenf Wochen": Claras Wortlaut nennt eine Untergrenze, keinen
   Termin. Der Satz steht deshalb genau so da. */
const LIEFER_HINWEIS = 'Die Lieferung erfolgt ab 5 Wochen nach dem Bestellen.';
/* ===== WUNSCHSTART (13.10.2026) ==============================================
   Vorgabe Claras: "unter Abholung oder Lieferung noch ein Kalender ... soll gar nicht ein
   konkreter Tag ausgewaehlt werden, sondern mehr eine Woche. Es kann aber auch sein, dass
   jemand noch gar keine Ahnung hat, oder nur grob sagen kann 'in den naechsten 3 Monaten'."

   DIE AUSWAHL, DIE WOCHENRECHNUNG UND DER KALENDER STEHEN IN bwp-startwunsch.js. Hier blieben
   nur die beiden Zeilen, die den Zustand des Konfigurators damit verbinden - siehe weiter
   unten bei startZustand(). Der Umzug war noetig, weil die Warenkorbseite dieselbe Frage
   stellt und konfigurator.js dort nicht geladen wird.
   ============================================================================= */

/* ===== WUNSCHSTART - DIE OBERFLAECHE LIEGT IN bwp-startwunsch.js (13.10.2026) =====
   HIER STAND DER KALENDER SELBST. Er ist am 13.10.2026 in eine eigene Datei gezogen, weil die
   Warenkorbseite dieselbe Frage stellen soll (Vorgabe Claras) und konfigurator.js dort gar
   nicht geladen wird. Zweimal gebaut waere der Kalender zweimal zu pflegen, und der erste
   Unterschied zwischen den beiden faellt niemandem auf.

   DAS MODUL KENNT A NICHT. Es arbeitet auf einem schlichten { wahl, woche, datum }; die
   Bruecke zu A steht hier, und nur hier. So bleibt der Zustand des Konfigurators an einer
   Stelle, und das Modul laeuft auch dort, wo es ihn nicht gibt.

   HARTE ABHAENGIGKEIT, KEIN RUECKFALL: bwp-startwunsch.js wird unmittelbar vor dieser Datei
   geladen (bwp-seite-fuss, product.liquid). Ein eingebauter Ersatz waere genau die zweite
   Fassung, die der Umzug vermeiden soll - fehlt das Modul, fehlt die Frage, und das faellt
   sofort auf statt still zu veralten. */
function startZustand(){ return {wahl:A.startWunsch, woche:A.startWoche, datum:A.startDatum, monat:A.startMonat}; }
function startWunschText(){
  return (window.BwpStartwunsch) ? BwpStartwunsch.text(startZustand()) : '';
}
function startWunschHtml(id){
  return (window.BwpStartwunsch) ? BwpStartwunsch.html(id, startZustand()) : '';
}
function startWunschVerdrahten(id){
  if(!window.BwpStartwunsch) return;
  BwpStartwunsch.verdrahten(id, startZustand(), function(z){
    A.startWunsch=z.wahl; A.startWoche=z.woche; A.startDatum=z.datum; A.startMonat=z.monat;
    /* Die Pflicht-Markierung verschwindet, sobald die Angabe VOLLSTAENDIG ist - sie meldet
       eine Luecke, nicht einen Fehler, und soll deshalb nicht stehen bleiben (siehe
       wireStepNav). Seit dem 21.10.2026 reicht dafuer die Wahl allein nicht mehr: Wer
       "Bestimmte Woche" antippt, hat die Luecke noch nicht geschlossen, und eine Markierung,
       die in diesem Moment verschwaende, naehme dem Kunden genau den Hinweis darauf. */
    { const k=document.getElementById(id);
      if(k) k.classList.toggle('fehlt', k.classList.contains('fehlt') && !BwpStartwunsch.vollstaendig(z)); }
    try{ speichereStand(); }catch(e){}
    track('startwunsch',{wahl:z.wahl, woche:z.woche||'', datum:z.datum||''});
  });
}

/* DIE BILDKACHEL ALS ANKREUZFLAECHE IST AM 14.10.2026 WIEDER ENTFALLEN (Vorgabe Claras:
   "bei mobile, mach das mit den Bildchen und Haken rueckgaengig und so wie vorher"). Sie stand
   genau einen Tag. Das Kaestchen ist wieder das Ankreuzfeld, auf dem Telefon wie auf dem
   Desktop. Die zweizeilige Paketzeile vom selben Tag bleibt - sie war eine eigene Vorgabe. */

function paketSeiteHtml(e){
  if(!e || !e.paket) return '';
  return `<button type="button" class="xr-seite" data-paketfenster="${esc(e.paket)}"`
       + ` aria-label="${esc(e.name)}: alle Inhalte erklärt"`
       + ` title="Alle Inhalte erklärt – öffnet ein Fenster">↗</button>`;
}

/* ============ DAS PAKET ALS FENSTER UEBER DER PRODUKTSEITE (01.10.2026) ============

   Vorgabe Claras: "da, wo jetzt der Pfeil zu der Produktpaketseite geleitet wird, soll ein
   Pop-up-Button werden ... wie so ein weiteres Fenster, aber immer noch auf der Produktseite.
   Nicht komplett so gross wie die ganze Seite, aber fast so gross ... um wieder nur auf die
   Konfiguration zu kommen, klickt man einfach das X."

   WARUM DAS BESSER IST ALS DER VERWEIS VON VORHIN: Wer mitten im Zusammenstellen ein Paket
   nachschlagen wollte, verliess die Seite. Zurueck fuehrte zwar ein Weg, aber der Blick war
   weg, die Stelle musste wiedergefunden werden, und bei langsamer Verbindung dauerte es zweimal
   einen Seitenaufbau. Jetzt bleibt die Konfiguration stehen, das Fenster legt sich darueber,
   das Kreuz nimmt es weg.

   DER INHALT KOMMT AUS DERSELBEN FUNKTION wie die Paketseite (paketInhaltHtml) - Positionen,
   Aufklapper mit Beschreibung, Datenblaetter, Preis, der Knopf "Zur Konfiguration hinzufuegen"
   und der Mengenregler. Kein zweites Markup, das auseinanderlaufen koennte.

   DIE PAKETSEITE BLEIBT, WIE SIE WAR: Wer ueber die Bauteile-Uebersicht kommt, bekommt
   weiterhin die eigene Seite. Dieses Fenster ist der Weg aus dem Konfigurator heraus und
   wieder hinein - zwei Wege zum selben Inhalt, bewusst.

   EIN EINZIGES FENSTER IM DOKUMENT, beim ersten Oeffnen gebaut: Die Paketzeile steht an bis zu
   drei Stellen gleichzeitig (Kaufbox, Kauf-Kasten, Warenkorb-Dialog). Je Zeile eines anzulegen
   hiesse, dieselbe Huelle mehrfach im Dokument zu halten und bei jeder Aenderung alle zu
   pflegen.

   DIE SEITE HINTER DEM FENSTER WIRD FESTGESTELLT (html.paketfenster-offen): Ohne das scrollt
   beim Wischen im Fenster irgendwann die Seite darunter weiter, und beim Schliessen steht man
   woanders. Dieselbe Technik wie bei der Navigations-Schublade. */
let __paketFensterKey=null;
function paketFensterBauen(){
  let f=document.getElementById('paketFenster');
  if(f) return f;
  f=document.createElement('div');
  f.id='paketFenster';
  f.className='paketfenster';
  f.hidden=true;
  f.setAttribute('role','dialog');
  f.setAttribute('aria-modal','true');
  f.setAttribute('aria-label','Paketinhalt');
  f.innerHTML=`<div class="paketfenster-karte">
      <button type="button" class="paketfenster-zu" aria-label="Fenster schließen">✕</button>
      <div class="paketfenster-inhalt"></div>
    </div>`;
  /* Klick auf den Grund daneben schliesst - erwartetes Verhalten bei einem Fenster, und der
     einzige Weg fuer jemanden, der das Kreuz oben nicht im Blick hat. */
  f.addEventListener('click',e=>{ if(e.target===f) paketFensterSchliessen(); });
  f.querySelector('.paketfenster-zu').addEventListener('click',paketFensterSchliessen);
  document.body.appendChild(f);
  return f;
}
function paketFensterOeffnen(key){
  const p=ZUBEHOER_PAKETE.find(x=>x.key===key); if(!p) return;
  const f=paketFensterBauen();
  const inhalt=f.querySelector('.paketfenster-inhalt');
  /* true = im Fenster. Nur hier zeigt der Regler den Stueckpreis - siehe zubMengeHtml(). */
  inhalt.innerHTML=paketInhaltHtml(p, true);
  /* Knopf und Regler im Fenster verhalten sich wie ueberall sonst - dieselbe Verdrahtung. */
  zubKnoepfeVerdrahten(inhalt);
  f.hidden=false;
  document.documentElement.classList.add('paketfenster-offen');
  __paketFensterKey=key;
  inhalt.scrollTop=0;
  const zu=f.querySelector('.paketfenster-zu'); if(zu) zu.focus();
  try{ track('paket_fenster_offen',{key:key}); }catch(e){}
}
function paketFensterSchliessen(){
  const f=document.getElementById('paketFenster'); if(!f || f.hidden) return;
  f.hidden=true;
  document.documentElement.classList.remove('paketfenster-offen');
  /* Zurueck auf den Knopf, von dem aus geoeffnet wurde - sonst beginnt die Tastaturbedienung
     wieder ganz oben auf der Seite. */
  const zurueck=__paketFensterKey
    ? document.querySelector('[data-paketfenster="'+__paketFensterKey+'"]') : null;
  if(zurueck) zurueck.focus();
  __paketFensterKey=null;
}
document.addEventListener('click',e=>{
  const knopf=e.target.closest && e.target.closest('[data-paketfenster]');
  if(knopf){ e.preventDefault(); e.stopPropagation(); paketFensterOeffnen(knopf.getAttribute('data-paketfenster')); }
});
document.addEventListener('keydown',e=>{ if(e.key==='Escape') paketFensterSchliessen(); });

/* ================= DAS SERVICE-FENSTER (02.10.2026) =========================================
   Vorgabe Claras: "mach bei den Services bitte auch ein Pop-up-Fenster wie bei den Bauteilen.
   Der Inhalt wird der sein, der beim Reiter Foerderung unter 'Verfuegbare Services bei uns'
   steht - hier muss man aufklappen und dann sieht man Was, Wann, Warum. Diese aufgeklappte
   Darstellung im Pop-up anzeigen."

   ES BENUTZT DIESELBE HUELLE WIE DAS PAKETFENSTER - denselben Kasten, dasselbe Kreuz, denselben
   Grund daneben, dieselbe Escape-Taste. Zwei Fenster, die gleich aussehen sollen und getrennt
   gebaut sind, sehen nach dem zweiten Umbau verschieden aus. paketFensterBauen() bekommt dafuer
   nur eine Beschriftung uebergeben; alles andere war schon allgemein genug.

   AUFGEKLAPPT UND OHNE KNOPF: Auf der Foerderseite steckt derselbe Inhalt hinter einem
   Aufklapper, weil dort acht Karten untereinander stehen. Im Fenster steht genau einer - da
   waere ein Aufklapper ein Klick, der nichts sortiert. Genau das hat Clara verlangt.

   DIE QUELLE IST SVC_DEEP, dieselbe Tabelle wie auf der Foerderseite. Fehlt ein Service dort,
   erscheint auch kein Pfeil - das ist richtig so: Ohne Was/Wann/Warum gaebe es nichts zu zeigen.

   oel IST EIN SONDERFALL wie drueben: Vier Einzelservices, eine gemeinsame Karte. Der Pfeil
   steht deshalb an jeder der vier Zeilen und zeigt dieselbe Karte. */
function svcFensterDaten(k){
  if(typeof SVC_DEEP==='undefined') return null;
  /* Die Oeltank-Sammelzeile traegt keinen der vier Schluessel, sondern den der gemeinsamen
     Karte - sie steht fuer alle vier und kennt vor der Wahl noch keinen davon. */
  if(k===OEL_SAMMEL) return SVC_DEEP.find(d=>d.k==='oel') || null;
  const s=SERVICES[k]; if(!s) return null;
  return SVC_DEEP.find(d=>d.k===k) || (s.xgroup==='oel' ? SVC_DEEP.find(d=>d.k==='oel') : null);
}
/* Name und Preis fuer den Fensterkopf. Beim Sammelschluessel gibt es kein SERVICES[k]: Dort
   stehen der gemeinsame Name und die Spanne, genau wie auf der Foerderseite. */
function svcFensterKopf(k){
  if(k===OEL_SAMMEL) return {name:'Öltank-Entsorgung (Ausbau & Entsorgung)', preis:oelSpanne()};
  const s=SERVICES[k];
  return {name:s.name, preis: s.price ? eur(s.price)+(s.preisZusatz?' '+s.preisZusatz:'') : 'inklusive'};
}
function svcFensterHtml(k){
  const d=svcFensterDaten(k); if(!d) return '';
  const kopf=svcFensterKopf(k);
  const preis=kopf.preis;
  const spalte=(label,items)=>`<div class="sd-col"><span class="sd-l">${label}</span><ul>${
    (items||[]).map(x=>`<li>${esc(x)}</li>`).join('')}</ul></div>`;
  return `<div class="svcfenster-kopf">
      <h3>${esc(kopf.name)}</h3>
      <span class="tag${d.foerderRelevant?' gruen':''}">${esc(d.pflicht)}</span>
      <span class="price m">${preis}</span>
    </div>
    <div class="sd-cols">${spalte('Was',d.was)}${spalte('Wann',d.wann)}${spalte('Warum',d.warum)}</div>
    ${d.src?`<span class="sd-src">Quelle: ${esc(d.src)}</span>`:''}`;
}
/* Der Pfeil an der Service-Zeile - dieselbe Form wie der an den Paketzeilen (.xr-seite), damit
   beide als dasselbe Angebot gelesen werden: "hier steht mehr dazu". */
function svcFensterKnopfHtml(k){
  if(!svcFensterDaten(k)) return '';
  return `<button type="button" class="xr-seite" data-svcfenster="${esc(k)}"`
       + ` aria-label="${esc(svcFensterKopf(k).name)}: Was, wann und warum"`
       + ` title="Was, wann und warum - öffnet ein Fenster">↗</button>`;
}
function svcFensterOeffnen(k){
  const html=svcFensterHtml(k); if(!html) return;
  const f=paketFensterBauen();
  f.setAttribute('aria-label','Service-Details');
  const inhalt=f.querySelector('.paketfenster-inhalt');
  inhalt.innerHTML=`<div class="svcfenster">${html}</div>`;
  f.hidden=false;
  document.documentElement.classList.add('paketfenster-offen');
  __paketFensterKey=null;
  inhalt.scrollTop=0;
  const zu=f.querySelector('.paketfenster-zu'); if(zu) zu.focus();
  try{ track('service_fenster_offen',{service:k}); }catch(e){}
}
document.addEventListener('click',e=>{
  const knopf=e.target.closest && e.target.closest('[data-svcfenster]');
  if(knopf){ e.preventDefault(); e.stopPropagation(); svcFensterOeffnen(knopf.getAttribute('data-svcfenster')); }
});
function serviceGruppe(k){
  return FOERDER_CRITICAL.includes(k) ? 'foerder' : (SERVICE_KATEGORIE[k] || 'frei');
}
/* Services, deren Fehlen der Kunde durch Eigenleistung ausgleichen darf. Sie werden
   vorausgewaehlt und gewarnt, aber die generische "muss ein Fachbetrieb bestaetigen"-
   Formulierung waere bei ihnen schlicht falsch. */
const FOERDER_EIGENLEISTUNG_MOEGLICH=['vot'];
let chosenServices=new Set();
let eigenBetraege={};
let chosenCandidate=null;
/* Vorausgewählte Positionen (Förder-Pflicht-Services + Fertigfundament) sind fürs funktionierende
   System wichtig genug, dass Abwählen eine kurze bewusste Bestätigung braucht statt einfach lautlos
   zu verschwinden. Checkbox wird sofort zurückgesetzt, echte Entfernung erst nach Klick auf "Ja". */
/* Meldet, was hier passiert (27.08.2026): der Riegel steht genau an den Positionen, die
   fuer die Foerderung Pflicht sind. Wer ihn oeffnet, will Geld sparen und riskiert dabei
   den Zuschuss - das ist das schaerfste Signal, das die Kaufbox hergibt. Bisher lief es
   voellig stumm ab. Der Schluessel kommt als sechstes Argument dazu, damit beide
   Kaufwege dasselbe melden und nicht nur einen Anzeigenamen. */
function guardedUncheck(checkbox,row,label,warnText,onRemove,schluessel){
  checkbox.checked=true;
  const old=row.querySelector('.kb-confirm'); if(old) old.remove();
  const box=document.createElement('div');
  box.className='banner warn kb-confirm';
  box.style.marginTop='8px';
  box.innerHTML=`<b>${esc(label)} wirklich entfernen?</b> ${esc(warnText)}<div style="display:flex;gap:8px;margin-top:8px"><button type="button" class="btn quiet kb-yes">Ja, entfernen</button><button type="button" class="btn quiet kb-no">Doch behalten</button></div>`;
  row.appendChild(box);
  track('entfernen_gewarnt',{position:schluessel||label});
  box.querySelector('.kb-yes').onclick=()=>{
    checkbox.checked=false; box.remove();
    track('entfernen_bestaetigt',{position:schluessel||label});
    onRemove();
  };
  box.querySelector('.kb-no').onclick=()=>{
    box.remove();
    track('entfernen_abgebrochen',{position:schluessel||label});
  };
}
/* Guard: Förder-Pflicht-Services nur beim allerersten Aufbau der Buybox fuer diesen Kit-Key
   vorausgewählt anhaken, nicht bei jedem Re-Render (sonst überschreibt es eine bewusste Abwahl bei
   jedem updateTotal()-Aufruf). fundament ist am 16.09.2026 ganz entfallen - weder Frage noch
   Produkt, das Fundament ist immer Eigenleistung. */
let buyboxPreselectedFor=null;

/* ---- Checkout-Education-Walkthrough: Spotlight-Tour ueber die vorausgewaehlten Positionen ----
   Einmal pro Session (sessionStorage), damit es beim erneuten Besuch derselben Buybox nicht nervt.
   Findet die Schritte rein ueber den aktuell im DOM stehenden, angehakten Zustand - dieselbe Funktion
   bedient Funnel- und Modal-Pfad, nur die Selektoren unterscheiden sich. */
/* Die Tour laeuft PRO ABSCHNITT statt einmal ueber alles (User 24.07.2026): erst Hardware, und erst
   wenn der Kunde selbst auf Services weiterklickt, die zweite Tour dort. Das haelt jede Tour kurz
   und erklaert immer nur das, was gerade vor Augen liegt - vorher sprang sie zwischen den beiden
   Wizard-Schritten hin und her und musste den Step dafuer selbst umschalten. */
function walkthroughSteps(scope,section){
  const steps=[];
  if(section==='hardware'){
    /* Der Hardware-Abschnitt hatte bis 29.07.2026 nur einen einzigen, an eine Funnel-Antwort
       gebundenen Schritt - bei "Fundament baue ich selbst" lief die Tour deshalb gar nicht an.
       Jetzt fuehren feste Ankerpunkte durch den Abschnitt; jeder Schritt wird nur aufgenommen,
       wenn sein Element wirklich existiert, damit nie ein Spotlight ins Leere zeigt. */
    const cm = scope==='modal';
    /* Auf den Container scopen, in den die Kaufbox tatsaechlich gerendert wird - #app beim
       Rechner-Weg, #cartModalBody beim Direktkauf. NICHT auf #rechnerCalc: das ist die ganze
       Section samt Hero und Vergleich, dort gibt es weitere .buyline-Elemente. */
    const wurzel = document.querySelector(cm ? '#cartModalBody' : '#app') || document;
    const nimm = (sel, title, text, details) => {
      const el = typeof sel==='string' ? wurzel.querySelector(sel) : sel;
      if(el) steps.push({el, title, text, details});
    };
    /* 1. Was gekauft wird: die erste Kaufzeile traegt Kit-Bild und Preis. */
    nimm('.buyline', 'Dein Kit',
      'Das ist die Hardware, die zu deiner Heizlast passt: Außeneinheit, Hydraulikstation und alles, was fest dazugehört.');
    /* 2. Lieferumfang - beantwortet die haeufigste Frage "ist da wirklich alles dabei?".
       Nur noch im Direktkauf-Dialog: im Rechner-Weg ist die Kurzliste am 12.08.2026 aus dem
       Hardware-Schritt geflogen (sie lief nicht mit), dort fuehrt der vollstaendige Lieferumfang
       im Service-Schritt. nimm() ueberspringt fehlende Elemente ohnehin - das hier ist nur
       ehrlicher zu lesen als ein Selektor auf etwas, das es nicht mehr gibt. */
    /* IDs berichtigt (02.09.2026): hier stand #cmLuDetails, im Markup heisst der Block aber
       #cmLuGrid. nimm() ueberspringt fehlende Elemente stumm - dieser Tourschritt ist also nie
       erschienen, ohne dass irgendwo ein Fehler aufgetaucht waere. Genau die Frage, die er
       beantwortet ("ist da wirklich alles dabei?"), ist die haeufigste vor dem Kauf. */
    /* Sichtbarkeitspruefung (14.09.2026): Im Kasten auf der Produktseite ist "Was drin ist"
       ausgeblendet - dort steht die Auswahl parallel in der Warenkorb-Schublade. Ohne diese
       Pruefung haette der Rundgang einen unsichtbaren Punkt angeleuchtet: ein Scheinwerfer
       auf nichts, und der Schritt davor und danach haetten keinen Zusammenhang mehr ergeben.
       getClientRects() ist leer, sobald ein Vorfahr display:none traegt. */
    const luEl = wurzel.querySelector('#cmLuGrid');
    const luSichtbar = !!(luEl && luEl.getClientRects && luEl.getClientRects().length);
    if(cm && luSichtbar) nimm(luEl, 'Was alles drin ist',
      'Klapp die Liste auf, wenn du wissen willst, welche Teile im Kit stecken. Jede Position ist einzeln aufgeführt.',
      '#cmLuGrid');
    /* 3. Die Lieferung - kostenwirksam und wird sonst leicht uebersehen.
       DER ANKER HAT SICH AM 28.10.2026 GEAENDERT: Die Chips, an denen der Schritt hing, sind
       mit der Abholung entfallen. Ein querySelector auf die alte id haette null geliefert und
       der Schritt waere lautlos aus dem Rundgang gefallen - keine Meldung, nur ein Punkt
       weniger. Jetzt zeigt er auf die Preiszeile selbst. */
    const lief = wurzel.querySelector(cm ? '#cmLieferZeile' : '#deliveryPrice');
    if(lief) nimm(lief.closest('.buyline') || lief, 'Lieferung',
      'Wir liefern deutschlandweit zu dir nach Hause. Die Lieferung schlägt mit ' + lieferPreisText() + ' zu Buche und steckt in der Summe unten mit drin.');
    /* 4. Material-Extras, inklusive des Fundament-Hinweises aus dem Funnel. */
    const fundInp=document.querySelector(cm ? '#cmExtraList input[data-x="fundament"]' : '#extraList input[data-x="fundament"]');
    if(fundInp && fundInp.checked){
      steps.push({el:fundInp.closest('.svc-row'), title:EXTRAS.fundament.name, text:'Du hast im Rechner „Fertigfundament liefern lassen" gewählt – das ist hier schon für dich eingeplant.', details: scope==='modal'?'#cmExtraList':'#extraList'});
    } else {
      /* Auch hier berichtigt: #cmExtraDetails/#extraDetails gibt es im Markup nicht, die
         Listen heissen #cmExtraList und #extraList. Der Schritt "Material dazubestellen"
         fiel damit in BEIDEN Kaufwegen aus. */
      nimm(cm ? '#cmExtraList' : '#extraList', 'Material dazubestellen',
        'Fundament, Hauseinführung, Erdleitung: was du nicht selbst besorgen willst, kannst du hier direkt mitbestellen.',
        cm ? '#cmExtraList' : '#extraList');
    }
    /* 5. Im gefuehrten Modus jede vorausgewaehlte Position einzeln erklaeren. Genau dafuer
       hat der Kunde "Nimm mich an die Hand" gewaehlt - die Begruendung darf nicht nur als
       Kleintext unter der Zeile stehen. Reihenfolge wie im Plan, damit die Logik
       nachvollziehbar bleibt (Pumpengruppe -> Systemtrennung -> Peripherie -> Hauseinfuehrung). */
    if(A.gefuehrt==='ja'){
      const liste = cm ? '#cmExtraList' : '#extraList';
      const aufklappen = cm ? '#cmExtraList' : '#extraList';
      vorauswahlPlan().forEach(pos=>{
        /* Das Fundament hat weiter oben bereits einen eigenen Schritt - sonst erschiene es
           in der Kombination "gefuehrt + Fertigfundament" doppelt. */
        if(pos.key==='fundament') return;
        const e=EXTRAS[pos.key]; if(!e) return;
        const zeile = wurzel.querySelector(liste+' input[data-x="'+pos.key+'"]');
        if(!zeile) return;
        nimm(zeile.closest('.svc-row')||zeile, e.name+' haben wir eingeplant', pos.grund, aufklappen);
      });
    }
    /* 6. Eigenleistung - erhoeht die Foerderbasis und wird sonst gar nicht wahrgenommen. */
    nimm(cm ? '#cmEigenBlock' : '#eigenBlock', 'Deine Eigenleistung zählt mit',
      'Material, das du selbst kaufst, gehört mit in die Förderung. Trag die Beträge hier ein, dann rechnen wir sie in die Förderbasis ein.',
      cm ? '#cmEigenDetails' : '#eigenDetails');
    return steps;
  }
  document.querySelectorAll(scope==='modal' ? '#cartModalBody .svcchoice input[data-k]' : '#svcListRequired input[data-k], #svcListOptional input[data-k]').forEach(inp=>{
    const k=inp.dataset.k;
    if(FOERDER_CRITICAL.includes(k) && inp.checked){
      const info=SERVICE_FOERDER_INFO[k];
      steps.push({el:inp.closest('.svc-row'), title:SERVICES[k].name, text:info?info.warum:'Pflicht für deine KfW-Förderung.'});
    }
  });
  /* Letzter Schritt der gesamten Fuehrung: nicht mit einer Pflicht aufhoeren, sondern mit
     dem Angebot, jederzeit nachfragen zu koennen - und mit Zutrauen. Nur im gefuehrten
     Modus, denn wer "Ich weiß Bescheid" gewaehlt hat, sieht die Tour ohnehin nicht. */
  if(steps.length && A.gefuehrt==='ja'){
    const ziel = document.querySelector(scope==='modal' ? '#cmFoerderRiskBox, #cartModalBody .buybox' : '#foerderRiskBox')
      || steps[steps.length-1].el;
    steps.push({el:ziel, title:'Und wenn du irgendwo hängst?',
      text:'Dann meldest du dich einfach. Unter '+CONFIG.SUPPORT_PHONE+' ist jemand dran, der die Anlage kennt, und über den Chat geht es auch schriftlich. Wenn du an einer Stelle lieber gar nicht selbst ran willst, übernehmen wir sie als Service - der hydraulische Abgleich und die Inbetriebnahme stehen oben schon zur Auswahl. Aber ehrlich: Wir glauben, dass du das packst.'});
  }
  return steps;
}
let tourSteps=[], tourStepIdx=0, tourSection='';
/* Eigener Merker je Abschnitt: sonst wuerde die Hardware-Tour die Services-Tour miterledigen. */
function tourSeenKey(section){ return 'bwp_tour_seen_'+section; }
/* Die Fuehrung laeuft absichtlich nur EINMAL pro Sitzung - beim Vorfuehren oder Testen ist sie
   danach weg, weil der Merker im sessionStorage steht. `?tour=1` an die URL haengen erzwingt sie
   wieder, ohne dass jemand den Browserspeicher leeren oder ein privates Fenster oeffnen muss. */
function tourForced(){
  try{ return new URLSearchParams(location.search).get('tour')==='1'; }catch(e){ return false; }
}
/* Leert die "schon gesehen"-Merker aller Tour-Abschnitte. */
function tourMerkerLeeren(){
  ['hardware','service'].forEach(a=>{ try{ sessionStorage.removeItem(tourSeenKey(a)); }catch(e){} });
}
function startCheckoutWalkthrough(scope,section){
  /* NICHT IM KASTEN AUF DER PRODUKTSEITE (Vorgabe 15.09.2026: "du springst beim Konfigurator
     immer so nach unten").

     Die Tour leuchtet Schritt fuer Schritt ein Element an und fuehrt es dafuer mit
     scrollIntoView({block:'center'}) in die Mitte. Im Vollbild-Dialog ist das harmlos - er
     IST die ganze Seite. Der Kasten steht mitten auf der Produktseite: Dort reisst dasselbe
     Anfahren die Seite nach unten, und zwar bei jedem Neuaufbau der Flaeche, also auch nach
     jeder beantworteten Frage. Genau das war der Sprung, den die Abschaltung der
     Schritt-Scrolls nicht beseitigt hat.

     Die Tour bleibt ueberall sonst: im Rechner-Kaufweg und im Direktkauf-Dialog. */
  if(scope==='modal' && document.querySelector('#cartModal.kauf-inline')) return;
  /* Die Fuehrungsfrage entscheidet, ob ueberhaupt gefuehrt wird. Wer "Ich weiß Bescheid"
     gewaehlt hat, bekommt keine Erklaertour - das war die Zusage bei der Antwort.
     Vorher haing die Tour NUR am sessionStorage und ignorierte die Antwort komplett. */
  if(A.gefuehrt==='nein' && !tourForced()) return;
  /* Nie zwei Touren gleichzeitig - aber ein VERWAISTES Overlay darf keine neue Tour blockieren.
     Verwaist heisst: das Element, auf das der aktuelle Schritt zeigt, haengt nicht mehr im
     Dokument, weil die Ansicht zwischenzeitlich neu gerendert wurde. */
  if(document.getElementById('tourOverlay')){
    const aktuell = tourSteps[tourStepIdx];
    if(aktuell && aktuell.el && aktuell.el.isConnected) return;
    endTour(false);
  }
  if(!tourForced() && sessionStorage.getItem(tourSeenKey(section))) return;
  const steps=walkthroughSteps(scope,section);
  /* Merker NICHT setzen, wenn nichts gezeigt wurde: sonst gilt der Abschnitt als gesehen,
     obwohl der Kunde nie etwas zu sehen bekam - und die Tour kaeme auch dann nicht mehr,
     wenn er spaeter etwas auswaehlt, das Schritte erzeugt haette. */
  if(!steps.length) return;
  tourSteps=steps; tourStepIdx=0; tourSection=section;
  setTimeout(showTourStep,450);
}
/* Spotlight und Karte liegen position:fixed, ihre Koordinaten kommen aber aus einem einmaligen
   getBoundingClientRect(). Ohne Neuberechnung wandert der Lichtkegel beim Scrollen oder Drehen des
   Geräts von der Zeile weg, die er erklären soll. */
let tourReflowRaf=0;
function tourReflow(){
  if(tourReflowRaf) return;
  tourReflowRaf=requestAnimationFrame(()=>{
    tourReflowRaf=0;
    const step=tourSteps[tourStepIdx];
    if(step && step.el && step.el.isConnected && document.getElementById('tourOverlay')) positionTourStep(step);
  });
}
function tourKeydown(e){ if(e.key==='Escape'){ e.stopPropagation(); endTour(); } }
/* merken=true bedeutet: der Kunde hat die Tour bewusst hinter sich gebracht - durchgeklickt,
   uebersprungen oder per Escape weggeschickt. Dann gilt der Abschnitt fuer diese Sitzung als
   gesehen. Beim blossen Ansichtswechsel (merken=false) darf der Merker NICHT gesetzt werden,
   sonst kostet ein Klick auf "Zurueck zum Vergleich" die Tour fuer den Rest der Sitzung. */
function endTour(merken){
  if(merken!==false && tourSection) sessionStorage.setItem(tourSeenKey(tourSection),'1');
  const ov=document.getElementById('tourOverlay'); if(ov) ov.remove();
  document.documentElement.classList.remove('bwp-tour-on');
  window.removeEventListener('scroll',tourReflow,true);
  window.removeEventListener('resize',tourReflow);
  document.removeEventListener('keydown',tourKeydown,true);
  tourSteps=[]; tourStepIdx=0;
}
function showTourStep(){
  const step=tourSteps[tourStepIdx];
  /* Zwei verschiedene Faelle mit demselben Ausgang: !step heisst, der letzte Schritt ist
     durch - die Tour gilt als gesehen. Ein verschwundenes Element dagegen ist ein Abbruch,
     den der Kunde nicht zu verantworten hat; dann bleibt der Merker offen. */
  if(!step){ endTour(true); return; }
  if(!step.el || !step.el.isConnected){ endTour(false); return; }
  /* Seit die Tour pro Abschnitt laeuft, darf sie den Mini-Wizard NICHT mehr selbst umschalten -
     das war genau das Hin- und Herspringen, das wir loswerden wollten. Liegt das Ziel wider
     Erwarten in einem versteckten Step, wird der Schritt uebersprungen statt erzwungen. */
  const stepContainer=step.el.closest('.bb-step');
  if(stepContainer && stepContainer.classList.contains('hidden')){ tourStepIdx++; return showTourStep(); }
  if(step.details){
    const det=document.querySelector(step.details);
    if(det && !det.open) det.open=true;
  }
  /* UND JEDER AUFKLAPPER, IN DEM DAS ZIEL SELBST STECKT (21.09.2026). Seit die
     Material-Gruppen im Direktkauf-Dialog zugeklappt starten, liegen die Zeilen, auf die der
     Rundgang zeigt, in einem geschlossenen <details> - der Scheinwerfer haette auf eine
     unsichtbare Stelle geleuchtet und die Karte daneben ins Nichts gezeigt.
     Ueber die VORFAHREN des Ziels und nicht ueber einen weiteren Selektor in step.details:
     so stimmt es auch fuer jeden Aufklapper, den es hier noch nicht gibt, und niemand muss
     beim naechsten Umbau daran denken. */
  for(let v=step.el.parentElement; v; v=v.parentElement){
    if(v.tagName==='DETAILS' && !v.open) v.open=true;
  }
  let overlay=document.getElementById('tourOverlay');
  if(!overlay){
    overlay=document.createElement('div'); overlay.id='tourOverlay'; overlay.className='tour-overlay';
    overlay.innerHTML=`<div class="tour-spot" id="tourSpot"></div>
      <svg class="tour-rays" id="tourRays" aria-hidden="true"></svg>
      <div class="tour-card" id="tourCard" role="dialog" aria-modal="false" aria-labelledby="tourTitle" aria-describedby="tourText">
        <div class="tour-head">
          <div class="tour-progress" id="tourProgress"></div>
          <button type="button" class="tour-skip" id="tourSkip">Überspringen</button>
        </div>
        <div class="tour-title" id="tourTitle"></div>
        <div class="tour-text" id="tourText"></div>
        <div class="tour-nav">
          <button type="button" class="btn quiet" id="tourBack">Zurück</button>
          <button type="button" class="btn" id="tourNext"></button>
        </div>
      </div>`;
    document.body.appendChild(overlay);
    /* Waehrend der Tour liegt alles ausser dem Spotlight im Dunkeln - der Hilfe-Knopf wuerde dann
       als einziges helles Element am Rand um Aufmerksamkeit konkurrieren. */
    document.documentElement.classList.add('bwp-tour-on');
    overlay.querySelector('#tourNext').onclick=()=>{ tourStepIdx++; showTourStep(); };
    overlay.querySelector('#tourBack').onclick=()=>{ if(tourStepIdx>0){ tourStepIdx--; showTourStep(); } };
    /* Ohne Ausstieg war die Tour eine Sackgasse: nur das Durchklicken aller Schritte beendete sie. */
    overlay.querySelector('#tourSkip').onclick=endTour;
    window.addEventListener('scroll',tourReflow,true);
    window.addEventListener('resize',tourReflow);
    document.addEventListener('keydown',tourKeydown,true);
  }
  step.el.scrollIntoView({behavior:'smooth',block:'center'});
  /* ZIEL ZUERST INS BILD HOLEN (portiert 16.09.2026). positionTourStep() misst mit
     getBoundingClientRect() und setzte voraus, dass das Ziel im Fenster steht. War es das
     nicht - etwa weil die Kaufbox frisch gezeichnet wurde und der Browser die Scrollposition
     nach oben klemmt -, lag der Lichtkegel ausserhalb und die Karte wurde in die Ecke
     geschoben: eine abgedunkelte Seite mit einer Erklaerung zu etwas, das man nicht sieht.
     Gescrollt wird NUR hier, nicht in tourReflow(): das laeuft am Scroll-Ereignis und zoege
     dem Kunden die Seite unter den Fingern weg. */
  setTimeout(()=>tourZielInsBild(step.el,()=>positionTourStep(step)),260);
  document.getElementById('tourProgress').textContent=`${tourStepIdx+1}/${tourSteps.length}`;
  document.getElementById('tourTitle').textContent=step.title;
  document.getElementById('tourText').textContent=step.text;
  document.getElementById('tourBack').style.visibility = tourStepIdx>0 ? 'visible':'hidden';
  const nextBtn=document.getElementById('tourNext');
  /* Abschnittsbezogene Beschriftung: nach der Hardware-Tour geht es NICHT zum Checkout, sondern
     erst weiter zu den Services - alles andere waere ein falsches Versprechen. */
  nextBtn.textContent = tourStepIdx<tourSteps.length-1 ? 'Weiter →'
    : (tourSection==='hardware' ? 'Alles klar' : 'Verstanden, weiter zum Checkout');
  /* Tastatur-Nutzer standen sonst mit dem Fokus irgendwo hinter dem verdunkelten Overlay. */
  nextBtn.focus({preventScroll:true});
}
/* Keith-Haring-Zitat: kurze Striche, die vom Rand der Maske nach aussen schiessen und die
   hervorgehobene Zeile "aufladen". Bewusst dosiert - acht Striche, duenner als bei Haring, und sie
   zeichnen sich nacheinander statt alle gleichzeitig zu blinken. Die Geometrie sitzt auf demselben
   Rechteck wie der Spotlight (r + 8px), damit Kontur und Striche exakt zusammenpassen. */
function drawTourRays(r){
  const svg=document.getElementById('tourRays'); if(!svg) return;
  const pad=34, w=r.width+16, h=r.height+16;
  svg.style.left=(r.left-8-pad)+'px'; svg.style.top=(r.top-8-pad)+'px';
  svg.style.width=(w+pad*2)+'px'; svg.style.height=(h+pad*2)+'px';
  svg.setAttribute('viewBox',`0 0 ${w+pad*2} ${h+pad*2}`);
  const D=Math.SQRT1_2; // Ecken diagonal normieren, sonst waeren sie 41 % laenger als die Kanten
  const anchors=[
    [0,0,-D,-D],[w/2,0,0,-1],[w,0,D,-D],[w,h/2,1,0],
    [w,h,D,D],[w/2,h,0,1],[0,h,-D,D],[0,h/2,-1,0]
  ];
  svg.innerHTML=anchors.map(([px,py,dx,dy],i)=>{
    const len=13, gap=6;
    const sx=pad+px+dx*gap, sy=pad+py+dy*gap;
    return `<line x1="${sx.toFixed(1)}" y1="${sy.toFixed(1)}" x2="${(sx+dx*len).toFixed(1)}" y2="${(sy+dy*len).toFixed(1)}" style="animation-delay:${(i*0.07).toFixed(2)}s"/>`;
  }).join('');
}
/* Holt das Ziel ins Fenster und ruft danach zurueck. Steht es schon da, wird nicht gescrollt -
   ein ruckender Sprung bei jedem Schritt waere schlimmer als gar keiner. */
function tourZielInsBild(el, danach){
  if(!el || !el.isConnected){ danach(); return; }
  let r; try{ r=el.getBoundingClientRect(); }catch(e){ danach(); return; }
  const rand=80;   /* Luft, damit die Karte darunter noch Platz findet */
  if(r.top>=rand && r.bottom<=window.innerHeight-rand){ danach(); return; }
  const sanft = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  try{ el.scrollIntoView({behavior: sanft?'smooth':'auto', block:'center'}); }
  catch(e){ try{ el.scrollIntoView(); }catch(e2){} }
  /* Fuer 'smooth' gibt es kein zuverlaessiges Ende-Ereignis in allen Browsern - kurze Frist,
     danach positionieren, egal wo die Seite steht. Lieber leicht daneben als keine Karte. */
  setTimeout(danach, sanft?420:60);
}
function positionTourStep(step){
  const overlay=document.getElementById('tourOverlay'); if(!overlay) return;
  const r=step.el.getBoundingClientRect();
  /* SICHERUNG: ein Ziel ohne Ausdehnung ist nicht sichtbar - ausgeblendet, zugeklappt oder noch
     nicht fertig gezeichnet. Der Lichtkegel waere ein Punkt und die Karte erklaerte etwas, das
     der Kunde nirgends findet, ueber einer abgedunkelten Seite. Lieber sauber abbrechen.
     Ohne Merker: die Tour hatte keine Chance, sie soll sie beim naechsten Anlauf wiederbekommen. */
  if(r.width===0 && r.height===0){ endTour(false); return; }
  const spot=document.getElementById('tourSpot');
  spot.style.top=(r.top-8)+'px'; spot.style.left=(r.left-8)+'px';
  spot.style.width=(r.width+16)+'px'; spot.style.height=(r.height+16)+'px';
  drawTourRays(r);
  const card=document.getElementById('tourCard');
  /* FEHLER 31.07.2026 (Meldung Carsten): die Kartenhoehe war mit 150px GERATEN
     (`r.bottom+150 < innerHeight`). Beim Schritt "Lieferung" ist der Text
     laenger, die Karte auf dem Handy also gut 250px hoch. Sie wurde trotzdem nach unten
     gesetzt, und der untere Teil mit "Zurueck"/"Weiter" lag ausserhalb des Fensters. Weil
     .tour-card position:fixed ist, half auch Scrollen nicht - erreichbar blieb nur
     "Ueberspringen" oben. Die Tour war damit eine Sackgasse.

     Jetzt wird die tatsaechliche Hoehe gemessen (Titel und Text stehen zu diesem Zeitpunkt
     schon drin, positionTourStep laeuft verzoegert) und die Karte anschliessend hart ins
     Fenster geklemmt. Passt sie weder darunter noch darueber, wird sie sichtbar gehalten,
     auch wenn sie dann das hervorgehobene Element ueberlappt - eine verdeckte Zeile ist
     immer noch besser als ein unerreichbarer Weiter-Knopf. */
  const hoehe=card.offsetHeight, breite=card.offsetWidth, rand=12, luft=22;
  const passtDarunter = window.innerHeight - r.bottom - luft - rand >= hoehe;
  const passtDarueber = r.top - luft - rand >= hoehe;
  let oben;
  if(passtDarunter) oben = r.bottom + luft;
  else if(passtDarueber) oben = r.top - hoehe - luft;
  else oben = window.innerHeight - hoehe - rand;
  /* Letzte Sicherung, falls die Karte hoeher als das Fenster ist: dann oben buendig, den Rest
     faengt das overflow-y der Karte ab. */
  oben = Math.min(Math.max(rand, oben), Math.max(rand, window.innerHeight - hoehe - rand));
  const links = Math.min(window.innerWidth - breite - rand, Math.max(rand, r.left));
  card.style.top=oben+'px'; card.style.left=links+'px';
  /* Kleiner "Pop" bei jedem neuen Schritt - Reflow-Trick (wie .flash an anderer Stelle im Code),
     macht spuerbar, dass gerade neue Info erscheint statt nur stumm zu verschieben. */
  card.classList.remove('pop'); void card.offsetWidth; card.classList.add('pop');
}
function finish(){
  /* Eigenes Flag statt !finished: seit "Antworten ändern" (reopenFunnel) kann finish() mehrfach
     laufen. An finished gekoppelt würde jeder erneute Abschluss ein zweites config_complete und
     einen doppelten Lead auslösen - die Conversion-Zahlen wären kaputt. */
  const first=!completeTracked; finished=true; completeTracked=true; syncResume();
  speichereStand();   /* Ergebnis-Zustand merken, damit der Rueckkehrer im Ergebnis landet */
  /* DER EINZELNE GESAMTBALKEN IST AM 14.10.2026 ENTFALLEN (eine Leiste statt zwei, siehe
     zeichnePhasen). Hier stand bis dahin ein UNGEPRUEFTER Zugriff auf #pbar - haette ich das
     Element entfernt und diese Zeile stehen lassen, waere finish() mit einem TypeError
     abgebrochen, und zwar genau im Augenblick des Ergebnisses. setProgress() unmittelbar
     darunter faerbt die Abschnittsleiste jetzt ohnehin vollstaendig ein, sobald stepIndex
     hinter dem letzten Schritt liegt. */
  /* DIE LEISTE SELBST NACHZIEHEN (16.09.2026). finish() setzte nur den Balken und liess Zaehler
     und Zurueck-Knopf stehen. Im geradlinigen Durchlauf faellt das nicht auf, weil
     show(STEPS.length) unmittelbar davor setProgress() ruft. Auf JEDEM anderen Weg ins Ergebnis
     blieb die Leiste stehen, wie der Seitenaufbau sie hinterlassen hatte - also auf "1/12":
       - Resume-Chip "Zu deinem Ergebnis" (startFunnel -> finish, ohne show)
       - Deep-Link #los von einer anderen Seite
       - Rueckkehr auf die Rechnerseite mit gespeichertem Stand
     Seit der Rechner bei Clara eine EIGENE SEITE ist, sind das die Normalfaelle und nicht die
     Ausnahme. Deshalb repariert finish() die Leiste selbst, statt sich auf den Aufrufer zu
     verlassen - dann stimmt sie auf allen Wegen, auch auf kuenftigen. */
  setProgress();
  const zurueck=document.getElementById('backBtn');
  if(zurueck) zurueck.classList.remove('hidden');
  const grid=document.getElementById('funnelGrid'); if(grid) grid.classList.add('done');
  const rc=document.getElementById('receipt'); if(rc){ if(typeof ledgerStumm==='function') ledgerStumm(); rc.open=false; }
  const r=routeAll();
  if(first){
    /* Die Bivalenz-Kennzahlen reisen hier mit, NICHT nur im Lead-Datensatz: solange
       LEAD_ENDPOINT auf TBD steht, verlaesst submitLead() den Browser gar nicht. Der
       dataLayer ist damit der einzige Weg, auf dem sich sammeln laesst, wie die neue Regel
       an echten Anfragen entschieden haette - Grundlage fuer die Entscheidung, ob sie
       scharfgeschaltet wird. Flach gehalten, weil GA4 verschachtelte Parameter nicht mag. */
    const bivT = {};
    (r.candidates||[]).forEach(x=>{ if(x.tbiv!=null) bivT['biv_'+x.kit]=x.tbiv; });
    const bivKand = (r.candidates||[]).find(x=>x.kit===r.bivEmpfehlung);
    track("config_complete",{routing:r.type,recommended:r.recommended,candidates:r.candidates.map(x=>x.kit),kw:r.c&&r.c.pausl,
      auswahlregel:CONFIG.RULES.AUSWAHL,
      biv_wuerde_empfehlen:r.bivEmpfehlung||'keine',
      biv_dim_pruefen:!r.bivEmpfehlung,
      biv_heizstab_pct:bivKand?bivKand.heizstabPct:null,
      biv_tgrenz_geschaetzt:!!(bivKand&&bivKand.tgGeschaetzt),
      heizstab_zu_hoch:!!r.heizstabZuHoch, heizstab_min_pct:r.heizstabMinPct!=null?r.heizstabMinPct:null,
      ...bivT});
    submitLead("config_complete");
  }
  /* ZURUECK VON DER PRODUKTSEITE FUEHRT IN DIE AUSWAHL (14.10.2026, Vorgabe Claras: "wenn man
     auf dieser Produktseite ist und dann zurueck geht, geht man zum Ergebnis des Rechners
     zurueck, also zu der Auswahl und nicht zu der normalen Uebersicht der Kits").

     DER E-MAIL-RIEGEL BLEIBT AUSSEN VOR, und das ist kein Loch: Wer den Merker traegt, stand
     eben noch auf der Ergebnisseite - er kann dort nur hingekommen sein, indem er den Riegel
     passiert hat. Ihn auf dem Rueckweg ein zweites Mal nach derselben Adresse zu fragen waere
     eine Mautstelle fuer den Weg zurueck.

     DER MERKER WIRD HIER GELOESCHT, nicht auf der Produktseite: Dort wird er bei jedem Aufbau
     gelesen (der Verweis muss auch nach einem Neuladen noch stimmen), hier ist er verbraucht.

     Und das angetippte Kit steht im Diagramm vorn - man kommt genau zu der Groesse zurueck,
     die man sich angesehen hat. */
  let vomKit=null; try{ vomKit=sessionStorage.getItem(ERG_RUECKWEG); }catch(e){}
  if(vomKit && (r.candidates||[]).some(x=>x.kit===vomKit)){
    try{ sessionStorage.removeItem(ERG_RUECKWEG); }catch(e){}
    emailGatePassiert=true;
    ergAuswahl=vomKit;
    return renderComparison(r);
  }
  /* Nicht mehr direkt in den Vergleich (25.08.2026, User-Entscheid "hartes Gate").
     Dazwischen liegt jetzt renderAuslegung(): erst die Zahl erklaeren, dann nach der
     Adresse fragen, dann die Kits. Zur Reihenfolge siehe Kommentar dort. */
  renderAuslegung(r);
}

/* =====================================================================
   AUSLEGUNG ERKLAEREN + E-MAIL (25.08.2026)

   Zwei Anforderungen treffen sich an derselben Stelle - Funnel-Ende:
   "Die Auslegung und Heizlast per Tooltip erklaeren nachdem Funnel durchlauf" und
   "Capture die Emails ... wenn sie ... gerade eigentlich zur Auswahl des Geraetes kommen
   wuerden". Beides in denselben Frame zu legen hiesse zwei Overlays uebereinander.
   Deshalb EIN eigener Schritt, und die Reihenfolge ist Absicht:

   Der Vergleichsschritt zeigte bisher KEINE kW-Zahl - die Auslegungsheizlast erschien erst
   nach der Kit-Wahl in renderBuyBox. Der Rechenzettel wird eine Zeile ueber diesem Aufruf
   zugeklappt. Der Kunde stand also vor Kits, ohne die Zahl gesehen zu haben, aus der sie
   folgen. Genau dort eine Adresse zu verlangen waere eine Mautstelle: erst kassieren, dann
   liefern. Hier steht es andersherum - Zahl und Erklaerung zuerst, die Adresse danach.

   WIEDERKEHRER WERDEN NICHT ZWEIMAL GEFRAGT. Wer ueber den Kauflink aus der
   Konfigurations-Mail kommt, wer schon im Chat, auf der Warteliste oder ueber die
   Erinnerung eine Adresse hinterlassen hat, hat sie laengst gegeben. Ein zweites Mal
   danach zu fragen liest sich wie "wir haben dich vergessen".

   ZURUECK AUS DER KAUFBOX geht weiterhin direkt an renderComparison (backToCompare, skBack).
   Das Gate sitzt ausschliesslich am Uebergang aus finish() - sonst stuende es bei jedem
   Blick zurueck erneut im Weg. */
/* ============ VORSCHLAGSPAKET FUER DIE GATE-MAIL (26.08.2026) ============
   Am E-Mail-Riegel steht die Rechnung schon komplett: Heizlast, Kandidaten, Empfehlung.
   Was fehlt, ist der Schritt vom Ergebnis zur KONFIGURATION - und der besteht aus genau
   den zwei Anweisungen, die auch die Kaufbox ausfuehrt, bevor sie zeichnet:
     1. FOERDER_CRITICAL  -> die Pflicht-Services (Foerderantrag, Anlagencheck, Planung)
     2. wendeVorauswahlAn -> die Materialpositionen aus den Antworten (Pumpengruppe,
                             Peripherie-Set, Hauseinfuehrung)
   Beide brauchen kein DOM, und paketSchnappschuss() liest ausschliesslich Zustand. Der
   Kunde bekommt damit exakt das Paket, das ihm die Kaufbox eine Sekunde spaeter zeigen
   wuerde - keine zweite Rechenstelle, die driften koennte.

   AUF EINER KOPIE. Wuerden wir chosenCandidate und die Vorauswahl wirklich setzen, waere
   der Kunde auf eine Wahl festgelegt, die er nie getroffen hat - speichereStand() wuerde
   sie sogar festschreiben. Deshalb: sichern, rechnen, zuruecksetzen. Das Fenster ist rein
   synchron, dazwischen laeuft nichts anderes.

   Welches Kit? Bevorzugt die Empfehlung des Rechners. Gibt es keine - der Normalfall,
   wenn kein Kit im Bivalenzfenster liegt -, dann das technisch naechstliegende: erst die im
   Fenster, dann das mit dem kleinsten Abstand zum Ziel. Kits, die kitUnpassend() als zu
   klein meldet, kommen nur zum Zug, wenn es gar nichts anderes gibt.

   HIER STAND "dasselbe, das im Vergleich oben stehen wird". Das stimmt seit dem 17.09.2026
   nicht mehr: Der Vergleich sortiert nach Leistung (KIT_REIHE), nicht mehr nach Eignung.
   Die Auswahl hier bleibt trotzdem richtig - sie sucht das passendste Kit, nicht das erste
   auf dem Bildschirm. Nur die Begruendung im Text war an die Sortierung geknuepft. */
function vorschlagsPaket(r){
  if(A.installMode==='pro') return null;   /* Fachbetrieb-Weg kauft hier nichts */
  const alle=(r&&r.candidates)||[];
  if(!alle.length) return null;
  const brauchbar=alle.filter(c=>!kitUnpassend(c));
  const pool=brauchbar.length?brauchbar:alle;
  const sortiert=pool.slice().sort((a,b)=>
    (b.imFenster?1:0)-(a.imFenster?1:0) || bivAbstand(a.tbiv)-bivAbstand(b.tbiv));
  const cand=pool.find(c=>c.kit===r.recommended) || sortiert[0];
  if(!cand || !PRODUCTS[cand.kit]) return null;

  /* DER WARENKORB DARF DEN VORSCHLAG NICHT UEBERSTIMMEN (16.10.2026, gemeldet von Jannik: Rechner
     10 kW, Mail "Passend zu deinem Haus: DIY-Kit 5 kW").
     paketSchnappschuss() nimmt das Kit aus directCand, sobald dort eines steht, und erst danach
     chosenCandidate. directCand stellt ladeStand() seit dem 15.09.2026 auf JEDER Seite aus dem
     Warenkorb wieder her (KORB_TAGE). Wer vorher eine Produktseite besucht hatte - etwa ueber den
     Link der 5-kW-Mail -, bekam am Riegel also das Kit aus seinem Warenkorb samt dessen Services
     als Empfehlung, mit der Heizlast aus dem Rechner daneben. Der Kauflink im selben Paket kam aus
     kaufStand() und trug das richtige Kit: Mail und Link widersprachen sich.
     Deshalb liegt directCand hier fuer die Dauer des Schnappschusses beiseite, genau wie
     chosenCandidate und die Auswahl. Der Warenkorb selbst bleibt unberuehrt (Vorgabe Claras vom
     16.09.2026: was im Warenkorb liegt, bleibt liegen). */
  const sicher={ c:chosenCandidate, s:chosenServices, e:chosenExtras,
                 vg:vorauswahlGesetzt, vgr:vorauswahlGruende, d:directCand };
  let paket=null;
  try{
    directCand=null;
    chosenCandidate=cand;
    chosenServices=new Set();
    chosenExtras={};
    vorauswahlGesetzt=[];
    vorauswahlGruende={};
    FOERDER_CRITICAL.forEach(k=>{ if(SERVICES[k] && (!SERVICES[k].only||SERVICES[k].only(A))) chosenServices.add(k); });
    wendeVorauswahlAn();
    paket=paketSchnappschuss();
  }catch(e){
    console.warn('[vorschlag] Paket konnte nicht gebaut werden:',e);
    paket=null;
  }finally{
    chosenCandidate=sicher.c; chosenServices=sicher.s; chosenExtras=sicher.e;
    vorauswahlGesetzt=sicher.vg; vorauswahlGruende=sicher.vgr; directCand=sicher.d;
  }
  if(!paket) return null;
  /* Der Kauflink traegt sonst &kasse=1 und wuerde direkt in die Kasse durchreichen. Bei
     einem VORSCHLAG waere das zu weit gegriffen: der Kunde hat dieses Kit nie gewaehlt.
     Ohne das Kennzeichen oeffnet der Link den Rechner mit fertig gefuellter Kaufbox - er
     sieht also, was er kauft, bevor er kauft. Die Mail, die er sich in der Kaufbox selbst
     schickt, behaelt die Durchreiche. */
  if(paket.kauf_link) paket.kauf_link=paket.kauf_link.replace('&kasse=1','');
  return paket;
}

function renderAuslegung(r){
  endTour(false);
  const kw = (r.c && r.c.pausl) || 0;
  const schonBekannt = istEmail(A.email);
  track("auslegung_view",{kw:kw, email_bekannt:schonBekannt});

  /* DIESER SCHRITT STEHT WIE JEDE FRAGE DAVOR (14.10.2026, Vorgabe Claras: "das 'Deine
     Auslegung steht' genauso breit wie die Fragen und Antworten machen und an die gleiche
     Stelle packen").

     ZWEI SACHEN STANDEN DEM IM WEG. Erstens die Augenbrauenzeile ueber der Ueberschrift: Jede
     Frage beginnt mit ihrem <h2> ganz oben, hier schob eine Kleinzeile den Titel um gut zwanzig
     Pixel nach unten - der Sprung war genau beim Wechsel von der letzten Frage auf diesen
     Schritt zu sehen. Der Ort steht jetzt im Fliesstext darunter, wo er ohnehin hingehoert.
     Zweitens drei eigene Breiten im Inneren (52ch fuer den Text, 520px fuer den Kasten), die
     schmaler waren als die 680er-Spalte der Fragen. Die Spalte selbst kommt aus dem CSS
     (.qcard>#app>.step), hier muss nur niemand mehr dagegenhalten. */
  rechnerFuss(true);
  app.innerHTML=`<div class="step">
    <h2>Deine Auslegung steht</h2>
    <div class="kwline" style="margin-top:14px">Auslegungsheizlast <b id="auslKw">0,0 kW</b><button type="button" class="kb-info" data-key="info_auslegung" aria-label="Was Auslegung, Deckung und Heizstab bedeuten">ⓘ</button></div>
    <p class="sub" style="margin-top:10px">Das ist die Leistung, die dein Haus am kältesten Tag braucht${r.c && r.c.klima?` &ndash; gerechnet mit der Normaußentemperatur für ${esc(r.c.klima.ort)}`:''}. Sie ergibt sich aus deinen Angaben und bestimmt, welche Kits überhaupt für dich in Frage kommen.</p>
    <p style="margin-top:10px"><button type="button" class="btn quiet" id="auslZettel">Rechenweg Schritt für Schritt ansehen →</button></p>
    <div class="buybox" style="margin:22px 0 0">
      ${schonBekannt
        ? `<p class="sub" style="margin:0 0 12px">Wir schicken dir deine Auswahl an <b>${esc(A.email)}</b>, damit du sie in Ruhe vergleichen kannst.</p>
           <label class="proconsent pflicht" style="margin:12px 0 4px"><input type="checkbox" id="auslOk">${esc(EINWILLIGUNG_TEXT)}<span class="pflicht-stern" aria-hidden="true">*</span></label>
           <label class="proconsent" style="margin:4px 0 4px"><input type="checkbox" id="auslWerbung">${esc(WERBUNG_TEXT)}</label>
           <button class="btn" id="auslGo">Passende Kits anzeigen →</button>
           <p class="fineprint" style="margin-top:8px"><button type="button" class="btn quiet" id="auslMailAendern" style="padding:0;font-size:inherit">Andere Adresse verwenden</button></p>`
        : `<p class="sub" style="margin:0 0 12px">Wohin dürfen wir dir deine passenden Kits schicken? Dann kannst du sie in Ruhe vergleichen, auch später und auf einem anderen Gerät.</p>
           <div class="emailrow"><input type="email" id="auslEmail" placeholder="du@beispiel.de" autocomplete="email" aria-label="E-Mail-Adresse"></div>
           <label class="proconsent pflicht" style="margin:12px 0 4px"><input type="checkbox" id="auslOk">${esc(EINWILLIGUNG_TEXT)}<span class="pflicht-stern" aria-hidden="true">*</span></label>
           <label class="proconsent" style="margin:4px 0 4px"><input type="checkbox" id="auslWerbung">${esc(WERBUNG_TEXT)}</label>
           <button class="btn" id="auslGo" style="margin-top:10px">Passende Kits anzeigen →</button>`}
      <div id="auslDone"></div>
      <p class="fineprint" style="margin-top:10px">Wir nutzen deine Adresse, um dir deine Auswahl zu schicken und auf Rückfragen zu antworten. Keine Weitergabe an Dritte. Werbung bekommst du nur, wenn du sie oben ausdrücklich erlaubst.<br><span class="pflicht-stern" aria-hidden="true">*</span> Pflichtangabe.</p>
    </div>
    ${/* VON VORNE (16.10.2026, Vorgabe Claras: "wenn man es nochmal jetzt machen will, den
          Rechner, dann komplett neue Konfiguration und die neuen Infos - kannst du bitte, wenn
          man beim E-Mail-Gate ist, einen Button einfuegen, der sagt, dass man von vorne
          berechnen will").

          ER LAEDT DIE SEITE MIT ?neu NEU, statt den Zustand im Laufenden zurueckzusetzen. Den
          Werkszustand gibt es seit dem 24.09.2026 genau dafuer: Er loescht den gespeicherten
          Stand und die Sitzungsdaten und raeumt den Parameter danach aus der Adresszeile.
          Ein Zuruecksetzen von Hand muesste alle Felder von A einzeln kennen - und genau die
          Liste ist heute dreimal gewachsen; die naechste neue Frage waere wieder vergessen
          worden.

          UNTER DEM KASTEN UND LEISE: Es ist der Weg zurueck, nicht der Weg weiter. Ein zweiter
          auffaelliger Knopf neben "Passende Kits anzeigen" wuerde um dieselbe Aufmerksamkeit
          werben wie der, der den Kunden ans Ziel bringt. */''}
    <p class="ausl-neu"><button type="button" class="btn quiet" id="auslNeu">Von vorne berechnen &ndash; neue Angaben eingeben</button></p>
  </div>`;

  countUp(document.getElementById('auslKw'), kw);

  /* Der Rechenzettel steht im Layout NEBEN #app (eigener .receipt-wrap), er ueberlebt
     app.innerHTML also und laesst sich von hier aus einfach aufklappen. Auf Schmal-
     bildschirmen liegt er per order:-1 ueber dem Inhalt - openLedger() scrollt hin. */
  const zettel=document.getElementById('auslZettel');
  if(zettel) zettel.onclick=()=>{ track('ledger_open',{step:'auslegung',via:'auslegung'}); if(typeof ledgerStumm==='function') ledgerStumm(); const rc=document.getElementById('receipt'); if(rc){ rc.open=true; rc.scrollIntoView({behavior:'smooth',block:'nearest'}); } };

  const weiter=()=>{ emailGatePassiert=true; renderComparison(r); };

  const aendern=document.getElementById('auslMailAendern');
  if(aendern) aendern.onclick=()=>{ A.email=null; speichereStand(); renderAuslegung(r); };

  /* VON VORNE (16.10.2026). vergissStand() gibt es schon, aber ein Neuladen mit ?neu raeumt
     zusaetzlich die Sitzungsdaten und setzt jede Variable im Skript auf ihren Anfangswert -
     ein Zuruecksetzen im Laufenden muesste dafuer jedes Feld einzeln kennen. */
  const neu=document.getElementById('auslNeu');
  if(neu) neu.onclick=()=>{
    try{ track('rechner_neu',{von:'email_gate'}); }catch(e){}
    const z=(window.BWP_EINZELSEITE==='rechner') ? location.pathname : '/pages/rechner';
    location.href=z+'?neu';
  };

  /* DIE EINWILLIGUNG IST PFLICHT (16.10.2026, Vorgabe Claras: "beim E-Mail-Gate ist die erste
     Auswahl Pflicht ... wenn das nicht ausgewaehlt wurde, dann kann man nicht weiterklicken und
     es kommt so ein Sternchen, dass sagt, dass man das auswaehlen muss").

     BIS HEUTE KAM MAN OHNE HAKEN WEITER und bekam nur seine Konfiguration, sonst nichts -
     so stand es auch im Vermerk weiter unten. Das ist jetzt umgedreht: ohne Haken kein Weiter.

     DER HINWEIS IST KURZ. Clara ausdruecklich: "das musst du nicht als langen Text
     ausschreiben, aber dieses typische Sternchen, das das eigentlich schon aussagt." Also ein
     Stern am Haken, "Pflichtangabe" im Kleingedruckten und beim Klick ohne Haken eine Zeile,
     die sagt, was fehlt - mehr nicht.

     GEPRUEFT WIRD IN BEIDEN ZWEIGEN: Wer seine Adresse schon hinterlassen hat, bekommt kein
     Feld mehr, aber denselben Haken - und muesste ihn sonst nie setzen. */
  const pflichtOk=(done)=>{
    const h=document.getElementById('auslOk');
    if(h && h.checked) return true;
    if(done) done.innerHTML='<div class="banner warn">Bitte setz den Haken mit dem <span aria-hidden="true">*</span>.</div>';
    if(h){ h.closest('.proconsent').classList.add('fehlt'); h.focus(); }
    return false;
  };
  const okHaken=document.getElementById('auslOk');
  if(okHaken) okHaken.addEventListener('change',()=>{
    const l=okHaken.closest('.proconsent'); if(l) l.classList.toggle('fehlt', !okHaken.checked);
    if(okHaken.checked){ const d=document.getElementById('auslDone'); if(d) d.innerHTML=''; }
  });

  const go=document.getElementById('auslGo');
  if(!go) return;
  if(schonBekannt){
    go.onclick=()=>{ if(pflichtOk(document.getElementById('auslDone'))) weiter(); };
    return;
  }

  go.onclick=async()=>{
    const feld=document.getElementById('auslEmail');
    const done=document.getElementById('auslDone');
    const v=(feld.value||'').trim();
    if(!istEmail(v)){
      /* Der Satz nennt den haeufigsten Grund mit: Seit dem 16.10.2026 faellt auch eine formal
         richtige Wegwerf- oder Testadresse durch, und "ungueltig" allein wuerde den Kunden vor
         einem Feld stehen lassen, in dem seiner Meinung nach alles stimmt. */
      done.innerHTML='<div class="banner warn">Bitte gib eine echte E-Mail-Adresse an – an diese schicken wir dir deine Auswahl. Test- und Wegwerfadressen nehmen wir nicht an.</div>';
      feld.focus(); return;
    }
    if(!pflichtOk(done)) return;
    A.email=v; speichereStand();
    /* Riegel VOR dem Versand - gleiche Begruendung wie bei den Wartelisten-Formularen. */
    go.disabled=true;
    done.innerHTML='<div class="banner ok">Einen Moment …</div>';
    track('email_gate_signup',{kw:kw});
    /* Der Lead darf den Kunden NICHT aufhalten. Kommt die Zustellung nicht durch, geht es
       trotzdem weiter: die Adresse steht im gespeicherten Stand und laeuft spaetestens mit
       dem naechsten Lead mit. Ein Kunde, der seine Kits nicht sieht, weil unser Webhook
       klemmt, waere der schlechtere Tausch. */
    /* EIN Lead, nicht zwei. Traegt der Riegel ein Paket, geht er als 'konfiguration_mail'
       raus - damit greift der bestehende Kundenmail-Zweig in n8n unveraendert (er verlangt
       genau diese Stufe, eine Adresse und ein Paket) und im CRM steht eine Zeile MIT
       Konfiguration statt einer ohne. Nur wenn sich kein Paket bilden laesst, bleibt es
       beim reinen 'email_gate' - die Adresse darf auf keinen Fall verlorengehen.
       'anlass' sagt der Mail-Vorlage, dass dies ein Vorschlag ist und keine Bestellung:
       was er am Ende kauft, entscheidet er selbst, aber die noetigen Teile stehen fest. */
    const vpaket=vorschlagsPaket(r);
    const stufe=vpaket?'konfiguration_mail':'email_gate';
    /* DER HAKEN AM RIEGEL (27.08.2026). Bis hierher war der Riegel eine Sackgasse fuer die
       Einwilligung: die Adresse wurde erhoben, gefragt wurde nie. Im CRM landete das
       ununterscheidbar neben den Leuten, die in der Kaufbox ausdruecklich zugestimmt hatten -
       beides als "konfiguration_mail". Wer hier nicht anhakt, kommt trotzdem weiter; er
       bekommt nur seine Konfiguration und sonst nichts. */
    const einOk=document.getElementById('auslOk');
    const eingewilligt=!!(einOk&&einOk.checked);
    /* Zweite, getrennte Einwilligung. Bewusst eigene Felder statt eines zweiten Werts im
       bestehenden - im CRM muss nachweisbar bleiben, WOFUER jemand zugestimmt hat. */
    const werbOk=document.getElementById('auslWerbung');
    const werbung=!!(werbOk&&werbOk.checked);
    const zusatz={
      beratung_ok:eingewilligt,
      einwilligung_text:eingewilligt?EINWILLIGUNG_TEXT:null,
      einwilligung_ts:eingewilligt?new Date().toISOString():null,
      werbung_ok:werbung,
      werbung_text:werbung?WERBUNG_TEXT:null,
      werbung_ts:werbung?new Date().toISOString():null,
      ...(vpaket?{paket:vpaket, anlass:'vorschlag'}:{})
    };
    try { await submitLead(stufe,zusatz); } catch(e) { console.warn('[email_gate] Versand fehlgeschlagen:',e); }
    weiter();
  };
}
function countUp(el,target){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){ el.textContent=fmt(target,1)+" kW"; return; }
  const t0=performance.now(), dur=800;
  function tick(now){
    const p=Math.min(1,(now-t0)/dur), eased=1-Math.pow(1-p,3);
    el.textContent=fmt(Math.round(target*eased*10)/10,1)+" kW";
    if(p<1) requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}

/* Rücksprung in den Funnel nach dem Abschluss. Vorher gab es den nicht: sobald finished gesetzt war,
   führte JEDER Weg (Sticky-CTA, Topbar-Chip, startFunnel) wieder in den Vergleich - wer sich bei
   Verbrauch oder PLZ vertippt hatte, kam ohne Reload nicht mehr an seine Antworten.
   Einstieg ist die letzte Frage; von dort führt der bestehende Zurück-Button zu jeder anderen. */
/* Wie renderComparison: der Weg zurueck in den Funnel raeumt eine offene Tour ab. */
function reopenFunnel(){
  endTour(false);
  /* Antworten aendern heisst: die Vorauswahl ist nicht mehr gueltig. Ohne dieses Zuruecksetzen
     bleibt buyboxPreselectedFor auf demselben Kit stehen und wendeVorauswahlAn() laeuft nie
     wieder - der Kunde saehe dann die Vorauswahl zu seinen ALTEN Antworten. */
  buyboxPreselectedFor=null;
  track('funnel_reopen',{});
  finished=false;
  const grid=document.getElementById('funnelGrid'); if(grid) grid.classList.remove('done');
  const act=activeSteps();
  show(STEPS.indexOf(act[act.length-1]));
  syncReceipt();
  const el=document.getElementById('rechnerCalc'); if(el) el.scrollIntoView({behavior:'smooth',block:'start'});
}
/* ---- Vergleichsansicht (Punkt 1): alle anwendbaren Kandidaten, inkl. Amortisation je Kandidat.
   Kandidaten unter der Schwelle BIVALENT_MIN werden nicht versteckt, sondern sichtbar als unzureichend markiert. ---- */
function amortLineHtml(cand,investExtra=0,investOhneFoerderung=0){
  if(cand.c.mode==='din') return `<div class="amort-line muted">Amortisationsvergleich braucht deinen bisherigen Verbrauch, im Verbrauchsmodus verfügbar.</div>`;
  const am=amortizationFor(cand,investExtra,investOhneFoerderung);
  if(!am) return '';
  const costs=`<div class="amort-costs"><s>${fmt(am.kostenAlt)} €/Jahr</s><span class="arr">→</span><b>${fmt(am.kostenNeu)} €/Jahr</b></div>`;
  const result = am.jahre
    ? `<div class="amort-result">Dadurch amortisiert: in <b>~${fmt(Math.round(am.jahre*10)/10,1)} Jahren</b></div>`
    : `<div class="amort-result muted">Laufende Heizkosten aktuell nicht günstiger, die Ersparnis liegt in den Einbaukosten gegenüber dem Handwerker</div>`;
  return `<div class="amort-line">${costs}${result}</div>`;
}
/* ersatzKit ist nur bei junger Gasheizung belegt (siehe routeAll). Dann tragen ZWEI Karten
   ein Siegel: der Hybrid fuer "Gasheizung bleibt", das Fox-Kit fuer "Gasheizung raus".
   Ohne ersatzKit bleibt alles wie bisher - genau ein Siegel, ohne Zusatz. */
/* EINE Quelle dafuer, ob ein Kit als unpassend gilt - vorher stand dieselbe Bedingung
   doppelt im Code: einmal auf der Kit-Karte (modusabhaengig) und einmal in der Warnung der
   Kaufbox (fest auf der Deckungsregel). Seit die Bivalenz-Regel aktiv ist, widersprachen sich
   beide: ein Kit konnte gleichzeitig "Empfehlung" und "passt nicht zu deinem Setup" tragen.
   (Gemeldet 10.08.2026.) */
function kitUnpassend(cand){
  if(CONFIG.RULES.AUSWAHL==='bivalenz'){
    /* Massstab ist die Lage des Bivalenzpunkts: ueber 0 °C ist die Maschine fuer das Haus
       zu klein. Der Hybrid hat keinen Bivalenzpunkt und behaelt seine eigene Pruefung. */
    return cand.kit==='hybrid' ? cand.sufficient===false : (cand.tbiv!=null && cand.tbiv>0);
  }
  return cand.sufficient===false && !cand.bivalent;
}
/* ============ DIMENSIONS-URTEIL FUER DEN KAUFWEG (08.09.2026, Betreiber-Wunsch) ============
   Der Rechner kannte bisher nur EINE Richtung: kitUnpassend() meldet ein Kit, das fuer das
   Haus ZU KLEIN ist (Bivalenzpunkt ueber 0 Grad). Ueberdimensionierung war nirgends geprueft -
   dabei ist sie der teurere Fehler: eine zu grosse Waermepumpe taktet, das kostet Effizienz
   und Lebensdauer, und der Kunde zahlt zusaetzlich fuer Leistung, die er nie abruft.

   MASSSTAB IST DAS FENSTER, DAS DER RECHNER OHNEHIN BENUTZT. BIV.FENSTER = [-8,-2] entscheidet
   schon heute darueber, welches Kit das Empfohlen-Siegel bekommt (siehe imBivFenster). Hier
   wird dieselbe Grenze nur in beide Richtungen gelesen, statt eine zweite Regel zu erfinden,
   die gegen die erste driften kann:
     tbiv >  -2  ->  knapp bemessen, Heizstab springt frueh an
     tbiv <  -8  ->  reichlich dimensioniert, die Maschine taktet
     dazwischen  ->  in Ordnung, kein Hinweis

   KEIN RIEGEL, NUR EIN HINWEIS. Der blockierende Haken (unsuitOk) bleibt dem harten Fall
   vorbehalten - tbiv ueber 0 Grad, wo das Kit die Wohnung nicht warm bekommt. Wer ein
   groesseres Kit will, als der Rechner vorschlaegt, darf das: es ist seine Anlage und sein
   Geld. Er soll es nur wissen, bevor er zahlt.

   STILL, WENN NICHTS BEKANNT IST. Ohne Funnel-Antworten gibt es keinen Bivalenzpunkt - der
   Direktkauf ueber /pages/produkt laeuft genau so. Dann kommt "unbekannt" zurueck und es
   wird nichts angezeigt. Eine Warnung ohne Datengrundlage waere schlimmer als keine.

   r kann durchgereicht werden, wo es schon berechnet ist (renderBuyBox bekommt es als
   Parameter). Sonst wird es hier geholt - im Kauf-Dialog gibt es keins. */
function dimensionsUrteil(kitKey, r){
  const nichts={status:'unbekannt'};
  if(!kitKey || kitKey==='hybrid' || !PRODUCTS[kitKey]) return nichts;
  if(CONFIG.RULES.AUSWAHL!=='bivalenz') return nichts;
  let route=r;
  if(!route){ try{ route=routeAll(); }catch(e){ return nichts; } }
  const cand=((route&&route.candidates)||[]).find(x=>x.kit===kitKey);
  if(!cand || cand.tbiv==null) return nichts;
  const [unten,oben]=BIV.FENSTER;
  const d={tbiv:cand.tbiv, heizlast:(route.c&&route.c.pausl)||null, kitKw:cand.kitKw,
           heizstabPct:cand.heizstabPct, empfohlen:route.recommended||null};
  if(cand.tbiv>oben)  return {...d, status:'zu_klein'};
  if(cand.tbiv<unten) return {...d, status:'zu_gross'};
  return {...d, status:'ok'};
}
/* Erzeugt den Hinweis oder einen leeren String. hartGezeigt=true unterdrueckt den Fall
   "zu klein" dort, wo der blockierende Riegel dieselbe Aussage schon trifft - zweimal
   dasselbe untereinander liest sich wie ein Fehler in der Seite. */
function dimensionsHinweisHtml(kitKey, r, hartGezeigt){
  const u=dimensionsUrteil(kitKey,r);
  if(u.status==='ok' || u.status==='unbekannt') return '';
  if(u.status==='zu_klein' && hartGezeigt) return '';
  const t=fmt(u.tbiv,1).replace('.',',');
  const hl=u.heizlast!=null ? `${fmt(u.heizlast,1).replace('.',',')} kW Heizlast` : 'deiner Heizlast';
  const rat = (u.empfohlen && u.empfohlen!==kitKey && PRODUCTS[u.empfohlen])
    ? ` Der Rechner empfiehlt dir das <b>${esc(PRODUCTS[u.empfohlen].name)}</b>.` : '';
  if(u.status==='zu_klein'){
    return `<div class="banner warn dimhinweis"><b>Knapp bemessen für dein Haus.</b>
      Bei ${hl} liegt der Bivalenzpunkt dieses Kits bei ${t} °C &ndash; empfohlen sind
      &minus;8 bis &minus;2 °C. Der Heizstab springt damit schon bei milden Außentemperaturen
      an, und der Strom dafür kostet mehr als die Wärmepumpe.${rat}</div>`;
  }
  return `<div class="banner warn dimhinweis"><b>Reichlich dimensioniert für dein Haus.</b>
    Bei ${hl} liegt der Bivalenzpunkt dieses Kits bei ${t} °C &ndash; empfohlen sind
    &minus;8 bis &minus;2 °C. Eine zu große Wärmepumpe läuft in kurzen Takten statt
    durchzulaufen; das senkt Effizienz und Lebensdauer, und du zahlst für Leistung, die
    du nie abrufst.${rat} Kaufen kannst du es trotzdem &ndash; es ist deine Anlage.</div>`;
}
/* =====================================================================
   DIE ERGEBNISSEITE (14.10.2026)

   Vorgabe Claras: "in der HTML, die ich dir geschickt habe, gibt es auch die Ergebnisseite,
   die haben wir jetzt noch gar nicht beruecksichtigt. Kannst du bitte anstatt die jetzige
   Seite nach dem E-Mail-Gate zu der Ergebnisseite der HTML-Datei umwandeln. Das E-Mail-Gate
   soll aber drin bleiben ... also die Empfehlung fuer ein Kit, aber auch die technischen
   Daten dazu."

   SIE ERSETZT renderComparison NICHT, SIE ERWEITERT ES. Die alte Seite war der einzige Weg
   in den Kauf: Die Kit-Karten tragen Preis, Foerderschaetzung, KI-Fussnote, das
   Empfehlungssiegel und den Knopf zur Produktseite. Die Ergebnisseite der HTML-Datei ist ein
   reiner Rechner und hat davon nichts. Haette ich sie eins zu eins uebernommen, haette der
   Funnel am Ergebnis aufgehoert - niemand haette mehr etwas bestellen koennen. Die Karten
   bleiben deshalb, sie bekommen nur die technischen Zahlen dazu; darueber kommt der Kopf mit
   der Empfehlung, das Diagramm und die Heizstab-Rechnung aus der Vorlage.

   DIE ZAHLEN KOMMEN AUS DEM RECHNER DES THEMES, nicht aus einer zweiten Auslegung. routeAll()
   liefert je Kandidat Bivalenzpunkt, Heizstabanteil, Deckung - und seit heute Taktgrenze,
   Heizstabstrom und Heizstabstufe. Eine zweite Rechenstelle waere die sicherste Art, zwei
   verschiedene Ergebnisse auf derselben Seite zu zeigen.
   ===================================================================== */
/* Ganze Zahlen ohne Nachkomma: "taktet ab 12 °C" liest sich besser als "12,0 °C", und eine
   Nachkommastelle verspricht hier eine Genauigkeit, die die Kurve nicht hat. */
function ergT(v){
  if(v==null||!isFinite(v)) return '–';
  const g=Math.round(v*10)/10;
  return fmt(g, Number.isInteger(g)?0:1).replace('.',',').replace('-','−')+' °C';
}
function ergKw(v){ return (v==null||!isFinite(v)) ? '–' : fmt(v,1).replace('.',',')+' kW'; }
/* Die Fox-Kandidaten in der Reihe des Sortiments - dieselbe wie auf dem Kits-Reiter. */
function ergKandidaten(r){
  return [...(r.candidates||[])].filter(x=>x.kit!=='hybrid').sort((a,b)=>kitRang(a.kit)-kitRang(b.kit));
}
/* Welches Kit steht gerade im Diagramm? Vorgabe: die Empfehlung, sonst das kleinste, das
   reicht, sonst das groesste. ergAuswahl haelt die Wahl ueber einen Neuzeichnen-Vorgang. */
let ergAuswahl=null;
function ergAktiv(r){
  const k=ergKandidaten(r); if(!k.length) return null;
  const gewaehlt=k.find(x=>x.kit===ergAuswahl);
  if(gewaehlt) return gewaehlt;
  return k.find(x=>x.kit===r.recommended) || k.find(x=>x.sufficient) || k[k.length-1];
}

/* ---------- Kopf: die Empfehlung in einem Satz ---------- */
function ergHeroHtml(r){
  const ort=r.c.klima?esc(r.c.klima.ort):null;
  const empf=ergKandidaten(r).find(x=>x.kit===r.recommended);
  if(!empf){
    /* DER TITEL SAGT, DASS NICHTS PASST (14.10.2026, Vorgabe Claras: "in den Titel, wenn sie
       nicht passt, schreiben, dass sie nicht passt - und nicht, was sie verbraucht, als
       Catching Title").

       BIS HEUTE STAND HIER DIE KILOWATTZAHL, in jedem Fall dieselbe - auch dann, wenn es gar
       keine Empfehlung gab. Die Zahl ist richtig, aber sie beantwortet die Frage nicht, mit
       der jemand auf diese Seite kommt: passt eine? Sie steht deshalb jetzt im Fliesstext
       darunter, die Antwort steht in der Ueberschrift.

       DREI FAELLE, DREI SAETZE - der Hinweisblock weiter unten nennt die Einzelheiten. */
    const kw = `Dein Haus braucht ${ergKw(r.c.pausl)} am kältesten Tag${ort?` in ${ort}`:''}.`;
    /* REIHENFOLGE: Die Warteliste steht VOR dem Heizstab-Satz. Ueber dem groessten Kit sind
       beide Kennzeichen gesetzt - der Heizstab-Anteil ist dann aber nur die Folge davon, dass
       das Haus zu gross ist, und "zu gross" ist der Satz, den jemand hier lesen muss. */
    if(r.type==='waitlist'){
      return `<h2 class="erg-h">Dein Haus ist <span class="h1-accent">größer</span>, als unsere Kits tragen</h2>
        <p class="erg-lead">${kw} Damit liegst du über unserer größten Größe. Unten siehst du trotzdem, wie nah die Kits kommen &ndash; und wir sagen dir Bescheid, sobald etwas Passendes dazukommt.</p>`;
    }
    if(r.heizstabZuHoch){
      return `<h2 class="erg-h">Zu deinem Haus passt <span class="h1-accent">keine</span> unserer Wärmepumpen</h2>
        <p class="erg-lead">${kw} Selbst die größte Größe müsste ${fmt(r.heizstabMinPct,1).replace('.',',')} % der Jahreswärme über den Heizstab decken. Nach VDI 4645 sollen es höchstens ${CONFIG.RULES.HEIZSTAB_MAX_PCT} % sein &ndash; darüber geht Effizienz verloren, und du heizt zu oft mit teurem Strom statt mit der Wärmepumpe.</p>`;
    }
    return `<h2 class="erg-h">Keine Größe passt <span class="h1-accent">sicher</span> zu deinem Haus</h2>
      <p class="erg-lead">${kw} Wir setzen dir hier bewusst kein Empfehlungssiegel. Unten siehst du, wie nah die vier Größen kommen und woran es liegt &ndash; melde dich gern, bevor du bestellst.</p>`;
  }
  const p=PRODUCTS[empf.kit]||{};
  const allein = (empf.tbiv!=null && r.c.klima && empf.tbiv<=r.c.klima.tn)
    ? `Sie hält dein Haus sogar am kältesten Tag${ort?` in ${ort}`:''} allein warm.`
    : `Sie heizt dein Haus allein, bis es draußen <b>${ergT(empf.tbiv)}</b> hat. Erst darunter hilft der Heizstab mit${r.c.klima?` &ndash; am kältesten Tag${ort?` in ${ort}`:''} rechnen wir mit ${ergT(r.c.klima.tn)}`:''}.`;
  const stufe = empf.hsStufe && empf.hsStufe.stufe>0
    /* WORTLAUT AM 16.10.2026 AUF CLARAS VORGABE GEAENDERT ("Der Heizstab in der Hydrobox
       laeuft auf max 3kW"). Vorher stand dort eine Anweisung - "Stell den Heizstab auf 3 kW" -,
       und das war an dieser Stelle zu viel versprochen: Der Rechner sagt, welche Stufe die
       Auslegung braucht, eingestellt wird sie beim Anlagencheck vom Fachbetrieb. Jetzt eine
       Feststellung ueber das Geraet. Die Zahl bleibt die gerechnete Stufe, nicht die 3 aus
       Claras Beispielsatz - dort stand sie fuer den Fall, den sie gerade vor sich hatte. */
    ? `Der Heizstab in der Hydrobox läuft auf max. <b>${empf.hsStufe.stufe} kW</b>.${empf.hsStufe.reicht?'':' Mehr gibt die Hydrobox nicht her &ndash; am kältesten Tag bleibt eine Lücke.'}`
    : 'Den Heizstab brauchst du rechnerisch nicht &ndash; er bleibt als Reserve.';
  /* "das", nicht "die": Die Kits heissen "DIY-Kit 10 kW" und sind damit saechlich. Die Vorlage
     schrieb "die Fox 5 kW" - dort ist das Geraet gemeint, hier das Paket. */
  /* .erg-kitname NEBEN .h1-accent (15.10.2026, Vorgabe Claras: "die Ueberschrift auch einen
     Umbruch machen, sodass 'DIY Kit 8 kW' eine Zeile drunter steht").

     EINE EIGENE KLASSE UND NICHT .h1-accent, obwohl die gelbe Marke genau dieses Wort traegt:
     Die drei Ueberschriften ohne Empfehlung setzen dieselbe Marke MITTEN in den Satz ("Zu
     deinem Haus passt KEINE unserer Waermepumpen"). Ein Umbruch an .h1-accent wuerde die in
     drei Zeilen zerlegen. Die Klasse markiert also nicht "gelb", sondern "das ist der
     Produktname und steht am Satzende" - nur dort darf er auf eine eigene Zeile. */
  /* DIE BERECHNETE HEIZLAST STEHT IM KOPF (15.10.2026, Vorgabe Claras: "beim Rechner nach der
     E-Mail-Angabe bei den Ergebnissen bitte nach Titel und dem Text die Heizlast, die gerade
     errechnet wurde, dazuschreiben - zwischen Text und 'Stell den Heizstab ...'").

     SIE STAND BISHER NUR IN DEN KENNZAHLEN darunter ("Bedarf am kaeltesten Tag") und im
     E-Mail-Riegel davor. Im Kopf fehlte sie ausgerechnet dort, wo die Empfehlung begruendet
     wird: Der Satz darueber nennt den Bivalenzpunkt, der darunter die Heizstab-Stufe - beide
     folgen aus dieser einen Zahl.

     NUR IM EMPFEHLUNGSFALL: Die drei Ueberschriften ohne Empfehlung tragen sie seit heute
     frueh schon im Fliesstext ("Dein Haus braucht 16,8 kW am kaeltesten Tag"). Dort ein
     zweites Mal waere sie doppelt. */
  return `<h2 class="erg-h">Für dein Haus passt das <span class="h1-accent erg-kitname">${esc(p.name||empf.kit)}</span></h2>
    <p class="erg-lead">${allein}</p>
    <p class="erg-heizlast">Deine berechnete Heizlast: <b>${ergKw(r.c.pausl)}</b> am kältesten Tag${ort?` in ${ort}`:''}.</p>
    <p class="erg-stufe">${stufe}</p>`;
}

/* ---------- Drei Kennzahlen ---------- */
function ergKpiHtml(r){
  const a=ergAktiv(r);
  const ww = r.c.pww>0 ? `davon ${ergKw(r.c.pww)} für Warmwasser` : 'ohne Warmwasser';
  const strom = a ? eur(Math.round((a.heizstabKwh||0)*ergPreisCt()/100)) : '–';
  return `<div class="erg-kpis">
    <div class="erg-kpi"><div class="k">Bedarf am kältesten Tag</div><div class="v">${fmt(r.c.pausl,1).replace('.',',')}<small> kW</small></div><div class="s">${ww}</div></div>
    <div class="erg-kpi"><div class="k">Bivalenzpunkt</div><div class="v">${a?ergT(a.tbiv).replace(' °C','')+'<small> °C</small>':'–'}</div><div class="s">${a?`bis hierhin heizt das ${esc((PRODUCTS[a.kit]||{}).name||a.kit)} allein`:'abhängig von der Größe'}</div></div>
    <div class="erg-kpi"><div class="k">Heizstab-Strom</div><div class="v" id="ergKpiStrom">${strom}</div><div class="s">${a?`im Jahr &middot; ${fmt(a.heizstabPct,1).replace('.',',')} % der Jahreswärme`:'abhängig von der Größe'}</div></div>
  </div>`;
}

/* ---------- Heizstab-Kosten ---------- */
const ERG_PREIS_WP=24, ERG_PREIS_HAUSHALT=37;
let ergPreis=String(ERG_PREIS_WP);
function ergPreisCt(){ const v=zahlAus(ergPreis); return (isFinite(v)&&v>0&&v<200)?v:ERG_PREIS_WP; }
function ergKostenHtml(r){
  const k=ergKandidaten(r);
  const ct=ergPreisCt();
  const zeile=c=>{
    const jahr=Math.round((c.heizstabKwh||0)*ct/100), zwanzig=jahr*20;
    return `<tr${c.kit===r.recommended?' class="rec"':''}>
      <td><b>${esc((PRODUCTS[c.kit]||{}).name||c.kit)}</b><br><span class="m">${c.heizstabPct>0?fmt(c.heizstabPct,1).replace('.',',')+' % Heizstab':'kein Heizstab'}</span></td>
      <td class="opt">${fmt(c.heizstabKwh||0)} kWh</td>
      <td>${eur(jahr)}</td><td>${eur(zwanzig)}</td></tr>`;
  };
  return `<div class="erg-kosten">
    <div class="erg-preiswahl">
      <div class="erg-preis-seg">
        <button type="button" data-ct="${ERG_PREIS_WP}"${ergPreis===String(ERG_PREIS_WP)?' aria-pressed="true"':''}>Wärmepumpentarif ${ERG_PREIS_WP} ct</button>
        <button type="button" data-ct="${ERG_PREIS_HAUSHALT}"${ergPreis===String(ERG_PREIS_HAUSHALT)?' aria-pressed="true"':''}>Haushaltsstrom ${ERG_PREIS_HAUSHALT} ct</button>
      </div>
      <div class="erg-preis-feld"><input type="text" id="ergPreisInput" inputmode="decimal" value="${esc(ergPreis)}" aria-label="Strompreis in Cent je Kilowattstunde"><span>ct/kWh</span></div>
    </div>
    <table class="erg-tab"><thead><tr><td>Größe</td><td class="opt">Heizstab-Strom</td><td>pro Jahr</td><td>20 Jahre</td></tr></thead>
      <tbody id="ergKostenBody">${k.map(zeile).join('')}</tbody></table>
    <p class="fineprint">So rechnen wir: Heizstab-Anteil mal Jahresheizwärme deines Hauses. Der Heizstab macht aus 1 kWh Strom 1 kWh Wärme &ndash; die Wärmepumpe braucht für dieselbe Wärme nur rund ein Drittel. Ohne Warmwasser, Preis über 20 Jahre unverändert gerechnet.</p>
  </div>`;
}
function ergKostenNachziehen(r){
  const body=document.getElementById('ergKostenBody'); if(!body) return;
  const neu=document.createElement('tbody'); neu.id='ergKostenBody';
  neu.innerHTML=ergKostenHtml(r).split('<tbody id="ergKostenBody">')[1].split('</tbody>')[0];
  body.replaceWith(neu);
  const kpi=document.getElementById('ergKpiStrom'), a=ergAktiv(r);
  if(kpi&&a) kpi.textContent=eur(Math.round((a.heizstabKwh||0)*ergPreisCt()/100));
}

/* ---------- Was heisst das? ---------- */
function ergErklaerHtml(){
  return `<div class="erg-erklaer">
    <div class="erg-ek"><h4>Bivalenzpunkt</h4><p>Die Außentemperatur, bis zu der die Wärmepumpe dein Haus allein warm hält. Je tiefer, desto seltener braucht sie Hilfe.</p></div>
    <div class="erg-ek"><h4>Heizstab</h4><p>Ein elektrischer Zusatzheizer in der Hydrobox. Er springt nur an den wenigen sehr kalten Tagen ein. Unter 5 % der Jahreswärme ist ein guter Wert.</p></div>
    <div class="erg-ek"><h4>Warum nicht die größte?</h4><p>Die meisten Tage im Jahr sind mild. Braucht eine Größe gar keinen Heizstab, ist sie überdimensioniert: Sie geht an milden Tagen ständig an und aus. Das kostet Strom und Lebensdauer.</p></div>
  </div>`;
}

/* ---------- Das Diagramm ----------

   ES ZEIGT DREI LINIEN UND ZWEI FLAECHEN: den Waermebedarf des Hauses (faellt mit steigender
   Aussentemperatur auf null an der Heizgrenze), die groesste und die kleinste Leistung des
   gewaehlten Kits, dazwischen den Modulationsbereich, und links vom Bivalenzpunkt die Flaeche,
   die der Heizstab fuellt.

   DIE WERTE KOMMEN AUS DEN FUNKTIONEN, MIT DENEN AUCH GERECHNET WIRD - gebaeudeLast(),
   kitPowerAt(), kitMinPowerAt(). Eine Zeichnung, die ihre eigene Kurve rechnet, waere
   irgendwann eine zweite Wahrheit.

   KEIN DIAGRAMM OHNE KLIMADATEN: Ohne Postleitzahl gibt es keine Norm-Aussentemperatur und
   damit keine x-Achse, an der irgendetwas haengt. */
function ergChartMasse(r,a){
  const schmal=(app&&app.clientWidth||800)<620;
  const tn=r.c.klima.tn;
  /* H WAR 400 / 330 (bis 14.10.2026, Vorgabe Claras "mach das Diagramm kleiner"). Die Breite
     bleibt, weil die x-Achse von -25 bis +20 °C reicht und sonst die Beschriftung kollidiert;
     kleiner wird es ueber die Hoehe und ueber die Deckelung von .erg-chart im CSS.
     ml/mr/mt/mb sind Innenabstaende in denselben Nutzereinheiten - mt und mb bleiben, sonst
     verliert die Legende oben bzw. die Achsenbeschriftung unten ihren Platz. */
  return {schmal, W:schmal?400:720, H:schmal?280:330, ml:schmal?34:46, mr:schmal?12:18, mt:34, mb:44,
    xMin:Math.min(-20,Math.floor(Math.min(tn,a.tbiv==null?tn:a.tbiv)/5)*5-5), xMax:20};
}
function ergChartHtml(r){
  const a=ergAktiv(r);
  if(!a || !r.c.klima || !(r.c.pausl>0)) return '';
  const tn=r.c.klima.tn, tg=heizgrenze(r.c.san);
  const {W,H,ml,mr,mt,mb,xMin,xMax,schmal}=ergChartMasse(r,a);
  const last=t=>gebaeudeLast(r.c.pausl,tn,t,tg);
  const wpMax=t=>kitPowerAt(a.kit,t)||0;
  const wpMin=t=>kitMinPowerAt(a.kit,t)||0;
  const stufe=a.hsStufe&&a.hsStufe.stufe>0?a.hsStufe.stufe:null;
  const yTop=Math.max(last(xMin), wpMax(xMax), stufe?wpMax(xMin)+stufe:0);
  const schritt=yTop>24?5:yTop>12?4:2;
  const yMax=Math.ceil(yTop*1.06/schritt)*schritt||2;
  const X=t=>ml+(t-xMin)/(xMax-xMin)*(W-ml-mr);
  const Y=p2=>mt+(1-p2/yMax)*(H-mt-mb);
  const ts=[]; for(let t=xMin;t<=xMax+1e-9;t+=0.5) ts.push(Math.round(t*10)/10);
  const pts=f=>ts.map(t=>`${X(t).toFixed(1)},${Y(f(t)).toFixed(1)}`);
  const pfad=f=>'M'+pts(f).join('L');
  const band=`<polygon points="${pts(wpMax).concat(pts(wpMin).reverse()).join(' ')}" fill="var(--sand)"/>`;
  let flaeche='';
  const links=ts.filter(t=>a.tbiv!=null&&t<=a.tbiv);
  if(a.tbiv!=null && a.tbiv>xMin && links.length>1){
    const oben=links.map(t=>`${X(t).toFixed(1)},${Y(last(t)).toFixed(1)}`);
    const unten=links.slice().reverse().map(t=>`${X(t).toFixed(1)},${Y(Math.min(last(t),wpMax(t))).toFixed(1)}`);
    flaeche=`<polygon points="${oben.concat(unten).join(' ')}" fill="var(--rost)" stroke="var(--ink)" stroke-width="1.1" stroke-linejoin="round"/>`;
  }
  let raster='',xt='',yt='';
  for(let p2=0;p2<=yMax+1e-9;p2+=schritt){
    raster+=`<line x1="${ml}" x2="${W-mr}" y1="${Y(p2)}" y2="${Y(p2)}" stroke="var(--line)" stroke-width="1"/>`;
    yt+=`<text x="${ml-8}" y="${Y(p2)+4}" text-anchor="end" font-size="12" fill="var(--muted)">${p2}</text>`;
  }
  for(let t=Math.ceil(xMin/5)*5;t<=xMax;t+=5){
    raster+=`<line x1="${X(t)}" x2="${X(t)}" y1="${mt}" y2="${Y(0)}" stroke="var(--line)" stroke-width="1"/>`;
    xt+=`<text x="${X(t)}" y="${H-mb+18}" text-anchor="middle" font-size="12" fill="var(--muted)">${String(t).replace('-','−')}</text>`;
  }
  const bivDrin = a.tbiv!=null && a.tbiv>=xMin && a.tbiv<tg;
  const taktDrin = a.taktAb!=null && a.taktAb<tg;
  return `<div class="erg-chart" id="ergChart">
    <svg viewBox="0 0 ${W} ${H}" role="img" aria-label="Wärmebedarf und Leistung der ${esc((PRODUCTS[a.kit]||{}).name||a.kit)} über der Außentemperatur. Bivalenzpunkt ${ergT(a.tbiv)}.">
      <defs><clipPath id="ergPlot"><rect x="${ml}" y="${mt}" width="${W-ml-mr}" height="${H-mt-mb}"/></clipPath></defs>
      <style>.erg-chart text{paint-order:stroke;stroke:var(--card);stroke-width:4px;stroke-linejoin:round}</style>
      ${raster}
      <g clip-path="url(#ergPlot)">
        ${band}${flaeche}
        ${stufe?`<path d="${pfad(t=>wpMax(t)+stufe)}" fill="none" stroke="var(--ink)" stroke-width="2" stroke-dasharray="7 5"/>`:''}
        <path d="${pfad(wpMin)}" fill="none" stroke="var(--ink)" stroke-width="2" stroke-dasharray="2 4" stroke-linecap="round"/>
        <path d="${pfad(last)}" fill="none" stroke="var(--bernstein)" stroke-width="3" stroke-linecap="round"/>
        <path d="${pfad(wpMax)}" fill="none" stroke="var(--ink)" stroke-width="3.2" stroke-linecap="round"/>
      </g>
      <line x1="${ml}" x2="${W-mr}" y1="${Y(0)}" y2="${Y(0)}" stroke="var(--ink)" stroke-width="1.2"/>
      <line x1="${ml}" x2="${ml}" y1="${mt}" y2="${Y(0)}" stroke="var(--ink)" stroke-width="1.2"/>
      <line x1="${X(tn)}" x2="${X(tn)}" y1="${mt-8}" y2="${Y(0)}" stroke="var(--ink)" stroke-width="1.2" stroke-dasharray="6 4"/>
      <text x="${Math.max(X(tn),schmal?64:84)}" y="${mt-14}" text-anchor="middle" font-size="${schmal?11:12}" font-weight="800" fill="var(--ink)">Kältester Tag ${ergT(tn)}</text>
      <line x1="${X(tg)}" x2="${X(tg)}" y1="${mt-8}" y2="${Y(0)}" stroke="var(--muted)" stroke-width="1.2" stroke-dasharray="6 4"/>
      <text x="${Math.min(X(tg),W-mr-(schmal?48:60))}" y="${mt-14}" text-anchor="middle" font-size="${schmal?11:12}" font-weight="700" fill="var(--muted)">Heizgrenze ${ergT(tg)}</text>
      ${taktDrin?`<circle cx="${X(a.taktAb)}" cy="${Y(last(a.taktAb))}" r="5.5" fill="var(--card)" stroke="var(--ink)" stroke-width="2.2"/>
        <text x="${X(a.taktAb)+9}" y="${Y(last(a.taktAb))-9}" font-size="12" font-weight="700" fill="var(--ink)">taktet ab ${ergT(a.taktAb)}</text>`:''}
      ${bivDrin?`<circle cx="${X(a.tbiv)}" cy="${Y(Math.min(last(a.tbiv),wpMax(a.tbiv)))}" r="7.5" fill="var(--ink)" stroke="var(--card)" stroke-width="3"/>
        <text x="${X(a.tbiv)+4}" y="${Y(Math.min(last(a.tbiv),wpMax(a.tbiv)))-15}" text-anchor="middle" font-size="13.5" font-weight="800" fill="var(--ink)">${ergT(a.tbiv)}</text>`:''}
      ${yt}${xt}
      <text x="${ml-8}" y="${mt-14}" text-anchor="end" font-size="12" fill="var(--muted)">kW</text>
      <text x="${W-mr}" y="${H-6}" text-anchor="end" font-size="12" fill="var(--muted)">Außentemperatur in °C</text>
      <line id="ergCross" x1="0" x2="0" y1="${mt}" y2="${Y(0)}" stroke="var(--ink)" stroke-width="1" visibility="hidden"/>
      <rect id="ergHit" x="${ml}" y="${mt}" width="${W-ml-mr}" height="${H-mt-mb}" fill="transparent"/>
    </svg>
    <div class="erg-tip" id="ergTip"></div>
  </div>
  <div class="erg-legende">
    <span><i class="lg-linie lg-last"></i>Wärmebedarf deines Hauses</span>
    <span><i class="lg-linie lg-wp"></i>${esc((PRODUCTS[a.kit]||{}).name||a.kit)}, größte Leistung</span>
    <span><i class="lg-linie lg-min"></i>kleinste Leistung &ndash; darunter taktet sie</span>
    <span><i class="lg-band"></i>Modulationsbereich</span>
    ${stufe?`<span><i class="lg-linie lg-stufe"></i>mit ${stufe} kW Heizstab</span>`:''}
    <span><i class="lg-flaeche"></i>Heizstab hilft</span>
  </div>`;
}
function ergChartBinden(r){
  const box=document.getElementById('ergChart'); if(!box) return;
  const a=ergAktiv(r); if(!a||!r.c.klima) return;
  const svg=box.querySelector('svg'), tip=document.getElementById('ergTip'), cross=document.getElementById('ergCross');
  const tn=r.c.klima.tn, tg=heizgrenze(r.c.san);
  const {W,ml,mr,xMin,xMax}=ergChartMasse(r,a);
  const bewegen=ev=>{
    const kasten=svg.getBoundingClientRect();
    const px=(ev.clientX-kasten.left)/kasten.width*W;
    let t=xMin+(px-ml)/(W-ml-mr)*(xMax-xMin);
    t=Math.max(xMin,Math.min(xMax,Math.round(t*2)/2));
    const bedarf=gebaeudeLast(r.c.pausl,tn,t,tg), wp=kitPowerAt(a.kit,t)||0, wpm=kitMinPowerAt(a.kit,t)||0;
    const hs=Math.max(0,bedarf-wp);
    const zustand = bedarf<=0 ? 'Heizung aus' : hs>0.05 ? 'Heizstab hilft' : bedarf<wpm ? 'taktet' : 'läuft durch';
    const x=ml+(t-xMin)/(xMax-xMin)*(W-ml-mr);
    cross.setAttribute('x1',x); cross.setAttribute('x2',x); cross.setAttribute('visibility','visible');
    tip.innerHTML=`<div class="t">Bei ${ergT(t)}: ${zustand}</div>
      <div class="z"><span>Wärmebedarf</span><b>${ergKw(bedarf)}</b></div>
      <div class="z"><span>größte Leistung</span><b>${ergKw(wp)}</b></div>
      <div class="z"><span>kleinste Leistung</span><b>${ergKw(wpm)}</b></div>
      <div class="z"><span>Heizstab</span><b>${hs>0.05?ergKw(hs):'–'}</b></div>`;
    tip.style.display='block';
    const bx=(x/W)*kasten.width;
    const links=bx+14+tip.offsetWidth>kasten.width ? bx-14-tip.offsetWidth : bx+14;
    tip.style.left=Math.max(0,links)+'px'; tip.style.top='40px';
  };
  const weg=()=>{ tip.style.display='none'; cross.setAttribute('visibility','hidden'); };
  svg.addEventListener('pointermove',bewegen);
  svg.addEventListener('pointerdown',bewegen);
  svg.addEventListener('pointerleave',weg);
}

function candidateCardHtml(cand,recommendedKit,ersatzKit,alleZuKlein,keineSicher){
  const p=PRODUCTS[cand.kit];
  const isRec = cand.kit===recommendedKit;
  const isErsatz = !!ersatzKit && cand.kit===ersatzKit && !isRec;
  const nachBivalenz = CONFIG.RULES.AUSWAHL==='bivalenz';
  /* Im Bivalenz-Modus entscheidet nicht mehr die 80-%-Deckung, ob ein Kit als unpassend
     markiert wird, sondern die Lage des Bivalenzpunkts: ueber 0 °C ist die Maschine fuer das
     Haus zu klein. Alles dazwischen ist brauchbar, nur eben nicht optimal - dafuer gibt es
     den Hinweis statt einer Abwertung. */
  /* ALLE VIER TRAGEN DAS ABZEICHEN, WENN KEINE PASST (14.10.2026, Vorgabe Claras: "wenn keine
     Waermepumpe passt, dann auch bei allen 4 Auswahlen anzeigen, dass die zu klein ist").

     kitUnpassend() allein reicht dafuer nicht: Es misst die Lage des Bivalenzpunkts, und die
     ist bei 16 kW Heizlast fuer alle vier noch unter 0 °C - formal also "brauchbar", obwohl
     der Heizstab uebers Jahr mehr als die erlaubten 5 % traegt. Ohne diese Zeile stuenden
     vier Karten ohne jede Markierung unter einer Ueberschrift, die sagt, dass keine passt.

     DAS HYBRID-KIT BLEIBT AUSSEN VOR: Es faellt nicht unter die 5-%-Regel (kein Heizstab in
     diesem Sinn), und wo es passt, gibt es ohnehin eine Empfehlung - dann ist alleZuKlein
     gar nicht gesetzt. */
  const zuKlein = kitUnpassend(cand) || (!!alleZuKlein && cand.kit!=='hybrid');
  /* KEIN KIT IM BIVALENZFENSTER (15.10.2026, Vorgabe Claras: "wenn keine Groesse sicher passt,
     dann mach die Auswahl der Kits im Ergebnis auch transparent, und markiere auch da, dass
     die nicht sicher passen").

     ES IST EIN ANDERER BEFUND ALS "ZU KLEIN", und deshalb traegt er einen anderen Satz. Am
     14.10.2026 war dieser Fall hier noch ausgenommen, und zwar mit Grund: Liegt kein
     Bivalenzpunkt im Fenster [-8, -2], sind die Kits fuer das Haus meistens zu GROSS - sie
     takten an milden Tagen. "Fuer dein Haus zu klein" waere an diesen Karten schlicht falsch.
     Die Ueberschrift sagt "Keine Groesse passt SICHER zu deinem Haus", und genau das steht
     jetzt auch auf den Karten.

     ZU KLEIN SCHLAEGT UNSICHER: Eine Karte mit Bivalenzpunkt ueber 0 Grad ist auch in diesem
     Fall zu klein, und das ist die genauere Auskunft. Nur die uebrigen bekommen den
     allgemeinen Hinweis. */
  const unsicher = !zuKlein && !!keineSicher && cand.kit!=='hybrid';
  const insufficient = zuKlein || unsicher;
  /* Zusatzzeile mit Bivalenzpunkt und Jahresenergie-Anteil des Heizstabs. Bewusst der
     JAHRES-Anteil und nicht der Leistungsanteil bei T_norm: nur der erste ist die Groesse,
     auf die sich VDI 4645 bezieht (rund 5 % bei Bivalenzpunkt -5 °C).
     ACHTUNG, die Zahl an dieser Stelle hiess bis zum 14.10.2026 "Grenze 25 %" - das war der
     Leistungsanteil bei Norm-Aussentemperatur, nicht der Jahresanteil. Seit Claras Vorgabe
     ist die Grenze CONFIG.RULES.HEIZSTAB_MAX_PCT = 5 % und gilt auf genau die Zahl, die hier
     in der Zeile steht. */
  let bivLine='';
  if(nachBivalenz && cand.tbiv!=null){
    /* "rund", wenn die Heizgrenztemperatur geschaetzt werden musste, weil der Sanierungsstand
       nicht abgefragt wurde. Lieber ein ehrliches Ungefaehr als eine Nachkommastelle,
       die eine Genauigkeit vorgibt, die es hier nicht gibt. */
    const hs = cand.heizstabPct==null ? ''
      : ` · Heizstab ${cand.tgGeschaetzt?'rund ':''}${fmt(cand.heizstabPct,1).replace('.',',')} % der Jahresarbeit`;
    bivLine = `<div class="cc-biv${cand.imFenster?' ok':''}">Bivalenzpunkt ${fmt(cand.tbiv,1).replace('.',',')} °C${hs}</div>`;
  }
  const covLine = cand.kit==='hybrid'
    ? (cand.sufficient ? `MHG Beistell-WP zur bestehenden Gasheizung` : `MHG Beistell-WP · setzt Gasheizung ab Baujahr 2016 voraus`)
    : `${fmt(cand.kitKw,2).replace('.',',')} kW${cand.c.klima?` bei ${fmt(cand.c.klima.tn,1).replace('.',',')} °C`:''} · Deckung ${Math.round(cand.coverage*100)} %${cand.bivalent?' · Spitzenlast über Heizstab':''}`;
  const badgeLabel = cand.kit==='hybrid' ? 'Nicht optimal für dein Setup'
    : (unsicher ? 'Passt nicht sicher'
    : (nachBivalenz ? 'Für dein Haus zu klein' : 'Deckung zu gering'));
  /* Kleine Förder-Zeile direkt auf der Karte (User-Entscheid 15.07.2026): der Effektivpreis nach
     KfW-458-Schätzung, nur aufs Kit gerechnet, dezent unterm Preis. Nur wenn Einkommen bekannt. */
  const q=foerderQuote();
  let ccFoerder='';
  if(q){
    const betrag=Math.round(Math.min(p.price,foerderKostenCap())*q/100/10)*10;
    ccFoerder=`<div class="cc-foerder">nach Förderung ~ ${eur(Math.max(0,p.price-betrag))}*</div>`;
  }
  /* Zwei-Wege-Fall: das Siegel sagt nicht mehr nur DASS, sondern WOFUER empfohlen wird.
     Ohne den zweiten Weg bleibt es beim schlichten "Empfehlung". */
  const siegel = isRec ? (ersatzKit ? 'Empfehlung · beistellen' : 'Empfehlung')
    : (isErsatz ? 'Empfehlung · ersetzen' : null);
  /* DIE GANZE KARTE IST DER KNOPF (14.10.2026, Vorgabe Claras: "'Tippe eine Groesse an, um sie
     im Diagramm zu sehen' bitte entfernen und eher schreiben 'Tippe eine Groesse an, um deine
     Konfiguration zu starten' - dann fuehrt das zu der Produktseite").
     Bis dahin tat ein Tipp auf die Karte gar nichts: Das Diagramm haengt an den Reitern
     darueber, nicht an den Karten. Der Satz versprach also schon vorher etwas, das es nicht
     gab. role und tabindex, damit die Flaeche auch ohne Maus erreichbar bleibt; der Knopf
     unten bleibt stehen und ist weiterhin der sichtbare Weg. */
  return `<div class="candcard reveal klickbar${isRec||isErsatz?' rec':''}${insufficient?' insuff':''}" data-kit="${cand.kit}" role="link" tabindex="0" aria-label="${esc(p.name)} wählen">
    ${siegel?`<div class="cc-badge">${siegel}</div>`:(insufficient?`<div class="cc-badge warn">${badgeLabel}</div>`:'')}
    <img src="${IMG[cand.kit]}" alt="${esc(p.name)}">
    <div class="cc-name">${esc(p.name)}${kiStern(cand.kit)}</div>
    <div class="cc-cov m">${covLine}</div>
    ${bivLine}
    ${/* DIE TECHNISCHEN DATEN AUF DER KARTE (14.10.2026, Vorgabe Claras: "also die Empfehlung
          fuer ein Kit, aber auch die technischen Daten dazu").

          VIER ZAHLEN, DIE DIE GROESSEN UNTERSCHEIDEN - und zwar in beide Richtungen: Bis wohin
          die Waermepumpe allein heizt und was der Heizstab im Jahr kostet, sprechen fuer das
          groessere Geraet; ab wann es taktet, gegen das zu grosse. Ohne die letzte Zahl liest
          sich die Karte wie "je groesser, desto besser", und genau das stimmt nicht.

          NUR BEI DEN FOX-KITS: Das Hybrid-Kit ist eine Beistelloesung ohne Bivalenzpunkt in
          diesem Sinn - dort stuenden vier Striche. */''}
    ${cand.kit!=='hybrid' && cand.tbiv!=null ? `<div class="cc-fakten">
      <div><span>heizt allein bis</span><b>${ergT(cand.tbiv)}</b></div>
      <div><span>Heizstab-Strom</span><b>${cand.heizstabKwh>0?eur(Math.round(cand.heizstabKwh*ergPreisCt()/100))+'<small> /Jahr</small>':'0 €'}</b></div>
      <div><span>Anteil Heizstab</span><b>${fmt(cand.heizstabPct||0,1).replace('.',',')} %</b></div>
      <div><span>taktet ab</span><b>${cand.taktAb!=null&&cand.taktAb<15?ergT(cand.taktAb):'–'}</b></div>
    </div>
    ${(()=>{ /* Der Balken zeigt, welchen Teil der Spitzenlast das Geraet selbst traegt. */
      const anteil=Math.min(1,(cand.kitKw||0)/(cand.c.pausl||1));
      const hs=Math.max(0,(cand.c.pausl||0)-(cand.kitKw||0));
      return `<div class="cc-deckung" aria-label="Am kältesten Tag: Wärmepumpe ${ergKw(Math.min(cand.kitKw,cand.c.pausl))}, Heizstab ${ergKw(hs)}">
        <div class="ccd-bahn"><div class="ccd-wp${hs<=0?' voll':''}" style="width:${Math.round(anteil*100)}%"></div>${hs>0?'<div class="ccd-hs"></div>':''}</div>
        <div class="ccd-text"><span>Kältester Tag: WP ${ergKw(cand.kitKw)}</span><span>${hs>0?'Heizstab '+ergKw(hs):'Reserve '+ergKw((cand.kitKw||0)-(cand.c.pausl||0))}</span></div>
      </div>`; })()}` : ''}
    ${amortLineHtml(cand)}
    <div class="cc-price"><span class="ab">ab</span> ${eur(p.price)}${p.vorlaeufig?'<span class="tag">Preis vorläufig</span>':''}</div>
    ${ccFoerder}
    <button class="btn" id="cand-${cand.kit}">${esc(p.name)} wählen →</button>
  </div>`;
}
function renderComparison(r){
  /* Zurueck zum Vergleich beendet eine laufende Tour: sonst bliebe ihr Overlay ueber der
     neuen Ansicht stehen und wuerde jede spaetere Tour blockieren. Ohne Merker - der Kunde
     hat die Tour nicht weggeklickt, er hat nur die Ansicht gewechselt. */
  endTour(false);
  track("comparison_view",{type:r.type,recommended:r.recommended,candidates:r.candidates.map(x=>x.kit),kw:r.c&&r.c.pausl});
  currentCand=null; syncSticky();
  if(!r.candidates.length) return renderWaitlistForm(r);
  /* IMMER NACH LEISTUNG, NIE NACH EIGNUNG (Vorgabe 17.09.2026).

     Clara: "die Ordnung nach kW-Groesse soll so bleiben, aber das Kit das empfohlen wird soll
     immer noch gekennzeichnet werden, aber halt auf der Position wo das Kit eh schon stand."

     VORHER SORTIERTE DER BIVALENZ-MODUS die Kits im Fenster nach vorn und darin nach Abstand
     zu -5 °C. Das zog die Empfehlung aus der Reihe heraus an den Anfang - gedacht war es als
     Hilfe, gelesen wurde es als andere Reihenfolge. Und weil dieselben vier Kits auf dem
     Kits-Reiter nach Groesse standen, wirkte der Vergleich wie eine andere Produktwelt.

     Jetzt steht ueberall dieselbe Reihe (KIT_REIHE). Die Empfehlung ist damit nicht mehr an
     der Position ablesbar, sondern nur noch am Siegel - was sie ohnehin traegt, und was
     ehrlicher ist: Die Reihenfolge ist eine Eigenschaft der Geraete, keine Meinung.

     WAS DAMIT ENTFAELLT: Unpassende Kits rutschen nicht mehr ans Ende. Sie bleiben sichtbar
     und waehlbar wie bisher und tragen ihr eigenes Abzeichen mit dem Grund - die Information
     geht also nicht verloren, sie steht nur nicht mehr in der Reihenfolge. */
  const sorted=[...r.candidates].sort((a,b)=>kitRang(a.kit)-kitRang(b.kit));
  const cards=sorted.map(cand=>candidateCardHtml(cand,r.recommended,r.ersatzEmpfehlung,r.heizstabZuHoch,r.dimPruefen)).join('');
  /* ZWEI WEGE (User-Vorgabe 07.08.2026): Bei einer Gasheizung nach 2016 stehen zwei
     verschiedene Entscheidungen zur Wahl, nicht vier Produkte. Ohne diesen Block sah der
     Kunde ein Empfohlen-Siegel auf dem billigsten Kit und keinen Hinweis darauf, dass
     das eine Beistelloesung ist - die Gasheizung also bleibt.
     Bewusst ohne Foerder-Aussage: ob der Klimabonus beim Beistellen ueberhaupt greift,
     ist noch nicht belegt (siehe Meldung an Joey 07.08.2026). Lieber nichts sagen als
     etwas versprechen, das im Bescheid dann fehlt. */
  const ersatzName = r.ersatzEmpfehlung ? (PRODUCTS[r.ersatzEmpfehlung]||{}).name : null;
  const zweiWege = r.hybridFits ? `
    <div class="zweiwege reveal">
      <div class="zw-kopf">Zwei Wege &ndash; beide sind für dich möglich</div>
      <p class="zw-sub">Deine Gasheizung ist von nach 2016. Sie ist zu jung, um sie einfach rauszuwerfen &ndash; also hast du wirklich die Wahl.</p>
      <div class="zw-grid">
        <div class="zw-karte">
          <div class="zw-titel">Beistellen</div>
          <p>Die Gasheizung bleibt drin. Die Wärmepumpe übernimmt den größten Teil des Jahres, das Gas springt nur an den kältesten Tagen ein. Günstiger in der Anschaffung, dafür bleiben zwei Systeme im Haus.</p>
          <div class="zw-kit">Dafür: ${esc(PRODUCTS.hybrid.name)} mit MHG-Wärmepumpe &middot; ab ${eur(PRODUCTS.hybrid.price)}</div>
        </div>
        <div class="zw-karte">
          <div class="zw-titel">Ersetzen</div>
          <p>Die Gasheizung kommt raus. Nur noch ein System im Haus, kein Gasvertrag, keine zweite Wartung. Höhere Investition, dafür bist du vom Gaspreis unabhängig.</p>
          <div class="zw-kit">${ersatzName?`Dafür: ${esc(ersatzName)} &middot; ab ${eur(PRODUCTS[r.ersatzEmpfehlung].price)}`:'Dafür reicht bei deiner Heizlast keins unserer Kits &ndash; sprich uns an.'}</div>
        </div>
      </div>
      <p class="zw-fuss">Beide Wege stehen unten als Karte. Du kannst dich jederzeit anders entscheiden &ndash; nichts ist damit festgelegt.</p>
    </div>` : '';
  rechnerFuss(false);
  app.innerHTML=`<div class="step compare-step">
    ${/* Kopf linksbuendig wie jede Funnel-Frage davor (User-Vorgabe 30.07.2026). Zentriert
          brach die Ueberschrift auf dem Handy in eine zweite Zeile mit einem einzelnen Wort
          in der Mitte - und der Blick sprang zwischen Frage- und Ergebnisschritt hin und her.
          Die Kit-Karten darunter bleiben mittig: dort steht ein zentriertes Produktbild
          obendrueber, linksbuendiger Text darunter saehe daneben aus. */''}
    ${/* DIE SPALTE (14.10.2026, Vorgabe Claras: "das 'Deine Auslegung steht' genauso breit wie
          die Fragen und Antworten machen und an die gleiche Stelle packen - das gleiche auch
          bei den Ergebnissen ... der rote Hinweis soll gleich breit zum anderen Text sein, und
          die Legende der Grafik auch").

          ALLES, WAS TEXT IST, STEHT IN .erg-spalte - derselben 680er-Spalte, in der jede Frage
          davor stand. Vorher trug jedes Stueck seine eigene Breite: der Hinweis 640, die
          Bildunterschrift 720, das Diagramm 640, die Legende die vollen 1040. Fuenf Kanten auf
          einer Seite.

          AUSSERHALB DER SPALTE BLEIBEN GENAU ZWEI SACHEN: die vier Kit-Karten ("die Groessen im
          Vergleich, aber alle 4 nebeneinander lassen" - in 680 px passen nur zwei) und das
          Kaestchenpaar darunter. */''}
    <div class="erg-spalte">
    ${ergHeroHtml(r)}
    <div class="editanswers"><button type="button" class="btn quiet" id="editAnswers">← Antworten ändern</button></div>
    ${ergKpiHtml(r)}
    ${r.type==='waitlist'?`<div class="banner warn erg-band">${esc(r.reason)} Trotzdem: hier siehst du, wie nah die Kits kommen.</div>`:''}
    ${/* Zwei Heizkreise: das Hybrid-Kit steht gar nicht mehr in der Liste (siehe routeAll).
          Ohne diesen Hinweis waere die Karte fuer den Kunden einfach kommentarlos weg -
          und er haette sie, bei junger Gasheizung, sonst als Empfehlung bekommen. */''}
    ${r.hybridEntfallen?`<div class="banner warn erg-band">Für Häuser mit Fußbodenheizung <b>und</b> Heizkörpern haben wir aktuell keine Hybrid-Lösung. Trag dich unten ein, wir melden uns, sobald es passt.</div>`:''}
    ${/* Vorgabe 31.07.2026: liegt kein Kit im Fenster [-8 °C, -2 °C], gibt es bewusst KEIN
          Empfohlen-Badge, sondern diesen Hinweis. Der Kunde kann trotzdem jedes Kit waehlen -
          es ist ein Hinweis, keine Sperre. */''}
    ${r.heizstabZuHoch && r.type!=='waitlist'?`<div class="banner warn erg-band"><b>Heizstab-Anteil zu groß:</b> Bei ${fmt(r.c.pausl,1).replace('.',',')} kW Heizlast müsste selbst das größte unserer Kits ${fmt(r.heizstabMinPct,1).replace('.',',')} % der Jahreswärme über den Heizstab erzeugen. Nach VDI 4645 sollen es höchstens ${CONFIG.RULES.HEIZSTAB_MAX_PCT} % sein. Wir empfehlen dir deshalb keine unserer Wärmepumpen &ndash; der Heizstab-Anteil ist sehr groß, und dadurch geht Effizienz verloren. Sprich uns an, bevor du bestellst.</div>`:''}
    ${r.dimPruefen?`<div class="banner warn erg-band"><b>Dimensionierung prüfen:</b> Bei ${fmt(r.c.pausl,1).replace('.',',')} kW Heizlast liegt der Bivalenzpunkt bei jedem unserer Kits außerhalb des empfohlenen Bereichs von −8 bis −2 °C. Wir sprechen das vor der Bestellung mit dir durch, statt hier eine Empfehlung zu setzen, die nicht trägt.</div>`:''}
    ${zweiWege}
    ${/* DAS DIAGRAMM STEHT VOR DEN KARTEN, nicht dahinter: Es erklaert die Zahlen, die auf den
          Karten stehen. Wer es erst danach sieht, hat die Karten schon verglichen, ohne zu
          wissen, was "Bivalenzpunkt" und "taktet ab" bedeuten. Ohne Klimadaten faellt es
          lautlos weg - dann gibt es keine Achse, an der etwas haengt. */''}
    ${ergChartHtml(r) ? `<div class="erg-block">
      <div class="erg-kopf"><h3>So deckt die Wärmepumpe deinen Wärmebedarf</h3>
        <div class="erg-tabs" id="ergTabs">${ergKandidaten(r).map(k=>
          `<button type="button" class="erg-tab${k.kit===ergAktiv(r).kit?' sel':''}" data-kit="${k.kit}">${esc((PRODUCTS[k.kit]||{}).name||k.kit)}</button>`).join('')}</div>
      </div>
      <p class="erg-sub">Je kälter es draußen ist, desto mehr Wärme braucht dein Haus (bernsteinfarbene Linie). Die Wärmepumpe regelt ihre Leistung im hellen Band stufenlos. Wo sich Bedarf und größte Leistung kreuzen, liegt der Bivalenzpunkt &ndash; links davon hilft der Heizstab. Rechts, wo der Bedarf unter die kleinste Leistung fällt, geht sie an und aus. Fahr mit Maus oder Finger über das Diagramm.</p>
      ${ergChartHtml(r)}
    </div>` : ''}
    </div>
    <div class="erg-kopf"><h3>Alle Größen im Vergleich</h3><span class="m">Tippe eine Größe an, um deine Konfiguration zu starten.</span></div>
    <div class="compare-grid" id="compareGrid">${cards}</div>
    <p class="fineprint" style="margin-top:14px">Alle Preise inkl. MwSt.${foerderQuote()?' · *Förder-Schätzung nach KfW 458, unverbindlich.':''}</p>
    ${kiFussnoteHtml(sorted.map(x=>x.kit))}
    ${/* AUFKLAPPBAR seit dem 14.10.2026 (Vorgabe Claras). Mit <details>, nicht mit einem
          eigenen Schalter: Der Inhalt steht auch zugeklappt im DOM, ergKostenBinden() findet
          seine Knoepfe und das Preisfeld also unveraendert - und ergKostenNachziehen() kann
          die Tabelle austauschen, ohne dass jemand sie gesehen haben muss. */''}
    ${/* ZWEI KAESTEN NEBENEINANDER (14.10.2026, Vorgabe Claras: "kannst du beim Ergebnis des
          Rechners auch das 'Was heisst das?' ausklappbar machen - und dann 'Was kostet der
          Heizstab' und 'Was heisst das' nebeneinander machen, gerne auch in Kaesten").
          Sie stehen bewusst NICHT in der Textspalte: Zwei Kaesten in 680 px waeren je 332 px
          breit, und in die passt die vierspaltige Kostentabelle nicht. */''}
    ${ergKandidaten(r).length ? `<div class="erg-paar">
      <details class="erg-auf" id="ergKostenBlock">
        <summary><h3>Was kostet der Heizstab?</h3><span class="m">Stromkosten je Größe &ndash; Preis anpassbar</span></summary>
        ${ergKostenHtml(r)}
      </details>
      <details class="erg-auf" id="ergErklaerBlock">
        <summary><h3>Was heißt das?</h3><span class="m">Bivalenzpunkt, Heizstab, Größe</span></summary>
        ${ergErklaerHtml()}
      </details>
    </div>` : ''}
    ${(r.type==='waitlist'||r.hybridEntfallen)?`<div class="buybox" style="max-width:520px;margin:24px auto 0"><p class="sub" style="margin-bottom:10px">${r.hybridEntfallen&&r.type!=='waitlist'?'Sag uns Bescheid, dann melden wir uns, sobald es eine Hybrid-Lösung für zwei Heizkreise gibt.':'Keins davon passt genug? Wir sagen Bescheid, sobald sich das ändert.'}</p><div class="emailrow"><input type="email" id="wEmail" value="${esc(A.email||'')}" placeholder="du@beispiel.de"></div><div class="emailrow" style="margin-top:8px"><input type="tel" id="wTel" placeholder="Telefon" autocomplete="tel" required aria-required="true"></div><p class="fineprint" style="margin-top:6px">Beides brauchen wir: Sobald ein passendes Kit da ist, melden wir uns &ndash; und das geht am schnellsten telefonisch.</p><button class="btn" id="wGo" style="margin-top:8px">Auf die Warteliste →</button><div id="wDone"></div></div>`:''}
  </div>`;
  /* WICHTIG: .candcard trägt die Klasse .reveal (opacity:0 per default), aber triggerEnterAnimation()
     für das 'rechner'-Panel ist schon beim ersten showPanel()-Aufruf gelaufen - lange bevor diese
     Karten existierten. Ohne diesen Aufruf bleiben sie unsichtbar (außer zufällig durch die
     .insuff-Opacity-Regel überschrieben). Root Cause des "Kit X fehlt"-Bugs. */
  triggerEnterAnimation('rechner');
  /* DIE DREI BEDIENTEILE DER ERGEBNISSEITE (14.10.2026). Jedes haengt an Elementen, die es nur
     gibt, wenn der zugehoerige Block gezeichnet wurde - deshalb jedes Mal die Pruefung. */
  ergChartBinden(r);
  const ergTabs=document.getElementById('ergTabs');
  if(ergTabs) ergTabs.querySelectorAll('.erg-tab').forEach(b=>{
    b.onclick=()=>{
      ergAuswahl=b.dataset.kit;
      track('ergebnis_kit_ansehen',{kit:ergAuswahl});
      /* Neu zeichnen statt nur das Diagramm zu tauschen: Kopf und Kennzahlen haengen an
         derselben Wahl, und renderComparison ist der eine Weg, auf dem sie entstehen. */
      renderComparison(r);
    };
  });
  const ergFeld=document.getElementById('ergPreisInput');
  if(ergFeld) ergFeld.addEventListener('input',()=>{ ergPreis=ergFeld.value; ergKostenNachziehen(r); });
  document.querySelectorAll('.erg-preis-seg button').forEach(b=>{
    b.onclick=()=>{
      ergPreis=b.dataset.ct;
      if(ergFeld) ergFeld.value=ergPreis;
      document.querySelectorAll('.erg-preis-seg button').forEach(x=>x.removeAttribute('aria-pressed'));
      b.setAttribute('aria-pressed','true');
      ergKostenNachziehen(r);
    };
  });
  document.getElementById('editAnswers').onclick=reopenFunnel;
  r.candidates.forEach(cand=>{
    const btn=document.getElementById('cand-'+cand.kit);
    if(!btn) return;
    /* "… wählen" fuehrt seit dem 16.09.2026 auf die PRODUKTSEITE (Vorgabe), nicht mehr in die
       Kaufbox hier darunter. Dort steht der Konfigurator mit Bildern, Beschreibung, Material,
       Services und dem Weg zur Kasse - also alles, was nach der Kit-Wahl kommt. Die Kaufbox
       hier war eine zweite, engere Fassung davon.

       Die Antworten reisen mit: speichereStand() schreibt sie weg, ladeStand() holt sie auf
       der Produktseite zurueck, und der Konfigurator setzt daraus die Haken (siehe
       autowahlAnwenden). Der Kunde beantwortet also nichts zweimal.

       RUECKFALL auf die Kaufbox, wenn kein Shopify-Produkt hinterlegt ist - dann gaebe es
       keine Seite, auf die man schicken koennte. */
    const los=ev=>{
      if(ev) ev.stopPropagation();
      const u=produktUrl(cand.kit);
      if(!u) return selectCandidate(cand,r);
      track('kit_gewaehlt',{kit:cand.kit, ziel:'produktseite'});
      try{ speichereStand(); }catch(e){}
      /* DER MERKER FUER DEN RUECKWEG (14.10.2026, Vorgabe Claras: "wenn man auf dieser
         Produktseite ist und dann zurueck geht, geht man zum Ergebnis des Rechners zurueck,
         also zu der Auswahl, und nicht zu der normalen Uebersicht der Kits").

         sessionStorage und nicht die Adresszeile: Der Rueckweg gilt fuer diesen Besuch, nicht
         fuer einen Link, den jemand weitergibt. Wer die Produktseite geteilt bekommt, soll
         "Zurueck zu den Kits" sehen und nicht in einen fremden Rechnerstand geschickt werden.
         Dieselbe Begruendung wie beim Paket-Rueckweg weiter unten. */
      try{ sessionStorage.setItem(ERG_RUECKWEG, cand.kit); }catch(e){}
      location.href=u;
    };
    btn.onclick=los;
    /* Die Karte selbst - ausser auf dem Knopf, der stopPropagation macht, und ausser auf
       Verweisen darin (der KI-Stern fuehrt in die Fussnote). */
    const karte=btn.closest('.candcard');
    if(karte){
      karte.onclick=ev=>{ if(ev.target.closest('a,button')) return; los(ev); };
      karte.onkeydown=ev=>{ if(ev.key==='Enter'||ev.key===' '){ ev.preventDefault(); los(ev); } };
    }
  });
  const wGo=document.getElementById('wGo');
  if(wGo) wGo.onclick=async()=>{
    const v=document.getElementById('wEmail').value, done=document.getElementById('wDone');
    if(!istEmail(v)){
      done.innerHTML=`<div class="banner warn">Bitte gib eine E-Mail-Adresse an, unter der wir dich erreichen.</div>`;
      document.getElementById('wEmail').focus(); return;
    }
    /* Telefon Pflicht (User-Entscheid 10.08.2026), Format offen - wie bei Superkunde und
       Fachbetrieb. Wer auf der Warteliste steht, ist genau der Kunde, den wir zurueckrufen
       wollen, sobald sich am Sortiment oder an der Auslegungsregel etwas aendert. Bis hierhin
       war die Warteliste der letzte Weg, auf dem uns eine Nummer entging. */
    const wTelFeld=document.getElementById('wTel');
    const wTel=wTelFeld?wTelFeld.value.trim():'';
    if(wTelFeld && !wTel){
      done.innerHTML=`<div class="banner warn">Wir brauchen noch deine Telefonnummer &ndash; sobald ein passendes Kit da ist, melden wir uns.</div>`;
      wTelFeld.focus(); return;
    }
    A.email=v; speichereStand(); track("waitlist_signup",{});
    done.innerHTML=`<div class="banner ok">Wird gesendet …</div>`;
    /* Riegel VOR dem Versand (25.08.2026).
       Vorher stand der Riegel erst hinter dem await. submitLead() braucht gegen n8n je nach
       Netz 250 ms bis 1,3 s - in diesem Fenster blieb der Knopf klickbar, und ein zweiter
       Klick erzeugte einen zweiten Datensatz. Im CRM stehen dadurch nachweislich Doppel:
       dieselbe Adresse zweimal im Abstand von 51 Sekunden. Die beiden anderen Formulare
       (hwGo 4326, kmGo) sperren bereits vorher - hier war es schlicht vergessen.
       Die Zeile hinter dem await bleibt: sie gibt den Knopf bei MISSERFOLG wieder frei. */
    wGo.disabled=true;
    const ok=await submitLead("waitlist_signup",{tel:wTel||null,grund:r.hybridEntfallen?'hybrid_zwei_heizkreise':'kein_passendes_kit'});
    done.innerHTML= ok ? `<div class="banner ok">Du stehst drauf.</div>`
      : `<div class="banner warn">Das hat gerade nicht geklappt, bitte später nochmal versuchen.</div>`;
    wGo.disabled=ok;
  };
}
/* Topic 4: PLZ-Superkunden-Interstitial. Fuer Kunden aus bestimmten PLZ-Gebieten fragen wir
   zwischen Funnel-Ende und Checkout-Start, ob sie einer der ersten "Superkunden" werden wollen -
   volle Begleitung durch den Bauprozess. Nicht blockierend (Ja/Nein), einmal pro Session gefragt. */
const SUPERKUNDE_PLZ_PREFIXES=['50','51','52','53']; // Koeln-Raum, Stand 24.07.2026 - bei Bedarf erweitern
function isSuperkundePLZ(){
  const plz=String(A.plz||'').trim();
  return SUPERKUNDE_PLZ_PREFIXES.some(p=>plz.startsWith(p));
}
function renderSuperkundeInterstitial(cand,r){
  track('superkunde_view',{kit:cand.kit,plz:A.plz});
  app.innerHTML=`<div class="step">
    <button class="btn quiet" id="skBack" style="margin-bottom:6px">← Zurück zum Vergleich</button>
    <div class="verdict">
      <div class="v-eyebrow">Erste Superkunden gesucht</div>
      <h2>Willst du einer unserer ersten Superkunden werden?</h2>
      <div class="kwline">In deiner Region begleiten wir ein paar erste Bauprojekte besonders eng.</div>
    </div>
    <div class="buybox">
      <div class="beleg">Als Superkunde begleiten wir dich Schritt für Schritt durch den kompletten Bauprozess – enger als im normalen Ablauf, von der Planung bis zur Inbetriebnahme. Ganz unverbindlich und ohne Aufpreis.</div>
      <div class="emailrow" style="margin-top:16px"><input type="email" id="skEmail" placeholder="du@beispiel.de"></div>
      <div class="emailrow" style="margin-top:8px"><input type="tel" id="skTel" placeholder="Telefon" autocomplete="tel" required aria-required="true"></div>
      <p class="fineprint" style="margin-top:6px">Beides brauchen wir: Die enge Begleitung läuft übers Telefon, kurz anrufen schlägt fünf Mails.</p>
      <button class="btn" id="skYes" style="margin-top:10px">Ja, ich will Superkunde werden →</button>
      <button class="btn quiet" id="skNo" style="margin-top:10px;width:100%">Nein danke, weiter zum Angebot</button>
      <div id="skDone"></div>
    </div>
  </div>`;
  const markAsked=()=>sessionStorage.setItem('bwp_superkunde_asked','1');
  document.getElementById('skBack').onclick=()=>renderComparison(r);
  document.getElementById('skNo').onclick=()=>{ markAsked(); track('superkunde_decline',{kit:cand.kit}); renderBuyBox(cand,r); };
  document.getElementById('skYes').onclick=async()=>{
    const v=document.getElementById('skEmail').value, done=document.getElementById('skDone'), go=document.getElementById('skYes');
    /* Sagt jetzt auch etwas. Solange nur das Telefonfeld eine Meldung hatte, sah eine
       falsche Adresse aus wie ein kaputter Knopf: Klick, und nichts passiert. */
    if(!istEmail(v)){
      done.innerHTML=`<div class="banner warn">Bitte gib eine E-Mail-Adresse an, unter der wir dich erreichen.</div>`;
      document.getElementById('skEmail').focus(); return;
    }
    /* Pflichtfeld (User-Entscheid 07.08.2026): die Superkunden-Begleitung laeuft ueber
       das Telefon, ohne Nummer ist das Versprechen nicht einloesbar.
       BEWUSST OHNE FORMATPRUEFUNG (ebenfalls User-Entscheid): "0171 / 234 56 78",
       "+49(0)171-2345678" oder eine Nummer mit dem Zusatz "ab 18 Uhr" sind alle
       brauchbar. Ein strenges Muster wuerde echte Interessenten aussperren, und die
       Nummer landet ohnehin bei einem Menschen, nicht in einer Telefonanlage.
       Geprueft wird nur, DASS etwas dasteht. */
    const telFeld=document.getElementById('skTel');
    const tel=telFeld.value.trim();
    if(!tel){
      done.innerHTML=`<div class="banner warn">Wir brauchen noch deine Telefonnummer &ndash; die Begleitung läuft übers Telefon.</div>`;
      telFeld.focus(); return;
    }
    A.email=v; speichereStand();
    /* Die Nummer geht NICHT ins Tracking - Rufnummern haben in GA4-Parametern nichts verloren.
       Ein Merker "Nummer war dabei" waere jetzt auch sinnlos: seit dem Pflichtfeld ist er
       immer true und wuerde nur einen der 50 GA4-Parameterplaetze belegen. */
    track('superkunde_signup',{kit:cand.kit,plz:A.plz});
    done.innerHTML=`<div class="banner ok">Wird gesendet …</div>`;
    const ok=await submitLead('superkunde_signup',{kit_gewaehlt:cand.kit,plz:A.plz,tel});
    done.innerHTML= ok ? `<div class="banner ok">Danke! Wir melden uns bei dir, sobald es losgeht.</div>`
      : `<div class="banner warn">Das hat gerade nicht geklappt, bitte später nochmal versuchen.</div>`;
    go.disabled=true; markAsked();
    setTimeout(()=>renderBuyBox(cand,r),1100);
  };
}
/* Die Kartenwahl IST die Scope-Antwort (Beistell vs. Komplett) - keine extra Frage nötig.
   installMode bestimmt den restlichen Pfad: diy → Warenkorb (unverändert), pro → Lead-Capture,
   Superkunde-PLZ (noch nicht in dieser Session gefragt) → Interstitial vor der Buybox. */
function selectCandidate(cand,r){
  chosenCandidate=cand;
  const scope = cand.kit==='hybrid' ? 'beistell' : 'komplett';
  track("candidate_select",{kit:cand.kit,scope,installMode:A.installMode});
  /* SUPERKUNDEN-ABFRAGE IST HIER RAUS (User-Entscheid 10.08.2026).
     Sie stand zwischen Kit-Wahl und Kaufbox und hat den Kauffluss unterbrochen, um etwas zu
     fragen, das mit dem Kauf nichts zu tun hat. Der Weg dorthin ist jetzt: erst kaufen, dann
     fragen - per Mail nach der Bestellung. renderSuperkundeInterstitial() bleibt im Code, wird
     aber von nirgends mehr aufgerufen; die Vorlage fuer die Mail kann sich daran orientieren. */
  if(A.installMode==='pro') renderProLead(cand,r,scope);
  else renderBuyBox(cand,r);
}

/* Hardware/Service-Mini-Wizard: schaltet die zwei .bb-step-Container innerhalb der Buybox um, ohne
   neu zu rendern (updateTotal/cmUpdateTotal bleiben die einzige Berechnungsquelle). prefix ist "bb"
   fuer den Rechner-Funnel (renderBuyBox) bzw. "cm" fuer das Direktkauf-Modal (renderCartModalIncluded)
   - gleiche Funktion, nur andere ID-Praefixe (Modal nutzt ueberall "cm..." als Konvention). */
/* Die Pflicht-Services sind vorausgewaehlt, damit die Foerderung nicht durch ein vergessenes
   Haekchen verfaellt. In der Warenkorb-Schublade standen sie dadurch von Anfang an - drei
   Positionen, die niemand ausgesucht hatte, noch bevor der Kunde den Schritt ueberhaupt
   gesehen hat. Sie erscheinen dort jetzt erst, wenn er bei den Services angekommen ist
   (Vorgabe 14.09.2026).

   Der Merker faellt nicht wieder zurueck: Wer nach dem Blick auf die Services noch einmal zur
   Hardware zurueckgeht, soll nicht zusehen, wie die Summe im Warenkorb unter seinen Haenden
   schrumpft. Gesehen ist gesehen. */
let servicesErreicht=false;
function wireStepNav(prefix){
  const box=prefix==='cm' ? document.getElementById('cartModalBody') : document.querySelector('.buybox');
  if(!box) return;
  const hwStep=box.querySelector('.bb-step[data-step="hardware"]'), svcStep=box.querySelector('.bb-step[data-step="service"]');
  const toService=document.getElementById(prefix+'ToService'), toHardware=document.getElementById(prefix+'ToHardware');
  const label=document.getElementById(prefix+'MiniStepLabel');
  /* Kurzer Cross-Slide statt stummem hidden-Toggle: der aktuelle Step faehrt raus, DANACH faehrt
     der Ziel-Step von der Gegenseite rein (Reflow-Trick, wie an anderer Stelle im Code fuer .flash/
     .in genutzt) - macht den Wizard-Wechsel spuerbar statt wie ein Sprung. */
  /* IM KASTEN NICHT SCROLLEN (Vorgabe 15.09.2026). Der Dialog fuellt den Bildschirm und hat
     eine eigene Scrollflaeche - dort ist das Anfahren des neuen Schritts richtig. Der Kasten
     steht mitten auf der Produktseite: Dasselbe Anfahren zieht die ganze Seite ein Stueck
     nach unten, obwohl der Kasten schon im Bild ist. Man klickt einen Reiter und verliert die
     Stelle, an der man gerade war. */
  const imKasten = prefix==='cm' && !!document.querySelector('#cartModal.kauf-inline');
  const go=step=>{
    const showEl=step==='hardware'?hwStep:svcStep, hideEl=step==='hardware'?svcStep:hwStep;
    /* Zaehlt mit, statt nur zu benennen: der Kunde soll sehen, wo er steht und wie viel noch kommt. */
    if(label) label.textContent = step==='hardware' ? 'Schritt 1/2 · Bauteile' : 'Schritt 2/2 · Services';
    /* Der Zurueck-Knopf sitzt in der klebenden Kopfleiste und faehrt mit - vorher stand er
       im Inhalt und war nach 700px Scrollen 360px ausserhalb des Bildes. */
    if(toHardware) toHardware.hidden = (step==='hardware');
    if(!showEl||!hideEl||hideEl.classList.contains('hidden')){
      if(hwStep) hwStep.classList.toggle('hidden', step!=='hardware');
      if(svcStep) svcStep.classList.toggle('hidden', step!=='service');
      syncSticky();   /* NACH dem Umschalten: syncSticky liest den aktiven Schritt aus dem DOM */
      if(showEl && !imKasten) showEl.scrollIntoView({behavior:'smooth',block:'start'});
      if(step==='service') startCheckoutWalkthrough(prefix==='cm'?'modal':'funnel','service');
      return;
    }
    hideEl.classList.add('bb-leave');
    setTimeout(()=>{
      hideEl.classList.add('hidden'); hideEl.classList.remove('bb-leave');
      showEl.classList.remove('hidden');
      syncSticky();   /* NACH dem Umschalten: syncSticky liest den aktiven Schritt aus dem DOM */
      showEl.classList.add('bb-enter');
      void showEl.offsetWidth;
      showEl.classList.remove('bb-enter');
      if(!imKasten) showEl.scrollIntoView({behavior:'smooth',block:'start'});
      /* Zweite Tour genau hier: der Services-Block ist jetzt sichtbar und ausgerichtet. Frueher
         gestartet wuerde der Spotlight auf ein noch verstecktes oder wanderndes Element zielen. */
      if(step==='service') startCheckoutWalkthrough(prefix==='cm'?'modal':'funnel','service');
    },220);
  };
  if(toService) toService.onclick=()=>{
    /* DER WUNSCHSTART IST PFLICHT, BEVOR ES ZU DEN SERVICES GEHT (16.10.2026, Vorgabe Claras:
       "mach die Frage 'ab wann moechtest du starten' bitte als Pflicht zu beantworten, bevor
       es zu Services geht").

       AN DIESER STELLE UND NICHT AM KAUFKNOPF: Der Wizard hat genau zwei Schritte, und die
       Frage steht im ersten. Am Kaufknopf zu pruefen hiesse, den Kunden durch den ganzen
       zweiten Schritt zu lassen und ihn dann zurueckzuschicken - zwei Bildschirme zurueck zu
       einer Frage, die er laengst hinter sich glaubte.

       GEPRUEFT WIRD AUCH DER KALENDERWERT (21.10.2026, Vorgabe Claras: "... und wenn es eine
       konkrete Woche, Datum, dass man das auch auswaehlen muss"). Bis dahin reichte die Wahl
       im Auswahlfeld: Wer "Bestimmte Woche" nahm und keine anklickte, kam durch, und in der
       Bestellung stand eine Woche-Wahl ohne Woche.

       SEIT DEM 28.10.2026 GILT DAS AUCH FUER "SOBALD ES GEHT" (Vorgabe Claras). Dort war das
       Datum vorher freiwillig. Die Regel lautet jetzt schlicht: Wer einen Kalender aufmacht,
       schliesst ihn auch - welche Wahl einen aufmacht, steht in KALENDER in
       bwp-startwunsch.js.

       WELCHE WAHL EINEN WERT BRAUCHT, WEISS DAS MODUL - BwpStartwunsch.fehltWas(). Die Regel
       gehoert dorthin, wo der Kalender gebaut wird; hier stuende sonst eine zweite Liste der
       Modi, die beim naechsten neuen Zeitraum auseinanderlaeuft. Faellt das Modul aus, gilt
       die alte, schwaechere Pruefung - lieber durchlassen als den Kunden aussperren.

       KEINE ROTE WARNUNG, SONDERN DER SPRUNG ZUR FRAGE samt Markierung: Der Knopf steht am
       unteren Ende eines langen Kastens, die Frage weiter oben. Eine Meldung am Knopf saehe der
       Kunde, die Frage nicht. */
    const startLuecke = window.BwpStartwunsch
      ? BwpStartwunsch.fehltWas(startZustand())
      : (A.startWunsch ? null : 'wahl');
    if(startLuecke){
      /* DIE HUELLE TRAEGT DIE id SELBST (.startwunsch, siehe bwp-startwunsch.js html()) - ein
         closest() darauf liefe ins Leere. Erst nachgesehen, dann geschrieben; die erste Fassung
         suchte eine Klasse .bwpstart, die es nicht gibt. */
      const kasten=document.getElementById(prefix==='cm'?'cmStartWunsch':'startWunsch');
      if(kasten){
        kasten.classList.add('fehlt');
        kasten.scrollIntoView({behavior:'smooth',block:'center'});
        /* Den Blick dorthin lenken, wo die Luecke IST: Steht die Wahl schon und fehlt nur der
           Kalenderwert, waere ein Sprung ins Auswahlfeld die Aufforderung, etwas zu aendern,
           das stimmt. */
        if(startLuecke==='wahl'){
          const sel=kasten.querySelector('select'); if(sel){ try{ sel.focus({preventScroll:true}); }catch(e){ sel.focus(); } }
        }else{
          const kal=kasten.querySelector('.bwpkal');
          if(kal) kal.scrollIntoView({behavior:'smooth',block:'center'});
        }
      }
      try{ track('bb_step_blockiert',{grund:'startwunsch',luecke:startLuecke,path:prefix}); }catch(e){}
      return;
    }
    track('bb_step',{step:'service',path:prefix});
    if(!servicesErreicht){
      servicesErreicht=true;
      /* Neu zeichnen UND neu zaehlen: Die Zahl am Knopf zaehlt Positionen, und die Schublade
         faehrt bei Zuwachs von selbst auf - hier kommen drei auf einmal dazu. */
      try{ bwpKorbZeichnen(); bwpKorbZahl(); }catch(e){}
    }
    go('service');
  };
  if(toHardware) toHardware.onclick=()=>{ track('bb_step',{step:'hardware',path:prefix}); go('hardware'); };
}
/* Topic 5: Chat-Maskottchen - Rohrzange mit Augen, im Linien-Icon-Stil der Seite (vgl. ICONS/I()
   weiter oben: currentColor-Strich, keine Fremdfarben). Eigene Funktion statt Eintrag in ICONS, weil
   die Augen per CSS blinzeln (.mascot-eye) - ICONS-Einträge sind reine statische Strichzeichnungen. */
/* Der kleine Hilfe-Knopf braucht ein eigenes Zeichen (16.09.2026): das Maskottchen ist seit
   heute die Marke des Chats und darf nicht gleichzeitig fuer den menschlichen Weg stehen -
   zwei Knoepfe nebeneinander mit demselben Bild sind keine Wahl, sondern eine Dopplung. */
function frageSVG(size){
  return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="9.5" stroke="currentColor" stroke-width="2"/>
    <path d="M9.2 9.3a2.9 2.9 0 1 1 3.6 2.8c-.5.2-.8.7-.8 1.2v.6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <circle cx="12" cy="17.2" r="1.2" fill="currentColor"/>
  </svg>`;
}
function mascotSVG(size){
  return `<svg width="${size}" height="${size}" viewBox="0 0 64 64" fill="none" aria-hidden="true" class="mascot-svg">
    <rect x="25" y="33" width="14" height="27" rx="7" stroke="currentColor" stroke-width="3"/>
    <rect x="13" y="9" width="38" height="27" rx="13" fill="var(--paper)" stroke="currentColor" stroke-width="3"/>
    <path d="M20 11 15 3M44 11 49 3" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
    <circle cx="49" cy="23" r="4" stroke="currentColor" stroke-width="2.5"/>
    <circle class="mascot-eye" cx="24" cy="23" r="4" fill="currentColor"/>
    <circle class="mascot-eye" cx="40" cy="23" r="4" fill="currentColor"/>
  </svg>`;
}
/* Hilfe-Fallback im Service-Step: kleiner CTA transformiert sich animiert in drei Optionen.
   Telefon/Chat sind bewusst als funktionierender Mini-Fallback gebaut (Chat nutzt die bestehende
   submitLead()-Pipeline), keine tote UI-Attrappe - nur die echte Telefonnummer ist noch Platzhalter
   (CONFIG.SUPPORT_PHONE). Fachbetrieb nutzt denselben Vamo-Link/Tracking wie renderProLead(). */
/* ============ WISSENS-CHAT (15.09.2026) ============
   Spricht den n8n-Fluss hinter CONFIG.CHAT_ENDPOINT an. Der Bot antwortet NUR aus der
   hinterlegten Wissensdatenbank; alles andere beantwortet er mit einem Verweis. Das ist
   Absicht und dort serverseitig erzwungen - hier wird nichts nachgebessert.

   Die Sitzungskennung haelt den Verlauf im Protokoll zusammen. Sie liegt im localStorage,
   damit ein Seitenwechsel sie nicht zerreisst, und ist bewusst keine Kennung des Kunden:
   sie sagt nur "dieselbe Unterhaltung", nicht "dieselbe Person". */
const CHAT_SCHLUESSEL='bwp_chat_sid';
function chatBereit(){
  const e=String(CONFIG.CHAT_ENDPOINT||'');
  return !!e && !e.startsWith('TBD_');
}
function chatSitzung(){
  try{
    let id=localStorage.getItem(CHAT_SCHLUESSEL);
    if(!id){
      id='c-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,8);
      localStorage.setItem(CHAT_SCHLUESSEL,id);
    }
    return id;
  }catch(e){
    /* Privater Modus: dann eben eine fluechtige Kennung. Lieber ein Protokolleintrag ohne
       Zusammenhang als eine Unterhaltung, die gar nicht erst zustande kommt. */
    return 'c-fluechtig-'+Math.random().toString(36).slice(2,8);
  }
}
/* Woher die Frage kommt - hilft beim Lesen des Protokolls, ohne etwas zu verraten. */
function chatSeite(prefix){
  const teile=[prefix||'seite'];
  const h=(location.hash||'').slice(1); if(h) teile.push(h);
  if(typeof chosenCandidate!=='undefined' && chosenCandidate && chosenCandidate.kit) teile.push(chosenCandidate.kit);
  return teile.join('/');
}
/* LINKS IN TOMMYS ANTWORTEN (16.10.2026, Wunsch Janniks: "links zu weiterfuehrenden seiten direkt
   verlinkt"). Tommy nennt am Ende die Seite, auf der es steht, als nackte Adresse - bisher nur
   Text zum Abtippen.
   WEITERHIN KEIN innerHTML: Der Text wird an den Adressen zerlegt, jedes Stueck als Textknoten
   gesetzt, nur die Adresse selbst wird ein <a>. Verlinkt wird ausschliesslich die eigene Domain
   ueber https. Jede andere Adresse bleibt Text: Was ein Sprachmodell schreibt, soll niemanden
   auf eine fremde Seite schicken koennen.
   Neuer Tab, weil der Verlauf nicht gespeichert wird - im selben Tab waere die Unterhaltung beim
   Klick weg. Satzzeichen am Ende gehoeren zum Satz, nicht zur Adresse. */
const CHAT_LINK=/https?:\/\/(?:www\.)?billigerwaermepumpe\.de(?:\/[^\s<>"'„“”‚‘’()\[\]{}]*)?/g;
function chatTextSetzen(el,text){
  text=String(text==null?'':text);
  el.textContent='';
  let pos=0, m;
  CHAT_LINK.lastIndex=0;
  while((m=CHAT_LINK.exec(text))){
    const roh=m[0].replace(/[.,;:!?…]+$/,'');
    let url=null;
    try{
      const u=new URL(roh);
      if(/^(www\.)?billigerwaermepumpe\.de$/.test(u.hostname)){ u.protocol='https:'; url=u.href; }
    }catch(e){}
    if(!url) continue;
    if(m.index>pos) el.appendChild(document.createTextNode(text.slice(pos,m.index)));
    const a=document.createElement('a');
    a.href=url; a.target='_blank'; a.rel='noopener';
    a.textContent=roh.replace(/^https?:\/\//,'');
    el.appendChild(a);
    pos=m.index+roh.length;
  }
  if(pos<text.length) el.appendChild(document.createTextNode(text.slice(pos)));
}
async function chatFrage(text, prefix){
  const antwort = await fetch(CONFIG.CHAT_ENDPOINT,{
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({ session_id:chatSitzung(), message:text, page_context:chatSeite(prefix) })
  });
  if(!antwort.ok) throw new Error('HTTP '+antwort.status);
  const d = await antwort.json();
  return { text:String((d&&d.answer)||'').trim(), risiko: !!(d&&d.risk_flag) };
}
/* Der Satz, mit dem Tommy an einen Menschen uebergibt. An einer Stelle, damit die beiden
   Sackgassen (keine Antwort / Dienst weg) nicht auseinanderlaufen, und damit die
   Erreichbarkeit nur einmal im Code steht. Ohne gepflegte Nummer bleibt der Weg uebrig,
   der ohne sie funktioniert. */
function helpTelSatz(auftakt){
  const tel=String(CONFIG.SUPPORT_PHONE||'');
  if(!tel || tel.startsWith('TBD_'))
    return auftakt+' Schreib uns \u00fcber "Nachricht schreiben", dann antwortet dir jemand pers\u00f6nlich.';
  return auftakt+' Ruf uns an: '+tel+' \u2013 am besten zwischen 16 und 18 Uhr. '
       + 'Oder schreib uns \u00fcber "Nachricht schreiben", dann antwortet dir jemand pers\u00f6nlich.';
}
function renderHelpCta(prefix){
  const el=document.getElementById(prefix+'HelpCta'); if(!el) return;
  const phoneReady=!String(CONFIG.SUPPORT_PHONE).startsWith('TBD_');
  /* tel:-Ziel ohne Leerzeichen - die lesbare Schreibweise steht nur in der Anzeige. */
  const telHref='tel:'+String(CONFIG.SUPPORT_PHONE).replace(/\s+/g,'');
  el.innerHTML=`<div class="help-cta">
    <button type="button" class="btn quiet help-ask">Brauchst du Hilfe?</button>
    <div class="help-options hidden">
      ${/* DIE ERREICHBARKEIT STEHT AN DER NUMMER (19.10.2026, Vorgabe Claras: "bei dem
            Hilfe-Button unten rechts bitte bei dem Telefon einen Hinweis schreiben: am besten
            erreichbar zwischen 16 - 18 Uhr und immer per E-Mail").

            AN DER ZEILE UND NICHT ALS FUENFTER PUNKT: Wer die Nummer liest, soll im selben
            Blick sehen, wann jemand drangeht.

            JEDE KACHEL TRAEGT IHREN EIGENEN HINWEIS (19.10.2026, Clara: "den Hinweis 'per
            Mail erreichst du uns jederzeit' bitte unter 'Nachricht schreiben'"). Bis dahin
            stand der Mail-Satz als Fusszeile unter der ganzen Reihe und zeigte von dort auf
            eine Kachel daneben - jetzt steht er in ihr. Der Umbruch vor der Uhrzeit ist
            gesetzt und nicht dem Zufall der Kachelbreite ueberlassen: "Am besten erreichbar /
            16-18 Uhr" trennt die Aussage von der Zeit, ein Umbruch mitten in "erreichbar
            16-18" waere beides halb. */''}
      ${/* DIE REIHENFOLGE IST VORGEGEBEN (26.10.2026, Clara: "ganz oben soll in gross Tommy
            stehen, da drunter dann Nachricht schreiben und dann der Link zum Fachbetrieb [...]
            unter den Fachbetrieb-Button stelle die Telefonnummer").

            Sie laeuft vom schnellsten zum langsamsten Weg: Tommy antwortet sofort, eine
            Nachricht am selben Tag, der Fachbetrieb ist ein anderer Weg als unserer, und das
            Telefon steht zuletzt, weil es nur zwei Stunden am Tag besetzt ist.

            Sie steht hier im Markup und NICHT per CSS-order: Tastatur und Screenreader laufen
            die Quelltext-Reihenfolge ab, order verschoebe nur das Bild. Wer die Reihenfolge
            aendert, aendert sie hier - die Breiten dazu stehen im Stylesheet. */''}
      ${chatBereit()?`<button type="button" class="help-opt help-bot-btn"><span class="help-opt-ico">${mascotSVG(30)}</span><span class="help-opt-text">Frag Tommy<small>Der weiß ganz schön viel und antwortet dir sofort.</small></span></button>`:''}
      <button type="button" class="help-opt help-chat-btn"><span class="help-opt-ico">✉️</span><span class="help-opt-text">Nachricht schreiben<small>Per E-Mail erreichst du uns jederzeit.</small></span></button>
      <a class="help-opt help-vamo" href="https://www.vamo-energy.com/" target="_blank" rel="noopener"><span class="help-opt-ico">🔧</span><span class="help-opt-text">Fachbetrieb<small>Doch nicht selber einbauen? Schau dich bei einem Fachbetrieb für Wärmepumpen um.</small></span></a>
      ${phoneReady?`<a class="help-opt help-opt-tel" href="${esc(telHref)}"><span class="help-opt-ico">📞</span><span class="help-opt-text">${esc(CONFIG.SUPPORT_PHONE)}<small>Am besten erreichbar 16&ndash;18 Uhr</small></span></a>`:`<span class="help-opt help-opt-soon"><span class="help-opt-ico">📞</span>Telefon (bald)</span>`}
    </div>
    ${chatBereit()?`<div class="help-bot hidden">
      ${/* DER ZURUECK-KNOPF HAENGT SEIT DEM 19.10.2026 AM WEG HINEIN, nicht mehr am Ort.
            Vorgabe Claras: "wenn ich ueber den Hilfe-Button zu Tommy komme, gibt es kein
            Zurueck mehr [...] aber nur wenn man ueber den Hilfe-Button zu Tommy kommt, wenn
            man so ueber Tommy geht, kein Zurueck-Button, denn es gibt ja kein Zurueck zu
            irgendwas."

            Am 15.10.2026 war er ganz entfallen - richtig fuer den Tommy-Knopf, der direkt in
            den Chat springt, falsch fuer die Optionsliste: wer dort auf "Frag Tommy" tippt,
            hat die drei anderen Hilfe-Wege gesehen und kommt ohne Knopf nicht mehr hin.

            Beide Wege laufen durch DENSELBEN Klick-Handler (der Tommy-Knopf ruft ihn per
            bb.click() auf), deshalb steht der Knopf hier immer im Markup und wird erst beim
            Oeffnen ein- oder ausgeblendet. Die Berater-Seite blendet ihn ohnehin per CSS aus -
            dort IST der Chat der Inhalt der Spalte, es gibt kein Dahinter.

            NUR DER PFEIL, KEIN WORT (19.10.2026, Vorgabe Claras) - er sitzt als Gegenstueck
            zum Schliessen-Kreuz in der Kopfzeile des Fensters, und zwei Beschriftungen
            nebeneinander waeren dort eine Zeile zu viel. Das Ziel steht im aria-label, sonst
            hoerte ein Screenreader nur "Pfeil nach links". */''}
      <button type="button" class="help-bot-back" aria-label="Zurück zur Hilfe-Auswahl" hidden>←</button>
      ${/* DERSELBE KOPF WIE AUF DER BERATER-SEITE, ABER NUR HIER (15.10.2026, Vorgabe Claras).
            Dort steht er schon im Markup der Section (.berater-chat-kopf, mit Titel und Text aus
            dem Theme-Editor) - ein zweiter waere dort ein Doppel. Deshalb haengt er am prefix
            und nicht an einer Bedingung im CSS: Wer die Funktion liest, sieht sofort, dass es
            zwei Einbauorte gibt und nur einer den Kopf mitbringt.

            DER TEXT STEHT HIER IM CODE und auf der Berater-Seite im Editor (chat_titel,
            chat_text). Das ist kein Versehen, sondern die Folge davon, dass Section-Felder nur
            dort lesbar sind, wo die Section gerendert wird - der schwebende Knopf steht aber auf
            jeder Seite. Wer den Wortlaut drueben aendert, muss ihn hier nachziehen. */''}
      ${prefix==='fab'?`<div class="help-bot-kopf"><span class="help-bot-fig">${mascotSVG(40)}</span>
        <div class="help-bot-worte"><b>Frag Tommy</b>
        <p>Schreib deine Frage hier &ndash; unser KI-Berater Tommy beantwortet sie.</p></div>
      </div>`:''}
      <div class="help-bot-verlauf" id="${prefix}BotVerlauf" role="log" aria-live="polite" aria-label="Unterhaltung"></div>
      <div class="help-bot-eingabe">
        <textarea class="help-bot-text" rows="1" placeholder="Frag Tommy etwas …" aria-label="Deine Frage"></textarea>
        <button type="button" class="help-bot-send" aria-label="Frage abschicken">→</button>
      </div>
      ${/* HIER STAND BIS ZUM 15.10.2026: "Antworten kommen aus unserer Wissensdatenbank. Zur
            Auslegung deiner Anlage duerfen wir nicht beraten - dafuer ist ein Fachbetrieb da."
            Auf Claras Vorgabe entfernt. Der Satz war eine Abgrenzung, keine Pflichtangabe;
            dass die Auslegung ein Fachbetrieb bestaetigt, steht weiterhin im Rechner, auf der
            Ablaufseite und in den Service-Beschreibungen. */''}
    </div>`:''}
    <div class="help-chat-form hidden">
      <button type="button" class="btn quiet help-chat-back">← Zurück</button>
      <div class="help-chat-head">${mascotSVG(36)}<p>Hallo! Schreib uns kurz, wir antworten dir persönlich.</p></div>
      <div class="field"><input type="text" placeholder="Name (optional)" class="help-chat-name"></div>
      <div class="emailrow"><input type="email" placeholder="E-Mail" class="help-chat-email"></div>
      <div class="field"><textarea placeholder="Deine Frage" rows="2" class="help-chat-msg" style="width:100%;font-family:inherit;font-size:14px;padding:10px;border:1px solid var(--line);border-radius:var(--radius-s);background:var(--paper);color:var(--ink)"></textarea></div>
      <button type="button" class="btn quiet help-chat-send">Senden</button>
      <div class="help-chat-done"></div>
    </div>
  </div>`;
  const ask=el.querySelector('.help-ask'), opts=el.querySelector('.help-options');
  const entfalteOpts=()=>opts.classList.add('entfaltet');
  ask.onclick=()=>{
    track('help_cta_open',{path:prefix});
    ask.classList.add('hidden'); opts.classList.remove('hidden');
    void opts.offsetWidth; opts.classList.add('in');
    /* DIESELBE DECKELUNG, DERSELBE FEHLER WIE BEIM FORMULAR WEITER UNTEN: Die Liste klappt
       ueber max-height auf (200px) und schneidet mit overflow:hidden ab, was darueber
       hinausragt. Seit die Wege auf drei Zeilen plus Fusszeile stehen, ist sie hoeher - der
       Fachbetrieb und der Satz darunter waren abgeschnitten, unsichtbar UND nicht klickbar
       (Clara, 19.10.2026: "felder die abgeschnitten werden"). Nach dem Aufklappen faellt die
       Deckelung weg, die Animation bleibt unveraendert. */
    opts.addEventListener('transitionend',entfalteOpts,{once:true});
    setTimeout(entfalteOpts,420);
  };
  /* Steht hier und nicht im Klick-Handler: Ein jedes Mal neu erzeugter Verweis liesse sich
     mit removeEventListener nicht mehr abraeumen, und {once:true} greift nur, wenn der
     transitionend ueberhaupt kommt. */
  el.querySelector('.help-vamo').onclick=()=>track('vamo_referral_click',{path:prefix,via:'help_cta'});
  const chatBtn=el.querySelector('.help-chat-btn'), chatForm=el.querySelector('.help-chat-form');
  /* Die Aufklapp-Animation laeuft ueber max-height (380px) plus overflow:hidden. Sobald die
     Antwort unter dem Senden-Knopf dazukommt - Banner + "Nachricht abschicken"-Button +
     Telefonzeile - ist das Formular hoeher als 380px und genau dieser Knopf wurde abgeschnitten:
     unsichtbar UND nicht klickbar (User-Meldung 30.07.2026). Nach dem Aufklappen faellt die
     Deckelung deshalb weg; die Animation selbst bleibt unveraendert. */
  const entfalte=()=>chatForm.classList.add('entfaltet');
  chatBtn.onclick=()=>{
    track('help_chat_open',{path:prefix}); opts.classList.add('hidden');
    chatForm.classList.remove('hidden'); void chatForm.offsetWidth; chatForm.classList.add('in');
    chatForm.addEventListener('transitionend',entfalte,{once:true});
    /* Fallback, falls transitionend ausbleibt (reduzierte Bewegung, Hintergrund-Tab). */
    setTimeout(entfalte,420);
  };
  /* ---- Wissens-Chat ----
     Nur verdrahten, wenn der Endpunkt steht: ohne ihn rendert der Block gar nicht erst. */
  const bot=el.querySelector('.help-bot');
  if(bot){
    const verlauf=bot.querySelector('.help-bot-verlauf');
    const feld=bot.querySelector('.help-bot-text');
    const senden=bot.querySelector('.help-bot-send');
    let laeuft=false;

    /* Blasen immer ueber textContent statt innerHTML: der Antworttext kommt aus einem
       Sprachmodell, und was ein Modell schreibt, wird nie als Markup ausgefuehrt.
       Tommys Blasen gehen seit dem 16.10.2026 durch chatTextSetzen() - ebenfalls nur Textknoten,
       dazu Links auf die eigene Seite. Die Frage des Kunden bleibt reiner Text. */
    const blase=(wer,text,klasse)=>{
      const b=document.createElement('div');
      b.className='bot-blase bot-'+wer+(klasse?' '+klasse:'');
      if(wer==='bot') chatTextSetzen(b,text); else b.textContent=text;
      verlauf.appendChild(b);
      verlauf.scrollTop=verlauf.scrollHeight;
      return b;
    };

    blase('bot','Hallo! Ich beantworte Fragen zu unseren Kits, zum Einbau, zur Bestellung und zum Versand. Was möchtest du wissen?');

    const fragen=async()=>{
      const text=(feld.value||'').trim();
      if(!text || laeuft) return;
      feld.value=''; feld.style.height='auto';
      blase('du',text);
      laeuft=true; senden.disabled=true;
      const wartet=blase('bot','…','bot-wartet');
      track('help_bot_frage',{path:prefix});
      try{
        const a=await chatFrage(text,prefix);
        wartet.remove();
        /* WO TOMMY NICHT WEITERKOMMT, STEHT DIE NUMMER (26.10.2026, Vorgabe Claras: "bei
           Tommy, wenn dieser die Fragen nicht mehr beantworten kann, schicke dann als Antwort
           die Telefonnummer").

           ZWEI VERSCHIEDENE SACKGASSEN, beide hier: Die Wissensdatenbank gibt nichts her
           (leere Antwort) oder der Dienst antwortet gar nicht (catch). Vorher endete die
           erste mit "Frag es gern anders" - eine Bitte an den Kunden, es noch einmal zu
           versuchen, obwohl der Bot die Antwort schlicht nicht hat. Die zweite verwies auf
           "Nachricht schreiben", also auf einen Weg mit Wartezeit.

           DIE NUMMER STEHT ALS TEXT, nicht als Verweis: Die Blasen bekommen kein innerHTML
           (siehe chatTextSetzen), und das bleibt so - eine Antwort aus einem fremden Dienst
           ist kein Ort fuer Markup. Auf dem Telefon erkennen die Systeme die Nummer von
           selbst. */
        blase('bot', a.text || helpTelSatz('Da habe ich keine Antwort für dich.'), a.risiko?'bot-risiko':'');
      }catch(e){
        console.error('[chat]',e);
        wartet.remove();
        /* Ehrlich bleiben und den Weg zeigen, der sicher funktioniert - nicht so tun,
           als haette der Bot geantwortet. */
        blase('bot', helpTelSatz('Ich bin gerade nicht erreichbar.'), 'bot-fehler');
      }
      laeuft=false; senden.disabled=false; feld.focus();
    };

    senden.onclick=fragen;
    feld.addEventListener('keydown',ev=>{
      /* Enter schickt, Shift+Enter macht einen Absatz - wie in jedem Messenger. */
      if(ev.key==='Enter' && !ev.shiftKey){ ev.preventDefault(); fragen(); }
    });
    /* Mitwachsendes Eingabefeld, gedeckelt: ohne Deckel schiebt eine lange Frage den
       Verlauf aus dem Panel. */
    feld.addEventListener('input',()=>{
      feld.style.height='auto';
      feld.style.height=Math.min(feld.scrollHeight,96)+'px';
    });

    const botBtn=el.querySelector('.help-bot-btn'), botBack=el.querySelector('.help-bot-back');
    if(botBtn) botBtn.onclick=()=>{
      /* WER HAT GEKLOPFT? Der Tommy-Knopf des schwebenden Fensters laesst diesen Handler per
         bb.click() laufen und setzt vorher die Markierung - er kommt an der Optionsliste vorbei,
         hinter ihm liegt nichts, zu dem ein Zurueck fuehren koennte. Ohne Markierung kommt der
         Klick aus der Liste selbst, und dorthin fuehrt der Knopf zurueck.
         Die Markierung wird sofort wieder entfernt: Sie gilt fuer diesen einen Weg hinein, nicht
         fuer das Fenster. Sonst saehe der naechste Besuch ueber den Hilfe-Knopf noch die
         Entscheidung des vorigen. */
      const direkt = botBtn.dataset.direkt==='1';
      delete botBtn.dataset.direkt;
      if(botBack) botBack.hidden = direkt;
      track('help_bot_open',{path:prefix,weg:direkt?'tommy':'liste'});
      opts.classList.add('hidden');
      bot.classList.remove('hidden'); void bot.offsetWidth; bot.classList.add('in');
      feld.focus({preventScroll:true});
    };
    /* Zurueck in die Optionsliste - derselbe Ablauf wie bei .help-chat-back weiter unten.
       Der Knopf steht nur im Markup des schwebenden Fensters sichtbar; auf der Berater-Seite
       nimmt ihn das CSS heraus, dort gibt es keine Liste dahinter. */
    if(botBack) botBack.onclick=()=>{
      bot.classList.remove('in'); bot.classList.add('hidden');
      opts.classList.remove('hidden'); void opts.offsetWidth; opts.classList.add('in');
      if(botBtn) botBtn.focus({preventScroll:true});
    };
  }

  /* Ohne Rueckweg war das Chat-Formular eine Sackgasse: wer doch lieber anrufen wollte, musste das
     ganze Hilfe-Panel schliessen und neu oeffnen. */
  el.querySelector('.help-chat-back').onclick=()=>{
    chatForm.classList.remove('in','entfaltet'); chatForm.classList.add('hidden');
    opts.classList.remove('hidden'); void opts.offsetWidth; opts.classList.add('in');
  };
  el.querySelector('.help-chat-send').onclick=async()=>{
    const email=el.querySelector('.help-chat-email').value;
    const done=el.querySelector('.help-chat-done');
    if(!istEmail(email)){ done.innerHTML=`<div class="banner warn">Bitte gib eine E-Mail-Adresse an.</div>`; return; }
    const name=el.querySelector('.help-chat-name').value||null, msg=el.querySelector('.help-chat-msg').value||null;
    A.email=email; speichereStand(); track('help_chat_send',{path:prefix});
    /* Versand versuchen - klappt nur mit gesetztem LEAD_ENDPOINT. Der frueher hier
       eingebaute Umweg ueber Shopifys /contact ist ersatzlos raus: er lieferte 403 bzw.
       "400 Missing CAPTCHA token", weil Shopifys Spamschutz-Skript auf diesem Layout nicht
       ausgeliefert wird. Solange der Endpunkt fehlt, wird hier nichts versprochen, was nicht
       eingehalten wird - siehe Kommentar an submitLead. */
    const versuchtZuSenden = !CONFIG.LEAD_ENDPOINT.startsWith('TBD_');
    if(versuchtZuSenden){
      done.innerHTML=`<div class="banner ok">Wird gesendet …</div>`;
      let ok=false;
      try{ ok = await submitLead('chat_request',{name,message:msg,path:prefix}); }
      catch(e){ console.error('[chat]',e); ok=false; }
      if(ok){
        done.innerHTML=`<div class="banner ok"><b>Angekommen.</b> Wir melden uns zeitnah unter ${esc(email)}.</div>`;
        entfalte();
        return;
      }
    }
    /* Nichts verloren gehen lassen: Der Kunde hat getippt, also bekommt er seinen Text als
       fertigen Mail-Entwurf zurueck statt einer Sackgasse. */
    const betreff='Frage über den Rechner'+(name?' von '+name:'');
    const koerper=[
      msg||'',
      '',
      '---',
      name?('Name: '+name):'',
      'E-Mail: '+email,
      'Kontext: '+prefix,
      A.plz?('PLZ: '+A.plz):''
    ].filter(Boolean).join('\n');
    const mailto='mailto:info@billigerwaermepumpe.de?subject='+encodeURIComponent(betreff)+
      '&body='+encodeURIComponent(koerper);
    /* Drei Wege statt einem: der mailto-Knopf funktioniert nur mit eingerichtetem
       Mailprogramm - auf dem Handy oft nicht der Fall. Deshalb daneben die Adresse zum
       Kopieren (Zwischenablage, mit Klartext-Rueckfall) und die Telefonnummer als Link.
       Wortlaut ohne Erfolgsversprechen: es ist noch nichts bei uns angekommen. */
    const telHrefKurz='tel:'+String(CONFIG.SUPPORT_PHONE).replace(/\s+/g,'');
    done.innerHTML = `<div class="banner warn"><b>Fast geschafft &ndash; ein Schritt fehlt noch.</b>
         Deine Nachricht ist fertig, sie muss nur noch raus. Such dir aus, wie.</div>
         <a class="btn" href="${mailto}">Im Mailprogramm öffnen →</a>
         <button type="button" class="btn quiet chat-kopieren">Text kopieren</button>
         <p class="fineprint" style="margin-top:6px">Oder schreib an
           <a href="mailto:info@billigerwaermepumpe.de">info@billigerwaermepumpe.de</a>
           &middot; oder ruf an: <a href="${esc(telHrefKurz)}">${esc(CONFIG.SUPPORT_PHONE)}</a></p>`;
    const kopieren=done.querySelector('.chat-kopieren');
    if(kopieren) kopieren.onclick=async()=>{
      const text=betreff+'\n\n'+koerper;
      try{
        if(navigator.clipboard && window.isSecureContext){ await navigator.clipboard.writeText(text); }
        else { /* aelteres Safari/HTTP: ueber ein temporaeres Feld */
          const t=document.createElement('textarea'); t.value=text;
          t.style.cssText='position:fixed;left:-9999px'; document.body.appendChild(t);
          t.select(); document.execCommand('copy'); t.remove();
        }
        kopieren.textContent='Kopiert ✓';
      }catch(e){ kopieren.textContent='Kopieren ging nicht'; }
      setTimeout(()=>{ kopieren.textContent='Text kopieren'; },2600);
    };
    /* Deckelung sicher weg und den Knopf ins Bild holen - die Antwort haengt unten am Formular,
       auf dem Handy sonst leicht unterhalb des sichtbaren Bereichs. */
    entfalte();
    done.scrollIntoView({block:'nearest',behavior:'smooth'});
    track('chat_mailto_fallback',{path:prefix});
  };
}
/* ============================== EINBAU-FAHRPLAN ==============================
   Optionaler, personalisierter Ablaufplan: die sieben Einbauschritte, aber mit SEINEN Positionen
   darin. Beantwortet die Frage, die der Rechner sonst offen laesst - nicht "was kostet es", sondern
   "was mache ich da eigentlich, und schaffe ich das".
   Bewusst OPT-IN (User-Vorgabe): steckt zugeklappt in der Kaufbox, oeffnet nur auf Klick, baut sich
   erst dann auf. Wer nur kaufen will, sieht eine Zeile mehr und sonst nichts. */

/* Die Schritte kommen aus dem DOM der Einbau-Section, NICHT aus einer Kopie hier. Damit bleibt der
   Customizer die einzige Quelle: benennt das Team einen Schritt um oder aendert das Werkzeug,
   zieht der Fahrplan automatisch mit. Faellt die Section weg, faellt der Fahrplan lautlos aus. */
function einbauSchritte(){
  return [...document.querySelectorAll('#einbauRoadmap .rm-item')].map(it=>{
    const t=it.querySelector('.rm-text');
    const g=sel=>{ const e=it.querySelector(sel); return e?e.textContent.trim():''; };
    return {
      nr:g('.rm-dot'), wann:g('.rm-when'),
      titel:t&&t.querySelector('b')?t.querySelector('b').textContent.trim():'',
      text:t&&t.querySelector('p')?t.querySelector('p').textContent.trim():'',
      tools:[...it.querySelectorAll('.rm-tools .tag')].map(x=>x.textContent.trim()),
      wir:it.classList.contains('wir')
    };
  }).filter(s=>s.titel);
}
/* Zuordnung Bestellposition -> Einbauschritt, abgeleitet aus den Schritt-Texten der Section
   ("Durchfuehrung abdichten" = Hauseinfuehrung, "Speicher & Isolierung" = Warmwasserspeicher usw.).
   FACHLICH VOM TEAM GEGENZULESEN. Was hier nicht steht, geht nicht verloren, sondern landet unten
   im Sammelblock - lieber unsortiert sichtbar als still verschwunden. */
const FAHRPLAN_EXTRAS={ haus_ober:'02', haus_unter:'02', fundament:'03', erdleitung:'03',
  peri_basic:'04', pump_gem:'04', pump_ungem:'04', systr:'04',
  homematic:'06', eq3_hk:'06', eq3_stell:'06', eq3_klemm:'06', eq3_dose:'06' };
const FAHRPLAN_KIT={ '03':'Außeneinheit aufstellen und anschließen', '04':'Inneneinheit (Hydrobox) setzen' };

function fahrplanZeilen(cand,schritte){
  const proStep={}; schritte.forEach(s=>proStep[s.nr]=[]);
  const push=(nr,text,art)=>{ if(proStep[nr]) proStep[nr].push({text,art}); };
  /* Kit-Teile: die Hardware taucht in zwei Schritten auf, aussen und innen. */
  Object.entries(FAHRPLAN_KIT).forEach(([nr,label])=>push(nr,label,'du'));
  /* Material-Extras aus seiner Konfiguration, mit Menge wo sie zaehlt. */
  const offen=[];
  Object.entries(chosenExtras).forEach(([k,q])=>{
    const e=EXTRAS[k]; if(!e) return;
    const menge=(e.perMeter?` (${q} m)`:(e.perUnit?` (${q}×)`:''));
    const zeile=e.name+menge;
    const nr=FAHRPLAN_EXTRAS[k];
    if(nr && proStep[nr]) push(nr,zeile,'du'); else offen.push(zeile);
  });
  /* Warmwasserspeicher haengt an der Funnel-Antwort, nicht an chosenExtras. */
  const spKey=speicher();
  if(spKey) push('05',PRODUCTS[spKey].name+' anschließen und isolieren','du');
  /* Eigenleistung sichtbar machen: was er selbst baut, gehoert genauso in den Plan wie Gekauftes. */
  if(A.fundament==='selbst') push('03','Fundament baust du selbst','selbst');
  Object.entries(eigenBetraege).forEach(([k,v])=>{
    if(!v||v<=0) return;
    if(k==='fundament' && chosenExtras.fundament) return;
    const e=EIGENLEISTUNGEN.find(x=>x.k===k);
    if(e) offen.push(e.name+' (deine Eigenleistung)');
  });
  /* Services landen im Wir-Schritt: genau der Punkt, an dem der Kunde aufhoert und wir uebernehmen. */
  const wirNr=(schritte.find(s=>s.wir)||{}).nr;
  if(wirNr) chosenServices.forEach(k=>{ if(SERVICES[k]) push(wirNr,SERVICES[k].name,'wir'); });
  return {proStep,offen};
}
function renderFahrplan(cand){
  const box=document.getElementById('fahrplanBody'); if(!box) return;
  const schritte=einbauSchritte();
  if(!schritte.length){ box.innerHTML=`<p class="fineprint">Der Ablauf steht auf der Startseite unter „Einbau".</p>`; return; }
  const {proStep,offen}=fahrplanZeilen(cand,schritte);
  const rahmen=(document.querySelector('#einbau h2')||{}).textContent||'';
  /* Werkzeugliste ueber alle Schritte, doppelte Nennungen zusammengefasst. */
  const werkzeug=[...new Set(schritte.flatMap(s=>s.tools))];
  const artTag={du:'',selbst:'<span class="tag">Eigenleistung</span>',wir:'<span class="tag gruen">machen wir</span>'};
  box.innerHTML=`
    ${rahmen?`<div class="fp-frame"><b>${esc(rahmen)}</b><span>So ist der Einbau geplant. Dein Paket ist unten in die Schritte einsortiert.</span></div>`:''}
    <ol class="fp-list">
      ${schritte.map(s=>{
        const zeilen=proStep[s.nr]||[];
        return `<li class="fp-step${s.wir?' fp-step--wir':''}">
          <div class="fp-head"><span class="fp-nr m">${esc(s.nr)}</span><span class="fp-titel">${esc(s.titel)}</span><span class="fp-wann">${esc(s.wann)}</span></div>
          ${s.text?`<p class="fp-text">${esc(s.text)}</p>`:''}
          ${zeilen.length?`<ul class="fp-items">${zeilen.map(z=>`<li>${esc(z.text)}${artTag[z.art]||''}</li>`).join('')}</ul>`:''}
          ${s.tools.length?`<div class="fp-tools">${s.tools.map(t=>`<span class="tag">${esc(t)}</span>`).join('')}</div>`:''}
        </li>`;
      }).join('')}
    </ol>
    ${offen.length?`<div class="fp-offen"><b>Außerdem in deinem Paket</b><ul class="fp-items">${offen.map(o=>`<li>${esc(o)}</li>`).join('')}</ul></div>`:''}
    ${werkzeug.length?`<div class="fp-werkzeug"><b>Werkzeug über alle Schritte</b><div class="fp-tools">${werkzeug.map(t=>`<span class="tag">${esc(t)}</span>`).join('')}</div></div>`:''}
    <p class="fineprint">Orientierung, keine Montageanleitung. Die führt dich Schritt für Schritt durch die App &ndash; ausdrucken kannst du sie dir jederzeit. Und wenn ein Schritt unklar ist, frag uns vorher, nicht mittendrin.</p>`;
}
/* Hilfe war bisher NUR in der Kaufbox und im Direktkauf-Modal erreichbar - also erst, wenn der
   Kunde schon fast am Ende war. Das Gefuehl "wenn ich feststecke, frage ich einfach nach" muss aber
   ab der ersten Minute mitlaufen, sonst traegt es die Selbstbau-Entscheidung nicht.
   Der Knopf haengt an document.body und ueberlebt damit jeden Panel-Wechsel; den Inhalt liefert
   dieselbe renderHelpCta()-Funktion wie in der Kaufbox - ein Chat-Pfad, eine Lead-Pipeline. */
/* ================== KLICK-NETZ (16.09.2026, Betreiber-Entscheid) ==================
   Faengt JEDEN Klick auf ein bedienbares Element und schickt ihn als `klick` in den dataLayer.

   WARUM EIN NETZ UND KEINE 190 EINZELMARKIERUNGEN: Am 16.09.2026 gezaehlt - 132 track()-Aufrufe
   gegen rund 190 Klick-Handler. Die Luecke von Hand zu schliessen waere einmal Arbeit und danach
   ein Dauerproblem: jeder neue Knopf muesste daran denken, und genau das passiert nicht. Das
   Netz kennt auch, was es noch nicht gibt.

   ES ERSETZT DIE BENANNTEN EREIGNISSE NICHT. Die 70 bestehenden Ereignisse tragen Bedeutung
   (checkout_start, foerder_gate_abbruch, rabatt_code_ok) und bleiben die Grundlage der
   Trichter. `klick` ist die Flaeche darunter - fuer Klickkarten und fuer die Frage "was tun
   die Leute eigentlich, bevor sie abspringen". Wer beides addiert, zaehlt doppelt; in GA4
   gehoeren sie in getrennte Berichte.

   WAS NIE MITFAEHRT: Eingegebenes. Es wird ausschliesslich der BESCHRIFTUNGSTEXT eines
   Bedienelements gelesen, nie .value und nichts aus einem Eingabefeld - dort steht die
   E-Mail-Adresse des Kunden. Deshalb faengt das Netz input und textarea gar nicht erst.

   NIEMALS DEN KLICK BEHINDERN: Zuhoerer in der Erfassungsphase, passiv, alles in try/catch.
   Ein Fehler in der Messung darf keinen Kauf kosten. */
const KLICK_ZIELE='button,a,summary,label,[role="button"],.opt,.chipbtn,.help-opt';
function klickKennung(el){
  /* Reihenfolge nach Verlaesslichkeit: eine ausdrueckliche Markierung schlaegt eine ID,
     eine ID schlaegt geratenen Text. data-track gibt es noch nirgends im Markup - es ist der
     Haken, an dem man spaeter einzelne Knoepfe sauber benennen kann, ohne hier anzufassen. */
  const d=el.dataset||{};
  if(d.track) return String(d.track);
  if(el.id) return el.id;
  if(d.x) return 'extra:'+d.x;
  if(d.key) return 'kb:'+d.key;
  if(d.svc) return 'service:'+d.svc;
  const kl=(el.className&&el.className.baseVal!==undefined)?el.className.baseVal:String(el.className||'');
  const erste=kl.trim().split(/\s+/).filter(Boolean)[0];
  if(erste) return '.'+erste;
  return el.tagName.toLowerCase();
}
function klickBereich(el){
  /* Wo auf der Seite? Der naechste benannte Behaelter - Panel, Section oder Modal. Ohne das
     sind "Weiter"-Knoepfe aus fuenf verschiedenen Ansichten in der Auswertung dasselbe. */
  try{
    const p=el.closest('[data-panel]'); if(p&&p.dataset.panel) return p.dataset.panel;
    const m=el.closest('.modalback'); if(m&&m.id) return m.id;
    const s=el.closest('section[id],div[id]'); if(s&&s.id) return s.id;
  }catch(e){}
  return null;
}
function klickNetzSpannen(){
  document.addEventListener('click',ev=>{
    try{
      const roh=ev.target;
      if(!roh || !roh.closest) return;
      /* Eingabefelder bleiben aussen vor - dort steht, was der Kunde tippt. */
      if(roh.closest('input,textarea,select')) return;
      const el=roh.closest(KLICK_ZIELE);
      if(!el) return;
      /* Nur der Beschriftungstext, hart gekuerzt. Er stammt aus unserem eigenen Markup. */
      let text='';
      try{ text=(el.textContent||'').replace(/\s+/g,' ').trim().slice(0,60); }catch(e){}
      track('klick',{
        ziel: klickKennung(el),
        bereich: klickBereich(el),
        beschriftung: text || null,
        art: el.tagName.toLowerCase(),
        /* Ein Link, der die Seite verlaesst, ist etwas anderes als ein Knopf im Rechner. */
        ...(el.tagName==='A'&&el.getAttribute('href')?{ziel_url:el.getAttribute('href').slice(0,120)}:{})
      });
    }catch(e){ /* Messung darf nie einen Klick kosten */ }
  },true);
}
/* ZU CLARAS AUFBAU (16.09.2026): Das Netz gewinnt hier gegenueber unserem Theme. Clara hat
   acht Abschnitte mit data-panel ausgezeichnet (ablauf, app, bauteile, faq, foerderung,
   magazin, produkt, rechner) - genau das, worauf klickBereich() zuerst schaut. Ihre neuen
   Oberflaechen sind damit von Haus aus sauber zugeordnet: die Warenkorb-Schublade ueber
   #bwpKorbDrawer, die Produktseiten-Kaufbox ueber #cartModal, die Pop-up-Navigation ueber
   ihren Abschnitt. Ohne eine einzige zusaetzliche Markierung im Markup. */
/* Anstoss fuer die Kaufbox-Blase. Wird von mountHelpFab() gesetzt, weil nur dort wrap, panel
   und open() leben, und von renderBuyBox() gerufen. Mit null vorbelegt: ein Zugriff vor der
   Zuweisung soll nichts tun, nicht werfen. */
let kaufBlaseAnstossen=null;
function mountHelpFab(){
  if(document.getElementById('helpFab')) return;
  const wrap=document.createElement('div');
  wrap.id='helpFab'; wrap.className='help-fab';
  wrap.innerHTML=`<div class="help-fab-panel" id="helpFabPanel" role="dialog" aria-label="Hilfe" hidden>
      <button type="button" class="help-fab-close" id="helpFabClose" aria-label="Hilfe schließen">×</button>
      <div class="help-fab-title">Steckst du fest?</div>
      <p class="help-fab-sub">Kein Problem. Wir gehen da gemeinsam durch.</p>
      <div id="fabHelpCta" class="help-fab-body"></div>
    </div>
    <div class="help-fab-reihe">
      <button type="button" class="help-fab-btn help-fab-neben" id="helpFabBtn" aria-expanded="false" aria-controls="helpFabPanel">
        <span class="help-fab-ico">${chatBereit()?frageSVG(21):mascotSVG(24)}</span><span class="help-fab-label">Hilfe</span>
      </button>
      ${/* "Tommy" STATT "Chat" (15.10.2026, Vorgabe Claras: "nenn den Chatbot, der rechts unten
            steht, auch Tommy - pass den bitte an den an, der auf der Berater-Seite steht, sodass
            die aehnlich aussehen"). Es ist derselbe Bot: Beide Oberflaechen entstehen in
            renderHelpCta(), nur an zwei Stellen eingehaengt. Dass die eine ihn beim Namen nannte
            und die andere "Chat", liess sie wie zwei verschiedene Angebote aussehen. */''}
      ${chatBereit()?`<button type="button" class="help-fab-btn help-fab-chat" id="chatFabBtn" aria-expanded="false" aria-controls="helpFabPanel">
        <span class="help-fab-ico">${mascotSVG(30)}</span><span class="help-fab-label">Tommy</span>
      </button>`:''}
    </div>`;
  document.body.appendChild(wrap);
  const btn=wrap.querySelector('#helpFabBtn'), panel=wrap.querySelector('#helpFabPanel');
  /* Ruhe fuer diesen Besuch: gesetzt, wenn der Kunde die Blase wegklickt oder die Hilfe
     oeffnet. Bewusst KEIN localStorage - beim naechsten Besuch darf der Hinweis wieder
     kommen, er ist die einzige Stelle, an der Tommy sich von selbst meldet.

     STEHT HIER UND NICHT BEIM BLASEN-ABSCHNITT WEITER UNTEN, obwohl sie dort hingehoert:
     open() liest sie, und open() steht davor. Ein `let` wird nicht nach oben gezogen - ein
     Aufruf vor der Deklaration waere ein ReferenceError, und zwar genau beim Oeffnen der
     Hilfe. Heute laeuft open() erst beim Klick und damit lange danach; darauf soll sich aber
     niemand verlassen muessen, der hier etwas umstellt. */
  let blaseRuhe=false;
  /* OHNE CHAT-ENDPUNKT BLEIBT ALLES WIE VORHER (16.09.2026): dann gibt es keinen zweiten Knopf,
     und der Hilfe-Knopf traegt weiter das Maskottchen. Ein zweiter Knopf, der ins Leere fuehrt,
     waere schlimmer als gar keiner. */
  const chatBtn=wrap.querySelector('#chatFabBtn');
  let rendered=false;
  const close=()=>{
    panel.hidden=true; wrap.classList.remove('open');
    btn.setAttribute('aria-expanded','false');
    if(chatBtn) chatBtn.setAttribute('aria-expanded','false');
  };
  /* ZURUECK AUF DIE OPTIONSLISTE - der Grundzustand des Fensters.
     Beide Knoepfe teilen sich EIN Panel, und sein Zustand blieb bisher stehen: Wer einmal
     ueber Tommy geoeffnet hatte, bekam beim naechsten Druck auf "Hilfe" wieder Tommy zu sehen
     (Clara, 19.10.2026: "wenn ich einmal auf Tommy klicke, und danach auf Hilfe, dann oeffnet
     sich auch Tommy. Ich moechte, dass dies zwei verschiedene Buttons sind").

     Das Zuruecksetzen geht ueber die Rueckweg-Knoepfe, die es ohnehin gibt, statt ueber eine
     zweite Umschalt-Logik daneben: Es ist genau der Weg, den der Kunde von Hand ginge, und es
     bleibt eine Stelle, an der die Klassen (hidden/in/entfaltet) gesetzt werden. Ein
     JS-click() wirkt auch auf einen Knopf mit [hidden] - der Zurueck-Pfeil ist nach dem
     direkten Weg ueber Tommy genau das. */
  const zurListe=()=>{
    const bot=panel.querySelector('.help-bot'), form=panel.querySelector('.help-chat-form');
    if(bot && !bot.classList.contains('hidden')) panel.querySelector('.help-bot-back')?.click();
    else if(form && !form.classList.contains('hidden')) panel.querySelector('.help-chat-back')?.click();
  };
  const open=(ziel)=>{
    /* WER DIE HILFE VON SELBST OEFFNET, BRAUCHT KEINEN HINWEIS MEHR DARAUF (29.10.2026).
       Sonst poppt die Blase fuenf Minuten spaeter neben einem Fenster auf, das der Kunde
       gerade benutzt hat - und empfiehlt ihm, was er schon gefunden hat. */
    blaseRuhe=true;
    /* UND DIE, DIE GERADE DASTEHT, GEHT MIT (29.10.2026, Vorgabe Claras: "wenn man dann auf
       Tommy klickt, soll der schwarze Kasten dann weg sein").

       blaseRuhe allein reicht dafuer NICHT - es verhindert nur kuenftige Blasen. Wer den
       Tommy-Knopf druckt statt der Blase darueber, liess sie bis zum Ablauf ihrer 22
       Sekunden neben dem geoeffneten Chat stehen: ein Hinweis auf etwas, das schon offen
       ist. Ueber _weg() und nicht per remove(), damit sie ausblendet statt zu springen. */
    const bl=document.getElementById('chatBlase');
    if(bl && bl._weg) bl._weg('panel');
    /* VOR dem Einblenden: Der Wechsel soll nicht als Zucken im gerade aufgehenden Fenster
       sichtbar sein. */
    if(rendered) zurListe();
    panel.hidden=false; wrap.classList.add('open');
    btn.setAttribute('aria-expanded','true');
    if(chatBtn) chatBtn.setAttribute('aria-expanded','true');
    if(!rendered){
      renderHelpCta('fab');
      /* Die Optionen liegen hinter einem "Brauchst du Hilfe?"-Knopf. Im Panel hat der Kunde diese
         Frage durch das Oeffnen schon beantwortet - also direkt aufklappen statt zweimal fragen. */
      const ask=panel.querySelector('.help-ask'); if(ask) ask.click();
      rendered=true;
    }
    /* Nicht einfach die erste .help-opt: solange CONFIG.SUPPORT_PHONE noch TBD ist, rendert die
       Telefon-Option als <span> ("bald") und nimmt keinen Fokus an - der Tastatur-Nutzer bliebe
       dann draussen stehen. Darum das erste wirklich fokussierbare Element, sonst der Schliessen-Knopf. */
    /* Mit Ziel 'bot' ueberspringen wir die Optionsliste: wer auf die Sprechblase klickt, hat
       seine Wahl schon getroffen - ihn dann noch einmal fragen zu lassen waere ein Klick zu viel. */
    if(ziel==='bot'){
      const bb=panel.querySelector('.help-bot-btn');
      /* Die Markierung sagt dem Handler, dass dieser Klick nicht aus der Optionsliste kommt -
         er laesst den Zurueck-Knopf dann weg (19.10.2026, Vorgabe Claras). Sie muss VOR dem
         click() stehen und wird dort sofort wieder entfernt. */
      if(bb){ bb.dataset.direkt='1'; bb.click(); return; }
      /* Kein Bot-Knopf da (CHAT_ENDPOINT leer): dann eben die normale Liste. */
    }
    const first=panel.querySelector('a.help-opt,button.help-opt')||panel.querySelector('#helpFabClose');
    if(first) first.focus({preventScroll:true});
  };
  btn.onclick=()=>{ if(panel.hidden){ track('help_fab_open',{panel:location.hash.slice(1)||'rechner'}); open(); } else close(); };
  /* Der Chat-Knopf springt an der Optionsliste vorbei direkt in den Bot - wer auf das
     Maskottchen tippt, hat seine Wahl getroffen. open('bot') gibt es dafuer schon. */
  if(chatBtn) chatBtn.onclick=()=>{
    if(!panel.hidden){ close(); return; }
    track('chat_fab_open',{panel:location.hash.slice(1)||'rechner'});
    open('bot');
  };

  /* ---- SPRECHBLASE AM KNOPF (15.09.2026, Betreiber-Entscheid) ----
     Der Hilfe-Knopf steht unten rechts und wird uebersehen: wer eine technische Frage hat,
     sucht sie nicht dort. Also holt der Bot den Kunden einmal aktiv ab.

     BEWUSST ZURUECKHALTEND, an vier Stellen:
       - nur auf grossen Schirmen. Auf dem Handy nimmt eine Blase ueber der Sticky-Leiste den
         halben Bildschirm und deckt genau die Knoepfe zu, die der Kunde gerade braucht.
       - einmal pro Besucher, gemerkt im localStorage. Wer sie wegklickt, sieht sie nie wieder.
       - erst nach 12 Sekunden. Wer sofort weiss, was er will, soll nicht gestoert werden.
       - nicht, wenn gerade etwas anderes offen ist (Panel, Kauf-Dialog, Rabatt-Fenster) oder
         die Tour laeuft. Zwei Overlays gleichzeitig sind ein Fehler, keine Aufmerksamkeit.

     Sie nimmt KEINEN Fokus. Ein Element, das sich von selbst einblendet und die Tastatur an
     sich reisst, wirft den Nutzer aus dem Formular, in dem er gerade tippt. */
  const BLASE_SCHLUESSEL='bwp_chat_blase';
  /* EIGENER MERKER FUER DIE KAUFBOX (16.09.2026). Nicht derselbe wie die allgemeine Blase:
     sonst verbraucht der fruehe Hinweis auf der Startseite die Chance an der Stelle, an der
     es wirklich zaehlt. Zwei Merker heissen hoechstens zwei Hinweise im ganzen Kundenleben,
     und sie liegen weit auseinander. */
  const KAUFBLASE_SCHLUESSEL='bwp_kaufblase';
  function blaseGesehen(k){ try{ return localStorage.getItem(k)==='1'; }catch(e){ return true; } }
  function blaseMerken(k){ try{ localStorage.setItem(k,'1'); }catch(e){} }

  /* EIN BAUER FUER BEIDE ANLAESSE (16.09.2026). Vorher stand der Aufbau fest verdrahtet in
     zeigeBlase(); mit einem zweiten Anlass waere derselbe Kasten ein zweites Mal im Code
     gestanden - und die naechste Aenderung haette genau eine der beiden Fassungen erwischt. */
  function baueBlase(o){
    if(!chatBereit()) return;
    /* DER MERKER IST SEIT DEM 29.10.2026 OPTIONAL. Die Kaufbox-Blase traegt weiter einen und
       kommt damit einmal im Kundenleben; der allgemeine Hinweis wiederholt sich und regelt
       seine Ruhe selbst (blaseRuhe). Ohne diese Unterscheidung haette der erste Hinweis den
       Merker verbraucht und alle weiteren waeren still ausgefallen. */
    if(o.merker && blaseGesehen(o.merker)) return;
    if(!panel.hidden) return;
    if(!window.matchMedia || !window.matchMedia('(min-width: 900px)').matches) return;
    if(document.querySelector('.modalback:not(.hidden)')) return;
    if(document.documentElement.classList.contains('bwp-tour-on')) return;
    if(document.getElementById('chatBlase')) return;

    const b=document.createElement('div');
    b.id='chatBlase'; b.className='chat-blase';
    /* Das Maskottchen steht jetzt MIT in der Blase (16.09.2026): sie soll erkennbar von
       derselben Figur kommen, auf die der Kunde danach tippt. */
    b.innerHTML='<button type="button" class="chat-blase-zu" aria-label="Hinweis ausblenden">✕</button>'
      +'<button type="button" class="chat-blase-text">'
      +'<span class="chat-blase-fig">'+mascotSVG(30)+'</span>'
      +'<span class="chat-blase-wort"><b>'+o.titel+'</b>'
      +'<span>'+o.text+'</span></span>'
      +'</button>';
    /* Vor den Knopf, nicht dahinter: .help-fab ist eine Spalte, die Blase gehoert darueber. */
    wrap.insertBefore(b, wrap.querySelector('.help-fab-reihe'));
    requestAnimationFrame(()=>b.classList.add('in'));
    track('chat_blase_zeigt',{anlass:o.anlass});

    const weg=(grund)=>{
      if(o.merker) blaseMerken(o.merker);
      /* WEGGEKLICKT HEISST RUHE FUER DIESEN BESUCH. Von selbst verschwunden ("zeit") heisst
         das NICHT - dann kommt der naechste Takt. Der Unterschied ist der ganze Punkt der
         Wiederholung: Wer nicht reagiert, hat sie vielleicht nicht gesehen; wer sie
         wegklickt, hat Nein gesagt. */
      if(grund==='zu') blaseRuhe=true;
      b.classList.remove('in');
      setTimeout(()=>{ if(b.parentNode) b.parentNode.removeChild(b); },220);
      if(grund) track('chat_blase_weg',{grund});
    };
    /* weg() am Knoten hinterlegen: open() muss die Blase wegnehmen koennen, steht aber
       ausserhalb dieser Funktion. Ein zweiter Ausblend-Weg daneben (Knoten einfach
       entfernen) waere ohne Animation und wuerde den Zeit-Timer weiterlaufen lassen. */
    b._weg=weg;
    b.querySelector('.chat-blase-zu').onclick=ev=>{ ev.stopPropagation(); weg('zu'); };
    b.querySelector('.chat-blase-text').onclick=()=>{
      weg(null); blaseRuhe=true; track('chat_blase_klick',{anlass:o.anlass});
      open('bot');
    };
    /* Von selbst wieder verschwinden. Sie bleibt gemerkt - sie hatte ihre Chance. */
    setTimeout(()=>{ if(document.getElementById('chatBlase')) weg('zeit'); },22000);
  }

  /* ---- DER ALLGEMEINE HINWEIS WIEDERHOLT SICH (29.10.2026, Vorgabe Claras) ----
     "Dass Tommy, der KI-Berater, mehr auf der Seite zur Geltung kommt [...] dass der halt
     eben irgendwann aufklappt, wo steht: Hast du eine Frage oder moechtest mehr
     Informationen -> Frag Tommy, der weiss ganz schoen viel."

     Bis heute kam er genau EINMAL im Kundenleben, gemerkt im localStorage. Wer ihn beim
     ersten Besuch uebersah, sah ihn nie wieder - und genau das war das Problem.

     DER TAKT STEHT HIER UND NUR HIER. Clara wollte die durchschnittliche Verweildauer noch
     nachsehen; 5 Minuten ist ihr Vorschlag als Startwert. Wer ihn aendert, aendert diese
     eine Zahl - nicht vier verstreute setTimeout-Aufrufe.

     DREIMAL IST SCHLUSS. Ohne Obergrenze poppt auf einer Seite, auf der jemand eine halbe
     Stunde liest, sechsmal dasselbe auf - das ist kein Hinweis mehr, sondern ein Flackern.
     Zusammen mit den 5 Minuten deckt das rund eine Viertelstunde ab.

     RUHE, SOBALD DER KUNDE GEANTWORTET HAT: Wegklicken oder Tommy oeffnen beendet die Reihe
     fuer diesen Besuch (blaseRuhe). Von selbst verschwinden tut es NICHT - wer nicht
     reagiert, hat den Hinweis vielleicht gar nicht gesehen.

     IM HINTERGRUND-TAB ZAEHLT NICHTS. document.hidden wird geprueft, und ein uebersprungener
     Takt verbraucht keinen der drei Versuche: Eine Blase, die in einem unsichtbaren Tab
     auftaucht und nach 22 Sekunden wieder geht, waere ein verbrauchter Versuch ohne
     Zuschauer. */
  const BLASE_TAKT_MS = 5*60*1000;
  const BLASE_MAX     = 3;
  /* HARTE OBERGRENZE FUER DIE TAKTE SELBST, nicht nur fuer die gezeigten Blasen. Ohne sie
     laeuft die Kette endlos weiter, sobald kein Versuch je zaehlt - und das ist nicht der
     Ausnahmefall, sondern der haeufigste: Auf jedem Telefon steigt baueBlase() an der
     Schirmbreite aus, der Zaehler bleibt auf 0, und ein Timer tickt bis zum Schliessen des
     Tabs vor sich hin. Dasselbe im Hintergrund-Tab und bei dauerhaft offener Kaufbox.
     12 Takte sind rund eine Stunde; danach ist Schluss, auch wenn nie etwas zu sehen war. */
  const BLASE_TAKTE_MAX = 12;
  let   blaseZaehler  = 0;
  let   blaseTakte    = 0;
  function zeigeBlase(){
    /* Solange die Kaufbox steht, hat ihre eigene Blase Vorrang - unveraendert seit dem
       16.09.2026. Der Takt laeuft weiter, der Versuch bleibt unverbraucht. */
    if(document.querySelector('.buybox')) return false;
    if(document.hidden) return false;
    baueBlase({anlass:'allgemein',
      titel:'Hast du eine Frage oder möchtest mehr Informationen?',
      text:'Frag Tommy &ndash; der weiß ganz schön viel.'});
    /* Gebaut wurde nur, wenn die Blase jetzt auch dasteht: baueBlase() steigt aus, sobald
       etwas anderes offen ist oder der Schirm zu klein ist. Ein stiller Fehlversuch darf
       keinen der drei Durchgaenge kosten. */
    return !!document.getElementById('chatBlase');
  }
  /* Erster Anlauf nach 12 Sekunden wie bisher, danach im Takt. Kein setInterval: Es laeuft
     weiter, auch wenn die Reihe laengst beendet ist, und haelt die Seite wach. */
  function blaseTakten(verzug){
    setTimeout(()=>{
      if(blaseRuhe || blaseZaehler>=BLASE_MAX || ++blaseTakte>BLASE_TAKTE_MAX) return;
      if(zeigeBlase()) blaseZaehler++;
      blaseTakten(BLASE_TAKT_MS);
    }, verzug);
  }
  blaseTakten(12000);

  /* ZOEGERN IN DER KAUFBOX (16.09.2026, Betreiber-Entscheid). Zwanzig Sekunden ohne Klick und
     ohne Tastendruck, waehrend die Kaufbox steht - dann kommt der Hinweis. Scrollen zaehlt
     BEWUSST NICHT als Handlung: wer liest und nicht entscheidet, ist genau der, den wir
     meinen. Wer klickt, konfiguriert weiter und wird nicht gestoert.
     Nur im Rechner-Kaufweg, nicht im Direktkauf-Dialog: dort liegt ein Overlay ueber der
     Seite, der Knopf unten rechts ist verdeckt, und die Blase zeigte ins Leere. */
  let kaufWacheLaeuft=false;
  kaufBlaseAnstossen=function(){
    if(!chatBereit() || blaseGesehen(KAUFBLASE_SCHLUESSEL) || kaufWacheLaeuft) return;
    kaufWacheLaeuft=true;
    let uhr=null;
    const schluss=()=>{
      kaufWacheLaeuft=false; clearTimeout(uhr);
      document.removeEventListener('click',neu,true);
      document.removeEventListener('keydown',neu,true);
    };
    const neu=()=>{
      clearTimeout(uhr);
      uhr=setTimeout(()=>{
        /* Kaufbox inzwischen weg (zurueck in den Funnel, Kasse) - dann gibt es keinen Anlass
           mehr, und der Merker bleibt unverbraucht fuer den naechsten Besuch. */
        if(!document.querySelector('.buybox')){ schluss(); return; }
        baueBlase({merker:KAUFBLASE_SCHLUESSEL, anlass:'kaufbox',
          titel:'Unsicher bei der Auswahl?',
          text:'Frag unseren digitalen Experten &ndash; zu Kits, Speicher und Services.'});
        schluss();
      },20000);
    };
    document.addEventListener('click',neu,true);
    document.addEventListener('keydown',neu,true);
    neu();
  };
  wrap.querySelector('#helpFabClose').onclick=close;
  document.addEventListener('keydown',e=>{ if(e.key==='Escape' && !panel.hidden) close(); });
  document.addEventListener('click',e=>{ if(!panel.hidden && !wrap.contains(e.target)) close(); });
}
/* ---- DIY-Pfad: Warenkorb, Speicher-Wahl, Services, Checkout - unverändert bis auf routeAll-Anbindung ---- */
/* ============ AUFSTELLORT IM KAUFWEG STATT IM FUNNEL (02.09.2026) ============
   Liefert die Chip-Reihe, solange die Frage offen ist, und sonst nichts. Sie steht direkt
   ueber dem Material, weil genau dort ihre Folge sichtbar wird: von der Antwort haengt ab,
   welche Hauseinfuehrung angeboten wird und ob die Erdleitung ueberhaupt Sinn hat.
   "Weiss ich noch nicht" bleibt eine vollwertige Antwort - dann wird keine der beiden
   Hauseinfuehrungen angeboten, statt den Kunden raten zu lassen (siehe Filter weiter unten). */
/* immer=true: Die Frage bleibt auch nach der Antwort stehen, die gegebene ist markiert.

   NACHGEBESSERT 14.09.2026. Vorher verschwand sie, sobald A.aufstellort gesetzt war - und
   das ist es nach einem Durchlauf des Rechners dauerhaft, denn die Antwort liegt im Browser
   gespeichert. Wer den Rechner einmal benutzt hatte, sah im Kasten auf der Produktseite
   ueberhaupt keine Frage mehr und hatte auch keinen Weg, eine falsche Antwort zu berichtigen:
   Die Hauseinfuehrung stand fest, ohne dass erkennbar war, woran sie haengt.

   Im Rechner-Weg bleibt es beim alten Verhalten (immer bleibt dort leer): Dort ist der
   Aufstellort ein eigener Schritt kurz davor, und die Frage ein zweites Mal daneben zu
   stellen, saehe aus, als haette die erste Antwort nicht gezaehlt. */
function aufstellortChipsHtml(immer){
  if(A.aufstellort && !immer) return '';
  const chips=[['nah','Direkt an der Hauswand'],['weit','Weiter weg im Garten'],['unklar','Weiß ich noch nicht']];
  return frageHtml({
    id:'aufstellortFrage', attr:'ort', wert:A.aufstellort, chips:chips,
    titel:'Wo soll die Außeneinheit stehen?', kurz:'Außeneinheit',
    sub:'Davon hängt ab, welche Hauseinführung du brauchst. Du kannst es auch offen lassen.'
  });
}
/* ============ HEIZART IM KAUFWEG (14.09.2026) ============
   Zweite Frage nach demselben Muster: Sie entscheidet, welche Pumpengruppe angeboten wird.
   A.heating ist KEIN neues Feld - es ist dieselbe Antwort, die der Rechner im Schritt
   "Heizkoerper oder Fussboden?" erhebt. Wer von dort kommt, hat sie beantwortet und sieht
   die Frage hier gar nicht; wer direkt auf einer Produktseite landet, beantwortet sie hier.
   Ein eigenes Feld haette zwei Wahrheiten ueber dieselbe Sache ergeben.

   Anders als beim Aufstellort gibt es hier bewusst KEIN "Weiss ich noch nicht": Ob im Haus
   Heizkoerper oder eine Fussbodenheizung liegen, sieht man an der Wand. Die Antwort ist immer
   verfuegbar, und ohne sie laesst sich die Pumpengruppe nicht bestimmen. */
function heizartChipsHtml(immer){
  if(A.heating && !immer) return '';
  /* WORTLAUT NACH DER GRAFIK "BWP Customer Journey" (25.09.2026). Die dritte Antwort hiess
     "Beides" und meinte Heizkoerper UND Fussbodenheizung. Nach der Grafik ist die Frage aber
     eine andere: Wie viele Heizkreise gibt es - und erst die Nachfrage klaert, welche.

     DER WERT 'mix' BLEIBT, nur die Beschriftung aendert sich. Er steckt im gespeicherten Stand,
     im Rechner-Schritt "Heizflaechen", in der Hybrid-Regel, in vlCol() und in der Uebergabe an
     das CRM. Ihn umzubenennen waere eine Aenderung an acht Stellen fuer null Gewinn. */
  const chips=[['hk','Heizkörper'],['fbh','Fußbodenheizung'],['mix','Zwei oder mehr Heizkreise']];
  return frageHtml({
    id:'heizartFrage', attr:'heiz', wert:A.heating, chips:chips,
    titel:'Womit wird bei dir geheizt?', kurz:'Heizart',
    sub:'Davon hängt ab, welche Pumpengruppe du brauchst - eine gemischte regelt die Fußbodenheizung, eine ungemischte versorgt Heizkörper.'
  });
}

/* ============ WIE VIELE HEIZKREISE (Vorgabe 25.09.2026, Grafik "BWP Customer Journey") ======
   Nachfrage zu "Zwei oder mehr Heizkreise". Erst sie entscheidet, welche Pumpengruppe gebraucht
   wird - die Grafik kennt dafuer genau drei Faelle:

     1x Fussbodenheizung + 1x Heizkoerper  ->  1 gemischte + 1 ungemischte (Schluessel gem_ungem)
     2x Heizkoerper                        ->  2 ungemischte Pumpengruppen (Schluessel 2ungem)
     2x Fussbodenheizung                   ->  2 gemischte Pumpengruppen   (Schluessel 2gem)

   Jeder Kreis bekommt seine eigene Pumpengruppe - Stand 25.09.2026 nachmittags. Die ersten
   beiden Zeilen standen vormittags noch auf EINER Gruppe; beide Male hat Clara korrigiert.

   Links steht seit dem 25.09.2026, was der Kunde liest, rechts das Bauteil. Die Schluessel
   tragen noch die alte Sprache - sie stecken in gespeicherten Staenden und bleiben deshalb.

   NUR BEI "Zwei oder mehr": Bei einem einzelnen Kreis steht die Antwort schon fest - ein
   ungemischter braucht gar keine Pumpe, ein gemischter genau eine. Die Nachfrage haette dort
   keinen Gegenstand.

   DIE ZAHL STECKT IN DER ANTWORT, es gibt keinen zusaetzlichen Zaehler: Die Grafik
   unterscheidet nur diese drei Kombinationen. Wer mehr als zwei Kreise hat, korrigiert die
   Menge an der Pumpengruppe selbst - sie traegt seit heute einen Mengenregler. */
function kreiseChipsHtml(immer){
  if(A.heating!=='mix') return '';
  if(A.kreise && !immer) return '';
  /* DIE ANTWORTEN NENNEN DIE HEIZFLAECHE, NICHT DIE REGELUNG (Vorgabe Claras 25.09.2026:
     "anstatt gemischt und ungemischt zu schreiben, bitte fuer gemischt = Fussbodenheizung und
     fuer ungemischt = Heizkoerper schreiben").

     Vorher stand die Fachsprache in den Knoepfen und die Uebersetzung im Satz darunter - wer
     den Satz nicht las, musste raten. Der Kunde weiss, ob in seinem Haus Rohre im Boden oder
     Heizkoerper an der Wand haengen; "gemischt" weiss er nicht.

     DIE SCHLUESSEL BLEIBEN gem_ungem / 2ungem / 2gem: Sie stehen in AUTOWAHL_HEIZART, in
     pumpenMenge(), in systemtrennungNoetig() und in gespeicherten Staenden im Browser. Ein
     Umbenennen waere eine Aenderung an sechs Stellen mit genau null sichtbarer Wirkung - und
     jeder gespeicherte Stand haette seine Antwort verloren. */
  /* DER UMBRUCH STEHT IM TEXT, NICHT IM STYLESHEET (01.10.2026, Vorgabe Claras: "im Button
     '1× Fußbodenheizung + 1× Heizkörper' das Jeweilige in eine Zeile tun, also nach dem + das
     '1× Heizkörper' komplett in die zweite Zeile").

     Gemeint ist eine Trennung nach Sinn, nicht nach Platz: oben der eine Kreis, unten der
     andere. Wo genau ein Text umbricht, kann CSS nicht bestimmen - es bricht dort, wo die
     Zeile voll ist, und das waere je nach Breite mitten in "Fußbodenheizung" oder vor dem
     "1×". Ein <br> setzt die Stelle fest.

     ES DARF HIER MARKUP STEHEN, weil frageHtml() die Beschriftung unveraendert einsetzt
     (${t}, ohne esc) - anders als den Titel und die Erklaerzeile daneben. Wer das spaeter
     aendert, muss diesen Umbruch mitnehmen, sonst steht "<br>" als Text im Knopf.

     DIE BESCHRIFTUNG WIRD SONST NIRGENDS BENUTZT: Gespeichert, gerechnet und an die Kasse
     uebergeben wird der Schluessel gem_ungem, nie dieser Text. */
  const chips=[['gem_ungem','1× Fußbodenheizung +<br>1× Heizkörper'],['2ungem','2× Heizkörper'],['2gem','2× Fußbodenheizung']];
  return frageHtml({
    id:'kreiseFrage', attr:'kreise', wert:A.kreise, chips:chips,
    titel:'Wie sind die Heizkreise aufgeteilt?', kurz:'Heizkreise',
    sub:'Eine Fußbodenheizung braucht eine eigene, geregelte Vorlauftemperatur, Heizkörper nicht. Davon hängt ab, wie viele Pumpengruppen dazukommen.'
  });
}

/* ============ ALTER DER FUSSBODENHEIZUNG (Vorgabe 23.09.2026) ============
   "Wenn bei Pumpengruppe nach der Heizart mit Fussbodenheizung geantwortet wird, lass bitte
   eine weitere Frage aufploppen, und zwar nach dem Jahr, in dem die Fussbodenheizung gebaut
   wurde. Wenn das vor 1990 war, muss auch die Systemtrennung mit ausgewaehlt werden."

   NUR NACH "Fussbodenheizung" ODER "Beides": Bei Heizkoerpern gibt es keine Fussbodenheizung,
   nach deren Alter man fragen koennte - die Frage erschiene ohne Gegenstand.

   WARUM ES DIESE FRAGE BRAUCHT, obwohl die Regel laengst in systemtrennungNoetig() steht:
   Die kannte das Alter bisher nur aus dem RECHNER (A.baujahr, dazu die Nachfrage "fbhalter"
   an der Grenzspanne 1980-1994). Wer ueber eine Produktseite direkt kauft, durchlaeuft den
   Rechner nie - fuer ihn war A.baujahr leer, und die Systemtrennung fiel still aus, obwohl
   genau sie der teuerste und am leichtesten uebersehene Posten der Gruppe ist.

   "WEISS ICH NICHT" PLANT DIE TRENNUNG NICHT EIN (Vorgabe Claras 25.09.2026). Bis dahin zaehlte
   die Antwort wie "vor 1990" - lieber eingeplant als fehlend. Dagegen steht der Posten selbst:
   einige hundert Euro, die niemand angefordert hat. Wer das Alter kennt und "Vor 1990" waehlt,
   bekommt die Trennung weiterhin von allein; wer es nicht weiss, nimmt sie mit einem Haken
   dazu. Die Regel steht in systemtrennungNoetig(), nicht hier.

   DREI SPANNEN STATT EINER JAHRESZAHL: Gefragt ist eine Entscheidung an genau einer Grenze.
   Ein Zahlenfeld verlangte eine Genauigkeit, die niemand hat ("1987 oder 1989?"), und muesste
   Fehleingaben abfangen - drei Knoepfe beantworten dieselbe Frage ohne Tastatur. */
function fbhBaujahrChipsHtml(immer){
  if(A.heating!=='fbh' && A.heating!=='mix') return '';
  /* "2x Heizkoerper" hat keine Fussbodenheizung, nach deren Alter man fragen koennte (Vorgabe
     Claras 25.09.2026: "in dem Fall kannst du auch die Frage nach dem Alter der
     Fussbodenheizung entfernen"). Die Frage haengt an 'mix', und 'mix' heisst nur "zwei oder
     mehr Kreise" - erst die Nachfrage sagt, ob eine Fussbodenheizung dabei ist. */
  if(A.heating==='mix' && A.kreise==='2ungem') return '';
  if(A.fbhBaujahr && !immer) return '';
  const chips=[['vor1990','Vor 1990'],['ab1990','1990 oder später'],['unklar','Weiß ich nicht']];
  return frageHtml({
    id:'fbhBaujahrFrage', attr:'fbhbj', wert:A.fbhBaujahr, chips:chips,
    titel:'Wann wurde deine Fußbodenheizung gebaut?', kurz:'Alter der Fußbodenheizung',
    sub:'Rohre von vor 1990 sind oft nicht diffusionsdicht. Dann kommt eine Systemtrennung dazu, die den Kreis der Wärmepumpe schützt.'
  });
}

/* ============ MENGEN-FRAGEN IM HYDRAULISCHEN ABGLEICH ============
   Fragen nach einer Stueckzahl, alle in der Gruppe "Hydraulischer Abgleich". Jede entscheidet
   die MENGE genau eines Bauteils:

     Heizkoerper       -> EQ3 Heizkoerperthermostat  (eines je Heizkoerper)
     Heizkreise        -> EQ3 FBH-Stellmotor         (einer je Kreis im Verteilerkasten)
     Verteilerkaesten  -> EQ3 Regelklemmleiste       (eine je Kasten, meist also je Etage)

   Die erste gibt es seit dem 21.09.2026, die beiden anderen seit demselben Tag nachmittags
   (Vorgabe: "fueg die Fragen die du mir vorgeschlagen hast dem Konfigurator hinzu").

   EINE TABELLE STATT DREIMAL DERSELBEN FUNKTION. Die Heizkoerper-Frage stand hier
   ausgeschrieben; zwei weitere danebenzustellen hiesse, denselben Stepper, dasselbe Zuklappen
   und dieselbe Nachfuehrung dreimal zu pflegen. In diesem Repository ist mehrfach ein Weg
   geaendert und sein Zwilling uebersehen worden - jetzt gibt es einen Weg und drei Zeilen
   Konfiguration.

   WARUM ZAHLEN UND KEINE CHIPS wie bei Aufstellort und Heizart: Der Rechner fragt die
   Heizkoerper in Spannen ab ("1-8", "9-15", "16+"), weil er daraus nur die Groesse des
   Abgleich-Pakets ableitete. Fuer eine Stueckzahl taugt eine Spanne nicht - aus "1-8" laesst
   sich weder 1 noch 8 begruenden, und jede geratene Zahl staende sofort im Preis.
   A.heizkoerperAnzahl ist deshalb ein EIGENES Feld neben A.radiators: die Spanne ordnet ein,
   die Zahl zaehlt.

   JEDE FRAGE STEHT NUR, WENN IHR BAUTEIL ANGEBOTEN WIRD - und das entscheidet allein
   paketAusgeblendet() ueber die Heizart. Hier entsteht dadurch KEINE zweite Regel: bei
   Heizkoerpern fallen eq3_stell und eq3_klemm weg und mit ihnen die beiden unteren Fragen,
   bei Fussbodenheizung faellt eq3_hk weg und mit ihm die obere, bei "beides" stehen alle drei.
   Wer die Vorauswahl in AUTOWAHL_HEIZART aendert, aendert damit automatisch mit, was gefragt
   wird; eine hier eingebaute Kopie der Heizart-Logik waere genau die zweite Wahrheit, die
   irgendwann auseinanderlaeuft.

   DIE CONTROL UNIT WIRD NICHT GEFRAGT. Von ihr braucht jedes Haus genau eine - eine Frage,
   deren Antwort feststeht, ist keine Frage, sondern eine Bestaetigung. */
const MENGEN_FRAGEN=[
  {id:'heizkoerperFrage', feld:'heizkoerperAnzahl', extra:'eq3_hk', einheit:'Heizkörper', kurz:'Heizkörper',
   titel:'Wie viele Heizkörper hast du?',
   sub:'Für jeden Heizkörper braucht der Abgleich ein Thermostat. Zähl einmal durch – die Stückzahl kannst du hier jederzeit ändern.'},
  {id:'heizkreisFrage', feld:'heizkreisAnzahl', extra:'eq3_stell', einheit:'Heizkreise', kurz:'Heizkreise',
   titel:'Wie viele Heizkreise hat dein Verteilerkasten?',
   sub:'Je Heizkreis sitzt ein Stellmotor am Verteiler. Zähl die Rohrpaare im Kasten – meist ist es ein Kreis je Raum.'},
  {id:'verteilerFrage', feld:'verteilerAnzahl', extra:'eq3_klemm', einheit:'Verteilerkästen', kurz:'Verteilerkästen',
   titel:'Wie viele Verteilerkästen hast du?',
   sub:'Jeder Kasten bekommt eine eigene Regelklemmleiste. Meistens ist es einer je Etage.'}
];
function mengenFrage(id){ return MENGEN_FRAGEN.find(f=>f.id===id)||null; }
/* DIE FRAGE ZIEHT MIT, WENN DIE ZEILE SICH AENDERT (13.10.2026) - die Gegenrichtung zu
   setzeMenge(), das die Zeile nachfuehrt, wenn die Frage sich aendert.

   OHNE DAS STEHEN ZWEI ZAHLEN FUER DIESELBE SACHE auf einem Bildschirm: In Claras
   Bildschirmfoto sagt die Frage "3 Heizkreise", und die Zeile darunter "2 Stk.
   EQ3 FBH-Stellmotor" - gerechnet wird mit der Zeile. Wer am Regler der Zeile dreht, aendert
   die Antwort auf die Frage mit; etwas anderes kann er damit gar nicht gemeint haben.

   A[f.feld] WIRD MITGESETZT und nicht nur die Anzeige: Die Antwort steht im gespeicherten
   Stand und kommt beim naechsten Besuch zurueck. Nur die Zahl auf dem Schirm zu aendern hiesse,
   den Widerspruch bis zum naechsten Laden zu verstecken. */
function mengenFrageNachziehen(extraKey, n, wurzel){
  const f=MENGEN_FRAGEN.find(x=>x.extra===extraKey); if(!f) return;
  if(!(n>0)) return;      /* abgewaehlt ist keine Antwort "null Heizkreise" */
  A[f.feld]=n;
  const w=wurzel||document;
  const anzeige=w.querySelector(`[data-mfwert="${f.id}"]`); if(anzeige) anzeige.textContent=n;
  const zus=w.querySelector(`[data-mfzahl="${f.id}"]`); if(zus) zus.textContent=n;
}
/* Eine einzelne Frage. Leerer String heisst: gehoert hier gerade nicht hin - der Aufrufer
   haengt dann nichts ein, statt einen leeren Kasten zu bauen.

   ANGESPROCHEN WIRD UEBER data-*, NICHT UEBER id: Kaufbox und Direktkauf-Dialog koennen
   gleichzeitig im DOM stehen, dann gaebe es jede Kennung zweimal. Die alte Fassung hatte
   genau dieses Problem (#hkFrageWert) und umging es, indem jeder Zugriff auf die jeweilige
   Wurzel eingeschraenkt wurde. Das bleibt so - aber ohne doppelte id ist es kein Umgehen
   mehr, sondern schlicht richtig. */
/* IMMER OFFEN, AUCH BEANTWORTET (01.10.2026, Vorgabe Claras: "zu den Oberthemen werden ja
   Fragen gestellt, damit man Hilfe bekommt, die Pakete auszuwaehlen. Im Moment, wenn man die
   beantwortet hat, wird das zugeklappt - bitte lass die immer offen/ausgeklappt, sodass man
   die Fragen und die Auswahlmoeglichkeiten sieht. Auch aufgeklappt lassen, wenn durch den
   Rechner die Fragen beantwortet wurden").

   WAS HIER BISHER PASSIERTE, waren ZWEI Verengungen hintereinander:
     1. Beantwortet und ohne "immer" wurde die Frage GANZ WEGGELASSEN - sie verschwand aus der
        Flaeche, als haette es sie nie gegeben.
     2. Beantwortet und mit "immer" wurde sie zu einer Zeile zusammengeklappt, mit "aendern"
        als einzigem Weg zurueck zu den Knoepfen.
   Beides stammt aus einer Vorgabe vom 14.09.2026 ("was geklaert ist, muss keinen Platz mehr
   beanspruchen"). Diese Vorgabe ist am 01.10.2026 aufgehoben: Die Fragen sind die Hilfe beim
   Auswaehlen, und eine Hilfe, die sich nach der ersten Antwort wegraeumt, hilft nur einmal.

   DIE ANTWORT BLEIBT SICHTBAR, OHNE EIGENE ZEILE: Die gewaehlte Menge steht im Regler, die
   gewaehlte Antwort als hervorgehobener Knopf - man sieht also beides auf einmal, was gewaehlt
   ist und was sonst zur Wahl stand.

   DER PARAMETER "immer" BLEIBT STEHEN, obwohl er nichts mehr unterscheidet: Er wird an fuenf
   Stellen uebergeben, und ihn zu entfernen hiesse, fuenf Aufrufe anzufassen, ohne dass sich
   etwas aendert. */
/* ============ DIE FRAGE KLAPPT EIN, DIE AUSWAHL BLEIBT (Vorgabe Claras 01.10.2026) ============

   "Kannst du, wenn die Frage beantwortet wurde, sie doch wieder zuklappen, aber die
   Auswahlmoeglichkeiten noch bestehen lassen, sodass man dann zwar immer noch auswaehlen kann,
   man aber nicht die ganze Frage mehr sieht. Dies erst, wenn die Frage beantwortet wurde, egal
   ob direkt im Konfigurator oder im Rechner. Die Frage, also das, was dann nicht mehr angezeigt
   wird, soll trotzdem noch anzeigbar sein, gerne mit einem Pfeil."

   DAS IST ETWAS ANDERES ALS DAS FRUEHERE ZUKLAPPEN, und der Unterschied ist der ganze Punkt:
   Bis zum 14.09.2026 schrumpfte die beantwortete Frage auf eine Zeile zusammen
   ("Aussseneinheit - Direkt an der Hauswand - aendern"), und damit verschwanden auch die
   Antwortknoepfe. Wer umentscheiden wollte, musste erst aufklappen. Am 01.10.2026 wurde
   deshalb auf Vorgabe alles dauerhaft geoeffnet - und damit stand ueber jeder Auswahl wieder
   ein Absatz Text, den man laengst gelesen hatte.

   JETZT GEHT NUR DER TEXT WEG. Ueberschrift und Erklaerung klappen ein, die Knoepfe bzw. der
   Mengenregler bleiben an Ort und Stelle stehen. Beides zusammen: kein Textberg und trotzdem
   jederzeit umwaehlbar, ohne einen Klick dazwischen.

   DER PFEIL IST IMMER DA, SOBALD BEANTWORTET WURDE - in beide Richtungen. Er zeigt den Text
   wieder und nimmt ihn auch wieder weg; ein Knopf, der nur in eine Richtung wirkt, ist eine
   Sackgasse. Vor der ersten Antwort erscheint er nicht: Da gaebe es nichts einzuklappen, und
   die Frage soll ja gelesen werden.

   ZWEI ZUSTAENDE, ZWEI KLASSEN. af-beantwortet sagt "es gibt etwas zum Ein- und Ausklappen"
   (und blendet den Pfeil ein), af-knapp sagt "gerade eingeklappt". Getrennt, weil eine von Hand
   aufgeklappte Frage beantwortet BLEIBT - mit nur einer Klasse waere das Aufklappen nicht von
   "noch nie beantwortet" zu unterscheiden, und der Pfeil waere beim Aufklappen verschwunden.

   WER VON HAND AUFKLAPPT, BEHAELT ES OFFEN: data-af-auf merkt sich das, und das automatische
   Einklappen der Mengenfragen laesst solche Fragen in Ruhe. Eine Flaeche, die sich gegen den
   Benutzer wieder schliesst, ist schlimmer als gar keine Automatik. */
function afKopfHtml(titel, sub){
  /* Der Pfeil steht VOR dem Text und nicht darin: Eingeklappt wird .af-text ausgeblendet, und
     ein Knopf im ausgeblendeten Block waere mit weg - der Weg zurueck haette gefehlt. */
  return `<button type="button" class="af-auf" aria-label="Frage anzeigen oder ausblenden"
      title="Frage anzeigen oder ausblenden">\u25be</button>
    <div class="af-text">
      <div class="af-titel">${esc(titel)}</div>
      <p class="af-sub">${esc(sub)}</p>
    </div>`;
}
/* Die beiden Klassen fuer den Zustand, damit beide Fragearten dieselbe Schreibweise benutzen. */
function afZustand(beantwortet){
  return beantwortet ? ' af-beantwortet af-knapp' : '';
}
function mengenFrageHtml(f, immer){
  if(typeof paketAusgeblendet==='function' && paketAusgeblendet(f.extra)) return '';
  const n=A[f.feld];
  const stepper=`<div class="af-zahl"><span class="qtystep" data-mfstep="${f.id}">
      <button type="button" data-mfd="-1" aria-label="Weniger">−</button>
      <span class="qv m" data-mfwert="${f.id}">${n||1}</span>
      <button type="button" data-mfd="1" aria-label="Mehr">+</button>
    </span><span class="af-zahl-einheit">${esc(f.einheit)}</span></div>`;
  /* BEANTWORTET HEISST HIER: Es steht eine Zahl im Feld. Die "1" in der Anzeige ist nur der
     Vorgabewert (n||1) und zaehlt nicht - sonst waere jede Frage von Anfang an eingeklappt.
     Gesetzt wird das Feld entweder vom Rechner oder vom ersten Druck auf + / -. */
  return `<div class="aufstellort-frage${afZustand(!!n)}" data-mf="${f.id}">
      ${afKopfHtml(f.titel, f.sub)}
      ${stepper}
    </div>`;
}
/* Alle Fragen der Gruppe am Stueck. Der Aufrufer muss nicht wissen, wie viele es gerade
   sind - bei Heizkoerpern eine, bei Fussbodenheizung zwei, bei "beides" drei. */
function mengenFragenHtml(immer){
  return MENGEN_FRAGEN.map(f=>mengenFrageHtml(f,immer)).join('');
}
/* Setzt Antwort und Menge in einem Zug. BEWUSST OHNE NEUAUFBAU der Flaeche: Die Fragen nach
   Aufstellort und Heizart zeichnen den Kasten nach jedem Klick neu, das ist bei einem Chip
   genau einmal. Hier klickt man sich auf acht hoch - achtmal neu zeichnen hiesse achtmal
   Scrollsprung. Stattdessen werden die Stellen nachgefuehrt, die die Zahl zeigen. */
function setzeMenge(id, n, wurzel){
  const f=mengenFrage(id); if(!f) return;
  const max=(EXTRAS[f.extra] && EXTRAS[f.extra].max) || 30;
  n=Math.max(1,Math.min(max,n));
  A[f.feld]=n;
  chosenExtras[f.extra]=n;
  const w=wurzel||document;
  const anzeige=w.querySelector(`[data-mfwert="${id}"]`); if(anzeige) anzeige.textContent=n;
  const zus=w.querySelector(`[data-mfzahl="${id}"]`); if(zus) zus.textContent=n;
  /* DIE ZEILE IM KASTEN ZIEHT MIT - UND ZWAR AUCH IHR PREIS (13.10.2026).

     HIER STAND DIE STUECKZAHL ALLEIN. Wer die Frage "Wie viele Heizkreise?" hochzaehlte, sah
     in der Zeile darunter die neue Zahl stehen, aber den Betrag von vorher: "3 Stk." neben
     "+ 38 EUR", und 38 sind zwei Stellmotoren. Die Gesamtsumme unten rechnete richtig
     (updateTotal laeuft gleich darunter) - nur die Zeile selbst log, und zwar genau die, auf
     die man gerade geschaut hat.

     GEFUNDEN UEBER DEN STUECKPREIS: Clara meldete, dass er in dieser Zeile nicht erscheint,
     obwohl er im Code steht ("wenn man da die Stueckzahl hoeher macht, veraendert sich der
     Gesamtpreis und man sieht den Stueckpreis nicht mehr"). Er erscheint dort auch nicht - er
     kann gar nicht, weil das Preisfeld seit dem Aufbau der Zeile nicht mehr angefasst wurde.
     Die +/- Knoepfe AN DER ZEILE zeichnen ihn neu (siehe set() in renderBuyBox und im
     Kaufkasten), der Regler an der FRAGE nicht. Zwei Wege zur selben Zahl, einer davon halb.

     querySelectorAll STATT querySelector: Es kann zwei Flaechen geben, die dieselbe Position
     fuehren - die Kaufbox und der Kaufkasten. Eine davon stillschweigend stehen zu lassen ist
     derselbe Fehler eine Ebene hoeher. */
  const eintrag=EXTRAS[f.extra];
  w.querySelectorAll(`input[type=checkbox][data-x="${f.extra}"]`).forEach(cb=>{
    cb.checked=true;
    const zeile=cb.closest('.buyline');
    if(!zeile) return;
    const qv=zeile.querySelector('.qv'); if(qv) qv.textContent=n+' Stk.';
    const pr=zeile.querySelector('.extra-price');
    if(pr && eintrag) pr.innerHTML=mengenPreisHtml(n, eintrag);
  });
  try{ speichereStand(); }catch(e){}
  try{
    if(w.querySelector('#cmExtraList')||document.getElementById('cmExtraList')){
      if(typeof directCand!=='undefined' && directCand) cmUpdateTotal(directCand);
    }
    if(typeof chosenCandidate!=='undefined' && chosenCandidate) updateTotal(chosenCandidate);
  }catch(e){}
  track('mengen_antwort',{frage:f.feld,n:n});
}
/* Die Regler EINER Frage. Eigene Funktion, seit es zwei Aufrufer gab: den Aufbau der Flaeche
   und den Tausch gegen die zugeklappte Fassung. Der zweite ist am 01.10.2026 entfallen - die
   Fragen bleiben offen -, die Aufteilung bleibt trotzdem: Sie haelt den Aufbau der Flaeche
   lesbar und kostet nichts. */
function wireEineMengenFrage(el, wurzel){
  el.querySelectorAll('[data-mfstep] button[data-mfd]').forEach(b=>b.addEventListener('click',()=>{
    const id=b.parentElement.getAttribute('data-mfstep');
    const f=mengenFrage(id); if(!f) return;
    setzeMenge(id,(A[f.feld]||1)+parseInt(b.dataset.mfd,10), wurzel||document);
  }));
}
/* DER PFEIL, EINMAL AM DOKUMENT. Die Fragen werden bei jeder Antwort neu gebaut; einzeln
   mitgehaengte Empfaenger muessten dabei jedes Mal abgeraeumt werden, sonst sammeln sie sich
   an. Ein delegierter Empfaenger kennt dieses Problem nicht. */
document.addEventListener('click', function(e){
  const knopf = e.target.closest && e.target.closest('.af-auf');
  if(!knopf) return;
  const box = knopf.closest('.aufstellort-frage');
  if(!box) return;
  e.preventDefault();
  const jetztZu = box.classList.toggle('af-knapp');
  /* Von Hand aufgeklappt bleibt aufgeklappt - siehe die Begruendung bei afKopfHtml. */
  if(jetztZu) delete box.dataset.afAuf; else box.dataset.afAuf = '1';
});

/* AUTOMATISCH EINKLAPPEN, WENN DIE ZAHL STEHT.

   Die Chipfragen klappen von selbst ein: Ein Klick ist die Antwort, und danach wird die Flaeche
   ohnehin neu gezeichnet. Beim Mengenregler gibt es diesen Moment nicht - nach der "1" kommt
   vielleicht noch die "2", und neu gezeichnet wird hier mit Absicht nicht (acht Druecke waeren
   acht Scrollspruenge). Der naechste eindeutige Zeitpunkt ist deshalb: wenn der Kunde WOANDERS
   hinfasst. Dann ist er mit der Zahl fertig - auch dann, wenn er dazwischen lange nachgezaehlt
   hat. Eine Wartezeit haette genau das bestraft.

   NUR EINE KLASSE WIRD GESETZT, nichts neu gebaut (anders als bei der Fassung vom 21.09.2026,
   die die Frage per replaceWith austauschte): kein Fokusverlust, kein Sprung, und der Regler
   unter dem Finger bleibt derselbe Knopf.

   pointerdown und nicht click, damit es auch dort greift, wo der Griff gar kein click
   ausloest. */
document.addEventListener('pointerdown', function(e){
  document.querySelectorAll('.aufstellort-frage[data-mf]:not(.af-knapp)').forEach(box=>{
    if(box.dataset.afAuf) return;            /* von Hand geoeffnet - in Ruhe lassen */
    if(box.contains(e.target)) return;       /* er ist noch an dieser Frage */
    const f = mengenFrage(box.getAttribute('data-mf'));
    if(!f || !A[f.feld]) return;             /* noch gar nicht beantwortet */
    box.classList.add('af-beantwortet','af-knapp');
  });
});
function wireMengenFragen(scope){
  const wurzel = scope==='cm' ? document.getElementById('cartModalBody') : document.querySelector('.buybox');
  if(!wurzel) return;
  wurzel.querySelectorAll('[data-mf]').forEach(el=>wireEineMengenFrage(el, wurzel));
}
/* ============ ZUKLAPPEN, WENN DIE ZAHL STEHT (Vorgabe 21.09.2026) ============
   "Beim hydraulischen Abgleich sollen sich die Fragen auch schliessen, wenn man sie
   beantwortet hat, so wie auch bei den anderen."

   Zugeklappt konnten sie von Anfang an - mengenFrageHtml() liefert bei gesetzter Antwort die
   Zeile "Heizkoerper · 8 · aendern". Gebaut wurde sie aber nur beim Neuzeichnen der ganzen
   Flaeche, und genau das unterbleibt hier absichtlich: Die Chip-Fragen zeichnen nach ihrer
   einen Antwort neu, ein Stueckregler wird acht Mal gedrueckt, und acht Neuaufbauten waeren
   acht Scrollspruenge.

   WANN IST EINE ZAHL BEANTWORTET? Bei einem Chip ist es der Klick. Beim Regler gibt es diesen
   Moment nicht - nach der "1" kommt vielleicht noch die "2". Deshalb der naechste eindeutige
   Zeitpunkt: wenn der Kunde WOANDERS hinfasst. Dann ist er mit der Zahl fertig, und zwar auch
   dann, wenn er dazwischen lange ueberlegt oder nachgezaehlt hat. Eine Wartezeit haette genau
   das bestraft.

   EIN EINZIGER, DELEGIERTER EMPFAENGER am Dokument statt je Frage einer: Die Fragen werden bei
   jeder Antwort neu gebaut: mitgehaengte Empfaenger muessten dabei jedes Mal abgeraeumt werden,
   sonst sammeln sie sich an. pointerdown und nicht click, damit es auch dann greift, wenn der
   Griff woanders gar kein click ausloest.

   GETAUSCHT WIRD NUR DIE EINE FRAGE, nicht die Flaeche: replaceWith an Ort und Stelle, dann die
   Regler der neuen Fassung verdrahten. Der Rest der Liste ruehrt sich nicht - kein Sprung. */
/* HIER STAND DAS ZUKLAPPEN BEIM KLICK DANEBEN (schliesseMengenFrage und ein pointerdown-
   Horcher am Dokument). Beides ist am 01.10.2026 entfallen, weil die Fragen auf Claras Vorgabe
   dauerhaft offen bleiben - siehe mengenFrageHtml().

   ES WAERE NICHT NUR WIRKUNGSLOS, SONDERN SCHAEDLICH GEWESEN: Der Horcher lief bei JEDEM Klick
   irgendwo auf der Seite und baute jede beantwortete Frage neu auf. Zugeklappt war das der
   Zweck; offen haette er dieselbe Flaeche durch eine gleich aussehende ersetzt - mitsamt
   Verlust des Fokus und einem Sprung, sobald jemand gerade am Mengenregler war.

   Zurueckholen hiesse: beide Teile wieder einsetzen UND in mengenFrageHtml() die zugeklappte
   Fassung. Das eine ohne das andere ergibt nichts. */

/* Beide Fragen werden hier gebaut, damit sie sich nicht auseinanderentwickeln.

   IMMER OFFEN, OB BEANTWORTET ODER NICHT (01.10.2026, Vorgabe Claras - siehe die ausfuehrliche
   Begruendung bei mengenFrageHtml). Bis dahin klappte eine beantwortete Frage auf eine Zeile
   zusammen ("Außeneinheit · Direkt an der Hauswand · ändern"), nach einer Vorgabe vom
   14.09.2026. Die ist aufgehoben: Die Fragen sind die Hilfe beim Auswaehlen, und wer die
   Antwort sieht, soll auch sehen, was sonst zur Wahl stand.

   DAS GILT AUCH FUER ANTWORTEN AUS DEM RECHNER. Sie landen in denselben Feldern, also durch
   dieselbe Stelle - es braucht dafuer keine eigene Regel.

   DIE ANTWORT IST WEITERHIN ZU ERKENNEN: Der gewaehlte Knopf traegt "sel" und hebt sich ab. */
function frageHtml(o){
  const chips=`<div class="af-chips">${o.chips.map(([w,t])=>
    `<button type="button" class="af-chip${o.wert===w?' sel':''}" data-${o.attr}="${w}">${t}</button>`).join('')}</div>`;
  return `<div class="aufstellort-frage${afZustand(!!o.wert)}" id="${o.id}">
      ${afKopfHtml(o.titel, o.sub)}
      ${chips}
    </div>`;
}

/* Waehlt die Position aus, die zur Antwort gehoert - Vorgabe 14.09.2026: Wer sagt, wo die
   Aussseneinheit steht, soll die passende Hauseinfuehrung nicht noch einmal suchen muessen.
   Die Menge bleibt stehen, falls schon eine eingestellt war; neu ist sie 1.

   Das Entweder/Oder der Gruppe gilt dabei wie beim Anhaken von Hand: Bei einem Wechsel von
   "an der Wand" auf "im Garten" verschwindet die oberirdische Durchfuehrung, statt neben der
   unterirdischen stehen zu bleiben. */
/* WAS EINE ANTWORT MITBRINGT (Vorgabe 15.09.2026). Frueher war es je eine Position, jetzt
   die ganze Zusammenstellung, die zu dieser Entscheidung gehoert - der Kunde soll nicht
   dieselbe Antwort ein zweites Mal in Form von vier Haekchen geben muessen.

   Die Reihenfolge ist die der Liste im Kasten, damit die Warenkorb-Schublade danach in
   derselben Folge liest wie die Auswahl daneben.

   Abwaehlen bleibt jederzeit moeglich; nichts davon ist gesperrt. */
/* DIE ERDLEITUNG GEHOERT NUR ZU "weiter weg im Garten" (Vorgabe 18.09.2026).

   Sie stand bis hierher auch bei "direkt an der Hauswand" gehakt. Das war die Vorgabe vom
   15.09.2026, die sie fuer BEIDE Aufstellorte nannte - und sie widersprach dem, was die
   Frage selbst sagt: "bis etwa 2 m - oberirdische Durchfuehrung moeglich". Wer an der Wand
   aufstellt, hat kein Erdreich zu queren und bekam trotzdem 95 € je Meter vorgewaehlt.

   EIN WECHSEL RAEUMT JETZT VON SELBST AUF: autowahlAnwenden() loescht, was in der Liste der
   anderen Antwort steht und in der neuen fehlt. Wer von "im Garten" auf "an der Wand"
   umschwenkt, verliert die Erdleitung also mit demselben Klick. Die ausdrueckliche
   Aufraeumzeile im Fragebogen (siehe "Stiller Fehler, gefunden am 18.08.2026") bleibt
   trotzdem stehen: Dort wird nur A.aufstellort gesetzt, autowahlAnwenden laeuft erst
   spaeter in der Kaufbox - ohne sie klaffte dazwischen ein Zustand mit bezahlten Metern. */
const AUTOWAHL_AUFSTELLORT = {
  nah:    ['haus_ober',  'daempfung'],
  weit:   ['haus_unter', 'anschluss_ui', 'erdleitung', 'daempfung'],
  unklar: []   /* Ohne Entscheidung waere jede Vorauswahl geraten. */
};
/* Bei "beides" gibt es zwei getrennt geregelte Kreise - und damit braucht es BEIDE
   Pumpengruppen (Vorgabe 16.09.2026): die gemischte fuer die Fussbodenheizung, die
   ungemischte fuer die Heizkoerper. Vorher war nur die gemischte gehakt.

   Dass beide gleichzeitig stehen duerfen, ist kein Sonderfall fuer diese Tabelle: Die
   Entweder/Oder-Sperre der Gruppe 'pumpe' ist bei "beides" ohnehin aufgehoben
   (pumpenSperreAktiv liest A.heating), sonst wuerde die zweite die erste wieder abraeumen. */
/* DIE HEIZART ENTSCHEIDET AUCH DEN ABGLEICH (Vorgabe 21.09.2026). Bis hierher setzte sie nur
   die Pumpengruppe; die EQ3-Bauteile musste der Kunde selbst zusammensuchen, obwohl aus
   derselben Antwort folgt, welche davon ueberhaupt passen:

     EQ3 Heizkoerperthermostat  ersetzt den manuellen Thermostatkopf am Heizkoerper
                                -> nur bei Heizkoerpern, Menge = Zahl der Heizkoerper
     EQ3 FBH-Stellmotor         regelt den Durchfluss am Verteilerkasten
                                -> nur bei Fussbodenheizung, Menge = Zahl der Heizkreise
     EQ3 Regelklemmleiste WK    die Steuerbox, die die Stellmotoren ansteuert
                                -> nur bei Fussbodenheizung, eine je Verteilerkasten
     Homematic Control Unit     die zentrale Steuerung des Abgleichs
                                -> bei BEIDEN Heizarten, genau eine je Haus

   MENGE IMMER 1 ZUM START. waehleAusGruppe() setzt eins; wie viele Heizkoerper oder
   Heizkreise es sind, weiss der Shop nicht - die Frage im Rechner liefert nur Spannen
   ("1-8", "9-15"), und bei Fussbodenheizung wird sie gar nicht gestellt. Eine geratene Zahl
   waere hier teuer: Sie stuende sofort im Preis. Der Hinweis "je Heizkoerper" steht an der
   Zeile, der ⓘ der Gruppe sagt ausdruecklich "zaehl einmal durch".

   DIE SCHALTSTECKDOSE steht bewusst in KEINER Liste: Sie ist ein Verstaerker fuer den
   Funk und nur noetig, wenn die Reichweite nicht langt - das weiss niemand vorher.
   Dadurch wird sie weder vorgewaehlt noch ausgeblendet.

   WAS NICHT IN DER LISTE DER ANTWORT STEHT, VERSCHWINDET (siehe paketAusgeblendet): Bei
   Heizkoerpern fallen Stellmotor und Klemmleiste weg, bei Fussbodenheizung das Thermostat.
   Die Control Unit steht in allen drei Listen und bleibt deshalb immer. */
/* NACH DER GRAFIK "BWP Customer Journey" (25.09.2026). Vorher hing alles an der Heizart
   allein, und ein einzelner Heizkoerper-Kreis bekam eine ungemischte Pumpengruppe
   vorausgewaehlt. Die Grafik sagt etwas anderes: Ein einzelner ungemischter Kreis braucht GAR
   KEINE weitere Pumpe - die Hydraulikstation versorgt ihn direkt.

     Heizkoerper (1 Kreis ungemischt)      ->  keine Pumpengruppe
     Fussbodenheizung (1 Kreis gemischt)   ->  1 gemischte
     Zwei oder mehr + 1x gem / 1x ungem    ->  1 gemischte  (die ungemischte entfaellt)
     Zwei oder mehr + 2x ungemischt        ->  1 ungemischte
     Zwei oder mehr + 2x gemischt          ->  2 gemischte

   DIE HYDROBOX BRINGT EINEN UNGEMISCHTEN KREIS MIT - das ist der rote Faden durch die drei
   Zeilen mit Heizkoerpern (28.09.2026, Vorgabe Claras: "wenn man einen Heizkreis mit
   Heizkoerpern hat, braucht man keine Pumpengruppe (ungemischt) mehr, da die in der Hydrobox
   vorhanden ist"). Siehe ungemischteKreise().

   DER SCHLUESSEL IST ZUSAMMENGESETZT ("mix:2gem"), weil die Antwort allein nicht mehr reicht.
   Solange die Nachfrage unbeantwortet ist, gibt es zu 'mix' keinen Eintrag - paketAusgeblendet
   blendet dann nichts aus und autowahlAnwenden waehlt nichts. Das ist richtig: Vor der
   Nachfrage ist nicht entschieden, was gebraucht wird. */
const AUTOWAHL_HEIZART = {
  'hk':           ['eq3_hk', 'homematic'],
  'fbh':          ['pump_gem', 'eq3_stell', 'eq3_klemm', 'homematic'],
  /* OHNE pump_ungem seit dem 28.09.2026: Den einen Heizkoerperkreis versorgt die Pumpe in der
     Hydrobox. Was hier nicht steht, wird nicht nur nicht gehakt, sondern gar nicht erst
     gezeigt (paketAusgeblendet) - genau das war die Vorgabe: "stelle die ungemischte gar nicht
     dar, nur wieder den Hinweis, dass in der Hydrobox schon eine drin ist". */
  'mix:gem_ungem':['pump_gem', 'eq3_hk', 'eq3_stell', 'eq3_klemm', 'homematic'],
  'mix:2ungem':   ['pump_ungem', 'eq3_hk', 'homematic'],
  'mix:2gem':     ['pump_gem', 'eq3_stell', 'eq3_klemm', 'homematic']
};
/* Der Schluessel fuer die Tabelle oben. Bei 'mix' ohne Nachfrage bewusst leer - siehe dort. */
function heizartSchluessel(){
  if(A.heating!=='mix') return A.heating;
  return A.kreise ? ('mix:'+A.kreise) : '';
}
/* Wie viele Pumpengruppen die Antwort bedeutet - je Bauart eine Zahl.

   ZWEI KREISE HEISST ZWEI GRUPPEN, in beide Richtungen (Vorgabe Claras 25.09.2026: "wenn man
   2x Heizkreise auswaehlt, wird bei der Stueckzahl nicht automatisch 2 Stueck ausgewaehlt").
   Fuer die gemischte galt das seit gestern, die ungemischte stand bis heute mit einer einzelnen
   da - obwohl die Antwort ausdruecklich von zwei Kreisen spricht. Jeder Kreis braucht seine
   eigene Pumpe; eine Zahl, die der Antwort widerspricht, muss der Kunde von Hand berichtigen,
   und was er uebersieht, steht falsch in der Summe.

   waehleAusGruppe setzt sonst immer 1 - diese beiden Funktionen sind die einzige Ausnahme. */
function pumpenMenge(){ return (A.heating==='mix' && A.kreise==='2gem') ? 2 : 1; }
/* WIE VIELE UNGEMISCHTE KREISE (Heizkoerperkreise) die Antworten bedeuten: 0, 1 oder 2.

   Diese eine Zahl beantwortet seit dem 28.09.2026 beide Fragen der Gruppe - ob eine ungemischte
   Pumpengruppe noetig ist und ob der Hydrobox-Hinweis erscheint. Vorher standen die drei Faelle
   an drei Stellen verstreut, und genau dort liefen sie auseinander: Bei "1x Fussbodenheizung +
   1x Heizkoerper" stand eine ungemischte Pumpengruppe im Angebot, bei "2x Heizkoerper" gleich
   zwei - obwohl die Hydrobox einen dieser Kreise selbst versorgt. */
function ungemischteKreise(){
  if(A.heating==='hk') return 1;
  if(A.heating!=='mix') return 0;
  if(A.kreise==='gem_ungem') return 1;
  if(A.kreise==='2ungem')    return 2;
  return 0;
}
/* EINER GEHT AUFS HAUS (28.09.2026, Vorgabe Claras: "auch wenn man zwei Heizkreise mit 2x
   Heizkoerpern hat, braucht man nur eine ungemischte Pumpengruppe und nicht zwei, weil eine ja
   schon in der Hydrobox ist - mach dort im Stueckzahl-Regler nur 1 Stk").

   In der Hydrobox der Inneneinheit sitzt bereits eine ungemischte Pumpe. Sie versorgt den
   ersten Heizkoerperkreis; erst der zweite braucht eine eigene Gruppe. Bis heute rechnete diese
   Funktion einen Kreis gleich eine Gruppe und legte bei "2x Heizkoerper" zwei in den Korb - eine
   davon war doppelt bezahlt.

   MINDESTENS 1, nicht 0: Bei einem einzigen Heizkoerperkreis steht die Gruppe gar nicht zur
   Wahl. Wer sie trotzdem von Hand dazunimmt, soll keine Position mit der Menge 0 bekommen -
   das waere ein Haken ohne Wirkung. Der Regler an der Zeile bleibt frei bis 4. */
function pumpenMengeUngemischt(){ return Math.max(1, ungemischteKreise()-1); }
/* Nachziehen, was gerade gehakt IST. Nur die gehakten: Eine Menge an einer abgewaehlten
   Position waere ein Haken, den niemand gesetzt hat. Drei Aufrufstellen hatten bisher je eine
   eigene Zeile fuer die gemischte - die vierte Bauart haette dort dreimal nachgetragen werden
   muessen, und genau so entstehen in dieser Datei die Zwillinge, die auseinanderlaufen. */
function pumpenMengenAnwenden(){
  if(chosenExtras.pump_gem)   chosenExtras.pump_gem   = pumpenMenge();
  if(chosenExtras.pump_ungem) chosenExtras.pump_ungem = pumpenMengeUngemischt();
  /* Das Trennsystem IST der gemischte Kreis (es enthaelt dieselbe Pumpengruppe) und zaehlt
     deshalb wie er: Zwei Fussbodenheizungskreise von vor 1990 brauchen zwei davon (Vorgabe
     Claras 25.09.2026: "bei 2x Fussbodenheizung vor 1990 den gemischten Kreis zwei Mal
     auswaehlen, also bei Stueckzahlen").

     DIESE RUNDE LAEUFT NACH systemtrennungAnwenden(), nicht davor: Die setzt den Posten
     ueberhaupt erst. Andersherum traefe die Mengenrunde ihn noch gar nicht an, und er bliebe
     bei der 1, die waehleAusGruppe vergibt. */
  if(chosenExtras.systr)      chosenExtras.systr      = pumpenMenge();
}

/* Wendet die Antwort einer Frage an: Was zu ihr gehoert, wird gehakt - was zu einer ANDEREN
   Antwort derselben Frage gehoerte und zu dieser nicht, verliert seinen Haken.

   Der zweite Teil war nicht noetig, solange ein only-Filter die unpassenden Pakete ausblendete:
   raeumeUnpassendeExtras() raeumte sie dann mit weg. Seit alle Pakete stehenbleiben (16.09.2026)
   muss das Umhaken hier passieren - sonst behielte etwa der Innenanschluss UI seinen Haken,
   wenn jemand von "im Garten" auf "an der Hauswand" wechselt. Er traegt keine xgroup, ueber die
   ihn ein Geschwister ablösen koennte.

   Was in BEIDEN Listen steht - Erdleitung, Daempfungssockel - bleibt unangetastet. */
/* WAS DIE ANTWORT AUSSCHLIESST, WIRD AUSGEBLENDET (Vorgabe 21.09.2026).

   Bis hierher standen alle Pakete in der Liste, und die Antwort setzte nur die Haken - das
   war die Vorgabe vom 16.09.2026 ("die unpassenden sollen aber immer noch angezeigt werden,
   nur halt ohne Haken"). Die neue kehrt das um: Wer geantwortet hat, soll die Pakete, die zu
   seiner Antwort nicht gehoeren, gar nicht erst sehen.

   NUR INNERHALB DER FRAGE. Verglichen wird ausschliesslich mit den Paketen, die in DER
   TABELLE der jeweiligen Frage ueberhaupt vorkommen. Alles andere - Speicher, hydraulischer
   Abgleich, Befuellung - hat mit der Frage nichts zu tun und bleibt unberuehrt. Ohne diese
   Eingrenzung wuerde eine beantwortete Frage die halbe Liste verschwinden lassen.

   DIE SYSTEMTRENNUNG steht in KEINER der Tabellen und kann deshalb nie verschwinden. Sie
   wird von systemtrennungAnwenden() aus Baujahr und Heizart entschieden - waere sie hier
   erfasst, verschwaende ein Paket, das gleichzeitig angehakt ist.

   VON HAND ANGEHAKTES BLEIBT STEHEN. Wer ein Paket bewusst dazugenommen hat, verliert es
   nicht, weil er hinterher die Frage anders beantwortet - es waere sonst still aus dem
   Warenkorb verschwunden, waehrend die Summe sich aendert. Abwaehlen kann er es selbst. */
/* DER HINWEIS ANSTELLE DER PAKETE (Vorgabe Claras 25.09.2026). Bei Heizkoerpern gibt es in
   dieser Gruppe nichts zu waehlen - aber die Gruppe ganz wegzulassen liesse die Frage nach der
   Heizart ohne sichtbare Folge stehen, und der Kunde suchte die Pumpengruppe, die er anderswo
   gesehen hat. Der Satz sagt ihm, warum keine dasteht.

   KURSIV UND KLEIN, weil er keine Auswahl ist: Alles andere in dieser Liste laesst sich anhaken
   und kostet etwas. Ein Satz in derselben Schrift wie die Zeilen daneben sieht aus wie eine
   Position, der nur der Preis fehlt.

   ER GILT NUR FUER "Heizkoerper": Bei "zwei oder mehr Heizkreise" kann ein ungemischter Kreis
   dabei sein und trotzdem eine Pumpengruppe noetig werden - dort steht sie weiter zur Wahl. */
/* STEHT DIE SYSTEMTRENNUNG UEBERHAUPT ZUR WAHL? (25.09.2026)

   Nicht zu verwechseln mit systemtrennungNoetig(): Die sagt, ob der HAKEN gesetzt wird. Diese
   hier sagt, ob die Zeile ueberhaupt erscheint. Bisher stand sie immer da und war nur mal
   gehakt und mal nicht - in drei Faellen ist das eine Wahl, die es gar nicht gibt:

     Heizkoerper                 - es gibt keine Fussbodenheizung, die zu trennen waere
                                   (Vorgabe: "kein Produktpaket, nur ein Hinweis in kursiv")
     2x Heizkoerper              - dasselbe, nur ueber die Nachfrage beantwortet
                                   (Vorgabe: "die Moeglichkeit ... auszuwaehlen entfernen")
     Fussbodenheizung ab 1990    - diffusionsdichte Rohre, die Trennung hat nichts zu schuetzen
                                   (Vorgabe: "musst du den gemischten Kreis mit Systemtrennung
                                   nicht anzeigen")

   DIE LETZTE REGEL GILT UEBERALL, nicht nur bei "2x Fussbodenheizung", wo sie gefordert wurde:
   Der Grund haengt am Alter der Rohre, nicht an ihrer Anzahl. Eine Zeile, die bei einem Kreis
   erscheint und bei zweien nicht, waere aus dem Verhalten nicht zu erklaeren. */
function systemtrennungWaehlbar(){
  if(A.heating==='hk') return false;
  if(A.heating==='mix' && A.kreise==='2ungem') return false;
  if(A.fbhBaujahr==='ab1990') return false;
  return true;
}
/* DER HINWEIS GILT, SOBALD EIN HEIZKOERPERKREIS DABEI IST (28.09.2026 erweitert, Vorgabe
   Claras: "nur wieder den Hinweis, dass in der Hydrobox schon eine drin ist, wie auch bei nur
   einem Heizkreis mit Heizkoerpern" - und fuer zwei Heizkoerperkreise: "auch wieder den
   Hinweis").

   Er stand bis dahin nur bei "Heizkoerper" und war ausdruecklich auf diesen Fall begrenzt. Das
   war richtig, solange die Nachfrage nach den Kreisen eine ungemischte Gruppe nach sich zog:
   Ein Satz "ist schon eine drin" neben einer Zeile, die genau die anbietet, widerspricht sich.
   Seit die Hydrobox-Pumpe in allen drei Faellen mitzaehlt, erklaert derselbe Satz alle drei -
   einmal, warum keine Zeile dasteht, und einmal, warum bei zwei Kreisen nur eine. */
function pumpenHinweisHtml(){
  if(ungemischteKreise() < 1) return '';
  return '<p class="xgrp-hinweis"><em>In der Hydrobox ist schon eine ungemischte Pumpe integriert.</em></p>';
}
function paketAusgeblendet(key){
  const pruefe=(tabelle, wert)=>{
    const liste=wert && tabelle[wert];
    /* "WEISS ICH NOCH NICHT" BLENDET NICHTS AUS. Die leere Liste bei 'unklar' heisst nicht
       "nichts davon", sondern "noch nicht entschieden" - siehe den Kommentar an der Tabelle.
       Ohne diese Zeile verschwaende die ganze Hauseinfuehrung, sobald jemand ehrlich
       antwortet, dass er es noch nicht weiss. Genau der waere auf die Liste angewiesen. */
    if(!liste || !liste.length) return false;
    const inTabelle=Object.keys(tabelle).some(w=>(tabelle[w]||[]).indexOf(key)>=0);
    if(!inTabelle) return false;
    if(liste.indexOf(key)>=0) return false;
    /* Von Hand Angehaktes bleibt stehen - sonst verschwaende es samt seinem Betrag aus der
       sichtbaren Liste, waehrend die Summe es weiter mitzaehlt. */
    return !(chosenExtras[key]>0);
  };
  return pruefe(AUTOWAHL_AUFSTELLORT, A.aufstellort) || pruefe(AUTOWAHL_HEIZART, heizartSchluessel());
}
function autowahlAnwenden(tabelle, wert){
  const neu = tabelle[wert] || [];
  Object.keys(tabelle).forEach(w=>{
    if(w===wert) return;
    (tabelle[w]||[]).forEach(k=>{ if(neu.indexOf(k)<0) delete chosenExtras[k]; });
  });
  neu.forEach(waehleAusGruppe);
}
/* Setzt oder loescht den Haken bei der Systemtrennung nach derselben Regel. Getrennt von
   AUTOWAHL_HEIZART, weil sie nicht an der Heizart allein haengt, sondern auch am Baujahr -
   eine Tabelle nach Antwort waere dafuer zu grob. */
function systemtrennungAnwenden(){
  if(systemtrennungNoetig()) waehleAusGruppe('systr');
  else delete chosenExtras.systr;
}
function waehleAusGruppe(key){
  const e=EXTRAS[key]; if(!e) return;
  if(xgroupSperrt(e.xgroup)) Object.keys(EXTRAS).forEach(o=>{
    if(o!==key && EXTRAS[o].xgroup===e.xgroup) delete chosenExtras[o];
  });
  raeumeAusgeschlossene(key);
  chosenExtras[key]=chosenExtras[key]||1;
}
/* Raeumt weg, was zur neuen Antwort nicht mehr angeboten wird. Ohne das bliebe eine Position
   im Warenkorb, die in der Liste gar nicht mehr auftaucht: Wer erst "an der Wand" sagt, die
   oberirdische Durchfuehrung bekommt und dann auf "weiss ich noch nicht" wechselt, haette sie
   weiter bezahlt, ohne sie irgendwo abwaehlen zu koennen. */
function raeumeUnpassendeExtras(){
  Object.keys(chosenExtras).forEach(k=>{
    const e=EXTRAS[k];
    if(!e || (e.only && !e.only(A))) delete chosenExtras[k];
  });
}
/* Dieselbe Mechanik wie bei der Heizart - nur dass hier ausser der Systemtrennung nichts
   umgehakt wird: Das Alter der Fussbodenheizung entscheidet genau einen Posten. */
/* Wie bei der Heizart: Die Antwort waehlt um, raeumt auf und zeichnet neu. Zusaetzlich wird
   die Menge der gemischten Pumpengruppe gesetzt - waehleAusGruppe kennt nur "mindestens 1". */
function wireKreiseChips(scope){
  const wurzel = scope==='cm' ? document.getElementById('cartModalBody') : document.querySelector('.buybox');
  if(!wurzel) return;
  wurzel.querySelectorAll('#kreiseFrage .af-chip').forEach(b=>b.addEventListener('click',()=>{
    A.kreise=b.dataset.kreise;
    raeumeUnpassendeExtras();
    autowahlAnwenden(AUTOWAHL_HEIZART, heizartSchluessel());
    systemtrennungAnwenden();
    pumpenMengenAnwenden();
    speichereStand();
    track('heizkreise_select',{wert:b.dataset.kreise, path:scope==='cm'?'direct':'funnel'});
    if(scope==='cm'){ if(directCand) renderCartModalIncluded(directCand); }
    else if(chosenCandidate){ renderBuyBox(chosenCandidate); }
  }));
}
function wireFbhBaujahrChips(scope){
  const wurzel = scope==='cm' ? document.getElementById('cartModalBody') : document.querySelector('.buybox');
  if(!wurzel) return;
  wurzel.querySelectorAll('#fbhBaujahrFrage .af-chip').forEach(b=>b.addEventListener('click',()=>{
    A.fbhBaujahr=b.dataset.fbhbj;
    /* DIE ANTWORT ENTSCHEIDET SEIT DEM 25.09.2026 AUCH UEBER DIE PUMPENGRUPPE, nicht mehr nur
       ueber die Systemtrennung: Bei Rohren von vor 1990 tritt die einzelne gemischte Gruppe
       hinter das Trennsystem zurueck, das sie enthaelt. Der Weg zurueck braucht deshalb die
       Vorauswahl neu - wer von "vor 1990" auf "1990 oder spaeter" wechselt, stuende sonst ganz
       ohne Pumpengruppe da: Das Trennsystem faellt weg, und die einzelne war vorher geraeumt. */
    autowahlAnwenden(AUTOWAHL_HEIZART, heizartSchluessel());
    systemtrennungAnwenden();
    pumpenMengenAnwenden();
    speichereStand();
    track('fbh_baujahr_select',{wert:b.dataset.fbhbj, path:scope==='cm'?'direct':'funnel'});
    if(scope==='cm'){ if(directCand) renderCartModalIncluded(directCand); }
    else if(chosenCandidate){ renderBuyBox(chosenCandidate); }
  }));
}
function wireHeizartChips(scope){
  const wurzel = scope==='cm' ? document.getElementById('cartModalBody') : document.querySelector('.buybox');
  if(!wurzel) return;
  wurzel.querySelectorAll('#heizartFrage .af-chip').forEach(b=>b.addEventListener('click',()=>{
    A.heating=b.dataset.heiz;
    /* Die Nachfrage gehoert zu "Zwei oder mehr". Wer auf eine der beiden anderen Antworten
       wechselt, darf ihre alte Antwort nicht behalten - sie wuerde weiter Pumpengruppen
       waehlen, die zur neuen Heizart nicht gehoeren. */
    if(A.heating!=='mix') A.kreise=null;
    raeumeUnpassendeExtras();
    autowahlAnwenden(AUTOWAHL_HEIZART, heizartSchluessel());
    systemtrennungAnwenden();
    pumpenMengenAnwenden();
    speichereStand();
    track('heizart_select',{art:b.dataset.heiz, path:scope==='cm'?'direct':'funnel'});
    if(scope==='cm'){ if(directCand) renderCartModalIncluded(directCand); }
    else if(chosenCandidate){ renderBuyBox(chosenCandidate); }
  }));
}
/* Nach der Antwort muss die Materialliste neu gebaut werden - die Filter darin lesen
   A.aufstellort. Deshalb wird die ganze Kauffaeche neu gezeichnet statt einzelner Zeilen:
   eine Quelle, kein Teilabgleich, der auseinanderlaufen kann. */
function wireAufstellortChips(scope){
  const wurzel = scope==='cm' ? document.getElementById('cartModalBody') : document.querySelector('.buybox');
  if(!wurzel) return;
  wurzel.querySelectorAll('#aufstellortFrage .af-chip').forEach(b=>b.addEventListener('click',()=>{
    A.aufstellort=b.dataset.ort;
    raeumeUnpassendeExtras();
    autowahlAnwenden(AUTOWAHL_AUFSTELLORT, A.aufstellort);
    speichereStand();
    track('aufstellort_select',{ort:b.dataset.ort, path:scope==='cm'?'direct':'funnel'});
    if(scope==='cm'){ if(directCand) renderCartModalIncluded(directCand); }
    else if(chosenCandidate){ renderBuyBox(chosenCandidate); }
  }));
}
/* WAS DER KUNDE SELBST BESORGT (Vorgabe 18.09.2026).

   Steht zwischen Warmwasserspeicher und Abholung, also am Ende dessen, was es bei uns zu
   waehlen gibt und vor der Frage, wie es kommt. Genau dort ist die Liste der Auswahl im
   Kopf des Kunden vollstaendig - und genau dort faellt auf, was darin NICHT vorkommt.

   EINE QUELLE FUER BEIDE KAUFWEGE. Rechner-Kaufbox und Kasten der Produktseite bauen ihre
   Oberflaechen getrennt; ein zweites Mal hingeschriebener Text waere beim naechsten Zusatz
   nur an einer Stelle nachgezogen worden - das ist in dieser Datei schon mehrfach passiert.

   KEIN KAUFHINWEIS, SONDERN EINE ABGRENZUNG: Nichts davon ist bei uns bestellbar, und der
   Satz soll auch nicht so klingen. Deshalb leise gesetzt und ohne Knopf.

   "Stockschrauben" statt "Stochschrauben" aus der Vorgabe - gemeint sind die Schrauben mit
   Holz- und Metrischgewinde, mit denen Schellen befestigt werden. */
const SELBST_BESORGEN = 'Fundament, Rohre, Fittinge, Übergänge, Verschraubungen, T-Stücke, '
  + 'Entleerungen, Entlüftungsstopfen etc., Schellen, Stockschrauben, Dübel etc.';
/* WARUM DIESE TEILE NICHT IM KIT SIND (Vorgabe 18.09.2026). Der Satz steht UNTER der Liste:
   Erst sieht der Kunde, worum es geht, dann erfaehrt er den Grund. Umgekehrt haette er eine
   Begruendung gelesen, bevor klar war, wofuer.

   Er nennt zwei Wege bei Fragen - beide gibt es wirklich: der Chatbot steckt im Hilfe-Knopf
   unten rechts (CHAT_ENDPOINT), die Telefonnummer steht im Fuss jeder Seite. Ein Hinweis auf
   Hilfe, die es nicht gibt, waere schlimmer als keiner.

   Getrennt von SELBST_BESORGEN, weil die Werkzeug-Seite nur die LISTE uebernimmt - dort steht
   der Grund schon im Hinweis ueber der Karte. */
/* "kaufst" statt "waehlst" (Vorgabe 18.09.2026), woertlich uebernommen. Das nachgestellte
   "aus" gehoerte zu "waehlst ... aus" und steht jetzt ohne sein Verb - Clara ist darauf
   hingewiesen; geaendert wird es erst auf ihr Wort, nicht still. */
const SELBST_BESORGEN_GRUND = 'Du weißt am besten, was deine Baustelle braucht: Da diese '
  + 'Kleinteile sehr individuell sind, kaufst du sie selbst passend zu deinem Haus aus. '
  + 'Bei Fragen hilft dir unser Chatbot direkt weiter oder du rufst uns einfach an!';
/* DER VERWEIS DARUNTER IST REDAKTIONELL (Vorgabe 18.09.2026). Die Liste aendert sich mit
   dem Sortiment und steht deshalb im Code; die Zielseite gab es beim Einbau noch nicht und
   soll ohne Push nachgereicht werden koennen - Theme-Editor, Gruppe "Sortiment".

   OHNE ADRESSE KEIN SATZ. Ein Verweis, der nirgendwo hinfuehrt, ist schlimmer als keiner:
   Er verspricht eine Erklaerung, die es nicht gibt. Fehlt die Beschriftung, springt ein
   Standardtext ein - sonst staende dort ein leerer, aber anklickbarer Bereich.

   Bewusst als ganzer Satz verlinkt und nicht als "hier klicken": Was hinter dem Verweis
   steht, soll der Verweis selbst sagen. */
/* DIE LISTE ALS EINZELTEILE (18.09.2026). Gebraucht an zwei Orten - im Konfigurator als
   Pillen und auf der Werkzeug-Seite ebenso. Deshalb hier und nicht zweimal zerlegt.

   "etc." faellt weg, an beiden Stellen, an denen es vorkommt: als eigener Eintrag und als
   Anhaengsel ("Entlueftungsstopfen etc."). In einem Satz sagt es "und aehnliches"; auf einer
   Pille saehe es aus wie ein Teil, das so heisst. Dass die Liste nicht abschliessend ist,
   sagt der Satz darunter. */
function selbstBesorgenTeile(){
  return String(SELBST_BESORGEN).split(',')
    .map(t=>t.trim().replace(/\s*etc\.$/,'').trim())
    .filter(t=>t);
}
/* ALS PILLEN STATT ALS KOMMALISTE (Vorgabe 18.09.2026: "sieht vom Design her noch nicht so
   ansprechend aus"). Elf Begriffe in einem Satz sind eine Wand; einzeln gesetzt laesst sich
   jeder erfassen, und man sieht auf einen Blick, wie viele es sind.

   DIESELBEN PILLEN WIE AUF DER WERKZEUG-SEITE (.pp-tools) - dort steht dieselbe Liste. Zwei
   Orte, ein Aussehen; und es ist die Darstellung, in der auf den Produktseiten schon
   "Werkzeug dafuer" steht. */
/* DIE DREI WERKZEUG-KARTEN ALS FENSTER (03.10.2026, Vorgabe Claras: "bitte noch eine
   Verlinkung bei dem 'Selbst besorgen' im Konfigurator - hier werden die Sachen angezeigt, die
   im Reiter Bauteile stehen, das sind so drei Kaesten, die bitte auch als Pop-up anzeigen").

   DIE DATEN KOMMEN AUS DEM THEME-EDITOR, nicht aus dem Code: window.__BWP_WERKZEUG setzt die
   Section billigerwaermepumpe-werkzeug, dieselbe, die die Karten auf der Bauteile-Seite
   zeichnet. Sie wird dafuer seit heute auf jeder Seite ins Layout eingebunden - an die
   Einstellungen einer Section kommt Liquid nur dort heran, wo sie gerendert wird, und ohne das
   waere das Fenster im Konfigurator leer gewesen.

   DIE ERSTE KARTE BAUT DER KONFIGURATOR SELBST. Ihr Inhalt haengt an der Auswahl und steht
   hier in SELBST_BESORGEN; die Section liefert dafuer nur Titel und Hinweis. Die Liste von
   dort zu holen waere eine zweite Pflegestelle fuer dieselbe Angabe.

   KEINE DATEN, KEIN FENSTER: Dann bleibt der Verweis, was er war - ein Link auf die Seite.
   Das ist der Rueckfall, und er ist auch der Zustand auf jeder Seite, auf der das Layout
   nicht greift. */
function werkzeugFensterDaten(){
  const d = (typeof window!=='undefined' && window.__BWP_WERKZEUG) || null;
  if(!d || !d.karten || !d.karten.length) return null;
  return d;
}
function werkzeugKarteHtml(titel, note, pillen){
  return `<div class="lu-card">
    <div class="lu-card-head">${esc(titel||'')}</div>
    ${note?`<p class="wz-note">${esc(note)}</p>`:''}
    <ul class="pp-tools">${pillen}</ul>
  </div>`;
}
function werkzeugFensterHtml(){
  const d = werkzeugFensterDaten(); if(!d) return '';
  /* Dieselben Pillen wie im Kasten darunter - selbstBesorgenTeile() ist die eine Quelle. */
  const eigen = selbstBesorgenTeile().map(t=>`<li>${esc(t)}</li>`).join('');
  const ersteKarte = (d.selbst && eigen)
    ? werkzeugKarteHtml(d.selbst.titel, d.selbst.note, eigen)
    : '';
  const weitere = d.karten.filter(k=>k && k.teile && k.teile.length).map(k=>{
    /* Das Bild sitzt IN der Pille, klein und rund - wie auf der Werkzeug-Seite. Wer noch kein
       Foto hinterlegt hat, bekommt die Pille wie gehabt. */
    const pillen = k.teile.map(t=>
      `<li>${t.b?`<img class="wz-bild" src="${esc(t.b)}" alt="" width="48" height="48" loading="lazy">`:''}${esc(t.n||'')}</li>`
    ).join('');
    return werkzeugKarteHtml(k.titel, k.note, pillen);
  }).join('');
  if(!ersteKarte && !weitere) return '';
  return `<div class="wzfenster">
    <h3>Welche Bauteile und welches Werkzeug du selbst besorgst</h3>
    <div class="wz-grid">${ersteKarte}${weitere}</div>
  </div>`;
}
function werkzeugFensterOeffnen(){
  const html = werkzeugFensterHtml(); if(!html) return;
  const f = paketFensterBauen();
  f.setAttribute('aria-label','Werkzeug und Bauteile, die du selbst besorgst');
  const inhalt = f.querySelector('.paketfenster-inhalt');
  inhalt.innerHTML = html;
  f.hidden = false;
  document.documentElement.classList.add('paketfenster-offen');
  __paketFensterKey = null;
  inhalt.scrollTop = 0;
  const zu = f.querySelector('.paketfenster-zu'); if(zu) zu.focus();
  try{ track('werkzeug_fenster_offen',{}); }catch(e){}
}
document.addEventListener('click',e=>{
  const knopf = e.target.closest && e.target.closest('[data-wzfenster]');
  if(knopf){ e.preventDefault(); e.stopPropagation(); werkzeugFensterOeffnen(); }
});
function selbstBesorgenHtml(){
  const url=(typeof window!=='undefined' && window.BWP_SELBST_LINK) || '';
  const text=((typeof window!=='undefined' && window.BWP_SELBST_LINK_TEXT) || '').trim()
    || 'Was du genau brauchst und wofür, steht hier im Detail';
  /* DER VERWEIS IST EIN PFEIL HINTER DER UEBERSCHRIFT (03.10.2026, Vorgabe Claras: "die
     Verlinkung bei 'Was du selbst besorgen musst' bitte genauso mit dem Pfeil hinter dem Titel
     darstellen wie auch bei den Produkten").

     DERSELBE KNOPF WIE AN DEN PAKET- UND SERVICE-ZEILEN (.xr-seite mit ↗). Es ist dasselbe
     Angebot - "hier steht mehr dazu" -, also soll es auch gleich aussehen und an derselben
     Stelle stehen. Die Textzeile darunter ist dafuer entfallen: Zwei Wege zum selben Fenster
     sind einer zu viel, und der Pfeil ist der, den der Kunde im Kasten darueber schon kennt.

     ER OEFFNET EIN FENSTER, STATT DIE SEITE ZU WECHSELN. Wer mitten im Konfigurieren
     nachsieht, was er selbst besorgen muss, will danach dort weitermachen, wo er war; ein
     Seitenwechsel wirft die halbe Konfiguration aus dem Blick.

     OHNE DATEN BLEIBT DER LINK auf die Seite, und zwar als Textzeile unten wie bisher - ein
     Pfeil, hinter dem nichts aufgeht, waere schlimmer als ein Umweg. */
  const kannFenster = !!werkzeugFensterDaten();
  const titelPfeil = kannFenster
    ? `<button type="button" class="xr-seite" data-wzfenster="1"`
      + ` aria-label="${esc(text)}" title="${esc(text)} - öffnet ein Fenster">↗</button>`
    : '';
  const verweis = (!kannFenster && url)
    ? `<a class="selbst-besorgen-link" href="${esc(url)}">${esc(text)} →</a>`
    : '';
  const teile = selbstBesorgenTeile();
  const pillen = teile.map(t=>`<li>${esc(t)}</li>`).join('');
  /* AUFKLAPPBAR UND WIE DIE GRUPPEN DARUEBER (Vorgabe 21.09.2026). Dasselbe Geruest, nicht
     ein nachgebautes: details.mini.xgrp mit summary, Zahl rechts, ▾ und .xgrp-body. Ein
     eigenes Aussehen haette hier nichts erklaert - es ist derselbe Fall wie eine Gruppe,
     naemlich ein Stapel Positionen unter einer Ueberschrift -, und es waere die zweite
     Stelle, an der jemand bei der naechsten Design-Aenderung mitziehen muesste.

     DIE ZAHL RECHTS ZAEHLT TEILE, nicht Gewaehltes: Hier wird nichts angehakt, der Kasten
     sagt nur, was der Kunde selbst kauft. Zugeklappt ist "11 Teile" trotzdem die Angabe, die
     man braucht, um zu entscheiden, ob man ihn aufmacht. Sie steht fest im Markup und nicht
     in gruppenZaehlerAktualisieren(): Der Kasten liegt ausserhalb der Gruppenliste, und die
     Zahl aendert sich nur mit der Auswahl, die den Kasten ohnehin neu baut.

     Die Ueberschrift traegt .svc-group-label wie die Gruppen. Die frueher eigene .sb-kopf war
     bewusst klein und in Versalien gehalten, "um mit den Gruppenueberschriften darueber nicht
     zu konkurrieren" - seit der Kasten selbst eine davon ist, waere genau das falsch. */
  return `<details class="mini xgrp selbst-besorgen" data-g="Selbst besorgen">
    <summary><span class="svc-group-label">Selbst besorgen</span>${titelPfeil}<span class="xgrp-n m">${teile.length} Teile</span><span class="xgrp-chev" aria-hidden="true">▾</span></summary>
    <div class="xgrp-body">
      <ul class="pp-tools sb-liste">${pillen}</ul>
      <p class="sb-grund">${esc(SELBST_BESORGEN_GRUND)}</p>${verweis}
    </div>
  </details>`;
}
/* Der Kasten steht AUSSERHALB der Gruppenliste und laeuft deshalb nicht durch deren
   Schleife - ohne diese Zeilen waere er der einzige Aufklapper, der nach jeder Antwort auf
   die Heizart- oder Aufstellort-Frage wieder zufaellt. Eigene Funktion statt eines Sonderfalls
   in der Schleife: Er gehoert dort nicht hinein, sein Zustand soll aber genauso ueberleben. */
function wireSelbstBesorgen(scope){
  const wurzel = scope==='cm' ? document.getElementById('cartModalBody') : document.querySelector('.buybox');
  if(!wurzel) return;
  const det=wurzel.querySelector('details.selbst-besorgen');
  if(det) merkeGruppenZustand(det,'Selbst besorgen');
}
function renderBuyBox(cand,r){
  track("package_view",{kit:cand.kit,kw:cand.c.pausl});
  /* syncSticky() steht bewusst NICHT hier, sondern unten nach wireStepNav().
     Es liest den aktiven Schritt aus dem DOM (activeBbStep) - an dieser Stelle existiert die
     neue Kaufbox aber noch gar nicht, app.innerHTML kommt erst weiter unten. Der Aufruf las
     damit den alten Zustand, bekam null zurueck und setzte den Sticky auf "Anzahlung", obwohl
     der Kunde im Hardware-Schritt steht - also zwei konkurrierende Handlungsaufforderungen.
     (Gefunden 10.08.2026 beim Nachmessen der Schrittfuehrung.) */
  currentCand=cand;
  const kit=PRODUCTS[cand.kit], spKey=speicher(), sp=spKey?PRODUCTS[spKey]:null;
  let beleg;
  if(cand.kit!=='hybrid'){
    /* ENTSCHLACKT 11.08.2026 (Carsten, nach 90 % Abbruch auf dieser Seite): Auslegungstemperatur
       und COP am Auslegungspunkt sind hier raus. An der Stelle, wo der Kunde entscheidet, ob er
       kauft, beantworten sie keine Frage, die er gerade hat, und luden die Box mit Fachbegriffen
       auf. Was bleibt: passt das Geraet zu meinem Haus, ja oder nein. Der Heizstab-Hinweis bleibt
       im bivalenten Fall (ohne Temperaturangabe) - ohne ihn liest sich "deckt 92 %" wie ein Mangel.

       ACHTUNG, hier stand zuerst "steht weiterhin im Rechenzettel" - das ist FALSCH und wurde im
       Review widerlegt: renderLedger() fuehrt din/pww/ein/eta/qnutz/qww/qheiz/bvh/phl/res/pausl,
       aber weder COP noch Norm-Aussentemperatur. Beide Werte sind mit dieser Aenderung also
       nirgends mehr sichtbar. Das ist so gewollt (sie sind Auslegungsdetails, keine Kaufinfo) -
       wer sie zurueckholen will, muss sie in den Rechenzettel aufnehmen, nicht in diese Box. */
    /* Quellenzeile (Fox-Performance, DWD, Rechenzettel-Link) am 11.08.2026 entfernt: der Kunde
       steht hier vor der Kaufentscheidung, nicht vor einer Quellenpruefung. Der Rechenzettel
       bleibt ueber die Ergebnisseite erreichbar. */
    beleg=`<div class="beleg"><b>${esc(PERF[cand.kit].model)}</b>: ${cand.bivalent
      ? `deckt <span class="m">${Math.round(cand.coverage*100)} %</span> deiner <span class="m">${fmt(cand.c.pausl,1)} kW</span> Heizlast · die wenigen kältesten Tage ergänzt der eingebaute Heizstab`
      : `deckt deine <span class="m">${fmt(cand.c.pausl,1)} kW</span> Heizlast ✓`}</div>`;
  } else {
    beleg=`<div class="beleg">${esc(cand.note)}</div>`;
  }
  /* ENTFERNT 12.08.2026 (User): die Liste "Lieferumfang (3 Positionen)" im Hardware-Schritt.
     Sie las nur effektiverLU() und aenderte sich deshalb einzig beim Warmwasserspeicher - Material,
     Services und die Lieferwahl liefen daran vorbei. Eine Liste, die "Lieferumfang" heisst und
     Aenderungen NICHT mitmacht, ist schlimmer als keine: der Kunde haelt sie fuer vollstaendig.
     Der vollstaendige, mitlaufende Lieferumfang steht im Service-Schritt ueber dem Kaufknopf
     (siehe lieferumfangZeilen/luListeHtml). Im Direktkauf-Dialog gibt es die Kurzliste weiter
     als "Was drin ist" (#cmLuGrid) - die ist dort die einzige Uebersicht. */
  app.innerHTML=`<div class="step">
    <button class="btn quiet" id="backToCompare" style="margin-bottom:6px">← Zurück zum Vergleich</button>
    <div class="verdict">
      <div class="v-eyebrow">Dein Kit${cand.c.klima?` für ${esc(cand.c.klima.ort)}`:''}</div>
      <img src="${IMG[cand.kit]}" alt="${esc(kit.name)}">
      <h2>${esc(kit.name)}</h2>
      <div class="kwline">Auslegungsheizlast <b id="kwCount">0,0 kW</b> · ${esc(kit.sub)}<button type="button" class="kb-info" data-key="info_auslegung" aria-label="Was Auslegung, Deckung und Heizstab bedeuten">ⓘ</button></div>
    </div>
    <div class="buybox">
      <div class="bb-minisum"><span class="bb-ms-links"><button type="button" class="bb-zurueck" id="bbToHardware" hidden>← Bauteile</button><span id="bbMiniStepLabel">Schritt 1/2 · Bauteile</span></span><span class="sum" id="bbMiniSum"></span></div>
      <div class="bb-step" data-step="hardware">
        <div class="bb-stage">
          <div class="bb-stage-nr">Schritt 1 von 2 · Bauteile</div>
        </div>
        <div class="buyline"><span class="withthumb"><img class="thumb" src="${IMG[cand.kit]}" alt=""><span>${esc(kit.name)}${kit.vorlaeufig?'<span class="tag">Preis vorläufig</span>':''}</span></span><span class="price">${eur(kit.price)}</span></div>
        <!-- Was ohne Zutun schon drin ist. Stand 14.09.2026: Im Kasten soll erkennbar sein,
             dass Aussen- und Inneneinheit nicht fehlen, sondern zum Kit gehoeren - sonst sucht
             man sie in der Auswahlliste und findet sie nicht. -->
        <div class="bb-enthalten">Außeneinheit und Inneneinheit (Hydro-Box) sind im Kit enthalten.</div>
        <!-- Immer sichtbar: der Kunde muss den Speicher auch dann waehlen koennen, wenn er im
             Funnel "kein Warmwasser" gesagt hat - und ihn wieder abwaehlen koennen. -->
        <div class="buyline"><span class="withthumb"><svg class="thumb" viewBox="0 0 44 44" aria-hidden="true"><rect x="12" y="6" width="20" height="32" rx="9" fill="#fff" stroke="#33312D" stroke-width="2.5"/><rect x="17" y="14" width="10" height="2.5" rx="1.2" fill="#DDCCB2"/></svg><span><b>Warmwasserspeicher</b><span class="spchips" id="spChips"></span></span></span><span class="svc-right"><span class="price" id="spPrice"></span></span></div>
        ${selbstBesorgenHtml()}
        <div class="buyline"><span class="withthumb"><svg class="thumb" viewBox="0 0 44 44" aria-hidden="true"><path d="M8 30V16l14-8 14 8v14" fill="none" stroke="#33312D" stroke-width="2.5" stroke-linejoin="round"/><path d="M8 30h28" stroke="#33312D" stroke-width="2.5"/></svg><span><b>Lieferung</b><small class="buyline-sub">Deutschlandweit zu dir nach Hause.</small></span></span><span class="price" id="deliveryPrice"></span></div>
        <p class="lief-hinweis">${esc(LIEFER_HINWEIS)}</p>
        ${startWunschHtml('startWunsch')}
        <div class="svc-block">
          ${aufstellortChipsHtml()}
          ${heizartChipsHtml()}
          ${kreiseChipsHtml()}
          ${fbhBaujahrChipsHtml()}
          <div id="extraList"></div>
        </div>
        <div class="svc-block" id="eigenBlock">
          <details class="mini" id="eigenDetails">
            <summary>Baust du etwas zusätzlich selbst? Zählt zur Förderung</summary>
            <div class="sd-group sd-group--other">
              <div class="svc-group-label muted">Material dafür ist förderfähig, auch wenn du es nicht bei uns kaufst</div>
              <div id="eigenList"></div>
            </div>
          </details>
        </div>
        <button class="btn" id="bbToService" type="button" style="margin-top:6px">Weiter zu Services →</button>
      </div>
      <div class="bb-step hidden" data-step="service">
        
        <div class="bb-stage">
          <div class="bb-stage-nr">Schritt 2 von 2 · Services</div>
        </div>
        <div class="svc-block">
          <div class="svc-block-title">Services für deinen Einbau</div>
          <div class="sd-group sd-group--required">
            <div class="svc-group-label">Pflicht für deine Förderung</div>
            ${/* Derselbe Satz wie im Konfigurator-Dialog: Der Foerderantrag ist inklusive und
                  steht deshalb nicht mehr als anklickbare Zeile darunter. Aus SERVICE_INKLUSIVE
                  gelesen und nicht hier abgeschrieben - zwei Fassungen desselben Satzes
                  laufen auseinander. */''}
            ${Object.keys(SERVICE_INKLUSIVE).filter(k=>serviceGruppe(k)==='foerder')
                .map(k=>`<p class="svc-inklusive">${esc(SERVICE_INKLUSIVE[k])}</p>`).join('')}
            <div id="svcListRequired"></div>
          </div>
          <div class="sd-group sd-group--other">
            <div class="svc-group-label muted">Freiwillig</div>
            <div id="svcListOptional"></div>
          </div>
          <div id="foerderRiskBox" style="margin-top:10px"></div>
        </div>
        <!-- AUFSCHLUESSELUNG STATT EINER ZAHL (02.09.2026)
             Die Foerder-Pflichtservices sind vorausgewaehlt. Damit stand schon auf dem
             Hardware-Schritt eine Summe da, in der Leistungen steckten, die der Kunde noch gar
             nicht gesehen hatte - er konnte sich die Zahl nicht erklaeren und hielt sie fuer den
             Hardwarepreis. Jetzt steht darueber, woraus sie sich zusammensetzt. -->
        <div class="totalrow sub"><span>Dein Paket gesamt</span><span class="sum" id="totalSum"></span></div>${RABATT_CODES.length?`
        <!-- AUFSCHLUESSELUNG ALS AUFKLAPPER UNTER DER GESAMTSUMME (portiert 16.09.2026)
             ACHTUNG, DAS AENDERT EINEN FRUEHEREN ENTSCHEID. Am 02.09.2026 standen diese Zeilen
             ausdruecklich UEBER der Gesamtsumme, weil der Kunde sich die Zahl sonst nicht
             erklaeren konnte. Der Grund gilt weiter - fuer den HARDWARE-SCHRITT. Dort steht der
             Aufklapper deshalb OFFEN (gliederungAnzeigen), samt "Services waehlst du im
             naechsten Schritt". Zu klappt er nur in der fertigen Kaufbox, wo die Kette darunter
             die Aussage traegt: gesamt, minus Rabatt, minus Foerderung, dein Preis. Vier Zeilen
             ueber der Summe haetten diese Kette vorne abgeschnitten.
             Claras Wortlaut "Zubehoer" bleibt unangetastet. -->
        ${/* DER AUFKLAPPER "Woraus sich das zusammensetzt" IST AM 30.09.2026 ENTFALLEN
              (Vorgabe Claras: "entferne bei der Konfiguration in Services den Text und
              Aufklappbar 'woraus sich das zusammensetzt'").

              Hier standen unter der Gesamtsumme zwei Zeilen - Bauteile und Services - in einem
              zugeklappten details. Der Grund von 2026-09-02 war der Hardware-Schritt: Dort
              stand eine Summe, in der vorausgewaehlte Services steckten, die noch niemand
              gesehen hatte. Im SERVICES-Schritt gilt das nicht mehr - dort stehen die Services
              Zeile fuer Zeile darueber, jede mit ihrem Preis.

              Die Summen selbst sind nicht weg: gliederungAnzeigen() rechnet sie weiter und
              entscheidet daraus, was "Dein Paket gesamt" zeigt. Sie findet die Elemente jetzt
              nicht mehr und laesst sie aus - das ist abgesichert (el() gibt null zurueck). */''}
        <!-- RABATTCODE (portiert 16.09.2026). Steht zwischen Gesamtsumme und Foerderabzug,
             damit der Kunde die Kette in EINER Spalte liest: gesamt, minus Rabatt, minus
             Foerderung, Endpreis. Das Feld verschwindet, sobald der Code greift - die
             Abzugszeile darunter ist dann die Quittung.
             Nur gerendert, wenn ueberhaupt eine Aktion laeuft: ein Feld fuer einen Code, den
             es nicht gibt, erzeugt nur Fehlversuche. -->
        <div class="totalrow rabattfeld" id="bbRabattFeld"><span>Du hast einen Rabattcode?</span><span class="rabatt-eingabe"><input type="text" id="bbRabattCode" placeholder="XXXXX-XXXXX-XXXXX" autocomplete="off" spellcheck="false" aria-label="Rabattcode"><button type="button" class="rabatt-go" id="bbRabattGo">Einlösen</button></span></div>
        <div class="rabatt-hinweis" id="bbRabattHinweis"></div>
        <div class="totalrow abzug hidden" id="bbRabattLine"><span>Rabatt<small id="bbRabattPct"></small></span><span class="sum" id="bbRabattSum"></span></div>`:''}
        <!-- Die Abzugszeile war im Code laengst vorgesehen (foerderDeductLine in updateTotal),
             stand aber nirgends im Markup - der Kunde sah zwei Zahlen und musste den Unterschied
             selbst ausrechnen. Jetzt steht die Rechnung da: gesamt, minus Foerderung, Endpreis.
             Das Minus traegt der Betrag, nicht das Wort. -->
        <div class="totalrow abzug hidden" id="foerderDeductLine"><span>Förderung<small id="foerderDeductPct"></small></span><span class="sum" id="foerderDeductSum"></span></div>
        ${zusatzAusdehnungHtml(cand)}
        <div class="totalrow eff hidden" id="effektivRow"><span class="eff-lbl"><span id="effektivLabel">Dein Preis nach Förderung</span><small>voraussichtlich &ndash; du zahlst zuerst voll, die KfW erstattet danach</small></span><span class="sum" id="effektivSum"></span></div>
        <!-- ZAHLUNGSPLAN (03.09.2026, Betreiber-Entscheid)
             Diese Zeilen gab es bis zum 11.08.2026 schon einmal und wurden beim Entschlacken
             entfernt. Der Wert lief seitdem nur noch unsichtbar als Positions-Eigenschaft
             "Restzahlung bei Erhalt" in die Bestellung - der Kunde sah vor dem Klick nicht, was
             nach der Lieferung noch auf ihn zukommt. Bei einem zweistufigen Kauf ist das die
             wichtigste Zahl ueberhaupt; sie gehoert vor den Knopf, nicht in die Bestelldaten. -->
        <div class="totalrow zplan" id="bbHeuteRow"><span>Heute fällig<small id="bbHeuteHint"></small></span><span class="sum" id="bbHeuteSum"></span></div>
        <div class="totalrow zplan" id="bbRestRow"><span>Nach Lieferung fällig<small>Restzahlung bei Lieferung</small></span><span class="sum" id="bbRestSum"></span></div>
        <p class="fineprint" style="text-align:right;margin:4px 0 0">Alle Preise inkl. MwSt.</p>
        ${kitUnpassend(cand)?`<div class="banner warn" id="unsuitWarn"><b>Passt laut Rechner nicht zu deinem Setup:</b> ${cand.kit==='hybrid'?'Das Hybrid-Kit setzt eine Gasheizung ab Baujahr 2016 voraus, die es bei dir nicht gibt.':(CONFIG.RULES.AUSWAHL==='bivalenz'?`Der Bivalenzpunkt liegt bei ${fmt(cand.tbiv,1).replace('.',',')} °C. Die Wärmepumpe bräuchte schon bei milden Außentemperaturen dauerhaft den Heizstab - für dein Haus ist sie zu klein.`:`Die Leistung deckt weniger als ${Math.round(CONFIG.RULES.BIVALENT_MIN*100)} % deiner Heizlast, das schafft auch der Heizstab an kalten Tagen nicht mehr.`)}<label style="display:flex;gap:9px;align-items:flex-start;margin-top:10px;cursor:pointer;font-weight:600"><input type="checkbox" id="unsuitOk" style="width:18px;height:18px;accent-color:var(--warn);flex:0 0 auto;margin-top:1px">Ich habe das gelesen und will trotzdem fortfahren.</label></div>`:''}
        ${/* Weicher Hinweis daneben: er deckt die Faelle ab, die der harte Riegel NICHT
             kennt - knapp bemessen (Bivalenzpunkt zwischen -2 und 0) und ueberdimensioniert
             (unter -8). Beim harten Fall wird er unterdrueckt, sonst stuende zweimal
             dieselbe Aussage untereinander. r ist hier schon berechnet und wird
             durchgereicht, damit routeAll() nicht ein zweites Mal laeuft. */''}
        ${dimensionsHinweisHtml(cand.kit, r, kitUnpassend(cand))}
        <div id="depositNote"></div>
                <button class="btn" id="buyBtn"></button>
        <div id="demoBanner"></div>
        ${/* KONFIGURATION PER MAIL (18.08.2026)
              Der Knopf "Rechnung per E-Mail" flog am 07.08.2026 raus, weil er einen Versand
              versprach, den es nicht gab. Jetzt gibt es ihn: n8n schickt die Konfiguration
              mit Positionen, Foerderung und Kauflink an den Kunden (stage konfiguration_mail).
              Erst der Weg, dann der Knopf - genau in der Reihenfolge, die der alte Kommentar
              verlangt hat.

              BEWUSST KEIN GATE: der Preis steht darueber und bleibt sichtbar. Eine Sperre vor
              dem Preis waere ein anderer Eingriff mit anderen Folgen.

              E-Mail Pflicht, Telefon freiwillig, Beratungs-Einwilligung getrennt und nicht
              vorangehakt: die Adresse braucht es fuer den Versand selbst, die Nummer nicht -
              sie an den Versand zu koppeln waere die Kopplung, die man sich spart. */''}
        <details class="mini konfmail" id="konfMailBox">
          <summary><span class="svc-group-label">Konfiguration per E-Mail schicken</span></summary>
          <div class="konfmail-body">
            <p class="sub">Damit du in Ruhe vergleichen kannst – mit allen Positionen, der Förderung und einem Link zurück in den Warenkorb.</p>
            <div class="emailrow"><input type="email" id="kmEmail" value="${esc(A.email||'')}" placeholder="du@beispiel.de" aria-label="E-Mail für die Zusammenfassung"></div>
            <div class="emailrow" style="margin-top:8px"><input type="tel" id="kmTel" value="${esc(A.tel||'')}" placeholder="Telefon (freiwillig)" aria-label="Telefon, freiwillig"></div>
            <label class="proconsent"><input type="checkbox" id="kmOk">${esc(EINWILLIGUNG_TEXT)}</label>
            <label class="proconsent"><input type="checkbox" id="kmWerbung">${esc(WERBUNG_TEXT)}</label>
            <button class="btn quiet" id="kmGo">Schick mir meine Konfiguration →</button>
            <div id="kmDone"></div>
          </div>
        </details>
      </div>
    </div>
  </div>`;
  document.getElementById('backToCompare').onclick=()=>renderComparison(r);
  /* Der Zustand des Codes lebt in rabattAktiv, NICHT im Eingabefeld: die Kaufbox wird bei
     jeder Aenderung neu gezeichnet, ein im Feld gehaltener Code waere danach weg. */
  wireRabattFeld('bb', ()=>updateTotal(cand));
  /* Ab hier zaehlt die Uhr fuer die Chat-Blase. Nullgeprueft, weil renderBuyBox() beim
     Wiederherstellen VOR mountHelpFab() laeuft - der Fall wird unten nachgezogen. */
  if(kaufBlaseAnstossen) kaufBlaseAnstossen();
  wireStepNav('bb');
  wireAufstellortChips('bb');
  wireHeizartChips('bb');
  wireKreiseChips('bb');
  wireFbhBaujahrChips('bb');
  wireMengenFragen('bb');
  wireSelbstBesorgen('bb');
  syncSticky();   /* erst jetzt - die Kaufbox steht im DOM, activeBbStep findet den Hardware-Schritt */
  /* Opt-in: erst beim Aufklappen bauen. Danach bei jedem Oeffnen neu, damit der Plan zu einer
     zwischenzeitlich geaenderten Service-/Materialwahl passt statt einen alten Stand zu zeigen. */
  const fpDet=document.getElementById('fahrplanDetails');
  if(fpDet) fpDet.addEventListener('toggle',()=>{
    if(!fpDet.open) return;
    track('fahrplan_open',{kit:cand.kit});
    renderFahrplan(cand);
  });
  /* Versand der Konfigurations-Mail. Der Knopf bleibt gesperrt, solange gesendet wird -
     zweimal klicken schickt sonst zwei Mails. */
  const kmGo=document.getElementById('kmGo');
  if(kmGo) kmGo.onclick=async()=>{
    const mail=(document.getElementById('kmEmail').value||'').trim();
    const tel=(document.getElementById('kmTel').value||'').trim();
    const ok=document.getElementById('kmOk');
    /* Getrennte Werbe-Einwilligung, siehe WERBUNG_TEXT. Fehlt der Haken im DOM, bleibt werb
       null und die Payload traegt werbung_ok:false - kein stiller Ja-Wert. */
    const werb=document.getElementById('kmWerbung');
    const done=document.getElementById('kmDone');
    if(!istEmail(mail)){ done.innerHTML='<div class="banner warn">Bitte gib eine gültige E-Mail-Adresse an.</div>'; return; }
    A.email=mail; speichereStand();
    if(tel){ A.tel=tel; speichereStand(); }
    kmGo.disabled=true;
    done.innerHTML='<div class="banner ok">Wird geschickt …</div>';
    track('konfiguration_mail',{kit:cand.kit, beratung:!!(ok&&ok.checked)});
    const gesendet=await submitLead('konfiguration_mail',{tel:tel||null,
      beratung_ok:!!(ok&&ok.checked),
      einwilligung_text:(ok&&ok.checked)?EINWILLIGUNG_TEXT:null,
      einwilligung_ts:(ok&&ok.checked)?new Date().toISOString():null,
      werbung_ok:!!(werb&&werb.checked),
      werbung_text:(werb&&werb.checked)?WERBUNG_TEXT:null,
      werbung_ts:(werb&&werb.checked)?new Date().toISOString():null});
    kmGo.disabled=!gesendet;
    done.innerHTML = gesendet
      ? '<div class="banner ok">Unterwegs an <b>'+esc(mail)+'</b>. Schau auch im Spam nach, falls sie nicht ankommt.</div>'
      : '<div class="banner warn">Hat gerade nicht geklappt. Ruf uns an unter '+CONFIG.SUPPORT_PHONE+' oder versuch es gleich nochmal.</div>';
  };
  countUp(document.getElementById('kwCount'), cand.c.pausl||0);
  /* Speicher: explizite Wahl - Empfehlung vormarkiert, aber der Kunde klickt selbst.
     "Keiner" gehoert dazu, sonst kann er eine einmal getroffene Entscheidung nicht mehr
     zuruecknehmen. Setzt A.dhw mit, damit speicher() fuer beide Kaufwege dasselbe liefert. */
  const spChips=document.getElementById('spChips');
  if(spChips){
    const rec=speicherRec();
    [['keiner','Keiner'],['sp200','200 l'],['sp300','300 l']].forEach(([k,label])=>{
      const b=document.createElement('button'); b.type='button';
      const istGewaehlt = (k==='keiner') ? !speicher() : (speicher()===k);
      /* SPEICHERWAHL SIEHT AUS WIE EINE ANTWORT AUF EINE FRAGE (Vorgabe 21.09.2026).
         .af-chip statt .chipbtn: Die Chips der beiden Fragen im selben Kasten sind flache
         Pillen, .chipbtn ist der grosse Mono-Knopf aus dem Fragebogen. Es IST hier eine
         Frage - welchen Speicher haettest du gern -, also soll sie auch so aussehen. */
      b.className='af-chip'+(istGewaehlt?' sel':'');
      b.innerHTML=label+(rec===k&&A.dhw==='ja'?' <span class="tag gruen">Empfohlen</span>':'');
      b.onclick=()=>{
        if(k==='keiner'){ A.dhw='nein'; A.speicherChoice=null; }
        else { A.dhw='ja'; A.speicherChoice=k; }
        track("speicher_choice",{sp:k,path:'buybox'});
        spChips.querySelectorAll('.af-chip').forEach(x=>x.classList.remove('sel'));
        b.classList.add('sel');
        updateTotal(cand);
      };
      spChips.appendChild(b);
    });
  }
  /* Abholung/Lieferung: kostenlose Abholung vorbelegt, Kunde klickt sich bewusst auf Lieferung um.

     DIESELBE FORM WIE DIE SPEICHERWAHL DARUEBER (29.09.2026, Vorgabe Claras: "bei Konfigurator
     bitte unten die Lieferung, die beiden Auswahl-Buttons in dem gleichen Design machen wie
     auch oben bei dem Warmwasserspeicher").

     .af-chip statt .chipbtn - die flache Pille der Fragen im selben Kasten statt des grossen
     Mono-Knopfes aus dem Fragebogen. Der Speicher hat den Wechsel am 21.09.2026 gemacht, die
     Lieferung blieb zurueck: Zwei Fragen im selben Kasten sahen seither verschieden aus,
     obwohl sie dasselbe tun - eine von zwei bis drei Moeglichkeiten waehlen. */
  /* HIER STANDEN BIS ZUM 28.10.2026 ZWEI CHIPS (Abholung / Lieferung). Die Abholung ist auf
     Claras Vorgabe entfallen; die Lieferung wird nicht mehr gewaehlt, sondern angesagt - der
     Betrag steht rechts in der Zeile wie bei jedem anderen Posten auch. */
  startWunschVerdrahten('startWunsch');
  let justPreselected=false;
  if(buyboxPreselectedFor!==cand.kit){
    FOERDER_CRITICAL.forEach(k=>{ if(SERVICES[k] && (!SERVICES[k].only||SERVICES[k].only(A))) chosenServices.add(k); });
    /* Gefuehrter Modus: technisch notwendige Material-Positionen im selben Moment setzen,
       damit sie denselben Aufmerksamkeits-Effekt bekommen wie die Foerder-Services. */
    wendeVorauswahlAn();
    /* DIE ANTWORTEN AUS DEM FRAGEBOGEN SETZEN AUCH HIER DIE HAKEN (16.09.2026).

       Der Kunde beantwortet "Wo soll die Aussseneinheit stehen?" und "Womit wird geheizt?"
       im Rechner - und landet direkt danach in DIESER Kaufbox. Die Zuordnung Antwort ->
       Pakete lief bisher aber nur im Kasten auf der Produktseite; hier blieben dieselben
       Fragen unbeantwortet stehen, obwohl sie zwei Schritte vorher beantwortet wurden.

       Dieselben Tabellen wie dort, dieselbe Funktion. wendeVorauswahlAn() daneben bleibt: Es
       deckt andere Faelle ab (Systemtrennung bei alter Fussbodenheizung) und greift nur im
       gefuehrten Modus.

       Nur beim ersten Aufbau je Kit - dieser Zweig laeuft genau einmal. */
    autowahlAnwenden(AUTOWAHL_AUFSTELLORT, A.aufstellort);
    autowahlAnwenden(AUTOWAHL_HEIZART, heizartSchluessel());
    systemtrennungAnwenden();
    pumpenMengenAnwenden();
    buyboxPreselectedFor=cand.kit;
    justPreselected=true;
  }
  const svcListReq=document.getElementById('svcListRequired'), svcListOpt=document.getElementById('svcListOptional');
  /* Die vier Oeltank-Varianten werden zu EINER Zeile mit Auswahlfeld zusammengezogen (siehe
     OEL_KEYS). Der Merker sorgt dafuer, dass sie genau einmal entsteht - an der Stelle, an der
     sonst die erste der vier stuende, damit die Reihenfolge der Liste gleich bleibt. */
  let oelZeileGebaut=false;
  Object.entries(SERVICES).filter(([k,s])=>(!s.only||s.only(A)) && s.buyable!==false && !SERVICE_INKLUSIVE[k]).forEach(([k,s])=>{
    if(istOelKey(k)){
      if(oelZeileGebaut) return;
      oelZeileGebaut=true;
      const oelRow=document.createElement('div');
      oelRow.innerHTML=oelZeileHtml(chosenServices,'buybox',null);
      const zeile=oelRow.firstElementChild;
      oelZeileVerdrahten(zeile, chosenServices, ()=>updateTotal(cand), 'buybox');
      /* Keiner der vier steht in FOERDER_CRITICAL - die Entsorgung ist freiwillig. */
      svcListOpt.appendChild(zeile);
      return;
    }
    const rec=s.rec(A);
    const info=SERVICE_FOERDER_INFO[k];
    const isRequired=FOERDER_CRITICAL.includes(k);
    const row=document.createElement('div'); row.className='svc-row'+(justPreselected&&isRequired?' svc-preselect-flash':'');
    row.innerHTML=`<div class="buyline"><label><input type="checkbox" data-k="${k}"${chosenServices.has(k)?' checked':''}><span>${esc(s.name)}${rec?'<span class="tag gruen">Empfohlen</span>':''}</span></label><span class="svc-right"><span class="price">${zeilenPreis(s.price, chosenServices.has(k), s.preisZusatz)}</span>${svcFensterKnopfHtml(k)}</span></div>`;
    row.querySelector('input').addEventListener('change',e=>{
      if(e.target.checked){
        /* xgroup = Radio-Verhalten: z. B. nur EINE Öltank-Variante gleichzeitig */
        if(s.xgroup) Object.keys(SERVICES).forEach(o=>{
          if(o!==k && SERVICES[o].xgroup===s.xgroup && chosenServices.has(o)){
            chosenServices.delete(o);
            const other=document.querySelector(`#svcListRequired input[data-k="${o}"], #svcListOptional input[data-k="${o}"]`);
            if(other) other.checked=false;
          }
        });
        chosenServices.add(k);track("service_added",{service:k});
        updateTotal(cand);
      } else if(isRequired){
        guardedUncheck(e.target,row,s.name,info?info.warum:'',()=>{ chosenServices.delete(k); updateTotal(cand); },k);
      } else {
        chosenServices.delete(k);
        track('service_removed',{service:k,pflicht:false,path:'buybox'});
        updateTotal(cand);
      }
    });
    (isRequired?svcListReq:svcListOpt).appendChild(row);
  });
  const eigenList=document.getElementById('eigenList');
  if(eigenList && !eigenList.childElementCount){
    EIGENLEISTUNGEN.forEach(e=>{
      const row=document.createElement('div'); row.className='svc-row';
      row.innerHTML=`<div class="buyline"><span>${esc(e.name)}<span class="tag">extern gekauft</span></span><span class="svc-right"><span class="eigen-wrap"><input type="number" min="0" step="50" placeholder="0" inputmode="numeric"><span class="eigen-eur">€</span></span></span></div>`;
      row.dataset.k=e.k;
      row.querySelector('input').addEventListener('input',ev=>{
        const v=parseFloat(ev.target.value.replace(',','.'));
        eigenBetraege[e.k]=(v>0)?v:0;
        updateTotal(cand);
      });
      eigenList.appendChild(row);
    });
  }
  /* Material-Extras: gruppiert (CSV-Gruppe = Überschrift), Einzelprodukte dahinter.
     Entweder/oder-Gruppen (Hauseinführung, Pumpengruppe) über xgroup; Erdleitung mit Meter-Stepper. */
  const extraList=document.getElementById('extraList');
  if(extraList && !extraList.childElementCount){
    const groups={};
    /* paketAusgeblendet(): siehe dort - die Antwort auf Aufstellort und Heizart blendet aus,
       was sie ausschliesst. Gefiltert wird beim AUFBAU der Liste, nicht per CSS: Eine
       versteckte Zeile mit Haken wuerde weiterhin in jeder Summe mitzaehlen. */
    Object.entries(EXTRAS).forEach(([k,e])=>{
      if(paketAusgeblendet(k)) return;
      (groups[e.group]=groups[e.group]||[]).push([k,e]);
    });
    Object.entries(groups).forEach(([gname,items])=>{
      /* ALLE Material-Gruppen stehen offen (Betreiber-Vorgabe 14.08.2026: "der hydraulische
         Abgleich soll auch direkt geoeffnet sein, also nichts mit ausklappen").
         Bis dahin war genau eine Gruppe - "Hydraulischer Abgleich" - als <details> gebaut, weil
         man den EQ3-Block an dieser Stelle nicht zwingend braucht (Vorgabe 12.08.2026). Jetzt
         gilt fuer alle dasselbe: keine Umschalter, kein Akkordeon, jede Position sofort sichtbar.
         Die Zahl im Gruppenkopf ("1 gewaehlt · 599 €") bleibt und wird in updateTotal()
         nachgezogen; die Liste selbst wird nur einmal gebaut.

         NUR HIER, NICHT IM DIREKTKAUF-DIALOG: Dort ist seit dem 21.09.2026 jede Gruppe ein
         Aufklapper und startet zu (Vorgabe). Diese Kaufbox laeuft im Rechner und hat die ganze
         Seitenbreite; der Dialog ist eine schmale Spalte, in der fuenf offene Gruppen zu einer
         langen Rolle wurden. Die Regeln fuer die aufklappbare Variante (details.mini.xgrp)
         stehen in konfigurator.css und sind dort wieder in Gebrauch - ein Zurueckdrehen hier
         bleibt damit die Aenderung von zwei Zeilen. */
      const det=document.createElement('div');
      det.className='xgrp xgrp-fest';
      det.dataset.g=gname;
      const kopf=document.createElement('div');
      kopf.className='xgrp-kopf';
      kopf.innerHTML=`<span class="svc-group-label">${esc(gname)}</span><span class="xgrp-n m"></span>`;
      det.appendChild(kopf);
      const lbl=document.createElement('div'); lbl.className='xgrp-body';
      det.appendChild(lbl);
      extraList.appendChild(det);
      /* Der Hinweis steht VOR den Zeilen und haelt die Gruppe am Leben: Ohne ihn raeumt die
         Leerpruefung unten die ganze Gruppe weg, sobald bei Heizkoerpern keine Zeile uebrig
         ist - und mit ihr den Satz, der genau das erklaeren soll. */
      let hatHinweis=false;
      if(gname==='Pumpengruppen'){
        const h=pumpenHinweisHtml();
        if(h){ lbl.insertAdjacentHTML('beforeend', h); hatHinweis=true; }
      }
      /* Die Heizkoerper-Frage steht IN ihrer Gruppe, wie im Kasten der Produktseite - sie
         entscheidet die Menge der Thermostate, die zwei Zeilen darunter steht. Die anderen
         beiden Fragen liegen in diesem Kaufweg noch ueber der Liste; dorthin gehoeren sie
         historisch, und sie hier umzuhaengen waere eine eigene Aenderung. */
      if(gname==='Hydraulischer Abgleich'){
        /* ALLE Kinder, nicht nur das erste: Seit dem 21.09.2026 sind es je nach Heizart bis zu
           drei Fragen. Die alte Zeile nahm firstElementChild - bei Fussbodenheizung waere davon
           nur die Frage nach den Heizkreisen angekommen und die nach den Verteilerkaesten still
           verschwunden. */
        const huelle=document.createElement('div'); huelle.innerHTML=mengenFragenHtml(true);
        while(huelle.firstElementChild) lbl.appendChild(huelle.firstElementChild);
      }
      /* Merker: haengt an dieser Gruppe am Ende ueberhaupt eine Zeile? Die Filter unten
         (unklarer Aufstellort, Erdleitung ohne unterirdische Verlegung) koennen eine Gruppe
         komplett leerraeumen - dann stand hier bis 11.08.2026 eine Ueberschrift ohne Inhalt,
         am sichtbarsten bei "Hauseinfuehrung". Wird nach der Schleife aufgeraeumt. */
      let sichtbar=0;
      items.forEach(([k,e])=>{
        const row=document.createElement('div');
        /* Aufmerksamkeit auf JEDE vorausgewaehlte Position, nicht mehr nur aufs Fundament -
           im gefuehrten Modus stehen dort mehrere Haken, die der Kunde bemerken soll. */
        row.className='svc-row'+((justPreselected&&chosenExtras[k]&&(k==='fundament'||vorauswahlGruende[k]))?' svc-preselect-flash':'');
        row.dataset.k=k;   /* damit die Gruppen-Kopfzeile weiss, welcher Posten in dieser Zeile steckt */
        /* Aufstellort noch offen: die Hauseinfuehrung ist dann nicht entscheidbar - oberirdisch
           und unterirdisch sind verschiedene Bauteile. Statt einer Auswahl, die der Kunde raten
           muesste, steht hier die Einordnung samt Hinweis, dass er sie nachreichen kann. */
        /* Sichtbarkeit haengt jetzt an only() im Paket-Eintrag statt an fest verdrahteten
           Sonderfaellen (Umbau 14.09.2026). Inhaltlich unveraendert:
             - Hauseinfuehrung erst NACH der Frage nach dem Aufstellort, und dann nur die
               passende Bauart. Bei "Weiss ich noch nicht" keine von beiden, statt raten zu
               lassen.
             - Erdleitung faellt nur bei ausdruecklich "direkt an der Hauswand" weg; bei
               "weiss ich noch nicht" bleibt sie stehen (Betreiber-Entscheid 18.08.2026).
               Genau dann will jemand am ehesten Meter mitbestellen.
           Der Erklaerkasten dazu wurde am 11.08.2026 entfernt (Seite entschlacken). */
        if(e.only && !e.only(A)) return;
        if(e.perMeter||e.perUnit){
          /* Mengen-Stepper: Meter (Erdleitung) oder Stück je Einheit (EQ3-Komponenten) */
          const q0=chosenExtras[k]||0;
          const unitShort=e.perMeter?'m':'Stk.';
          /* Die Pille mit dem Einzelpreis ("950 € je Wanddurchführung") ist am 14.09.2026
             entfallen - Vorgabe. Rechts steht der laufende Gesamtpreis der Zeile, und der
             ist die Zahl, auf die es beim Zusammenstellen ankommt. */
          const maxQ=e.max||50;
          row.innerHTML=`<div class="buyline xrow hat-menge"><label class="xr-check"><input type="checkbox" data-x="${k}"${q0>0?' checked':''}><span class="xr-name">${esc(e.name)}</span></label><span class="xr-tag"></span><span class="xr-step"><span class="qtystep"><button type="button" data-d="-1" aria-label="Weniger">−</button><span class="qv m">${q0} ${unitShort}</span><button type="button" data-d="1" aria-label="Mehr">+</button></span></span><span class="xr-price price extra-price m">${mengenPreisHtml(q0,e)}</span>${paketInfoHtml(e)}${paketSeiteHtml(e)}</div>`;
          const qv=row.querySelector('.qv'), pr=row.querySelector('.extra-price');
          /* Der Haken links gehoert seit dem 02.09.2026 auch zu den Mengen-Zeilen: vorher hatten
             nur die Ja/Nein-Positionen einen, die Liste sprang dadurch von Zeile zu Zeile.
             Haken und Regler zeigen denselben Zustand - angehakt heisst Menge >= 1, abgehakt
             heisst 0. Er wird bei jedem set() mitgezogen, damit beide nie auseinanderlaufen. */
          const cb=row.querySelector('input[type=checkbox][data-x]');
          const set=q=>{
            q=Math.max(0,Math.min(maxQ,q));
            if(q>0){ chosenExtras[k]=q; } else delete chosenExtras[k];
            qv.textContent=q+' '+unitShort; pr.innerHTML=mengenPreisHtml(q,e);
            if(cb) cb.checked = q>0;
            mengenFrageNachziehen(k, q);
            updateTotal(cand);
          };
          /* RICHTUNG (27.08.2026): der Regler meldete bisher auch beim Verringern 'extra_added'.
             Damit war jede Auswertung von Zu- und Abwahl von vornherein unbrauchbar. */
          if(cb) cb.addEventListener('change',()=>{
            const vorher=chosenExtras[k]||0;
            set(cb.checked ? Math.max(1,vorher) : 0);
            const nachher=chosenExtras[k]||0;
            if(nachher>vorher) track('extra_added',{extra:k,qty:nachher,via:'haken'});
            else if(nachher<vorher) track('extra_removed',{extra:k,qty:nachher,ganz_weg:nachher===0,via:'haken'});
          });
          row.querySelectorAll('button[data-d]').forEach(b=>b.addEventListener('click',()=>{
            const vorher=chosenExtras[k]||0;
            set(vorher+parseInt(b.dataset.d,10));
            const nachher=chosenExtras[k]||0;
            if(nachher>vorher) track('extra_added',{extra:k,qty:nachher,path:'buybox'});
            else if(nachher<vorher) track('extra_removed',{extra:k,qty:nachher,ganz_weg:nachher===0,path:'buybox'});
          }));
        } else {
          /* checked-Zustand aus chosenExtras - die Fundament-Frage im Funnel setzt das schon vorher */
          row.innerHTML=`<div class="buyline xrow"><label class="xr-check"><input type="checkbox" data-x="${k}"${chosenExtras[k]?' checked':''}><span class="xr-name">${esc(e.name)}</span></label><span class="xr-tag"></span><span class="xr-step"></span><span class="xr-price price">${zeilenPreis(e.price, !!chosenExtras[k])}</span>${paketInfoHtml(e)}${paketSeiteHtml(e)}</div>`;
          row.querySelector('input').addEventListener('change',ev=>{
            if(ev.target.checked){
              if(xgroupSperrt(e.xgroup)) Object.entries(EXTRAS).forEach(([o,oe])=>{
                if(o!==k && oe.xgroup===e.xgroup && chosenExtras[o]){
                  delete chosenExtras[o];
                  const oi=extraList.querySelector(`input[data-x="${o}"]`); if(oi) oi.checked=false;
                }
              });
              /* Dieselbe Bewegung fuer die Tabelle SCHLIESST_AUS - Haken weg UND Zustand weg,
                 sonst bliebe eine abgehakte Zeile in der Summe stehen. */
              raeumeAusgeschlossene(k, o=>{
                const oi=extraList.querySelector(`input[data-x="${o}"]`); if(oi) oi.checked=false;
              });
              chosenExtras[k]=1; track('extra_added',{extra:k,path:'buybox'});
              if(k==='fundament') A.fundament='fertig';
              updateTotal(cand);
            } else if(k==='fundament'){
              guardedUncheck(ev.target,row,e.name,'Ohne Fertigfundament baust du das Fundament selbst (zählt als Eigenleistung).',()=>{ delete chosenExtras.fundament; A.fundament='selbst'; updateTotal(cand); },'fundament');
            } else {
              delete chosenExtras[k];
              track('extra_removed',{extra:k,qty:0,ganz_weg:true,path:'buybox'});
              updateTotal(cand);
            }
          });
        }
        lbl.appendChild(row);
        sichtbar++;
      });
      /* Leere Gruppe: ganz raus, damit keine Rubrik ohne Inhalt stehenbleibt. */
      if(!sichtbar && !hatHinweis){ det.remove(); return; }
      /* Hier stand bis 14.08.2026 "if(einklappbar) det.open = ..." - das Aufklappen einer Gruppe,
         sobald darin etwas gewaehlt war. Mit dem Wegfall der aufklappbaren Variante ist die Regel
         gegenstandslos: es gibt nichts mehr zuzuklappen, jede Position steht ohnehin offen. */
    });
  }
  updateTotal(cand);
  /* Der unsuitOk-Riegel stand frueher hier. Er liegt jetzt in checkout() selbst, damit
     der Sticky-CTA nicht daran vorbeikommt - siehe unsuitFrei(). */
  document.getElementById('buyBtn').onclick=()=>{
    checkout(cand, setBusy(document.getElementById('buyBtn'),'Checkout wird vorbereitet …'));
  };
  /* "Rechnung per E-Mail" ist am 07.08.2026 ersatzlos entfernt worden (User-Entscheid).
     Der Knopf versprach "Wir schicken dir Kit, Preis und Foerder-Schaetzung als PDF" und
     meldete danach "Unterwegs, kommt per E-Mail" - beim Kunden kam aber nie etwas an.
     submitLead('result_email') benachrichtigt ausschliesslich unser eigenes Postfach; einen
     Versand an den Kunden gibt es nirgends, das PDF existiert nicht. Damit war es dieselbe
     stille Falschmeldung, die am 30.07. schon aus dem Chat geflogen ist.
     Wenn der Weg zurueckkommen soll, braucht es ZUERST die Mail an den Kunden (Vorlage +
     Versandknoten in n8n), dann den Knopf - nicht umgekehrt. */
  /* Beim Oeffnen der Kaufbox steht der Hardware-Step vorn - also auch nur dessen Tour. Die
     Services-Tour startet wireStepNav(), sobald der Kunde selbst dorthin weiterklickt. */
  startCheckoutWalkthrough('funnel','hardware');
}
/* Explizite Risiko-Warnung im Checkout: welche der aktuell sichtbaren Förder-Pflichtservices (siehe
   FOERDER_CRITICAL) sind NICHT ausgewählt? Läuft bei jedem Checkbox-Klick neu (via updateTotal), damit
   die Warnung sofort verschwindet, sobald der Kunde den fehlenden Service dazubucht. */
/* ---------------------------------------------------------------------
   Nachfrage vor der Anzahlung (User-Entscheid 29.07.2026).
   Wer zur Zahlung geht, ohne alle foerderrelevanten Punkte geklaert zu haben, soll das
   nicht unbemerkt tun. Kein Blocker - eine bewusste Entscheidung: ergaenzen oder trotzdem
   weiter. Die Liste kommt aus derselben Quelle wie die Risiko-Box im Checkout, damit beide
   nie Unterschiedliches behaupten.
   --------------------------------------------------------------------- */
function offeneFoerderpunkte(gewaehlteServices){
  const offen=[];
  FOERDER_CRITICAL.forEach(k=>{
    if(!SERVICES[k]) return;
    if(SERVICES[k].only && !SERVICES[k].only(A)) return;
    if(gewaehlteServices.has(k)) return;
    /* vot darf durch Eigenleistung ersetzt werden - dann ist der Punkt geklaert, auch
       ohne den Service im Warenkorb. */
    if(k==='vot' && A.hlbWeg==='eigen') return;
    offen.push({key:k, name:SERVICES[k].name,
      warum:(SERVICE_FOERDER_INFO[k]||{}).warum||'',
      eigenleistung:FOERDER_EIGENLEISTUNG_MOEGLICH.includes(k)});
  });
  return offen;
}

/* Zeigt die Nachfrage. weiter() wird nur aufgerufen, wenn der Kunde ausdruecklich
   trotzdem zur Zahlung will. Ohne offene Punkte laeuft weiter() sofort durch. */
/* ============ SCROLL-SPERRE: BENANNTE MENGE STATT EINZELPLATZ (02.09.2026) ============
   Acht Stellen haben bisher document.body.style.overflow direkt gesetzt: Foerder-Gate,
   Einbring-Gate, Kauf-Dialog (zweimal), Artikel-Overlay, Lieferumfang-Popup und der
   Kassen-Schirm. Das war EIN Platz fuer sechs Nutzer - wer als Zweiter schloss, riss die
   Sperre des Ersten mit auf. Am haeufigsten ueber Escape: der Kauf-Dialog-Handler lief
   bedingungslos und gab damit die Sperre eines fremden, noch offenen Overlays frei. Man
   sah es sofort - das Overlay stand still, die Seite darunter scrollte weg.

   Jetzt merkt sich die Menge, WER sperrt. Freigegeben wird erst, wenn der Letzte geht.
   Die Menge ist absichtlich nach Namen und nicht als Zaehler gebaut: openCartModal() kann
   zweimal hintereinander laufen (Hybrid-Riegel und Normalfall setzen beide), ein Zaehler
   stuende danach auf 2 und die Sperre liesse sich nie wieder loesen. Ein Name geht nur
   einmal in die Menge.

   WICHTIG FUER DEN FULLSCREEN-UMBAU: Sobald der Kauf bildschirmfuellend wird, liegen
   Kauffaeche und Info-Overlays uebereinander statt nebeneinander. Ohne diese Menge wuerde
   jedes Schliessen eines Info-Fensters den Seitenhintergrund unter dem Kauf freigeben. */
const __scrollSperren = new Set();
function scrollSperren(wer){
  __scrollSperren.add(wer);
  document.body.style.overflow='hidden';
}
function scrollFreigeben(wer){
  __scrollSperren.delete(wer);
  if(__scrollSperren.size===0) document.body.style.overflow='';
}

function foerderGate(gewaehlteServices, weiter, ergaenzenScrollZiel){
  const offen=offeneFoerderpunkte(gewaehlteServices);
  if(!offen.length){ weiter(); return; }
  track('foerder_gate_view',{offen:offen.map(o=>o.key)});

  const alt=document.getElementById('foerderGate'); if(alt) alt.remove();
  const ov=document.createElement('div');
  ov.className='fg-overlay'; ov.id='foerderGate';
  ov.innerHTML=`<div class="fg-card" role="dialog" aria-modal="true" aria-labelledby="fgTitel">
    <div class="fg-eyebrow">Kurz bevor es weitergeht</div>
    <h3 id="fgTitel">${offen.length===1?'Ein Punkt fehlt noch für deine Förderung':'Diese Punkte fehlen noch für deine Förderung'}</h3>
    <p class="fg-sub">Ohne ${offen.length===1?'ihn':'sie'} können wir die Förderung nicht für dich absichern. Du kannst trotzdem bestellen &ndash; dann liegt der Antrag aber bei dir.</p>
    <ul class="fg-list">${offen.map(o=>`<li>
      <b>${esc(o.name)}</b>
      ${o.warum?`<span>${esc(o.warum)}</span>`:''}
      ${o.eigenleistung?'<span class="fg-hint">Diesen Punkt darfst du auch selbst erbringen &ndash; sag uns das im Checkout, dann ist er erledigt.</span>':''}
    </li>`).join('')}</ul>
    <div class="fg-nav">
      <button type="button" class="btn" id="fgFix">${offen.length===1?'Punkt ergänzen':'Punkte ergänzen'}</button>
      <button type="button" class="btn quiet" id="fgGo">Trotzdem zur Anzahlung</button>
    </div>
  </div>`;
  document.body.appendChild(ov);
  scrollSperren('foerder');

  const zu=()=>{ ov.remove(); scrollFreigeben('foerder'); document.removeEventListener('keydown',esc_); };
  const esc_=e=>{ if(e.key==='Escape'){ e.stopPropagation(); track('foerder_gate_abbruch',{}); zu(); } };
  document.addEventListener('keydown',esc_,true);
  ov.addEventListener('click',e=>{ if(e.target===ov){ track('foerder_gate_abbruch',{}); zu(); } });

  ov.querySelector('#fgFix').onclick=()=>{
    track('foerder_gate_ergaenzen',{offen:offen.map(o=>o.key)});
    zu();
    const ziel=document.getElementById(ergaenzenScrollZiel);
    if(ziel){
      if(ziel.scrollIntoView) ziel.scrollIntoView({behavior:'smooth',block:'center'});
      ziel.classList.remove('flash'); void ziel.offsetWidth; ziel.classList.add('flash');
    }
  };
  ov.querySelector('#fgGo').onclick=()=>{
    track('foerder_gate_trotzdem',{offen:offen.map(o=>o.key)});
    zu(); weiter();
  };
  ov.querySelector('#fgFix').focus();
}

/* Die raumweise Heizlastberechnung nach DIN EN 12831 ist Foerdervoraussetzung (Grundlage des
   hydraulischen Abgleichs nach Verfahren B), der SERVICE dafuer ist es nicht - sie darf selbst
   erbracht werden. Deshalb kein FOERDER_CRITICAL-Eintrag, sondern eine eigene Klaerung:
   entweder die Technische Planung ist im Warenkorb, oder der Kunde bestaetigt die Eigenleistung.
   Solange weder noch, ist das Projekt NICHT foerderfaehig und genau das muss dastehen. */
function hlbGeklaert(gewaehlteServices){
  if(gewaehlteServices && gewaehlteServices.has('vot')) return 'service';
  return A.hlbWeg === 'eigen' ? 'eigen' : null;
}
/* Baut den Heizlast-Block fuer die Risiko-Box. praefix trennt die IDs der beiden Kaufwege. */
function hlbBlockHtml(gewaehlteServices, praefix){
  const weg = hlbGeklaert(gewaehlteServices);
  if(weg === 'service') return `<div class="okline">✓ Raumweise Heizlastberechnung über die Technische Planung abgedeckt</div>`;
  if(weg === 'eigen') return `<div class="okline">✓ Raumweise Heizlastberechnung erstellst du selbst
    <button type="button" class="hlb-undo" id="${praefix}HlbUndo">ändern</button>
    <span class="hlb-nachweis">Denk daran: Maße, Baujahr, Dämmstärken und Fensterflächen darfst du selbst
    erfassen und die Berechnung selbst durchführen. Für die Förderung muss sie am Ende aber in der
    Nachweisdokumentation deines Fachbetriebs auftauchen - dort prüfen wir sie mit.</span></div>`;
  return `<div class="banner warn hlb-warn">⚠ <b>So noch nicht förderfähig:</b> Es fehlt die raumweise
    Heizlastberechnung nach DIN EN 12831. Sie ist Voraussetzung für den hydraulischen Abgleich nach
    Verfahren B und damit für die Auszahlung - im Förderantrag-Service ist sie <b>nicht</b> enthalten.
    <div class="hlb-wahl">
      <button type="button" class="chipbtn" id="${praefix}HlbBuy">Technische Planung dazubuchen · ${eur(SERVICES.vot.price)}</button>
      <button type="button" class="chipbtn" id="${praefix}HlbSelf">Erstelle ich selbst</button>
    </div>
    <div class="hlb-fussnote">Selbst rechnen ist erlaubt &ndash; die fertige Berechnung muss für die
      Förderung trotzdem in der Nachweisdokumentation des Fachbetriebs landen.</div></div>`;
}
/* Verdrahtet die Knoepfe aus hlbBlockHtml. onBuy legt den Service im jeweiligen Kaufweg ab. */
function wireHlbBlock(box, praefix, onBuy, neuZeichnen){
  const buy=box.querySelector('#'+praefix+'HlbBuy');
  if(buy) buy.onclick=()=>{ A.hlbWeg='service'; track('hlb_weg',{weg:'service'}); onBuy(); };
  const self=box.querySelector('#'+praefix+'HlbSelf');
  if(self) self.onclick=()=>{ A.hlbWeg='eigen'; track('hlb_weg',{weg:'eigen'}); neuZeichnen(); };
  const undo=box.querySelector('#'+praefix+'HlbUndo');
  if(undo) undo.onclick=()=>{ A.hlbWeg=null; neuZeichnen(); };
}
/* Bedingte Zusatzposition aus der Stueckliste: Ab dem 12-kW-Kit mit zwei Heizkreisen reicht
   das 24-Liter-Gefaess in der Hydro Box nicht mehr, dann liegt ein 50-Liter-Ausdehnungsgefaess
   samt Anschlussteilen bei. Beide Bedingungen stehen in der Konfiguration - das groesste Kit
   ist fox12, zwei Heizkreise entsprechen der Antwort "Beides" bei den Heizflaechen. */
function zusatzAusdehnungHtml(cand){
  if(!cand || cand.kit!=='fox12' || A.heating!=='mix') return '';
  return `<p class="fineprint" style="text-align:right;margin:6px 0 0">Bei deiner Kombination aus
    12-kW-Kit und zwei Heizkreisen liegt zusätzlich ein 50-Liter-Ausdehnungsgefäß mit
    Anschlussteilen bei &ndash; das 24-Liter-Gefäß in der Hydraulikstation reicht dafür nicht.
    Ohne Aufpreis.</p>`;
}
function updateFoerderRisk(){
  const box=document.getElementById('foerderRiskBox'); if(!box) return;
  const visible=FOERDER_CRITICAL.filter(k=>SERVICES[k] && (!SERVICES[k].only||SERVICES[k].only(A)));
  const missing=visible.filter(k=>!chosenServices.has(k));
  const hlb=hlbBlockHtml(chosenServices,'bb');
  const verdrahten=()=>wireHlbBlock(box,'bb',
    /* Die Services stehen in ZWEI Listen (Pflicht/Optional) - vot sitzt in der optionalen,
       aber der Selektor deckt bewusst beide ab, falls die Einordnung sich einmal aendert. */
    ()=>{ const cb=document.querySelector('#svcListRequired input[data-k="vot"], #svcListOptional input[data-k="vot"]');
          if(cb && !cb.checked){ cb.checked=true; cb.dispatchEvent(new Event('change',{bubbles:true})); }
          else { chosenServices.add('vot'); updateTotal(chosenCandidate); } },
    ()=>updateFoerderRisk());
  if(missing.length===0){
    /* Der Haken darf erst stehen, wenn AUCH die Heizlastberechnung geklaert ist - sonst
       beruhigt die Box ueber eine Luecke hinweg, die die Foerderung kostet. */
    box.innerHTML = (visible.length ? `<div class="okline">✓ Alle Förder-Pflichtservices gebucht</div>` : '') + hlb;
    verdrahten();
    return;
  }
  /* vot aussen vor lassen: fuer ihn steht der praezise Heizlast-Block darunter, der auch
     den Eigenleistungs-Weg anbietet. Beides zusammen waere widerspruechlich. */
  const names=[...new Set(missing.filter(k=>!FOERDER_EIGENLEISTUNG_MOEGLICH.includes(k)).map(k=>SERVICES[k].name))];
  if(!names.length){
    /* Es fehlt nur ein Service, den der Kunde selbst erbringen darf - dann spricht
       ausschliesslich der Heizlast-Block, ohne die harte Fachbetriebs-Warnung. */
    box.innerHTML = hlb;
    verdrahten();
    return;
  }
  box.innerHTML=`<div class="banner warn">⚠ Ohne <b>${names.map(esc).join(', ')}</b> gehst du das Risiko ein, keine Förderung zu bekommen. Diese Schritte muss laut KfW 458 ein Fachbetrieb bestätigen. Kein Fachbetrieb, keine Bestätigung, keine Auszahlung.</div>` + hlb;
  verdrahten();
}
/* updateTotal ist der gemeinsame Weg jeder Aenderung in der Kaufbox - Kit, Service, Material,
   Lieferart laufen alle hier durch. Damit ist es die einzige Stelle, an der das Merken
   haengen muss. Kurz verzoegert, damit das Halten einer Mengen-Taste nicht bei jedem
   Zwischenschritt in den Speicher schreibt. */
let __kaufSpeicherTimer=null;
function merkeKauf(){ clearTimeout(__kaufSpeicherTimer); __kaufSpeicherTimer=setTimeout(speichereStand,250); }
/* ============ AUFSCHLUESSELUNG: HARDWARE GEGEN SERVICES (02.09.2026) ============
   Die Foerder-Pflichtservices werden vorausgewaehlt (FOERDER_CRITICAL). Fachlich richtig - ohne
   sie gibt es keine Foerderung -, fuer den Kunden aber undurchschaubar: auf dem Hardware-Schritt
   stand eine Summe, in der Leistungen steckten, die er noch nicht zu Gesicht bekommen hatte. Die
   naheliegende Deutung war "so teuer ist also die Hardware".

   Zwei Aenderungen, beide nur ANZEIGE - die Rechengroesse "sum" und damit die Foerderbasis, die
   Amortisation und der Effektivpreis bleiben unberuehrt:
     1. Ueber der Gesamtsumme steht jetzt, woraus sie besteht: Hardware & Material, Services.
     2. Solange der Hardware-Schritt offen ist, zeigt "Dein Paket gesamt" NUR die Hardware; die
        Services-Zeile sagt, dass sie im naechsten Schritt kommen. Erst dort erscheint die volle
        Summe - und weil die Gliederung daneben steht, ist der Sprung erklaert statt raetselhaft.

   Foerder-Abzug und Effektivpreis bleiben im Hardware-Schritt ausgeblendet. Sie haengen an den
   Pflichtservices; sie neben einer reinen Hardwaresumme zu zeigen waere eine Rechnung, die mit
   den Zahlen darueber nicht aufgeht. */
/* ZAHLUNGSPLAN: was heute abgebucht wird und was spaeter faellig ist (03.09.2026).
   Rechnet auf DERSELBEN Summe, die daneben steht - im Hardware-Schritt also auf der Hardware,
   im Services-Schritt auf der vollen. Zwei Grundlagen auf einem Bildschirm waeren genau die
   Verwirrung, die wir gerade abgestellt haben.

   Variante B (kostenfreie Vorbestellung) beantwortet die Frage "0 EUR - und was zahle ich dann?"
   ausdruecklich: heute nichts, faellig wird der volle Betrag nach der Lieferung. Ohne diesen
   Satz liest sich eine 0 wie ein Geschenk.

   Im Modus "full" gibt es keine Zweistufigkeit - dort bleiben beide Zeilen aus. */
/* RABATTZEILE UND EINGABEFELD (15.09.2026). Ein Renderer fuer beide Kaufwege - die Oberflaeche
   ist doppelt, die Aussage darf es nicht sein.
   betrag > 0  -> Abzugszeile sichtbar, Eingabefeld weg
   betrag == 0 -> Eingabefeld sichtbar, solange ueberhaupt eine Aktion laeuft
   Ohne RABATT (Schalter aus oder Frist abgelaufen) bleibt beides weg, auch die Eingabe:
   ein Feld fuer einen Code, den es nicht mehr gibt, erzeugt nur Fehlversuche.
   Seit dem 28.09.2026 zwei Codes: das Feld steht, solange einer davon laeuft. nurHw (Hardware-
   Schritt) braucht nur der Hinweis zum Mindestwert des festen Betrags. */
function rabattZeileAnzeigen(prefix, betrag, nurHw){
  const p = prefix==='cm' ? 'cm' : 'bb';
  const el=id=>document.getElementById(id);
  const feld=el(p+'RabattFeld'), zeile=el(p+'RabattLine');
  const pct=el(p+'RabattPct'), sum=el(p+'RabattSum');
  const hinweis=el(p+'RabattHinweis');
  const aktion = RABATT_CODES.some(codeFristOffen);
  /* FESTER BETRAG UNTER DEM MINDESTWERT (28.09.2026): eingeloest, zieht aber noch nichts ab. */
  const rabattJetzt = rabattWirksam();
  const koopWartet = !!(rabattJetzt && rabattJetzt.art==='fest' && !(betrag>0));
  if(zeile){
    if(betrag>0){
      zeile.classList.remove('hidden');
      if(sum) sum.textContent='– '+eur(betrag);
      /* BEZUG DAZU (16.09.2026). Die Theme-Einstellung "bezug" ("auf die Schlussrechnung")
         wurde seit dem 15.09. eingelesen und nirgends angezeigt - ein toter Schalter. Sie
         gehoert genau hierhin: neben den Abzug, wo der Kunde sonst annimmt, die 10 % gingen
         von der Reservierung ab. Faellt sie leer aus, steht wie bisher nur der Prozentsatz. */
      if(pct) pct.textContent=rabattText();
    } else zeile.classList.add('hidden');
  }
  /* Auch wer unter dem Mindestwert liegt, sieht kein Feld: der Code ist ja eingeloest, ein
     zweites Eintippen aendert nichts. */
  if(feld) feld.classList.toggle('hidden', betrag>0 || koopWartet || !aktion);
  /* HINWEIS STATT STILLE (28.09.2026). Ohne ihn verschwaende beim Einloesen unter 8.000 EUR nur
     das Feld, und der Kunde hielte den Code fuer abgelehnt - derselbe Fall wie bei der Quittung
     unten. BEWUSST OHNE GERECHNETEN BETRAG ("dir fehlen noch ..."): im Kasten der Produktseite
     stehen seit dem 14.09.2026 keine Summen, die von der Schublade abweichen koennten.
     Geleert wird nur dieser eigene Hinweis, erkennbar am Merker im Markup - nie eine
     Fehlermeldung aus wireRabattFeld(). */
  if(hinweis){
    if(koopWartet){
      hinweis.innerHTML='<div class="banner" data-rabatt-mindest="1">Dein Code <b>'+esc(rabattJetzt.code)+
        '</b> ist gespeichert. Er gilt ab einem Warenkorb von '+eur(rabattJetzt.mindest)+' (ohne Lieferung).'+
        (nurHw ? ' Die Services im nächsten Schritt zählen mit.' : '')+'</div>';
    } else if(String(hinweis.innerHTML||'').indexOf('data-rabatt-mindest')>=0){
      hinweis.innerHTML='';
    }
  }
  /* QUITTUNG IM KASTEN DER PRODUKTSEITE (17.09.2026, Betreiber-Entscheid).
     Dort blendet die Vorgabe vom 14.09.2026 jede .totalrow aus - auch die Abzugszeile, die
     eine Zeile weiter oben gerade sichtbar gemacht wurde. Ohne diesen Zusatz verschwindet
     beim Einloesen nur das Eingabefeld, und sonst passiert sichtbar nichts: Der Kunde haelt
     seinen Code fuer abgelehnt und tippt ihn ein zweites Mal.

     BEWUSST OHNE EURO-BETRAG. Die Vorgabe vom 14.09. gibt es, weil zwei Rechnungen
     nebeneinander zum Vergleichen einladen und nicht deckungsgleich waren. Eine Zeile ohne
     Zahl kann von der Schublade nicht abweichen - dafuer sagt sie, WO der Abzug steht.
     .rabatt-hinweis ist keine .totalrow und damit von der Regel nicht betroffen.

     Nur schreiben, nie leeren: dasselbe Element traegt die Fehlermeldungen aus
     wireRabattFeld(). Ein Leeren an dieser Stelle wischte die Meldung "Diesen Code kennen
     wir nicht" beim naechsten Haken im Formular weg, waehrend der Kunde sie noch liest.
     Beim festen Betrag steht statt "10 %" der Code (rabattText) - ebenfalls ohne Euro-Betrag. */
  if(p==='cm' && betrag>0 && document.querySelector('#cartModal.kauf-inline')){
    if(hinweis) hinweis.innerHTML='<div class="banner ok">Rabattcode aktiv &ndash; '+
      esc(rabattText())+'. Der Abzug steht in deinem Warenkorb.</div>';
  }
  /* Auch die Zeile ueber dem Kasten nachziehen - sonst erschiene sie nach einer Einloesung
     im Services-Schritt erst beim naechsten Neuaufbau. */
  if(p==='cm') rabattKopfZeigen();
}
/* RABATT-QUITTUNG OBEN IM KASTEN DER PRODUKTSEITE (24.09.2026).
   Wer aus der Rabatt-Mail auf seinem Kit landet, soll SOFORT sehen, dass sein Code greift. Der
   Kasten beginnt aber im Zubehoer-Schritt, das Codefeld und seine Quittung (.rabatt-hinweis)
   stehen erst im Services-Schritt, und die Schublade mit der Rechnung ist zu.

   Die Schublade oeffnet sich bewusst NICHT von selbst - das automatische Aufziehen ist seit dem
   15.09.2026 ausdruecklich entfernt, und dieser Fall aendert daran nichts. Stattdessen eine
   Zeile ueber dem Kasten, die sagt, dass der Rabatt aktiv ist und wo die Rechnung steht, mit
   einem Knopf dorthin.

   OHNE EURO-BETRAG, aus demselben Grund wie die Quittung im Services-Schritt: im Kasten stehen
   seit dem 14.09.2026 keine Summen, die von der Schublade abweichen koennten.

   Die Zeile steht AUSSERHALB von #cartModalBody - dessen Inhalt wird bei jedem Tabwechsel neu
   gebaut. Einmal angelegt, wird sie danach nur noch ein- oder ausgeblendet. */
function rabattKopfZeigen(){
  const kasten=document.querySelector('#cartModal.kauf-inline');
  const koerper=document.getElementById('cartModalBody');
  if(!kasten || !koerper) return;
  let el=document.getElementById('cmRabattKopf');
  const rabattJetzt = rabattWirksam();
  if(!rabattJetzt){ if(el) el.hidden=true; return; }
  if(!el){
    koerper.insertAdjacentHTML('beforebegin','<div class="rabatt-kopf" id="cmRabattKopf" role="status"></div>');
    el=document.getElementById('cmRabattKopf');
    if(!el) return;
  }
  el.hidden=false;
  /* FESTER BETRAG: HIER MIT SEINER BEDINGUNG (28.09.2026). DAS WEICHT VOM "OHNE EURO-BETRAG"
     OBEN AB, und zwar nur an dieser Stelle: "1.300 EUR ab 8.000 EUR" ist die Bedingung des
     Codes, keine gerechnete Summe - sie kann von der Schublade so wenig abweichen wie "10 %".
     Ohne sie laese ein Kunde unter dem Mindestwert "Dein Rabattcode ist aktiv" und faende in der
     Schublade keinen Abzug. Eine gerechnete Zahl steht hier weiterhin nicht. */
  const was = rabattJetzt.art==='fest'
    ? esc(rabattJetzt.name||rabattJetzt.code)+': '+eur(rabattJetzt.betrag)
      +(rabattJetzt.mindest>0 ? ' ab '+eur(rabattJetzt.mindest)+' Warenkorb' : '')
      +(rabattJetzt.bezug ? ' · '+esc(rabattJetzt.bezug) : '')
    : esc(rabattText());
  el.innerHTML='<span><b>Dein Rabattcode ist aktiv</b> – '+was
    +'. Die Rechnung steht in deinem Warenkorb.</span>'
    +'<button type="button" class="rabatt-kopf-knopf" id="cmRabattKopfKnopf">Warenkorb ansehen</button>';
  const k=document.getElementById('cmRabattKopfKnopf');
  if(k) k.onclick=()=>{
    track('rabatt_kopf_warenkorb',{kit:directCand||null});
    if(typeof bwpKorbToggle==='function') bwpKorbToggle(true);
  };
}
/* Gesamtpreis durchstreichen, sobald IRGENDETWAS abgezogen wird - Rabatt, Foerderung oder
   beides. Vorher hing das allein an der Foerderung; mit einem zweiten Abzug waere die Zahl
   sonst ungestrichen stehen geblieben, obwohl sie nicht mehr gilt. */
function gestrichenSetzen(id, an){
  const el=document.getElementById(id);
  if(el) el.classList.toggle('gestrichen', !!an);
}
/* VERDRAHTUNG DES CODE-FELDS (15.09.2026). Eine Fassung fuer beide Kaufwege; der Aufrufer gibt
   mit, wie neu gerechnet wird - in der Kaufbox braucht updateTotal() den Kandidaten, im Dialog
   braucht cmUpdateTotal() den Kit-Schluessel, und diese Funktion kennt weder das eine noch das
   andere.

   ZUSTAND LEBT IN rabattAktiv, NICHT IM FELD. Der Dialog wird bei jedem Tabwechsel neu
   gezeichnet (renderCartModalChoice -> renderCartModalIncluded); ein im Eingabefeld gehaltener
   Code waere danach weg. rabattAktiv ist eine Modulvariable und ueberlebt das - wie
   directServices und warOffen, gleiches Muster, gleicher Grund.

   VORAUSGEFUELLT, WER SICH ANGEMELDET HAT: rbStand() traegt den Code aus dem Balken. Eingeloest
   wird trotzdem erst auf Klick - das Feld soll zeigen, dass hier etwas passiert, nicht heimlich
   rechnen. Wer schon eingeloest hat, sieht das Feld ohnehin nicht mehr (rabattZeileAnzeigen). */
function wireRabattFeld(prefix, neuRechnen){
  const p = prefix==='cm' ? 'cm' : 'bb';
  const feld=document.getElementById(p+'RabattCode');
  const knopf=document.getElementById(p+'RabattGo');
  const hinweis=document.getElementById(p+'RabattHinweis');
  if(!feld || !knopf) return;   /* RABATT aus - das Markup existiert dann gar nicht */

  const sagen=(art,text)=>{ if(hinweis) hinweis.innerHTML = text ? '<div class="banner '+art+'">'+text+'</div>' : ''; };

  /* Vorausgefuellt wird nur noch, was der Kunde selbst schon einmal eingeloest hat. Der Code
     aus der Anmeldung liegt seit dem 15.09.2026 bewusst NICHT mehr im Speicher - er kommt per
     Mail, nach dem Bestaetigungsklick. */
  const merker=rbStand();
  if(merker && merker.eingeloest && merker.code && !feld.value) feld.value=merker.code;

  const einloesen=()=>{
    const eingabe=(feld.value||'').trim();
    if(!eingabe){ sagen('warn','Bitte gib deinen Code ein.'); return; }
    /* Frist zuerst: ein abgelaufener Code ist etwas anderes als ein falscher, und der Kunde
       soll nicht nach einem Tippfehler suchen, den er nicht gemacht hat.
       Seit dem 28.09.2026 je Code - das Feld steht auch dann, wenn nur einer von zweien laeuft. */
    const codeTreffer=codeFinden(eingabe);
    if(codeTreffer && !codeFristOffen(codeTreffer)){ sagen('warn','Diese Aktion ist abgelaufen.'); return; }
    if(!rabattEinloesen(eingabe)){
      track('rabatt_code_falsch',{pfad:p});
      sagen('warn','Diesen Code kennen wir nicht. Schau nochmal in die E-Mail &ndash; Bindestriche gehören dazu.');
      return;
    }
    track('rabatt_code_ok',{pfad:p, prozent:rabattProzent(), code:rabattCode()});
    /* In den gespeicherten Stand, damit der Rabatt einen Seitenwechsel ueberlebt - und in den
       localStorage-Merker des Balkens, damit das andere Kauffenster ihn vorausgefuellt sieht. */
    speichereStand();
    const st=rbStand()||{}; st.code=rabattCode(); st.eingeloest=true; rbSpeichern(st);
    sagen('', '');
    if(typeof neuRechnen==='function') neuRechnen();
    korbStand();
  };

  knopf.onclick=einloesen;
  /* Enter im Feld loest ebenfalls aus. Ohne das tippt der Kunde den Code, drueckt Enter, nichts
     passiert - und er haelt den Code fuer ungueltig. */
  feld.onkeydown=ev=>{ if(ev.key==='Enter'){ ev.preventDefault(); einloesen(); } };
}
function zahlungsplanAnzeigen(prefix, angezeigteSumme){
  const p = prefix==='cm' ? 'cm' : 'bb';
  const el=id=>document.getElementById(id);
  const heuteRow=el(p+'HeuteRow'), heuteSum=el(p+'HeuteSum'), heuteHint=el(p+'HeuteHint');
  const restRow=el(p+'RestRow'), restSum=el(p+'RestSum');
  if(CONFIG.MODE!=='deposit'){
    if(heuteRow) heuteRow.classList.add('hidden');
    if(restRow) restRow.classList.add('hidden');
    return;
  }
  const heute = PRODUCTS.deposit ? PRODUCTS.deposit.price : 0;
  const rest = Math.max(0, angezeigteSumme - heute);
  if(heuteRow&&heuteSum){
    heuteRow.classList.remove('hidden');
    heuteSum.textContent = eur(heute);
    if(heuteHint) heuteHint.textContent = heute>0
      ? 'Reservierung – wird voll angerechnet'
      : 'Es wird heute nichts abgebucht';
  }
  if(restRow&&restSum){ restRow.classList.remove('hidden'); restSum.textContent=eur(rest); }
}
/* Wer den Aufklapper selbst angefasst hat, behaelt seinen Zustand (portiert 16.09.2026). Ohne
   diesen Merker zoege gliederungAnzeigen() ihn bei jedem Neuzeichnen wieder auf den
   Schrittzustand zurueck - der Kasten schnappte dem Kunden unter der Hand zu, waehrend er
   hineinschaut. Modulvariable und kein DOM-Zustand: der Dialog wird bei jedem Tabwechsel
   komplett neu gezeichnet. Gleiches Muster wie warOffen und directServices. */
const gliederungBeruehrt={bb:false,cm:false};
function gliederungAnzeigen(prefix, hardware, services, lieferung){
  const p = prefix==='cm' ? 'cm' : 'bb';
  const el=id=>document.getElementById(id);
  const nurHw = activeBbStep(prefix)==='hardware';
  /* OFFEN im Hardware-Schritt, ZU in der fertigen Kaufbox - Begruendung am Markup. Im
     Hardware-Schritt traegt die Services-Zeile "waehlst du im naechsten Schritt"; genau dieser
     Hinweis war der Anlass fuer die Aufschluesselung und darf nicht hinter einem zugeklappten
     Kasten verschwinden. */
  const box=el(p+'Gliederung');
  if(box){
    if(!gliederungBeruehrt[p]) box.open=nurHw;
    if(!box.dataset.verdrahtet){
      box.dataset.verdrahtet='1';
      const kopf=box.querySelector('summary');
      /* Auf den Klick hoeren, nicht auf 'toggle': toggle feuert auch, wenn wir selbst
         umschalten - der Merker stuende dann sofort auf true und die Automatik waere tot. */
      if(kopf) kopf.addEventListener('click',()=>{ gliederungBeruehrt[p]=true; });
    }
  }
  const hwRow=el(p+'HwSumRow'), hwSum=el(p+'HwSum');
  const svRow=el(p+'SvcSumRow'), svSum=el(p+'SvcSum'), svHint=el(p+'SvcSumHint');
  if(hwRow&&hwSum){ hwRow.classList.remove('hidden'); hwSum.textContent=eur(hardware+lieferung); }
  if(svRow&&svSum){
    svRow.classList.remove('hidden');
    if(nurHw){
      svSum.textContent='–';
      if(svHint) svHint.textContent='wählst du im nächsten Schritt';
    } else {
      svSum.textContent = services>0 ? ('+ '+eur(services)) : 'keine gewählt';
      if(svHint) svHint.textContent='';
    }
  }
  return nurHw;
}
/* Hardware-Anteil: Kit, Speicher und Material - alles ausser Services und Logistik. */
function hardwareSumme(kitKey, spKey){
  return PRODUCTS[kitKey].price + (spKey?PRODUCTS[spKey].price:0) + extrasSumme();
}
function serviceSumme(svcSet){
  let n=0; svcSet.forEach(k=>{ if(SERVICES[k]) n+=SERVICES[k].price; }); return n;
}
function updateTotal(cand){
  /* Die Zahl am Warenkorb oben rechts zieht mit jeder Aenderung mit. Hier und nicht in den
     einzelnen Handlern: updateTotal laeuft ohnehin bei jeder Auswahl, und eine Stelle kann
     nicht vergessen werden. Die Funktion prueft selbst, ob es den Knopf ueberhaupt gibt. */
  try{ bwpKorbZahl(); }catch(e){}
  merkeKauf();
  let sum=PRODUCTS[cand.kit].price;
  const spKey=speicher(); if(spKey) sum+=PRODUCTS[spKey].price;
  chosenServices.forEach(k=>sum+=SERVICES[k].price);
  sum+=extrasSumme();
  /* Lieferung/Abholung fließt NUR in die angezeigte/gebuchte Summe (grandTotal), NICHT in "sum" -
     "sum" bleibt die Förderbasis weiter unten unangetastet (Logistik ist nicht foerderfähig). */
  /* Der Rabatt greift auf der Summe VOR der Liefergebuehr - Logistik wird nicht rabattiert,
     dieselbe Grenze wie bei der Foerderbasis (portiert 16.09.2026). */
  const rabBetrag=rabattBetrag(sum);
  const grandTotal=sum-rabBetrag+deliveryFee();
  /* Fertigfundament gekauft → Eigenleistungs-Zeile "Fundament" ausblenden (zählt nicht mehr) */
  const fundRow=document.querySelector('#eigenList .svc-row[data-k="fundament"]');
  if(fundRow) fundRow.classList.toggle('hidden', !!chosenExtras.fundament);
  updateFoerderRisk();
  syncZeilenPreise();
  /* Amortisation an die tatsaechliche Konfiguration koppeln: die Zeile stand bisher fest auf
     Kit + Speicher, obwohl direkt darunter eine Gesamtsumme mit Services, Extras, Eigenleistung
     und Lieferung steht. Die Foerderbasis ist "sum" ohne Logistik - dieselbe Trennung wie oben. */
  const amortBox=document.getElementById('bbAmortBox');
  if(amortBox){
    const basisKit=PRODUCTS[cand.kit].price + (spKey?PRODUCTS[spKey].price:0);
    const zusatzFoerderfaehig=Math.max(0, sum - basisKit) + eigenleistungSumme();
    amortBox.innerHTML=amortLineHtml(cand, zusatzFoerderfaehig, deliveryFee());
  }
  /* Gliederung setzen und daraus entscheiden, was "Dein Paket gesamt" zeigt. */
  const __nurHw = gliederungAnzeigen('bb', hardwareSumme(cand.kit, spKey), serviceSumme(chosenServices), deliveryFee());
  /* BRUTTO OBEN, ABZUG ALS EIGENE ZEILE (portiert 16.09.2026). Stuende oben schon der
     rabattierte Wert, waere der Abzug zweimal drin: einmal verrechnet, einmal als Zeile.
     __basis folgt dem Schritt wie Claras Ausdruck zuvor; bei rabBetrag 0 rechnet das identisch. */
  const __basis = __nurHw ? hardwareSumme(cand.kit, spKey) : sum;
  const __rab   = rabattBetrag(__basis);
  document.getElementById('totalSum').textContent = eur(__basis + deliveryFee());
  rabattZeileAnzeigen('bb', __rab, __nurHw);
  zahlungsplanAnzeigen('bb', __basis - __rab + deliveryFee());
  /* bbMiniSum wird weiter unten gesetzt, sobald der Foerderbetrag berechnet ist - die Leiste zeigt
     seit 11.08.2026 den Preis nach Foerderung, nicht mehr die Bruttosumme. */
  const spPrice=document.getElementById('spPrice');
  if(spPrice) spPrice.textContent = spKey ? eur(PRODUCTS[spKey].price) : 'nicht dabei';
  const spInfo=document.getElementById('spInfo');
  /* Der Info-Knopf bleibt IMMER sichtbar (User-Vorgabe 30.07.2026). Ohne Auswahl zeigt er den
     200-Liter-Speicher - das ist die empfohlene Groesse und der haeufigste Fall. Vorher war der
     Knopf ausgeblendet, solange nichts gewaehlt war: wer wissen wollte, was ueberhaupt drin ist,
     musste erst blind einen Speicher auswaehlen. */
  if(spInfo){
    const ziel = (spKey && hasComponents(spKey)) ? spKey : (hasComponents('sp200') ? 'sp200' : null);
    spInfo.hidden = !ziel;
    if(ziel) spInfo.dataset.key = ziel;
  }
  const deliveryPrice=document.getElementById('deliveryPrice'); if(deliveryPrice) deliveryPrice.textContent='+ '+lieferPreisText();
  const eigenSum=eigenleistungSumme();
  const eigenRow=document.getElementById('eigenSumRow'), eigenSumEl=document.getElementById('eigenSum');
  const giRow=document.getElementById('gesamtInvestRow'), giSum=document.getElementById('gesamtInvestSum');
  if(eigenRow&&giRow){
    if(eigenSum>0){
      eigenRow.classList.remove('hidden'); eigenSumEl.textContent="+ "+eur(eigenSum);
      giRow.classList.remove('hidden'); giSum.textContent=eur(grandTotal+eigenSum);
    } else { eigenRow.classList.add('hidden'); giRow.classList.add('hidden'); }
  }
  /* Förder-Schätzung (KfW 458) - nur Anzeige, kein Versprechen. Disclaimer hart formuliert (Punkt 2).
     Seit der Kürzung vom 08.07.2026 (in Kraft 21.07.2026) nur noch EIN Regime, siehe foerderQuote().
     Eigenleistungs-Material (eigenBetraege) erhöht die förderfähige Kostenbasis, auch wenn es nicht in
     "sum"/Gesamt steckt - das macht die Botschaft "selbst bauen, trotzdem volle Förderung" konkret,
     statt sie nur zu behaupten.
     CEO-Feedback (Jan, 08.07.): Förderung muss als Abzug direkt unter "Gesamt" sichtbar sein, nicht nur im Banner
     weiter unten - deshalb foerderDeductLine/effektivRow zusätzlich zum bestehenden foerderBox-Detailbanner. */
  const fb=document.getElementById('foerderBox'), q=foerderQuote();
  const fdLine=document.getElementById('foerderDeductLine'), fdSum=document.getElementById('foerderDeductSum');
  const effRow=document.getElementById('effektivRow'), effLabel=document.getElementById('effektivLabel'), effSum=document.getElementById('effektivSum');
  /* UMGEBAUT 11.08.2026: Der ganze Block hing vorher an "if(fb)" - der Foerder-Infobox. Die ist
     beim Entschlacken der Services-Seite entfallen, damit waere der Effektivpreis nie mehr
     gefuellt worden. Jetzt haengt die Rechnung an nichts mehr im DOM: erst rechnen, dann jedes
     Element einzeln bedienen, falls es existiert. So ueberlebt die Logik auch das naechste
     Aufraeumen der Oberflaeche.
     effektivPreis wird weiter unten fuer die Mini-Leiste gebraucht. */
  let effektivPreis=null;
  if(q){
    /* FOERDERBASIS FOLGT DER ANGEZEIGTEN SUMME (03.09.2026)
       Der Preis nach Foerderung steht jetzt auch im Hardware-Schritt - er ist das staerkste
       Argument der Seite und darf dort nicht fehlen. Damit die drei Zahlen untereinander aber
       aufgehen, rechnet er im Hardware-Schritt auf der HARDWARE-Summe, nicht auf der vollen:
       gesamt, minus Foerderung, Endpreis - alle auf derselben Grundlage.
       Im Services-Schritt waechst die Basis um die Services, und mit ihr Abzug und Endpreis.
       Der Kunde sieht den Foerderbetrag also steigen, wenn er Services dazunimmt - das ist die
       Wahrheit und zugleich das Argument fuer die Pflichtservices.
       Die Eigenleistung bleibt in beiden Schritten drin: sie haengt nicht an den Services und
       hat ihre eigene Zeile darueber. Logistik bleibt wie bisher draussen (nicht foerderfaehig). */
    const foerderSumme = __nurHw ? hardwareSumme(cand.kit, spKey) : sum;
    /* DIE FOERDERBASIS SINKT MIT (portiert 16.09.2026). Sonst zeigte die Seite eine Foerderung
       auf Kosten, die der Kunde nie hatte - und bei kleinem Warenkorb laege "Preis nach
       Foerderung" UEBER dem rabattierten Gesamtpreis. */
    const foerderNetto = foerderSumme - rabattBetrag(foerderSumme);
    const basis=foerderNetto+eigenSum, kosten=Math.min(basis,foerderKostenCap()), betrag=Math.round(kosten*q/100/10)*10;
    /* KORREKTUR 11.08.2026: Der Effektivpreis rechnete auf "basis" (= sum + Eigenleistung, OHNE
       Logistik) und unterschlug damit die Liefergebuehr, die in "Gesamt" schon drinsteht. Bei
       gewaehlter Lieferung stand hier 239,99 EUR zu wenig - ausgerechnet in der wichtigsten Zeile
       der Seite. Die FOERDERBASIS bleibt "basis" (Logistik ist nicht foerderfaehig), der
       ANGEZEIGTE Endpreis enthaelt alles, was der Kunde tatsaechlich zahlt. */
    effektivPreis=Math.max(basis+deliveryFee()-betrag,0);
    if(fdLine&&fdSum){
      fdLine.classList.remove('hidden'); fdSum.textContent="– "+eur(betrag);
      const pct=document.getElementById('foerderDeductPct'); if(pct) pct.textContent=q+" % KfW 458";
    }
    /* Gesamtpreis durchstreichen, sobald wirklich etwas abgezogen wird - nicht als Deko, sondern
       als Vorzeichen: die Zahl darueber gilt nicht mehr, die darunter schon. */
    const tSumAn=document.getElementById('totalSum'); if(tSumAn) tSumAn.classList.add('gestrichen');
    if(effRow&&effSum){
      effRow.classList.remove('hidden'); effSum.textContent=eur(effektivPreis);
      /* CLARAS DREI FASSUNGEN BLEIBEN (Vorgabe 14.09.2026) - sie sagen, WORAUF sich der Preis
         bezieht. Der Rabatt ist eine andere Frage und kommt als vierte Dimension dazu. */
      if(effLabel){
        const __nachWas = __rab>0 ? "nach Rabatt und Förderung" : "nach Förderung";
        effLabel.textContent = __nurHw
          ? "Dein Preis "+__nachWas+" (Bauteile)"
          : (eigenSum>0 ? "Dein Preis "+__nachWas+" (Gesamtprojekt)" : "Dein Preis "+__nachWas);
      }
    }
    if(fb){
      fb.classList.remove('hidden');
      const kurz=fb.querySelector('#foerderShortLabel');
      if(kurz) kurz.innerHTML=`Auch im Selbsteinbau die volle Förderung: bis zu <b>${q} % ≈ ${eur(betrag)}</b>`;
      const body=fb.querySelector('#foerderInfoBody');
      if(body) body.innerHTML=`<b>Zur Auszahlung:</b> Sobald die Bestätigung nach Durchführung (BnD) im KfW-Portal eingegangen ist, geht es in der Regel zügig - die Auszahlung folgt kurz darauf auf dein Konto. Den Antrag selbst musst du aber <b>vor</b> Baubeginn gestellt haben.<br><br>Lass die Abnahme (Anlagencheck &amp; Inbetriebnahme-Service) von uns machen, dann zählt die volle Investition für die KfW-458-Förderung, ganz unabhängig davon, dass du selbst einbaust.${eigenSum>0?` Deine Eigenleistung oben ist mit <b>${eur(eigenSum)}</b> bereits eingerechnet.`:''} <span class="tag">unverbindliche Schätzung</span><br><span class="src">${esc(CONFIG.FOERDER_DISCLAIMER)}</span>`;
    }
    if(!updateTotal._fTracked){ track("foerder_view",{quote:q}); updateTotal._fTracked=true; }
  } else {
    if(fb) fb.classList.add('hidden');
    if(fdLine) fdLine.classList.add('hidden');
    /* OHNE FOERDERUNG, ABER MIT RABATT (portiert 16.09.2026): die Endpreiszeile blieb hier
       frueher aus, der Abzug haette nirgends eine Summe gehabt. Kein "nach Foerderung" im
       Label - es gibt keine. */
    if(effRow && effSum && __rab>0){
      effRow.classList.remove('hidden');
      effektivPreis=Math.max(__basis - __rab + deliveryFee(), 0);
      effSum.textContent=eur(effektivPreis);
      if(effLabel) effLabel.textContent='Dein Preis mit Rabatt';
    } else if(effRow) effRow.classList.add('hidden');
    /* Ohne Foerderung ist der Gesamtpreis der Endpreis - dann darf er auch nicht gestrichen
       sein. Jetzt bedingt statt bedingungslos: mit einem Rabatt als zweitem Abzug waere die
       Zahl sonst ungestrichen stehen geblieben, obwohl sie nicht mehr gilt. */
    const tSumAus=document.getElementById('totalSum'); if(tSumAus) tSumAus.classList.toggle('gestrichen', __rab>0);
  }
  /* Mini-Leiste oben in der Kaufbox zeigt den Preis NACH Foerderung (User 11.08.2026) - dieselbe
     Zahl, die unten gross steht. Ohne Foerderquote bleibt die Paketsumme als Rueckfall. */
  const bbMini=document.getElementById('bbMiniSum');
  /* Die Leiste oben zeigt den Preis NACH FOERDERUNG (User 11.08.2026, bestaetigt 03.09.2026) -
     dieselbe Zahl, die unten gross steht. Ohne Foerderquote bleibt die Paketsumme als Rueckfall.
     Am 02.09. stand hier kurz die Hardware-Summe; das war ein Missverstaendnis und ist zurueck.
     Seit die Foerderbasis der angezeigten Summe folgt, passt die Zahl in BEIDEN Schritten zu den
     Zeilen darunter: im Hardware-Schritt zur Hardware-Rechnung, im Services-Schritt zur vollen. */
  if(bbMini) bbMini.textContent = effektivPreis!=null ? eur(effektivPreis) : eur(grandTotal);
  const bbMiniLabel=document.getElementById('bbMiniStepLabel');
  if(bbMiniLabel && activeBbStep('bb')==='hardware')
    bbMiniLabel.textContent = effektivPreis!=null ? 'Schritt 1/2 · Bauteile · nach Förderung' : 'Schritt 1/2 · Bauteile';
  /* ENTFERNT 11.08.2026 (Carsten): Handwerker-Anker (~30.000 EUR) und die Zeile "Du sparst gegenueber
     dem Handwerker-Einbau" sind raus - inklusive der Rechnung dahinter (ankerNetto/unsNetto/saveLine)
     und der Fussnote "*Vergleich: typisches Handwerker-Komplettangebot".
     Grund: rund 90 % der Besucher brechen auf dieser Seite ab. Der Vergleich lenkt genau in dem
     Moment vom Endpreis ab, in dem der Kunde entscheiden soll, und laedt zum Preisvergleich mit
     Dritten ein statt zum naechsten Schritt. Die Ersparnis-Aussage kann spaeter an anderer Stelle
     wiederkommen (Carsten: "ggf an anderer Stelle / später anzeigen") - dann aber nicht neben dem
     Kaufbutton.
     WO DER VERGLEICH WEITERLEBT: im Hero, als redaktioneller Text ueber die Section-Einstellungen
     ("~30.000 €" / "beim Handwerker.", siehe sections/billigerwaermepumpe-hero.liquid und
     config/settings_data.json). Der haengt NICHT an dieser Konstante, sondern wird im Theme-Editor
     gepflegt - wer die Zahl aendert, aendert sie dort.
     CONFIG.ANCHOR_VERGLEICH selbst hat seit diesem Umbau keinen Leser mehr (im Review geprueft).
     Bewusst stehengelassen, weil die Zahl der dokumentierte User-Entscheid vom 29.07.2026 ist und
     die Ersparnis-Anzeige laut Carsten spaeter zurueckkommen soll. Wer sie reaktiviert, findet
     hier den abgestimmten Wert - wer sie endgueltig verwirft, kann Zeile 241 loeschen. */
  gruppenZaehlerAktualisieren('extraList');
  const btn=document.getElementById('buyBtn'), note=document.getElementById('depositNote');
  if(CONFIG.MODE==='deposit'){
    /* Zweistufiges Modell mit voller Transparenz (Slack-Entscheid 14.07.2026): der Kunde sieht,
       was sein Paket kostet, was er HEUTE zahlt und was als Restzahlung bei Erhalt bleibt. */
    btn.innerHTML=kaufKnopfGross();
    /* Die drei Zeilen "Paket gesamt / heute / Restzahlung bei Erhalt" sind am 11.08.2026 entfernt
       worden (User: "1 mal dick der Gesamtpreis nach Foerderung und klein der Gesamtpreis, thats
       it"). Die Paketsumme steht weiterhin im Preisblock darueber, die Anzahlung auf dem Button,
       und Schritt 3 der Ablaufliste sagt, wann die Restzahlung faellig wird. */
    /* Bullet-Liste: jede Gruppe des Pakets, identisch zu den Checkout-Zeilen (paketGruppen = eine
       Quelle, inkl. Abholung/Lieferung-Zeile). Zugeklappt hinter "Dein Paket im Detail". */
    /* Inhalt statt Rechnung: hier stand die Gruppenliste aus paketGruppen() mit Preisen - also
       ein zweites Mal Zahlen, direkt unter dem Preisblock. Jetzt steht drin, WAS er bekommt;
       was es kostet, steht Zeile fuer Zeile darueber und als Summe im Preisblock. */
    const luD=lieferumfangZeilen(cand.kit);
    /* UMGEBAUT 11.08.2026 (Carsten: "Was passiert nach der Anzahlung stärker rausstellen").
       Vorher stand der Ablauf als Fliesstext ganz unten in der Box - also genau da, wo niemand mehr
       liest, der ohnehin schon zoegert. Jetzt drei nummerierte Schritte ueber den Zahlen: der Kunde
       sieht die Antwort auf "was passiert, wenn ich jetzt klicke" bevor er den Betrag sieht.
       Die Geld-zurueck-Zusage steht nicht mehr nur in der Kleinschrift, sondern als eigene Zeile. */
    /* Offen-Zustand ueber das Neuzeichnen retten: updateTotal() laeuft bei jedem Klick auf einen
       Service. Ohne das wuerde die aufgeklappte Liste bei jeder Aenderung zuklappen - also genau
       dann, wenn der Kunde nachsieht, was sich gerade geaendert hat. */
    const warOffen=!!(note.querySelector('details.resdetail')||{}).open;
    note.innerHTML=`<div class="banner ok resnote">
            <details class="mini resdetail"${warOffen?' open':''}><summary>Dein Lieferumfang (${luD.anzahl} ${luD.anzahl===1?'Position':'Positionen'})</summary><div class="lu-liste">${luListeHtml(luD)}</div></details>
    </div>`;
  } else { btn.textContent=`Kaufen: ${eur(grandTotal)}`; note.innerHTML=''; }
}
/* Zwischen Klick und Shopify-Checkout liegen drei Netzwerk-Requests (clear/add/update). Ohne
   sichtbaren Zustand sieht der Button aus, als wäre der Klick ins Leere gegangen - Kunden klicken
   dann nochmal und lösen ein zweites Cart-Rennen aus. Gibt eine Restore-Funktion für die Fälle
   zurück, in denen doch nicht navigiert wird. */
/* innerHTML statt textContent (11.08.2026): der Kaufbutton traegt seit dem Kit-Overview-Umbau eine
   zweite Zeile ("100 % erstattbar") als <small>. Mit textContent haette der Restore-Pfad das Markup
   als sichtbaren Text zurueckgeschrieben.
   NACHGEZOGEN nach Review: auch der SETZ-Pfad muss die zweite Zeile behalten. Mit textContent(label)
   fiel das <small> beim Klick weg, der Button schrumpfte von zwei Zeilen auf eine und alles darunter
   sprang um rund 20 px nach oben - genau in dem Moment, in dem der Kunde auf Rueckmeldung wartet.
   Die Zeile bleibt deshalb waehrend "Wird vorbereitet ..." stehen; label kommt aus festen Strings
   im Code, nicht aus Nutzereingaben, escapen ist also nicht noetig. */
function setBusy(btn,label){
  if(!btn) return ()=>{};
  const old=btn.innerHTML;
  const sub=btn.querySelector('small');
  btn.disabled=true; btn.setAttribute('aria-busy','true'); btn.classList.add('is-busy');
  btn.textContent=label;
  if(sub) btn.appendChild(sub.cloneNode(true));
  return ()=>{ btn.disabled=false; btn.removeAttribute('aria-busy'); btn.classList.remove('is-busy'); btn.innerHTML=old; };
}
/* Reservierung per Ajax-Cart-API statt Permalink: Line-Item-Properties erscheinen sichtbar
   unter der Position - im Checkout, in der Bestellbestätigung UND in der Admin-Bestellansicht.
   So sieht der Kunde auch an der Kasse: was ist das Paket, was zahle ich heute, was bleibt.
   Fällt bei API-Fehlern auf den alten Permalink (ohne Properties, mit Note) zurück. */
/* Der Seitenwechsel zur Kasse wartet auf die Messung. kasseFrei wird an der Stelle gesetzt, an
   der checkout_start gemeldet wird - siehe Kommentar an track(). Ohne diese Kopplung konkurriert
   die Navigation mit den Messanfragen, und je nach Netz verliert die Messung. */
let kasseFrei=null;
/* Merkt, dass das E-Mail-Gate am Funnel-Ende passiert wurde. Nur zur Auswertung und
   fuer spaetere Rueckfragen - der Weg zurueck in den Vergleich prueft es bewusst nicht. */
let emailGatePassiert=false;
/* Nur die Durchreiche aus der Mail setzt das (Knopf "Lieber erst ansehen"). Die Cart-Requests
   laufen dann zu Ende - ein halb gefuellter Warenkorb waere schlimmer als ein voller, und der
   naechste echte Kauf raeumt ihn mit /cart/clear.js ohnehin ab. Nur der Seitenwechsel faellt
   aus. checkout() setzt es bei jedem neuen Anlauf zurueck, damit ein Abbruch nicht den
   spaeteren Kauf per Hand blockiert. */
let kasseAbgebrochen=false;
/* Zaehlt die Kaufanlaeufe. Ohne ihn gaebe es ein Rennen: bricht der Kunde die Durchreiche ab
   (kasseAbgebrochen=true), waehrend clear/add/update noch laufen, und klickt dann von Hand
   auf Kaufen, setzt checkout() das Flag zurueck - und die ALTE, abgebrochene Kette navigiert
   doch noch, moeglicherweise mitten in die frische clear/add-Folge hinein. Der Kunde saehe
   dann eine Kasse mit halbem oder leerem Warenkorb. Jede Kette merkt sich daher ihre eigene
   Nummer und faehrt nur, wenn sie noch die aktuelle ist. */
let kaufLauf=0;
function navigiereNachMessung(url,lauf){
  const meins=(typeof lauf==='number')?lauf:kaufLauf;
  const los=()=>{ if(kasseAbgebrochen || meins!==kaufLauf) return; window.location.href=url; };
  if(kasseFrei) kasseFrei.then(los,los); else los();
}
/* items (optional): die echten Warenkorbzeilen im Positionsmodus "echt". Ohne sie bleibt es
   bei der einen Sammelposition - dem Verhalten bis zum 03.09.2026.
   Die Eigenschaften haengen an der ERSTEN Zeile (dem Kit). Sie an jede Zeile zu haengen
   wuerde dieselbe Konfiguration acht Mal untereinander in die Kasse schreiben. */
/* NUR DIE KAUFAUSWAHL VERGESSEN, NICHT DEN GANZEN STAND (16.09.2026, Betreiber-Entscheid).
   Gemeldet wurde: alte Positionen landeten in frischen Bestellungen. Ursache war der
   gespeicherte Stand, der bewusst NICHT beim Checkout geleert wurde - Begruendung bei
   STAND_SCHLUESSEL: "wer abbricht, braucht seinen Stand dringender, als ein Kaeufer ihn los
   sein muss". Diese Abwaegung ist in der Praxis anders ausgegangen.

   DER GROBE SCHALTER WAERE HIER FALSCH. Am 16.09.2026 war im Konfigurator-Test-Theme kurz
   CONFIG.STAND_SPEICHERN=false gesetzt - das Speichern also ganz abgeschaltet. In Claras
   Aufbau wuerde das ihre Warenkorb-Schublade aushebeln: sie stuetzt sich an 34 Stellen auf
   standDirekt, und ihre Vorgabe vom 16.09.2026 lautet ausdruecklich "WAS SCHON IM WARENKORB
   LIEGT, BLEIBT LIEGEN". Der Schalter ist deshalb bewusst NICHT mitportiert.

   Stattdessen genau der gemeldete Fall: wer in die Kasse geht, verliert seine KAUFAUSWAHL
   (kauf/direkt). Die Antworten bleiben - er muss den Fragebogen nicht noch einmal ausfuellen.
   Wer abbricht, findet seinen Rechner wieder; wer kauft, faengt beim naechsten Mal mit einem
   leeren Tisch an. Innerhalb derselben Sitzung ist die Schublade unberuehrt, weil das hier
   erst beim Sprung in die Kasse passiert. */
function kaufauswahlVergessen(){
  try{
    const roh=localStorage.getItem(STAND_SCHLUESSEL); if(!roh) return;
    const d=JSON.parse(roh); if(!d) return;
    d.kauf=null; d.direkt=null;
    localStorage.setItem(STAND_SCHLUESSEL, JSON.stringify(d));
  }catch(e){ /* privater Modus: dann gibt es ohnehin keinen Stand */ }
}
function depositCheckout(props,noteText,fallbackUrl,items){
  /* Nummer JETZT merken, nicht erst am Ende der Kette - am Ende waere sie laengst
     hochgezaehlt und die Pruefung wertlos. */
  const lauf=kaufLauf;
  const zeilen = (items && items.length)
    ? items.map((it,i)=> i===0 ? {id:it.id,quantity:it.quantity,properties:props} : it)
    : [{id:Number(PRODUCTS.deposit.variantId),quantity:1,properties:props}];
  fetch('/cart/clear.js',{method:'POST'})
    .then(()=>fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:zeilen})}))
    .then(r=>{ if(!r.ok) throw new Error('add '+r.status);
      /* Merkmal "konfiguration" am Warenkorb: templates/cart.liquid sperrt daran die Mengen.
         Liegen die echten Produkte einzeln im Korb, ist jede Zeile Teil EINER Konfiguration -
         wer dort die Menge tippt, kauft zwei Kits oder loescht das Kit und behaelt den
         Foerderantrag. Die Regeln, die das im Rechner verhindern (Entweder/Oder je xgroup,
         Mengengrenzen je Position), gibt es auf der Warenkorbseite nicht und kann es dort
         auch nicht geben - also wird dort gar nicht mehr getippt, sondern zurueck in den
         Rechner geschickt. */
      return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({note:noteText,attributes:{...attrAttributes(),
          konfiguration:(items&&items.length)?'echt':'sammel'}})}); })
    .then(()=>{ kaufauswahlVergessen(); navigiereNachMessung('/checkout',lauf); })
    .catch(e=>{ console.warn('[checkout] Ajax-Cart fehlgeschlagen, Permalink-Fallback:',e); navigiereNachMessung(fallbackUrl,lauf); });
}
/* onAbort wird nur aufgerufen, wenn wir NICHT navigieren (Testbetrieb ohne echtes Produkt) - der
   Kaufen-Button muss dann wieder klickbar werden. */
/* ---------- Positionen fuer die Shopify-Kasse (User-Vorgabe 12.08.2026) ----------
   Vorher stand dort pro Gruppe EINE Zeile mit allem drin ("Services: Förderantrag (inklusive),
   Anlagencheck & Inbetriebnahme (999 €), Technische Planung (999 €)") - ein Textblock, in dem
   man den einzelnen Posten samt Preis suchen muss. Jetzt: eine Zeile je Posten.

   Shopify rendert Line-Item-Properties als "Schluessel: Wert". Der Schluessel traegt deshalb den
   NAMEN, der Wert den PREIS - damit steht links der Posten und rechts der Betrag, in der Kasse,
   in der Bestellbestaetigung und in der Admin-Ansicht gleichermassen.

   Ueberschriften sind eigene Zeilen mit der Anzahl als Wert, die Posten darunter bekommen "· "
   vorangestellt. Ein Wert MUSS gesetzt sein: Shopify-Vorlagen (auch unsere Mail fuer verlassene
   Checkouts) blenden Eigenschaften ohne Wert aus - eine Ueberschrift mit leerem Wert waere
   unsichtbar. Schluessel mit "_" waeren sogar generell versteckt.

   Reihenfolge = Einfuegereihenfolge des Objekts (String-Schluessel behalten sie). Gleiche Namen
   wuerden sich gegenseitig ueberschreiben, deshalb haengt setz() im Zweifel eine Nummer an. */
/* schlank=true im Positionsmodus "echt": Kit, Speicher, Services und Material stehen dann
   als eigene Warenkorbzeilen mit eigenem Preis da. Sie zusaetzlich als Eigenschaften unter
   die erste Zeile zu schreiben, haette dieselbe Liste zweimal untereinander gestellt - einmal
   als Positionen, einmal als Text. Was bleibt, ist das, was Shopify NICHT von selbst zeigt:
   Versandart und die Zahlungszusage. */
function checkoutPositionen(kitKey,svcSet,schlank){
  const p={};
  const setz=(k,v)=>{ let s=k,i=2; while(s in p) s=k+' ('+(i++)+')'; p[s]=String(v); };
  const preis=n=>n>0?eur(n):'inklusive';

  const spKey=speicher();
  /* DER WUNSCHSTART REIST MIT (13.10.2026). Eine Angabe, die der Kunde macht und die
     niemanden erreicht, ist schlimmer als keine Frage: Sie weckt eine Erwartung, von der
     im Betrieb niemand weiss. Deshalb steht er in BEIDEN Fassungen - auch in der schlanken,
     die sonst nur den Versand nennt. Ohne Angabe steht nichts da; "Wunschstart: -" waere
     eine Zeile ueber nichts. */
  const startText=startWunschText();
  /* MASCHINENLESBAR DANEBEN (13.10.2026). Der Unterstrich am Anfang blendet die Eigenschaft
     im Checkout und in der Bestellbestaetigung aus - sie ist nicht fuer den Kunden, sondern
     fuer die Warenkorbseite: Dort soll der Wunschstart aenderbar sein, und dafuer muss der
     Stand zurueckgelesen werden koennen. Aus dem Klartext ("KW 48 · 23.11.-29.11.2026") ginge
     das nur ueber das Zerlegen von Datumsformaten, und beim ersten anders geschriebenen Monat
     ginge es schief. */
  const startRoh = (typeof window!=='undefined' && window.BwpStartwunsch)
    ? BwpStartwunsch.roh(startZustand()) : '';
  if(schlank){
    setz('VERSAND', deliveryLabel());
    if(startText) setz('Wunschstart (unverbindlich)', startText);
    if(startRoh) setz('_startwunsch', startRoh);
    return p;
  }
  /* UNTER "PRODUKTE" STEHT NUR DAS KIT (Vorgabe 18.09.2026). Der Warmwasserspeicher stand
     bis hierher daneben, weil er wie das Kit in PRODUCTS gefuehrt wird - im Katalog aus
     gutem Grund, denn er hat eine eigene Shopify-Variante und einen eigenen Preis. Fuer den
     Kunden in der Bestellung ist er aber dasselbe wie die uebrigen Bauteile: etwas, das er
     dazugenommen hat. Er steht deshalb jetzt unter MATERIAL, an erster Stelle, weil er die
     groesste dieser Positionen ist.

     NUR DIE UEBERSCHRIFT WANDERT, nicht die Tabelle. PRODUCTS bleibt sein Platz im Katalog;
     ihn dorthin zu verschieben, wo er in der Bestellung erscheint, haette Preisberechnung,
     Varianten-Zuordnung und den Warenkorb betroffen - fuer eine Beschriftung. */
  setz('PRODUKTE', '1 Position');
  setz('· '+PRODUCTS[kitKey].name, eur(PRODUCTS[kitKey].price));

  /* Dieselbe Sortierung wie die Warenkorbzeilen - sonst staende in derselben Bestellung
     einmal die eine und einmal die andere Reihenfolge. */
  const svc=svcSortiert(svcSet);
  if(svc.length){
    setz('SERVICES', svc.length+(svc.length===1?' Position':' Positionen'));
    svc.forEach(k=>setz('· '+SERVICES[k].name, preis(SERVICES[k].price)));
  }
  /* Material einzeln statt als Gruppenzeile - der Kunde soll jedes Teil mit Menge und Preis
     wiederfinden, auch wenn zwei Teile zur selben Gruppe gehoeren. */
  const mat=extrasSortiert();
  /* Der Speicher zaehlt mit - sonst staende "1 Position" ueber zwei Zeilen. Und der Block
     erscheint auch dann, wenn ausser ihm nichts gewaehlt ist. */
  const matAnzahl = mat.length + (spKey?1:0);
  if(matAnzahl){
    setz('MATERIAL', matAnzahl+(matAnzahl===1?' Position':' Positionen'));
    if(spKey) setz('· '+PRODUCTS[spKey].name, eur(PRODUCTS[spKey].price));
    mat.forEach(([k,q])=>{
      const e=EXTRAS[k];
      const menge = e.perMeter ? ` (${q} m)` : (e.perUnit&&q>1 ? ` (${q}×)` : '');
      setz('· '+e.name+menge, eur(e.price*q));
    });
  }
  setz('VERSAND', deliveryLabel());
  if(startText) setz('Wunschstart (unverbindlich)', startText);
  if(startRoh) setz('_startwunsch', startRoh);
  return p;
}
/* Riegel "Kit passt nicht" - eine Pruefung fuer ALLE Kaufwege (25.08.2026).
   Vorher stand sie ausschliesslich in #buyBtn.onclick. Die Checkbox steht aber in der
   Kaufbox, und der Sticky-CTA am unteren Rand ruft checkout() direkt auf - beide sind
   gleichzeitig sichtbar. Wer unten tippte statt in der Box, kaufte ein Kit, dessen
   Warnung er nie bestaetigt hatte. Exakt der Fehler, vor dem der Kommentar in checkout()
   fuer das Foerder-Gate warnt; fuer diesen Riegel war die Lehre nur nicht gezogen worden.
   Kein Merker noetig: die Checkbox steht im DOM, ihr Zustand IST die Wahrheit. */
function unsuitFrei(){
  const gate=document.getElementById('unsuitOk');
  if(!gate || gate.checked) return true;
  const w=document.getElementById('unsuitWarn');
  if(w){
    w.scrollIntoView({behavior:'smooth',block:'center'});
    w.classList.remove('flash'); void w.offsetWidth; w.classList.add('flash');
  }
  gate.focus();
  track('unsuit_gate_blockiert',{});
  return false;
}
/* EINBRINGBARKEITS-URTEIL.
   Liefert 'aus', solange CONFIG.EINBRINGUNG.AKTIV false ist oder Schwellen fehlen -
   dann greift der Riegel nicht und der Shop verhaelt sich wie vorher.
   'unbekannt' heisst: der Kunde hat die Frage nicht beantwortet. Das ist AUSDRUECKLICH
   kein Urteil. Wer den Direktkauf ueber /pages/produkt nimmt, laeuft am Funnel vorbei und
   hat gar keine Antworten - den deshalb pauschal zu blockieren oder pauschal durchzulassen
   waere beides falsch. Fehlende Antwort = fragen, nicht urteilen. */
function einbringUrteil(){
  const E=CONFIG.EINBRINGUNG||{};
  if(!E.AKTIV) return {status:'aus', gruende:[]};
  const schwellen=[E.TUER_MIN_CM,E.TREPPE_MIN_CM,E.HOEHE_MIN_CM];
  if(schwellen.every(v=>v===null||v===undefined)) return {status:'aus', gruende:[]};

  const gruende=[];
  const pruefe=(wert,minimum,text)=>{
    if(minimum===null||minimum===undefined) return;
    if(wert===null||wert===undefined||wert==='') { gruende.push({offen:true, text}); return; }
    if(Number(wert) < Number(minimum)) gruende.push({offen:false, text});
  };
  pruefe(A.einbringTuer,   E.TUER_MIN_CM,   `Tür mindestens ${E.TUER_MIN_CM} cm lichte Breite`);
  pruefe(A.einbringTreppe, E.TREPPE_MIN_CM, `Treppe mindestens ${E.TREPPE_MIN_CM} cm lichte Breite`);
  pruefe(A.einbringHoehe,  E.HOEHE_MIN_CM,  `durchgehend mindestens ${E.HOEHE_MIN_CM} cm lichte Höhe`);

  if(!gruende.length) return {status:'ok', gruende:[]};
  if(gruende.every(g=>g.offen)) return {status:'unbekannt', gruende};
  return {status:'eng', gruende:gruende.filter(g=>!g.offen)};
}

/* RIEGEL EINBRINGBARKEIT (25.08.2026).
   Vorgabe des Betreibers woertlich: warnen, den Weg trotzdem offen lassen, zur Kontakt-
   aufnahme raten, und klar distanzieren - keine Haftung, und wir empfehlen den Kauf bei
   diesen Massen ausdruecklich NICHT.

   Nutzt bewusst dieselbe .fg-overlay/.fg-card-Optik wie foerderGate: der Kunde hat das
   Muster an dieser Stelle schon einmal gesehen, und es spart eine zweite CSS-Wahrheit.
   Steht NACH dem Foerder-Gate - Geld zuerst, Bau danach; zwei Dialoge hintereinander sind
   unvermeidbar, ihre Reihenfolge ist es nicht. */
function einbringGate(urteil, weiter){
  track('einbring_gate_view',{status:urteil.status});
  const alt=document.getElementById('einbringGate'); if(alt) alt.remove();
  const ov=document.createElement('div');
  ov.className='fg-overlay'; ov.id='einbringGate';
  const offen = urteil.status==='unbekannt';
  ov.innerHTML=`<div class="fg-card" role="dialog" aria-modal="true" aria-labelledby="egTitel">
    <div class="fg-eyebrow">Bevor du bestellst</div>
    <h3 id="egTitel">${offen?'Passt die Inneneinheit bei dir überhaupt hinein?':'Der Weg in den Keller könnte zu eng sein'}</h3>
    <p class="fg-sub">Die Inneneinheit muss als Ganzes in den Aufstellraum getragen werden. Ist der Weg zu eng, lässt sie sich weder zerlegen noch nachträglich anders einbringen.</p>
    <ul class="fg-list">${urteil.gruende.map(g=>`<li><b>${esc(g.text)}</b></li>`).join('')}</ul>
    <p class="fg-sub"><b>Wir empfehlen dir ausdrücklich nicht, die Inneneinheit in dieser Größe zu bestellen, solange der Einbringweg nicht geklärt ist.</b> Sprich vorher kurz mit uns &ndash; oft findet sich eine Lösung, und wenn nicht, hast du dir eine Rücksendung erspart.</p>
    <p class="fineprint">Die Prüfung beruht ausschließlich auf deinen eigenen Angaben. Wir messen nicht nach und übernehmen für die Einbringbarkeit keine Haftung. Bestellst du trotzdem, trägst du das Risiko, dass das Gerät nicht an seinen Platz gelangt.</p>
    <div class="fg-nav">
      <button type="button" class="btn" id="egHilfe">Mit uns klären →</button>
      <button type="button" class="btn quiet" id="egGo">Trotzdem bestellen</button>
    </div>
  </div>`;
  document.body.appendChild(ov);
  scrollSperren('einbring');

  const zu=()=>{ ov.remove(); scrollFreigeben('einbring'); document.removeEventListener('keydown',esc_,true); };
  const esc_=e=>{ if(e.key==='Escape'){ e.stopPropagation(); track('einbring_gate_abbruch',{}); zu(); } };
  document.addEventListener('keydown',esc_,true);
  ov.addEventListener('click',e=>{ if(e.target===ov){ track('einbring_gate_abbruch',{}); zu(); } });

  ov.querySelector('#egHilfe').onclick=async()=>{
    track('einbring_gate_hilfe',{status:urteil.status});
    const knopf=ov.querySelector('#egHilfe');
    knopf.disabled=true; knopf.textContent='Wird gesendet …';
    /* Eigene Stage statt fachbetrieb_lead: "wer baut mir das ein" ist eine andere Frage
       als "passt das ueberhaupt durch meine Kellertreppe". In n8n faellt eine unbekannte
       Stage in den Mail-Zweig, im CRM gibt es dafuer die Option "Einbringung klären". */
    const ok=await submitLead('einbringung_klaeren',{einbring_status:urteil.status, einbring_gruende:urteil.gruende.map(g=>g.text).join(' · ')});
    knopf.textContent = ok ? 'Wir melden uns' : 'Bitte ruf uns an';
    ov.querySelector('.fg-sub').insertAdjacentHTML('afterend', ok
      ? `<div class="banner ok">Angekommen. Wir melden uns bei dir, bevor du bestellst.</div>`
      : `<div class="banner warn">Das hat gerade nicht geklappt &ndash; ruf uns bitte an: ${esc(CONFIG.SUPPORT_PHONE||'')}</div>`);
  };
  ov.querySelector('#egGo').onclick=()=>{
    track('einbring_gate_trotzdem',{status:urteil.status});
    zu(); weiter();
  };
}

/* gates statt einzelner Booleans (25.08.2026).
   Vorher hiess der dritte Parameter gatePassiert und meinte genau das Foerder-Gate. Mit
   der Einbringungs-Pruefung waere daraus ein zweiter Boolean geworden, mit dem naechsten
   Riegel ein dritter - und die Aufrufstellen haetten irgendwann checkout(c,a,true,false,true)
   gelesen. Ein Objekt benennt, was passiert ist. true wird weiter angenommen, damit eine
   uebersehene Aufrufstelle nicht still ein Gate ueberspringt. */
function checkout(cand,onAbort,gates){
  const abort=onAbort||(()=>{});
  kasseAbgebrochen=false; kaufLauf++;
  const g = (gates===true) ? {foerder:true,einbring:true} : (gates||{});
  /* Riegel 1: unpassendes Kit. Steht vor allem anderen - wenn der Rechner sagt, das Geraet
     passt nicht, ist jede weitere Frage nachrangig. */
  if(!unsuitFrei()){ abort(); return; }
  /* Riegel 2: offene Foerderpunkte. Die Nachfrage sitzt HIER und nicht am Knopf: der
     Sticky-CTA ruft checkout() direkt auf und ging sonst daran vorbei. abort() gibt den
     Knopf frei, solange der Dialog offen ist. */
  if(!g.foerder && offeneFoerderpunkte(chosenServices).length){
    abort();
    foerderGate(chosenServices, ()=>checkout(cand,onAbort,{...g,foerder:true}), 'foerderRiskBox');
    return;
  }
  /* Riegel 3: Einbringbarkeit. Inert, solange CONFIG.EINBRINGUNG.AKTIV false ist. */
  if(!g.einbring){
    const u=einbringUrteil();
    if(u.status!=='aus' && u.status!=='ok'){
      abort();
      einbringGate(u, ()=>checkout(cand,onAbort,{...g,einbring:true}));
      return;
    }
  }
  kasseFrei=new Promise(erfuellt=>track("checkout_start",{kit:cand.kit,services:[...chosenServices],mode:CONFIG.MODE,path:'buybox'},erfuellt));
  submitLead("checkout_start");
  const extrasNote=Object.entries(chosenExtras).map(([k,q])=>k+(EXTRAS[k]&&EXTRAS[k].perMeter?'x'+q+'m':(EXTRAS[k]&&EXTRAS[k].perUnit?'x'+q:''))).join(",")||"keine";
  const noteText=`Konfiguration: ${cand.kit} | ${cand.c.pausl} kW | Services: ${[...chosenServices].join(",")||"keine"} | Extras: ${extrasNote} | Lieferung | PLZ ${A.plz}${attrShort()}`;
  if(CONFIG.MODE==='deposit'){
    /* Im Positionsmodus "echt" wird das Anzahlungsprodukt gar nicht angefasst - dann darf
       eine fehlende Anzahlungs-Variante den Kauf auch nicht aufhalten. */
    if(!echtePositionen() && String(PRODUCTS.deposit.variantId).startsWith('TBD_')){ abort(); renderOrderConfirmation(cand,'TBD'); return; }
    const spKey=speicher(), sp=spKey?PRODUCTS[spKey]:null;
    let sum=PRODUCTS[cand.kit].price + (sp?sp.price:0);
    chosenServices.forEach(k=>sum+=SERVICES[k].price);
    sum+=extrasSumme();
    /* Der Rabatt greift auf der Summe VOR der Liefergebuehr - Logistik wird nicht rabattiert
       (portiert 16.09.2026). */
    const rabBetrag=rabattBetrag(sum);
    const grandTotal=sum-rabBetrag+deliveryFee(); /* Förderbasis bleibt "sum" ohne Lieferkosten, siehe deliveryFee() */
    /* Checkout-Zeilen: jede Position mit Preis, Material-Extras als GRUPPE (User-Entscheid) -
       identisch zur Bullet-Übersicht in der Buybox (paketGruppen = eine Quelle). */
    /* Im Modus "echt" liegen die wirklichen Varianten im Warenkorb; die Textliste faellt dann
       weg, weil Shopify sie als Positionen zeigt. Bleibt die Liste leer (keine einzige gueltige
       Varianten-ID), faellt der Kauf auf die Sammelposition zurueck statt auf einen leeren
       Warenkorb - ein Kauf ohne Positionen waere schlimmer als einer ohne Einzelpreise. */
    const zeilenRoh=echtePositionen()?warenkorbPositionen(cand.kit,chosenServices):null;
    const zeilen=(zeilenRoh&&zeilenRoh.length)?zeilenRoh:null;
    const props=checkoutPositionen(cand.kit,chosenServices,!!zeilen);
    /* Geld zum Schluss (User 12.08.2026): erst die Liste dessen, was bestellt wird, dann was es
       kostet, dann wie es weitergeht. "Wie es weitergeht" stand bis heute als ERSTE Eigenschaft,
       damit die Zusage in der Kasse ganz oben steht - mit einer echten Positionsliste davor waere
       das aber ein Absatz Fliesstext zwischen Ueberschrift und erster Position. */
    /* DER ABZUG SICHTBAR IN DER KASSE (portiert 16.09.2026). Shopify kann hier keinen
       Rabattcode rechnen - im Warenkorb liegt nur die Vorbestellung, ein Code traefe die 0 EUR
       und nicht das Paket. Der Abzug wird deshalb als Positionstext gezeigt und auf der
       Schlussrechnung verrechnet. Zwei Zeilen, weil eine rabattierte Summe allein nichts
       belegt: der Kunde soll sehen, WOVON abgezogen wurde. Grossbuchstaben als Ueberschrift
       und "· " davor ist dasselbe Muster, das checkoutPositionen() schon benutzt.
       ACHTUNG: In Shopifys Kasse steht ein Feld "Rabattcode", das unseren Code abweist
       (DISCOUNTS_NOT_FOUND). Die Vorwarnung steht bewusst nur in der Willkommensmail -
       Betreiber-Entscheid 16.09.2026, die Kasse sollte nicht geschwaetziger werden. */
    if(rabBetrag>0){
      props['DEIN RABATT']='Code '+rabattCode();
      props['· Originalpreis']=eur(sum+deliveryFee());
      /* Fester Betrag (28.09.2026): ohne Prozentangabe - der Code steht eine Zeile hoeher. */
      props[rabattProzent()>0 ? '· Rabatt '+rabattProzent()+' %' : '· Rabatt']='– '+eur(rabBetrag);
    }
    /* Fuer das Bestell-Attribut des festen Betrags, siehe attrAttributes(). */
    rabattGebucht=rabBetrag;
    props['PAKET GESAMT']=eur(grandTotal);
    /* Variante B des A/B-Tests kostet heute nichts. "Du zahlst heute 0 EUR (Anzahlung, wird
       voll angerechnet)" waere dort sachlich falsch und liest sich wie ein Fehler - es gibt
       keine Anzahlung, die angerechnet werden koennte. Deshalb zwei Wortlaute. */
    if(PRODUCTS.deposit.price>0){
      props['Du zahlst heute']=`${eur(PRODUCTS.deposit.price)} (Anzahlung, wird voll angerechnet)`;
      props['Restzahlung bei Erhalt']=eur(Math.max(0,grandTotal-PRODUCTS.deposit.price));
    } else {
      /* Wortlaut folgt AGB Paragraf 2 und dem Betreiber-Entscheid vom 03.09.2026: in Variante B
         zahlt der Kunde heute nichts, der Gesamtbetrag wird per Rechnung faellig, nachdem wir
         angenommen haben. Hier stand bis heute "Faellig bei Lieferung" - die falsche Zaesur:
         faellig wird nichts, bevor die Auftragsbestaetigung raus ist, und die Lieferung ist
         weder der Zeitpunkt der Annahme noch der der Rechnung. */
      props['Heute zu zahlen']='nichts – dies ist eine Reservierung';
      props['Fällig nach unserer Auftragsbestätigung']=eur(grandTotal)+' (per Rechnung)';
    }
    /* Nur Variante A: der Satz beginnt mit der Anzahlung, die es in der kostenfreien
       Vorbestellung nicht gibt. Betreiber-Entscheid 18.08.2026: in B ersatzlos weglassen. */
    if(PRODUCTS.deposit.price>0) props['Wie es weitergeht']='Du zahlst heute nur die Anzahlung. Danach melden wir uns und planen Liefertermin, Spedition und Abladestelle mit dir - erst dann geht dein Kit raus.';
    depositCheckout(props,noteText,
      zeilen ? warenkorbPermalink(zeilen,noteText) : `/cart/${PRODUCTS.deposit.variantId}:1?note=${encodeURIComponent(noteText)}`,
      zeilen);
    return;
  }
  const items=[PRODUCTS[cand.kit].variantId+":1"];
  const spKey=speicher(); if(spKey) items.push(PRODUCTS[spKey].variantId+":1");
  chosenServices.forEach(k=>items.push(SERVICES[k].variantId+":1"));
  /* Relativ statt CONFIG.SHOP_URL: der Rechner läuft im Shop selbst - so funktioniert der
     Warenkorb-Link auch auf Dev-Server und Theme-Preview, nicht nur auf der Live-Domain. */
  const url=`/cart/${items.join(",")}?note=${encodeURIComponent(noteText)}`;
  if(url.includes("TBD_")){
    abort();
    renderOrderConfirmation(cand,url);
  } else { navigiereNachMessung(url); }
}
/* Direkt nach dem Reservieren/Kaufen: Kunde soll ohne Suchen zu Lieferumfang und Anleitung kommen,
   statt nur eine Bestätigung zu sehen (Jan, 09.07.). Im Demo-Modus (kein Shop verbunden) ersetzt das
   den reinen Debug-Banner; live liefe das auf der Shopify-Danke-Seite. */
function renderOrderConfirmation(cand,demoUrl){
  const box=document.getElementById('demoBanner'); if(!box) return;
  const verb=CONFIG.MODE==='deposit'?'Angezahlt':'Bestellt';
  box.innerHTML=`<div class="orderconfirm">
    <div class="oc-head"><span class="oc-check">✓</span><b>${verb}.</b> Kit, Preis und Lieferumfang sind für dich vorgemerkt.</div>
    <div class="oc-actions">
      <button type="button" class="oc-btn" id="ocParts">Deinen Lieferumfang ansehen</button>
      <button type="button" class="oc-btn" id="ocGuide">Zur Einbau-Anleitung →</button>
    </div>
    ${demoUrl?`<div class="banner warn" style="margin-top:14px"><b>Hinweis (Testbetrieb):</b> Das Anzahlungs-Produkt ist im Shop noch nicht angelegt, dieser Klick löst noch keine echte Anzahlung aus.</div>`:''}
  </div>`;
  const ocParts=document.getElementById('ocParts');
  if(ocParts) ocParts.onclick=()=>openLu();
  const ocGuide=document.getElementById('ocGuide');
  /* Die Anleitung liegt seit dem Umzug auf /pages/ablauf, nicht mehr als Reiter auf derselben
     Seite. showPanel('ablauf') faende hier kein Panel mehr und landete auf der Startseite. */
  /* Zielt seit 25.08.2026 auf die App-Seite statt auf den Ablauf: die App ist ab dem Kauf
     freigeschaltet und IST die Anleitung. Der Ablauf bleibt das, was er ist - die Uebersicht
     davor. */
  if(ocGuide) ocGuide.onclick=()=>{ location.href=reiterUrl('app'); };
}

/* ============================== ADD-TO-CART MODAL (Produkt-Panel) ==============================
   Eigenständiger Kaufweg neben dem Rechner: Kit direkt wählen, ohne den Funnel zu durchlaufen.
   Erste Wahl im Modal ist bewusst "Rechner zuerst" (sichere Auslegung + Fördercheck), aber wer
   schon weiß was er braucht, bekommt trotzdem vollen Lieferumfang + Zusatzleistungen zu sehen. */
let directServices=new Set();
/* Fuer welches Kit der Ausgangszustand schon eingerichtet ist - siehe renderCartModalIncluded. */
let cmAufgebautFuer=null;
/* ============ FOKUS UND HINTERGRUND WAEHREND DES KAUFDIALOGS (02.09.2026) ============
   Der Dialog hatte bisher gar keine Fokusbehandlung: beim Oeffnen blieb der Fokus auf der
   Kit-Kachel DAHINTER, und Tab wanderte durch die Seite im Hintergrund statt durch den Dialog.
   Im 560px-Fenster war das eine Unsauberkeit; bildschirmfuellend wird daraus eine Bedienstoerung,
   weil der Fokus dann durch etwas laeuft, das gar nicht zu sehen ist.

   Statt einer selbstgebauten Fokusfalle bekommen die GESCHWISTER des Dialogs das inert-Attribut:
   der Browser nimmt sie damit aus Tab-Reihenfolge und Screenreader-Baum, und der Fokus kann den
   Dialog nicht verlassen. Kennt ein Browser inert nicht, bleibt es beim heutigen Verhalten -
   kein Rueckschritt, nur kein Gewinn. */
let __kaufOeffner=null;
let __kaufInert=[];
function __kaufGeschwisterSperren(){
  const m=document.getElementById('cartModal'); if(!m || !m.parentElement) return;
  __kaufInert=[];
  Array.prototype.forEach.call(m.parentElement.children,el=>{
    if(el===m || el.inert) return;
    try{ el.inert=true; __kaufInert.push(el); }catch(e){}
  });
}
function __kaufGeschwisterFreigeben(){
  __kaufInert.forEach(el=>{ try{ el.inert=false; }catch(e){} });
  __kaufInert=[];
}
/* Fokus in den Dialog setzen: erstes bedienbares Element, sonst der Dialog selbst.
   Verzoegert per rAF, weil der Inhalt erst nach dem Rendern dasteht. */
function __kaufFokusHinein(){
  requestAnimationFrame(()=>{
    const m=document.getElementById('cartModal'); if(!m || m.classList.contains('hidden')) return;
    const ziel=m.querySelector('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
    if(ziel){ try{ ziel.focus(); }catch(e){} return; }
    try{ m.setAttribute('tabindex','-1'); m.focus(); }catch(e){}
  });
}
function openCartModal(kitKey, direkt){
  /* Wer den Dialog geoeffnet hat - dorthin geht der Fokus beim Schliessen zurueck. */
  __kaufOeffner=document.activeElement;
  /* Zweiter Kaufweg. Die Kit-Kacheln auf /pages/produkt rufen das hier direkt auf und
     laufen komplett an routeAll() vorbei - ohne diesen Riegel bliebe das Hybrid-Kit bei
     zwei Heizkreisen mit einem Klick kaufbar, obwohl es im Rechner ausgeschlossen ist.
     Greift bewusst nur, wenn die Frage beantwortet wurde: wer die Produktseite ohne Funnel
     besucht, hat kein A.heating und soll nicht ausgesperrt werden. */
  if(kitKey==='hybrid' && A.heating==='mix'){
    track('hybrid_gesperrt',{grund:'zwei_heizkreise'});
    document.getElementById('cartModal').classList.remove('hidden');
    scrollSperren('kauf');
    __kaufGeschwisterSperren();
    __kaufFokusHinein();
    document.getElementById('cartModalBody').innerHTML=`
      <div class="v-eyebrow" style="color:var(--bernstein-dark)">Hybrid-Kit</div>
      <h2 style="font-size:clamp(21px,3vw,26px);margin-top:8px;font-weight:800;letter-spacing:-.01em">Für zwei Heizkreise haben wir noch keine Lösung.</h2>
      <p style="color:var(--graphit);margin-top:10px;max-width:46ch;font-size:15px">Du hast Fußbodenheizung <b>und</b> Heizkörper. Beide brauchen eine eigene Regelung, und das deckt das Hybrid-Kit nicht ab. Wir sagen dir Bescheid, sobald es passt.</p>
      <div class="emailrow" style="margin-top:18px"><input type="email" id="hwEmail" value="${esc(A.email||'')}" placeholder="du@beispiel.de"></div>
      <div class="emailrow" style="margin-top:8px"><input type="tel" id="hwTel" placeholder="Telefon für Rückfragen"></div>
      <button class="btn" id="hwGo" style="margin-top:12px">Auf die Warteliste →</button>
      <div id="hwDone"></div>
      <p class="fineprint" style="margin-top:10px">Die drei DIY-Kits ohne Gasheizung stehen dir weiterhin offen &ndash; die kommen mit zwei Heizkreisen zurecht.</p>`;
    const go=document.getElementById('hwGo');
    go.onclick=async()=>{
      const mail=(document.getElementById('hwEmail').value||'').trim();
      const tel=(document.getElementById('hwTel').value||'').trim();
      const box=document.getElementById('hwDone');
      if(!istEmail(mail)){ box.innerHTML='<div class="banner warn">Bitte eine gültige E-Mail-Adresse.</div>'; return; }
      if(!tel){ box.innerHTML='<div class="banner warn">Bitte eine Telefonnummer für Rückfragen.</div>'; return; }
      A.email=mail; speichereStand(); go.disabled=true;
      track('waitlist_signup',{});
      const ok=await submitLead('waitlist_signup',{tel:tel,grund:'hybrid_zwei_heizkreise'});
      go.disabled=ok;
      box.innerHTML = ok ? '<div class="banner ok">Du stehst drauf. Wir melden uns.</div>'
                         : '<div class="banner warn">Hat gerade nicht geklappt, bitte später nochmal versuchen.</div>';
    };
    return;
  }
  track("addtocart_open",{kit:kitKey});
  document.getElementById('cartModal').classList.remove('hidden');
  scrollSperren('kauf');
  __kaufGeschwisterSperren();
  __kaufFokusHinein();
  /* direkt=true kommt aus der Pfad-Weiche auf der Startseite. Dort hat der Kunde "Direkt
     bestellen" schon gewaehlt - ihn danach noch einmal zwischen "Erst rechnen" und "Direkt
     bestellen" waehlen zu lassen, fragt dieselbe Sache zweimal. Von den Kit-Kacheln auf
     /pages/produkt aus bleibt die Zwischenfrage sinnvoll: dort ist noch kein Weg gewaehlt. */
  if(direkt) renderCartModalIncluded(kitKey);
  else renderCartModalChoice(kitKey);
}
function closeCartModal(){
  document.getElementById('cartModal').classList.add('hidden');
  scrollFreigeben('kauf');
  /* FOKUS ZURUECK (02.09.2026). Ohne das bleibt der Tastaturfokus auf einem Element, das
     gerade unsichtbar geworden ist; der naechste Tab-Druck springt an den Seitenanfang.
     Wer mit Tastatur oder Screenreader kauft, verliert damit seine Stelle. */
  __kaufGeschwisterFreigeben();
  if(__kaufOeffner && __kaufOeffner.isConnected){ try{ __kaufOeffner.focus(); }catch(e){} }
  __kaufOeffner=null;
  if(splitSource==='modal') exitSplitView();
  /* Erst sichern, dann vergessen: direktStand() liest directCand, und gleich steht dort null.
     Ohne das waere die Zusammenstellung genau beim Schliessen weg - also in dem Moment, in dem
     der Kunde am ehesten nur kurz woanders nachschauen will. Der verzoegerte Schreibvorgang
     aus merkeKauf() wird abgeraeumt, sonst ueberschriebe er das gleich wieder mit null. */
  clearTimeout(__kaufSpeicherTimer);
  speichereStand();
  directCand=null; syncSticky();
}
/* Abgesichert am 14.09.2026. Ungeschuetzt riss diese Zeile die GANZE Datei mit, sobald eine
   Seite kein #cartModal hat - alles danach wurde nie definiert. Genau dieses Muster hat auf
   der Produktseite schon einmal zugeschlagen, dort mit window.__BWP_IMG_URLS. Ein fehlendes
   Element ist kein Grund, den Konfigurator einer ganzen Seite abzuschalten. */
const __cartModalEl=document.getElementById('cartModal');
if(__cartModalEl) __cartModalEl.addEventListener('click',e=>{ if(e.target.id==='cartModal') closeCartModal(); });
/* ESCAPE NUR BEI OFFENEM DIALOG (02.09.2026)
   Vorher lief das hier bei JEDEM Escape-Druck irgendwo auf der Seite, ohne zu pruefen, ob
   der Kauf-Dialog ueberhaupt offen ist. closeCartModal() ist aber nicht folgenlos: es gibt
   die Scroll-Sperre frei (die dann womoeglich einem anderen Overlay gehoerte), schreibt
   ueber speichereStand() in den Speicher und setzt vor allem directCand=null.
   Damit war die gemerkte Express-Zusammenstellung nach einem beliebigen Escape weg - und
   zwar dauerhaft, weil der Verlust im selben Zug gespeichert wurde. Wer im Direktkauf ein
   Kit zusammengestellt und dann irgendwo Escape gedrueckt hat, fing von vorn an, ohne dass
   auf dem Bildschirm etwas passiert waere. */
document.addEventListener('keydown',e=>{
  if(e.key!=='Escape') return;
  const m=document.getElementById('cartModal');
  if(m && !m.classList.contains('hidden')) closeCartModal();
});

function renderCartModalChoice(kitKey){
  const p=PRODUCTS[kitKey];
  /* Die Auswahlseite hat keine zwei Schritte - Tabs waeren hier eine Behauptung ueber einen
     Fortschritt, den es noch gar nicht gibt. wireKaufTabs() schaltet sie wieder ein, sobald
     der Kaufkoerper steht. */
  const tabs=document.getElementById('kaufTabs'); if(tabs) tabs.hidden=true;
  const kt=document.getElementById('kaufKopfTitel'); if(kt) kt.textContent=p?p.name:'Dein Kit zusammenstellen';
  document.getElementById('cartModalBody').innerHTML=`
    <div class="v-eyebrow" style="color:var(--gruen)">${esc(p.name)} · ${eur(p.price)}</div>
    <h2 style="font-size:clamp(21px,3vw,26px);margin-top:8px;font-weight:800;letter-spacing:-.01em">Erst rechnen oder direkt bestellen?</h2>
    <p style="color:var(--graphit);margin-top:10px;max-width:46ch;font-size:15px">Der Rechner prüft in 2 Minuten, ob das ${esc(p.name)} zu deinem Haus passt, mit belegter Heizlast und Förder-Schätzung. Du kannst dein Kit aber auch direkt bestellen.</p>
    <div class="options" style="margin-top:22px">
      <button class="opt" id="cmFunnel"><span class="oi">${ICONS.frage}</span><span>2 Minuten durchrechnen<small>Empfohlen: sichere Auslegung + Förderung</small></span></button>
      <button class="opt" id="cmDirect"><span class="oi">${ICONS.wp}</span><span>Ich weiß es schon<small>${esc(p.name)} direkt bestellen</small></span></button>
    </div>`;
  document.getElementById('cmFunnel').onclick=()=>{ track("addtocart_choice",{kit:kitKey,choice:'funnel'}); closeCartModal(); startFunnel(); };
  document.getElementById('cmDirect').onclick=()=>{ track("addtocart_choice",{kit:kitKey,choice:'direct'}); renderCartModalIncluded(kitKey); };
}

/* ============ TAB-LEISTE DER VOLLBILD-KAUFFAECHE (02.09.2026) ============
   Die Tabs bauen KEINE eigene Umschaltlogik. Sie klicken die vorhandenen Schritt-Knoepfe
   #cmToService / #cmToHardware an - dieselbe Mechanik, die der Mini-Wizard schon hatte,
   nur sichtbar und in beide Richtungen anspringbar statt nur vorwaerts. Damit bleibt der
   Cross-Slide, das Nachladen der Erklaertour und syncSticky() unveraendert; es gibt keine
   zweite Wahrheit darueber, welcher Schritt gerade offen ist.

   Der aktive Zustand wird NICHT mitgezaehlt, sondern am DOM abgelesen: welcher .bb-step
   nicht "hidden" traegt, ist offen. Ein Zaehler wuerde beim ersten Weg, der an den Tabs
   vorbei umschaltet (Sticky-CTA, "Weiter zu Services"), auseinanderlaufen. */
function wireKaufTabs(kitKey){
  const leiste=document.getElementById('kaufTabs');
  const titel=document.getElementById('kaufKopfTitel');
  const koerper=document.getElementById('cartModalBody');
  if(!leiste||!koerper) return;
  const p=PRODUCTS[kitKey];
  if(titel && p) titel.textContent=p.name+' zusammenstellen';
  /* Erst zeigen, wenn es wirklich zwei Schritte gibt - die Auswahlseite davor hat keine. */
  const hat=!!koerper.querySelector('.bb-step[data-step="service"]');
  leiste.hidden=!hat;
  if(!hat) return;
  const stand=()=>{
    const sv=koerper.querySelector('.bb-step[data-step="service"]');
    return (sv && !sv.classList.contains('hidden')) ? 'service' : 'hardware';
  };
  /* Die Pfeile gibt es nur im Kasten auf der Produktseite. Sie klicken dieselben
     Schrittknoepfe an wie die Reiter - ein Weg durch den Ablauf, zwei Bedienelemente. */
  const pfeile=document.getElementById('kaufPfeile');
  const pZur=document.getElementById('kaufPfeilZurueck');
  const pWei=document.getElementById('kaufPfeilWeiter');
  if(pfeile) pfeile.hidden=false;
  const male=()=>{
    const jetzt=stand();
    leiste.querySelectorAll('.kauftab').forEach(t=>{
      const an=t.dataset.tab===jetzt;
      t.classList.toggle('an',an);
      t.setAttribute('aria-selected',String(an));
    });
    /* Abgeblendet statt ausgeblendet: Ein Pfeil, der beim Schrittwechsel verschwindet,
       laesst den anderen springen - und man klickt daneben. */
    if(pZur) pZur.disabled = jetzt==='hardware';
    if(pWei) pWei.disabled = jetzt==='service';
  };
  if(pZur) pZur.onclick=()=>{
    const k=document.getElementById('cmToHardware'); if(k) k.click(); setTimeout(male,260);
  };
  if(pWei) pWei.onclick=()=>{
    const k=document.getElementById('cmToService'); if(k) k.click(); setTimeout(male,260);
  };
  leiste.querySelectorAll('.kauftab').forEach(t=>{
    t.onclick=()=>{
      if(t.dataset.tab===stand()) return;
      const knopf=document.getElementById(t.dataset.tab==='service'?'cmToService':'cmToHardware');
      if(knopf) knopf.click();
      /* Der Wechsel laeuft ueber einen 220-ms-Cross-Slide; danach neu ablesen. */
      setTimeout(male,260);
    };
  });
  /* Auch Umschaltungen, die NICHT von den Tabs kommen, muessen die Leiste nachziehen -
     etwa der Sticky-CTA oder "Weiter zu Services" im Inhalt. Ein Beobachter auf den
     Klassenwechsel ist dafuer verlaesslicher als ein Haken an jedem einzelnen Ausloeser. */
  /* Vor/Zurueck-Pillen. Sie bedienen dieselben Knoepfe wie die Tabs; am ersten Schritt
     fuehrt "Zurueck" aus dem Kauf heraus statt ins Leere. */
  const nav=document.getElementById('kaufNav');
  const zur=document.getElementById('kaufZurueck');
  const wei=document.getElementById('kaufWeiter');
  if(nav){
    nav.hidden=false;
    if(zur) zur.onclick=()=>{
      if(stand()==='service'){ const k=document.getElementById('cmToHardware'); if(k) k.click(); setTimeout(male,260); }
      else { track('kauf_nav',{ziel:'startseite'}); closeCartModal(); }
    };
    if(wei) wei.onclick=()=>{
      if(stand()==='hardware'){ const k=document.getElementById('cmToService'); if(k) k.click(); setTimeout(male,260); }
    };
  }
  const malePlus=()=>{
    male();
    const jetzt=stand();
    if(zur) zur.textContent = jetzt==='service' ? '← Bauteile' : '← Startseite';
    if(wei) wei.hidden = (jetzt==='service');
  };
  if(leiste.__beobachter) leiste.__beobachter.disconnect();
  leiste.__beobachter=new MutationObserver(malePlus);
  koerper.querySelectorAll('.bb-step').forEach(el=>leiste.__beobachter.observe(el,{attributes:true,attributeFilter:['class']}));
  malePlus();
}
/* HIER STANDEN VERZOEGERUNG UND TIMER FUER DAS HEIZKOSTEN-FENSTER (12.10.2026, am selben Tag
   wieder entfallen: "der Heizkostenrechner-Pop-up soll nicht mehr aufpoppen"). Der Knopf
   oeffnet jetzt den grossen Warenkorb - ein zweites Fenster darueber waere genau das, was die
   Verzoegerung verhindern sollte. Entfernt statt auf 0 gesetzt: Ein Timer, der nichts mehr
   oeffnet, waere beim naechsten Mal eine Frage ohne Antwort. */
function renderCartModalIncluded(kitKey){
  const p=PRODUCTS[kitKey];
  /* syncSticky() erst nach wireStepNav('cm') - gleiche Falle wie in renderBuyBox: hier steht
     der Kaufkoerper des Dialogs noch nicht im DOM. */
  directCand=kitKey;
  /* Hat der Kunde diesen Express-Kauf schon einmal zusammengestellt und ist zwischendurch nur
     auf eine andere Seite gegangen, kommt seine Auswahl zurueck statt auf Werk zurueckzufallen.
     BEWUSST NICHT beim Seitenaufbau: ein Dialog, der sich von selbst oeffnet, waere uebergriffig.
     Der Zustand wartet, bis der Kunde denselben Weg von sich aus wieder betritt.
     Nur Schluessel, die es heute noch gibt - Preise rechnet cmUpdateTotal ohnehin frisch. */
  /* NUR EINMAL JE KIT (Fehlerbehebung 15.09.2026). Dieser Block richtet den Ausgangszustand
     ein - und er lief bei JEDEM Aufbau der Flaeche. Die Flaeche wird aber auch neu gebaut,
     sobald eine der beiden Fragen beantwortet wird (die Filter darin lesen die Antwort). Damit
     wurde genau das wieder eingerissen, was die Antwort gerade gesetzt hatte:

       - chosenExtras={} und Wiederherstellen aus einem Stand, der beim Seitenaufbau gelesen
         wurde und die frischen Haken nicht kennt - die Vorauswahl war sofort wieder weg;
       - directServices=new Set() bei jedem Aufbau - zusaetzlich gebuchte Services fielen
         beim naechsten Antworten aus dem Warenkorb.

     Gemerkt wird jetzt, fuer welches Kit eingerichtet wurde. Weitere Aufbauten zeichnen nur
     noch, was im Zustand steht. Dasselbe Muster wie buyboxPreselectedFor im Rechner-Kaufweg. */
  const zurueck = standDirekt && standDirekt.kit===kitKey;
  /* WAS SCHON IM WARENKORB LIEGT, BLEIBT LIEGEN (Vorgabe 16.09.2026).

     Wer auf einer Produktseite alles zusammengestellt hat und sich dann ein anderes Kit
     ansieht, kam bisher auf einen geraeumten Tisch: Der Aufbau fuer das NEUE Kit setzte
     directServices frisch auf, und die Vorauswahl griff wieder von vorn. Von Hand
     Hinzugefuegtes und von Hand Abgewaehltes war weg - beim blossen Umschauen.

     Die Erst-Einrichtung laeuft deshalb nur noch, wenn wirklich noch nichts gewaehlt ist.
     Danach wechselt nur das Kit; Material und Services bleiben, wie der Kunde sie hat.

     Der Zweig fuer den gespeicherten Stand (zurueck) bleibt davor: Kommt jemand nach einer
     Pause zu SEINEM Kit zurueck, ist dessen Stand die genauere Auskunft. */
  const schonGewaehlt = directServices.size>0
    || Object.keys(chosenExtras).some(k=>chosenExtras[k]>0);
  if(cmAufgebautFuer!==kitKey){
    if(zurueck){
      directServices=new Set();
      /* buyable!==false: siehe stelleKaufWiederHer(). */
      (standDirekt.services||[]).forEach(k=>{ if(SERVICES[k] && SERVICES[k].buyable!==false) directServices.add(k); });
      chosenExtras={};
      Object.entries(standDirekt.extras||{}).forEach(([k,v])=>{ if(EXTRAS[k]&&v) chosenExtras[k]=v; });
    } else if(!schonGewaehlt){
      directServices=new Set();
      FOERDER_CRITICAL.forEach(k=>{ if(SERVICES[k] && (!SERVICES[k].only||SERVICES[k].only(A))) directServices.add(k); });
      wendeVorauswahlAn();
      /* ANTWORTEN AUS DEM RECHNER GELTEN AUCH HIER (Vorgabe 16.09.2026). Wer den Fragebogen
         durchlaufen hat, hat "Wo soll die Aussseneinheit stehen?" und "Womit wird geheizt?"
         laengst beantwortet - die beiden Fragen im Kasten stehen dann schon zugeklappt da.
         Die zugehoerigen Pakete fehlten trotzdem: Ausgewaehlt wurden sie bisher nur beim
         KLICK auf einen der Chips, und den gab es ja nicht mehr. Der Kunde sah eine
         beantwortete Frage und eine leere Liste darunter.

         Dieselben Tabellen wie beim Klick - eine Zuordnung, nicht zwei.

         NUR BEIM ERSTEN AUFBAU je Kit (dieser Zweig laeuft genau einmal): Wer danach etwas
         abwaehlt, soll es nicht beim naechsten Neuzeichnen zurueckbekommen. Und ohne
         Antworten passiert nichts - dann stehen die Fragen offen da und nichts ist
         angehakt, so wie es sein soll. */
      autowahlAnwenden(AUTOWAHL_AUFSTELLORT, A.aufstellort);
      autowahlAnwenden(AUTOWAHL_HEIZART, heizartSchluessel());
      systemtrennungAnwenden();
      pumpenMengenAnwenden();
    }
    cmAufgebautFuer=kitKey;
  }
  const luEff=effektiverLU();
  const lu=luEff.list.map(([q,n],i)=>{
    const sku=luEff.details[i]&&luEff.details[i].sku;
    /* Kein ⓘ mehr (Vorgabe 14.09.2026, "überall die i weg"). Die Variable bleibt, damit die
       Zeile darunter unveraendert bleibt - sie ist jetzt immer leer. */
    const btn='';
    return `<div class="lu-pop" style="animation-delay:${i*40}ms;display:flex;justify-content:space-between;align-items:center;gap:8px"><span><span class="m">${q}</span>${esc(n)}</span>${btn}</div>`;
  }).join('');
  const svcEntries=Object.entries(SERVICES).filter(([k,s])=>(!s.only||s.only(A)) && s.buyable!==false && !SERVICE_INKLUSIVE[k]);
  /* Gruppiert statt einer langen Reihe (Vorgabe 15.09.2026). Leere Gruppen fallen weg - die
     Oeltank-Entsorgung etwa erscheint nur bei einer Oelheizung, und eine Ueberschrift ohne
     Zeilen darunter waere ein Versprechen auf nichts. Seit dem 02.10.2026 zaehlt dafuer auch
     die Oeltank-Sammelzeile mit: Sie ist die einzige Zeile ihrer Gruppe, die nicht aus
     svcEntries entsteht, und ohne diese Mitzaehlung faellt eine Gruppe weg, in der etwas steht. */
  let svcNr=0;
  const svcZeile=([k,s])=>{
    /* Die Pille mit "Pflicht"/"Optional" ist am 15.09.2026 entfallen (Vorgabe). Sie sagte
       seit der Gruppierung dasselbe wie die Ueberschrift zwei Zeilen darueber - und zwei
       Stellen, die dieselbe Einordnung behaupten, koennen nur auseinanderlaufen.
       "Empfohlen" bleibt: Das ist eine Aussage ueber DIESEN Fall, keine Einordnung. */
    const flash = FOERDER_CRITICAL.includes(k) && directServices.has(k) ? ' svc-preselect-flash' : '';
    return `
    <div class="svc-row${flash}" style="animation-delay:${(luEff.list.length+(svcNr++))*40}ms">
      <div class="svcline">
        <label class="svcchoice">
          <input type="checkbox" data-k="${k}"${directServices.has(k)?' checked':''}>
          <span>${esc(s.name)}${s.rec(A)?'<span class="tag gruen">Empfohlen</span>':''}</span>
          <span class="price m">${zeilenPreis(s.price, directServices.has(k), s.preisZusatz)}</span>
        </label>
        ${svcFensterKnopfHtml(k)}
      </div>
    </div>`;};
  const svcRows=SERVICE_GRUPPEN.map(([g,titel])=>{
    const alleDrin=svcEntries.filter(([k])=>serviceGruppe(k)===g);
    /* Dieselbe Zusammenfassung wie in der Kaufbox: die vier Oeltank-Varianten verlassen die
       Reihe und kommen als EINE Zeile mit Auswahlfeld ans Ende ihrer Gruppe zurueck. */
    const drin=alleDrin.filter(([k])=>!istOelKey(k));
    const oelDrin=alleDrin.length!==drin.length;
    /* Die Saetze der inklusiven Leistungen dieser Gruppe - sie stehen unter der Ueberschrift
       und ersetzen die Zeile zum Anklicken. */
    const satz=Object.keys(SERVICE_INKLUSIVE).filter(k=>serviceGruppe(k)===g)
      .map(k=>`<p class="svc-inklusive">${esc(SERVICE_INKLUSIVE[k])}</p>`).join('');
    /* Eine Gruppe, die nur noch aus dem Satz besteht, bleibt stehen - sonst faellt mit der
       letzten anklickbaren Zeile auch die Aussage weg. */
    if(!drin.length && !oelDrin && !satz) return '';
    return `<div class="svc-group-label">${esc(titel)}</div>`+satz+drin.map(svcZeile).join('')
      +(oelDrin?oelZeileHtml(directServices,'modal',luEff.list.length+(svcNr++)):'');
  }).join('');
  const spKey=speicher();
  document.getElementById('cartModalBody').innerHTML=`
    <button class="btn quiet" id="cmBack" style="margin-bottom:2px;padding-left:0">← Zurück</button>
    <div class="cm-kitkopf">
      <img src="${IMG[kitKey]}" alt="${esc(p.name)}" style="width:64px;height:64px;object-fit:contain;background:var(--paper);border-radius:10px;padding:6px;flex:0 0 auto">
      ${/* Modellzeile wie im Rechner-Pfad (kwline). Ohne sie war der Direktkauf der einzige
            Weg, auf dem der Kunde bis zur Kasse nie erfaehrt, von welchem Hersteller die
            Wärmepumpe kommt - Fox ESS bei den DIY-Kits, MHG bei der Beistell-WP. */''}
      <div><div class="v-eyebrow" style="color:var(--bernstein-dark)">Dein Kit</div><h2 style="font-size:21px;font-weight:800">${esc(p.name)}</h2><div class="kd-model" style="margin-top:3px">${esc(p.sub)}</div></div>
    </div>
    ${/* Dimensions-Hinweis BEWUSST hier, ueber der Mini-Summe und damit ausserhalb der
          beiden .bb-step-Bloecke: so steht er in Schritt 1 (Hardware) UND in Schritt 2
          (Services), ohne dass er zweimal im Markup liegt und beim Umschalten flackert.
          Betreiber-Wunsch 08.09.2026: die Warnung gehoert in den Checkout, nicht nur in
          die Kit-Auswahl - dort faellt die Entscheidung, und dort wird gezahlt.
          Kein hartGezeigt: im Kauf-Dialog gibt es den blockierenden Riegel nicht, hier ist
          dieser Hinweis die einzige Stelle, die etwas zur Dimensionierung sagt. */''}
    ${dimensionsHinweisHtml(kitKey)}
    <div class="bb-minisum" style="margin-top:18px"><span class="bb-ms-links"><button type="button" class="bb-zurueck" id="cmToHardware" hidden>← Bauteile</button><span id="cmMiniStepLabel">Schritt 1/2 · Bauteile</span></span><span class="sum" id="cmMiniSum"></span></div>
    <div class="bb-step" data-step="hardware">
      ${/* Symbol und die fette Zeile "Warmwasserspeicher" sind am 14.09.2026 entfallen: Seit
            die Gruppe darueber denselben Namen traegt, stand er zweimal untereinander. Die
            Gruppenzeile bleibt, sie ordnet sich in die drei anderen Gruppen ein. */''}
      ${/* AUFKLAPPER WIE DIE VIER GRUPPEN DARUNTER (Vorgabe 21.09.2026). Der Speicher ist
            keine Material-Gruppe aus EXTRAS - seine Auswahl haengt an der Funnel-Antwort und
            nicht an chosenExtras -, sieht hier aber wie eine aus und steht seit dem
            21.09.2026 an ihrer Spitze. Deshalb dasselbe Geruest von Hand: details.mini.xgrp,
            summary mit Name, ⓘ und Zahl rechts, Koerper in .xgrp-body.
            Die Zahl rechts fuellt gruppenZaehlerAktualisieren() aus A.speicherChoice; der
            Preis in der Zeile bleibt, er steht beim Chip, der ihn ausloest. */''}
      <details class="mini xgrp" id="cmSpeicherBlock" data-g="Warmwasserspeicher">
        <summary><span class="svc-group-label">Warmwasserspeicher</span>${gruppenInfoHtml('Warmwasserspeicher')}<span class="xgrp-n m"></span><span class="xgrp-chev" aria-hidden="true">▾</span></summary>
        <div class="xgrp-body"><div class="buyline" style="margin-top:0"><span class="spchips" id="cmSpChips"></span><span class="svc-right"><span class="price" id="cmSpPrice"></span></span></div></div>
      </details>
      <div class="cm-lu" style="margin-top:22px">
        <div style="font-weight:800;font-size:14.5px">Was drin ist <span style="color:var(--muted);font-weight:500">· <span id="cmLuCount">${luEff.list.length}</span> Positionen</span></div>
        <div class="lu-grid" id="cmLuGrid" style="grid-template-columns:1fr 1fr;gap:2px 24px;margin-top:10px">${lu}</div>
      </div>
      ${/* Die beiden Fragen stehen nicht mehr hier, sondern in ihrer Gruppe: die nach dem
            Aufstellort bei der Hauseinfuehrung, die nach der Heizart bei den Pumpengruppen
            (Vorgabe 14.09.2026). Eingesetzt werden sie unten beim Aufbau der Gruppen. */''}
      <div class="svc-block">
        <div id="cmExtraList"></div>
      </div>
      ${/* "Baust du etwas zusätzlich selbst?" ist am 15.09.2026 entfallen (Vorgabe) - siehe
            die Regel dazu im Stylesheet. Markup und Kennungen bleiben stehen: cmUpdateTotal
            liest #cmEigenList fuer die Foerderbasis, und der Rundgang sucht #cmEigenBlock. */''}
      <div class="svc-block" id="cmEigenBlock">
        <details class="mini" id="cmEigenDetails">
          <summary>Baust du etwas zusätzlich selbst? Zählt zur Förderung</summary>
          <div class="sd-group sd-group--other">
            <div class="svc-group-label muted">Material dafür ist förderfähig, auch wenn du es nicht bei uns kaufst</div>
            <div id="cmEigenList"></div>
          </div>
        </details>
      </div>
      ${selbstBesorgenHtml()}
      <div style="margin-top:22px">
        <div style="font-weight:800;font-size:14.5px;margin-bottom:8px">Lieferung</div>
        <p class="lief-betrag" id="cmLieferZeile">Deutschlandweit zu dir nach Hause – <b>${esc(lieferPreisText())}</b>.</p>
        <p class="lief-hinweis">${esc(LIEFER_HINWEIS)}</p>
        ${startWunschHtml('cmStartWunsch')}
      </div>
      <button class="btn" id="cmToService" type="button" style="margin-top:18px">Weiter zu Services →</button>
    </div>
    <div class="bb-step hidden" data-step="service">
      
      <div class="svc-block">
        ${/* "Dazubuchen?" ist am 15.09.2026 entfallen (Vorgabe). Seit die Liste in drei
              Gruppen steht, war die Frage der falsche Kopf darueber: Ueber "Pflicht fuer die
              Foerderung" und "Gesetzlich vorgeschrieben" zu schreiben, ob man sie DAZUBUCHEN
              moechte, stellt gerade die beiden Gruppen in Frage, die keine Wahl sind. Die
              Gruppenzeilen sagen jetzt selbst, worum es geht. */''}
        <div>${svcRows}</div>
        <div id="cmFoerderRiskBox" style="margin-top:8px"></div>
      </div>
      <!-- AUFSCHLUESSELUNG STATT EINER ZAHL (02.09.2026)
             Die Foerder-Pflichtservices sind vorausgewaehlt. Damit stand schon auf dem
             Hardware-Schritt eine Summe da, in der Leistungen steckten, die der Kunde noch gar
             nicht gesehen hatte - er konnte sich die Zahl nicht erklaeren und hielt sie fuer den
             Hardwarepreis. Jetzt steht darueber, woraus sie sich zusammensetzt. -->
        <div class="totalrow sub"><span>Dein Paket gesamt</span><span class="sum m" id="cmTotal"></span></div>${RABATT_CODES.length?`
        <!-- AUFSCHLUESSELUNG ALS AUFKLAPPER UNTER DER GESAMTSUMME (portiert 16.09.2026)
             ACHTUNG, DAS AENDERT EINEN FRUEHEREN ENTSCHEID. Am 02.09.2026 standen diese Zeilen
             ausdruecklich UEBER der Gesamtsumme, weil der Kunde sich die Zahl sonst nicht
             erklaeren konnte. Der Grund gilt weiter - fuer den HARDWARE-SCHRITT. Dort steht der
             Aufklapper deshalb OFFEN (gliederungAnzeigen), samt "Services waehlst du im
             naechsten Schritt". Zu klappt er nur in der fertigen Kaufbox, wo die Kette darunter
             die Aussage traegt: gesamt, minus Rabatt, minus Foerderung, dein Preis. Vier Zeilen
             ueber der Summe haetten diese Kette vorne abgeschnitten.
             Claras Wortlaut "Zubehoer" bleibt unangetastet. -->
        ${/* DER AUFKLAPPER "Woraus sich das zusammensetzt" IST AM 30.09.2026 ENTFALLEN
              (Vorgabe Claras: "entferne bei der Konfiguration in Services den Text und
              Aufklappbar 'woraus sich das zusammensetzt'").

              Hier standen unter der Gesamtsumme zwei Zeilen - Bauteile und Services - in einem
              zugeklappten details. Der Grund von 2026-09-02 war der Hardware-Schritt: Dort
              stand eine Summe, in der vorausgewaehlte Services steckten, die noch niemand
              gesehen hatte. Im SERVICES-Schritt gilt das nicht mehr - dort stehen die Services
              Zeile fuer Zeile darueber, jede mit ihrem Preis.

              Die Summen selbst sind nicht weg: gliederungAnzeigen() rechnet sie weiter und
              entscheidet daraus, was "Dein Paket gesamt" zeigt. Sie findet die Elemente jetzt
              nicht mehr und laesst sie aus - das ist abgesichert (el() gibt null zurueck). */''}
        <!-- RABATTCODE (portiert 16.09.2026). Steht zwischen Gesamtsumme und Foerderabzug,
             damit der Kunde die Kette in EINER Spalte liest: gesamt, minus Rabatt, minus
             Foerderung, Endpreis. Das Feld verschwindet, sobald der Code greift - die
             Abzugszeile darunter ist dann die Quittung.
             Nur gerendert, wenn ueberhaupt eine Aktion laeuft: ein Feld fuer einen Code, den
             es nicht gibt, erzeugt nur Fehlversuche. -->
        <div class="totalrow rabattfeld" id="cmRabattFeld"><span>Du hast einen Rabattcode?</span><span class="rabatt-eingabe"><input type="text" id="cmRabattCode" placeholder="XXXXX-XXXXX-XXXXX" autocomplete="off" spellcheck="false" aria-label="Rabattcode"><button type="button" class="rabatt-go" id="cmRabattGo">Einlösen</button></span></div>
        <div class="rabatt-hinweis" id="cmRabattHinweis"></div>
        <div class="totalrow abzug hidden" id="cmRabattLine"><span>Rabatt<small id="cmRabattPct"></small></span><span class="sum" id="cmRabattSum"></span></div>`:''}
      <!-- ABZUGSZEILE NACHGEZOGEN (02.09.2026)
           cmUpdateTotal() fragt #cmFoerderDeductLine und #cmFoerderDeductSum seit jeher ab,
           im Markup standen sie nie. Die Abfrage lief also ins Leere und der Direktkauf zeigte
           nur zwei Zahlen - Paketpreis und Preis nach Foerderung - ohne den Abzug dazwischen.
           Der Kunde musste die Differenz selbst ausrechnen. Genau dafuer wurde die Zeile in der
           Rechner-Kaufbox eingefuehrt (siehe Kommentar dort); der zweite Kaufweg hat sie nur
           nie bekommen. Beide Wege zeigen jetzt dieselbe Rechnung: gesamt, minus Foerderung,
           Endpreis. Das Minus traegt der Betrag, nicht das Wort. -->
      <div class="totalrow abzug hidden" id="cmFoerderDeductLine"><span>Förderung<small id="cmFoerderDeductPct"></small></span><span class="sum" id="cmFoerderDeductSum"></span></div>
      <div class="totalrow eff hidden" id="cmEffektivRow"><span class="eff-lbl"><span id="cmEffektivLabel">Dein Preis nach Förderung</span><small>voraussichtlich &ndash; du zahlst zuerst voll, die KfW erstattet danach</small></span><span class="sum" id="cmEffektivSum"></span></div>
      <!-- ZAHLUNGSPLAN (03.09.2026, Betreiber-Entscheid)
           Diese Zeilen gab es bis zum 11.08.2026 schon einmal und wurden beim Entschlacken
           entfernt. Der Wert lief seitdem nur noch unsichtbar als Positions-Eigenschaft
           "Restzahlung bei Erhalt" in die Bestellung - der Kunde sah vor dem Klick nicht, was
           nach der Lieferung noch auf ihn zukommt. Bei einem zweistufigen Kauf ist das die
           wichtigste Zahl ueberhaupt; sie gehoert vor den Knopf, nicht in die Bestelldaten. -->
      <div class="totalrow zplan" id="cmHeuteRow"><span>Heute fällig<small id="cmHeuteHint"></small></span><span class="sum" id="cmHeuteSum"></span></div>
      <div class="totalrow zplan" id="cmRestRow"><span>Nach Lieferung fällig<small>Restzahlung bei Lieferung</small></span><span class="sum" id="cmRestSum"></span></div>
      <p class="fineprint" style="text-align:right;margin:4px 0 0">Alle Preise inkl. MwSt.</p>
      <div id="cmDepositNote"></div>
            <button class="btn" id="cmAdd" style="margin-top:16px"></button>
      <div id="cmDemoBanner"></div>
    </div>`;
  document.getElementById('cmBack').onclick=()=>renderCartModalChoice(kitKey);
  /* Gilt fuer BEIDE Darstellungen dieser Funktion - Direktkauf-Dialog und Produktseite. */
  wireRabattFeld('cm', ()=>cmUpdateTotal(kitKey));
  rabattKopfZeigen();
  wireStepNav('cm');
  wireKaufTabs(kitKey);
  syncSticky();   /* erst jetzt - siehe Kommentar oben bei directCand */
  /* [data-k] ist seit dem 02.10.2026 Pflicht in dieser Auswahl: Die Oeltank-Sammelzeile traegt
     ebenfalls eine Checkbox in einem .svcchoice, aber keinen Service-Schluessel - sie waere hier
     als SERVICES[undefined] gelandet und haette den Dialog beim ersten Klick zerlegt. */
  document.querySelectorAll('#cartModalBody .svcchoice input[data-k]').forEach(inp=>{
    inp.addEventListener('change',e=>{
      const k=e.target.dataset.k;
      if(e.target.checked){
        const g=SERVICES[k].xgroup;
        if(g) document.querySelectorAll('#cartModalBody .svcchoice input').forEach(o=>{
          if(o!==e.target && SERVICES[o.dataset.k].xgroup===g && o.checked){ o.checked=false; directServices.delete(o.dataset.k); }
        });
        directServices.add(k);
        /* Fehlte im Direktkauf komplett - die Kaufbox meldete Zuwahl, dieser Weg nicht. */
        track('service_added',{service:k,path:'direct'});
        cmUpdateTotal(kitKey);
      } else if(FOERDER_CRITICAL.includes(k)){
        const info=SERVICE_FOERDER_INFO[k];
        guardedUncheck(e.target,e.target.closest('.svc-row'),SERVICES[k].name,info?info.warum:'',()=>{ directServices.delete(k); cmUpdateTotal(kitKey); },k);
      } else {
        directServices.delete(k);
        track('service_removed',{service:k,pflicht:false,path:'direct'});
        cmUpdateTotal(kitKey);
      }
    });
  });
  const cmOelRow=document.querySelector('#cartModalBody .oel-row');
  if(cmOelRow) oelZeileVerdrahten(cmOelRow, directServices, ()=>cmUpdateTotal(kitKey), 'direct');
  /* Speicher-Wahl im Direktkauf: hier gibt es (anders als im Rechner-Funnel) keine vorherige
     Warmwasser-Frage - daher explizite dritte Option "Kein Speicher" statt einer Vorauswahl.
     Setzt A.dhw/A.speicherChoice, damit die gemeinsame speicher()-Funktion konsistent bleibt. */
  const cmSpChips=document.getElementById('cmSpChips');
  if(cmSpChips){
    const cur=speicher();
    [['keiner','Kein Speicher'],['sp200','200 l'],['sp300','300 l']].forEach(([k,label])=>{
      const b=document.createElement('button'); b.type='button';
      const isSel=(k==='keiner'? !cur : cur===k);
      /* Dasselbe Aussehen wie im Rechner-Kaufweg, siehe dort. */
      b.className='af-chip'+(isSel?' sel':'');
      b.textContent=label;
      b.onclick=()=>{
        if(k==='keiner'){ A.dhw='nein'; } else { A.dhw='ja'; A.speicherChoice=k; }
        track("speicher_choice",{sp:k,path:'direct'});
        cmSpChips.querySelectorAll('.af-chip').forEach(x=>x.classList.remove('sel')); b.classList.add('sel');
        cmUpdateTotal(kitKey);
      };
      cmSpChips.appendChild(b);
    });
  }
  /* Dieselbe Form wie die Speicherwahl - siehe die Begruendung am Zwilling in renderBuyBox. */
  /* Auch im Direktkauf keine Wahl mehr - siehe den Vermerk in der Kaufbox. */
  startWunschVerdrahten('cmStartWunsch');
  const cmEigenList=document.getElementById('cmEigenList');
  if(cmEigenList && !cmEigenList.childElementCount){
    EIGENLEISTUNGEN.forEach(e=>{
      const row=document.createElement('div'); row.className='svc-row';
      row.innerHTML=`<div class="buyline"><span>${esc(e.name)}<span class="tag">extern gekauft</span></span><span class="svc-right"><span class="eigen-wrap"><input type="number" min="0" step="50" placeholder="0" inputmode="numeric"><span class="eigen-eur">€</span></span></span></div>`;
      row.dataset.k=e.k;
      row.querySelector('input').addEventListener('input',ev=>{
        const v=parseFloat(ev.target.value.replace(',','.'));
        eigenBetraege[e.k]=(v>0)?v:0;
        cmUpdateTotal(kitKey);
      });
      cmEigenList.appendChild(row);
    });
  }
  /* Material-Extras: identischer Aufbau wie im Rechner-Funnel (renderBuyBox), gruppiert nach
     CSV-Gruppe, geteilter chosenExtras-State - sonst waeren diese Teile im Direktkauf gar nicht
     mehr buchbar, seit sie aus dem kostenlosen Lieferumfang raus sind. */
  const cmExtraList=document.getElementById('cmExtraList');
  if(cmExtraList && !cmExtraList.childElementCount){
    const groups={};
    /* paketAusgeblendet(): siehe dort - die Antwort auf Aufstellort und Heizart blendet aus,
       was sie ausschliesst. Gefiltert wird beim AUFBAU der Liste, nicht per CSS: Eine
       versteckte Zeile mit Haken wuerde weiterhin in jeder Summe mitzaehlen. */
    Object.entries(EXTRAS).forEach(([k,e])=>{
      if(paketAusgeblendet(k)) return;
      (groups[e.group]=groups[e.group]||[]).push([k,e]);
    });
    Object.entries(groups).forEach(([gname,items])=>{
      /* JEDE GRUPPE IST EIN AUFKLAPPER UND STARTET ZU (Vorgabe 21.09.2026). Vorher lagen
         Ueberschrift, Frage und Zeilen flach hintereinander in cmExtraList - fuenf Gruppen
         ergaben eine Liste, durch die man erst einmal scrollen musste, bevor ueberhaupt zu
         sehen war, wie viele Entscheidungen anstehen. Zugeklappt sind es fuenf Zeilen.

         GEBAUT MIT <details>, nicht mit einem eigenen Auf-Zu-Schalter: Oeffnen und Schliessen
         erledigt der Browser, es geht mit der Tastatur und ohne JavaScript. Dieselbe Bauform
         wie bei den beantworteten Fragen darueber.

         DAS GERUEST IST NICHT NEU: details.mini.xgrp mit .xgrp-n rechts stammt vom
         12.08.2026 und steht seither in konfigurator.css - die Kaufbox im Rechner hat es
         benutzt, bis dort am 14.08.2026 alles auf "immer offen" gestellt wurde. Hier wird es
         wieder eingeschaltet, statt ein zweites Klapp-Idiom zu erfinden.

         DIE ZAHL RECHTS IM KOPF IST PFLICHT, kein Schmuck: Eine zugeklappte Gruppe darf keine
         Kaufentscheidung verstecken. "2 gewaehlt - 599 EUR" sagt im geschlossenen Zustand,
         dass drinnen etwas angehakt ist. Gefuellt wird sie von gruppenZaehlerAktualisieren().

         Der ⓘ-Knopf steht mit im Kopf und klappt NICHT mit auf: Sein Klick-Empfaenger ruft
         schon e.preventDefault(), und genau das haelt ein <summary> davon ab umzuschalten. */
      const det=document.createElement('details');
      det.className='mini xgrp';
      det.dataset.g=gname;
      const kopf=document.createElement('summary');
      /* DER PFEIL STEHT IM MARKUP, nicht als ::after im Stylesheet (Vorgabe 21.09.2026:
         "nicht mit einem Plus oeffnen, sondern mit dem dreieckigen Pfeil, den du auch wo
         anders schon verwendet hast"). Genau so macht es der Rest der Seite - .sd-chev in
         den Service-Gruppen, .xr-chev in den Rechenzeilen, .pinfo-chev im Produkt-Infokasten:
         ein span mit ▾, das sich beim Oeffnen dreht. aria-hidden, weil <details> seinen
         Zustand der Vorlesesoftware ohnehin meldet - das Zeichen waere eine zweite, stumpfe
         Ansage. */
      kopf.innerHTML=`<span class="svc-group-label">${esc(gname)}</span>${gruppenInfoHtml(gname)}<span class="xgrp-n m"></span><span class="xgrp-chev" aria-hidden="true">▾</span>`;
      det.appendChild(kopf);
      const lbl=document.createElement('div'); lbl.className='xgrp-body';
      det.appendChild(lbl);
      merkeGruppenZustand(det, gname);
      cmExtraList.appendChild(det);
      /* Die Frage steht IN ihrer Gruppe (Vorgabe 14.09.2026), nicht mehr ueber der ganzen
         Liste: Sie entscheidet ja genau darueber, was in dieser einen Gruppe angeboten wird -
         daneben ist ihre Wirkung zu sehen, darueber war sie eine Vorrede zu allem. */
      const frageHtmlStr = gname==='Hauseinführung' ? aufstellortChipsHtml(true)
                         : gname==='Pumpengruppen'  ? heizartChipsHtml(true) + kreiseChipsHtml(true) + fbhBaujahrChipsHtml(true)
                         : gname==='Hydraulischer Abgleich' ? mengenFragenHtml(true) : '';
      /* ALLE Kinder, nicht nur das erste - beim Abgleich sind es je nach Heizart bis zu drei
         Fragen (21.09.2026). Merker statt Element, weil unten nur noch zaehlt, OB die Gruppe
         eine Frage traegt. */
      let hatFrage=false;
      if(frageHtmlStr){
        const huelle=document.createElement('div'); huelle.innerHTML=frageHtmlStr;
        while(huelle.firstElementChild){ lbl.appendChild(huelle.firstElementChild); hatFrage=true; }
      }
      /* Derselbe Hinweis wie in der Kaufbox des Rechners - beide Ansichten muessen dasselbe
         zeigen. Er steht hinter den Fragen, also direkt unter der Antwort, auf die er sich
         bezieht. hatFrage traegt die Gruppe hier ohnehin. */
      if(gname==='Pumpengruppen'){
        const h=pumpenHinweisHtml();
        if(h){ lbl.insertAdjacentHTML('beforeend', h); hatFrage=true; }
      }
      /* Leere Gruppen unterdruecken - siehe gleiche Stelle in renderBuyBox (11.08.2026) */
      let sichtbar=0;
      items.forEach(([k,e])=>{
        const row=document.createElement('div');
        row.className='svc-row'+(k==='fundament'&&chosenExtras[k]?' svc-preselect-flash':'');
        /* SORTIMENTSFILTER AUS renderBuyBox NACHGEZOGEN (02.09.2026)
           Diese zwei Bedingungen standen nur im Rechner-Kaufweg. Wer aus dem Funnel kam und
           dann den Direktkauf oeffnete, sah dort ploetzlich Bauteile, die der Rechner ihm
           gerade ausgeblendet hatte - bei unklarem Aufstellort beide Hauseinfuehrungs-
           Varianten zur Auswahl, obwohl keine davon entscheidbar ist, und die Erdleitung
           auch dann, wenn die Einheit direkt an der Hauswand steht.
           Beide greifen NUR bei ausdruecklich gegebener Antwort. Im reinen Direktkauf ist
           A.aufstellort null (nie gefragt), dann bleibt alles sichtbar - das ist richtig so,
           dort trifft der Kunde die Wahl selbst. Wortlaut und Begruendung stehen ausfuehrlich
           an der Zwillingsstelle in renderBuyBox; wer hier etwas aendert, muss dort mit. */
        /* Gleiche Sichtbarkeitsregel wie in der Kaufbox - siehe dort. Beide Ansichten muessen
           dasselbe zeigen, sonst steht im Direktkauf-Modal etwas anderes zur Wahl. */
        if(e.only && !e.only(A)) return;
        if(e.perMeter||e.perUnit){
          const q0=chosenExtras[k]||0;
          const unitShort=e.perMeter?'m':'Stk.';
          const maxQ=e.max||50;
          row.innerHTML=`<div class="buyline xrow hat-menge"><label class="xr-check"><input type="checkbox" data-x="${k}"${q0>0?' checked':''}><span class="xr-name">${esc(e.name)}</span></label><span class="xr-tag"></span><span class="xr-step"><span class="qtystep"><button type="button" data-d="-1" aria-label="Weniger">−</button><span class="qv m">${q0} ${unitShort}</span><button type="button" data-d="1" aria-label="Mehr">+</button></span></span><span class="xr-price price extra-price m">${mengenPreisHtml(q0,e)}</span>${paketInfoHtml(e)}${paketSeiteHtml(e)}</div>`;
          const qv=row.querySelector('.qv'), pr=row.querySelector('.extra-price');
          /* Der Haken links gehoert seit dem 02.09.2026 auch zu den Mengen-Zeilen: vorher hatten
             nur die Ja/Nein-Positionen einen, die Liste sprang dadurch von Zeile zu Zeile.
             Haken und Regler zeigen denselben Zustand - angehakt heisst Menge >= 1, abgehakt
             heisst 0. Er wird bei jedem set() mitgezogen, damit beide nie auseinanderlaufen. */
          const cb=row.querySelector('input[type=checkbox][data-x]');
          const set=q=>{
            q=Math.max(0,Math.min(maxQ,q));
            if(q>0){ chosenExtras[k]=q; } else delete chosenExtras[k];
            qv.textContent=q+' '+unitShort; pr.innerHTML=mengenPreisHtml(q,e);
            if(cb) cb.checked = q>0;
            mengenFrageNachziehen(k, q);
            cmUpdateTotal(kitKey);
          };
          /* RICHTUNG (27.08.2026): der Regler meldete bisher auch beim Verringern 'extra_added'.
             Damit war jede Auswertung von Zu- und Abwahl von vornherein unbrauchbar. */
          if(cb) cb.addEventListener('change',()=>{
            const vorher=chosenExtras[k]||0;
            set(cb.checked ? Math.max(1,vorher) : 0);
            const nachher=chosenExtras[k]||0;
            if(nachher>vorher) track('extra_added',{extra:k,qty:nachher,via:'haken'});
            else if(nachher<vorher) track('extra_removed',{extra:k,qty:nachher,ganz_weg:nachher===0,via:'haken'});
          });
          row.querySelectorAll('button[data-d]').forEach(b=>b.addEventListener('click',()=>{
            const vorher=chosenExtras[k]||0;
            set(vorher+parseInt(b.dataset.d,10));
            const nachher=chosenExtras[k]||0;
            if(nachher>vorher) track('extra_added',{extra:k,qty:nachher,path:'direct'});
            else if(nachher<vorher) track('extra_removed',{extra:k,qty:nachher,ganz_weg:nachher===0,path:'direct'});
          }));
        } else {
          row.innerHTML=`<div class="buyline xrow"><label class="xr-check"><input type="checkbox" data-x="${k}"${chosenExtras[k]?' checked':''}><span class="xr-name">${esc(e.name)}</span></label><span class="xr-tag"></span><span class="xr-step"></span><span class="xr-price price">${zeilenPreis(e.price, !!chosenExtras[k])}</span>${paketInfoHtml(e)}${paketSeiteHtml(e)}</div>`;
          row.querySelector('input').addEventListener('change',ev=>{
            if(ev.target.checked){
              if(xgroupSperrt(e.xgroup)) Object.entries(EXTRAS).forEach(([o,oe])=>{
                if(o!==k && oe.xgroup===e.xgroup && chosenExtras[o]){
                  delete chosenExtras[o];
                  const oi=cmExtraList.querySelector(`input[data-x="${o}"]`); if(oi) oi.checked=false;
                }
              });
              /* Dieselbe Bewegung fuer die Tabelle SCHLIESST_AUS - Haken weg UND Zustand weg,
                 sonst bliebe eine abgehakte Zeile in der Summe stehen. */
              raeumeAusgeschlossene(k, o=>{
                const oi=cmExtraList.querySelector(`input[data-x="${o}"]`); if(oi) oi.checked=false;
              });
              chosenExtras[k]=1; track('extra_added',{extra:k,path:'direct'});
              if(k==='fundament') A.fundament='fertig';
              cmUpdateTotal(kitKey);
            } else if(k==='fundament'){
              guardedUncheck(ev.target,row,e.name,'Ohne Fertigfundament baust du das Fundament selbst (zählt als Eigenleistung).',()=>{ delete chosenExtras.fundament; A.fundament='selbst'; cmUpdateTotal(kitKey); },'fundament');
            } else {
              delete chosenExtras[k];
              track('extra_removed',{extra:k,qty:0,ganz_weg:true,path:'direct'});
              cmUpdateTotal(kitKey);
            }
          });
        }
        lbl.appendChild(row);
        sichtbar++;
      });
      /* Eine Gruppe MIT Frage bleibt stehen, auch wenn sie gerade nichts anbietet: Genau die
         Frage darin ist der Weg, ueber den etwas erscheint. Ohne diese Ausnahme waeren die
         Pumpengruppen vor der Antwort samt ihrer Frage verschwunden - und niemand haette
         gesehen, dass es sie gibt. */
      if(!sichtbar && !hatFrage) det.remove();
    });
    /* DER WARMWASSERSPEICHER STEHT ZWISCHEN PUMPENGRUPPEN UND HYDRAULISCHEM ABGLEICH
       (28.10.2026, Vorgabe Claras: "den Warmwasserspeicher-Kasten mit allem, was drin ist,
       hinter den Pumpengruppen-Kasten schieben, also dann zwischen Pumpengruppen-Kasten und
       hydraulischer-Abgleich-Kasten"). Das ist die dritte Fassung: 14.09.2026 genau hier,
       21.09.2026 ganz oben, jetzt wieder hier.

       Sein Markup steht weiter oben im Schritt und wird hierher gezogen, statt es zu
       verdoppeln; deshalb braucht es diese Zeile ueberhaupt. Ohne sie staende er ausserhalb
       der Liste - mit anderem Abstand und ohne die Gruppenrhythmik der Bloecke drumherum.

       ZWEI ANKER UND EIN RUECKFALL, weil die Liste nicht fest ist: Die Schleife darueber
       entfernt jeden Gruppenblock, in dem nichts sichtbar ist (det.remove()). Mal fehlt also
       der Abgleich, mal die Pumpengruppen. Gesucht wird deshalb zuerst der Block, VOR den er
       gehoert; fehlt der, der Block, hinter den er gehoert; fehlen beide, haengt er ans Ende.
       insertBefore(null) verhaelt sich wie appendChild - der Rueckfall braucht keinen
       Sonderfall. Ein einzelner fester Anker waere genau der Fehler, den die alte Fassung mit
       "braucht keinen Anker, der verschwinden kann" vermeiden wollte. */
    const spBlock=document.getElementById('cmSpeicherBlock');
    if(spBlock){
      merkeGruppenZustand(spBlock, 'Warmwasserspeicher');
      const vor  = cmExtraList.querySelector('[data-g="Hydraulischer Abgleich"]');
      const hint = cmExtraList.querySelector('[data-g="Pumpengruppen"]');
      cmExtraList.insertBefore(spBlock, vor || (hint ? hint.nextSibling : null));
    }
    /* Erst jetzt verdrahten: Die Chips entstehen oben in dieser Schleife, die frueheren
       Aufrufe direkt nach dem innerHTML liefen also ins Leere. */
    wireAufstellortChips('cm');
    wireHeizartChips('cm');
    wireKreiseChips('cm');
    wireFbhBaujahrChips('cm');
    wireMengenFragen('cm');
    wireSelbstBesorgen('cm');
  }
  /* IM KASTEN legt der Knopf die Zusammenstellung in den Warenkorb und zeigt sie - er startet
     NICHT die Reservierung (Vorgabe 15.09.2026). Damit stimmen Beschriftung und Handlung
     wieder ueberein; der offene Punkt von gestern ist damit entschieden. Abgeschlossen wird
     in der Schublade, siehe den Knopf am Ende von bwpKorbZeichnen().
     Im Dialog auf den anderen Seiten bleibt es beim direkten Weg zur Reservierung - dort gibt
     es keine Schublade, die den Abschluss uebernehmen koennte. */
  document.getElementById('cmAdd').onclick=()=>{
    if(document.querySelector('#cartModal.kauf-inline')){
      /* DIREKT IN DEN GROSSEN WARENKORB (12.10.2026, Vorgabe Claras: "ich moechte gerne, dass
         wenn man beide dieser Buttons klickt, man zu einem Pop-up-Warenkorb kommt").

         OHNE DIE SCHUBLADE: Sie ist die Zwischenuebersicht fuer den Weg ueber die Kopfleiste.
         Wer hier klickt, hat seine Konfiguration gerade abgeschlossen und will das Ergebnis
         sehen - eine Schublade dazwischen waere ein Zwischenschritt ohne Frage.

         DAS RECHNER-FENSTER POPPT NICHT MEHR AUF (Vorgabe Claras vom selben Tag). Es waere
         sonst ueber dem Warenkorb aufgegangen, den derselbe Klick gerade geoeffnet hat. */
      try{ bwpKorbZeichnen(); }catch(e){}
      if(typeof bwpKorbFenster==='function') bwpKorbFenster(true);
      return;
    }
    cartAddDirect(kitKey, setBusy(document.getElementById('cmAdd'),'Checkout wird vorbereitet …'));
  };
  /* "Rechnung per E-Mail" hier ebenfalls entfernt - siehe Begruendung in renderBuyBox.
     Die beiden Kaufwege haben eigene, parallele Bloecke; was in einem geaendert wird,
     muss im anderen mitgehen, sonst verhalten sich Rechner und Direktkauf unterschiedlich. */
  cmUpdateTotal(kitKey);
  startCheckoutWalkthrough('modal','hardware');
}
/* Gleiche Risiko-Logik wie updateFoerderRisk() im Rechner-Checkout, nur auf directServices/#cmFoerderRiskBox
   gemappt statt chosenServices/#foerderRiskBox - zwei Kaufwege, eine Quelle (SERVICE_FOERDER_INFO). */
function updateCmFoerderRisk(){
  const box=document.getElementById('cmFoerderRiskBox'); if(!box) return;
  const visible=FOERDER_CRITICAL.filter(k=>SERVICES[k] && (!SERVICES[k].only||SERVICES[k].only(A)));
  const missing=visible.filter(k=>!directServices.has(k));
  const hlb=hlbBlockHtml(directServices,'cm');
  const verdrahten=()=>wireHlbBlock(box,'cm',
    ()=>{ const cb=document.querySelector('#cartModalBody input[data-k="vot"]');
          if(cb && !cb.checked){ cb.checked=true; cb.dispatchEvent(new Event('change',{bubbles:true})); }
          else { directServices.add('vot'); cmUpdateTotal(); } },
    ()=>updateCmFoerderRisk());
  if(missing.length===0){
    box.innerHTML = (visible.length ? `<div class="okline">✓ Alle Förder-Pflichtservices gebucht</div>` : '') + hlb;
    verdrahten();
    return;
  }
  /* vot aussen vor lassen: fuer ihn steht der praezise Heizlast-Block darunter, der auch
     den Eigenleistungs-Weg anbietet. Beides zusammen waere widerspruechlich. */
  const names=[...new Set(missing.filter(k=>!FOERDER_EIGENLEISTUNG_MOEGLICH.includes(k)).map(k=>SERVICES[k].name))];
  if(!names.length){
    box.innerHTML = hlb;
    verdrahten();
    return;
  }
  box.innerHTML=`<div class="banner warn">⚠ Ohne <b>${names.map(esc).join(', ')}</b> gehst du das Risiko ein, keine Förderung zu bekommen. Diese Schritte muss laut KfW 458 ein Fachbetrieb bestätigen. Kein Fachbetrieb, keine Bestätigung, keine Auszahlung.</div>` + hlb;
  verdrahten();
}

/* Direktkauf-Pendant zu paketGruppen(): jetzt inhaltsgleich (Kit, Speicher, Services, Extras-
   Gruppen, Abholung/Lieferung) - eine Quelle fuer Modal-Bullets UND Checkout-Zeilen, wie beim
   Rechner-Weg. */
function cmPaketGruppen(kitKey){
  const z=[['Kit',`${PRODUCTS[kitKey].name} · ${eur(PRODUCTS[kitKey].price)}`]];
  const spKey=speicher();
  if(spKey) z.push(['Warmwasserspeicher',`${PRODUCTS[spKey].name.replace('Warmwasserspeicher ','')} · ${eur(PRODUCTS[spKey].price)}`]);
  z.push(['Services',[...directServices].map(k=>`${SERVICES[k].name} (${SERVICES[k].price?eur(SERVICES[k].price):'inklusive'})`).join(', ')||'keine']);
  Object.entries(extrasGruppen()).forEach(([g,info])=>z.push([g,`${info.teile.join(' + ')} · ${eur(info.sum)}`]));
  z.push(['Lieferung',deliveryLabel()]);
  /* Der Wunschstart als eigene Zeile, direkt hinter der Versandart - beides sind Angaben zum
     WANN und WIE, nicht zum WAS. Ohne Angabe keine Zeile. In BEIDEN Kaufwegen, sonst zeigte
     "Dein Paket im Detail" je nach Weg etwas anderes. */
  const startTextDetail=startWunschText();
  if(startTextDetail) z.push(['Start',startTextDetail]);
  return z;
}
/* Kopfzeile jeder Material-Gruppe: was ist hier gewaehlt und was kostet es. Nur so darf eine
   Gruppe ueberhaupt zugeklappt sein - sonst verschwindet eine Kaufentscheidung aus dem Blick.
   Seit dem 21.09.2026 sind die Gruppen im Direktkauf-Dialog genau das, also braucht auch er
   diese Zahl; bis dahin stand die Schleife fest verdrahtet in updateTotal und kannte nur
   #extraList. Eine Funktion fuer beide Wege - sonst zeigte der eine Kopf bald etwas anderes
   als der andere.

   DER WARMWASSERSPEICHER RECHNET ANDERS: Er steckt nicht in EXTRAS und nicht in chosenExtras,
   sondern haengt an der Funnel-Antwort (speicher()). Als Gruppe sieht er aus wie die vier
   darunter, also muss sein Kopf dasselbe sagen - sonst waere ausgerechnet die oberste,
   teuerste Entscheidung die einzige, die zugeklappt unsichtbar wird. */
/* WELCHE GRUPPE HAT DER KUNDE AUFGEKLAPPT (21.09.2026).
   Zugeklappt zu STARTEN heisst nicht, bei jeder Kleinigkeit wieder zuzufallen: Die Antwort
   auf die Heizart- und die Aufstellort-Frage zeichnet den ganzen Dialog neu (siehe
   wireHeizartChips) - ohne diesen Merker haette der Kunde die Gruppe geoeffnet, darin
   geantwortet und danach vor fuenf geschlossenen Zeilen gestanden, ohne zu sehen, was seine
   Antwort bewirkt hat. Genau die Wirkung sollte die Frage in ihrer Gruppe ja zeigen.

   Nur im Arbeitsspeicher und absichtlich NICHT in speichereStand(): Es ist eine Blickrichtung
   von gerade eben, kein Teil der Konfiguration. Wer den Dialog spaeter neu oeffnet, faengt
   wie vorgegeben mit allem zu an. */
let offeneGruppen=new Set();
/* Ein Aufklapper, der sich merkt, ob er offen war. Beides zusammen, damit niemand das eine
   ohne das andere einbaut - dann faende der Merker nie einen Eintrag oder nie einen Leser. */
function merkeGruppenZustand(det, gname){
  det.open=offeneGruppen.has(gname);
  det.addEventListener('toggle',()=>{
    if(det.open) offeneGruppen.add(gname); else offeneGruppen.delete(gname);
  });
}
function gruppenZaehlerAktualisieren(listenId){
  const liste=document.getElementById(listenId); if(!liste) return;
  liste.querySelectorAll('.xgrp').forEach(det=>{
    const n=det.querySelector('.xgrp-n'); if(!n) return;
    let anzahl=0, betrag=0;
    if(det.dataset.g==='Warmwasserspeicher'){
      const sp=speicher();
      if(sp && PRODUCTS[sp]){ anzahl=1; betrag=PRODUCTS[sp].price; }
      n.textContent = anzahl ? `${PRODUCTS[sp].name.replace('Warmwasserspeicher ','')} · ${eur(betrag)}` : '';
      det.classList.toggle('hat-wahl', anzahl>0);
      speicherPfeilSetzen(det, sp);
      return;
    }
    det.querySelectorAll('.svc-row').forEach(row=>{
      const k=row.dataset.k || (row.querySelector('[data-x]')||{dataset:{}}).dataset.x
        || (row.querySelector('.kb-info')||{dataset:{}}).dataset.key;
      const menge=k?chosenExtras[k]:0;
      if(k && EXTRAS[k] && menge){ anzahl++; betrag+=EXTRAS[k].price*menge; }
    });
    n.textContent = anzahl ? `${anzahl} gewählt · ${eur(betrag)}` : '';
    det.classList.toggle('hat-wahl', anzahl>0);
  });
}
/* DER PFEIL AM WARMWASSERSPEICHER WANDERT MIT DER AUSWAHL (30.09.2026, Vorgabe Claras: "bei
   Warmwasserspeicher gibt es noch keinen Pfeil als Verlinkung zu der Produktpaketseite, da
   dieser sich daran variiert, wie ausgewaehlt wird - 200 l fuehrt zur Paketseite des
   Warmwasserspeichers 200 l, 300 l zu der des 300 l").

   WARUM ER GEFEHLT HAT: Die anderen Pakete sind Eintraege in EXTRAS und bekommen ihren Pfeil
   beim Zeichnen der Zeile (paketSeiteHtml). Der Speicher ist keiner - er haengt an der Antwort
   im Funnel (A.speicherChoice) und hat nur eine Gruppenzeile mit zwei Chips. Es gab also gar
   keine Zeile, an die der Pfeil haette wandern koennen.

   ER WIRD DESHALB HIER GESETZT, wo ohnehin schon die Sonderbehandlung des Speichers steht und
   was bei jeder Aenderung laeuft. Die Zuordnung Wahl -> Paket kommt aus ZUB_SPEICHER, also aus
   derselben Tabelle, die auch die Kachel auf der Bauteile-Seite benutzt.

   OHNE WAHL KEIN PFEIL: Solange niemand einen Speicher gewaehlt hat, gibt es kein Paket, auf
   das er zeigen koennte - ein Verweis auf "irgendeinen" waere geraten.

   preventDefault UND stopPropagation: Der Pfeil sitzt in einem <summary>. Ein Klick darin
   klappt die Gruppe auf oder zu; ohne beides waere der Verweis ein Aufklapper mit
   Nebenwirkung. Die Fahrt loesen wir danach selbst aus. */
/* DER PFEIL AM SPEICHER WIRD AUS EIGENEM TAKT GESETZT (berichtigt 01.10.2026, Meldung Claras:
   "bei Warmwasserspeicher gibt es gar keinen Pfeil gerade").

   ER HING AN gruppenZaehlerAktualisieren(), und das sucht ausschliesslich INNERHALB einer
   genannten Liste. Der Speicherblock entsteht jedoch ausserhalb und wird erst zur Laufzeit in
   die Liste geschoben - wer die Reihenfolge der beiden Schritte aendert oder den Block an
   anderer Stelle einhaengt, nimmt dem Pfeil still seinen einzigen Ausloeser. Genau das ist
   passiert.

   JETZT SUCHT ER SELBST, im ganzen Dokument, und haengt an zubKnoepfeAktualisieren() - der
   Stelle, die ohnehin nach dem Laden und nach jeder Aenderung am Warenkorb laeuft und schon
   die Knoepfe und Mengenregler nachzieht. Damit ist er unabhaengig davon, wo der Block gerade
   haengt.

   DIE ALTE STELLE BLEIBT TROTZDEM: Sie greift, sobald jemand im Kasten den Speicher wechselt,
   und spart die eine Runde Verzoegerung bis zur naechsten Warenkorb-Aenderung. Zweimal
   dasselbe zu setzen schadet nicht - die Funktion legt nur an, was fehlt. */
function speicherPfeilAktualisieren(){
  let sp=null; try{ sp=speicher(); }catch(e){}
  document.querySelectorAll('[data-g="Warmwasserspeicher"]').forEach(det=>speicherPfeilSetzen(det, sp));
}
function speicherPfeilSetzen(det, sp){
  const kopf=det.querySelector('summary'); if(!kopf) return;
  let a=kopf.querySelector('.xgrp-seite');
  const paket = sp ? Object.keys(ZUB_SPEICHER).find(p=>ZUB_SPEICHER[p]===sp) : null;
  if(!paket){ if(a) a.hidden=true; return; }
  if(!a){
    /* EIN KNOPF, KEIN VERWEIS (01.10.2026): Seit der Pfeil ein Fenster oeffnet statt die Seite
       zu wechseln, ist er keine Navigation mehr. Ein <button> sagt das auch den Hilfsmitteln -
       ein Verweis ohne Ziel waere eine Luege im Markup. */
    a=document.createElement('button');
    a.type='button';
    a.className='xr-seite xgrp-seite';
    a.textContent='↗';
    a.setAttribute('aria-label','Warmwasserspeicher: alle Inhalte erklärt');
    a.title='Alle Inhalte erklärt – öffnet ein Fenster';
    /* DAS FENSTER WIRD HIER SELBST GEOEFFNET, nicht ueber den Horcher am Dokument
       (berichtigt 01.10.2026): Der Knopf sitzt in einem <summary>, und ohne stopPropagation
       klappt die Gruppe beim Klick zugleich auf oder zu. stopPropagation haelt den Klick aber
       auch vom Dokument fern - der Horcher dort haette ihn nie gesehen, und der Pfeil waere
       ein Knopf ohne Wirkung gewesen.

       Die Kennung wird beim Klick gelesen und nicht beim Anlegen: Wer von 200 auf 300 Liter
       wechselt, soll dasselbe Element mit dem neuen Paket bekommen. */
    a.addEventListener('click',e=>{
      e.preventDefault(); e.stopPropagation();
      const k=a.getAttribute('data-paketfenster');
      if(k) paketFensterOeffnen(k);
    });
    const info=kopf.querySelector('.kb-info');
    if(info && info.nextSibling) kopf.insertBefore(a, info.nextSibling);
    else if(info) kopf.appendChild(a);
    else kopf.insertBefore(a, kopf.querySelector('.xgrp-n') || null);
  }
  a.hidden=false;
  a.setAttribute('data-paketfenster', paket);
}

function cmUpdateTotal(kitKey){
  /* Wie in updateTotal: die Zahl am Warenkorb zieht mit. Der Direktkauf-Weg - und damit
     der Kasten auf der Produktseite - rechnet hier, nicht dort. */
  try{ bwpKorbZahl(); }catch(e){}
  merkeKauf();   /* gemeinsamer Weg jeder Aenderung im Express-Dialog - siehe updateTotal */
  let sum=PRODUCTS[kitKey].price;
  const spKey=speicher(); if(spKey) sum+=PRODUCTS[spKey].price;
  directServices.forEach(k=>sum+=SERVICES[k].price);
  sum+=extrasSumme();
  /* Der Rabatt greift auf der Summe VOR der Liefergebuehr - Logistik wird nicht rabattiert,
     dieselbe Grenze wie bei der Foerderbasis (portiert 16.09.2026). */
  const rabBetrag=rabattBetrag(sum);
  const grandTotal=sum-rabBetrag+deliveryFee();
  const fundRow=document.querySelector('#cmEigenList .svc-row[data-k="fundament"]');
  if(fundRow) fundRow.classList.toggle('hidden', !!chosenExtras.fundament);
  updateCmFoerderRisk();
  syncZeilenPreise('cm');
  document.getElementById('cmTotal').textContent=eur(grandTotal);
  /* Die Leiste oben wird erst NACH dem Foerderblock gefuellt - vorher steht der Effektivpreis
     noch nicht fest. Sie hier schon zu setzen war der Grund, warum im Direktkauf die Bruttosumme
     stand, waehrend die Rechner-Kaufbox laengst den Preis nach Foerderung zeigte. */
  const spPrice=document.getElementById('cmSpPrice'); if(spPrice) spPrice.textContent=spKey?eur(PRODUCTS[spKey].price):'';
  gruppenZaehlerAktualisieren('cmExtraList');
  /* Der ⓘ am Speicher ist am 14.09.2026 entfallen (Vorgabe: keine Info-Knoepfe mehr in der
     Auswahl). Die Zeilen, die ihn ein- und ausblendeten, stehen deshalb nicht mehr hier -
     sie waren durch ihr if() zwar harmlos, haetten aber beim Lesen ein Element vermuten
     lassen, das es nicht mehr gibt. */
  const cmLuGrid=document.getElementById('cmLuGrid'), cmLuCount=document.getElementById('cmLuCount');
  if(cmLuGrid){
    const luEff=effektiverLU();
    cmLuGrid.innerHTML=luEff.list.map(([q,n],i)=>{
      const sku=luEff.details[i]&&luEff.details[i].sku;
      /* Kein ⓘ mehr (Vorgabe 14.09.2026). Die Variable bleibt, die Zeile darunter setzt sie
         unveraendert ein - sie ist jetzt immer leer. */
      const btn='';
      return `<div class="lu-pop" style="animation-delay:${i*40}ms;display:flex;justify-content:space-between;align-items:center;gap:8px"><span><span class="m">${q}</span>${esc(n)}</span>${btn}</div>`;
    }).join('');
    if(cmLuCount) cmLuCount.textContent=luEff.list.length;
  }
  const eigenSum=eigenleistungSumme();
  const eigenRow=document.getElementById('cmEigenSumRow'), eigenSumEl=document.getElementById('cmEigenSum');
  const giRow=document.getElementById('cmGesamtInvestRow'), giSum=document.getElementById('cmGesamtInvestSum');
  if(eigenRow&&giRow){
    if(eigenSum>0){
      eigenRow.classList.remove('hidden'); eigenSumEl.textContent="+ "+eur(eigenSum);
      giRow.classList.remove('hidden'); giSum.textContent=eur(grandTotal+eigenSum);
    } else { eigenRow.classList.add('hidden'); giRow.classList.add('hidden'); }
  }
  /* Förderung-Berechnung 1:1 aus updateTotal() - eine Formel fuer beide Kaufwege. */
  const __cmNurHw = gliederungAnzeigen('cm', hardwareSumme(kitKey, spKey), serviceSumme(directServices), deliveryFee());
  /* Wie in der Rechner-Kaufbox: die Leiste oben zeigt den Preis nach Foerderung, nicht die
     Bruttosumme. Wird weiter unten im Foerderblock gesetzt; ohne Quote bleibt sie null und die
     Leiste faellt auf die Paketsumme zurueck. Zwei Kaufwege, eine Aussage. */
  let cmEffektivPreis=null;
  /* BRUTTO OBEN, ABZUG DARUNTER - spiegelbildlich zur Kaufbox (portiert 16.09.2026). Dieselbe
     Funktion bedient bei Clara ZWEI Darstellungen: den Direktkauf-Dialog und die Kaufbox auf
     der Produktseite (#cartModal.kauf-inline). Eine Aenderung hier wirkt also an beiden
     Stellen - das ist gewollt, ein Rabatt darf sich nicht danach richten, wie die Box gerahmt
     ist. Bei rabBetrag 0 rechnet alles identisch zu vorher. */
  const __cmBasis = __cmNurHw ? hardwareSumme(kitKey, spKey) : sum;
  const __cmRab   = rabattBetrag(__cmBasis);
  const cmTotalEl=document.getElementById('cmTotal');
  if(cmTotalEl) cmTotalEl.textContent = eur(__cmBasis + deliveryFee());
  if(cmTotalEl) cmTotalEl.classList.toggle('gestrichen', __cmRab>0 || !!foerderQuote());
  rabattZeileAnzeigen('cm', __cmRab, __cmNurHw);
  zahlungsplanAnzeigen('cm', __cmBasis - __cmRab + deliveryFee());
  const fb=document.getElementById('cmFoerderBox'), q=foerderQuote();
  const fdLine=document.getElementById('cmFoerderDeductLine'), fdSum=document.getElementById('cmFoerderDeductSum');
  const effRow=document.getElementById('cmEffektivRow'), effLabel=document.getElementById('cmEffektivLabel'), effSum=document.getElementById('cmEffektivSum');
  /* Nicht mehr an fb gehaengt - dieselbe Umstellung wie in updateTotal() (11.08.2026): die
     Foerder-Infobox ist beim Entschlacken entfallen, die Rechnung muss trotzdem laufen. */
  if(q){
    /* FOERDERBASIS FOLGT DER ANGEZEIGTEN SUMME (03.09.2026)
       Der Preis nach Foerderung steht jetzt auch im Hardware-Schritt - er ist das staerkste
       Argument der Seite und darf dort nicht fehlen. Damit die drei Zahlen untereinander aber
       aufgehen, rechnet er im Hardware-Schritt auf der HARDWARE-Summe, nicht auf der vollen:
       gesamt, minus Foerderung, Endpreis - alle auf derselben Grundlage.
       Im Services-Schritt waechst die Basis um die Services, und mit ihr Abzug und Endpreis.
       Der Kunde sieht den Foerderbetrag also steigen, wenn er Services dazunimmt - das ist die
       Wahrheit und zugleich das Argument fuer die Pflichtservices.
       Die Eigenleistung bleibt in beiden Schritten drin: sie haengt nicht an den Services und
       hat ihre eigene Zeile darueber. Logistik bleibt wie bisher draussen (nicht foerderfaehig). */
    const foerderSumme = __cmNurHw ? hardwareSumme(kitKey, spKey) : sum;
    /* Foerderbasis sinkt mit - gleiche Begruendung wie in der Kaufbox. */
    const foerderNetto = foerderSumme - rabattBetrag(foerderSumme);
    const basis=foerderNetto+eigenSum, kosten=Math.min(basis,foerderKostenCap()), betrag=Math.round(kosten*q/100/10)*10;
    if(fdLine&&fdSum){
      fdLine.classList.remove('hidden'); fdSum.textContent="– "+eur(betrag);
      /* Prozentsatz wie in updateTotal(): "Förderung 30 % KfW 458" statt nur "Förderung". */
      const cmPct=document.getElementById('cmFoerderDeductPct'); if(cmPct) cmPct.textContent=q+" % KfW 458";
    }
    if(effRow&&effSum){
      /* Liefergebuehr im Endpreis - siehe ausfuehrliche Begruendung in updateTotal() (11.08.2026) */
      cmEffektivPreis=Math.max(basis+deliveryFee()-betrag,0);
      effRow.classList.remove('hidden'); effSum.textContent=eur(cmEffektivPreis);
      /* Claras drei Fassungen bleiben, der Rabatt kommt als vierte Dimension dazu. */
      if(effLabel){
        const __nachWas = __cmRab>0 ? "nach Rabatt und Förderung" : "nach Förderung";
        effLabel.textContent = __cmNurHw
          ? "Dein Preis "+__nachWas+" (Bauteile)"
          : (eigenSum>0 ? "Dein Preis "+__nachWas+" (Gesamtprojekt)" : "Dein Preis "+__nachWas);
      }
    }
    if(fb){
      fb.classList.remove('hidden');
      const kurz=fb.querySelector('#cmFoerderShortLabel');
      if(kurz) kurz.innerHTML=`Auch im Selbsteinbau die volle Förderung: bis zu <b>${q} % ≈ ${eur(betrag)}</b>`;
      const body=fb.querySelector('#cmFoerderInfoBody');
      if(body) body.innerHTML=`Lass die Abnahme (Anlagencheck &amp; Inbetriebnahme-Service) von uns machen, dann zählt die volle Investition für die KfW-458-Förderung, ganz unabhängig davon, dass du selbst einbaust.${eigenSum>0?` Deine Eigenleistung oben ist mit <b>${eur(eigenSum)}</b> bereits eingerechnet.`:''} <span class="tag">unverbindliche Schätzung</span><br><span class="src">${esc(CONFIG.FOERDER_DISCLAIMER)}</span>`;
    }
  } else {
    if(fb) fb.classList.add('hidden');
    if(fdLine) fdLine.classList.add('hidden');
    if(effRow) effRow.classList.add('hidden');
  }
  /* Handwerker-Vergleich hier ebenfalls entfernt - siehe Begruendung in updateTotal() (11.08.2026).
     Beide Kaufwege muessen dieselbe Preisdarstellung zeigen, sonst widersprechen sie sich. */
  /* Wie in der Rechner-Kaufbox: Preis nach Foerderung, sonst die Paketsumme. */
  const cmMini=document.getElementById('cmMiniSum');
  if(cmMini) cmMini.textContent = cmEffektivPreis!=null ? eur(cmEffektivPreis) : eur(grandTotal);
  const cmMiniLabel=document.getElementById('cmMiniStepLabel');
  if(cmMiniLabel && activeBbStep('cm')==='hardware')
    cmMiniLabel.textContent = cmEffektivPreis!=null ? 'Schritt 1/2 · Bauteile · nach Förderung' : 'Schritt 1/2 · Bauteile';
  /* ZUSATZ NEBEN DEM KITPREIS (16.09.2026): Was neben dem Kit zusammenkommt.
     Gerechnet aus den Bestandteilen, nicht aus einer der Summen weiter unten - die tragen
     Rabatt und Lieferkosten mit, und daneben stehen soll nur das Dazugebuchte. */
  const preisPlus=document.getElementById('bwpPreisPlus');
  if(preisPlus){
    /* DER WARMWASSERSPEICHER FEHLTE HIER (Fehlerbehebung 17.09.2026, von Clara gemeldet).

       Er ist die groesste Einzelposition neben dem Kit - 2.200 € beim 300-Liter-Speicher -
       und er wird NICHT angeklickt, sondern aus den Antworten abgeleitet (speicher() liest
       A.dhw und A.persons). Genau deshalb fiel er durchs Raster: Das Abzeichen summierte
       chosenExtras, und dort steht er nicht.

       SICHTBAR WURDE ES ERST NACH DEM RECHNER, und das machte es so verwirrend: Ohne
       beantwortete Fragen gibt speicher() null zurueck, es fehlte also nichts. Wer den
       Rechner durchlaeuft, hat A.dhw beantwortet - ab da lag ein Speicher im Warenkorb,
       den der Zuschlag neben dem Preis nicht kannte. Der Warenkorb zeigte 10.214 €, die
       Produktseite 6.399 € + 1.615 €.

       spKey steht schon oben in dieser Funktion, dieselbe Quelle wie die Gesamtsumme -
       zwei Zahlen auf einem Bildschirm duerfen nicht aus zwei Rechnungen stammen. */
    const sp = spKey ? PRODUCTS[spKey].price : 0;
    const zub=Object.entries(chosenExtras).reduce((a,[k,q])=>
      a + ((EXTRAS[k] && q>0) ? EXTRAS[k].price*q : 0), 0);
    /* SERVICES ERST AB IHREM SCHRITT (Vorgabe 16.09.2026). Sie sind vorausgewaehlt, damit die
       Foerderung nicht an einem vergessenen Haken scheitert - und sie gehoeren in den Preis.
       Nur eben nicht, bevor der Kunde sie gesehen hat: Sonst staende neben dem Kitpreis von
       Anfang an ein Zuschlag von knapp 2.000 €, den niemand ausgewaehlt hat.

       Derselbe Merker wie in der Warenkorb-Schublade (servicesErreicht) - eine Regel, zwei
       Anzeigen, die dadurch nie auseinanderlaufen. */
    const svc = servicesErreicht
      ? [...directServices].reduce((a,k)=>a + ((SERVICES[k] && SERVICES[k].price) || 0), 0)
      : 0;
    const dazu = sp + zub + svc;
    preisPlus.textContent = dazu>0 ? '+ '+fmt(dazu,2)+' €' : '';
    preisPlus.hidden = !(dazu>0);
  }
  /* DER PRODUKT-INFOKASTEN ZIEHT MIT (17.09.2026). Sein Reiter "Produktpakete" zeigt, was
     gerade angehakt ist - also dieselbe Auswahl, die eine Zeile weiter oben den Zuschlag
     bildet. Ohne diesen Anstoss stuende dort der Stand vom Seitenaufbau, waehrend der Preis
     daneben schon der neue ist.

     Ein Haken statt eines Aufrufs: Der Kasten ist eine Section und steht auf den meisten
     Seiten gar nicht. typeof faengt das ab, und konfigurator.js muss nichts von ihm wissen -
     die Abhaengigkeit laeuft in eine Richtung. */
  if(typeof window.bwpPinfoAktualisieren==='function'){
    try{ window.bwpPinfoAktualisieren(); }catch(e){ /* eine Anzeige darf keine Summe stuerzen */ }
  }
  const btn=document.getElementById('cmAdd'), note=document.getElementById('cmDepositNote');
  /* IM KASTEN AUF DER PRODUKTSEITE HEISST DER KNOPF ANDERS (Vorgabe 14.09.2026).
     Dort ist die Warenkorb-Schublade die Zusammenfassung, und der Schritt nach den Services
     fuehrt dorthin.

     ACHTUNG, HIER STIMMEN BESCHRIFTUNG UND HANDLUNG NICHT UEBEREIN: Der Knopf loest
     weiterhin cartAddDirect() aus, also die Reservierung - kostenlos und unverbindlich, aber
     eben mehr als ein Blick in den Warenkorb. Wer das aufloesen will, hat zwei Wege: den
     Knopf hier auf bwpKorbToggle(true) legen und den Abschluss in die Schublade holen, oder
     die Beschriftung zuruecknehmen. So oder so gehoert es entschieden, bevor die Seite
     veroeffentlicht wird. */
  const imKasten = !!document.querySelector('#cartModal.kauf-inline');
  if(CONFIG.MODE==='deposit'){
    /* Wortgleich zur Kaufbox in updateTotal() (11.08.2026) - zwei Kaufwege, eine Aussage. */
    btn.innerHTML = imKasten ? 'Warenkorb ansehen' : kaufKnopfGross();
    const cmGruppen=cmPaketGruppen(kitKey);
    const bullets=cmGruppen.map(([g,t])=>`<li><b>${esc(g)}:</b> ${esc(t)}</li>`).join('');
    note.innerHTML=`<div class="banner ok resnote">
            <details class="mini resdetail"><summary>Dein Paket im Detail (${cmGruppen.length} Positionen)</summary><ul class="resitems">${bullets}</ul></details>
    </div>`;
  } else {
    btn.textContent = imKasten ? 'Warenkorb ansehen' : `In den Warenkorb: ${eur(grandTotal)} →`;
    note.innerHTML='';
  }
  return grandTotal;
}

function cartAddDirect(kitKey,onAbort,gates){
  /* Eigener Kaufanlauf, gleiche Begruendung wie in checkout(): siehe kaufLauf. */
  kasseAbgebrochen=false; kaufLauf++;
  /* Gleiche Regel wie im Rechner-Checkout - auch hier greift der Sticky-CTA direkt zu.
     gates statt Boolean, identisch zu checkout(); true bleibt zulaessig.
     Der unsuitOk-Riegel fehlt hier bewusst: kitUnpassend() rendert die Checkbox
     ausschliesslich in renderBuyBox, im Direktkauf-Dialog gibt es sie gar nicht.
     unsuitFrei() wuerde hier immer true liefern - eine Zeile, die nichts pruefen kann,
     waere schlimmer als keine, weil sie Schutz vortaeuscht. */
  const g = (gates===true) ? {foerder:true,einbring:true} : (gates||{});
  if(!g.foerder && offeneFoerderpunkte(directServices).length){
    if(onAbort) onAbort();
    foerderGate(directServices, ()=>cartAddDirect(kitKey,onAbort,{...g,foerder:true}), 'cmFoerderRiskBox');
    return;
  }
  /* Riegel 3: Einbringbarkeit - gleiche Regel wie im Rechner-Checkout. */
  if(!g.einbring){
    const u=einbringUrteil();
    if(u.status!=='aus' && u.status!=='ok'){
      if(onAbort) onAbort();
      einbringGate(u, ()=>cartAddDirect(kitKey,onAbort,{...g,einbring:true}));
      return;
    }
  }
  const abort=onAbort||(()=>{});
  kasseFrei=new Promise(erfuellt=>track("checkout_start",{kit:kitKey,services:[...directServices],mode:CONFIG.MODE,path:'direct'},erfuellt));
  submitLead("checkout_start",{path:'direct'});
  const extrasNote=Object.entries(chosenExtras).map(([k,q])=>k+(EXTRAS[k]&&EXTRAS[k].perMeter?'x'+q+'m':(EXTRAS[k]&&EXTRAS[k].perUnit?'x'+q:''))).join(",")||"keine";
  const noteText=`Direktkauf ohne Rechner: ${kitKey} | Services: ${[...directServices].join(",")||"keine"} | Extras: ${extrasNote} | Lieferung${attrShort()}`;
  const banner=document.getElementById('cmDemoBanner');
  if(CONFIG.MODE==='deposit'){
    /* Wie im Rechner-Weg: im Positionsmodus "echt" spielt das Anzahlungsprodukt keine Rolle. */
    if(!echtePositionen() && String(PRODUCTS.deposit.variantId).startsWith('TBD_')){
      abort();
      banner.innerHTML=`<div class="banner warn" style="margin-top:14px"><b>Hinweis (Testbetrieb):</b> Das Anzahlungs-Produkt ist im Shop noch nicht angelegt, dieser Klick löst noch keine echte Anzahlung aus.</div>`;
      return;
    }
    const spKey=speicher();
    let sum=PRODUCTS[kitKey].price + (spKey?PRODUCTS[spKey].price:0);
    directServices.forEach(k=>sum+=SERVICES[k].price);
    sum+=extrasSumme();
    /* Der Rabatt greift auf der Summe VOR der Liefergebuehr - Logistik wird nicht rabattiert
       (portiert 16.09.2026). */
    const rabBetrag=rabattBetrag(sum);
    const grandTotal=sum-rabBetrag+deliveryFee();
    /* Dieselben Kassenzeilen wie im Rechner-Weg, nur mit den Services aus dem Direktkauf-Dialog.
       Beide Wege enden auf demselben Anzahlungs-Produkt - die Bestelluebersicht darf also nicht
       davon abhaengen, ueber welchen Weg jemand hereingekommen ist. */
    const zeilenRoh=echtePositionen()?warenkorbPositionen(kitKey,directServices):null;
    const zeilen=(zeilenRoh&&zeilenRoh.length)?zeilenRoh:null;
    const props=checkoutPositionen(kitKey,directServices,!!zeilen);
    /* DER ABZUG SICHTBAR IN DER KASSE (portiert 16.09.2026). Shopify kann hier keinen
       Rabattcode rechnen - im Warenkorb liegt nur die Vorbestellung, ein Code traefe die 0 EUR
       und nicht das Paket. Der Abzug wird deshalb als Positionstext gezeigt und auf der
       Schlussrechnung verrechnet. Zwei Zeilen, weil eine rabattierte Summe allein nichts
       belegt: der Kunde soll sehen, WOVON abgezogen wurde. Grossbuchstaben als Ueberschrift
       und "· " davor ist dasselbe Muster, das checkoutPositionen() schon benutzt.
       ACHTUNG: In Shopifys Kasse steht ein Feld "Rabattcode", das unseren Code abweist
       (DISCOUNTS_NOT_FOUND). Die Vorwarnung steht bewusst nur in der Willkommensmail -
       Betreiber-Entscheid 16.09.2026, die Kasse sollte nicht geschwaetziger werden. */
    if(rabBetrag>0){
      props['DEIN RABATT']='Code '+rabattCode();
      props['· Originalpreis']=eur(sum+deliveryFee());
      /* Fester Betrag (28.09.2026): ohne Prozentangabe - der Code steht eine Zeile hoeher. */
      props[rabattProzent()>0 ? '· Rabatt '+rabattProzent()+' %' : '· Rabatt']='– '+eur(rabBetrag);
    }
    /* Fuer das Bestell-Attribut des festen Betrags, siehe attrAttributes(). */
    rabattGebucht=rabBetrag;
    props['PAKET GESAMT']=eur(grandTotal);
    /* Variante B des A/B-Tests kostet heute nichts. "Du zahlst heute 0 EUR (Anzahlung, wird
       voll angerechnet)" waere dort sachlich falsch und liest sich wie ein Fehler - es gibt
       keine Anzahlung, die angerechnet werden koennte. Deshalb zwei Wortlaute. */
    if(PRODUCTS.deposit.price>0){
      props['Du zahlst heute']=`${eur(PRODUCTS.deposit.price)} (Anzahlung, wird voll angerechnet)`;
      props['Restzahlung bei Erhalt']=eur(Math.max(0,grandTotal-PRODUCTS.deposit.price));
    } else {
      /* Wortlaut folgt AGB Paragraf 2 und dem Betreiber-Entscheid vom 03.09.2026: in Variante B
         zahlt der Kunde heute nichts, der Gesamtbetrag wird per Rechnung faellig, nachdem wir
         angenommen haben. Hier stand bis heute "Faellig bei Lieferung" - die falsche Zaesur:
         faellig wird nichts, bevor die Auftragsbestaetigung raus ist, und die Lieferung ist
         weder der Zeitpunkt der Annahme noch der der Rechnung. */
      props['Heute zu zahlen']='nichts – dies ist eine Reservierung';
      props['Fällig nach unserer Auftragsbestätigung']=eur(grandTotal)+' (per Rechnung)';
    }
    /* Nur Variante A: der Satz beginnt mit der Anzahlung, die es in der kostenfreien
       Vorbestellung nicht gibt. Betreiber-Entscheid 18.08.2026: in B ersatzlos weglassen. */
    if(PRODUCTS.deposit.price>0) props['Wie es weitergeht']='Du zahlst heute nur die Anzahlung. Danach melden wir uns und planen Liefertermin, Spedition und Abladestelle mit dir - erst dann geht dein Kit raus.';
    depositCheckout(props,noteText,
      zeilen ? warenkorbPermalink(zeilen,noteText) : `/cart/${PRODUCTS.deposit.variantId}:1?note=${encodeURIComponent(noteText)}`,
      zeilen);
    return;
  }
  const spKey=speicher();
  const items=[PRODUCTS[kitKey].variantId+":1"];
  if(spKey) items.push(PRODUCTS[spKey].variantId+":1");
  directServices.forEach(k=>items.push(SERVICES[k].variantId+":1"));
  const url=`/cart/${items.join(",")}?note=${encodeURIComponent(noteText)}`;
  if(url.includes("TBD_")){
    abort();
    banner.innerHTML=`<div class="banner warn" style="margin-top:14px"><b>Hinweis (Testbetrieb):</b> Eine Produkt-ID fehlt noch, dieser Klick löst noch keinen echten Kauf aus.</div>`;
  } else { navigiereNachMessung(url); }
}

/* ---- Pro-Pfad (Fachbetrieb): ehrliches Lead-Capture, kein Preis, kein Angebot vorgetäuscht.
   Beide Quadranten (Beistell/Komplett) teilen sich diese Komponente, nur mit unterschiedlichen
   Tracking-Metadaten (scope). ---- */
function renderProLead(cand,r,scope){
  track("pro_lead_view",{kit:cand.kit,scope});
  const p=PRODUCTS[cand.kit];
  app.innerHTML=`<div class="step">
    <button class="btn quiet" id="backToCompare" style="margin-bottom:6px">← Zurück zum Vergleich</button>
    <div class="verdict">
      <div class="v-eyebrow">Fachbetrieb</div>
      <img src="${IMG[cand.kit]}" alt="${esc(p.name)}">
      <h2>Dein Kit-Vorschlag: ${esc(p.name)}</h2>
      <div class="kwline">${scope==='beistell'?'MHG Beistell-WP zur bestehenden Gasheizung':'Komplett-Installation'}</div>
    </div>
    <div class="buybox">
      <div class="beleg" style="background:var(--paper);border-color:var(--line)">Für die Vermittlung an einen Fachbetrieb kooperieren wir mit <b>Vamo</b>. Wir geben deine Anfrage samt Kit-Vorschlag dorthin weiter, das Angebot für die komplette Installation kommt dann von dort.</div>
      <div class="prolead">
        <div class="svc-block-title">Wir melden uns bei dir</div>
        ${CONFIG.VAMO.AKTIV ? `
        <p class="sub">Alles, was du im Rechner beantwortet hast, geht direkt mit an Vamo. Es fehlen nur noch ein paar Angaben zum Haus, die der Rechner nicht abfragt, und deine Kontaktdaten.</p>
        <button class="btn" id="proGo">Anfrage an Vamo weitergeben →</button>
        <div id="proDone"></div>` : `
        <p class="sub">Gib uns deine Daten, dann übernimmt das Vamo-Team und meldet sich mit einem Angebot für die komplette Installation. Deine Eckdaten aus dem Rechner gehen mit.</p>
        <div class="field"><input type="text" id="proName" placeholder="Name (optional)"></div>
        <div class="emailrow"><input type="email" id="proEmail" placeholder="E-Mail"></div>
        <div class="emailrow"><input type="tel" id="proTel" placeholder="Telefon" autocomplete="tel" required aria-required="true"></div>
        <label class="proconsent"><input type="checkbox" id="proOk">Ja, gebt meine Anfrage an Vamo weiter, damit sich jemand wegen der Installation bei mir meldet.</label>
        <button class="btn" id="proGo">Anfrage an Vamo weitergeben →</button>
        <div id="proDone"></div>`}
      </div>
    </div>
  </div>`;
  document.getElementById('backToCompare').onclick=()=>renderComparison(r);
  /* Mit aktiver API fuehrt der CTA ins Kurzformular (renderVamoGaps): Vamo verlangt
     Vor-/Nachname, Telefon und Gebaeudeangaben, die der Rechner nicht erhebt. Ohne API
     geht der Lead wie frueher als E-Mail an unser Postfach - das Team meldet sich von Hand.
     Beide Wege bleiben im Code, umgeschaltet wird ueber CONFIG.VAMO.AKTIV. */
  if(CONFIG.VAMO.AKTIV){
    document.getElementById('proGo').onclick=()=>renderVamoGaps(cand,r,scope);
    return;
  }
  document.getElementById('proGo').onclick=async()=>{
    const name=document.getElementById('proName').value||null;
    const email=document.getElementById('proEmail').value||null;
    const telFeld=document.getElementById('proTel');
    const tel=telFeld.value.trim();
    const done=document.getElementById('proDone'), go=document.getElementById('proGo');
    const okBox=document.getElementById('proOk');
    if(!email || !istEmail(email)){
      done.innerHTML=`<div class="banner warn">Bitte gib eine E-Mail-Adresse an, sonst können wir dich nicht erreichen.</div>`;
      document.getElementById('proEmail').focus(); return;
    }
    /* Telefon ist Pflicht (User-Entscheid 10.08.2026). Ein Fachbetrieb meldet sich zur
       Terminabsprache an - das laeuft ueber das Telefon, nicht ueber Mail-Pingpong.
       Format bleibt offen, geprueft wird nur, DASS etwas dasteht - dieselbe Regel wie
       bei der Superkunden-Anmeldung. */
    if(!tel){
      done.innerHTML=`<div class="banner warn">Wir brauchen noch deine Telefonnummer &ndash; der Fachbetrieb meldet sich telefonisch zur Terminabsprache.</div>`;
      telFeld.focus(); return;
    }
    /* Ausdrueckliche Bestaetigung, bevor irgendetwas rausgeht: die Weitergabe soll eine
       bewusste Handlung sein, keine Nebenwirkung des Ausfuellens. */
    if(!okBox.checked){
      done.innerHTML=`<div class="banner warn">Setz bitte noch den Haken, dann geben wir deine Anfrage weiter.</div>`;
      okBox.focus(); return;
    }
    A.email=email; speichereStand();
    track("fachbetrieb_lead",{installMode:'pro',scope,kit:cand.kit,ziel:'kontaktformular'});
    done.innerHTML=`<div class="banner ok">Wird übergeben …</div>`;
    const release=setBusy(go,'Wird übergeben …');
    const gesendet=await submitLead("fachbetrieb_lead",{
      installMode:'pro', scope, kit_gewaehlt:cand.kit, name, tel,
      weiterleitung:'vamo',
      heizlast_kw:cand.c&&cand.c.pausl, plz:A.plz
    });
    release();
    done.innerHTML = gesendet
      ? `<div class="banner ok"><b>Ist raus.</b> Das Vamo-Team meldet sich bei dir, in der Regel innerhalb von zwei Werktagen. Dein Kit-Vorschlag und deine Eckdaten sind mitgegangen.</div>`
      : `<div class="banner warn">Das hat gerade nicht geklappt. Ruf uns gern direkt an: ${esc(CONFIG.SUPPORT_PHONE)}</div>`;
    go.disabled=gesendet;
  };
}

/* ---------------------------------------------------------------------
   Kurzformular: NUR die Felder, die der Rechner gar nicht erhebt.
   Bewusst EINE Seite statt eines zweiten Frage-fuer-Frage-Funnels (User-Vorgabe
   28.07.2026: "kurzes Auswahlfeld mit Vorbild wie der Funnel, aber ohne grosse
   Huerden"). Alles bereits Beantwortete steht sichtbar oben drueber, damit
   erkennbar ist, dass nichts doppelt eingegeben werden muss.
   Reihenfolge und Wortlaut folgen Vamos eigenem DA-1-Flowchart, damit der Kunde
   spaeter dort nicht dieselbe Frage anders formuliert noch einmal sieht.
   --------------------------------------------------------------------- */
const VAMO_LUECKEN = [
  {id:'immoType', frage:'In was für einem Gebäude wohnst du?', pflicht:true, opt:[
    ['Einfamilienhaus / Zweifamilienhaus','Ein- oder Zweifamilienhaus'],
    ['Doppelhaus / Reihenhaus','Doppel- oder Reihenhaus'],
    ['Wohnung','Wohnung'],
    ['Mehrfamilienhaus','Mehrfamilienhaus'],
    ['Gewerbe','Gewerbe'],
    ['Sonstiges','Sonstiges']]},
  {id:'wohneinheiten', frage:'Wie viele Wohneinheiten?', zahl:true, opt:[[1,'1'],[2,'2'],[3,'3 +']]},
  {id:'selbstbewohnt', frage:'Wohnst du selbst darin?', opt:[['ja','Ja'],['nein','Nein']]},
  {id:'denkmal', frage:'Steht das Haus unter Denkmalschutz?', opt:[['Nein','Nein'],['Ja','Ja']]},
  {id:'heizraumEtage', frage:'Auf welcher Etage ist der Heizungsraum?', pflicht:true, opt:[
    ['Keller','Keller'],['Erdgeschoss','Erdgeschoss'],['Obergeschoss','Obergeschoss'],['Dachgeschoss','Dachgeschoss']]},
  {id:'heizraumFlaeche', frage:'Wie viel Platz ist dort frei?', opt:[
    ['mehr als 4 qm','Mehr als 4 m²'],['weniger als 4qm','Weniger als 4 m²']]},
  {id:'heizraumHoehe', frage:'Wie hoch ist der Raum?', opt:[
    ['höher als 199 cm','Über 199 cm'],['180 - 199 cm','180 – 199 cm'],['niedriger als 180 cm','Unter 180 cm']]},
  {id:'wegBreite', frage:'Ist der Weg dorthin überall mind. 65 cm breit?', opt:[['Ja','Ja'],['Nein','Nein']]},
  {id:'wegHoehe', frage:'Und überall mind. 180 cm hoch?', opt:[['Ja','Ja'],['Nein','Nein']]},
  {id:'zeitraum', frage:'Wann soll getauscht werden?', pflicht:true, opt:[
    ['Sofort','Sofort'],['1-3 Monate','1 – 3 Monate'],['3-6 Monate','3 – 6 Monate'],['>6 Monate','Später']]}
];

/* Kurzfassung dessen, was der Rechner schon weiss - reines Anzeigeelement, keine Eingabe. */
function vamoUebernommen(cand){
  const v = vamoVerbrauch();
  return [
    VAMO_SYSTEM_TYPE[A.energy],
    v ? fmt(v.consumption) + ' ' + (v.consumptionUnit === 'Liter (l)' ? 'l' : 'kWh') + '/Jahr' : null,
    VAMO_BAUJAHR[A.baujahr] ? 'Heizung ' + VAMO_BAUJAHR[A.baujahr] : null,
    VAMO_TYPE_OF_HEATING[A.heating],
    A.persons ? A.persons + ' Personen' : null,
    A.plz,
    cand && cand.c && cand.c.pausl ? fmt(cand.c.pausl,1) + ' kW Heizlast' : null,
    cand && PRODUCTS[cand.kit] ? PRODUCTS[cand.kit].name : null
  ].filter(Boolean).map(t=>'<span class="vg-chip">' + esc(String(t)) + '</span>').join('');
}

function renderVamoGaps(cand, r, scope){
  track('vamo_gaps_view',{kit:cand.kit,scope});
  const g = { leadId: vamoLeadId() };
  const reihen = VAMO_LUECKEN.map(f=>`
    <div class="vg-row" data-feld="${f.id}">
      <div class="vg-q">${esc(f.frage)}${f.pflicht?'<i class="vg-req" title="Pflichtangabe">•</i>':''}</div>
      <div class="vg-opts">${f.opt.map(([wert,label])=>
        `<button type="button" class="chipbtn" data-wert="${esc(String(wert))}">${esc(label)}</button>`).join('')}</div>
    </div>`).join('');

  app.innerHTML=`<div class="step">
    <button class="btn quiet" id="vgBack" style="margin-bottom:6px">← Zurück</button>
    <div class="verdict">
      <div class="v-eyebrow">Anfrage an Vamo</div>
      <h2>Kurz noch ein paar Angaben, dann läuft alles automatisch weiter</h2>
      <div class="kwline">Deine Antworten aus dem Rechner gehen mit, die musst du nicht wiederholen.</div>
    </div>
    <div class="buybox vg-box">
      <div class="vg-known">
        <div class="vg-known-title">Wird übernommen</div>
        <div class="vg-chips">${vamoUebernommen(cand)}</div>
      </div>
      <div class="vg-form">${reihen}
        <div class="vg-row">
          <div class="vg-q">Beheizte Wohnfläche</div>
          <div class="vg-num"><input type="number" id="vgFlaeche" min="20" max="2000" inputmode="numeric" placeholder="150" value="${esc(A.wohnflaeche||'')}" aria-label="Beheizte Wohnfläche in Quadratmetern"><span>m²</span></div>
        </div>
      </div>
      <div class="vg-kontakt">
        <div class="svc-block-title">Wohin darf sich Vamo melden?</div>
        <div class="vg-row" data-feld="anrede">
          <div class="vg-q">Anrede</div>
          <div class="vg-opts">${['Frau','Mann','Divers'].map(w=>
            `<button type="button" class="chipbtn" data-wert="${w}">${w}</button>`).join('')}</div>
        </div>
        <div class="vg-grid2">
          <input type="text" id="vgVorname" placeholder="Vorname" autocomplete="given-name" aria-label="Vorname">
          <input type="text" id="vgNachname" placeholder="Nachname" autocomplete="family-name" aria-label="Nachname">
        </div>
        <input type="email" id="vgEmail" placeholder="E-Mail" autocomplete="email" aria-label="E-Mail" value="${esc(A.email||'')}">
        <input type="tel" id="vgTelefon" placeholder="Telefon" autocomplete="tel" aria-label="Telefon">
        <div class="vg-grid-adr">
          <input type="text" id="vgStrasse" placeholder="Straße und Hausnummer" autocomplete="street-address" aria-label="Straße und Hausnummer">
          <input type="text" id="vgPlz" placeholder="PLZ" inputmode="numeric" value="${esc(A.plz||'')}" autocomplete="postal-code" aria-label="Postleitzahl">
          <input type="text" id="vgOrt" placeholder="Ort" autocomplete="address-level2" aria-label="Ort">
        </div>
        <label class="proconsent"><input type="checkbox" id="vgOk">Ja, gebt meine Anfrage samt meiner Angaben aus dem Rechner an Vamo weiter, damit sich jemand wegen der Installation bei mir meldet.</label>
        <label class="proconsent vg-optional"><input type="checkbox" id="vgAssistent">Optional: Der digitale Assistent von Vamo darf mich anrufen. Das geht meist schneller als ein Rückruf von Hand.</label>
        <button class="btn" id="vgGo">Anfrage absenden →</button>
        <div id="vgDone"></div>
      </div>
    </div>
  </div>`;
  triggerEnterAnimation('rechner');

  document.getElementById('vgBack').onclick=()=>renderProLead(cand,r,scope);

  /* Auswahl-Chips: eine Wahl je Zeile, der Wert landet direkt in g.
     Gilt auch fuer die Anrede-Zeile im Kontaktblock, die nicht aus VAMO_LUECKEN kommt. */
  app.querySelectorAll('.vg-row[data-feld]').forEach(zeile=>{
    const id = zeile.dataset.feld;
    const feld = VAMO_LUECKEN.find(f=>f.id===id);
    zeile.querySelectorAll('.chipbtn').forEach(b=>{
      b.onclick=()=>{
        zeile.querySelectorAll('.chipbtn').forEach(x=>x.classList.remove('sel'));
        b.classList.add('sel');
        zeile.classList.remove('vg-fehlt');
        g[id] = (feld && feld.zahl) ? Number(b.dataset.wert) : b.dataset.wert;
      };
    });
  });

  document.getElementById('vgGo').onclick=async()=>{
    const done=document.getElementById('vgDone'), go=document.getElementById('vgGo');
    const lese=id=>(document.getElementById(id).value||'').trim();
    g.vorname=lese('vgVorname'); g.nachname=lese('vgNachname');
    g.email=lese('vgEmail');     g.telefon=lese('vgTelefon');
    g.strasse=lese('vgStrasse'); g.plz=lese('vgPlz'); g.ort=lese('vgOrt');
    g.wohnflaeche=Number(lese('vgFlaeche'))||null;
    g.assistent=document.getElementById('vgAssistent').checked;

    /* Vamo weist einen Lead ohne Name, Telefon oder E-Mail mit 400 ab. Das faengt hier ab,
       bevor der Kunde auf eine Fehlermeldung aus einem fremden System laeuft. */
    const fehlt=[];
    if(!g.vorname) fehlt.push(['vgVorname','Vorname']);
    if(!g.nachname) fehlt.push(['vgNachname','Nachname']);
    if(!istEmail(g.email)) fehlt.push(['vgEmail','E-Mail']);
    if(g.telefon.replace(/[^\d]/g,'').length < 6) fehlt.push(['vgTelefon','Telefon']);
    if(fehlt.length){
      done.innerHTML=`<div class="banner warn">Bitte noch ausfüllen: ${fehlt.map(f=>esc(f[1])).join(', ')}. Ohne Name und Telefon kann sich niemand bei dir melden.</div>`;
      document.getElementById(fehlt[0][0]).focus();
      return;
    }
    const pflichtFehlt = VAMO_LUECKEN.filter(f=>f.pflicht && !g[f.id]);
    if(pflichtFehlt.length){
      pflichtFehlt.forEach(f=>app.querySelector('.vg-row[data-feld="'+f.id+'"]').classList.add('vg-fehlt'));
      done.innerHTML=`<div class="banner warn">Ohne diese Angaben kann Vamo nicht einschätzen, ob es bei dir passt. Die markierten Zeilen fehlen noch.</div>`;
      const erste=app.querySelector('.vg-row.vg-fehlt');
      if(erste && erste.scrollIntoView) erste.scrollIntoView({block:'center',behavior:'smooth'});
      return;
    }
    if(!document.getElementById('vgOk').checked){
      done.innerHTML=`<div class="banner warn">Setz bitte noch den Haken, dann geben wir deine Anfrage weiter.</div>`;
      document.getElementById('vgOk').focus(); return;
    }

    /* Der Blueprint verlangt die Landesvorwahl - fuehrende 0 der Ortsvorwahl faellt dabei weg. */
    if(!g.telefon.startsWith('+')) g.telefon = '+49 ' + g.telefon.replace(/^0/,'');
    A.email = g.email;

    track('fachbetrieb_lead',{installMode:'pro',scope,kit:cand.kit,ziel:'vamo_api'});
    done.innerHTML=`<div class="banner ok">Wird übergeben …</div>`;
    const release=setBusy(go,'Wird übergeben …');
    const body=buildVamoLead(cand,g);
    const antwort=await submitVamoLead(body);
    release();

    if(antwort.ok){
      const d=antwort.daten||{};
      track('vamo_lead_ok',{stage:d.leadStage||'unbekannt'});
      const termin=d.appointmentBookingLink, ergaenzen=d.dataAcquisitionLink;
      done.innerHTML=`<div class="banner ok"><b>Ist raus.</b> Vamo hat deine Anfrage inklusive aller Angaben aus dem Rechner. ${
        termin ? 'Du kannst dir direkt einen Termin aussuchen:'
               : (ergaenzen ? 'Für ein fertiges Angebot fehlen noch ein paar Fotos und Details. Das geht online in wenigen Minuten:'
                            : 'Das Vamo-Team meldet sich in der Regel innerhalb von zwei Werktagen.')}</div>
        ${termin?`<a class="btn" href="${esc(termin)}" target="_blank" rel="noopener">Termin bei Vamo buchen →</a>`:''}
        ${!termin&&ergaenzen?`<a class="btn" href="${esc(ergaenzen)}" target="_blank" rel="noopener">Angaben online vervollständigen →</a>
          <p class="fineprint" style="margin-top:8px">Kein Muss. Vamo meldet sich auch so bei dir.</p>`:''}`;
      go.disabled=true;
      return;
    }

    /* Ab hier ist der Lead NICHT bei Vamo angekommen. Er darf trotzdem nicht verloren gehen:
       der bestehende interne Weg (Webhook bzw. Shop-Postfach) faengt ihn auf, inklusive des
       fertigen Payloads - so kann ihn jemand von Hand nachreichen, ohne den Kunden zu fragen. */
    track('vamo_lead_fehler',{grund:antwort.grund||'unbekannt',status:antwort.status||0});
    if(antwort.status===400 && antwort.daten) console.error('[vamo] Validierung:',antwort.daten.issues||antwort.daten);
    const intern=await submitLead('fachbetrieb_lead',{
      installMode:'pro', scope, kit_gewaehlt:cand.kit, weiterleitung:'vamo',
      vamo_fehler:antwort.grund||'unbekannt', vamo_status:antwort.status||null,
      vamo_payload:body, name:(g.vorname+' '+g.nachname), tel:g.telefon
    });
    if(antwort.grund==='konflikt'){
      done.innerHTML=`<div class="banner ok"><b>Deine Anfrage liegt bereits vor.</b> Vamo hat dich schon im System, es meldet sich jemand. Wenn du unsicher bist, ruf gern durch: ${esc(CONFIG.SUPPORT_PHONE)}</div>`;
      go.disabled=true; return;
    }
    done.innerHTML = intern
      ? `<div class="banner ok"><b>Angekommen.</b> Die direkte Übergabe hat gerade nicht funktioniert, deine Anfrage liegt aber bei uns und wir geben sie von Hand weiter. Wir melden uns innerhalb von zwei Werktagen.</div>`
      : `<div class="banner warn">Das hat gerade nicht geklappt. Ruf uns bitte direkt an: ${esc(CONFIG.SUPPORT_PHONE)}</div>`;
    go.disabled=intern;
  };
}

/* ---- Waitlist: nur wenn wirklich keine Kandidaten existieren (Sonstiges-Energieträger etc.) ---- */
function renderWaitlistForm(r){
  track("waitlist_view",{reason:r.reason,kw:r.c&&r.c.pausl});
  app.innerHTML=`<div class="step">
    <div class="verdict"><div class="v-eyebrow">Noch kein Kit</div>
      <h2>Wir melden uns.</h2>
      <div class="kwline">${esc(r.reason)}</div></div>
    <div class="buybox">
      <div class="emailrow"><input type="email" id="wEmail" value="${esc(A.email||'')}" placeholder="du@beispiel.de"></div>
      <div class="emailrow" style="margin-top:8px"><input type="tel" id="wTel" placeholder="Telefon" autocomplete="tel" required aria-required="true"></div>
      <p class="fineprint" style="margin-top:6px">Beides brauchen wir: Sobald ein passendes Kit da ist, melden wir uns &ndash; und das geht am schnellsten telefonisch.</p>
      <button class="btn" id="wGo" style="margin-top:8px">Auf die Warteliste →</button><div id="wDone"></div>
    </div>
  </div>`;
  document.getElementById('wGo').onclick=async()=>{
    const v=document.getElementById('wEmail').value, done=document.getElementById('wDone'), go=document.getElementById('wGo');
    if(!istEmail(v)){
      done.innerHTML=`<div class="banner warn">Bitte gib eine E-Mail-Adresse an, unter der wir dich erreichen.</div>`;
      document.getElementById('wEmail').focus(); return;
    }
    /* Telefon Pflicht, Format offen - identisch zum zweiten Wartelisten-Formular im Vergleich. */
    const wTelFeld=document.getElementById('wTel');
    const wTel=wTelFeld?wTelFeld.value.trim():'';
    if(wTelFeld && !wTel){
      done.innerHTML=`<div class="banner warn">Wir brauchen noch deine Telefonnummer &ndash; sobald ein passendes Kit da ist, melden wir uns.</div>`;
      wTelFeld.focus(); return;
    }
    A.email=v; speichereStand(); track("waitlist_signup",{});
    done.innerHTML=`<div class="banner ok">Wird gesendet …</div>`;
    /* Riegel VOR dem Versand (25.08.2026).
       Vorher stand der Riegel erst hinter dem await. submitLead() braucht gegen n8n je nach
       Netz 250 ms bis 1,3 s - in diesem Fenster blieb der Knopf klickbar, und ein zweiter
       Klick erzeugte einen zweiten Datensatz. Im CRM stehen dadurch nachweislich Doppel:
       dieselbe Adresse zweimal im Abstand von 51 Sekunden. Die beiden anderen Formulare
       (hwGo 4326, kmGo) sperren bereits vorher - hier war es schlicht vergessen.
       Die Zeile hinter dem await bleibt: sie gibt den Knopf bei MISSERFOLG wieder frei. */
    go.disabled=true;
    const ok=await submitLead("waitlist_signup",{tel:wTel||null});
    done.innerHTML= ok ? `<div class="banner ok">Du stehst drauf.</div>`
      : `<div class="banner warn">Das hat gerade nicht geklappt, bitte später nochmal versuchen.</div>`;
    go.disabled=ok;
  };
}

/* ============================== NAVIGATION: Landing → Rechner ============================== */
/* ============ DER RECHNER STARTET GESCHLOSSEN (02.09.2026) ============
   Auf der Startseite stand der Funnel bisher schon offen da, bevor irgendjemand einen Weg
   gewaehlt hatte. Damit war die Pfad-Weiche darueber eine Behauptung: links "Rechnen lassen"
   anzubieten, waehrend der Rechner darunter ohnehin schon laeuft, entwertet beide Wege.

   Der Inhalt wird trotzdem beim Seitenaufbau gebaut (show(0)/renderLedger weiter unten) - nur
   der Bereich ist zu. Das ist bewusst so: haetten wir das Bauen verschoben, muesste jeder
   Einstiegsweg es nachholen (Tiefenlink, gespeicherter Stand, Kauf-Wiederherstellung), und
   genau dort brechen solche Umbauten.

   Gibt true zurueck, wenn wirklich geoeffnet wurde - der Aufrufer weiss dann, ob er animieren
   soll. */
function funnelOeffnen(){
  const sec=document.getElementById('rechnerCalc');
  if(!sec || !sec.classList.contains('rechner-zu')) return false;
  sec.classList.remove('rechner-zu');
  /* Die Weiche tritt ab: sie hat ihre Aufgabe erfuellt, und zwei Angebote gleichzeitig
     stehen zu lassen macht die Seite wieder unruhig. Der Rueckweg dorthin ist der Knopf
     oben links im Rechner. */
  const weiche=document.getElementById('losgehts');
  if(weiche) weiche.classList.add('weiche-zu');
  /* Die Reveal-Beobachtung lief beim Seitenaufbau ueber einen display:none-Bereich und hat dort
     nichts gesehen. Ohne dieses Nachziehen blieben Fragekarte und Rechenzettel auf opacity:0
     stehen - der Bereich waere zwar da, aber unsichtbar. */
  sec.querySelectorAll('.reveal:not(.in)').forEach(el=>el.classList.add('in'));
  return true;
}
/* Gegenstueck zu funnelOeffnen(): zurueck zur Weiche. Der Stand bleibt im Speicher, es wird
   nichts verworfen - wer wieder auf "Jetzt durchrechnen" geht, steht an derselben Frage. */
function funnelSchliessen(){
  const sec=document.getElementById('rechnerCalc');
  const weiche=document.getElementById('losgehts');
  if(sec) sec.classList.add('rechner-zu');
  if(weiche){
    weiche.classList.remove('weiche-zu');
    weiche.querySelectorAll('.reveal:not(.in)').forEach(el=>el.classList.add('in'));
    weiche.scrollIntoView({behavior:'smooth',block:'start'});
  }
}
function startFunnel(atStep){
  /* Der Rechner steht seit dem Umzug NUR noch auf der Startseite. Auf jeder Unterseite lief
     diese Funktion bis 12.08.2026 ins Leere: das Skript wird ueberall geladen, startFunnel ist
     also ueberall definiert, aber #app existiert dort nicht - der Knopf tat schlicht nichts.
     Betroffen war jeder Aufruf: der Chip oben rechts, der Sticky-CTA am unteren Rand,
     "Rechner oeffnen" auf /pages/produkt und "Zum Rechner" auf /pages/foerderung.
     Statt jeden dieser Knoepfe einzeln anzufassen, entscheidet die Funktion hier selbst:
     kein Rechner auf dieser Seite -> auf die Rechnerseite gehen und ihn dort oeffnen.
     Die Marke #los sagt der Rechnerseite, dass sie den Funnel gleich starten soll; sie ist
     bewusst kein Reiter-Name, damit die Hash-Weiterleitung sie nicht anfasst. */
  if(!app){
    /* Nicht losschicken, wenn wir schon dort sind - sonst liefe der Aufruf gegen sich selbst,
       falls die Rechnerseite einmal fehlen sollte. */
    const ziel='/pages/rechner';
    if(location.pathname.replace(/\/+$/,'')!==ziel) location.href=ziel+'#los';
    return;
  }
  /* Zuerst aufmachen, dann erst scrollen: auf einen display:none-Bereich zu scrollen tut nichts. */
  funnelOeffnen();
  showPanel('rechner');
  if(finished){ finish(); }
  else if(typeof atStep==='number'){ show(atStep); }
  /* sonst: aktueller Stand bleibt einfach stehen */
  /* Scroll robust: einmal sofort und einmal nachdem Panel-Wechsel/Reveals/Cookie-Banner das
     Layout gesetzt haben - sonst landet der Smooth-Scroll je nach Timing ueber dem Rechner
     (Live-Bug: "CTA fuehrt nicht zum Rechner"). */
  const go=()=>{ const el=document.getElementById('rechnerCalc'); if(el) el.scrollIntoView({behavior:'smooth',block:'start'}); };
  go();
  setTimeout(go,400);
  /* Sichtbare Rueckmeldung auf den Klick: Frage und Rechenzettel fahren kurz ein, versetzt.
     Die Klasse wird vorher entfernt und ein Reflow erzwungen, sonst spielt die Animation beim
     zweiten Klick nicht noch einmal. Bei prefers-reduced-motion greift sie gar nicht. */
  const gitter=document.getElementById('funnelGrid');
  if(gitter){
    gitter.classList.remove('faehrt-an');
    void gitter.offsetWidth;
    gitter.classList.add('faehrt-an');
    setTimeout(()=>gitter.classList.remove('faehrt-an'),700);
  }
}
/* Endowment + Goal Gradient in der Topbar: dein Stand wartet */
function syncResume(){
  syncSticky();
  const chip=document.getElementById('resumeChip'); if(!chip) return;
  if(finished){ chip.classList.add('on'); chip.innerHTML = routeAll().candidates.length ? `Deinen Vergleich ansehen →` : `Zum Ergebnis →`; return; }
  /* Der Ausgangstext kommt aus dem Markup (data-start), nicht aus dieser Zeile: Er ist seit dem
     28.09.2026 im Theme-Editor einstellbar, und eine zweite Fassung hier haette ihn beim ersten
     Zustandswechsel ueberschrieben. textContent statt innerHTML - das Attribut traegt Text,
     kein Markup. */
  if(!configStarted){ chip.classList.remove('on'); chip.textContent = chip.dataset.start || 'Jetzt passendes Kit berechnen →'; return; }
  const act=activeSteps(), idx=Math.max(0,act.findIndex(s=>s===STEPS[Math.min(stepIndex,STEPS.length-1)]));
  const c=calc(), kw=c.pausl?` · ${fmt(c.pausl,1)} kW`:'';
  chip.classList.add('on');
  chip.innerHTML=`<span class="pct">${Math.min(idx+1,act.length)}/${act.length}</span>${kw} · weiter →`;
}

/* Sticky Mobile-CTA folgt dem Funnel-Stand: vor dem Start = Einstieg, mittendrin = weiter,
   nach Kit-Wahl = direkt zur Reservierung/Kasse - kein Umweg über erneutes Scrollen/Suchen. */
let currentCand=null;
/* Direktkauf-Modal (Produkt-Tab -> Kit -> "Ich weiß es schon") laeuft komplett am
   currentCand/finished/configStarted-Zustand des Rechner-Funnels vorbei - ohne eigenes Flag hier
   zeigt der Sticky-CTA in diesem Pfad faelschlich "Jetzt selbst bauen" statt "Reservieren". Das war
   bisher unsichtbar, weil das Modal-Backdrop den Sticky-CTA optisch verdeckte (z-index) - erst durch
   die Split-View (Sticky-CTA per z-index sichtbar gemacht) ist der Zustand aufgefallen. */
let directCand=null;
/* Welcher Schritt des Mini-Wizards ist gerade offen? Solange der Kunde noch bei der Hardware steht,
   darf der Sticky-CTA ihn NICHT an der Service-Auswahl vorbei zur Kasse schicken - er hat dann weder
   Foerder-Pflichtservices noch Material gesehen. */
function activeBbStep(prefix){
  const box = prefix==='cm' ? document.getElementById('cartModalBody') : document.querySelector('.buybox');
  if(!box) return null;
  const steps=[...box.querySelectorAll('.bb-step')];
  if(!steps.length) return null;
  const sichtbar=steps.find(s=>!s.classList.contains('hidden'));
  return sichtbar ? sichtbar.dataset.step : null;
}
function syncSticky(){
  const bar=document.getElementById('stickyCta'); if(!bar) return;
  const b=bar.querySelector('button'); if(!b) return;
  if(!bar.dataset.defaultLabel) bar.dataset.defaultLabel=b.innerHTML;
  /* Im Hardware-Schritt fuehrt der Sticky zum naechsten Schritt statt zur Kasse - er spiegelt damit
     genau den Knopf, der ohnehin unten in der Box steht. */
  const weiterZuServices=(prefix,pos)=>{
    b.innerHTML=`Weiter zu Services →`;
    b.onclick=()=>{ track('cta_click',{pos}); const n=document.getElementById(prefix+'ToService'); if(n) n.click(); };
  };
  if(directCand){
    if(activeBbStep('cm')==='hardware') weiterZuServices('cm','sticky_next_step_direct');
    else {
      b.innerHTML = CONFIG.MODE==='deposit' ? kaufKnopfText() : `Zur Kasse →`;
      b.onclick=()=>{ track('cta_click',{pos:'sticky_checkout_direct'}); cartAddDirect(directCand, setBusy(b,'Wird vorbereitet …')); };
    }
  } else if(currentCand && finished){
    if(activeBbStep('bb')==='hardware') weiterZuServices('bb','sticky_next_step');
    else {
      b.innerHTML = CONFIG.MODE==='deposit' ? kaufKnopfText() : `Zur Kasse →`;
      b.onclick=()=>{ track('cta_click',{pos:'sticky_checkout'}); checkout(currentCand, setBusy(b,'Wird vorbereitet …')); };
    }
  } else if(finished){
    b.innerHTML=`Zu deinem Ergebnis →`;
    b.onclick=()=>{ track('cta_click',{pos:'sticky_result'}); startFunnel(); };
  } else if(configStarted){
    /* Auf Mobile ist der Topbar-Chip ausgeblendet - der Sticky übernimmt dessen Fortschrittsanzeige */
    const act=activeSteps(), idx=Math.max(0,act.findIndex(s=>s===STEPS[Math.min(stepIndex,STEPS.length-1)]));
    b.innerHTML=`Weiter im Rechner · Frage ${Math.min(idx+1,act.length)}/${act.length} →`;
    b.onclick=()=>{ track('cta_click',{pos:'sticky_resume'}); startFunnel(); };
  } else {
    b.innerHTML=bar.dataset.defaultLabel;
    b.onclick=()=>{ track('cta_click',{pos:'sticky'}); startFunnel(); };
  }
  beobachteHauptCta();
  if(window.__bwpStickySync) window.__bwpStickySync();
}

/* Die untere Sticky-Leiste ist eine Kruecke fuer genau einen Fall: der echte Knopf ist aus dem
   Bild gescrollt. Steht er im Bild, sind zwei Handlungsaufrufe gleichzeitig sichtbar - und die
   Leiste sagt oft sogar etwas anderes als der Knopf darunter. Deshalb beobachten wir den jeweils
   aktiven Hauptknopf und blenden die Leiste aus, solange er zu sehen ist.
   Der Hauptknopf wechselt mit Kaufweg und Schritt (Hardware -> "Weiter zu Services",
   Services -> "Jetzt reservieren"), und die Kaufbox wird bei jeder Aenderung neu gezeichnet -
   deshalb wird der Beobachter aus syncSticky() heraus jedes Mal neu gesetzt.
   rootMargin unten -76px: was hinter der Leiste liegt, ist nicht "im Bild". Sonst wuerde die
   Leiste sich selbst ueber den Knopf legen, ihn dadurch verdecken und trotzdem verschwinden. */
let __hauptCtaIO=null, __hauptCtaSichtbar=false;
function beobachteHauptCta(){
  if(__hauptCtaIO){ __hauptCtaIO.disconnect(); __hauptCtaIO=null; }
  __hauptCtaSichtbar=false;
  if(!('IntersectionObserver' in window)) return;
  const id = directCand
    ? (activeBbStep('cm')==='hardware' ? 'cmToService' : 'cmAdd')
    : (activeBbStep('bb')==='hardware' ? 'bbToService' : 'buyBtn');
  const el=document.getElementById(id);
  if(!el || el.offsetParent===null) return;   /* kein Hauptknopf sichtbar -> Leiste entscheidet wie bisher */
  __hauptCtaIO=new IntersectionObserver(es=>{
    __hauptCtaSichtbar=es[0].isIntersecting;
    if(window.__bwpStickySync) window.__bwpStickySync();
  },{rootMargin:'0px 0px -76px 0px'});
  __hauptCtaIO.observe(el);
}

/* ============================== PANEL-ROUTER (Punkt 7/8) ==============================
   Hash-basiert, alle Panels bleiben im DOM (hidden-Attribut) - SEO-neutral, crawlbar ohne JS.
   Ein Panel kann aus mehreren Elementen bestehen (z.B. "rechner" = Hero + Funnel + Proof + Reviews +
   End-CTA) - Gruppierung über data-panel statt über ein einziges Wrapper-Element, damit keine
   Elemente durchs DOM verschoben werden müssen.
   Deep-Links (#services) und Zurück-Button funktionieren nativ über hashchange. */
let ALL_PANELS=[...document.querySelectorAll('[data-panel]')];
let PANEL_IDS=new Set(ALL_PANELS.map(p=>p.dataset.panel));
/* Der Theme-Editor tauscht Section-DOM aus - danach zeigen die gecachten Listen auf tote Knoten. */
function refreshPanels(){ ALL_PANELS=[...document.querySelectorAll('[data-panel]')]; PANEL_IDS=new Set(ALL_PANELS.map(p=>p.dataset.panel)); }
/* Verglichen wird gegen die echte Adresse. Vorher stand hier '#'+id, die Links hiessen aber
   schon damals '/#produkt' - die Markierung ist deshalb nie gesetzt worden. Seit dem Umzug
   auf eigene Seiten laesst sie sich ausserdem direkt aus dem Pfad ableiten, ganz ohne
   Umschaltung, und stimmt damit auch beim direkten Aufruf einer Unterseite. */
function updateNavActive(id){
  const ziel=reiterUrl(id);
  /* Zusaetzlich ueber den PFAD vergleichen (16.09.2026): Der Reiter "Rechner" zeigt seit
     heute auf /pages/rechner, waehrend REITER_URL ihn weiterhin auf "/" fuehrt - dort liegt
     der Rechner ja noch. Ohne diesen zweiten Vergleich bliebe die neue Seite unmarkiert.
     Der Vergleich ist allgemein gehalten: Jeder Reiter, dessen Adresse die gerade geoeffnete
     ist, leuchtet - unabhaengig davon, was die Tabelle sagt. */
  const pfad=location.pathname.replace(/\/+$/,'')||'/';
  document.querySelectorAll('.nav a, .navdrawer nav a').forEach(a=>{
    const href=a.getAttribute('href');
    a.classList.toggle('active', href===ziel || href===pfad);
  });
}
function aktiverReiterAusPfad(){
  const pfad=location.pathname.replace(/\/+$/,'')||'/';
  const treffer=Object.keys(REITER_URL).find(k=>REITER_URL[k]===pfad);
  if(treffer) return treffer;
  /* Seiten, die keinem Reiter direkt entsprechen, aber zu einem gehoeren (14.09.2026):
     Eine Produktseite ist eine Kit-Seite, ein Artikel gehoert seit der Zusammenlegung von
     Magazin und Fragen dorthin. Ohne diese Zuordnung fiel alles auf "rechner" zurueck - man
     stellte sein Kit zusammen, und in der Leiste leuchtete der Rechner. */
  if(pfad.indexOf('/products/')===0) return 'produkt';
  if(pfad.indexOf('/blogs/')===0) return 'faq';
  /* Die Startseite ist seit dem 16.09.2026 kein Reiter mehr - sie haengt am Logo. 'home' steht
     in keiner Adressliste, es leuchtet dort also nichts in der Leiste. Frueher stand hier
     'rechner', und genau deshalb war der Rechner-Reiter auf der Startseite markiert. */
  return 'home';
}
function triggerEnterAnimation(id){
  ALL_PANELS.filter(p=>p.dataset.panel===id).forEach(p=>p.querySelectorAll('.reveal').forEach(e=>e.classList.add('in')));
}
/* Sprungziele, die KEIN eigener Reiter sind, sondern ein Abschnitt INNERHALB eines Reiters.
   "Alle Themen ansehen" zeigte auf #forum - das Forum liegt aber im Reiter "faq"
   (data-panel="faq"). showPanel bekam also eine unbekannte Kennung, fiel auf 'rechner'
   zurueck und der Knopf landete auf der Startseite statt beim Forum (User-Meldung 30.07.2026). */
/* magazin gehoert seit der Zusammenlegung zum Fragen-Reiter (15.09.2026). Ohne diesen
   Eintrag schickt showPanel die Marke #magazin auf die alte Seite /pages/magazin - der
   Sprung im Untermenue haette also die Seite gewechselt statt zum Abschnitt zu fuehren. */
/* WAS IST EIN ABSCHNITT IN EINEM REITER - und was ein Reiter fuer sich.

   app UND anleitungsapp WAREN HIER AUF 'ablauf' GESETZT (16.09.2026), als beide Seiten
   zusammengelegt waren. Am 22.09.2026 sind sie wieder getrennt, und die Eintraege waren damit
   nicht bloss ueberholt, sondern schaedlich: showPanel schlaegt fuer eine Unterseite hier nach,
   welcher Reiter gemeint ist, und schickt den Besucher auf dessen Adresse, wenn es ein anderer
   ist als die Seite, auf der er steht. Auf /pages/app hiess das: gemeint ist 'ablauf', also
   location.href='/pages/ablauf#app'. Der Reiter "App" sprang damit sofort zum Ablauf - genau
   so gemeldet.

   anleitungsapp zeigt jetzt auf 'app': Die Sprungmarke gibt es seit der Trennung auf
   /pages/app, nicht mehr auf /pages/ablauf. einbau bleibt beim Ablauf, dort steht sie.
   app selbst ist ein eigener Reiter und hat in dieser Tabelle nichts mehr verloren. */
const ABSCHNITT_IM_REITER={forum:'faq', magazin:'faq', kit:'produkt', kundenbilder:'produkt',
  services:'foerderung', anleitungsapp:'app', einbau:'ablauf'};
/* Auf einer Unterseite gibt es nichts umzuschalten - dort steht genau ein Abschnitt, und der
   gehoert sichtbar. Ohne diesen Ausstieg wuerde der Router unten alles verstecken, was nicht
   zufaellig die gesuchte Kennung traegt, und die Seite kaeme leer beim Besucher an.
   Das Kennzeichen setzt das jeweilige Template (bwp-seite-kopf), es ist auf dem One-Pager
   nicht definiert - dessen Verhalten aendert sich durch diesen Zweig also nachweislich nicht. */
function zeigeEinzelseite(){
  ALL_PANELS.forEach(p=>{ p.hidden=false; });
  ALL_PANELS.forEach(p=>p.querySelectorAll('.reveal').forEach(e=>e.classList.add('in')));
  setTimeout(()=>{ if(typeof markiereScrollbereiche==='function') markiereScrollbereiche(); },60);
  if(window.__layoutAllRoadmapLines) window.__layoutAllRoadmapLines();
  updateNavActive(window.BWP_EINZELSEITE);
  setzeWeiterBlock(window.BWP_EINZELSEITE);
  if(PANEL_IDS.has('faq')) ladeFaqAusApp();
  /* Sprungmarke aus der Adresszeile (#kundenbilder o.ae.) anfahren, sobald die Hoehen stehen. */
  const ziel=location.hash.slice(1);
  if(ziel){ setTimeout(()=>{ const z=document.getElementById(ziel); if(z) z.scrollIntoView({behavior:'smooth',block:'start'}); },90); }
}
function showPanel(id){
  if(window.BWP_EINZELSEITE){
    /* Auf einer Unterseite gibt es nichts umzuschalten - wohl aber etwas anzusteuern. Zeigt der
       Aufruf auf einen FREMDEN Reiter, ist das seit dem Umzug eine andere Adresse; frueher war
       es ein Panel im selben Dokument. Ohne diesen Zweig passierte gar nichts, und der Aufrufer
       lief anschliessend in ein getElementById(...) ins Leere - so ist "Unsere Services ansehen"
       auf /pages/ablauf abgestuerzt statt zu navigieren.
       Abschnittsmarken (services, kit, forum, kundenbilder) reisen als Anker mit. */
    const abschnitt=ABSCHNITT_IM_REITER[id];
    const reiter=abschnitt||id;
    if(REITER_URL[reiter] && reiter!==window.BWP_EINZELSEITE){
      location.href=reiterUrl(reiter)+(abschnitt?'#'+id:'');
      return;
    }
    zeigeEinzelseite();
    /* Eigener Abschnitt auf dieser Seite: einfach hinscrollen. */
    if(abschnitt){ const z=document.getElementById(id); if(z) z.scrollIntoView({behavior:'smooth',block:'start'}); }
    return;
  }
  /* Nach dem Einblenden die seitlich scrollbaren Bereiche neu bewerten - vorher waren ihre
     Breiten 0 und der Wisch-Hinweis konnte nicht entschieden werden. */
  setTimeout(()=>{ if(typeof markiereScrollbereiche==='function') markiereScrollbereiche(); },60);
  const abschnitt = ABSCHNITT_IM_REITER[id];
  if(abschnitt){
    showPanel(abschnitt);
    /* Erst nach dem Einblenden scrollen - vorher hat das Ziel keine Hoehe. */
    setTimeout(()=>{ const z=document.getElementById(id); if(z) z.scrollIntoView({behavior:'smooth',block:'start'}); },90);
    return;
  }
  /* Seiten ohne jedes Panel - Produktseite, Warenkorb, Artikel. Dort gibt es nichts
     umzuschalten, nur die Markierung in der Leiste gehoert gesetzt. Vorher fiel die Kennung
     mangels Panel eine Zeile weiter unten auf "rechner" zurueck; genau daran sprang die
     Leiste auf der Produktseite in den falschen Reiter. Der Sprung nach oben und der
     Weiter-Verweis entfallen hier mit - beide gehoeren zu einem Panelwechsel, den es auf
     diesen Seiten nicht gibt. */
  if(!ALL_PANELS.length){ updateNavActive(id); return; }
  /* Der Rueckfall gilt fuers ANZEIGEN, nicht fuers MARKIEREN: Auf der Startseite tragen die
     Abschnitte historisch data-panel="rechner", sie sollen also erscheinen - aber der Reiter
     "Rechner" gehoert seit dem 16.09.2026 einer anderen Seite und darf hier nicht leuchten. */
  const angefragt=id;
  if(!PANEL_IDS.has(id)) id='rechner';
  ALL_PANELS.forEach(p=>{ p.hidden = (p.dataset.panel!==id); });
  updateNavActive(angefragt);
  window.scrollTo(0,0);
  triggerEnterAnimation(id);
  if(window.__layoutAllRoadmapLines) window.__layoutAllRoadmapLines();
  setzeWeiterBlock(id);
  if(id==='faq') ladeFaqAusApp();
}
/* ============ WEITER-VERWEIS AM ENDE JEDER SEITE (nur Mobile) ============
   User-Vorgabe 30.07.2026: "am Ende jeder einzelnen Seite immer zur naechsten weiterverweisen".
   Auf dem Handy ist die Reiter-Leiste hinter dem Menue-Knopf versteckt - wer unten ankommt, hat
   dort keinen Weg weiter ausser zurueckzuscrollen. Auf Desktop steht die Navigation permanent
   sichtbar, deshalb bleibt der Block dort aus.
   Die Beschriftungen kommen aus der vorhandenen Navigation, damit Umbenennungen im Customizer
   automatisch mitziehen und nichts doppelt gepflegt wird. */
/* Ohne app und magazin: Beide Reiter sind in andere aufgegangen (App in Ablauf, Magazin in
   Fragen) und haben keinen Eintrag in der Leiste mehr. Standen sie hier weiter, boete der
   Weiter-Verweis am Seitenende sie als naechstes Ziel an - und reiterName() faende keinen
   Navigationslink dazu, gaebe also die technische Kennung aus statt eines Namens. */
const REITER=['rechner','produkt','bauteile','ablauf','foerderung','faq'];
/* ============ REITER -> ECHTE ADRESSE (Umzug 12.08.2026) ============
   Bis hierher war jeder Reiter ein #hash auf derselben Seite. Jetzt hat jeder seine eigene
   Adresse. Diese Tabelle ist die Seite dieser Wahrheit im Skript; die Navigation in
   billigerwaermepumpe-topbar.liquid traegt dieselben Ziele.

   Der Rechner liegt auf der Startseite und bekommt bewusst KEINE eigene Unterseite: sie
   traege denselben Inhalt unter zwei Adressen und die beiden naehmen sich gegenseitig die
   Sichtbarkeit - genau das Problem, das der Umzug loesen soll.

   "faq" zeigt seit dem 25.09.2026 auf /pages/wissen-neu (Vorgabe Claras: "ueberall, wo noch
   eine Verlinkung zu der alten Fragen-Seite ist, ersetze sie durch eine Verlinkung zu der
   neuen Wissen-neu-Seite"). Die Panel-Kennung im Code heisst weiter "faq" - sie stammt aus
   der One-Pager-Zeit und steckt in gespeicherten Zustaenden.

   DIESE ADRESSE MUSS ZUR NAVIGATION PASSEN, nicht nur zur Seite: reiterName() sucht unten den
   Namen des Reiters ueber .nav a[href=...]. Steht hier etwas anderes als im Menue, findet die
   Suche nichts und der Reiter heisst ploetzlich "faq". */
/* rechner zeigte bis zum 16.09.2026 auf '/' - dieselbe Adresse wie das Logo. Beide fuehrten
   an dieselbe Stelle, eine Startseite ohne Rechner gab es nicht. */
const REITER_URL={rechner:'/pages/rechner', produkt:'/pages/produkt', bauteile:'/pages/bauteile',
  ablauf:'/pages/ablauf', app:'/pages/app', foerderung:'/pages/foerderung', magazin:'/pages/magazin', faq:'/pages/wissen-neu'};
function reiterUrl(id){ return REITER_URL[id] || '/'; }
function reiterName(id){
  const a=document.querySelector('.nav a[href="'+reiterUrl(id)+'"]');
  return a ? a.textContent.trim() : id;
}
/* DER WEITER-BLOCK IST AM 28.09.2026 ABGESCHALTET (Vorgabe Claras: "am Ende jeder Seite gibt
   es irgendwie noch so eine Navigation mit 'weiter zu Bauteile' und dann Verlinkung zu einer
   anderen Seite - bitte entferne dies auf allen mobilen Seiten").

   Er stand nur unter 900px Breite am Fuss jedes Reiters: ein grosser Knopf zum naechsten
   Bereich und darunter eine Zeile mit allen uebrigen. Gedacht war er als Ersatz fuer die
   Reiter-Leiste, die auf dem Handy hinter dem Burger verschwindet. Inzwischen steht am Ende
   jeder Seite der Footer mit derselben Liste, und direkt darueber die Fragen mit ihrem Verweis
   - der Block war die dritte Navigation auf denselben zwei Bildschirmhoehen.

   ABGESCHALTET, NICHT GELOESCHT: bauWeiterNav() und die Regeln zu .panel-weiter bleiben stehen.
   Zurueckholen heisst, den Schalter unten auf true zu setzen - eine Zeile, kein Wiederaufbau.
   Das Aufraeumen zu Beginn der Funktion laeuft weiter: Es entfernt Bloecke, die ein frueherer
   Aufruf eingehaengt hat, und genau das braucht es beim Wechsel zwischen den Reitern. */
const WEITER_BLOCK_AN = false;
function setzeWeiterBlock(id){
  document.querySelectorAll('.panel-weiter').forEach(e=>e.remove());
  if(!WEITER_BLOCK_AN) return;
  if(!window.matchMedia('(max-width:900px)').matches) return;
  const i=REITER.indexOf(id); if(i<0) return;
  const abschnitte=[...document.querySelectorAll('[data-panel="'+id+'"]')].filter(s=>!s.hidden);
  let letzter=abschnitte[abschnitte.length-1]; if(!letzter) return;
  /* Auf der Startseite gehoert der Verweis VOR den Schluss-Aufruf ("2 Minuten. Dann weisst du,
     was du sparst") - danach waere er hinter dem Abbinder und damit nach dem Schlusspunkt.
     Der Abschnitt traegt keine ID, wird aber ueber .land.dark eindeutig gefunden. */
  const schluss=document.querySelector('section.land.dark[data-panel="rechner"]');
  if(id==='rechner' && schluss){
    const nav=bauWeiterNav(id);
    if(nav){
      /* Hier haengt der Block direkt zwischen zwei Sections, also OHNE die .wrap-Spalte.
         Die Klasse gibt ihm denselben seitlichen Rand und dieselbe Maximalbreite. */
      nav.classList.add("pw-standalone");
      schluss.parentNode.insertBefore(nav,schluss);
    }
    return;
  }
  const nav=bauWeiterNav(id);
  if(nav) (letzter.querySelector(':scope > .wrap') || letzter).appendChild(nav);
}
/* Baut den Block, haengt ihn aber nicht ein - so kann er je nach Reiter an unterschiedlichen
   Stellen landen (Startseite: vor dem Schluss-Aufruf, sonst ganz unten). */
function bauWeiterNav(id){
  const i=REITER.indexOf(id); if(i<0) return null;
  const naechster=REITER[(i+1)%REITER.length];
  const rest=REITER.filter(x=>x!==id&&x!==naechster);
  const nav=document.createElement('nav');
  nav.className='panel-weiter';
  nav.setAttribute('aria-label','Weiter zu anderen Bereichen');
  nav.innerHTML='<a class="pw-next" href="'+reiterUrl(naechster)+'"><span class="pw-kicker">Weiter</span>'
    +'<span class="pw-titel">'+esc(reiterName(naechster))+'</span><span class="pw-pfeil" aria-hidden="true">→</span></a>'
    +'<div class="pw-rest">'+rest.map(x=>'<a href="'+reiterUrl(x)+'">'+esc(reiterName(x))+'</a>').join('')+'</div>';
  return nav;
}
/* ============ FRAGEN AUS DER TRUSTED-FAQ-APP ============
   User-Entscheid 30.07.2026: "Ich moechte, dass wir die Fragen direkt aus der App ziehen."

   Warum ueber den App-Proxy und nicht ueber einen App-Block: unsere Startseite laeuft ueber
   templates/index.liquid, also ein Liquid- und kein JSON-Template. Shopify bietet App-Bloecke
   nur in JSON-Templates an - im Customizer waere die App hier gar nicht auswaehlbar.

   Warum ueber das JSON-LD und nicht ueber das Markup der App: die App legt auf ihrer
   Proxy-Seite ein FAQPage-Schema ab. Das ist ein standardisiertes Format (schema.org) und
   damit weit stabiler als ihre CSS-Klassennamen, die sich mit jedem App-Update aendern koennen.

   Faellt irgendetwas davon aus - Proxy nicht erreichbar, Schema fehlt, Antwort leer - bleiben
   die im Theme gepflegten Fragen einfach stehen. Es gibt also nie eine leere Fragen-Seite. */
const FAQ_APP_PFAD='/apps/frequently-asked-questions';
let faqAppLaeuft=false;
function entschluessele(s){
  /* Die Antworten kommen mit HTML-Entitaeten (&ouml;, &szlig;). textarea.value dekodiert sie,
     ohne dabei Markup auszufuehren - im Gegensatz zu innerHTML. */
  const ta=document.createElement('textarea'); ta.innerHTML=String(s||''); return ta.value;
}
function ladeFaqAusApp(){
  if(faqAppLaeuft) return; faqAppLaeuft=true;
  const wrap=document.querySelector('#faq .wrap'); if(!wrap) return;
  fetch(FAQ_APP_PFAD,{credentials:'same-origin'})
    .then(r=>r.ok?r.text():Promise.reject('Status '+r.status))
    .then(html=>{
      const doc=new DOMParser().parseFromString(html,'text/html');
      const schema=[...doc.querySelectorAll('script[type="application/ld+json"]')]
        .map(s=>{ try{ return JSON.parse(s.textContent); }catch(e){ return null; } })
        .find(j=>j && j['@type']==='FAQPage' && Array.isArray(j.mainEntity) && j.mainEntity.length);
      if(!schema) return Promise.reject('kein FAQPage im Proxy');
      const fragen=schema.mainEntity.map(q=>({
        frage: entschluessele(q.name).trim(),
        antwort: entschluessele(q.acceptedAnswer && q.acceptedAnswer.text).trim()
      })).filter(x=>x.frage && x.antwort);
      if(!fragen.length) return Promise.reject('keine verwertbaren Fragen');

      /* SEKTIONEN (31.07.2026): das FAQPage-Schema kennt keine Kategorien - schema.org sieht
         fuer FAQPage schlicht keine vor. Die Gruppierung steht nur im sichtbaren Aufbau der
         App-Seite: ein Seitenmenue mit den Kategorienamen, und im Hauptbereich stehen
         Kategorie- und Frage-Ueberschriften als h2 in einer Reihe. Ueber den Abgleich mit dem
         Menue laesst sich beides sauber trennen.
         Wichtig: das steht im ausgelieferten HTML, nicht erst nach JavaScript - der DOMParser
         hier sieht es also genauso. Geprueft mit abgeschaltetem JavaScript. */
      const menue=[...doc.querySelectorAll('.s-main-faq__menu-link, .s-main-faq__menu-item')]
        .map(e=>(e.textContent||'').trim()).filter(Boolean);
      const istKat=new Set(menue);
      const sektionFuer={};
      if(istKat.size){
        let aktuell='';
        [...doc.querySelectorAll('h2, h3')].forEach(h=>{
          const t=(h.textContent||'').trim(); if(!t) return;
          if(istKat.has(t)){ aktuell=t; return; }
          if(aktuell && !(t in sektionFuer)) sektionFuer[t]=aktuell;
        });
      }

      /* Eigene Fragen ersetzen - nicht ergaenzen, sonst stuenden sie doppelt da.
         Die Gruppen gehen mit weg, sonst blieben leere Huellen stehen. .faq-sektion ist der
         Vorgaenger aus der ersten Fassung und wird sicherheitshalber mit aufgeraeumt. */
      wrap.querySelectorAll('details.faq, .faq-gruppe, .faq-sektion').forEach(d=>d.remove());

      /* Aufbau identisch zur serverseitigen Fassung: je Sektion ein <details>, darin die
         Fragen eingerueckt. Die erste Gruppe steht offen. */
      const proSektion={};
      fragen.forEach(f=>{ const s=sektionFuer[f.frage]||''; proSektion[s]=(proSektion[s]||0)+1; });
      const ziel=document.createDocumentFragment();
      let letzte='', inhalt=null, erste=true;
      fragen.forEach((f,i)=>{
        const sek=sektionFuer[f.frage]||'';
        if(sek && sek!==letzte){
          const g=document.createElement('details');
          g.className='faq-gruppe reveal in';
          if(erste){ g.open=true; erste=false; }
          g.innerHTML='<summary><span class="fg-name"></span><span class="fg-zahl"></span>'
            +'<span class="ftoggle"></span></summary><div class="faq-gruppe-inhalt"></div>';
          g.querySelector('.fg-name').textContent=sek;
          g.querySelector('.fg-zahl').textContent=proSektion[sek];
          ziel.appendChild(g);
          inhalt=g.querySelector('.faq-gruppe-inhalt');
          letzte=sek;
        }
        const d=document.createElement('details');
        d.className='faq reveal in';
        d.innerHTML='<summary><span class="fidx">F'+String(i+1).padStart(2,'0')+'</span>'
          +'<h3 class="fq"></h3><span class="ftoggle"></span></summary><p></p>';
        d.querySelector('.fq').textContent=f.frage;
        d.querySelector('p').textContent=f.antwort;
        /* Fragen ohne Sektion (Rueckfall) landen ausserhalb der Gruppen, nicht im Nirgendwo. */
        (inhalt||ziel).appendChild(d);
      });
      wrap.appendChild(ziel);

      /* Schema mitziehen: sichtbarer Inhalt und Auszeichnung muessen dieselben Fragen tragen,
         sonst wertet Google das ab. Unser Skript wird ersetzt, nicht ein zweites ergaenzt. */
      const eigenes=[...document.querySelectorAll('script[type="application/ld+json"]')]
        .find(s=>{ try{ return JSON.parse(s.textContent)['@type']==='FAQPage'; }catch(e){ return false; } });
      if(eigenes) eigenes.textContent=JSON.stringify(schema);
      track('faq_app_geladen',{fragen:fragen.length});
    })
    .catch(grund=>{
      console.warn('[faq] Fragen aus der App nicht geladen, Theme-Fragen bleiben stehen:',grund);
      faqAppLaeuft=false;   /* naechster Aufruf darf es erneut versuchen */
    });
}
window.addEventListener('hashchange',()=>showPanel(location.hash.slice(1)||'rechner'));

/* ============================== SPLIT-VIEW "BAUTEILE" ==============================
   Additiver Overlay-Zustand ueber dem normalen Panel-System, ruehrt showPanel() NICHT an.
   splitSource verraet, woher der Checkout kommt, der rechts sichtbar bleiben soll:
   null = kein aktiver Checkout (Nav-Einstieg, #bauteile volle Breite), 'funnel' = #rechnerCalc,
   'modal' = #cartModal (Direktkauf). WICHTIG: nie [data-panel="rechner"] pauschal ansprechen,
   das haengt an vielen fachfremden Sections (Hero, Benefits, Proof, ...) - immer nur #rechnerCalc
   gezielt per ID. */
let splitSource=null;
let splitKey=null;
function enterSplitView(source,key){
  splitSource=source; splitKey=key;
  if(location.hash.slice(1)==='bauteile'){ showPanel('bauteile'); applySplitOverride(); }
  else location.hash='bauteile';
}
function applySplitOverride(){
  if(!splitSource) return;
  document.documentElement.classList.add('bwp-split');
  /* Body-Scroll war beim Direktkauf-Modal-Pfad noch von openCartModal() auf "hidden" - macht Sinn
     fuer ein normales zentriertes Modal, aber die Split-View ist ein persistenter Seitenbereich, der
     das Scrollen der Hauptseite (jetzt auch auf allen anderen Reitern moeglich) nicht blockieren darf. */
  scrollFreigeben('kauf');
  if(splitSource==='funnel'){
    const calc=document.getElementById('rechnerCalc');
    if(calc){
      calc.hidden=false;
      calc.classList.add('bwp-sidebar');
      injectSplitCloseButton();
      void calc.offsetWidth; /* Reflow erzwingen, damit .in wirklich animiert statt zu springen */
      calc.classList.add('in');
    }
  } else if(splitSource==='modal'){
    const modal=document.getElementById('cartModal');
    if(modal){
      modal.classList.add('bwp-sidebar-modal');
      void modal.offsetWidth;
      modal.classList.add('in');
    }
  }
  if(splitKey){
    const det=document.getElementById('bt-'+splitKey);
    if(det) bauteileOpenItem(det);
  }
  if(window.matchMedia('(max-width:760px)').matches) injectMobileBar();
  /* Deterministisch statt auf die Intersection-Observer-Timing der Hero/Qcard-Sichtbarkeit zu
     vertrauen (die auf fremden, ausgeblendeten Panels unzuverlaessig sein kann): Sticky-CTA nach
     jedem Reiter-Wechsel waehrend der Split-View explizit neu bewerten. */
  syncSticky();
}
function exitSplitView(){
  document.documentElement.classList.remove('bwp-split');
  const calc=document.getElementById('rechnerCalc');
  if(calc) calc.classList.remove('bwp-sidebar','in');
  const modal=document.getElementById('cartModal');
  if(modal) modal.classList.remove('bwp-sidebar-modal','in');
  removeSplitCloseButton();
  removeMobileBar();
  splitSource=null; splitKey=null;
  syncSticky();
}
/* Mobile Bottom-Bar: eigene Mini-Zusammenfassung statt der 26vw-Sidebar (die per CSS ab 760px
   ausgeblendet wird), gleicher splitSource-Zustand, nur andere Darstellung. */
function injectMobileBar(){
  let bar=document.getElementById('bwpMobileBar');
  if(!bar){
    bar=document.createElement('div'); bar.id='bwpMobileBar'; bar.className='bwp-mobile-bar';
    bar.innerHTML=`<span class="bwp-mb-text"><b class="bwp-mb-name"></b><span class="bwp-mb-total m"></span></span><span class="bwp-mb-cta">Zurück →</span>`;
    bar.onclick=()=>closeSplitView();
    document.body.appendChild(bar);
  }
  const name=bar.querySelector('.bwp-mb-name'), total=bar.querySelector('.bwp-mb-total');
  if(splitSource==='funnel'){
    name.textContent=document.querySelector('#app h2')?.textContent||'';
    total.textContent=document.getElementById('totalSum')?.textContent||'';
  } else if(splitSource==='modal'){
    name.textContent=document.querySelector('#cartModalBody h2')?.textContent||'';
    total.textContent=document.getElementById('cmTotal')?.textContent||'';
  }
  void bar.offsetWidth;
  bar.classList.add('in');
}
function removeMobileBar(){
  const bar=document.getElementById('bwpMobileBar'); if(bar) bar.remove();
}
function injectSplitCloseButton(){
  const qcard=document.querySelector('#rechnerCalc .qcard');
  if(!qcard || qcard.querySelector('.bwp-split-close')) return;
  const b=document.createElement('button');
  b.type='button'; b.className='bwp-split-close';
  b.textContent='✕ Zurück zum Rechner';
  b.onclick=()=>closeSplitView();
  qcard.prepend(b);
}
function removeSplitCloseButton(){
  const b=document.querySelector('.bwp-split-close'); if(b) b.remove();
}
/* Expliziter Schliessen-Weg (Close-Button, Mobile-Bar-Tap) statt history.back(): wer beim
   Stoebern durch mehrere Reiter die Split-View offen hatte, hat mehrere Eintraege in der
   Hash-History angesammelt - ein einzelnes "zurueck" wuerde dann nur einen Reiter zurueckspringen,
   nicht die Split-View schliessen. */
function closeSplitView(){
  const wasFunnel = splitSource==='funnel';
  exitSplitView();
  if(wasFunnel && (location.hash.slice(1)||'rechner')!=='rechner') location.hash='rechner';
}
/* Registrierung NACH dem showPanel-Listener oben - Listener feuern in Registrierungsreihenfolge,
   applySplitOverride() laeuft also immer NACHDEM showPanel() schon versteckt/gezeigt hat.
   Split-View bleibt jetzt ueber Reiter-Wechsel hinweg bestehen (User-Wunsch) - schliesst nur noch,
   wenn der Rechner-Quell-Pfad ('funnel') zurueck zu #rechner navigiert (Sidebar UND Quelle waeren
   sonst dasselbe Element). Der Modal-Pfad kennt dieses Problem nicht und bleibt in jedem Fall aktiv,
   bis explizit geschlossen wird (Modal-"✕"/closeCartModal, oder der Split-Close-Button). */
window.addEventListener('hashchange',()=>{
  if(!splitSource) return;
  const target=location.hash.slice(1)||'rechner';
  if(splitSource==='funnel' && target==='rechner'){ exitSplitView(); return; }
  applySplitOverride();
});
/* User-Entscheid 29.07.2026: Der Info-Knopf reisst den Kunden nicht mehr aus dem Kauf.
   Frueher startete er die Split-View - der Checkout rutschte nach rechts und die Seite
   wechselte auf "Bauteile". Jetzt bleibt der Checkout stehen und die Infos erscheinen
   daneben. enterSplitView() bleibt fuer den Einstieg ueber die Navigation erhalten. */
document.addEventListener('click',e=>{
  /* NUR KNOEPFE (berichtigt 30.09.2026, Meldung Claras: "die Pfeile in der Konfiguration zu
     den Produktpaketseiten funktionieren nicht, da ist kein Link drin").

     preventDefault() auf einem Verweis nimmt ihm die Wirkung - und genau das ist dem Pfeil
     zur Paketseite passiert, solange er .kb-info trug, um dasselbe Aussehen zu bekommen. Die
     Klasse ist ihm inzwischen genommen (das Aussehen steht jetzt im Stylesheet); diese
     Bedingung faengt den Fall ab, falls sie jemand spaeter wieder an einen Link haengt. */
  const btn=e.target.closest('.kb-info');
  if(btn && btn.tagName!=='A'){ e.preventDefault(); openBauteilBlase(btn.dataset.key,btn); return; }
  /* Klick irgendwo daneben schliesst die Blase - aber nicht innerhalb der Blase selbst
     und nicht auf einem Bedienelement der Kaufbox, sonst waere sie staendig weg. */
  const bl=document.getElementById('kbBubble');
  if(bl && !e.target.closest('#kbBubble')) closeBauteilBlase();
});

/* ============================== INIT ============================== */
function renderLuLanding(){
  const el=document.getElementById('luGridLanding'); if(!el) return;
  /* OHNE WARMWASSERSPEICHER (Vorgabe 16.09.2026). Der Kasten beschreibt, was im Karton
     liegt - und der Speicher liegt nicht darin: Er ist eine eigene Entscheidung im
     Konfigurator, kommt als eigene Position und steht in der Warenkorb-Schublade unter
     eigener Ueberschrift. "200-300 l" las sich hier ausserdem wie ein Versprechen auf
     etwas, das noch gar nicht gewaehlt ist.

     Gefiltert wird NUR hier. In LIEFERUMFANG bleibt der Eintrag stehen, weil
     effektiverLU() ihn als Platzhalter braucht: Ist ein Speicher gewaehlt, ersetzt es ihn
     durch dessen echten Namen; ist keiner gewaehlt, laesst es ihn ohnehin weg. Wer ihn
     dort entfernt, nimmt dem gewaehlten Speicher seinen Platz in der Positionsliste. */
  el.innerHTML=(window.LIEFERUMFANG||[])
    .filter(([,n])=>!/Warmwasser/i.test(n))
    .map(([q,n])=>`<tr><td class="m">${q}</td><td>${esc(n)}</td></tr>`).join("");
}
renderLuLanding();

/* Bauteile-Karten: Auf-/Zuklapp-Animation + "immer nur eine offen" + sauberes Nachscrollen.
   Top-Level-Funktionen (nicht in renderBauteilePanel verschachtelt), damit applySplitOverride()
   beim Klick auf einen Info-Button dieselbe Logik nutzen kann statt sie zu duplizieren. */
function bauteileAnimateOpen(det){
  const grid=det.querySelector('.lu-grid'); if(!grid) return;
  grid.style.overflow='hidden'; grid.style.maxHeight='0px'; grid.style.transition='none';
  requestAnimationFrame(()=>{
    grid.style.transition='max-height .32s cubic-bezier(.2,.8,.2,1)';
    grid.style.maxHeight=grid.scrollHeight+'px';
  });
  grid.addEventListener('transitionend',function te(e){
    if(e.propertyName && e.propertyName!=='max-height') return;
    grid.style.maxHeight='none'; grid.style.overflow=''; grid.style.transition='';
    grid.removeEventListener('transitionend',te);
    det.scrollIntoView({block:'nearest',behavior:'smooth'});
  },{once:true});
}
function bauteileAnimateClose(det,cb){
  const grid=det.querySelector('.lu-grid');
  if(!grid){ det.open=false; if(cb) cb(); return; }
  grid.style.overflow='hidden';
  grid.style.maxHeight=grid.scrollHeight+'px';
  grid.style.transition='none';
  void grid.offsetHeight; /* Reflow erzwingen, sonst greift die Transition unten nicht */
  requestAnimationFrame(()=>{
    grid.style.transition='max-height .28s cubic-bezier(.2,.8,.2,1)';
    grid.style.maxHeight='0px';
  });
  grid.addEventListener('transitionend',function te(e){
    if(e.propertyName && e.propertyName!=='max-height') return;
    det.open=false;
    grid.style.maxHeight=''; grid.style.overflow=''; grid.style.transition='';
    grid.removeEventListener('transitionend',te);
    if(cb) cb();
  },{once:true});
}
/* NIMMT SEIT DEM 29.09.2026 AUCH EINE KACHEL ENTGEGEN. Die Liste der Pakete besteht nicht mehr
   aus <details>-Zeilen, sondern aus Kacheln; das aufklappbare Stueck ist die Positionsliste
   DARIN. Beide Aufrufer suchen weiter das Element mit der Kennung bt-<schluessel> - das ist
   jetzt die Kachel. Diese Zeile findet von dort aus das richtige <details>.

   Ohne sie liefen die zwei Wege ins Leere, die ueber ?teil=<schluessel> und aus der
   Split-Ansicht hierher zeigen: det.open an einem div ist stumm wirkungslos. */
function bauteileOpenItem(det){
  if(!det) return;
  if(det.tagName!=='DETAILS'){
    const drin=det.querySelector('details.bt-kachel-liste');
    if(!drin){ det.scrollIntoView({block:'nearest',behavior:'smooth'}); return; }
    det.scrollIntoView({block:'nearest',behavior:'smooth'});
    det=drin;
  }
  if(det.open){ det.scrollIntoView({block:'nearest',behavior:'smooth'}); return; }
  document.querySelectorAll('#bauteileList details[open]').forEach(other=>{
    if(other!==det) bauteileAnimateClose(other);
  });
  det.open=true;
  bauteileAnimateOpen(det);
}
/* Preisdarstellung der Pakete an einer Stelle, damit Liste und Detailseite nie auseinanderlaufen.
   IMMER zwei Nachkommastellen (Vorgabe 14.09.2026): "35,00 EUR" statt "35 EUR". Alle Betraege
   sind derzeit glatt, stehen aber einheitlich mit Cent da - und ein kuenftiger ,99-Preis wird
   dadurch korrekt gezeigt statt stillschweigend gerundet.
   Deshalb NICHT eur(): das rundet ueber fmt() auf ganze Euro. Richtig fuer PRODUCTS/EXTRAS, wo
   es nie Centbetraege gab, hier aber falsch. Gleiches geschuetztes Leerzeichen wie eur(): U+00A0. */
function zubPreis(n){ return n==null ? '' : fmt(n,2)+" €"; }
/* DIE EINHEIT STEHT AM PREIS, WENN ES EINE GIBT (02.10.2026, Vorgabe Claras: "Erdleitung DN40:
   '95,00 EUR' ergaenzen zu '95,00 EUR pro Meter'").

   WARUM GERADE DORT: Bei jedem anderen Paket ist der Preis der Preis des Pakets. Bei der
   Erdleitung ist er der Preis EINES METERS - und die Zahl ohne Zusatz liest sich wie die Summe
   fuer die ganze Leitung. Das ist kein Schoenheitsfehler, sondern eine Angabe, die etwas
   anderes behauptet, als sie meint.

   ES BETRIFFT NUR DIESES EINE PAKET, und das ist nachgesehen: perMeter:true steht in dieser
   Datei genau einmal, bei erdleitung. Die Regel ist trotzdem allgemein formuliert - kommt ein
   zweites Meter-Paket dazu, steht die Einheit von selbst da.

   KEIN RUECKFALL IN DAS, WAS AM 30.09.2026 ENTFERNT WURDE: Damals fiel auf Vorgabe das "je
   Stueck / je Meter" an JEDER Kachel weg ("bei den Bauteilen kannst du den Preis je Stueck oder
   je Meter weglassen"). Hier steht es nur, wo der Preis ohne die Einheit falsch verstanden
   wird; bei Stueckpreisen bleibt es weg. */
function zubPreisEinheit(paketKey, n){
  const p = zubPreis(n);
  if(!p) return p;
  let m = null;
  try{ m = zubMengeEintrag(paketKey); }catch(e){}
  return (m && m.einheit === 'm') ? p + ' pro Meter' : p;
}

/* ---------- "ZUR KONFIGURATION HINZUFUEGEN" (29.09.2026) --------------------------------
   Vorgabe Claras: "fueg bitte noch einen kleinen Button hinzu, der sagt 'zur Konfiguration
   hinzufuegen', bei der Uebersicht und bei der Paketseite".

   Die Bauteile-Seite konnte bisher nur zeigen. Wer wusste, dass er ein Paket braucht, musste
   es sich anderswo noch einmal zusammensuchen.

   DIE ZUORDNUNG STEHT SCHON IN EXTRAS: Jeder Eintrag dort, der aus einem Paket gebaut ist,
   traegt dessen Schluessel im Feld paket (siehe ausPaket). Diese Funktion dreht die Richtung
   um, statt eine zweite Liste zu pflegen, die beim naechsten neuen Paket vergessen wird.

   DIE BEIDEN SPEICHER SIND DIE AUSNAHME und stehen deshalb ausdruecklich hier: Sie sind kein
   Extra, sondern eine Wahl zwischen 200 und 300 Litern (A.speicherChoice). Wer sie ueber
   EXTRAS anhaken wollte, bekaeme einen Posten, den der Konfigurator nicht kennt.

   OHNE ZUORDNUNG KEIN KNOPF: Kommt spaeter ein Paket dazu, das im Konfigurator nicht
   vorgesehen ist, bleibt seine Kachel eben ohne - besser als ein Knopf, der nichts tut. */
const ZUB_SPEICHER = { p79:'sp200', p82:'sp300' };
/* WELCHES BILD AUF DER KACHEL STEHT, wenn nicht das der ersten Position (29.09.2026, Vorgabe
   Claras: "bei Paket Anschluss UI Zentral bitte das Bild der Armaflex Fastlink in der
   Uebersicht machen").

   Die Kachel nimmt sonst das Bild der ERSTEN Position - bei den meisten Paketen ist das das
   Hauptteil. Beim Anschluss-Paket ist die erste Position eine Schrumpfendkappe; wonach das
   Paket aussieht, ist die Fastlink-Leitung. Diese Tabelle ist die Ausnahme von der Regel und
   nennt den Dateinamen, nicht die Nummer der Position: Kommt eine Position dazu oder faellt
   eine weg, zeigt die Kachel weiter dasselbe Bild. */
const ZUB_KACHELBILD = {
  p35:'kb-armaflex-fastlink-dn25-2m-anschlus.jpg',
  /* Ein Foto aus den Shopify-Dateien (Vorgabe Claras 29.09.2026: "das Bild image bei
     Systemtrennung"). Es zeigt die Pumpengruppe mit Waermetauscher - also das, was das Paket
     ausmacht; die erste Position ist nur die gemischte Gruppe ohne Trennung. */
  p90:'image.png'
};
function zubExtrasSchluessel(paketKey){
  const treffer = Object.keys(EXTRAS).find(k => EXTRAS[k] && EXTRAS[k].paket === paketKey);
  return treffer || null;
}
function zubIstDrin(paketKey){
  if(ZUB_SPEICHER[paketKey]) return A.dhw==='ja' && A.speicherChoice===ZUB_SPEICHER[paketKey];
  const k=zubExtrasSchluessel(paketKey);
  return !!(k && chosenExtras[k]);
}
/* DER KNOPF SCHALTET UM (29.09.2026, Vorgabe Claras: "wenn man bei Bauteile ist und das
   Produktpaket doch nicht will, kann man auch wieder auf den Konfigurationsknopf klicken und
   es somit entfernen").

   Vorher war er nach dem Hinzufuegen abgeschaltet: Er zeigte den Zustand, aber der Weg zurueck
   fuehrte ueber den Warenkorb. Wer ein Paket versehentlich nahm, musste die Seite verlassen.

   KEIN disabled MEHR, und der Titel sagt, was ein zweiter Klick tut. Die Beschriftung bleibt
   die Zustandsmeldung - sie ist die Antwort auf die Frage, die man VOR dem Klick hat. */
function zubKnopfHtml(paketKey){
  if(!ZUB_SPEICHER[paketKey] && !zubExtrasSchluessel(paketKey)) return '';
  const drin=zubIstDrin(paketKey);
  return `<button type="button" class="bt-add${drin?' ist-drin':''}" data-add="${paketKey}"`
       + ` title="${drin?'Noch einmal klicken, um es wieder zu entfernen':'Zur Konfiguration hinzufügen'}">`
       + (drin?'In der Konfiguration ✓':'Zur Konfiguration hinzufügen') + '</button>';
}
/* MENGENREGLER AUF DER BAUTEILE-SEITE (30.09.2026, Vorgabe Claras: "auch bei der Bauteile-Seite
   bei den aufgelisteten Produktpaketen einen Regler machen mit Meteranzahl und Stueckanzahl, bei
   den gleichen wie auch bei der Konfiguration").

   ACHT PAKETE HABEN EINE MENGE, und es sind genau die, die sie im Konfigurator auch haben:
   die Erdleitung nach Metern, die drei Pumpengruppen und die vier EQ3-Geraete nach Stueck.
   Welche das sind, wird nicht hier aufgezaehlt, sondern aus EXTRAS gelesen (perMeter/perUnit) -
   eine zweite Liste liefe beim naechsten neuen Paket auseinander. Pakete ohne Menge bekommen
   keinen Regler, nicht einen mit fester 1.

   AUCH DIE OBERGRENZE KOMMT VON DORT (e.max): 4 Heizkreise bei den Pumpengruppen, 30
   Heizkoerper bei den Thermostaten. Wer hier eine eigene Grenze setzte, liesse auf der einen
   Seite zu, was die andere ablehnt.

   DER SERVERSEITIGE ZWILLING BEKOMMT KEINEN REGLER, und das ist Absicht:
   snippets/bwp-inhalt-bauteileList.liquid zeichnet die Kacheln fuer den ersten Augenblick,
   bevor renderBauteilePanel() sie ersetzt. Die Menge ist aber der Stand DIESES Besuchers - der
   Server kennt ihn nicht und schriebe jedem eine 0 hin, auch dem, der gestern 18 Meter gewaehlt
   hat. Lieber erscheint der Regler einen Wimpernschlag spaeter als kurz mit einer falschen
   Zahl. */
/* HIER STANDEN DER MERKER "ZURUECK AN DIE STELLE, VON DER MAN KAM" UND DER VERWEIS
   "Zurück zur Konfiguration" - beide sind entfallen, und zwar aus demselben Grund.

   DER MERKER ZUERST (30.09.2026 gebaut, 01.10.2026 entfallen): Der Pfeil im Konfigurator legte
   Seite, Scrollhoehe und Paket in den sessionStorage, und die Paketseite fuehrte darueber genau
   dorthin zurueck. Seit der Pfeil ein Fenster ueber der Konfiguration oeffnet
   (paketFensterOeffnen), navigiert er gar nicht mehr: Wer das Fenster schliesst, steht ohnehin
   da, wo er war - ohne Speicher, ohne Rueckfahrt, ohne die Moeglichkeit, dass ein alter Merker
   eine spaetere Sitzung an eine fremde Stelle schickt.

   DER VERWEIS DANACH (01.10.2026, Vorgabe Claras: "bei der Produktseite, ueber die man bei
   Bauteile-Uebersicht kommt, bitte die Verlinkung zu 'Zurück zur Konfiguration' entfernen").
   Er stammte aus der Zeit, als man von der Konfiguration AUS auf diese Seite kam - dann war er
   der Rueckweg. Dieser Hinweg gibt es nicht mehr; wer jetzt hier steht, kam ueber die
   Bauteile-Uebersicht, und fuer den fuehrte er mitten in einen Kauf, den er gar nicht begonnen
   hat. "Zurueck zur Uebersicht" links fuehrt dorthin zurueck, wo man hergekommen ist.

   MIT IHM FAELLT konfigZielUrl() WEG - die Herleitung, welches Kit gemeint ist (chosenCandidate,
   directCand, dann der gespeicherte Stand). Sie hatte keinen zweiten Aufrufer. Wer den Verweis
   zurueckholen will, braucht beides wieder: die Funktion UND die Zeile in renderZubehoerDetail;
   das eine ohne das andere ergibt nichts. */

function zubMengeEintrag(paketKey){
  const k=zubExtrasSchluessel(paketKey); if(!k) return null;
  const e=EXTRAS[k];
  if(!e || !(e.perMeter || e.perUnit)) return null;
  return {k:k, e:e, einheit:e.perMeter?'m':'Stk.', max:e.max||50};
}
/* DER STUECKPREIS IM PAKETFENSTER (13.10.2026, Vorgabe Claras: "fuege bei der Konfiguration
   bitte hinzu, dass wenn man mit dem Stueckregler mehrere Stuecke auswaehlt, bei mehr als
   1 Stueck der Stueckpreis vor dem gesamten Preis - also fuer das jeweilige Produktpaket -
   angezeigt wird").

   IM KONFIGURATOR STAND ER SCHON, nur nicht hier. Die Zeilen der Kaufbox zeigen ihn seit dem
   24.09.2026 und seit dem 12.10.2026 VOR der Summe. Was fehlte, war das Paketfenster - der
   Kasten, der aus dem Konfigurator aufgeht, wenn man ein Paket genauer ansieht. Dort steht
   derselbe Regler und zeigte nur die Summe.

   AUF DER BAUTEILE-SEITE BLEIBT ER WEG, und das ist kein Widerspruch, sondern Claras eigene
   Vorgabe vom 30.09.2026: "bei den Bauteilen kannst du den Preis je Stueck oder je Meter
   weglassen". Dort steht der Regler allein in seiner Kachel, unter einem Paketpreis, der
   ohnehin schon dasteht. Im Konfigurator stehen Pakete nebeneinander und werden verglichen -
   da sagt der Stueckpreis etwas, das sonst fehlt.

   DIE UNTERSCHEIDUNG KOMMT VOM AUFRUFER und wird nicht hier erraten: paketInhaltHtml() weiss,
   ob es fuer das Fenster oder fuer die Seite baut - beide rendern dasselbe Markup, und das ist
   seit dem 01.10.2026 ausdruecklich so gewollt. Ein Blick auf die Umgebung (".liegt das
   gerade in einem .paketfenster?") waere eine Regel, die beim naechsten Umbau still kippt. */
function zubMengeHtml(paketKey, mitEinzel){
  const m=zubMengeEintrag(paketKey); if(!m) return '';
  const q=chosenExtras[m.k]||0;
  /* DER SCHALTER STEHT AM KASTEN, nicht nur in dieser einen Ausgabe. zubMengenAktualisieren()
     zeichnet den Preis bei jedem Klick neu und kennt den Aufrufer nicht mehr - ohne diese
     Markierung waere der Stueckpreis nach dem ersten Druck auf "+" wieder weg. */
  return `<div class="bt-menge" data-menge="${paketKey}"${mitEinzel?' data-einzel="1"':''}>
      <span class="qtystep">
        <button type="button" data-d="-1" aria-label="Weniger">−</button>
        <span class="qv m">${q} ${m.einheit}</span>
        <button type="button" data-d="1" aria-label="Mehr">+</button>
      </span>
      <span class="bt-menge-preis price m">${mengenPreisHtml(q,m.e,!mitEinzel)}</span>
    </div>`;
}
/* EINE STELLE, DIE DIE MENGE SETZT - fuer Regler und Knopf gleichermassen.

   ZIEHT DEN KONFIGURATOR MIT, falls er auf derselben Seite offen ist: Die Paketansicht wird
   auch aus der Kaufbox und dem Warenkorb-Dialog geoeffnet, und dort haengt am selben Paket
   eine Zeile mit Haken, Regler und Zeilenpreis. Bliebe sie stehen, zeigte sie eine Menge, die
   nicht mehr gilt - dieselbe Ueberlegung wie beim Umschalt-Knopf darunter. Auf der
   Bauteile-Seite gibt es diese Zeile nicht; dann passiert hier nichts. */
function zubMengeSetzen(paketKey, q){
  const m=zubMengeEintrag(paketKey); if(!m) return;
  q=Math.max(0, Math.min(m.max, q));
  if(q>0) chosenExtras[m.k]=q; else delete chosenExtras[m.k];
  const cb=document.querySelector('input[type=checkbox][data-x="'+m.k+'"]');
  if(cb){
    cb.checked = q>0;
    const zeile=cb.closest('.xrow') || cb.closest('.buyline');
    if(zeile){
      const qv=zeile.querySelector('.qv'); if(qv) qv.textContent=q+' '+m.einheit;
      const pr=zeile.querySelector('.extra-price'); if(pr) pr.innerHTML=mengenPreisHtml(q,m.e);
    }
  }
  try{ speichereStand(); }catch(e){}
  if(typeof bwpKorbZahl==='function') bwpKorbZahl();
  if(typeof window.bwpKorbZeichnen==='function') window.bwpKorbZeichnen();
  zubKnoepfeAktualisieren();
}
function zubMengenAktualisieren(){
  document.querySelectorAll('.bt-menge').forEach(box=>{
    const m=zubMengeEintrag(box.dataset.menge); if(!m) return;
    const q=chosenExtras[m.k]||0;
    const qv=box.querySelector('.qv'); if(qv) qv.textContent=q+' '+m.einheit;
    const pr=box.querySelector('.bt-menge-preis');
    if(pr) pr.innerHTML=mengenPreisHtml(q,m.e,!box.dataset.einzel);
  });
}

/* ZIEHT DIE KNOEPFE AUF DEN AKTUELLEN STAND (29.09.2026, Vorgabe Claras: "wenn einmal
   hinzugefuegt zu Konfiguration in Bauteile, bitte den Knopf auch so stehen lassen, sodass man
   sieht, es ist hinzugefuegt - wenn man das aus dem Konfigurator entfernt, dann darf der Knopf
   auch wieder in den Standard gehen").

   ZWEI LUECKEN WAREN ZU SCHLIESSEN:

   Beim Laden zeichnet renderBauteilePanel() die Kacheln, LANGE bevor ladeStand() den
   gespeicherten Stand aus dem Browser holt - die Knoepfe kannten den Stand also gar nicht und
   standen nach jedem Neuladen wieder auf Anfang. Deshalb wird nach dem Laden nachgezogen.

   Und wer eine Position in der Warenkorb-Schublade wieder abwaehlt, aendert chosenExtras,
   ohne die Kachel anzufassen. bwpKorbZeichnen() laeuft bei jeder solchen Aenderung; von dort
   aus wird ebenfalls nachgezogen. Der Knopf zeigt damit immer den Stand, nicht die Erinnerung
   an einen Klick. */
function zubKnoepfeAktualisieren(){
  document.querySelectorAll('.bt-add').forEach(btn=>{
    const drin=zubIstDrin(btn.dataset.add);
    btn.classList.toggle('ist-drin',drin);
    btn.disabled=false;
    btn.title = drin ? 'Noch einmal klicken, um es wieder zu entfernen' : 'Zur Konfiguration hinzufügen';
    btn.textContent = drin ? 'In der Konfiguration ✓' : 'Zur Konfiguration hinzufügen';
  });
  /* Die Regler haengen an denselben Daten und werden von denselben Stellen ausgeloest - beim
     Laden, aus der Warenkorb-Schublade, nach jedem Klick auf den Knopf. Sie hier mitzuziehen
     spart es, jede dieser Stellen ein zweites Mal zu ergaenzen und dabei eine zu vergessen. */
  zubMengenAktualisieren();
  /* Der Pfeil am Warmwasserspeicher haengt an derselben Stelle - siehe
     speicherPfeilAktualisieren(). */
  try{ speicherPfeilAktualisieren(); }catch(e){}
}
function zubKnoepfeVerdrahten(wurzel){
  wurzel.querySelectorAll('.bt-add').forEach(btn=>{
    btn.addEventListener('click',e=>{
      e.stopPropagation(); e.preventDefault();
      const key=btn.dataset.add;
      const raus=zubIstDrin(key);
      if(ZUB_SPEICHER[key]){
        if(raus){ A.dhw='nein'; A.speicherChoice=null; }
        else { A.dhw='ja'; A.speicherChoice=ZUB_SPEICHER[key]; }
      } else {
        const k=zubExtrasSchluessel(key); if(!k) return;
        /* UEBER DAS BEDIENELEMENT, WENN ES EINES GIBT: Steht der Konfigurator auf derselben
           Seite offen, haengt am Paket ein Ankreuzfeld. Direkt in chosenExtras zu schreiben
           liesse Haken, Menge und Zeilenpreis dort stehen und etwas zeigen, das nicht mehr
           gilt - dieselbe Ueberlegung wie beim Entfernen aus der Warenkorb-Schublade.
           Auf der Bauteile-Seite gibt es kein solches Feld; dort greift der Rueckfall. */
        const cb=document.querySelector('input[type=checkbox][data-x="'+k+'"]');
        if(raus){
          if(cb && cb.checked){ cb.checked=false; cb.dispatchEvent(new Event('change',{bubbles:true})); }
          else delete chosenExtras[k];
        } else {
          if(cb && !cb.checked){ cb.checked=true; cb.dispatchEvent(new Event('change',{bubbles:true})); }
          else chosenExtras[k]=chosenExtras[k]||1;
        }
      }
      try{ track(raus?'zubehoer_entfernt':'zubehoer_hinzugefuegt',{key}); }catch(e){}
      try{ speichereStand(); }catch(e){}
      /* Die Zahl am Warenkorb und die Schublade dahinter sind die Rueckmeldung, dass etwas
         passiert ist - ohne sie bliebe nur der Knopf, der sich selbst umbeschriftet. */
      if(typeof bwpKorbZahl==='function') bwpKorbZahl();
      if(typeof window.bwpKorbZeichnen==='function') window.bwpKorbZeichnen();
      /* Beschriftung, Titel und Zustand kommen aus einer Hand - sonst laufen der Knopf und
         das, was wirklich gewaehlt ist, beim naechsten Sonderfall auseinander. */
      zubKnoepfeAktualisieren();
    });
  });
  /* DIE REGLER IM SELBEN DURCHGANG: Beide gehoeren zur Kachel, und beide werden nach jedem
     Neuzeichnen neu verdrahtet. Getrennte Aufrufe waeren zwei Stellen, die man gleich halten
     muss. */
  wurzel.querySelectorAll('.bt-menge').forEach(box=>{
    const key=box.dataset.menge;
    box.querySelectorAll('button[data-d]').forEach(b=>b.addEventListener('click',e=>{
      e.stopPropagation(); e.preventDefault();
      const m=zubMengeEintrag(key); if(!m) return;
      const vorher=chosenExtras[m.k]||0;
      zubMengeSetzen(key, vorher + parseInt(b.dataset.d,10));
      const nachher=chosenExtras[m.k]||0;
      try{
        if(nachher>vorher) track('extra_added',{extra:m.k,qty:nachher,path:'bauteile'});
        else if(nachher<vorher) track('extra_removed',{extra:m.k,qty:nachher,ganz_weg:nachher===0,path:'bauteile'});
      }catch(err){}
    }));
  });
}

/* Eine Positionszeile - gleiche Form in der aufgeklappten Karte und auf der Detailseite.
   mitArt blendet die Artikelnummer ein: in der Uebersicht waere sie Ballast, auf der
   Detailseite ist sie der Grund, warum jemand dort nachschlaegt. Positionen OHNE Bild
   werden NICHT ausgeblendet (Vorgabe 14.09.2026) - ein Paket soll vollstaendig sein,
   sonst fehlen Teile ohne jeden Hinweis. Statt des Bildes steht ein gestrichelter
   Platzhalter, wie in bauteilInhaltHtml(). */
/* BESCHREIBUNGEN JE POSITION (29.09.2026, Vorgabe Claras mit Screenshot: "die Beschreibung ...
   bitte unter das passende Produkt als Beschreibung setzen", aufklappbar mit einem Dreieck).

   Der Schluessel ist die ARTIKELNUMMER, nicht der Name: Namen aendern sich beim naechsten
   Tabellenlauf ("2m" wird "2 m"), Artikelnummern nicht.

   HAT EINE POSITION KEINE ARTIKELNUMMER, steht ihr BILDNAME als Schluessel - der Speicher und
   die gemischte Pumpengruppe sind solche Faelle. Der Bildname ist zwar aus dem Produktnamen
   erzeugt, aber er ist eine Datei im Theme: Er kann sich nicht nebenbei aendern, ohne dass
   jemand das Bild mit umbenennt. Die Suche laeuft erst ueber die Nummer, dann ueber das Bild. Die Tabelle ist leer, solange die
   Texte fehlen - Clara will sie aus den Datenblaettern ziehen, die dafuer erst zugeordnet
   werden muessen. Eine Position ohne Eintrag bleibt eine Zeile ohne Aufklapper.

   DIE PAKETBESCHREIBUNG WANDERT AN DIE ERSTE POSITION, solange hier nichts steht: Sie
   beschreibt in aller Regel das Hauptteil - im Beispiel der Wanddurchfuehrung den Dichteinsatz,
   und der ist die erste Position. Dieselbe Annahme traegt schon das Kachelbild. */
const ZUB_POS_TEXT = {
  /* Armaflex Fastlink, im Paket "Anschluss UI Zentral" (p35). */
  'FL-AV-19X25/E02': {
    dok: [{ art:'Produktbroschüre', datei:'armaflex-fastlink-product-brochure_1.pdf' }],
    text: 'Vorgedämmte Systemlösung, um die Außeneinheit an die Hydraulikstation anzubinden: '
        + 'zwei flexible Edelstahlwellrohre in GEG-konformer Dämmung, mit UV- und '
        + 'witterungsbeständiger Folie ummantelt und mit Schnellkupplungen versehen. '
        + 'Verschraubt statt gelötet, und dank des Wellrohrs auch bei beengten Platzverhältnissen '
        + 'zu verlegen. Dieses Set ist für DN 25 ausgelegt und 2 m lang.'
  },
  /* Dichteinsatz Curaflex Nova Senso, im Paket "Wanddurchfuehrung UI Zentral" (p31). */
  'DOCNUMS20096': {
    dok: [
      { art:'Montageanleitung', datei:'Dichteinsatz_Curaflex_Nova_Senso_DN200_f._139-141_mm_Doyma_Montageanleitung.pdf' },
      { art:'Datenblatt',       datei:'Dichteinsatz_Curaflex_Nova_Senso_DN200_f._139-141_mm_Doyma_Datenblatt.pdf' }
    ],
    text: 'Dichtet in der Wanddurchführung Rohre mit strukturierter Oberfläche ab – gewellte '
        + 'Kunststoffmantelrohre und flexible Kabelschutzrohre. Beim Einbau zeigt die Mutternseite '
        + 'zur wasserabgewandten Seite; Knackgeräusche beim Verspannen sind normal und zeigen an, '
        + 'dass die Ringhälften fest verkeilt sind. Bei korrekter Montage wartungsfrei, aber nur '
        + 'für den einmaligen Einbau geeignet.'
  },
  /* Fuellstation CLEAR PRO FILL All-in-One, im Paket "Fuellstation" (p75). */
  'CLEARPFSA': {
    dok: [{ art:'Produktdatenblatt', datei:'Conel_All_in_One_Datenblatt.pdf' }],
    text: 'Anschlussmodul, um die geschlossene Heizungsanlage mit enthärtetem, vollentsalztem oder '
        + 'pH-stabilisiertem Wasser zu befüllen – welches davon, entscheidet die eingesetzte '
        + 'Kartusche. Systemtrenner BA und Druckminderer sind eingebaut, die Befüllung läuft damit '
        + 'automatisch. Dazu Absperrungen vor und hinter der Kartusche für den Wechsel, eine '
        + 'umstellbare Verschneidung, eine Multi-Controll zur Steuerung und ein Wandhalter.'
  },
  /* Lapesa HL-Speicher 300 l, im Paket "Warmwasserspeicher 300 l" (p82). NICHT von Clara
     benannt, sondern beim Durchprobieren der Dateinamen gefunden - der Name der Datei ist
     der Produktname aus der Tabelle mit angehaengtem "_Datenblatt". */
  'kb-lapesa-hl-speicher-300-ltr-emailli.png': {
    dok: [{ art:'Datenblatt', datei:'Lapesa_HL-Speicher_300_Ltr._Emailliert_Typ_CV-300-HL_WT_3_1qm_Datenblatt.pdf' }],
    text: 'Brauchwasserspeicher mit 300 Litern Nenninhalt und 3,1 m² Wärmetauscherfläche – die '
        + 'grosse Fläche ist für Wärmepumpen entscheidend, weil sie mit niedrigen Vorlauf'
        + 'temperaturen arbeiten. Stahl S 275 JR, innen emailliert nach DIN 4753, aussen '
        + 'FCKW-freier PU-Hartschaum. Kathodischer Schutz über eine Magnesiumanode mit '
        + 'Anodentester, dazu Revisionsflansch, Schaltfeld mit Thermometer und Stellfüsse. '
        + '1685 mm hoch, 620 mm Durchmesser.'
  },
  /* COSMO 3.0 Pumpengruppe gemischt DN 25, in "Gemischte Pumpengruppe" (p85) und
     "Gemischter Kreis mit Systemtrennung" (p90). Ebenfalls beim Durchprobieren gefunden.

     DAS PDF IST DIE ANLEITUNG DES STELLANTRIEBS, nicht die der Pumpengruppe: Der Dateiname
     nennt die Gruppe, der Inhalt beschreibt durchweg den 3-Punkt-Stellantrieb CSM1, der auf
     ihr sitzt. Deshalb heisst der Knopf auch so - wer die Anleitung der Gruppe sucht, soll
     nicht erst die PDF oeffnen muessen, um zu merken, dass er sie hier nicht findet. */
  'kb-cosmo-3-0-pumpengruppe-gemischt-dn.jpg': {
    dok: [{ art:'Montageanleitung Stellantrieb', datei:'COSMO_3.0_Pumpengruppe_gemischt_DN_25_COSMO_Pumpe_CPH_2.0_6-25_Montageanleitung.pdf' }],
    text: 'Gemischte Pumpengruppe DN 25 mit Hocheffizienzpumpe: Sie regelt die Vorlauf'
        + 'temperatur eines Heizkreises herunter, indem sie Rücklaufwasser beimischt – nötig, '
        + 'sobald ein Kreis kühler laufen soll als der Rest der Anlage. Den Mischer bewegt der '
        + '3-Punkt-Stellantrieb CSM1, der sich über einen Handbetriebeinsteller auch von Hand '
        + 'drehen lässt und an einen witterungsgeführten Regler angeschlossen wird.'
  }
};
/* Adressen der PDFs aus den Shopify-Dateien. Gleicher Weg wie bei den Bildern: konfigurator.js
   ist ein JS-Asset und kann file_url nicht selbst aufloesen, deshalb reicht Liquid sie herein
   (snippets/bwp-katalog-bilder.liquid). Wer eine PDF ergaenzt, traegt sie an beiden Stellen ein -
   oben den Dateinamen, drueben die Adresse. Fehlt die Adresse, zeigt die Position ihren Text
   und keinen Knopf; die Seite bleibt heil. */
const ZUB_PDF = window.__BWP_ZUB_PDF_URLS || {};

/* WAS CLARA IM THEME-EDITOR SCHREIBT, SCHLAEGT DIE TABELLE OBEN (30.09.2026, Vorgabe: "kannst
   du den Abschnitt Bauteile bitte so machen, dass ich ihn haendisch bearbeiten kann").

   Die Bloecke der Section billigerwaermepumpe-bauteile legen window.__BWP_ZUB_TEXTE an - je
   Produkt ein Text und wahlweise eine PDF mit fertiger Adresse. Dieselbe Regel wie ueberall
   sonst im Theme: Was in Shopify gepflegt wird, steht ueber dem, was im Code hinterlegt ist.

   FELDWEISE UND NICHT ALS GANZES: Wer nur den Text aendert, soll nicht das Datenblatt
   verlieren, und wer nur eine PDF anhaengt, nicht die Beschreibung. Ein leeres Feld im Editor
   heisst deshalb "nimm, was im Code steht" - und nicht "loesche es".

   NUR AUF DER BAUTEILE-SEITE: Die Bloecke gehoeren zu deren Section, also liegt die Variable
   auch nur dort. Ruft die Kaufbox oder der Warenkorb-Dialog dieselbe Ansicht auf einer anderen
   Seite auf, greift weiter die Tabelle im Code. Das faellt nicht auf, solange beide dasselbe
   sagen - nach einer Aenderung im Editor laufen sie auseinander, und das ist der Preis dafuer,
   dass die Texte ueberhaupt pflegbar sind. */
function zubPosEintrag(q){
  const ed = window.__BWP_ZUB_TEXTE || {};
  const fest = (q.a && ZUB_POS_TEXT[q.a]) || (q.img && ZUB_POS_TEXT[q.img]) || null;
  const eig  = (q.a && ed[q.a]) || (q.img && ed[q.img]) || null;
  if(!fest && !eig) return null;
  const dokEig = (eig && eig.dok || []).filter(x=>x && x.url);
  return {
    text: (eig && eig.text) || (fest && fest.text) || '',
    dok:  dokEig.length ? dokEig
                        : ((fest && fest.dok || []).map(x=>({art:x.art, url:ZUB_PDF[x.datei]||''})))
  };
}
function zubPosZeile(q, mitArt){
  const bild=q.img?ZUB_IMG[q.img]:null;
  const art=(mitArt && q.a)?`<span class="bt-pos-art">Art.-Nr. ${esc(q.a)}</span>`:'';
  return `<div class="bt-pos">
      ${bild?`<img class="bt-pos-img" src="${esc(bild)}" alt="${esc(q.n)}" width="44" height="44" loading="lazy">`
            :`<span class="bt-pos-img bt-pos-img--leer" aria-hidden="true"></span>`}
      <span class="bt-pos-name">${esc(q.n)}${art}</span>
      <span class="bt-pos-qty m">${q.q}×</span>
    </div>`;
}

/* Zubehoer-Panel (Reiter "Zubehoer", Stand 14.09.2026): listet die Pakete aus ZUBEHOER_PAKETE
   als aufklappbare Karten, gleiches Akkordeon-Idiom wie die Gruppen in #extraList - kein neuer
   Expand-Mechanismus. Bis dahin kamen die Karten aus componentCatalog(); jene Quelle speist
   weiterhin die ⓘ-Blase im Checkout (openBauteilBlase) und bleibt deshalb bestehen. */
function renderBauteilePanel(){
  const el=document.getElementById('bauteileList'); if(!el) return;
  const items=ZUBEHOER_PAKETE;
  /* Art der Bereitstellung (Spalte M): Steht sie bei ALLEN Paketen gleich, wird sie in der
     Liste gar nicht genannt (Vorgabe 14.09.2026) - ein Satz, der fuer jedes Paket dasselbe
     sagt, traegt nichts bei. Auf der Detailseite steht sie weiterhin je Paket. Sobald
     Pakete mit abweichender Art dazukommen, faellt die Bedingung um und jede Karte zeigt
     ihre eigene. */
  const arten=[...new Set(items.map(p=>p.bereit).filter(Boolean))];

  /* KACHELN STATT LISTE (29.09.2026, Vorgabe Claras: "kannst du auf dem Reiter Bauteile bitte
     die Aufzaehlung nicht mehr als Liste machen, sondern auch in so Kacheln mit einem Button,
     der sagt 'Paket ansehen'").

     Vorher war jedes Paket eine Zeile zum Aufklappen. Zwanzig gleich aussehende Zeilen
     untereinander sagen nichts darueber, was ein Paket IST - man musste jede einzeln oeffnen.
     Die Kachel zeigt es: Bild, Name, Preis, ein Knopf.

     DAS BILD IST DAS DER ERSTEN POSITION. Ein eigenes Paketbild gibt es nicht; die erste
     Position ist in dieser Tabelle das Hauptteil (die Pumpengruppe, der Speicher, die
     Durchfuehrung) - das Uebrige gehoert dazu. Fehlt es, bleibt die Flaeche leer und die
     Kachel steht trotzdem.

     DIE POSITIONSLISTE BLEIBT IN DER KACHEL, eingeklappt hinter "N Positionen". Sie ist der
     Grund, warum diese Seite ueberhaupt etwas zu indexieren hat: Die Detailansicht je Paket
     entsteht erst im Browser und steht in keinem ausgelieferten HTML. Haetten die Kacheln nur
     Namen und Preis, verloere die Seite alle Produktnamen auf einmal.

     ZWEI WEGE, EIN ZIEL: Der Knopf oeffnet die volle Ansicht des Pakets (wie vorher
     "Details"), die Zeile darunter klappt die Positionen an Ort und Stelle auf. Wer nur
     nachsehen will, was drin ist, muss die Seite nicht verlassen. */
  el.innerHTML = items.map(p=>{
    const art = (arten.length>1 && p.bereit) ? ` <span class="tag">${esc(p.bereit)}</span>` : '';
    const bildDatei = ZUB_KACHELBILD[p.key] || (p.pos.length ? p.pos[0].img : null);
    /* Theme-Bild zuerst, dann Shopify-Datei - die Karten sind getrennt, weil Liquid fuer
       beides einen anderen Filter braucht. */
    const ersteBild = bildDatei ? (ZUB_IMG[bildDatei] || ZUB_DATEI[bildDatei] || null) : null;
    const n = p.pos.length;
    return `<div class="bt-kachel" id="bt-${p.key}" data-key="${p.key}">
      <div class="bt-kachel-bild">${ersteBild
        ? `<img src="${esc(ersteBild)}" alt="${esc(p.name)}" width="300" height="300" loading="lazy">`
        : ''}</div>
      <div class="bt-kachel-kopf">
        <span class="bt-item-name">${esc(p.name)}${art}</span>
        <span class="price">${zubPreisEinheit(p.key, p.price)}</span>
      </div>
      <a class="btn bt-detail-link" href="${reiterUrl('bauteile')}?zubehoer=${encodeURIComponent(p.key)}">Paket ansehen</a>
      ${zubKnopfHtml(p.key)}
      ${zubMengeHtml(p.key)}
      <details class="bt-kachel-liste">
        <summary>${n} ${n===1?'Position':'Positionen'}</summary>
        <div class="lu-grid">${p.pos.map(q=>zubPosZeile(q,false)).join('')}</div>
      </details>
    </div>`;
  }).join('');

  /* KEIN KLICK-HOERER MEHR AN "Paket ansehen" (29.09.2026, Vorgabe Claras: "wenn man auf
     Paket ansehen klickt, wird das eine neue Seite").

     Vorher tauschte ein Klick den Inhalt an Ort und Stelle aus: dieselbe Adresse, kein
     Eintrag in der Verlaufsliste, der Zurueck-Knopf des Browsers fuehrte von der Paketansicht
     gleich von der Seite herunter, und ein Paket liess sich nicht verschicken oder als
     Lesezeichen sichern.

     Jetzt ist es ein gewoehnlicher Verweis auf ?zubehoer=<schluessel>. Den Weg gibt es seit
     dem 24.09.2026 schon - er wird beim Laden ausgewertet und oeffnet genau diese Ansicht.
     Es ist also keine neue Mechanik, sondern die vorhandene, jetzt auch von hier aus benutzt.

     DIE INNEN AUFGERUFENE ANSICHT BLEIBT: renderZubehoerDetail() wird weiterhin aus der
     Kaufbox und dem Warenkorb-Dialog heraus gerufen, dort ohne Seitenwechsel - der Kunde soll
     seinen laufenden Kauf nicht verlassen. */
  zubKnoepfeVerdrahten(el);
  /* Zurueck aus der Paketansicht: Der Behaelter ist wieder das Kachelraster. */
  el.classList.remove('zeigt-detail');
}

/* Detailseite EINES Pakets: ersetzt die Liste, gleiches Swap-Prinzip wie renderBauteileDetail()
   fuer die alten Bauteile - kein neuer Routing-Mechanismus.

   Eigene Funktion und nicht renderBauteileDetail(): jene liest componentCatalog() und kennt die
   Pakete nicht. Beschreibung, Montagehinweis und Datenblattwerte kommen ueber p.info aus
   COMPONENT_DETAILS/COMPONENT_TECHNIK - denselben Tabellen, aus denen sich auch die ⓘ-Blase
   bedient. Wo kein Text hinterlegt ist (4 der 16 Pakete), steht der uebliche
   "folgt in Kuerze"-Platzhalter statt einer leeren Seite. */
/* opts.ohneSprung = der Aufrufer kuemmert sich selbst um die Blickposition.

   GEBRAUCHT VON DER EIGENEN PAKETSEITE (?zubehoer=). Dort war der Sprung unten sogar
   schaedlich: scrollIntoView rechnet EINMAL aus, wie weit gescrollt werden muss, und
   animiert dann dorthin. Unmittelbar danach setzt der Aufrufer die Klasse bwp-paketseite
   und blendet Kopfband, Listentitel und Werkzeug-Abschnitt aus - der Inhalt darueber
   schrumpft also um mehrere hundert Pixel, waehrend die Animation noch auf den alten Wert
   zulaeuft. Man landet entsprechend zu weit unten; Clara kam am Seitenende bei "Fragen
   dazu" heraus (gemeldet 29.09.2026).

   Aus der Kaufbox und dem Warenkorb-Dialog bleibt der Sprung richtig: Dort ist die Ansicht
   ein Einschub mitten in einer laengeren Seite, und ohne ihn passiert sichtbar nichts. */
/* DER INHALT EINES PAKETS - Kopf und Positionsliste, ohne Rahmen und ohne Rueckwege.

   EINE QUELLE, ZWEI DARSTELLUNGEN (01.10.2026): die Paketseite unter /pages/bauteile und das
   Fenster, das im Konfigurator aufgeht. Bis hierhin stand das Markup nur in
   renderZubehoerDetail; das Fenster haette es kopieren muessen, und die beiden waeren beim
   naechsten gepflegten Text auseinandergelaufen - genau der Fehler, der an diesem Projekt
   schon zweimal aufgetreten ist (zwei Masken, zwei Rabattpfade).

   OHNE RUECKWEGE: Die Seite will "Zurueck zur Uebersicht" und "Zurueck zur Konfiguration", das
   Fenster ein Kreuz. Was sich unterscheidet, bleibt beim Aufrufer. */
function paketInhaltHtml(p, imFenster){
  const d=(p.info && COMPONENT_DETAILS[p.info])||{};
  return `<div class="bt-detail-head zub-head">
      <h3>${esc(p.name)}</h3>
      <span class="price">${zubPreisEinheit(p.key, p.price)}</span>
      ${zubKnopfHtml(p.key)}
      ${zubMengeHtml(p.key, imFenster)}
    </div>
    <div class="bt-detail-body">
      <div class="lu-grid bt-detail-pos">${p.pos.map((q,i)=>{
        const eintrag = zubPosEintrag(q);
        /* Beschreibung: erst die je Artikelnummer, sonst - nur bei der ersten Position - die
           des Pakets. */
        const text = (eintrag && eintrag.text) || (i===0 && d.description ? d.description : '');
        /* Die Adresse entscheidet, nicht der Dateiname: Steht die PDF in der Tabelle, aber
           Liquid hat keine Adresse geliefert (Datei in Shopify geloescht oder umbenannt), faellt
           der Knopf weg statt ins Leere zu fuehren. */
        const dok = ((eintrag && eintrag.dok) || []).filter(x=>x.url);
        const zeile = zubPosZeile(q,true);
        if(!text && !dok.length) return zeile;
        const knopf = dok.length
          ? `<p class="bt-pos-pdf">${dok.map(x=>`<a class="btn quiet" href="${esc(x.url)}"
               target="_blank" rel="noopener"
               onclick="track('datenblatt_open',{art:${JSON.stringify(x.art||'PDF')},teil:${JSON.stringify(q.a||'')}})"
               >${esc(x.art||'Datenblatt')} (PDF)</a>`).join('')}</p>`
          : '';
        return `<details class="bt-pos-item">
          <summary>${zeile}<span class="bt-pos-chev" aria-hidden="true">▾</span></summary>
          ${text?`<p class="bt-pos-text">${esc(text)}</p>`:''}
          ${knopf}
        </details>`;
      }).join('')}</div>
    </div>`;
}

function renderZubehoerDetail(key, opts){
  /* Gegenstueck zu svc_detail_open im Servicebereich: welches Bauteil sich jemand genauer
     ansieht, bevor er es dazunimmt oder weglaesst. Auf der Produktseite ist das die
     haeufigste Handlung ueberhaupt und war bisher nicht messbar. */
  try{ track('zubehoer_detail_open',{key:key||null}); }catch(e){}
  const el=document.getElementById('bauteileList'); if(!el) return;
  const p=ZUBEHOER_PAKETE.find(x=>x.key===key); if(!p) return;
  track('bauteil_detail_view',{key});
  const d=(p.info && COMPONENT_DETAILS[p.info])||{};
  /* DIE ZEILE "Bereitstellung: Dazu bestellbar" IST WEG (29.09.2026, Vorgabe Claras). Sie stand
     als Kleingedrucktes unter der Stueckliste und sagte bei jedem Paket dasselbe - alle sechzehn
     tragen "Dazu bestellbar". Ein Satz, der fuer alles gilt, unterscheidet nichts.

     Das Feld p.bereit bleibt in den Daten: Die Uebersicht blendet es als Kennzeichen ein,
     sobald es einmal Pakete mit verschiedener Bereitstellung gibt (siehe arten in
     renderBauteilePanel). Genau diese Bedingung ist der Grund, warum es hier verschwinden
     kann, ohne eine Unterscheidung zu verlieren.

     AUCH DIE MONTAGE IST VON DER PAKETSEITE WEG (29.09.2026, Vorgabe Claras: "Montage kannst
     du bitte auch entfernen aus allen Produktpaketseiten").

     Hier stand unter der Ueberschrift "Montage" der Anleitungstext aus COMPONENT_DETAILS - ein
     Absatz, der in knappen Worten sagte, wie das Teil eingebaut wird. Aus demselben Grund wie
     die technischen Daten: Die Montageanleitung des Herstellers soll zum Herunterladen
     danebenstehen, und eine Kurzfassung daneben ist eine zweite Wahrheit.

     Der Text bleibt in COMPONENT_DETAILS und erscheint weiter in der Info-Blase des
     Konfigurators und in der aelteren Bauteil-Detailansicht.

     KEINE TECHNISCHEN DATEN MEHR AUF DER PAKETSEITE (29.09.2026, Vorgabe Claras: "bei allen
     Produktpaketseiten bitte die technischen Daten entfernen, die brauchen wir nicht, weil wir
     die downloadbar machen").

     Hier stand eine Tabelle aus COMPONENT_TECHNIK - Masse, Anschluesse, Leistungswerte -, dazu
     die geprueften Normen und die Quelle des Herstellerdatenblatts. Das Datenblatt selbst soll
     kuenftig zum Herunterladen danebenstehen; eine abgetippte Auswahl daraus ist dann eine
     zweite Wahrheit, die beim naechsten Modellwechsel niemand mitpflegt.

     DIE DATEN SIND NICHT GELOESCHT: COMPONENT_TECHNIK steht unveraendert im Skript und fuellt
     weiter den Produkt-Infokasten der Kit-Seiten und die Info-Blase im Konfigurator. Nur diese
     eine Darstellung ist fort - die Zeile unten setzt sie wieder ein, wer sie zurueckwill.

     AUCH DIE MODELLZEILE IST FORT (29.09.2026, Vorgabe Claras mit Screenshot: "den
     eingekreisten Teil unter dem Button 'Zur Konfiguration hinzufuegen' bitte entfernen").
     Sie stand als Kasten unter dem Knopf und wiederholte, was zwei Zeilen darunter noch einmal
     als erste Position der Stueckliste steht - mit Bild, Artikelnummer und Menge. Von den
     beiden ist die Position die vollstaendigere.

     COMPONENT_TECHNIK wird auf dieser Seite deshalb gar nicht mehr gelesen. Die Tabelle steht
     unveraendert im Skript und fuellt weiter Infokasten und Info-Blase. */
  /* DER BEHAELTER IST EIN RASTER, SEIT DIE PAKETE KACHELN SIND (29.09.2026, Meldung Claras:
     "wenn man auf Paket ansehen klickt, dann geht das Paket nicht ueber die komplette Seite,
     sondern nur in der Breite wie der Kasten vorher"). Genau das war es: Die Paketansicht wurde
     selbst zum Rasterfeld und bekam die 240px einer Kachelspalte. Diese Klasse schaltet das
     Raster fuer die Dauer der Ansicht ab; renderBauteilePanel() nimmt sie wieder weg. */
  el.classList.add('zeigt-detail');
  /* DER RUECKWEG STEHT LINKS (29.09.2026, Vorgabe Claras: "bei Produktpaket-Seite das 'Zurueck
     zur Uebersicht' nach links bitte"). Der auto-Rand wandert dafuer von links nach rechts -
     mehr ist es nicht. Links ist er da, wo der Pfeil hinzeigt und wo jede andere Zeile der
     Seite beginnt; rechts stand er allein auf weiter Flur. */
  /* WAS IM KASTEN UNTEN NICHT MEHR STEHT (29.09.2026, Vorgabe Claras mit Screenshot):
       - die Modellzeile unter dem Knopf ("DOYMA Curaflex Nova Senso DN 200"). Sie nannte das
         Hauptteil ein zweites Mal; darunter stand seine Beschreibung und darunter noch einmal
         es selbst als erste Position.
       - die Ueberschrift "Enthaltene Produkte (3)". Nach dem Knopf kommt jetzt unmittelbar
         die Liste - dass es die enthaltenen Produkte sind, sagt die Seite bereits.
       - der Paket-Beschreibungsabsatz an dieser Stelle. Er steht jetzt aufklappbar unter der
         Position, die er beschreibt.

     DIESER KOMMENTAR STEHT BEWUSST VOR DER ZEILE UND NICHT IN IHR. Was zwischen den
     Backticks steht, ist HTML-Text und kein JavaScript - ein Kommentar in Schraegstrich-Stern
     wird dort nicht als Kommentar gelesen, sondern als Inhalt auf die Seite geschrieben. Genau
     das ist am 29.09.2026 passiert: Clara las diesen Text auf der Paketseite stehen. Wer hier
     etwas erklaeren will, tut es oberhalb der Zuweisung. */
  /* NUR NOCH EIN WEG IN DER KOPFZEILE (01.10.2026, Vorgabe Claras). Rechts stand bis hierher
     "Zurück zur Konfiguration"; die Begruendung fuer sein Verschwinden steht oben, dort, wo
     auch konfigZielUrl() stand. .bt-detail-nav bleibt als Zeile stehen - der eine Knopf sitzt
     darin genauso links wie vorher. */
  el.innerHTML = `<div class="bt-detail">
    <div class="bt-detail-nav">
      <button type="button" class="btn quiet" id="btDetailBack" style="display:block;width:fit-content;margin:0">← Zurück zur Übersicht</button>
    </div>
    ${paketInhaltHtml(p)}
  </div>`;
  document.getElementById('btDetailBack').onclick=()=>renderBauteilePanel();
  zubKnoepfeVerdrahten(el);
  if(!(opts && opts.ohneSprung)) el.scrollIntoView({behavior:'smooth',block:'start'});
}
renderBauteilePanel();
/* Gemeinsamer Inhalt fuer die Bauteil-Detailseite UND die Info-Blase im Checkout.
   Eine Quelle, zwei Darstellungen - sonst laufen die beiden Ansichten auseinander,
   sobald jemand einen Text pflegt. positionenOffen steuert nur, ob die Stueckliste
   aufgeklappt startet: auf der eigenen Seite ja, in der Blase bewusst nicht. */
/* ERKLAERTEXTE FUER DIE INFO-BLASE, die kein Bauteil beschreiben (18.08.2026).
   Der Kunde soll die Zahlen im Checkout verstehen KOENNEN, ohne dass die Seite mit
   Erklaerungen zugestellt ist - Betreiber-Vorgabe: "nicht ueberladen, aber richtig
   lokalisiert". Deshalb dieselbe Blase, derselbe Knopf, dieselbe Telemetrie wie bei den
   Bauteilen; nur die Inhaltsquelle ist eine andere.

   BEWUSST NICHT UEBERNOMMEN: die Herleitungen aus den Code-Kommentaren zur Bivalenz
   (VDI 4645, Jahresarbeits-Anteile). Die tragen dort teils den Vermerk "VALIDIEREN" -
   was intern als Arbeitsstand steht, gehoert nicht ungeprueft vor den Kunden. Hier steht
   nur, was der Rechner nachweislich rechnet. */
const INFO_TEXTE = {
  /* ZU DEN ENTSCHEIDUNGEN IM BESTELLPROZESS (15.09.2026). Sie beantworten zwei Fragen, die
     ein Kunde an dieser Stelle hat und die keine Produktbeschreibung beantwortet: Warum muss
     ich das jetzt entscheiden, und woran erkenne ich, was fuer mich gilt.

     Bewusst OHNE Preisangaben und ohne Kaufaufforderung: Wer hier klickt, sucht Orientierung,
     nicht ein weiteres Verkaufsargument. */
  info_gruppe_haus: `
    <h3>Hauseinführung: warum jetzt?</h3>
    <p>Die Leitung zwischen Außeneinheit und Haus muss durch die Wand – und <b>wie</b> sie das
    tut, hängt allein daran, wo die Außeneinheit steht. Beides zusammen lässt sich nicht
    auswählen, deshalb kommt die Frage vor der Auswahl.</p>
    <p><b>Direkt an der Hauswand</b> heißt: oberirdisch durch die Wand, kurzer Weg.</p>
    <p><b>Weiter weg im Garten</b> heißt: unterirdisch, mit Erdleitung im Graben und einem
    Anschluss im Haus. Der Graben ist Erdarbeit – die darfst du selbst machen, sie zählt dann
    als Eigenleistung zur Förderung.</p>
    <p><b>Woran du denken solltest:</b> Die Leitungslänge bestimmt die Meterzahl der Erdleitung.
    Miss vom geplanten Standort bis zur Hauswand und rechne den Weg im Haus bis zur
    Inneneinheit dazu.</p>`,

  /* NEU GEFASST 25.09.2026 (Vorgabe Claras: "die ganzen neuen Infos, die ich jetzt bei der
     Pumpengruppe integriert habe, stell das bitte bei dem Info-i mit dar, also erklaer es
     bisschen"). Der Kasten beschrieb den Stand von vorher: zwei Bauarten, beide immer
     sichtbar, die Systemtrennung als Zusatz. Seither entscheiden zwei Fragen und das Alter
     der Fussbodenheizung, WAS ueberhaupt in der Liste steht - wer das nicht weiss, haelt
     eine leere oder kurze Gruppe fuer einen Fehler.

     DIE REIHENFOLGE FOLGT DEN FRAGEN, nicht der Technik: erst was die Heizart bedeutet, dann
     die Nachfrage nach den Kreisen, dann das Alter. So steht der Kasten in derselben Folge wie
     die Knoepfe daneben. */
  info_gruppe_pumpe: `
    <h3>Pumpengruppe: warum jetzt?</h3>
    <p>Die Pumpengruppe fördert das Heizwasser in einen Heizkreis. Welche du brauchst – und ob
    überhaupt eine – hängt an deiner Heizfläche. Die kannst nur du kennen, deshalb die Frage
    davor.</p>
    <p><b>Heizkörper:</b> Hier steht nichts zur Auswahl, und das ist kein Fehler. In der
    Hydrobox der Inneneinheit ist bereits eine ungemischte Pumpe eingebaut, die einen
    Heizkörperkreis versorgt.</p>
    <p><b>Fußbodenheizung:</b> Sie braucht eine eigene, niedrigere Vorlauftemperatur. Dafür
    mischt die <b>gemischte</b> Pumpengruppe kühleres Rücklaufwasser bei.</p>
    <p><b>Zwei oder mehr Heizkreise:</b> Dann fragen wir nach, wie sie aufgeteilt sind. Jeder
    Fußbodenheizungskreis bekommt eine gemischte Pumpengruppe – aus „2× Fußbodenheizung“ werden
    also zwei. Bei Heizkörpern zählt die Pumpe in der Hydrobox mit: „1× Fußbodenheizung +
    1× Heizkörper“ braucht nur die gemischte, „2× Heizkörper“ genau eine ungemischte. Die
    Stückzahl steht an der Zeile und lässt sich ändern, wenn es bei dir mehr sind.</p>
    <p><b>Das Alter der Fußbodenheizung entscheidet mit:</b> Rohre von <b>vor 1990</b> sind oft
    nicht diffusionsdicht und tragen Sauerstoff ins Heizwasser. Dann kommt statt der einzelnen
    Pumpengruppe der <b>gemischte Kreis mit Systemtrennung</b> – die Pumpengruppe steckt darin
    schon drin, du brauchst sie nicht zusätzlich. Ab 1990 entfällt die Trennung.</p>
    <p><b>Woran du denken solltest:</b> Weißt du das Alter nicht, planen wir die Trennung erst
    einmal nicht ein – sie kostet deutlich mehr als die einfache Gruppe. Findest du das Baujahr
    später heraus und es liegt davor, änderst du die Antwort und die Liste zieht nach.</p>`,

  info_gruppe_speicher: `
    <h3>Warmwasserspeicher: warum jetzt?</h3>
    <p>Die Wärmepumpe heizt dein Haus. Warmes Wasser für Dusche und Bad macht sie nur mit einem
    Speicher – und der bestimmt mit, wie viel Platz du im Keller brauchst.</p>
    <p><b>200 Liter</b> reichen erfahrungsgemäß für bis zu zwei Personen, <b>300 Liter</b> ab
    drei. Entscheidend ist weniger die Zahl der Bewohner als die Gleichzeitigkeit: zwei
    Duschen hintereinander morgens sind mehr als vier über den Tag verteilt.</p>
    <p><b>Kein Speicher</b> ist eine gültige Wahl, wenn das Warmwasser weiter anders erzeugt
    wird – etwa über Durchlauferhitzer oder eine bestehende Anlage.</p>
    <p><b>Woran du denken solltest:</b> Das Kippmaß beim Einbringen. Ein 300-Liter-Speicher
    muss durch Tür und Treppenhaus passen, nicht nur an seinen Platz.</p>`,

  /* NEU GEFASST 21.09.2026 (Vorgabe: die Angaben zu den einzelnen Produkten fehlten).
     Der Kasten soll nicht laenger werden, deshalb ist die alte Merkliste am Ende entfallen -
     sie sagte in Fliesstext dasselbe ("ein Thermostat je Heizkoerper, ein Stellantrieb je
     Heizkreis, eine Anschlussdose je Verteiler"), nur unsortiert und ohne zu erklaeren,
     WOFUER das Teil da ist. Auch "zaehl einmal durch" ist weg: Die Zahl der Heizkoerper wird
     seit heute in diesem Bereich gefragt.

     Das "Warum" ist auf zwei Saetze gekuerzt. Es bleibt vorn, weil der Knopf "Warum jetzt zu
     entscheiden" heisst - aber die Frage, welches der fuenf Teile man braucht, stellt sich
     beim Anhaken oefter.

     GEGLIEDERT NACH HEIZART, nicht nach Produkt: Genau so trifft der Kunde die Entscheidung,
     und so waehlt der Konfigurator seit heute auch vor. */
  info_gruppe_abgleich: `
    <h3>Hydraulischer Abgleich: warum jetzt?</h3>
    <p>Ohne Abgleich fließt das meiste Heizwasser zum nächstgelegenen Heizkörper; entfernte
    Räume bleiben kühl, und die hochgedrehte Vorlauftemperatur kostet eine Wärmepumpe
    überproportional viel Strom. <b>Für die Förderung ist er verpflichtend.</b></p>
    <h4>Welches Teil wofür</h4>
    <p><b>Immer, genau einmal je Haus:</b> die <b>Homematic Control Unit</b> – die zentrale
    Steuerung, die den Abgleich automatisch fährt.</p>
    <p><b>Bei Heizkörpern:</b> je Heizkörper ein <b>EQ3 Heizkörperthermostat</b>. Es ersetzt
    den manuellen Thermostatkopf direkt am Heizkörper.</p>
    <p><b>Bei Fußbodenheizung:</b> je Heizkreis im Verteilerkasten ein <b>EQ3 FBH-Stellmotor</b>,
    der den Durchfluss elektronisch regelt – dazu je Verteilerkasten, also meist je Etage, eine
    <b>EQ3 Regelklemmleiste WK</b> als Steuerbox für die Stellmotoren.</p>
    <p><b>Nur wenn nötig:</b> die <b>EQ3 Schaltsteckdose</b> verstärkt das Funksignal bei dicken
    Wänden oder über mehrere Etagen.</p>`,

  info_gruppe_fuellen: `
    <h3>Befüllung: warum jetzt?</h3>
    <p>Womit die Anlage gefüllt wird, entscheidet sich genau einmal – beim Befüllen. Leitungswasser
    bringt Kalk und Salze mit; beides setzt sich dort ab, wo es am wenigsten hingehört, und
    beschleunigt Korrosion. <b>VDI 2035</b> beschreibt deshalb Anforderungen an das Heizungswasser.</p>
    <p>Die Füllstation nimmt das Wasser über eine Entsalzungskartusche auf, während du füllst –
    ein Arbeitsgang statt zweier. Im Paket ist eine Kartusche mit pH-Stabilisierung enthalten.</p>
    <p><b>Woran du denken solltest:</b> Nachträglich ist das aufwendig – die Anlage müsste dafür
    wieder entleert werden. Wer die Station nicht kauft, sollte sie sich zumindest leihen.</p>`,

  info_auslegung: `
    <h3>Was die Auslegung bedeutet</h3>
    <p><b>Auslegungsheizlast</b> ist die Leistung, die dein Haus am kaeltesten Tag braucht – berechnet
    aus deinen Angaben und der Normaussentemperatur an deiner PLZ. Sie ist die Grundlage fuer die
    Kit-Groesse.</p>
    <p><b>Deckung</b> sagt, wie viel davon die Waermepumpe bei genau dieser Temperatur aus eigener
    Kraft liefert. 100 % hiesse: sie schafft es allein, auch am kaeltesten Tag.</p>
    <p><b>Bivalenzpunkt</b> ist die Aussentemperatur, ab der sie es nicht mehr allein schafft.
    Darunter hilft der <b>Elektroheizstab</b> in der Inneneinheit mit – er ist bereits eingebaut
    und muss nicht dazugekauft werden.</p>
    <p>Dass die Waermepumpe nicht auf 100 % ausgelegt wird, ist Absicht: ein Geraet, das die
    wenigen kaeltesten Stunden im Jahr allein stemmt, ist den Rest des Jahres zu gross – teurer in
    der Anschaffung und ineffizienter im Betrieb.</p>
    <p class="bt-quelle">Diese Vorauslegung ersetzt keine raumweise Berechnung nach DIN EN 12831.
    Die brauchst du fuer die Foerderung ohnehin – du darfst sie auch selbst erstellen.</p>`,

  info_foerderung: `
    <h3>Wie die Förderung läuft</h3>
    <p><b>Du bezahlst zuerst den vollen Betrag.</b> Die Förderung bekommst du danach von der KfW
    erstattet – sobald der förderkonforme Einbau bestätigt und der Nachweis eingereicht ist.
    Vorab zahlt die KfW nicht; das ist bei dieser Förderung das übliche Verfahren.</p>
    <p>Der hier gezeigte Betrag ist deshalb <b>nicht</b> die Summe, die du überweist, sondern das,
    was dich die Anlage nach der Erstattung unterm Strich kostet.</p>
    <p><b>Der Antrag muss vor Baubeginn</b> gestellt und bestätigt sein – sonst verfällt die
    Förderung komplett. Den Antrag übernehmen wir für dich; euer Kaufvertrag braucht dafuer eine
    aufschiebende Bedingung.</p>
    <p class="bt-quelle">Die Angabe ist eine Schätzung nach KfW 458 und ersetzt keinen Bescheid.</p>`,

  /* WERKZEUG-HINWEIS (25.08.2026, User-Wunsch).
     Sitzt bewusst direkt ueber dem Kaufknopf - dort entsteht die Frage "brauche ich dafuer
     jetzt noch eine Werkstatt?". Der Text ist entlastend formuliert, nicht auflistend: an
     dieser Stelle eine Werkzeugliste aufzumachen waere ein Kaufhemmnis.

     KEINE MARKEN (ausdrueckliche Vorgabe). Kategorien wie "Baumaerkte mit Verleihstation"
     sind zulaessig, ein Anbietername nicht. Ebenso wenig Tagespreise oder Verfuegbarkeits-
     zusagen - das waeren Aussagen ueber fremde Konditionen, die wir nicht halten koennen.

     Das Presswerkzeug steht zuerst, weil es das teuerste Stueck ist UND weil wir es bereits
     mitverleihen: settings_data.json fuehrt live "Presswerkzeug · leihbar im Kit". Ein Text,
     der pauschal "leih dir Werkzeug woanders" sagt, wuerde die eigene Zusage entwerten. */
  info_werkzeug: `
    <h3>Werkzeug musst du nicht kaufen</h3>
    <p>Das <b>Presswerkzeug</b> – das teuerste Stück – <b>ist im Kit mit dabei</b>. Darum musst
    du dich nicht kümmern.</p>
    <p>Für alles Weitere gilt: was du nicht besitzt, musst du nicht anschaffen. Werkzeugverleih
    ist gut verfügbar – Baumärkte mit Verleihstation und örtliche Mietgeräte-Anbieter führen die
    üblichen Maschinen tageweise. Oft ist auch die Nachbarschaft der kürzeste Weg.</p>
    <p>Welches Werkzeug für welchen Schritt nötig ist, steht in der Anleitung – Position für
    Position. Du kannst also vorher entscheiden, was du leihst und was du schon hast.</p>
    <p class="bt-quelle">Wir vermitteln keinen Verleih und verdienen daran nichts. Preise und
    Verfügbarkeit legen die Anbieter selbst fest.</p>`,

  /* APP-TEXTE (25.08.2026, User-Vorgabe "hoechstens zwei Zeilen sichtbar").
     Der Abschnitt /pages/app zeigt je Schritt nur Titel und einen Satz. Alles Weitere haengt
     am ⓘ und landet hier - dieselbe Blase, die Auslegung, Foerderung und Werkzeug erklaert.
     Inhalte 1:1 aus den echten App-Bildschirmen, nichts dazuerfunden. */
  info_app_uebersicht: `
    <h3>Was die Übersicht zeigt</h3>
    <p>Oben dein <b>Fortschritt</b>: der wievielte von 14 Schritten dran ist, und welcher als
    Nächstes kommt. Ein Tipp darauf führt direkt hinein.</p>
    <p>Darunter das <b>Sparkonto</b>. Es zählt mit, was du dir durch Eigenleistung an
    Montagekosten sparst – und zeigt vor jedem Schritt, was dieser eine Schritt beiträgt.
    Aus abstrakter Ersparnis wird damit eine Zahl, die mit jedem Handgriff wächst.</p>
    <p>Dazu die Einstiege in Hydraulikschema, Wissensteil und den vollständigen Lieferumfang
    mit Kerndaten, Datenblättern und Anleitungen zu jedem einzelnen Bauteil.</p>
    <p class="bt-quelle">Elektro-Anschluss und Inbetriebnahme übernimmt unser Partnerbetrieb.
    Alles andere baust du selbst, begleitet durch die App.</p>`,

  info_app_schritt: `
    <h3>Was in einem Schritt steht</h3>
    <p>Ganz oben <b>„Was wird gebraucht?"</b> – das Werkzeug für genau diesen Schritt, und
    darunter jedes Bauteil mit der Angabe, ob es <b>im Kit liegt</b> oder von dir zu
    <b>besorgen</b> ist. Du weißt also vorher, was du holen musst, statt es mittendrin zu merken.</p>
    <p>Dann die Anleitung mit den konkreten Maßen aus dem Plan – Grubengröße, Schotterstärke,
    Fundamentabstände, Frostgrenze. Keine Faustregeln, sondern die Werte für deine Anlage.</p>
    <p><b>Arbeitsschutz</b> steht vor dem Schritt, nicht danach. Ebenso die <b>drei Fehler</b>,
    die bei diesem Schritt am häufigsten passieren und sich hinterher nicht mehr beheben lassen.</p>
    <p class="bt-quelle">Dazu eine bemaßte Zeichnung und ein aufklappbarer Teil „Gut zu wissen"
    für alles, was nicht jeder braucht.</p>`,

  info_app_schema: `
    <h3>Dein Hydraulikschema</h3>
    <p>Oben das <b>Originalschema des Herstellers</b> – aber nicht irgendeines, sondern das zu
    den Bauteilen, die für dich bestellt wurden. Durchgezogene Linien sind Vorlauf, gestrichelte
    Rücklauf.</p>
    <p>Darunter dieselbe Anlage <b>vereinfacht</b>: welches Teil welche Aufgabe hat, wie die
    Heizkreise laufen und woher das Warmwasser kommt.</p>
    <p>Jedes Bauteil im Schema lässt sich antippen – dahinter liegen Funktion, Kerndaten und die
    Hersteller-Unterlagen. Du musst also kein Datenblatt suchen, während du auf der Leiter stehst.</p>`,

  info_app_wissen: `
    <h3>Leitfäden und Antworten</h3>
    <p>Vier Leitfäden zu den Handgriffen, bei denen erfahrungsgemäß etwas schiefgeht:
    <b>MAG-Vordruck</b> richtig einstellen, <b>Befüllen nach VDI 2035</b>, <b>Entlüften</b> ohne
    dauerhaft Sauerstoff ins System zu ziehen, und <b>Bimetallkorrosion</b> bei
    Mischinstallation nach DIN 1988-200.</p>
    <p>Das sind keine allgemeinen Ratgeber, sondern die Fehler, die Anlagen tatsächlich Jahre
    kosten – und die man mit zehn Minuten Lesen vermeidet.</p>
    <p>Dazu die Fragen, die mitten im Einbau kommen: blinkende LED, zulässiger Abstand zwischen
    Außen- und Inneneinheit, was am Kältekreis erlaubt ist, wer den Strom anschließt. Alles über
    eine Suche erreichbar.</p>`,

  info_app_zugang: `
    <h3>Wie du an die App kommst</h3>
    <p>Der Zugang gehört zum Kit. Nach deiner Bestellung richten wir ihn ein, du meldest dich
    mit deiner E-Mail-Adresse an – es gibt nichts zusätzlich zu kaufen.</p>
    <p>Die App ist dann <b>auf dein Projekt eingerichtet</b>: deine Bauteile, dein
    Hydraulikschema, deine Schritte. Kein Blättern in einem Handbuch, das für zwanzig andere
    Anlagen auch gilt.</p>
    <p class="bt-quelle">Ausdrucken kannst du dir jeden Schritt. Und falls im Keller kein Netz
    ist: die Anleitung lässt sich vorher laden.</p>`,
};

function bauteilInhaltHtml(key, positionenOffen){
  /* Erklaertexte zuerst: sie beschreiben kein Bauteil und stehen in keinem Katalog. */
  if(INFO_TEXTE[key]) return INFO_TEXTE[key];
  const it=componentCatalog().find(x=>x.key===key);
  /* Keine Stueckliste? Dann wenigstens die Essenz - siehe extraEssenzHtml(). Vorher kam hier
     ein leerer String zurueck und die Blase oeffnete gar nicht: der Knopf tat scheinbar nichts. */
  if(!it) return extraEssenzHtml(key)+produktLinkHtml(key,'Zum Produkt');
  const d=COMPONENT_DETAILS[key]||{};
  const t=COMPONENT_TECHNIK[key]||{};
  const technikHtml = (t.daten && t.daten.length) ? `
      <h4>Technische Daten</h4>
      <dl class="bt-technik">${t.daten.map(([l,v])=>
        `<dt>${esc(l)}</dt><dd>${esc(v)}</dd>`).join('')}</dl>
      ${t.norm?`<div class="bt-norm"><b>Prüfungen und Normen:</b> ${esc(t.norm)}</div>`:''}
      ${t.quelle?`<div class="bt-quelle">Quelle: Herstellerdatenblatt ${esc(t.quelle)}</div>`:''}` : '';
  const rows=it.components.map(c=>{
    const bild=positionImg(c.name);
    return `<div class="bt-pos">
      ${bild?`<img class="bt-pos-img" src="${esc(bild)}" alt="" loading="lazy">`:`<span class="bt-pos-img bt-pos-img--leer" aria-hidden="true"></span>`}
      <span class="bt-pos-name">${esc(c.name)}${c.note?` <span class="tag">${esc(c.note)}</span>`:''}</span>
      <span class="bt-pos-qty m">${c.qty}×</span>
    </div>`;
  }).join('');
  return `<div class="bt-detail-head">
      ${d.image?`<img src="${esc(d.image)}" alt="${esc(it.name)}">`:`<div class="bt-detail-noimg">Bild folgt in Kürze</div>`}
      <h3>${esc(it.name)}</h3>
    </div>
    <div class="bt-detail-body">
      ${t.modell?`<div class="bt-modell">${esc(t.modell)}</div>`:''}
      <p>${d.description?esc(d.description):'Beschreibung folgt in Kürze.'}</p>
      <h4>Montage</h4>
      <p>${d.anleitung?esc(d.anleitung):'Montageanleitung folgt in Kürze.'}</p>
      ${technikHtml}
    </div>
    <details class="mini"${positionenOffen?' open':''}><summary><span class="mini-label">Das ist alles dabei (${it.components.length} Positionen)</span></summary><div class="bt-poslist">${rows}</div></details>
    ${produktLinkHtml(key,'Zum Produkt')}`;
}

/* ---------------------------------------------------------------------
   Info-Blase neben dem Checkout (User-Entscheid 29.07.2026).
   Vorher fuehrte der Info-Knopf in die Split-View: der Checkout rutschte nach rechts
   und die Seite wechselte auf "Bauteile". Das riss den Kunden aus dem Kauf heraus.
   Jetzt bleibt der Checkout unangetastet stehen und die Infos erscheinen daneben.
   Die Blase liegt per position:fixed ueber der Seite und wird an der Kaufbox
   ausgerichtet - so muss am Layout des Checkouts nichts geaendert werden.
   --------------------------------------------------------------------- */
let blaseKey=null;
const BLASE_ABSTAND=18;     /* Luft zwischen Kaufbox und Blase */
const BLASE_MIN_PLATZ=340;  /* darunter passt daneben nichts mehr, dann mittig als Karte */

function blaseAnker(){
  /* An der Kaufbox ausrichten, nicht am Knopf: die Blase soll neben dem Block stehen,
     nicht mitten in der Zeile kleben. */
  return document.querySelector('#cartModalBody .buybox, #app .buybox, #cartModalBody, #app');
}
function positioniereBlase(){
  const bl=document.getElementById('kbBubble'); if(!bl) return;
  const anker=blaseAnker(); if(!anker) return;
  const r=anker.getBoundingClientRect();
  const platzRechts=window.innerWidth-r.right-BLASE_ABSTAND*2;
  if(platzRechts<BLASE_MIN_PLATZ){
    /* Zu schmal: als zentrierte Karte zeigen statt sie halb aus dem Bild zu schieben. */
    bl.classList.add('kb-bubble--mittig');
    bl.style.left=''; bl.style.top=''; bl.style.width=''; bl.style.maxHeight='';
    return;
  }
  bl.classList.remove('kb-bubble--mittig');
  const breite=Math.min(420,platzRechts);
  bl.style.width=breite+'px';
  bl.style.left=Math.round(r.right+BLASE_ABSTAND)+'px';
  /* Oben an der Kaufbox ausrichten, aber im Bild halten. */
  const maxHoehe=window.innerHeight-2*BLASE_ABSTAND;
  const top=Math.min(Math.max(BLASE_ABSTAND,r.top), window.innerHeight-Math.min(maxHoehe,bl.offsetHeight||320)-BLASE_ABSTAND);
  bl.style.top=Math.round(Math.max(BLASE_ABSTAND,top))+'px';
  bl.style.maxHeight=maxHoehe+'px';
}
function closeBauteilBlase(){
  const bl=document.getElementById('kbBubble'); if(bl) bl.remove();
  document.querySelectorAll('.kb-info.is-offen').forEach(b=>{
    b.classList.remove('is-offen'); b.setAttribute('aria-expanded','false');
  });
  blaseKey=null;
  window.removeEventListener('scroll',positioniereBlase,true);
  window.removeEventListener('resize',positioniereBlase);
  document.removeEventListener('keydown',blaseKeydown,true);
}
function blaseKeydown(e){ if(e.key==='Escape'){ e.stopPropagation(); closeBauteilBlase(); } }

function openBauteilBlase(key,btn){
  /* Zweiter Klick auf denselben Knopf schliesst wieder - der Knopf ist ein Umschalter. */
  if(blaseKey===key){ closeBauteilBlase(); return; }
  closeBauteilBlase();
  const inhalt=bauteilInhaltHtml(key,false);
  if(!inhalt) return;
  blaseKey=key;
  track('bauteil_blase_view',{key});
  const bl=document.createElement('div');
  bl.id='kbBubble'; bl.className='kb-bubble';
  bl.setAttribute('role','dialog');
  bl.setAttribute('aria-label','Details zum Bauteil');
  bl.innerHTML=`<button type="button" class="kb-bubble-close" id="kbBubbleClose" aria-label="Schließen">✕</button>
    <div class="kb-bubble-body">${inhalt}</div>`;
  document.body.appendChild(bl);
  if(btn){ btn.classList.add('is-offen'); btn.setAttribute('aria-expanded','true'); }
  bl.querySelector('#kbBubbleClose').onclick=closeBauteilBlase;
  positioniereBlase();
  requestAnimationFrame(()=>{ bl.classList.add('in'); positioniereBlase(); });
  window.addEventListener('scroll',positioniereBlase,true);
  window.addEventListener('resize',positioniereBlase);
  document.addEventListener('keydown',blaseKeydown,true);
}

/* Bauteil-Produktseite (Topic 2): ersetzt die Liste durch die Detailansicht EINES Produkts, exakt
   das gleiche Swap-Prinzip wie renderBuyBox/backToCompare andernorts - kein neuer Routing-Mechanismus
   noetig, funktioniert unveraendert per Nav-Aufruf (volle Breite) und in der Split-View-Sidebar
   (schmalere Spalte). */
function renderBauteileDetail(key){
  const el=document.getElementById('bauteileList'); if(!el) return;
  const it=componentCatalog().find(x=>x.key===key); if(!it) return;
  track('bauteil_detail_view',{key});
  /* Inhalt kommt aus bauteilInhaltHtml() - dieselbe Quelle wie die Info-Blase im Checkout.
     Auf der eigenen Seite ist die Stueckliste aufgeklappt, in der Blase nicht. */
  el.innerHTML=`<div class="bt-detail">
    <button type="button" class="btn quiet" id="btDetailBack" style="margin-bottom:14px;padding-left:0">← Zurück zur Übersicht</button>
    ${bauteilInhaltHtml(key,true)}
  </div>`;
  document.getElementById('btDetailBack').onclick=()=>renderBauteilePanel();
}

/* Produktvorstellung: alle gefuehrten Kits im Detail aus PRODUCTS + PERF (Single Source of Truth).
   Zeigt jede Option mit vollen Leistungsdaten je Temperaturpunkt + Zielgruppe, nicht nur eine
   Kurzkarte. WIEVIELE es sind, entscheidet der Sortiment-Schalter: renderKitDeep() (6854) baut
   die Reihenfolge aus CONFIG.RULES.HYBRID_SICHTBAR, also drei Fox-Kits ohne und vier mit
   Beistell-Waermepumpe. Der Kommentar nannte hier bis zum 02.09.2026 fest "4 Kits" und
   widersprach damit dem Code, seit das Hybrid-Kit ausgeblendet ist. */
/* Richtwert, nicht validiert - grobe Einordnung nach Kit-Groesse (Jannik/Jan).

   WORTLAUT DER DREI FOX-KITS AM 22.09.2026 ERSETZT (Vorgabe). Die neuen Untertitel sagen
   dasselbe, nur ausgeschrieben: "Einfamilienhaeuser" statt "EFH", "Gebaeude" statt "Haeuser".

   ERSETZT UND NICHT DANEBENGESTELLT: Diese Zeile stand schon in jeder Kit-Karte und sagte
   bereits, fuer wen das Kit gedacht ist. Ein zweiter Satz mit derselben Aussage waere in
   jeder Karte doppelt gestanden.

   OHNE DAS VORANGESTELLTE "8-kW-Kit -": Der Name steht zwei Zeilen darueber als Ueberschrift
   der Karte ("DIY-Kit 8 kW"). Und ohne Schlusspunkt, weil rechts daneben die Marke
   "Richtwert" folgt - ein Punkt mittendrin liest sich wie ein Satzende vor einem Nachtrag.

   HYBRID BLEIBT: Dazu gab es keine neue Fassung, und seine Zeile beschreibt etwas anderes -
   nicht die Hausgroesse, sondern das Zusammenspiel mit der vorhandenen Gasheizung. */
const KIT_FIT = {
  hybrid: "Gasheizung ab Baujahr 2016 · WP übernimmt Grundlast, Gas nur an den kältesten Tagen",
  fox8:   "Für kompakte, gut gedämmte Einfamilienhäuser",
  fox10:  "Für mittelgroße, teil- bis vollsanierte Häuser",
  fox12:  "Für größere oder unsanierte Gebäude mit höherem Wärmebedarf",
  /* EINORDNUNG SEIT DEM 13.10.2026, und jetzt belegt statt geraten. Am 12.10. stand hier
     "Einordnung folgt", weil die Kennlinie fehlte - "fuer kleine Haeuser" waere die
     naheliegende Vermutung gewesen und genau deshalb unzulaessig: Welche Heizlast ein Kit
     traegt, entscheidet die Auslegung, nicht die Zahl im Namen.

     NACHGERECHNET MIT DEM EIGENEN AUSLEGUNGSWEG: Bei -12 °C Normaussentemperatur und 55 °C
     Vorlauf liegt der Bivalenzpunkt dieses Kits zwischen 5 und 7,5 kW Heizlast im Zielfenster
     [-8, -2 °C]. Das ist der Bereich, den der Satz beschreibt - keine Zusage, sondern
     derselbe Richtwert wie bei den drei anderen. */
  fox5:   "Für kleine oder sehr gut gedämmte Häuser mit niedriger Heizlast"
};
/* Knopf auf der Kit-Karte (Vorgabe 14.09.2026): ein Weg auf die Produktseite des Kits statt
   des Direktkauf-Modals.

   ER HEISST SEIT DEM 28.09.2026 "Kit konfigurieren" (Vorgabe Claras: "nenne auf der
   Produktseite den CTA bitte nicht 'Produkt ansehen', sondern 'Kit konfigurieren'"). "Ansehen"
   versprach eine Seite zum Lesen; dort wird aber zusammengestellt und gekauft. Die Startseite
   sagt es seit heute frueh genauso ("Jetzt Kit konfigurieren"), damit derselbe Weg nicht an
   zwei Stellen zwei Namen traegt.

   Der kleine Verweis "Alle Details zum Kit" darunter ist damit entfallen - er zeigte auf
   dasselbe Ziel. Zwei Wege zur selben Seite auf einer Karte sind kein Angebot, sondern eine
   Frage, die sich der Leser stellen muss.

   Ohne Produktseite (kein handle im Eintrag) bleibt es beim alten Knopf. Das ist kein
   theoretischer Fall fuer die Zukunft, sondern die Bedingung dafuer, dass die Karte nie ohne
   Handlung dasteht.

   Die Messung heisst weiter 'produktseite_klick', nur mit via:'kitkarte' - so bleibt
   vergleichbar, was vorher ueber den kleinen Verweis lief. */
function kitKnopfHtml(k){
  const u=produktUrl(k);
  if(!u) return `<button class="btn" style="margin-top:auto" onclick="openCartModal('${k}')">In den Warenkorb →</button>`;
  return `<a class="btn" style="margin-top:auto" href="${esc(u)}" onclick="track('produktseite_klick',{key:${JSON.stringify(String(k))},via:'kitkarte'})">Kit konfigurieren →</a>`;
}
/* DAS HERSTELLERLOGO AUF DER KIT-KACHEL (12.10.2026, Vorgabe Claras am Beispiel einer
   Vaillant-Karte: "kannst du bitte bei der Uebersicht der Kits bei der Kachel auch das Logo
   oben so einfuegen, also das Logo der Waermepumpe, so wie auf dem Beispielbild auch").

   DIE BILDER KOMMEN AUS DEM THEME-EDITOR und nicht aus dem Code. Zwei Gruende:
     - Die Logodateien liegen nicht im Theme, und ein asset_url auf eine Datei, die es nicht
       gibt, liefert eine Adresse, die 404 laeuft - also ein kaputtes Bildsymbol auf jeder
       Kachel. Ein Bildfeld im Editor hat diesen Zustand nicht: Es ist entweder gesetzt oder
       leer, und leer ist hier ein gueltiger Zustand.
     - Ein Markenlogo wechselt, wenn der Hersteller es wechselt. Das soll keinen Push kosten.

   SOLANGE KEINS GESETZT IST, STEHT DER NAME DA. Das ist kein Platzhalter, der nach einem
   Bild schreit, sondern die Angabe selbst - an derselben Stelle, in der Schrift der
   technischen Angaben. Wer nie ein Logo hochlaedt, hat trotzdem eine richtige Karte.

   DIE MARKE STEHT ALS EIGENES FELD IN PRODUCTS und wird nicht aus sub geraten. "Fox ESS
   HP3-8-E" waere zwei Woerter, "MHG ecoWP2 Xm" eines - jede Regel dafuer bricht beim
   naechsten Hersteller, und zwar still. */
const MARKE_LOGO = window.__BWP_MARKE_LOGOS || {};
function markeHtml(k){
  const m = PRODUCTS[k] && PRODUCTS[k].marke;
  if(!m) return '';
  const logo = MARKE_LOGO[m];
  /* alt traegt hier den Markennamen und ist NICHT leer - anders als bei den Bildern im
     Warenkorb: Dort steht der Name als Text daneben, hier ersetzt das Logo ihn. */
  return logo
    ? `<div class="kd-marke"><img src="${esc(logo)}" alt="${esc(m)}" height="22" width="43" loading="lazy"></div>`
    : `<div class="kd-marke kd-marke-text">${esc(m)}</div>`;
}
function renderKitDeep(){
  const el=document.getElementById('kitDeep'); if(!el) return;
  /* Reihenfolge (User 30.07.2026): erst die drei Fox-Kits, das Hybrid-Kit zuletzt.
     Es ist das Beistell-Geraet fuer bestehende Gasheizungen, also der Sonderfall - und die
     einzigen Abbildungen davon sind KI-Darstellungen. Gehoert ans Ende, nicht an den Anfang. */
  const order=KIT_REIHE.filter(k=>CONFIG.RULES.HYBRID_SICHTBAR || k!=='hybrid');
  el.innerHTML=order.map((k,i)=>{
    const p=PRODUCTS[k];
    let topHtml;
    if(PERF[k]){
      const specsHtml=PERF[k].t.map((t,idx)=>`<div><span>${t>0?'+':''}${t} °C</span><b>${fmt(PERF[k].W35[idx],1).replace('.',',')} kW</b></div>`).join('');
      topHtml=`<div class="kd-specs">${specsHtml}</div>`;
    } else if(k==='hybrid'){
      topHtml=`<div class="kd-hybrid">
        <div class="kd-hybrid-head">Beistell-WP</div>
        <ul class="kd-hybrid-list">
          <li>Kein eigener Auslegungspunkt – läuft parallel zur Gasheizung</li>
          <li>Beistell-Betrieb, keine eigene COP-Kennzahl</li>
        </ul>
      </div>`;
    } else {
      /* EIN KIT OHNE LEISTUNGSDATEN (12.10.2026, fuer das 5-kW-Kit). Bis heute gab es hier
         nur zwei Faelle: Tabelle oder Hybrid-Block. Ein drittes Kit ohne PERF waere in den
         else-Zweig gefallen und haette sich als Beistell-Waermepumpe zur Gasheizung
         ausgegeben - eine falsche Aussage, und zwar eine, die niemand als Fehler erkannt
         haette, weil der Block fuer sich genommen richtig aussieht.

         Der Hybrid-Zweig haengt deshalb jetzt ausdruecklich an k==='hybrid' und nicht mehr
         am blossen Fehlen der Daten. */
      topHtml=`<div class="kd-hybrid">
        <div class="kd-hybrid-head">Leistungsdaten folgen</div>
        <ul class="kd-hybrid-list">
          <li>Die Auslegungspunkte dieses Kits stehen noch nicht fest</li>
          <li>Der Rechner schlägt es deshalb noch nicht vor</li>
        </ul>
      </div>`;
    }
    /* data-kit macht die Karte adressierbar - empfehlungMarkieren() findet sie darueber.
       Gebraucht wird das erst NACH dem Laden: renderKitDeep() laeuft beim Einlesen der Datei,
       ladeStand() erst am Ende, hier weiss also noch niemand, ob es eine Empfehlung gibt. */
    /* OHNE BILD, MIT GROSSEM NAMEN UND AUFKLAPPBARER LEISTUNGSTABELLE (01.10.2026, Vorgabe
       Claras: "bei der Seite Kits, da wo die drei Kits im Ueberblick sind: die Bilder entfernen
       aus allen drei Kaesten und dafuer den Titel 'DIY-Kit 8 kW' ... groesser machen. Preis und
       den Button 'Kit konfigurieren' auch drin lassen. Die Unterueberschrift 'Fuer kompakte, gut
       gedaemmte Einfamilienhaeuser' ueber die Heizlast-Uebersicht tun und aufklappbar machen,
       sodass man nach dem Aufklappen die Tabelle mit der Heizlast bei den Temperaturen sieht").

       DAS BILD WAR BEI ALLEN DREI DASSELBE. IMG.fox8, IMG.fox10 und IMG.fox12 zeigen
       konfig-kit-fox10.jpg - drei Kaesten, ein Foto. Es unterschied also nichts und nahm oben
       96 px, in denen der Name klein darunter stand. Jetzt steht der Name dort, wo vorher das
       Bild war.

       DIE EINORDNUNG WANDERT NACH OBEN UND WIRD ZUM GRIFF. Sie sagt in einem Satz, fuer wen das
       Kit ist - das ist die Frage, die vor den Zahlen kommt. Die vier Auslegungspunkte stehen
       dahinter, einen Klick entfernt: Wer vergleicht, klappt auf; wer sucht, liest drei Saetze
       statt zwoelf Zahlen.

       ZUGEKLAPPT, NICHT OFFEN: Offen waere es dieselbe Karte wie vorher, nur mit einem Pfeil
       daneben. Der Gewinn entsteht erst dadurch, dass die Zahlen zunaechst weg sind.

       <details> UND NICHT EIN EIGENER UMSCHALTER: Der Lauscher, der die ganze Karte klickbar
       macht, laesst summary und details ausdruecklich in Ruhe (siehe dort) - ein selbstgebauter
       Umschalter haette genau dort eine zweite Ausnahme gebraucht, und wer sie vergisst, oeffnet
       mit dem Aufklappen zugleich die Produktseite. */
    /* DIE id IST DAS SPRUNGZIEL VON "Zurueck zu den Kits" (12.10.2026, Vorgabe Claras: "dann
       soll man nicht am Anfang der Seite stehen, sondern da, wo man auf den Button kam").
       Sie steht wortgleich auch in snippets/bwp-inhalt-kitDeep.liquid - der Browser springt
       beim Aufschlagen die servergelieferte Fassung an, und diese hier ersetzt sie gleich
       darauf. Truege nur eine der beiden die id, ginge der Sprung je nach Zeitpunkt ins
       Leere. */
    /* DIE NEUHEITEN-MARKE AM 5-kW-KIT (16.10.2026, Vorgabe Claras: "bei dem Reiter Kits bei
       dem Ueberblick der 4 Kits bitte bei dem 5-kW-Kit auch so eine Umrandung in diesem hellen
       Beige machen mit 'neu'").

       DIESELBE BAUFORM WIE DAS EMPFEHLUNGS-SIEGEL, nur in Sand statt Gruen: eine Pille ueber
       der oberen Kante und ein Ring um die Karte. Zwei verschiedene Formen fuer dieselbe Geste
       waeren auf einer Seite zwei Gestaltungen.

       SIE KOENNEN ZUSAMMEN AUFTRETEN: Ist das 5-kW-Kit zugleich das empfohlene, stehen beide
       Pillen da. Deshalb sitzt die Neuheit nicht mittig wie das Siegel, sondern rechts - sonst
       laegen sie uebereinander.

       DIE LISTE DER NEUHEITEN STEHT HIER UND NICHT IM EDITOR: Es ist eine einzige Kennung, und
       sie gehoert zu dem Tag, an dem das Kit dazukam. Wer sie wegnehmen will, loescht ein Wort;
       ein Editor-Feld dafuer waere ein Schalter, den danach niemand mehr findet.

       SEIT DEM 02.11.2026 IST KEIN KIT MEHR ALS NEU MARKIERT (Vorgabe Claras: "den Neu-Button,
       der um den Kasten bei Kits um den 5kW-Kit ist, entfernen"). Das DIY-Kit 5 kW war es
       seit dem 12.10.2026 - drei Wochen, und das reicht fuer eine Neuheit.

       null STATT DIE ZEILEN ZU LOESCHEN: Die Mechanik bleibt stehen (Pille, heller Rand,
       overflow:visible am Kasten), und das naechste neue Kit braucht genau ein Wort hier.
       Geloescht muesste sie beim naechsten Mal samt CSS neu gebaut werden. */
    const NEU_KIT = null;
    const istNeu = (k===NEU_KIT);
    return `<div class="kitcard-deep reveal${i?' d'+Math.min(i,3):''}${k==='hybrid'?' hybrid':''}${istNeu?' ist-neu':''}" id="kit-${esc(k)}" data-kit="${esc(k)}">
      <div class="kd-plate">
        ${istNeu?'<div class="kd-neu">Neu</div>':''}
        ${markeHtml(k)}
        <h3 class="kd-name">${esc(p.name)}${kiStern(k)}${k==='hybrid'?' <span class="tag" style="background:var(--bernstein-tint);color:var(--bernstein-dark)">Beistell-WP</span>':''}</h3>
        <div class="kd-model">${esc(p.sub)}</div>
      </div>
      <div class="kd-body">
        <details class="kd-auf">
          <summary class="kd-fit">${esc(KIT_FIT[k])}<span class="tag">Richtwert</span><span class="kd-chev" aria-hidden="true">\u25be</span></summary>
          ${topHtml}
        </details>
        <div class="kc-price"><span class="ab">ab</span> ${eur(p.price)}</div>
        ${kitKnopfHtml(k)}
      </div>
    </div>`;
  }).join('') + kiFussnoteHtml(order);
}
renderKitDeep();
/* NACH DEM NEUBAU NOCH EINMAL ANSPRINGEN (12.10.2026). Der Browser hat den Anker aus
   "Zurueck zu den Kits" angesprungen, als die servergelieferte Fassung stand; einen
   Wimpernschlag spaeter ersetzt renderKitDeep() sie. Beide sind gleich hoch, die Stelle
   stimmt also meistens - aber eben nur meistens: Bilder und Schriften laden noch, und jede
   Zeile darueber, die ihre Hoehe aendert, verschiebt das Ziel.

   NUR FUER KIT-ANKER und nur, wenn es die Karte wirklich gibt - ein beliebiger Hash aus der
   Adresszeile darf hier nichts ausloesen. 'auto' statt 'smooth': Der Besucher kommt frisch
   auf die Seite; ein sichtbares Scrollen von oben nach unten waere eine Bewegung, die er
   nicht angestossen hat. */
(function(){
  function kitAnkerAnspringen(){
    var h = (location.hash || '').slice(1);
    if(!/^kit-[A-Za-z0-9]+$/.test(h)) return;
    var el = document.getElementById(h);
    if(el) el.scrollIntoView({block:'start', behavior:'auto'});
  }
  if(location.hash) requestAnimationFrame(kitAnkerAnspringen);
  window.addEventListener('hashchange', kitAnkerAnspringen);
})();

/* Wisch-Hinweis und weiche Kante fuer seitlich scrollbare Bereiche. Notwendig, weil die
   Scrollbalken seitenweit ausgeblendet sind - ohne das waere die Kit-Vergleichstabelle auf
   dem Handy stumm abgeschnitten (640px Inhalt in 346px Fenster, gemessen bei 390px). */
function markiereScrollbereiche(){
  document.querySelectorAll('.kitcompare').forEach(box=>{
    /* Unsichtbares Panel: beide Breiten sind 0. Dann noch nichts entscheiden, showPanel()
       ruft erneut, sobald der Bereich wirklich Platz hat. */
    if(!box.clientWidth) return;
    if(box.scrollWidth <= box.clientWidth + 4){ box.classList.add('am-ende'); return; }
    const vorher=box.previousElementSibling;
    if(!vorher || !vorher.classList.contains('kitcompare-hint')){
      const h=document.createElement('p');
      h.className='kitcompare-hint';
      h.textContent='Tabelle seitlich wischen';
      box.parentNode.insertBefore(h,box);
    }
    if(!box._wischGebunden){
      box.addEventListener('scroll',()=>box.classList.toggle('am-ende',
        box.scrollLeft + box.clientWidth >= box.scrollWidth - 4),{passive:true});
      box._wischGebunden=true;
    }
    box.classList.toggle('am-ende', box.scrollLeft + box.clientWidth >= box.scrollWidth - 4);
  });
}
markiereScrollbereiche();
window.addEventListener('resize',markiereScrollbereiche);
/* Vergleichstabelle: alle 4 Auslegungspunkte nebeneinander - nichts kann hier untergehen */
/* WELCHE VORLAUFTEMPERATUR DIE TABELLE ZEIGT (13.10.2026, Vorgabe Claras: "ein kleiner Button,
   der zwischen zwei Tabellenversionen wechselt - W35 (Fussbodenheizung) und W55 (Heizkoerper)").

   W35 IST DIE VORGABE, weil sie es vorher war: Die Tabelle zeigte immer die 35-°C-Spalte, und
   der servergelieferte Zwilling tut es weiterhin. Haette der Umschalter eine andere Vorgabe,
   zeigte die Seite beim Aufschlagen die eine und einen Wimpernschlag spaeter die andere Zahl.

   NICHT AN vlCol() GEHAENGT, obwohl es naheliegt: Diese Funktion liefert die Vorlauftemperatur
   AUS DEN ANTWORTEN des Besuchers und steuert damit die Auslegung. Die Tabelle auf der
   Kits-Seite ist aber eine Uebersicht ueber das Sortiment - sie soll fuer jeden dasselbe
   zeigen, solange er nicht selbst umschaltet. */
let kitVergleichVl='W35';
function renderKitCompareTable(){
  const el=document.getElementById('kitCompareTable'); if(!el) return;
  /* DIE ZEILEN FOLGEN KIT_REIHE, NICHT EINER EIGENEN LISTE (12.10.2026). Hier stand
     ['fox8','fox10','fox12'] - eine zweite Reihenfolge neben der einen, die es dafuer gibt.
     Genau diese Doppelung hat die Tabelle am 12.10.2026 das DIY-Kit 5 kW uebersehen lassen:
     Die Karten darueber zeigten vier Kits, die Tabelle darunter drei, und niemand hatte
     etwas falsch gemacht - die Liste wusste nur nichts von dem neuen Kit.

     WER KEINE KENNLINIE HAT, STEHT NICHT DRIN. Die Tabelle ist die Gegenueberstellung der
     Auslegungspunkte; eine Zeile aus vier Strichen waere keine Angabe, sondern eine Luecke
     mit Rahmen. Sobald PERF einen Eintrag fuer ein Kit traegt, erscheint es hier von selbst
     und an seiner Stelle in der Reihe.

     Das Hybrid-Kit faellt ueber dieselbe Bedingung heraus und bekommt darunter seine eigene
     Zeile - es hat keinen Auslegungspunkt, aber einen Preis. */
  const foxOrder=KIT_REIHE.filter(k=>k!=='hybrid' && PERF[k]);
  const points=PERF.fox8.t; // [-15,-7,2,7]
  let head=`<tr><th>Kit</th>${points.map(t=>`<th>${t>0?'+':''}${t} °C</th>`).join('')}<th>Preis</th></tr>`;
  let rows=foxOrder.map(k=>{
    const p=PRODUCTS[k];
    /* data-l = Spaltenname an der Zelle. Auf dem Handy wird die Tabelle zur Liste,
       dann steht die Beschriftung vor dem Wert statt in einem Kopf ausserhalb des Bildes. */
    return `<tr><td data-l="Kit">${esc(p.name)}</td>${PERF[k][kitVergleichVl].map((v,i)=>`<td class="m" data-l="bei ${points[i]>0?'+':''}${points[i]} °C">${fmt(v,1).replace('.',',')} kW</td>`).join('')}<td class="m" data-l="Preis">${eur(p.price)}</td></tr>`;
  }).join('');
  /* AN DEN SORTIMENT-SCHALTER GEHAENGT (02.09.2026)
     Diese Zeile hing vorher bedingungslos an der Tabelle. renderKitDeep() weiter oben (6854)
     filtert das Hybrid-Kit korrekt ueber CONFIG.RULES.HYBRID_SICHTBAR heraus - hier fehlte
     dieselbe Bedingung. Ergebnis auf der Live-Seite: die Kit-KARTEN zeigten drei Kits, die
     Vergleichstabelle direkt darunter aber vier, inklusive Preis fuer ein Produkt, das man
     gar nicht mehr kaufen kann. Die Tabelle ueberschrieb damit auch das bereits korrekt
     gegatete statische Snippet bwp-inhalt-kitCompareTable.liquid, das die Zeile hinter
     {% if settings.hybrid_sichtbar %} haelt.
     DESHALB IST DAS DIE VORBEDINGUNG fuer jede Textkorrektur von "vier Kits" auf "drei":
     wer nur die Texte umschreibt, laesst die Seite behaupten, es gebe drei Kits, waehrend
     die Tabelle darunter vier auflistet - das ist schlechter als der Zustand vorher. */
  const hybridRow=CONFIG.RULES.HYBRID_SICHTBAR
    ? `<tr><td data-l="Kit">${esc(PRODUCTS.hybrid.name)}</td><td colspan="${points.length}" data-l="Auslegung" style="color:var(--muted)">MHG Beistell-WP zur Gasheizung, kein eigener Auslegungspunkt</td><td class="m" data-l="Preis">${eur(PRODUCTS.hybrid.price)}</td></tr>`
    : '';
  /* DIE TABELLE SAGT SELBST, WELCHE FASSUNG SIE ZEIGT (14.10.2026, Vorgabe Claras: "kannst du
     auch irgendwie innerhalb der Tabelle farblich oder so darstellen, welchen Button man
     gerade ausgewaehlt hat").

     DREI MITTEL, ZUSAMMEN EINES: eine Zeile im Klartext ueber den Spalten, ein Farbton am
     Kopf, der sich zwischen den beiden Fassungen unterscheidet, und ein Punkt davor in
     derselben Farbe. Wer die Knoepfe nicht im Blick hat - auf dem Telefon steht die Tabelle
     beim Scrollen allein da -, liest trotzdem, worauf er schaut.

     <caption> UND KEIN <div> DARUEBER: Es ist die Beschriftung dieser Tabelle, und als
     caption bleibt sie bei ihr, auch wenn die Tabelle seitlich geschoben wird oder jemand sie
     vorliest. Ein Kasten daneben waere beim Scrollen weg.

     data-vl AM TISCH, damit das Stylesheet die Farbe entscheidet und nicht das Skript: Wer den
     Ton aendern will, findet ihn bei den uebrigen Farben und nicht in einer Zeichenkette. */
  const vlText = kitVergleichVl==='W55'
    ? 'Leistung bei 55 °C Vorlauf · Heizkörper'
    : 'Leistung bei 35 °C Vorlauf · Fußbodenheizung';
  el.dataset.vl=kitVergleichVl;
  el.innerHTML=`<caption class="kitcompare-cap">${vlText}</caption><thead>${head}</thead><tbody>${rows}${hybridRow}</tbody>`;
}
/* DIE BEIDEN KNOEPFE, EINMAL AM DOKUMENT. Sie stehen in Liquid und werden nicht neu gebaut -
   ein delegierter Empfaenger ist trotzdem der richtige Griff: Im Theme-Editor wird die ganze
   Section ersetzt, wenn jemand dort etwas aendert, und einzeln gehaengte Empfaenger waeren
   danach weg. Dieselbe Begruendung wie beim Aufklapp-Pfeil der Mengenfragen. */
document.addEventListener('click', function(e){
  const b = e.target.closest && e.target.closest('#kitCompareSchalter [data-vl]');
  if(!b) return;
  const neu=b.dataset.vl;
  if(!neu || neu===kitVergleichVl) return;
  kitVergleichVl=neu;
  b.parentElement.querySelectorAll('[data-vl]').forEach(x=>{
    const an = x===b;
    x.classList.toggle('sel', an);
    x.setAttribute('aria-pressed', an?'true':'false');
  });
  renderKitCompareTable();
  try{ track('kitvergleich_vorlauf',{vl:neu}); }catch(e){}
});
renderKitCompareTable();

/* Services in der Tiefe - Was / Wann / Warum als 3 Spalten, recherche-belegt (KfW-Merkblatt 458, VdZ, Stand 07/2026).
   pflicht-Label macht auf einen Blick klar, was gesetzlich/förderrechtlich nicht optional ist. */
/* DIE DREI SPALTEN JE SERVICE - WAS, WANN, WARUM (02.10.2026 aus renderServiceDeep()
   herausgezogen).

   SIE STANDEN IN DER FUNKTION, die sie zeichnet, und das war richtig, solange nur die
   Foerderseite sie brauchte. Seit es dasselbe als Fenster im Konfigurator gibt (Vorgabe Claras:
   "mach bei den Services bitte auch ein Pop-up-Fenster wie bei den Bauteilen; der Inhalt wird
   der sein, der beim Reiter Foerderung unter 'Verfuegbare Services bei uns' steht"), braucht
   sie eine zweite Stelle - und die Funktion laeuft dort gar nicht: Sie steigt sofort aus, wenn
   es #svcDeep nicht gibt, und den gibt es nur auf der Foerderseite.

   ALS const VOR BEIDEN NUTZERN: Function-Deklarationen werden hochgezogen, const-Tabellen
   nicht. Stuende die Tabelle hinter renderServiceDeep(), liefe der Aufruf am Dateiende in
   "cannot access before initialization" - derselbe Fallstrick, der bei SERVICES und EXTRAS
   schon einmal zugeschlagen hat. */
const SVC_DEEP=[
    {k:'foerder', foerderRelevant:true, pflicht:'Pflicht für Förderung',
     was:["Bestätigung zum Antrag (BzA)","Bestätigung nach Durchführung (BnD)","Alle Uploads & Nachweise"],
     wann:["Vor Baubeginn"],
     warum:["Ohne BzA kein Antrag, ohne BnD keine Auszahlung","BzA darf nur ein Energieeffizienz-Experte oder Fachunternehmer ausstellen","Die raumweise Heizlastberechnung nach DIN EN 12831 ist hier NICHT enthalten, für die Förderung aber erforderlich - über die Technische Planung oder in Eigenleistung"],
     src:"KfW-Merkblatt 458"},
    /* DIE EIGENE KARTE FUER DEN HYDRAULISCHEN ABGLEICH IST AM 25.09.2026 ENTFALLEN (Vorgabe
       Claras: "entferne den hydraulischen Abgleich aus dem Reiter Foerderung"). Er ist keine
       eigene Leistung mehr, sondern steckt in den beiden Services, die ihn tatsaechlich
       erbringen: die raumweise Berechnung in der Technischen Planung, das VdZ-Protokoll im
       Anlagencheck - beide tragen ihn seit heute in Klammern im Feld "Was". Die Umsetzung
       dazwischen ist Eigenleistung und steht als Hinweis beim Anlagencheck.

       Die Karte versprach ausserdem einen Service, den es nicht gibt: "Festpreise je
       Komponente" statt eines Preises, und im Warenkorb war sie nie buchbar (hydS/M/L tragen
       buyable:false). */
    {k:'ibn', foerderRelevant:true, pflicht:'Pflicht für Auszahlung',
     was:["Kältecheck","Inbetriebnahme-Protokoll mit Messwerten","Fachunternehmererklärung","Garantie-Registrierung","VdZ-Protokoll (Hydraulischer Abgleich)"],
     wann:["Direkt nach dem Einbau, vor Dauerbetrieb"],
     warum:["Selbsteinbau bleibt förderfähig, wenn die Fachschritte vom Fachbetrieb kommen","Fachunternehmererklärung ist Pflicht-Nachweis für die Auszahlung"],
     src:"KfW 458 · Nachweisprozess"},
    /* DAS NETZMANAGEMENT STEHT SEIT DEM 28.10.2026 HIER (Vorgabe Claras: "inhaltlich soll das
       aber bei Elektroanschluss stehen, also auf der Seite, wo das erklaert wird - da bitte
       auch erklaeren, dass das Netzmanagement immer der Betrieb macht, der auch die
       Elektroarbeiten macht"). Als eigener Service ist es entfallen, weil es sich nicht
       getrennt beauftragen laesst: An- und Abmeldung laufen ueber die Nummer des
       Elektrobetriebs beim Netzbetreiber. Die eigene Karte ist damit weggefallen. */
    {k:'zs', foerderRelevant:false, pflicht:'Gesetzlich vorgeschrieben',
     was:["Zählerschrank-Anpassung","Verdrahtung","Anschluss ans Hausnetz","Anmeldung der Wärmepumpe beim Netzbetreiber","Abmeldung der Altanlage"],
     wann:["Nach dem mechanischen Einbau, vor Inbetriebnahme","Die Anmeldung vor der Inbetriebnahme"],
     warum:["Nur durch eingetragenen Elektro-Fachbetrieb erlaubt","Die An- und Abmeldung beim Netzbetreiber macht immer der Betrieb, der auch die Elektroarbeiten ausführt – sie läuft über seine Eintragung beim Netzbetreiber und ist deshalb nicht einzeln buchbar","Nicht verhandelbar – Sicherheit hinter dem Zähler, aber keine Förderungs-Voraussetzung"],
     src:"NAV § 13 · NAV / TAB des Netzbetreibers"},
    {k:'oel', foerderRelevant:false, pflicht:'Nur bei Ölheizung',
     was:["Ausbau & Reinigung","Zertifizierte Entsorgung","Festpreis nach Material und Größe, Auswahl im Rechner"],
     wann:["Rund um den Einbau"],
     warum:["Alttanks dürfen nicht einfach stillgelegt werden, unabhängig von der Förderung","Entsorgungsnachweis gehört in deine Unterlagen"],
     src:"Fachbetriebspflicht (AwSV)"},
    {k:'vot', foerderRelevant:true, pflicht:'Pflicht für Förderung',
     was:["Physischer Vor-Ort-Termin (VOT) bei dir zu Hause","Raumweise Heizlastberechnung nach DIN EN 12831 (Hydraulischer Abgleich)","U-Werte, Wärmebrücken, Lüftungsverluste","Machbarkeit von Aufstellort, Leitungswegen und Heizraum"],
     wann:["Vor dem Kauf - die Berechnung muss vor dem hydraulischen Abgleich vorliegen"],
     warum:["Die raumweise Heizlastberechnung ist Fördervoraussetzung: ohne sie kein Verfahren-B-Abgleich und damit keine Auszahlung","Im Förderantrag-Service ist sie NICHT enthalten - entweder hierüber oder selbst erstellt","In Eigenleistung erlaubt: wer sie selbst nach DIN EN 12831 rechnet, braucht diesen Service nicht","Der Vor-Ort-Termin klärt zusätzlich die Machbarkeit, bevor Material bestellt wird"],
     src:"DIN EN 12831 · KfW 458 (Verfahren B)"},
    {k:'baub', foerderRelevant:false, pflicht:'Optional',
     was:["Video-Support durch unsere Techniker","2 Stunden inklusive, danach 9,99 € je 10 Minuten"],
     wann:["Während deines Einbaus, wann du willst"],
     warum:["Backup statt Babysitter: du schraubst, wir sind auf Abruf da","Kein Termin-Stress, Blöcke flexibel abrufbar"],
     src:"BilligerWärmepumpe Service"},
    /* JAEHRLICHE WARTUNG (02.10.2026, Vorgabe Claras: "genauso auch bei der Seite Foerderung als
       neuer Punkt unter 'Verfuegbare Services bei uns' bei Freiwillig, also 08 - der Preis wie er
       da steht, aber jaehrlich den Betrag").

       DIE NUMMER 08 ERGIBT SICH VON SELBST: Die Karten werden in der Reihenfolge dieser Liste
       durchgezaehlt, und das hier ist die achte. Eine getippte Nummer waere beim naechsten
       Einschub falsch.

       "FREIWILLIG" EBENSO: Die Gruppe kommt aus serviceGruppe(), und die setzt alles dorthin, was
       weder foerderpflichtig noch gesetzlich vorgeschrieben ist. Hier ist nichts einzutragen.

       preisZusatz IST NEU: Der Betrag steht einmal, in SERVICES - 399 EUR. Dass er jaehrlich
       anfaellt, ist aber keine andere Zahl, sondern eine Angabe dazu, und die gehoert an die
       Karte und nicht in den Preis. Haette ich "399 EUR / Jahr" als Text in SERVICES geschrieben,
       waere aus dem Preis eine Zeichenkette geworden - und der Warenkorb rechnet damit. */
    {k:'wartung', foerderRelevant:false, pflicht:'Optional',
     was:["Wartungsvertrag für 399 € pro Jahr (brutto)",
          "Enthält Wärmepumpe und Peripherie: Schlammabscheider, Pumpengruppe, Warmwasserspeicher, Hauseinführung, Ausdehnungsgefäße"],
     wann:["1× im Jahr"],
     warum:["Instandhaltung der Anlage"],
     src:"BilligerWärmepumpe Service"}
  ];

function renderServiceDeep(){
  const el=document.getElementById('svcDeep'); if(!el) return;
  /* foerderRelevant:true = ohne diesen Schritt gibt's keine Förderung (Reihenfolge = Relevanz).
     Alles andere ist gesetzlich nötig oder optional, aber keine Förderungs-Voraussetzung -
     das wird unten sichtbar getrennt, damit klar ist, worauf es für den Zuschuss ankommt. */
  const DEEP=SVC_DEEP;
  /* nRelevant/nOther sind entfallen: Die Foerder-Gruppe traegt keine Zahl mehr ("4 Pflicht
     für Förderung" ist kein Satz), und die zweite Gruppe gibt es nicht mehr - sie ist in
     "Gesetzlich vorgeschrieben" und "Freiwillig" aufgeteilt. */
  /* Die Phasen-Zwischenzeile: einmal ueber der ersten Karte, einmal beim Wechsel. Gebaut,
     BEVOR die Gruppe zusammengesetzt wird - im Template selbst waere die Bedingung ein
     verschachtelter Ausdruck, den beim naechsten Mal niemand mehr liest. */
  const col=(label,items)=>`<div class="sd-col"><span class="sd-l">${label}</span><ul>${items.map(x=>`<li>${x}</li>`).join('')}</ul></div>`;
  /* art: 'foerder' | 'gesetz' | 'frei' - faerbt den Nummernkasten. Uebergeben statt aus d
     abgeleitet: Die Einteilung entsteht erst beim Gruppieren, d selbst kennt sie nicht. */
  const card=(d,i,art)=>{
    /* hyd: Komponenten-Festpreise stehen (Tabelle 17.07.2026), Stückzahl-Abfrage im Funnel noch offen.
       oel: 4 Einzelservices, hier als EINE Karte mit Preisspanne. */
    const oelPrices=Object.values(SERVICES).filter(s=>s.xgroup==='oel').map(s=>s.price);
    const price = d.k==='oel' ? `${eur(Math.min(...oelPrices))} – ${eur(Math.max(...oelPrices))}`
      : (SERVICES[d.k].price?eur(SERVICES[d.k].price):'inklusive');
    /* preisZusatz kommt seit dem 02.10.2026 aus SERVICES und nicht mehr aus dieser Tabelle:
       Dieselbe Angabe steht auch im Konfigurator an der Auswahlzeile, und zwei Quellen fuer
       "pro Jahr" liefen beim naechsten Mal auseinander. */
    const zusatz = SERVICES[d.k] && SERVICES[d.k].preisZusatz;
    const name = d.k==='oel' ? 'Öltank-Entsorgung (Ausbau & Entsorgung)'
      : SERVICES[d.k].name;
    const pflichtTag = d.foerderRelevant ? `<span class="tag gruen">${d.pflicht}</span>` : `<span class="tag">${d.pflicht}</span>`;
    return `<div class="svcdeep${d.foerderRelevant?' foerder-relevant':''} reveal${i%2?' d1':''}">
      <div class="sd-num${d.foerderRelevant?' relevant':''}${art?' sd-num--'+art:''}">${String(i+1).padStart(2,'0')}</div>
      <div class="sd-main">
        <button type="button" class="sd-head" aria-expanded="false" data-svc="${d.k}">
          <span class="sd-name">${esc(name)}${pflichtTag}</span>
          ${/* Lange Beschriftungen ("Festpreise je Komponente", Preisspannen) duerfen auf schmalen
               Schirmen umbrechen, kurze Betraege nie - sonst zerfaellt "999 €" in zwei Zeilen.
               Die Laenge entscheidet, nicht das Leerzeichen: auf das geschuetzte Leerzeichen aus
               eur() ist kein Verlass, der ausgelieferte Asset normalisiert es. */""}
          ${/* preisZusatz: eine Angabe ZUM Preis, kein Teil von ihm - "pro Jahr" bei der
               Wartung. Als <small> in derselben Zeile, wie in der Materialliste darunter
               ("pro Meter", "je Heizkörper"); so steht an beiden Stellen dasselbe Muster. */""}
          <span class="price m${price.length>10?" price-lang":""}">${price}${zusatz?`<small>${esc(zusatz)}</small>`:''}</span>
          <span class="sd-chev" aria-hidden="true">▾</span>
        </button>
        <div class="sd-body" hidden>
          <div class="sd-cols">${col('Was',d.was)}${col('Wann',d.wann)}${col('Warum',d.warum)}</div>
          <span class="sd-src">Quelle: ${d.src}</span>
          ${/* KEIN VERWEIS AUF EINE SERVICE-PRODUKTSEITE MEHR, bei keiner Karte (Vorgabe
               18.09.2026: "diese Seite kann zwar existieren, sie soll aber nicht ueber einen
               Link betretbar sein").

               Angefangen hatte es am 15.09.2026 mit vot und foerder, aus demselben Grund, nur
               enger gefasst: Auf dieser Seite geht es darum, WAS fuer die Foerderung verlangt
               wird - ein Verweis auf die Produktseite fuehrt mitten in der Erklaerung aus ihr
               heraus. Gebucht werden die Services im Konfigurator, nicht hier. Was fuer zwei
               Karten galt, gilt jetzt fuer alle.

               Die Seiten selbst bleiben bestehen; sie sind nur nicht mehr von hier aus
               erreichbar. produktLinkHtml() wird weiter gebraucht - im Zubehoer-Bereich. */''}
        </div>
      </div>
    </div>`;
  };
  /* REIHENFOLGE UND ZWEITEILUNG (Vorgabe 15.09.2026). Sortiert wird nach dem zeitlichen
     Ablauf, nicht nach der Reihenfolge im Datensatz: erst was VOR dem Einbau zu tun ist,
     dann was danach kommt. Wer die Liste von oben liest, liest damit seinen Zeitplan.

     Die Trennung steht hier und nicht als Feld an DEEP: Sie gilt nur fuer diese eine
     Darstellung. Dieselben Eintraege tauchen an anderen Stellen ohne Phasen auf. */
  /* OHNE_PRODUKTLINK ist am 18.09.2026 entfallen - es gibt keine Karte mehr MIT Verweis,
     die Liste haette also nichts mehr zu unterscheiden. */
  const REL_REIHE=['vot','foerder','ibn'];
  const REL_NACH_EINBAU=['ibn'];
  const relevant=DEEP.filter(d=>d.foerderRelevant)
    .slice().sort((a,b)=>REL_REIHE.indexOf(a.k)-REL_REIHE.indexOf(b.k));
  /* NUR der Elektroanschluss ist vorgeschrieben (Betreiber-Auskunft 15.09.2026). Arbeiten an
     der Hausinstallation darf ausschliesslich eine eingetragene Fachkraft ausfuehren. Beim
     Netzmanagement und der Oeltank-Entsorgung hatte ICH das angenommen und zur Bestaetigung
     gestellt - die Antwort ist nein, sie gelten als freiwillig. Dieselbe Liste steuert auch
     die Gruppierung im Konfigurator (SERVICE_KATEGORIE), damit beide Stellen dasselbe sagen. */
  const GESETZLICH=['zs'];
  const other=DEEP.filter(d=>!d.foerderRelevant)
    .slice().sort((a,b)=>(GESETZLICH.includes(a.k)?0:1)-(GESETZLICH.includes(b.k)?0:1));
  /* Die Material-Liste (matGroups/matRows) stand hier bis zum 15.09.2026 - siehe den
     Kommentar an der Stelle, wo ihre Gruppe stand. */
  /* Zwischenzeilen setzen, sobald sich der Abschnitt aendert. Die erste steht ohne Linie
     oben - eine Trennung ganz oben trennt von nichts -, jede weitere traegt den Schnitt.
     Eine Funktion fuer beide Gruppen: die Foerder-Pflichten teilen sich in vor und nach dem
     Einbau, die uebrigen in gesetzlich vorgeschrieben und freiwillig. Zweimal dieselbe
     Mechanik von Hand zu schreiben hiesse, sie zweimal pflegen zu muessen. */
  const mitAbschnitten=(liste,abschnitt,start,art)=>liste.map((d,i)=>{
    const jetzt=abschnitt(d);
    const davor=i>0 ? abschnitt(liste[i-1]) : null;
    const zeile = i===0 ? `<div class="sd-phase">${esc(jetzt)}</div>`
                : (jetzt!==davor ? `<div class="sd-phase sd-phase--schnitt">${esc(jetzt)}</div>` : '');
    return zeile + card(d,start+i,art);
  }).join('');
  const relevantMitPhasen = mitAbschnitten(relevant,
    d=>REL_NACH_EINBAU.includes(d.k) ? 'Nach dem Einbau' : 'Vor dem Einbau', 0, 'foerder');
  /* Die zweite Gruppe zerfaellt in ZWEI eigene Gruppen mit eigener Ueberschrift, statt in
     einer Gruppe mit zwei Zwischenzeilen zu stecken (Vorgabe 15.09.2026: "die Ueberschrift
     wie 'Pflicht für Förderung'"). Die alte Sammelbeschriftung - "3 gesetzlich noetig oder
     optional, keine Foerderungs-Bedingung" - sagte ohnehin zwei Dinge auf einmal und war
     genau deshalb so lang. Jetzt stehen drei Ueberschriften nebeneinander, jede sagt eine
     Sache: Pflicht für Förderung, Gesetzlich vorgeschrieben, Freiwillig. */
  const gesetzlich = other.filter(d=>GESETZLICH.includes(d.k));
  const freiwillig = other.filter(d=>!GESETZLICH.includes(d.k));
  el.innerHTML=`
    <div class="sd-groups reveal">
      <div class="sd-group sd-group--required" data-group="relevant">
        ${/* Ohne die Zahl davor: "4 Pflicht für Förderung" ist kein Satz. Die beiden anderen
              Gruppen behalten ihre Zaehlung, deren Beschriftungen tragen sie. */''}
        <button type="button" class="sd-legend-pill" data-toggle="relevant">Pflicht für Förderung<span class="sd-chev">▾</span></button>
        <div class="sd-group-body">${relevantMitPhasen}</div>
      </div>
      <div class="sd-group sd-group--other" data-group="gesetz">
        <button type="button" class="sd-legend-pill" data-toggle="gesetz">Gesetzlich vorgeschrieben<span class="sd-chev">▾</span></button>
        <div class="sd-group-body">${gesetzlich.map((d,i)=>card(d,relevant.length+i,'gesetz')).join('')}</div>
      </div>
      <div class="sd-group sd-group--other" data-group="frei">
        <button type="button" class="sd-legend-pill" data-toggle="frei">Freiwillig<span class="sd-chev">▾</span></button>
        <div class="sd-group-body">${freiwillig.map((d,i)=>card(d,relevant.length+gesetzlich.length+i,'frei')).join('')}</div>
      </div>
      ${/* "Material zum Dazubestellen" ist am 15.09.2026 entfallen (Vorgabe). Die Liste
            gehoert zum Zusammenstellen, nicht zur Foerderung - ausgewaehlt wird sie im
            Konfigurator, und seit dem Umbau steht sie dort vollstaendig mit Bildern und
            Paketinhalten. Hier war sie eine zweite, aermere Fassung derselben Sache. */''}
      </div>
    </div>
  `;
  el.querySelectorAll('.sd-legend-pill').forEach(btn=>{
    btn.addEventListener('click',()=>btn.closest('.sd-group').classList.toggle('off'));
  });
  /* Progressive Disclosure: zugeklappt nur Name + Pflicht-Tag + Preis, Details auf Klick */
  el.querySelectorAll('.sd-head').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const open=btn.getAttribute('aria-expanded')!=='true';
      btn.setAttribute('aria-expanded',String(open));
      btn.closest('.svcdeep').classList.toggle('open',open);
      const body=btn.parentElement.querySelector('.sd-body'); if(body) body.hidden=!open;
      if(open) track('svc_detail_open',{svc:btn.dataset.svc});
    });
  });
}
renderServiceDeep();

/* ---------- Wissen-Artikel: Klick-Vorschau mit Mockup-Inhalt (PLATZHALTER, finaler Text folgt) ---------- */
const ARTICLES = window.ARTICLES;
function openArticle(idx){
  const a=(window.ARTICLES||ARTICLES||[])[idx]; if(!a) return;
  document.getElementById('artBody').innerHTML=`
    <span class="art-kat">${esc(a.kat)}</span>
    <h3 class="art-title">${esc(a.title)}</h3>
    <div class="art-body">${a.body.map(p=>`<p>${p}</p>`).join('')}</div>
    ${a.isMockup ? '<div class="art-mock">Mockup-Inhalt · finaler Artikeltext folgt</div>' : ''}
  `;
  document.getElementById('artOverlay').classList.add('show');
  scrollSperren('artikel');
}
function closeArticle(){
  document.getElementById('artOverlay').classList.remove('show');
  scrollFreigeben('artikel');
}
function openLu(){
  const grid=document.getElementById('luPopGrid'); if(!grid) return;
  const luEff=effektiverLU();
  grid.innerHTML=luEff.list.map(([qty,name],i)=>{
    const d=luEff.details[i]||{};
    return `<div class="lu-popitem">
      <div class="lu-popimg"><span>Foto<br>${esc(d.img||name)}</span></div>
      <div class="lu-popmeta"><span class="lu-popqty">${qty}</span><b>${esc(name)}</b>${d.purpose?`<p>${esc(d.purpose)}</p>`:''}</div>
    </div>`;
  }).join('');
  document.getElementById('luOverlay').classList.add('show');
  scrollSperren('lieferumfang');
}
function closeLu(){
  document.getElementById('luOverlay').classList.remove('show');
  scrollFreigeben('lieferumfang');
}
/* Dasselbe Muster wie beim Kauf-Dialog: beide Schliesser geben die Scroll-Sperre frei,
   liefen aber bei jedem Escape, auch wenn gar nichts offen war. Jetzt wird nur geschlossen,
   was tatsaechlich zu sehen ist - beide Overlays zeigen sich ueber die Klasse "show". */
document.addEventListener('keydown',e=>{
  if(e.key!=='Escape') return;
  const art=document.getElementById('artOverlay');
  const lu =document.getElementById('luOverlay');
  if(art && art.classList.contains('show')) closeArticle();
  if(lu  && lu.classList.contains('show'))  closeLu();
});

/* Zusatzinfo-Pfeile in Service-/Eigenleistungs-Zeilen (Buybox + Direktkauf-Modal):
   eine Delegation für beide Kaufwege, überlebt jedes Re-Render */
document.addEventListener('click',e=>{
  const btn=e.target.closest ? e.target.closest('.svc-info') : null; if(!btn) return;
  const row=btn.closest('.svc-row'); if(!row) return;
  const open=!row.classList.contains('open');
  row.classList.toggle('open',open);
  btn.setAttribute('aria-expanded',String(open));
});

/* Förderung ↔ Services: jede KfW-458-Pflicht braucht einen Fachbetriebs-Nachweis -
   diese Zuordnung macht sichtbar, welcher Service welche Voraussetzung abdeckt.
   Quelle: SERVICES-Objekt (Single Source of Truth), keine eigenen Preise/Namen hier. */
const FOERDER_MAP=[
  {req:"Antrag stellen, vor Baubeginn", why:"Ohne Bestätigung zum Antrag (BzA) vor Start verfällt der Zuschuss komplett.", svc:'foerder'},
  {req:"Nachweis nach Fertigstellung", why:"Bestätigung nach Durchführung (BnD) + Fachunternehmererklärung, Pflicht für die Auszahlung.", svc:'ibn'},
  {req:"Raumweise Heizlastberechnung nach DIN EN 12831 (Hydraulischer Abgleich)", why:HLB_HINWEIS+" Im Förderantrag-Service ist sie nicht enthalten.", svc:'vot'},
  /* DER ABGLEICH STEHT NICHT MEHR ALS EIGENE PFLICHT DA, SONDERN AN SEINEN ZWEI NACHWEISEN
     (28.09.2026, Vorgabe Claras: "VdZ-Protokoll (Hydraulischer Abgleich) bitte hinzufuegen und
     hydraulischer Abgleich alleiniges bitte entfernen, nur bei Heizlastberechnung in Klammern
     setzen").

     Der Grund liegt in der Sache: Nachgewiesen wird nicht "der Abgleich", sondern zwei
     Papiere - die raumweise Berechnung vorher und das VdZ-Protokoll danach. Eine dritte Zeile
     daneben zaehlte dieselbe Pflicht ein zweites Mal, nur ohne eigenes Dokument.

     Die Klammer sagt an beiden Zeilen, wozu das Papier gehoert. Dieselbe Schreibweise wie im
     Abschnitt "Das machen wir" weiter oben - ein Begriff, eine Form. */
  {req:"VdZ-Protokoll (Hydraulischer Abgleich)",
   why:"Das Protokoll zum hydraulischen Abgleich nach Verfahren B darf nur der Fachhandwerker ausfüllen - es ist der Nachweis, mit dem die Förderung steht. Die Umsetzung davor, EQ3-System oder Ventiltausch, machst du selbst.",
   svc:'ibn'},
  {req:"Belege für Eigenleistungs-Material", why:"Rechnungen für Fundament, Erdarbeiten & Co. aufheben, ohne Beleg zählt das Material nicht zur förderfähigen Summe.", svc:null}
];
function renderFoerderMap(){
  const el=document.getElementById('foerderMap'); if(!el) return;
  /* Progressive Disclosure: Pflicht + zuständiger Service sichtbar, das "Warum" klappt auf Klick auf */
  el.innerHTML=FOERDER_MAP.map(m=>{
    /* Der Zweig fuer 'hyd' ist am 25.09.2026 entfallen: Die Zeile nannte als zustaendigen
       Service "Hydraulischer Abgleich - Preis folgt", also einen, den es im Shop nicht gibt.
       Seit die Leistung in Technischer Planung und Anlagencheck steckt, hat sie keinen
       eigenen Eintrag mehr. */
    /* "INKLUDIERT IN" VOR DEM SERVICE (29.09.2026, Vorgabe Claras: "da in dem buttonartigen
       steht, in welchem Service es inkludiert ist - gerne davor noch ein 'inkludiert in'").

       Der Chip nannte nur Namen und Preis. Wer die Liste ueberflog, konnte ihn fuer den Preis
       der Pflicht daneben halten - als koste das VdZ-Protokoll 999 Euro. Er sagt aber, in
       welcher Leistung die Pflicht schon enthalten ist. Genau das steht jetzt davor.

       ALS EIGENE ZEILE IM CHIP, nicht davorgesetzt: Die Chips stehen auf white-space:nowrap,
       und "inkludiert in Anlagencheck & Inbetriebnahme · 999 €" waere in einer Zeile so breit
       geworden, dass die Pflicht daneben zusammengedrueckt wird. Klein und leiser gesetzt -
       es ist die Einordnung, nicht die Angabe.

       NUR WO ES EINEN SERVICE GIBT. Bei "machst du selbst" ist nichts inkludiert; die Zeile
       davorzusetzen waere schlicht falsch. */
    const svcChip = m.svcText ? esc(m.svcText)
      : m.svc===null ? 'machst du selbst'
      : `<span class="fm-svc-vor">inkludiert in</span>${esc(SERVICES[m.svc].name)} · ${eur(SERVICES[m.svc].price)}`;
    /* KEIN AUFKLAPPEN, KEINE HAEKCHEN (28.09.2026, Vorgabe Claras: "mach bei allen bitte das
       Aufgeklappte weg und stell direkt den Text dar, und mach die Haekchen weg").

       Die Zeilen waren Knoepfe: Pflicht und Service sichtbar, das "Warum" erst nach einem
       Klick. Das war als Progressive Disclosure gedacht - fuenf Zeilen mit je zwei Saetzen
       sind aber keine Liste, durch die man sich klicken muss. Jetzt steht alles da.

       AUS DEM KNOPF WIRD EIN div: Ein Knopf, der nichts mehr tut, ist fuer Tastatur und
       Vorlesesoftware eine Falle - er kuendigt eine Handlung an, die es nicht gibt.

       Die Haekchen waren gruene Kaesten vor jeder Zeile und lasen sich wie abgehakte
       Aufgaben - in einer Liste dessen, was noch zu tun ist, genau verkehrt herum. */
    return `<div class="foermap-row">
      <span class="fm-req"><b>${esc(m.req)}</b><span class="fm-why">${esc(m.why)}</span></span>
      <span class="fm-svc">${svcChip}</span>
    </div>`;
  }).join('');
}
renderFoerderMap();
/* Förder-Karte: einziges Regime seit der Kürzung vom 08.07.2026, zeigt die aktuell gültigen Sätze
   (Klimabonus & Kostendeckel live aus foerderHalfSteps() berechnet), keine AKTUELL/REFORM-Gegenüber-
   stellung mehr. Echte Nutzer-Werte fließen separat in die Checkout-Förderbox (foerderBox, updateTotal()). */
function renderFoerderCard(){
  const el=document.getElementById('foerderCard'); if(!el) return;
  const F=CONFIG.FOERDER, klimaNow=Math.max(0,F.KLIMA_START-F.KLIMA_SCHRITT*foerderHalfSteps()), capNow=foerderKostenCap();
  /* Progressive Disclosure: sichtbar sind nur Posten + Wert, die Erklärung (.src) klappt auf Klick auf */
  const row=(label,src,val,cls)=>`<button type="button" class="rrow xr${cls?' '+cls:''}" aria-expanded="false"><span class="rl"><b>${label} <span class="xr-chev" aria-hidden="true">▾</span></b><span class="src">${src}</span></span>${val}</button>`;
  el.innerHTML=
    row('Grundförderung','für jede förderfähige Wärmepumpe',`<span class="rv m">${F.GRUND} %</span>`)+
    row('Klimageschwindigkeits-Bonus',`Austausch einer fossilen Altheizung (Gas/Öl) · sinkt alle 6 Monate um ${F.KLIMA_SCHRITT} Punkte`,`<span class="rv m">+ ${klimaNow} %</span>`)+
    row('Einkommensbonus','gestaffelt nach Haushaltseinkommen, mit Kind höher',`<span class="rv m">bis + ${Math.max(...F.EK_MIT_KIND)} %</span>`)+
    row('Effizienzbonus','zum 21.07.2026 ersatzlos entfallen, ebenso der Emissionsminderungszuschlag',`<span class="rv m">entfällt</span>`)+
    row('Gedeckelt bei','70 % · für Selbstnutzende mit zu versteuerndem Haushaltseinkommen bis 30.000 € (mit minderjährigem Kind bis 40.000 €) sind es 80 %',`<span class="stamp"><b>≤${foerderCap()}</b><small>Prozent</small></span>`,'total')+
    row('EU-Fertigung','ab 01.01.2027: außerhalb der EU gefertigte Wärmepumpen erhalten nur noch 15 % Grundförderung, EU-gefertigte bleiben über den Wertschöpfungsbonus bei 30 %',`<span class="rv m">ab 2027</span>`)+
    row('Natürliches Kältemittel','Voraussetzung für die Förderung überhaupt - die Fox-Kits arbeiten mit R290',`<span class="rv m">erfüllt</span>`)+
    row('Auszahlung','nach Eingang der Bestätigung nach Durchführung (BnD) im KfW-Portal geht es in der Regel zügig aufs Konto',`<span class="rv m">nach der BnD</span>`)+
    row('Förderfähige Kosten',`1 Wohneinheit · sinkt ab Q1 2027 alle 6 Monate um ${F.KOSTEN_SCHRITT} €`,`<span class="rv m">${eur(capNow)}</span>`);
  el.querySelectorAll('.xr').forEach(r=>r.addEventListener('click',()=>{
    const open=r.getAttribute('aria-expanded')!=='true';
    r.setAttribute('aria-expanded',String(open)); r.classList.toggle('open',open);
  }));
  const p=document.getElementById('foerderKostenP');
  if(p) p.innerHTML=`Förderfähige Kosten aktuell bis ${eur(capNow)} im Einfamilienhaus, bei ${foerderCap()} % also bis zu ${eur(Math.round(capNow*foerderCap()/100/10)*10)} Zuschuss. Der Antrag muss <b>vor</b> Baubeginn gestellt sein, sonst verfällt er komplett; euer Kaufvertrag braucht dafür eine aufschiebende Bedingung.`;
}
renderFoerderCard();

/* Rechenzettel: offen auf Desktop, eingeklappt auf Mobile */
const rcpt=document.getElementById('receipt');
/* ledger_open feuerte bis 30.07.2026 NUR ueber die zwei "Rechenzettel"-Textlinks im Ergebnis
   (openLedger). Der normale Weg - auf die Zusammenfassung tippen - loeste nichts aus, und auf
   dem Handy ist das der einzige Weg, weil der Zettel dort zugeklappt startet. Das Oeffnen war
   damit praktisch unmessbar. Jetzt haengt das Ereignis am Aufklappen selbst.
   Programmatische Umschaltungen (Start, Fensterwechsel, Ergebnisanzeige) duerfen nicht
   mitzaehlen - deshalb die kurze Sperrfrist: das toggle-Ereignis kommt eine Aufgabe spaeter,
   ein einfaches Flag waere zum Zeitpunkt des Handlers schon zurueckgesetzt. */
let ledgerStummBis=0;
function ledgerStumm(){ ledgerStummBis=Date.now()+120; }
function syncReceipt(){ if(!rcpt) return; ledgerStumm(); rcpt.open = !finished && window.matchMedia('(min-width:921px)').matches; }
/* Den Rechenzettel gibt es nur dort, wo auch der Rechner steht - auf den Unterseiten nicht.
   Ohne diese Klammer stirbt das Skript hier und reisst alles Nachfolgende mit. */
if(rcpt){
  rcpt.addEventListener('toggle',()=>{
    if(rcpt.open && Date.now()>ledgerStummBis) track('ledger_open',{step:stepIndex,via:'zusammenfassung'});
  });
  syncReceipt(); window.matchMedia('(min-width:921px)').addEventListener('change',syncReceipt);
}

/* Scroll-Reveal */
(()=>{
  const els=document.querySelectorAll('.reveal:not(.in)');
  if(!('IntersectionObserver' in window)){ els.forEach(e=>e.classList.add('in')); return; }
  const io=new IntersectionObserver(entries=>{
    entries.forEach(en=>{ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
  },{threshold:.14,rootMargin:'0px 0px -6% 0px'});
  els.forEach(e=>io.observe(e));
})();

/* Der Fragebogen und der Rechenzettel schreiben in #app bzw. #rTotalTop. Beide stehen nur auf
   der Seite mit dem Rechner. Auf den Unterseiten wird hier nichts angeworfen - der Rest der
   Seite (Topbar, Aufklapper, Warenkorb, Artikel-Overlay) laeuft davon unabhaengig weiter. */
if(app){ show(0); renderLedger(); }

/* Wer schon mittendrin war, soll den Rechner nicht erneut aufklappen muessen. Geoeffnet wird
   deshalb sofort, wenn ein Stand vorliegt: begonnener oder fertiger Funnel, eine gemerkte
   Kaufauswahl, oder ein Tiefenlink mit Zustands-Token (?k=). Der Marker #los laeuft weiter
   ueber startFunnel() und oeffnet dort. */
if(app){
  let __standDa=false;
  try{ __standDa = new URLSearchParams(location.search).has('k'); }catch(e){}
  if(configStarted || finished || standKauf || standDirekt || __standDa) funnelOeffnen();
}

/* ============ ZWEITER EINSTIEG: KIT-KNOEPFE IN DER PFAD-WEICHE (02.09.2026) ============
   Die Weiche liegt in Liquid, die Kits stehen in PRODUCTS - deshalb wird sie hier gefuellt.
   Sie folgt demselben Sortiment-Schalter wie die Kit-Uebersicht: ausgeblendete Kits tauchen
   auch hier nicht auf. Der Klick geht direkt in openCartModal(), also in genau denselben
   Kaufweg, den auch die Kit-Kacheln auf /pages/produkt oeffnen - es gibt keinen dritten Weg.

   Faellt JavaScript aus, bleibt der in Liquid hinterlegte Rueckfall-Link auf /pages/produkt
   stehen; ueberschrieben wird er erst, wenn wirklich Kits gerendert werden konnten. */
/* Positionsanzahl der Lieferumfang-Karte aus der echten Liste (02.09.2026).
   Im Theme-Editor stand hier fest "12 Positionen", tatsaechlich sind es zwei - die Karte
   darunter listete sie sogar sichtbar auf. Eine getippte Zahl neben der Liste, die sie
   widerlegt, kostet genau das Vertrauen, um das es auf dieser Seite geht.

   GEZAEHLT WIRD, WAS DIE KARTE ZEIGT (25.09.2026, Meldung Claras: "bei Kits beim Lieferumfang
   steht noch 3 Positionen, muss aber 2 Positionen stehen"). Die Zahl kam aus LIEFERUMFANG.length
   und damit auf drei, waehrend die Tabelle darunter nur zwei Zeilen zeigte: renderLuLanding()
   filtert den Warmwasserspeicher heraus - er ist eine eigene Entscheidung im Konfigurator und
   gehoert nicht zum Kit. Beide lesen jetzt dieselbe Regel.

   DER EINTRAG BLEIBT IN LIEFERUMFANG STEHEN, er wird nur nicht mitgezaehlt: effektiverLU()
   braucht ihn als Platzhalter fuer den spaeter gewaehlten Speicher (siehe den Kommentar an
   renderLuLanding). Wer ihn dort loescht, nimmt dem gewaehlten Speicher seinen Platz. */
(function lieferumfangAnzahl(){
  const el=document.getElementById('luAnzahl'); if(!el) return;
  const liste=(typeof LIEFERUMFANG!=='undefined' && LIEFERUMFANG)
    ? LIEFERUMFANG.filter(([,n])=>!/Warmwasser/i.test(n)) : [];
  const n=liste.length;
  if(n>0) el.textContent = n===1 ? '1 Position' : n+' Positionen';
})();

/* Rueckweg-Knopf oben links im Rechner. */
(function rueckwegVerdrahten(){
  const b=document.getElementById('rechnerAndererWeg'); if(!b) return;
  b.addEventListener('click',()=>{ track('pfad_click',{pfad:'zurueck_zur_weiche'}); funnelSchliessen(); });
})();

(function pfadWeicheFuellen(){
  const box=document.getElementById('pfadKits'); if(!box) return;
  /* fox5 steht hier mit drin, obwohl der Rechner es nicht vorschlaegt: Diese Weiche ist fuer
     die, die ihr Kit schon kennen - sie soll zeigen, was es gibt, nicht was gerechnet wurde. */
  const kits=CONFIG.RULES.HYBRID_SICHTBAR ? ['fox5','fox8','fox10','fox12','hybrid'] : ['fox5','fox8','fox10','fox12'];
  const html=kits.map(k=>{
    const p=PRODUCTS[k]; if(!p) return '';
    return `<button type="button" class="pfad-kit" data-kit="${k}">`
      +`<span>${esc(p.name)}${p.sub?`<span class="pk-sub">${esc(p.sub)}</span>`:''}</span>`
      +`<span class="pk-preis">${eur(p.price)}</span></button>`;
  }).filter(Boolean).join('');
  if(!html) return;
  box.innerHTML=html;
  box.querySelectorAll('.pfad-kit').forEach(b=>b.addEventListener('click',()=>{
    track('pfad_click',{pfad:'direkt',kit:b.dataset.kit});
    openCartModal(b.dataset.kit, true);
  }));
})();
/* ============ ALTE #HASH-LESEZEICHEN WEITERREICHEN (Umzug 12.08.2026) ============
   Vor dem Umzug war jeder Reiter ein Sprungziel auf der Startseite: billigerwaermepumpe.de/#produkt.
   Solche Adressen stehen in Lesezeichen, in verschickten Links und in Googles Index.

   Sie lassen sich NICHT per Shopify-Weiterleitung umbiegen: der Teil hinter dem # wird vom
   Browser nie an den Server geschickt. Der Server sieht immer nur "/" und kann deshalb gar
   nicht wissen, wohin der Besucher wollte. Das muss die Startseite selbst erledigen.

   location.replace statt location.href: der alte Hash soll nicht im Verlauf stehen bleiben,
   sonst landet der Zurueck-Knopf in einer Schleife.

   Laeuft nur einmal beim Seitenaufbau. Spaetere Hash-Wechsel kommen aus dem Skript selbst
   (die Split-Ansicht setzt #bauteile) und duerfen nicht weitergeleitet werden. */
(function altesSprungzielUmleiten(){
  if(window.BWP_EINZELSEITE) return;                 /* nur die Startseite hatte je Hashes */
  const roh=decodeURIComponent(location.hash.slice(1));
  if(!roh) return;
  /* Abschnitte innerhalb eines Reiters mitnehmen: #kit gehoerte zum Produkt-Reiter usw. */
  const reiter = REITER_URL[roh] ? roh : ABSCHNITT_IM_REITER[roh];
  if(!reiter) return;
  const ziel=reiterUrl(reiter);
  if(ziel==='/') return;                             /* zeigt auf die Startseite selbst */
  /* SCHLEIFENSCHUTZ. Der Browser haengt die Sprungmarke nach einer Server-Weiterleitung
     wieder an. Fehlt die Zielseite und leitet der Shop zurueck, kaeme dieselbe Marke hier
     erneut an - und wir schickten wieder los. Genau das pendelte am 15.09. zwischen "/" und
     "/pages/rechner". Einmal pro Sitzung und Ziel reicht. */
  if(ziel===location.pathname || ziel+'/'===location.pathname) return;
  try{
    const merk='bwp_umzug_'+ziel;
    if(sessionStorage.getItem(merk)) return;
    sessionStorage.setItem(merk,'1');
  }catch(e){}
  location.replace(ziel + (reiter===roh ? '' : '#'+roh));
})();
/* Ohne Sprungmarke ist das eigene Panel gemeint - auf der Startseite "rechner", auf einer
   Unterseite deren eigenes. Stuende hier pauschal 'rechner', haelt showPanel das auf jeder
   Unterseite fuer einen fremden Reiter und schickt den Besucher sofort zur Startseite weiter.
   Genau das ist am 12.08.2026 passiert, unmittelbar nach dem Einbau der Weiterleitung. */
showPanel(location.hash.slice(1) || window.BWP_EINZELSEITE || aktiverReiterAusPfad());

/* DIE GANZE KIT-KARTE IST KLICKBAR (Vorgabe 17.09.2026), nicht nur ihr Knopf.

   Betrifft beide Stellen, an denen man ein Kit waehlt: die Karten im Rechner-Vergleich
   (.candcard) und die Kacheln auf dem Kits-Reiter (.kitcard-deep). Zwei Orte, eine Geste -
   dass sie sich unterschiedlich anfuehlen, ist schon einmal aufgefallen (Sortierung).

   ALS EIN LAUSCHER AM DOKUMENT, nicht als Handler je Karte: Beide Kartensorten werden
   mehrfach neu gebaut - bei jeder Antwort, bei jedem Sortiment-Wechsel. Handler an den
   Karten muessten jedes Mal neu gesetzt werden, und genau dort reisst so etwas ab.

   DER KNOPF BLEIBT STEHEN. Er ist die sichtbare Zusage, dass hier etwas passiert, und der
   einzige Weg fuer die Tastatur - eine Karte mit tabindex waere ein zweiter Halt fuer
   dieselbe Handlung. Geklickt wird deshalb der Knopf, nicht an ihm vorbei: Alles, was an
   ihm haengt (Messung, gespeicherter Stand, Ruckfall ohne Produktseite), gilt unveraendert.

   ZWEI AUSNAHMEN, die sonst Klicks schlucken oder doppelt ausloesen wuerden:
     - Klicks auf etwas, das selbst schon anklickbar ist (Knopf, Verweis, Feld). Sonst
       liefe der Klick auf den Knopf zweimal.
     - Ein Klick, der eine Textauswahl beendet. Wer einen Preis markiert, um ihn zu
       kopieren, will nicht die Seite wechseln. */
document.addEventListener('click',e=>{
  const karte=e.target.closest && e.target.closest('.candcard, .kitcard-deep');
  if(!karte) return;
  if(e.target.closest('a,button,input,label,select,textarea,summary,details')) return;
  try{ if(String(window.getSelection())) return; }catch(err){ /* ohne Auswahl-API einfach weiter */ }
  const ziel=karte.querySelector('.btn');
  if(ziel) ziel.click();
});

/* ?teil= UND ?zubehoer= FUEHREN DIREKT ZU EINEM PAKET IM ZUBEHOER-REITER (17.09.2026).

   Gebraucht vom Produkt-Infokasten. Seine Paketliste bietet je Position zwei Wege, und beide
   muessen ohne Suchen ankommen - bei 16 Paketen waere "irgendwo in der Liste" keine Hilfe:

     ?teil=p31      klappt die Position in der Liste auf (bauteileOpenItem)
     ?zubehoer=p31  oeffnet ihre Detailansicht (renderZubehoerDetail) - dort stehen
                    Beschreibung, Montagehinweis und Datenblattwerte, und dorthin kommt
                    spaeter die Montageanleitung zum Herunterladen

   DER SCHLUESSEL IST DER PAKET-SCHLUESSEL (p30, p31 ...), nicht der EXTRAS-Schluessel
   (erdleitung, haus_unter ...). Die Liste vergibt ihre Kennungen aus ZUBEHOER_PAKETE; wer
   hier den anderen Schluessel einsetzt, landet lautlos bei einem Element, das es nicht gibt.
   EXTRAS[k].paket fuehrt vom einen zum anderen.

   ALS ABFRAGE, NICHT ALS ANKER: Die Marke (#) traegt hier den Reiter, showPanel liest sie.
   Ein "#bt-p31" wuerde showPanel einen unbekannten Reiter nennen; die Links tragen deshalb
   "?teil=p31#bauteile" - der Anker bringt den Reiter, die Abfrage die Position.

   Steht NACH showPanel: Vorher ist der Zubehoer-Reiter noch nicht gezeichnet und es gaebe
   weder etwas aufzuklappen noch zu ersetzen. */
/* HIER STAND DIE WIEDERHERSTELLUNG DER GEMERKTEN STELLE. Sie hatte seit dem 01.10.2026 keinen
   Ausloeser mehr - der Pfeil oeffnet ein Fenster, statt die Seite zu wechseln, und damit wird
   nichts mehr gemerkt. Code, der nicht mehr laufen kann, steht hier nicht weiter herum; die
   Begruendung oben bei der entfallenen Rueckfahrt sagt, wie es dazu kam. */

(function paketAusLinkOeffnen(){
  let p; try{ p=new URLSearchParams(location.search); }catch(e){ return; }

  /* ZURUECK ZUM KIT (Vorgabe 17.09.2026). Der Verweis steht als leere Huelle in der Section
     und wird NUR hier sichtbar - also nur, wenn jemand ueber den Produkt-Infokasten einer
     Kit-Seite gekommen ist. Wer den Reiter aus der Navigation oeffnet, hat kein Kit, zu dem
     zurueck; dann bleibt die Huelle versteckt.

     NUR EIGENE PRODUKTPFADE. Der Wert steht in der Adresszeile und laesst sich von aussen
     setzen - ohne diese Pruefung waere der Knopf eine Weiterleitung auf jede beliebige
     Adresse, die von unserer Seite aus vertrauenswuerdig aussieht. Erlaubt ist deshalb
     ausschliesslich "/products/<handle>": ein fuehrender Schraegstrich, kein zweiter
     (sonst waere "//fremde.example" ein gueltiger Protokoll-relativer Verweis), kein
     Doppelpunkt, keine weiteren Segmente.

     SEIT DEM 18.09.2026 IST GENAU EINE ABFRAGE ERLAUBT: "?pinfo=r1|r2|r3". Ohne sie landete
     der Rueckweg zwar auf der richtigen Seite, aber ganz oben - und nicht an der Stelle, an
     der man weggegangen ist (gemeldet von Clara). Der Wert sagt drueben, welcher Reiter des
     Infokastens zu oeffnen ist; dorthin wird auch gescrollt.

     BEWUSST ALS TEIL DES GEPRUEFTEN WERTS und nicht hier angehaengt: Wohin zurueck, entscheidet
     die Seite, die einen weggeschickt hat. Haenge ich die Abfrage hier an, muesste diese Datei
     wissen, aus welchem Reiter der Besucher kam - eine Kopplung, die beim naechsten Reiter
     wieder zu pflegen waere. Die Form bleibt eng begrenzt: kein freier Text, drei Werte. */
  const zurueck=p.get('zurueck');
  if(zurueck && /^\/products\/[A-Za-z0-9._~%-]+(\?pinfo=r[123])?$/.test(zurueck)){
    const a=document.getElementById('zubZurueck');
    if(a){ a.setAttribute('href',zurueck); a.hidden=false; }
  }

  /* WOHIN DER RUECKWEG FUEHRT - gemerkt wird der Paket-Schluessel, nicht die Scrollhoehe
     (29.09.2026, Meldung Claras: "wenn man wieder auf 'Zurueck zur Uebersicht' geht, landet
     man am Seitenanfang, anstatt da, wo man urspruenglich auf die Produktpaketseite gekommen
     ist").

     Eine Pixelzahl waere das Naheliegende und das Falsche: Die Uebersicht ist ein Raster, das
     je nach Fensterbreite zwei, drei oder vier Kacheln nebeneinander legt. Wer das Fenster
     dreht oder auf dem Weg ein Paket zur Konfiguration hinzunimmt, findet an derselben
     Pixelhoehe etwas voellig anderes. Der Schluessel dagegen zeigt immer auf dasselbe Paket.

     sessionStorage und nicht localStorage: Das gilt fuer diesen Besuch und soll nicht in
     einer Woche noch irgendwo hinspringen. Und in Klammern, weil der Zugriff in privaten
     Fenstern eine Ausnahme wirft - dann gibt es eben keinen Rueckweg an die Stelle, aber
     auch keinen Fehler. */
  const MERKER='bwp_bauteile_zurueck';

  const detail=p.get('zubehoer');
  if(detail){
    /* DIE KLASSE STEHT VOR DEM ZEICHNEN, nicht danach (29.09.2026). Sie blendet Kopfband,
       Listentitel und Werkzeug-Abschnitt aus; geschieht das erst hinterher, rechnet der
       Sprung in renderZubehoerDetail mit einer Seite, die es einen Wimpernschlag spaeter
       nicht mehr gibt. Erst raeumen, dann zeichnen, dann blicken. */
    document.documentElement.classList.add('bwp-paketseite');
    if(typeof renderZubehoerDetail==='function') renderZubehoerDetail(detail,{ohneSprung:true});
    /* AN DEN ANFANG DER PAKETSEITE, ohne Animation (Meldung Claras: "dann kommt man nicht an
       den Anfang der Produktpaketseite, sondern wird ans Ende geleitet"). Es ist ein
       Seitenaufruf und kein Sprung innerhalb einer Seite - da gehoert der Blick nach oben,
       so wie bei jeder anderen Adresse auch.

       Zweimal, und beim zweiten Mal nach dem Laden: Browser stellen beim Zurueckgehen die
       alte Scrollhoehe wieder her, und zwar nach unserem Aufruf. Der zweite raeumt das auf. */
    const anDenAnfang=()=>{ try{ window.scrollTo(0,0); }catch(e){ document.documentElement.scrollTop=0; } };
    anDenAnfang();
    if(document.readyState!=='complete') window.addEventListener('load',anDenAnfang,{once:true});
    /* EINE EIGENE SEITE SIEHT AUCH SO AUS (29.09.2026, Vorgabe Claras: "wenn man auf 'Paket
       ansehen' klickt und dann auf das Paket kommt, ist das eine eigene Seite - dann
       verschwindet also der Header und auch die Werkzeuge unten").

       Seit die Pakete eine eigene Adresse haben, ist das hier keine Ansicht INNERHALB der
       Bauteile-Seite mehr, sondern deren Ziel. Alles, was zur Uebersicht gehoert - das
       Kopfband mit dem Seitentitel, die Ueberschrift ueber den Kacheln und der
       Werkzeug-Abschnitt am Ende -, gehoert dann nicht mehr dazu und wuerde das Paket
       einrahmen wie einen Einschub.

       NUR AUF DIESEM WEG: Die Klasse haengt in diesem Zweig, also am Aufruf ueber die
       Adresse. Wer die Paketansicht aus der Kaufbox oder dem Warenkorb-Dialog oeffnet, sieht
       weiter seine ganze Seite - dort ist sie wirklich nur ein Einschub.

       Der Rueckweg raeumt sie nicht weg: Er laedt die Uebersichtsadresse, und damit ist die
       Klasse ohnehin fort.

       GESETZT WIRD SIE WEITER OBEN, vor dem Zeichnen - siehe die Begruendung dort. */
    /* NUR EIN RUECKWEG, WENN MAN AUS DEM KIT KOMMT (Vorgabe 24.09.2026). Die Detailansicht
       bringt oben rechts "Zurueck zur Uebersicht" mit - sinnvoll, solange jemand innerhalb
       der Bauteile-Seite blaettert. Wer aus dem Produktpakete-Reiter einer Kit-Seite kommt,
       hat darueber aber schon "Zurueck zum Kit" stehen: zwei Rueckwege untereinander, die an
       verschiedene Orte fuehren, und der falsche steht oben.

       Ausgeblendet statt entfernt: Die Schaltflaeche gehoert zu renderZubehoerDetail, und die
       wird auch aus der Kaufbox und dem Warenkorb-Dialog aufgerufen - dort ist sie der
       einzige Weg zurueck. Die Bedingung haengt deshalb am sichtbaren "Zurueck zum Kit",
       nicht an der Funktion.

       style.display statt hidden: Die Schaltflaeche traegt display:block als Inline-Stil,
       gegen den [hidden] nicht ankommt. */
    const zurueckZumKit=document.getElementById('zubZurueck');
    if(zurueckZumKit && !zurueckZumKit.hidden){
      const raus=document.getElementById('btDetailBack');
      if(raus) raus.style.display='none';
    } else {
      /* Wer ueber die Adresse hier ankommt, hat eine eigene Seite geoeffnet - "Zurueck zur
         Uebersicht" muss dann auch die Adresse aufraeumen. Ohne das bliebe ?zubehoer= stehen,
         und ein Neuladen zeigte wieder das Paket statt der Uebersicht. */
      const raus=document.getElementById('btDetailBack');
      if(raus) raus.onclick=()=>{
        /* Merken, WELCHES Paket man verlaesst - drueben wird zu dieser Kachel gescrollt. */
        try{ sessionStorage.setItem(MERKER,detail); }catch(e){}
        location.href=reiterUrl('bauteile');
      };
    }
    return;
  }
  /* ZURUECK AUF DER UEBERSICHT: zu der Kachel, von der aus jemand weggegangen ist.

     Der Merker wird gelesen UND geloescht - er gilt fuer genau diesen einen Rueckweg. Wer die
     Bauteile spaeter aus der Navigation oeffnet, soll oben anfangen und nicht dort, wo er
     vorgestern war.

     block:'center' statt 'start': Die Kachel steht dann mitten im Bild, mit den Nachbarn
     darum - das ist der Zusammenhang, aus dem man weggegangen ist. Ganz oben angeschlagen
     saehe es aus wie eine gefilterte Liste.

     'auto' und nicht 'smooth': Die Seite wird gerade erst aufgebaut, eine Animation von oben
     nach unten waere kein Wiederfinden, sondern eine Vorfuehrung. */
  try{
    const zurueckZu=sessionStorage.getItem(MERKER);
    if(zurueckZu){
      sessionStorage.removeItem(MERKER);
      const kachel=document.getElementById('bt-'+zurueckZu);
      if(kachel && kachel.scrollIntoView) kachel.scrollIntoView({block:'center'});
    }
  }catch(e){}

  const key=p.get('teil'); if(!key) return;
  const det=document.getElementById('bt-'+key);
  if(det && typeof bauteileOpenItem==='function') bauteileOpenItem(det);
})();
/* Ankunft aus einem CTA einer Unterseite: dort gibt es keinen Rechner, der Knopf hat deshalb
   hierher geschickt (siehe startFunnel). Jetzt den Funnel oeffnen, damit der Klick zu Ende
   gefuehrt wird - ohne das landet der Besucher nur irgendwo auf der Startseite und muss den
   Rechner selbst suchen. Die Marke wird danach aus der Adresszeile geraeumt, damit ein
   spaeteres Neuladen oder ein geteilter Link den Funnel nicht erneut aufreisst. */
if(location.hash==='#los'){
  history.replaceState(null,'',location.pathname+location.search);
  if(app) setTimeout(()=>startFunnel(),60);
}

/* Sticky Mobile-CTA: sichtbar sobald der Hero-CTA aus dem Bild scrollt, versteckt sich wieder über der
   Footer-CTA - und ueber dem Rechner selbst, solange er dort nichts Neues anbietet (im Kit-Detail bleibt
   er als direkter Reservieren-Shortcut sichtbar). */
let __stickyObservers=[];
function initStickyObservers(){
  __stickyObservers.forEach(o=>o.disconnect()); __stickyObservers=[];
  const bar=document.getElementById('stickyCta'), foot=document.querySelector('footer'), qcard=document.querySelector('.qcard');
  /* OBERES BEZUGSELEMENT: sonst der Hero. Den gibt es nur auf der Startseite und im
     One-Pager - auf der Rechnerseite fehlt er, und weil diese Funktion ohne ihn sofort
     zurueckkam, ist die Leiste dort nie erschienen. Genau das war gewuenscht (22.09.2026):
     dieselbe einfahrende Leiste wie auf der Startseite, nur mit "Jetzt durchrechnen".
     Ersatzweise der Kopfblock der Rechnerseite - er steht an derselben Stelle im Aufbau, ganz
     oben, und ist damit dasselbe Signal: Ist er aus dem Bild, ist der Besucher im Inhalt.
     AUSDRUECKLICH NUR DIESE EINE SEITE. Ein allgemeiner Rueckfall auf "das erste beste
     Element oben" haette die Leiste auf jeder Unterseite erscheinen lassen - auf /produkt,
     /ablauf, /foerderung -, wo sie bisher nie war und niemand sie bestellt hat.
     Die uebrige Heuristik bleibt unberuehrt: Nahe am Footer verschwindet die Leiste, und
     solange die Fragekarte im Bild ist, ebenfalls - auf der Rechnerseite heisst das, sie
     kommt genau dann, wenn das Formular aus dem Bild gescrollt ist. Also dann, wenn der Weg
     zurueck dorthin etwas wert ist. */
  const hero=document.querySelector('header.hero')
    || (window.BWP_EINZELSEITE==='rechner' ? document.querySelector('.rechner-kopf-block') : null);
  if(!bar||!hero||!foot||!('IntersectionObserver' in window)) return;
  let heroGone=false, footNear=false, qcardVisible=false;
  /* Waehrend der Split-View (persistiert jetzt ueber alle Reiter) gilt die Scroll-Heuristik unten
     nicht mehr zuverlaessig - Hero/Qcard sind auf fremden Panels ausgeblendet, ihr Intersection-
     Status ist dort irrelevant. Solange .bwp-split aktiv ist, Sticky-CTA also immer zeigen. */
  /* Der Hilfe-Knopf sitzt unten rechts und wuerde sonst unter der Sticky-Leiste verschwinden -
     die Klasse am <html> hebt ihn per CSS an, solange die Leiste sichtbar ist. */
  const sync=()=>{
    const on = (document.documentElement.classList.contains('bwp-split') || (heroGone && !footNear && !(qcardVisible && !currentCand)))
               && !__hauptCtaSichtbar;   /* echter Knopf im Bild schlaegt jede Heuristik - siehe beobachteHauptCta() */
    bar.classList.toggle('show', on);
    document.documentElement.classList.toggle('bwp-sticky-on', on);
    /* Echte Hoehe der Leiste als Variable weitergeben. Der Live-Lieferumfang legt sich auf
       Mobile darueber und muss exakt so weit hoch - geschaetzte 62px lagen 8px zu tief und
       die beiden ueberlappten. Die Hoehe haengt an Schriftgroesse und Safe-Area, also messen
       statt rechnen. offsetHeight funktioniert auch bei ausgefahrener Leiste (transform). */
    document.documentElement.style.setProperty('--stickycta-h', bar.offsetHeight+'px');
  };
  window.__bwpStickySync=sync;
  const io1=new IntersectionObserver(es=>{ heroGone=!es[0].isIntersecting; sync(); },{rootMargin:'-72px 0px 0px 0px'}); io1.observe(hero);
  const io2=new IntersectionObserver(es=>{ footNear=es[0].isIntersecting; sync(); },{rootMargin:'0px 0px -4% 0px'}); io2.observe(foot);
  __stickyObservers=[io1,io2];
  if(qcard){ const io3=new IntersectionObserver(es=>{ qcardVisible=es[0].isIntersecting; sync(); },{rootMargin:'-64px 0px -20% 0px'}); io3.observe(qcard); __stickyObservers.push(io3); }
}
/* Holt die gemerkte Kaufauswahl zurueck und zeichnet die Kaufbox neu, so wie der Kunde sie
   verlassen hat. Laeuft nur auf der Seite mit dem Rechner und nur, wenn der Funnel fertig war.

   Bewusst NICHT selectCandidate(): das meldet einen Kit-Klick, den es hier nicht gab. Der Rest
   ist identisch - deshalb steht die Weiche pro/diy hier genauso wie dort.

   Passt der gemerkte Kit nicht mehr zu den Antworten (der Kunde hat zwischendurch etwas
   geaendert), wird nichts wiederhergestellt: dann ist die Kit-Wahl neu zu treffen, und der
   Vergleich ist die ehrlichere Antwort als eine Kaufbox zu einem ueberholten Vorschlag. */
function stelleKaufWiederHer(){
  if(!standKauf || !finished || !app) return false;
  let r; try{ r=routeAll(); }catch(e){ return false; }
  const cand=(r.candidates||[]).find(c=>c.kit===standKauf.kit);
  if(!cand) return false;
  /* Nur Schluessel uebernehmen, die es heute noch gibt UND die heute noch buchbar sind - ein
     Stand aus einer aelteren Fassung darf keine unbekannten und keine zurueckgezogenen
     Positionen in den Warenkorb schieben.

     DIE ZWEITE BEDINGUNG KAM AM 28.10.2026 DAZU, mit dem Netzmanagement. Der Eintrag bleibt
     in SERVICES stehen (buyable:false, fuer alte Bestellungen und den Foerderung-Tab) - die
     alte Pruefung "gibt es den Schluessel?" haette ihn also durchgelassen. Wer ihn vor heute
     angehakt hatte und zurueckkommt, haette ihn weiter im Korb gehabt, mit Preis und in der
     Kasse, ohne ihn abwaehlen zu koennen: Die Zeile wird nicht mehr gerendert, es gibt kein
     Haekchen mehr, das man ausmachen koennte. */
  chosenServices=new Set((standKauf.services||[]).filter(k=>SERVICES[k] && SERVICES[k].buyable!==false));
  chosenExtras={};
  Object.entries(standKauf.extras||{}).forEach(([k,v])=>{ if(EXTRAS[k]&&v) chosenExtras[k]=v; });
  vorauswahlGesetzt=(standKauf.vgesetzt||[]).filter(k=>EXTRAS[k]);
  vorauswahlGruende={};
  if(standKauf.vgruende){
    /* Alter Token oder gespeicherter Stand: die Texte sind dabei, also von dort. */
    Object.entries(standKauf.vgruende).forEach(([k,g])=>{ if(EXTRAS[k]) vorauswahlGruende[k]=String(g); });
  } else {
    /* Kurzer Token (ab 26.08.2026): die Texte reisen nicht mehr mit, weil der Link sonst
       ueber die 998-Zeichen-Grenze einer Mail-Zeile lief. Sie kommen aus derselben Quelle,
       die sie urspruenglich erzeugt hat - vorauswahlPlan() liest die Antworten, und die
       stehen zu diesem Zeitpunkt bereits wiederhergestellt in A. Gleiches Ergebnis, nur
       gerechnet statt transportiert. */
    try{
      vorauswahlPlan().forEach(pl=>{ if(EXTRAS[pl.key]) vorauswahlGruende[pl.key]=String(pl.grund); });
    }catch(e){ /* ohne Begruendungstexte ist die Kaufbox karger, aber vollstaendig */ }
  }
  /* Die Vorauswahl NICHT erneut anwenden: sie wuerde Positionen zurueckholen, die der Kunde
     bewusst abgewaehlt hat. Das Kit hier einzutragen schaltet den Block in renderBuyBox ab. */
  buyboxPreselectedFor=cand.kit;
  chosenCandidate=cand;
  /* DEN ERGEBNIS-ZUSTAND DES FUNNELS MITHERSTELLEN - nicht nur die Kaufbox zeichnen.
     finish() setzt drei Dinge, an denen das Layout haengt; ohne sie sieht die Seite nach dem
     Zurueckkommen kaputt aus. Am wichtigsten ist die Klasse "done" auf #funnelGrid: sie
     schaltet das Raster von zwei Spalten (Frage links, Rechenzettel rechts) auf eine breite
     Spalte um. Ohne sie klemmt die Kaufbox in der linken Haelfte - 462 statt 976 Pixel,
     der Rechenzettel steht daneben. Genau so hat der Kunde es am 12.08.2026 gemeldet.
     Nachgestellt statt finish() aufzurufen: finish() zeichnet den Kandidatenvergleich, den
     die Kaufbox eine Zeile spaeter ohnehin wieder ueberschreiben wuerde. */
  /* Auch hier ist der Gesamtbalken entfallen (14.10.2026); diese Stelle war immerhin
     geprueft. Den Endstand der Abschnittsleiste setzt setProgress(). */
  if(typeof setProgress==='function') setProgress();
  const grid=document.getElementById('funnelGrid'); if(grid) grid.classList.add('done');
  const rcW=document.getElementById('receipt');
  if(rcW){ if(typeof ledgerStumm==='function') ledgerStumm(); rcW.open=false; }
  stummeWiederherstellung=true;
  try{
    if(A.installMode==='pro') renderProLead(cand,r,cand.kit==='hybrid'?'beistell':'komplett');
    else renderBuyBox(cand,r);
  } finally { stummeWiederherstellung=false; }
  return true;
}

/* ============ DURCHREICHE IN DIE KASSE (24.08.2026) ============
   Der Kauflink in der Konfigurations-Mail soll den Kunden in der Shopify-Kasse absetzen,
   nicht im Rechner. Der Weg fuehrt trotzdem ueber die Seite - das ist kein Umweg aus
   Bequemlichkeit, sondern der einzige Weg, der geht: nur /cart/add.js im Browser kann die
   Positions-Eigenschaften setzen, die der Kunde in der Kasse und spaeter auf der Rechnung
   sieht. Ein Shopify-Permalink kann das nicht (siehe kaufToken()).

   Gesprungen wird ueber checkout() - denselben Weg, den auch der Kaufknopf nimmt. Kein
   zweiter Bestellweg, der auseinanderlaufen kann.

   NICHT gesprungen wird, wenn irgendetwas nicht eindeutig ist. Jede dieser Bedingungen
   laesst den Kunden stattdessen im fertig gefuellten Rechner stehen - er sieht dann genau
   das, was er vorher auch gesehen haette, und entscheidet selbst:
     - Fachbetrieb-Weg: dort gibt es gar keinen Kauf, sondern ein Lead-Formular.
     - Eignungs-Warnung noch nicht bestaetigt: die Warnung will gelesen werden.
     - Kaufknopf fehlt oder Produkt ist TBD: dann gibt es nichts zu kaufen.
   Offene Foerderpunkte fangen wir hier NICHT ab - checkout() zeigt dafuer seinen Dialog,
   und der ist an dieser Stelle genauso richtig wie beim Klick auf den Knopf. */
function direktZurKasse(){
  if(!chosenCandidate) return false;
  if(A.installMode==='pro') return false;
  const knopf=document.getElementById('buyBtn');
  if(!knopf) return false;
  const eignung=document.getElementById('unsuitOk');
  if(eignung && !eignung.checked) return false;
  if(!PRODUCTS.deposit || String(PRODUCTS.deposit.variantId).startsWith('TBD_')) return false;
  /* A/B-VARIANTENWECHSEL: die Mail hat einen Heute-Betrag genannt. Stimmt der nicht mehr,
     wuerde der Kunde in einer Kasse landen, die etwas anderes verlangt als seine Mail
     versprochen hat - im schlimmsten Fall 199 EUR nach "Heute zahlst du nichts". Dann
     lieber die Kaufbox zeigen: dort sieht er den heutigen Betrag, bevor er klickt.
     Aeltere Links ohne das Feld (ausLinkAnzahlung===null) reichen wie bisher durch. */
  if(ausLinkAnzahlung!==null && ausLinkAnzahlung!==PRODUCTS.deposit.price){
    track('kasse_durchreiche_variantenwechsel',
      {war:ausLinkAnzahlung, ist:PRODUCTS.deposit.price});
    return false;
  }
  /* PREISDRIFT: der Token traegt nur Schluessel, nie Betraege - die Kasse rechnet also immer
     mit den heutigen Preisen. Genau das ist das Problem, wenn nicht mehr hingesehen wird:
     die Mail nannte eine Summe, und wer ungefragt durchgereicht wird, bekommt die neue nie
     zu Gesicht. Deshalb hier gegen dieselbe Quelle pruefen, aus der auch die Mail kam
     (paketSchnappschuss), statt die Rechnung ein zweites Mal aufzuschreiben.
     Eine Frist waere das groebere Mittel: sie bestraft den Kunden, der nach zwei Wochen
     klickt, obwohl sich nichts geaendert hat - und laesst eine Preisaenderung am naechsten
     Tag durch. Verglichen wird deshalb der Betrag, nicht das Alter. */
  if(ausLinkGesamt!==null){
    let jetzt=null;
    /* UNTER DER RABATTLAGE DES TOKENS VERGLEICHEN (24.09.2026).
       Die Frage dieser Pruefung ist: "Hat sich ein PREIS geaendert, seit die Mail rausging?"
       Ein Rabatt, den derselbe Link mitbringt, ist keine Preisaenderung - er soll durch.
       Bis heute kam das nicht vor, weil ?rabatt= neben ?k= verworfen wurde.

       Deshalb fuer die Dauer EINER Rechnung die Rabattlage herstellen, unter der gs entstand,
       und danach sofort die heutige zurueck. paketSchnappschuss() hat keine Nebenwirkungen -
       kein Tracking, kein DOM -, der Umschalter ist also von aussen nicht zu sehen. So bleibt
       es bei EINER Quelle fuer die Summe, statt den Rabatt hier ein zweites Mal abzuziehen.

       Eine echte Preisaenderung faellt weiterhin auf, mit oder ohne Code. Genau das ist ab
       dem 24.09.2026 bei vielen Links der Fall: die Zubehoerpreise wurden in dieser Woche
       angepasst, und wer eine davon im Paket hat, wird nicht durchgereicht, sondern sieht
       seine Kaufbox mit den neuen Preisen. So ist es gedacht. */
    /* Seit dem 28.09.2026 mit dem Code des Tokens, nicht nur ja/nein - sonst verglichen ein
       Link mit festem Betrag und ein heute eingeloester Prozentcode zwei verschiedene Abzuege. */
    const heute=rabattAktiv, heuteCode=rabattGewaehlt;
    try{
      rabattAktiv=!!ausLinkRabatt; rabattGewaehlt=ausLinkRabatt;
      const s=paketSchnappschuss(); jetzt=s&&s.gesamt_mit_lieferung;
    }catch(e){}
    finally{ rabattAktiv=heute; rabattGewaehlt=heuteCode; }
    if(typeof jetzt==='number' && jetzt!==ausLinkGesamt){
      track('kasse_durchreiche_preisdrift',{war:ausLinkGesamt, ist:jetzt});
      return false;
    }
  }

  /* Sichtbarer Zustand statt weisser Seite: zwischen Klick in der Mail und der Kasse liegen
     drei Netzwerk-Requests. Ohne Schirm saehe der Kunde eine Sekunde lang den Rechner
     aufblitzen und wuerde denken, er sei falsch gelandet. */
  const kit=(PRODUCTS[chosenCandidate.kit]||{}).name||'Deine Konfiguration';
  const ov=document.createElement('div');
  ov.className='kw-overlay'; ov.id='kasseWeiter';
  ov.innerHTML='<div class="kw-card" role="status" aria-live="polite">'
    +'<div class="kw-spin" aria-hidden="true"></div>'
    +'<b>Deine Konfiguration wird an die Kasse übergeben …</b>'
    +'<span>'+esc(kit)+' &ndash; genau so, wie es in deiner E-Mail steht.</span>'
    +'<button type="button" class="btn quiet" id="kwStop">Lieber erst ansehen</button>'
    +'</div>';
  document.body.appendChild(ov);
  scrollSperren('kasse');
  const zu=()=>{ ov.remove(); scrollFreigeben('kasse'); };
  /* ZURUECK-KNOPF AUS DER KASSE. Beim erfolgreichen Durchreichen bleibt der Schirm bewusst
     stehen, bis die Kasse die Seite ersetzt - sonst blitzte der Rechner im letzten Moment
     doch noch auf. Drueckt der Kunde in der Kasse aber "zurueck", holt der Browser diese
     Seite aus dem bfcache: DOM und JS-Zustand kommen 1:1 wieder, das Skript laeuft NICHT
     erneut. Ohne diesen Handler saehe er einen endlos drehenden Ring ueber einer Seite,
     die sich wegen overflow:hidden nicht scrollen laesst - der Rechner waere tot.
     kasseAbgebrochen zusaetzlich setzen: eine noch offene kasseFrei-Kette darf ihn nicht
     nachtraeglich doch wieder in die Kasse schieben. checkout() setzt es beim naechsten
     echten Kaufklick wieder zurueck, der Knopf bleibt also benutzbar. */
  window.addEventListener('pageshow',e=>{ if(e.persisted){ kasseAbgebrochen=true; zu(); } });
  ov.querySelector('#kwStop').onclick=()=>{
    kasseAbgebrochen=true; zu();
    track('kasse_durchreiche_abbruch',{kit:chosenCandidate.kit});
    if(knopf.scrollIntoView) knopf.scrollIntoView({behavior:'smooth',block:'center'});
  };

  track('kasse_durchreiche',{kit:chosenCandidate.kit});
  /* zu() als onAbort: greift, wenn checkout() den Foerder-Dialog zeigt statt zu navigieren -
     der Dialog braucht die Seite dahinter, nicht unseren Schirm. */
  checkout(chosenCandidate, zu);
  return true;
}

/* Gespeicherten Stand zurueckholen, BEVOR Sticky und Resume-Chip sich zeichnen - beide lesen
   finished/configStarted/stepIndex und bieten danach von selbst den richtigen Einstieg an:
   fertiger Funnel -> "Zu deinem Ergebnis", mittendrin -> "Weiter im Rechner, Frage x/y". */
/* Frueher Anker fuer GTM: sagt die Variante an, bevor der Kunde etwas tut. Bewusst KEIN
   track() - das wuerde den Eintrag durch stummeWiederherstellung unterdruecken koennen. */
try{ window.dataLayer=window.dataLayer||[]; window.dataLayer.push({event:'bwp_variante',...GTM_VARIANTE}); }catch(e){}

/* ============ WERKSZUSTAND AUF ZURUF: ?neu ============ (16.09.2026)
   Zum Durchspielen aus Sicht eines Besuchers, der zum ersten Mal da ist. Der gespeicherte
   Stand liegt im Browser des Besuchers, nicht im Theme - er laesst sich also weder von uns
   noch aus dem Admin loeschen. Diese Weiche ist der einzige Weg, ihn von der Seite aus
   loszuwerden, ohne in die Entwicklerwerkzeuge zu steigen:

       /pages/rechner?neu

   Geloescht wird beides: der gespeicherte Stand (Antworten, Schritt, Kaufauswahl,
   Warenkorb) und die Merker der Sitzung (gesehene Rundgaenge, einmalige Weiterleitungen).
   Der Shopify-Warenkorb bleibt - der gehoert dem Shop, nicht dem Rechner, und wird beim
   naechsten Kaufklick ohnehin neu gesetzt.

   Der Parameter wird danach aus der Adresszeile geraeumt: Ein Neuladen oder ein geteilter
   Link soll niemandem unbemerkt seinen Stand nehmen.

   BEWUSST OHNE SCHUTZ: Er richtet keinen Schaden an, den der Besucher nicht selbst
   anrichten koennte, und wer ihn nicht kennt, loest ihn nicht versehentlich aus. */
(function werkszustand(){
  let p; try{ p=new URLSearchParams(location.search); }catch(e){ return; }
  if(!p.has('neu')) return;
  vergissStand();
  try{ sessionStorage.clear(); }catch(e){}
  p.delete('neu');
  const rest=p.toString();
  try{ history.replaceState(null,'',location.pathname+(rest?'?'+rest:'')+location.hash); }catch(e){}
})();

/* ============ KAUFLINK OHNE RECHNER -> AUF DIE RECHNERSEITE (24.09.2026) ============
   Kauflinks zeigen auf die Startseite: kauf_link in paketSchnappschuss() baut
   https://billigerwaermepumpe.de/?k=... - aus der Zeit, als der Rechner dort stand. In Claras
   Aufbau (live seit 17.09.2026) steht er auf /pages/rechner, die Startseite hat kein #app mehr.

   Was dann passierte, ohne Fehlermeldung: ladeAusLink() las den Token, raeumte ihn aus der
   Adresszeile, stelleKaufWiederHer() stieg mangels #app aus, und der Kunde sah die normale
   Startseite. Die Konfiguration war weg, die Durchreiche in die Kasse fand nie statt. Das traf
   den Hauptknopf JEDER Konfigurations-Mail seit dem 17.09.2026 - am 24.09.2026 im Harnisch
   gegen das ausgelieferte Skript nachgestellt.

   WEITERLEITEN STATT DEN LINK NEU BAUEN. Die kaputten Links liegen schon in den Postfaechern;
   nur eine Weiterleitung auf der Zielseite repariert auch die. Alles hinter dem Pfad reist mit
   (?k=, &rabatt=, &kasse=1, utm_*, #...), damit die Rechnerseite exakt denselben Aufruf sieht.

   location.replace statt href: der Zwischenschritt soll nicht in der Zurueck-Liste stehen,
   sonst fuehrt "zurueck" aus dem Rechner wieder auf den Weiterleiter und sofort wieder vor.

   UND DANACH NICHTS MEHR: Die Navigation ist asynchron, dieses Skript laeuft noch zu Ende.
   Ohne kauflinkWeiter wuerden Rabatt und Konfiguration hier schon eingeloest, gezaehlt und
   aus der Adresse geraeumt - im schlimmsten Fall raeumt replaceState die Adresse, BEVOR der
   Browser sie fuer die Weiterleitung gelesen hat.

   ZIEL IST SEIT DEM 24.09.2026 (ABENDS) DIE PRODUKTSEITE DES KITS, NICHT MEHR DER RECHNER
   (Betreiber-Entscheid: "die Links leiten einen noch zum alten Rechner, da sollte man aber
   nicht hin, man sollte in den neuen Checkout"). Der neue Kaufweg ist Claras Produktseite
   /products/<kit> mit Kit-Konfigurator und Warenkorb-Schublade; die alte Kaufbox auf
   /pages/rechner (renderBuyBox) soll aus einem Link heraus niemand mehr sehen.

   Deshalb greift die Weiterleitung jetzt AUCH auf der Rechnerseite (vorher: if(app) return) und
   auf einer Produktseite des falschen Kits. Das Kit steht im Token (kauf.kit), der Pfad in
   PRODUCTS[kit].handle - dieselbe Quelle wie jeder andere Link auf eine Produktseite.

   RUECKFALL AUF DEN RECHNER nur, wenn es keine Produktseite gibt: Kit unbekannt, kein handle,
   oder das Hybrid-Kit, solange es ausgeblendet ist (HYBRID_SICHTBAR=false) - dessen Seite
   verkauft nichts, das Hybrid ist dort nicht waehlbar.

   KEINE SCHLEIFE: Auf der Zielseite selbst ist pathname===ziel, dort wird nicht weitergeleitet.
   Jede andere Seite leitet hoechstens einmal. */
const kauflinkWeiter=(function(){
  let q; try{ q=new URLSearchParams(location.search); }catch(e){ return false; }
  if(!q.has('k')) return false;
  let kit=null;
  try{
    const b=String(q.get('k')).replace(/-/g,'+').replace(/_/g,'/');
    const d=JSON.parse(decodeURIComponent(escape(atob(b))));
    kit=(d && d.kauf && d.kauf.kit) || null;
  }catch(e){ kit=null; }
  const prod = kit && PRODUCTS[kit];
  const hybridAus = kit==='hybrid' && !CONFIG.RULES.HYBRID_SICHTBAR;
  let ziel = (prod && prod.handle && !hybridAus) ? '/products/'+prod.handle : null;
  /* Ohne Produktseite: auf den Rechner - aber nur von einer Seite ohne Rechner aus. */
  if(!ziel) ziel = app ? null : '/pages/rechner';
  if(!ziel) return false;
  if(location.pathname.replace(/\/+$/,'')===ziel) return false;
  try{ location.replace(ziel+location.search+location.hash); }catch(e){ return false; }
  return true;
})();

/* RABATT AUS DER ADRESSZEILE EINLOESEN, VOR der Wiederherstellung (portiert 16.09.2026).
   stelleKaufWiederHer() zeichnet die Kaufbox; ein Rabatt, der erst danach greift, liesse eine
   Box mit veralteten Zahlen stehen. Seit dem 24.09.2026 AUCH bei ?k= - die Nachfass-Mail
   bringt Konfiguration und Code in einem Link. Die Preisdrift-Pruefung haelt beides
   auseinander (ausLinkRabatt), siehe direktZurKasse(). */
if(!kauflinkWeiter) rabattLinkEinloesen();

if(!kauflinkWeiter && (ladeAusLink() || ladeStand())){
  /* Der Stand steht erst JETZT fest - die Kacheln der Bauteile-Seite sind weiter oben schon
     gezeichnet worden. Ohne diese Zeile stuenden ihre Knoepfe nach jedem Neuladen wieder auf
     "hinzufuegen", obwohl das Paket in der Konfiguration liegt. */
  if(typeof zubKnoepfeAktualisieren==='function') zubKnoepfeAktualisieren();
  const wiederhergestellt=stelleKaufWiederHer();
  /* EINHEITLICH, EGAL WIE MAN ANKOMMT (16.09.2026).

     Vorher hing es am Weg: Wer ueber einen Knopf kam, landete mit der Marke #los hier, und
     startFunnel() zeigte das fertige Ergebnis - die Marke fragt nicht nach dem Alter des
     Standes. Wer die Rechnerseite direkt aufrief, bekam den Fragebogen von vorn, sobald der
     Stand aelter als KAUF_MINUTEN war: stelleKaufWiederHer() steigt dann aus, weil standKauf
     nicht gesetzt ist. Zwei Wege, zwei Ergebnisse, und es sah nach einem Fehler aus.

     ZWEI VERSCHIEDENE DINGE, die vorher an derselben Frist hingen:
       - das ERGEBNIS wieder zeigen: gehoert dem Besucher, solange er die Antworten hat.
         Es steht ohnehin im Speicher, und sein Rechenweg veraltet nicht.
       - die KAUFAUSWAHL wiederherstellen: Services und Material, die er angehakt hatte.
         Die bleibt an der kurzen Frist - nach Stunden ungefragt einen gefuellten Warenkorb
         aufzubauen waere uebergriffig, und genau dafuer wurde sie eingefuehrt.

     Also: Ergebnis immer, Auswahl nur frisch. stummeWiederherstellung unterdrueckt dabei die
     Ereignisse, wie im Zwilling darueber - ein Seitenaufbau ist kein Abschluss. */
  if(!wiederhergestellt && finished && app){
    stummeWiederherstellung=true;
    try{ finish(); }catch(e){ /* kein Ergebnis darstellbar - dann bleibt der Fragebogen */ }
    finally { stummeWiederherstellung=false; }
  }
  syncResume();
  /* Nur wenn die Kaufbox wirklich steht: ohne sie gibt es weder Knopf noch Positionen,
     und ein Sprung ginge ins Leere. */
  if(ausLinkZurKasse && wiederhergestellt) direktZurKasse();
}
/* ============ EMPFEHLUNGS-ABZEICHEN AUF DER PRODUKTSEITE (16.09.2026) ============
   Sichtbar nur, wenn der Rechner durchlaufen wurde UND genau dieses Kit dabei herauskam.

   Die Empfehlung wird NICHT gespeichert, sondern neu gerechnet: routeAll() liest dieselben
   Antworten, die gerade wiederhergestellt wurden, und liefert dasselbe Ergebnis wie im
   Vergleich. Ein zweites Feld im Speicher koennte nur veralten - etwa wenn sich eine
   Auslegungsregel aendert und der alte Merker weiter ein anderes Kit empfiehlt.

   Steht NACH dem Wiederherstellen des Standes: vorher waere finished noch false und die
   Antworten leer. */
/* EMPFEHLUNG SICHTBAR MACHEN - an beiden Orten, aus einer Entscheidung.

   Auf der Produktseite steht die Huelle schon im Markup (#bwpEmpfehlung), auf dem
   Kits-Reiter wird die Pille hier erzeugt: renderKitDeep() baut die Karten beim Einlesen
   der Datei, und da ist der gespeicherte Stand noch nicht gelesen - die Funktion kann also
   gar nicht wissen, welches Kit empfohlen ist.

   WARUM NICHT EINFACH renderKitDeep() NOCHMAL: Die Karten tragen .reveal und werden von
   einem IntersectionObserver eingeblendet, der weiter oben schon lief. Frisch gebaute
   Karten kennt er nicht - sie blieben unsichtbar. Hier wird deshalb nur ergaenzt, was
   fehlt, und der vorhandene Zustand bleibt unberuehrt.

   ERST AUFRAEUMEN, DANN MARKIEREN: Im Theme-Editor laeuft das nach jedem Nachladen einer
   Section erneut. Ohne das Aufraeumen truege nach einem Wechsel der Antworten das alte Kit
   seine Empfehlung weiter - zwei empfohlene Karten nebeneinander.

   Steht NACH dem Wiederherstellen des Standes: vorher waere finished noch false und die
   Antworten leer. */
function empfehlungMarkieren(){
  let empfohlen=null;
  if(finished){ try{ const r=routeAll(); if(r) empfohlen=r.recommended||null; }catch(e){} }

  /* Produktseite: eine Karte, die weiss, zu welchem Kit sie gehoert. */
  const el=document.getElementById('bwpEmpfehlung');
  if(el){
    const karte=el.closest('.shop-info');
    const passt = !!empfohlen && el.dataset.kit===empfohlen;
    el.hidden=!passt;
    if(karte) karte.classList.toggle('ist-empfohlen',passt);
  }

  /* Kits-Reiter: drei bis vier Kacheln, hoechstens eine davon empfohlen. */
  document.querySelectorAll('#kitDeep .kitcard-deep').forEach(karte=>{
    const passt = !!empfohlen && karte.dataset.kit===empfohlen;
    karte.classList.toggle('ist-empfohlen',passt);
    let pille=karte.querySelector('.kd-empfehlung');
    if(passt && !pille){
      pille=document.createElement('span');
      pille.className='kd-empfehlung';
      pille.textContent='Empfehlung für dein Haus';
      karte.insertBefore(pille,karte.firstChild);
    } else if(!passt && pille){ pille.remove(); }
  });
}
empfehlungMarkieren();

initStickyObservers();
mountHelpFab();
/* NACHZIEHEN: Wer aus dem gespeicherten Stand oder einem Kauflink direkt in der Kaufbox
   landet, hat renderBuyBox() schon hinter sich - zu einem Zeitpunkt, als es den Hilfe-Knopf
   noch nicht gab. Ohne diese Zeile liefe die Uhr ausgerechnet fuer den Rueckkehrer nie. */
if(kaufBlaseAnstossen && document.querySelector('.buybox')) kaufBlaseAnstossen();
klickNetzSpannen();

/* ============================== RABATT-BALKEN UND ANMELDEFENSTER (15.09.2026) ==========
   Der Balken steht unter der Menueleiste, nur auf der Startseite. Klick oeffnet ein kleines
   Fenster; nach dem Absenden sieht der Kunde den Code.

   ALLES HIER IST NULLGEPRUEFT. Balken und Fenster existieren nur auf der Startseite, das
   Skript laeuft auf allen Seiten. Ein blanker Zugriff auf ein fehlendes Element wuerde das
   ganze Skript abbrechen - genau der Fehler, der am 03.09.2026 alles ausser dem Hero
   ausgeblendet hat.

   localStorage erst NACH einer Handlung (Anmeldung oder Wegklicken), nie beim blossen
   Seitenaufruf - dieselbe Linie wie bei leadRef(). */
const RB_SCHLUESSEL='bwp_rb';
function rbStand(){
  try{ const r=localStorage.getItem(RB_SCHLUESSEL); return r?JSON.parse(r):null; }catch(e){ return null; }
}
function rbSpeichern(o){ try{ localStorage.setItem(RB_SCHLUESSEL, JSON.stringify(o)); }catch(e){} }
/* DER CODE WANDERT NICHT MEHR IN DEN SPEICHER (15.09.2026, Betreiber-Entscheid).
   Bis hierher legte rbMerken() den Code direkt nach dem Absenden ab, und das Fenster zeigte
   ihn sofort. Damit war die Bestaetigungsmail ein Anhaengsel, das niemand anklicken musste -
   und die Werbe-Einwilligung blieb dauerhaft unbewiesen.
   Jetzt bekommt der Kunde den Code erst NACH dem Klick, per Mail. Gespeichert wird nur, DASS
   er sich angemeldet hat: daran haengt das Ausblenden des Balkens. Wer den Code hat, traegt
   ihn im Rechner ein - dort wird er ohnehin geprueft. */
function rbMerken(mail){ rbSpeichern({angemeldet:true, email:mail||null, ts:new Date().toISOString()}); }
/* Wegklicken ist ein Nein zu DIESEM Balken, nicht zum Newsletter - deshalb kein Lead. */
function rbWeg(){ const st=rbStand()||{}; st.weggeklickt=true; rbSpeichern(st); }

let __rbOeffner=null, __rbInert=[];
/* Eigene Fassung statt __kaufGeschwisterSperren(): die haengt an #cartModal.parentElement.
   Dieses Fenster liegt in einem <div id="shopify-section-...">-Wrapper, dort waeren die
   Geschwister die Elemente INNERHALB der Section - die Sperre ginge lautlos ins Leere. */
function __rbGeschwisterSperren(){
  const d=document.getElementById('rbModal');
  const halter=d && d.closest && d.closest('.wp-konfigurator');
  if(!halter) return;
  __rbInert=[];
  Array.prototype.forEach.call(halter.children, el=>{
    if(el.contains(d) || el.inert) return;
    try{ el.inert=true; __rbInert.push(el); }catch(e){}
  });
}
function __rbGeschwisterFreigeben(){ __rbInert.forEach(el=>{ try{ el.inert=false; }catch(e){} }); __rbInert=[]; }

function rbOeffnen(quelle){
  const m=document.getElementById('rbModal'); if(!m) return;
  __rbOeffner=document.activeElement;
  m.classList.remove('hidden');
  /* Eigener Name in der Sperr-Menge. 'kauf' wiederzuverwenden wuerde beim Schliessen die
     Sperre eines fremden Overlays aufreissen - der dokumentierte Fehler vom 02.09.2026. */
  scrollSperren('rabatt');
  __rbGeschwisterSperren();
  const t=document.getElementById('rbWerbungText'); if(t) t.textContent=WERBUNG_TEXT;
  const mail=document.getElementById('rbEmail');
  if(mail && !mail.value && A.email) mail.value=A.email;
  requestAnimationFrame(()=>{ const f=document.getElementById('rbEmail'); if(f) f.focus(); });
  track('rabatt_fenster_offen',{quelle:quelle||'unbekannt'});
}
function rbSchliessen(){
  const m=document.getElementById('rbModal'); if(!m || m.classList.contains('hidden')) return;
  m.classList.add('hidden');
  scrollFreigeben('rabatt');
  __rbGeschwisterFreigeben();
  if(__rbOeffner && __rbOeffner.focus) __rbOeffner.focus();
  __rbOeffner=null;
}

function wireRabattBalken(){
  const balken=document.getElementById('rbBalken');
  const modal=document.getElementById('rbModal');
  if(!balken && !modal) return;                 /* nicht die Startseite - nichts zu tun */

  /* Balken freigeben, wenn die Frist offen ist und der Kunde ihn nicht schon erledigt hat.
     Er wird mit hidden ausgeliefert; ohne JavaScript bleibt er weg, und das Fenster braeuchte
     JavaScript ohnehin - es wird also nichts versprochen, was nicht bedienbar waere. */
  const st=rbStand()||{};
  const knopf=document.getElementById('rbBalkenKnopf');

  /* AUS DER WILLKOMMENSMAIL GEKOMMEN (16.09.2026). Der Rabatt ist beim Seitenaufbau bereits
     eingeloest (rabattLinkEinloesen). Ein Balken, der jetzt weiter "Code sichern" anbietet,
     wuerde dem Kunden etwas verkaufen, das er gerade bekommen hat - und er wuesste nicht, dass
     der Abzug schon laeuft. Derselbe Balken wird deshalb zur Quittung und fuehrt dorthin, wo
     der Abzug zu sehen ist. Bewusst kein zweites Bauteil: der Balken steht an genau der
     richtigen Stelle, ist gestaltet und faellt ins Auge. */
  if(rabattKamAusLink){
    if(balken){
      balken.hidden=false;
      const satz=balken.querySelector('.rb-satz');
      const cta =balken.querySelector('.rb-cta');
      if(satz) satz.textContent='Dein Rabatt ist aktiv – den Abzug siehst du in deiner Konfiguration.';
      if(cta)  cta.textContent='Zu deiner Konfiguration \u2192';
    }
    /* Merker nachziehen: beim naechsten Besuch soll der Balken nicht wieder werben, und das
       Eingabefeld im anderen Kaufweg steht dann vorausgefuellt da. */
    rbSpeichern(Object.assign({}, st, {angemeldet:true, eingeloest:true, code:rabattCode()}));
    if(knopf) knopf.onclick=()=>{
      funnelOeffnen();
      const el=document.getElementById('rechnerCalc');
      if(el) el.scrollIntoView({behavior:'smooth',block:'start'});
      track('rabatt_balken_zum_rechner',{});
    };
  } else {
    /* Balken freigeben, wenn die Frist offen ist und der Kunde ihn nicht schon erledigt hat.
       Er wird mit hidden ausgeliefert; ohne JavaScript bleibt er weg, und das Fenster braeuchte
       JavaScript ohnehin - es wird also nichts versprochen, was nicht bedienbar waere. */
    if(balken && RABATT && rabattFristOffen() && !st.weggeklickt && !st.angemeldet){
      balken.hidden=false;
    }
    if(knopf) knopf.onclick=()=>rbOeffnen('balken');
  }
  const zu=document.getElementById('rbBalkenZu');
  if(zu) zu.onclick=()=>{ rbWeg(); if(balken) balken.hidden=true; track('rabatt_balken_weg',{}); };

  if(!modal) return;
  const schliessen=document.getElementById('rbSchliessen');
  if(schliessen) schliessen.onclick=rbSchliessen;
  modal.addEventListener('click',e=>{ if(e.target===modal) rbSchliessen(); });
  /* Escape nur bei offenem Fenster - ein unbedingter Handler wuerde in fremde Dialoge
     hineinregieren. Dieselbe Lehre wie bei closeCartModal(). */
  document.addEventListener('keydown',e=>{
    if(e.key!=='Escape') return;
    const m=document.getElementById('rbModal');
    if(m && !m.classList.contains('hidden')){ e.stopPropagation(); rbSchliessen(); }
  });

  const go=document.getElementById('rbGo');
  if(go) go.onclick=async()=>{
    const mailF=document.getElementById('rbEmail'), telF=document.getElementById('rbTel');
    const hakF=document.getElementById('rbWerbung'), done=document.getElementById('rbDone');
    const mail=((mailF&&mailF.value)||'').trim();
    const tel=((telF&&telF.value)||'').trim();
    if(!istEmail(mail)){
      done.innerHTML='<div class="banner warn">Bitte gib eine gültige E-Mail-Adresse an.</div>';
      if(mailF) mailF.focus(); return;
    }
    /* Telefon wie im Fachbetrieb-Weg: sechs Ziffern statt eines strengen Formats. Deutsche
       Schreibweisen sind zu vielfaeltig, und ein abgewiesener Kunde kostet mehr als eine
       Nummer, die jemand von Hand liest. */
    if(tel.replace(/[^0-9]/g,'').length<6){
      done.innerHTML='<div class="banner warn">Bitte gib eine Telefonnummer an &ndash; für Rückfragen zu deiner Konfiguration.</div>';
      if(telF) telF.focus(); return;
    }
    if(!(hakF&&hakF.checked)){
      done.innerHTML='<div class="banner warn">Ohne die Einwilligung dürfen wir dir nichts schicken &ndash; setz bitte den Haken.</div>';
      if(hakF) hakF.focus(); return;
    }
    go.disabled=true; done.innerHTML='<div class="banner ok">Einen Moment …</div>';
    A.email=mail; A.tel=tel; speichereStand();

    let ok=true;
    if(RABATT && RABATT.versand){
      try{
        ok = await submitLead('rabatt_anmeldung',{
          tel:tel, werbung_ok:true, werbung_text:WERBUNG_TEXT,
          werbung_ts:new Date().toISOString(),
          /* Ausdruecklich der Prozentcode (28.09.2026): rabattCode() nennt seit dem zweiten Code
             den eingeloesten - die Anmeldung gehoert aber immer zum Newsletter-Code. */
          rabatt_code:(RABATT?RABATT.code:null), rabatt_prozent:(RABATT?RABATT.prozent:null),
          quelle:'startseite_balken'
        });
      }catch(e){ console.warn('[rabatt] Versand fehlgeschlagen:',e); ok=false; }
    } else if(console && console.warn){
      /* Laut sagen statt still nichts tun: sonst haelt man den Aufbau fuer fertig. */
      console.warn('[rabatt] Einstellung "Anmeldung wirklich absenden" ist AUS -'
        +' es ging KEIN Lead raus. Eingaben:', {email:mail, tel:tel, code:(RABATT?RABATT.code:null)});
    }

    if(!ok){
      done.innerHTML='<div class="banner warn">Das hat gerade nicht geklappt. Versuch es bitte gleich noch einmal oder ruf uns an: '+esc(CONFIG.SUPPORT_PHONE)+'</div>';
      go.disabled=false; return;
    }
    rbMerken(mail);
    if(balken) balken.hidden=true;
    track('rabatt_anmeldung',{versand:!!(RABATT&&RABATT.versand)});
    /* Hier stand frueher der Code. Er steht jetzt in der Mail, die nach dem Bestaetigungsklick
       kommt - siehe rbMerken(). Angezeigt wird stattdessen die Adresse, an die geschickt wurde:
       das ist die einzige Angabe, die der Kunde an dieser Stelle noch pruefen kann, und ein
       Tippfehler in der Adresse ist der haeufigste Grund, warum nichts ankommt. */
    const form=document.getElementById('rbFormular'), erfolg=document.getElementById('rbErfolg');
    const anz=document.getElementById('rbCodeAnzeige');
    if(anz) anz.textContent=mail;
    if(form) form.hidden=true;
    if(erfolg){ erfolg.hidden=false; const k=document.getElementById('rbZumRechner'); if(k) k.focus(); }
  };

  /* Der Kopierknopf ist am 15.09.2026 entfallen: im Fenster steht kein Code mehr, sondern die
     Adresse, an die geschickt wurde. Es gibt nichts zu kopieren. Die Verdrahtung wurde
     mitentfernt statt null-geschuetzt stehenzulassen - sie war erst einen Tag alt und
     gehoerte zu genau diesem Knopf. */
  const weiter=document.getElementById('rbZumRechner');
  if(weiter) weiter.onclick=()=>{
    rbSchliessen();
    if(typeof startFunnel==='function'){ startFunnel(); return; }
    const z=document.getElementById('rechner'); if(z) z.scrollIntoView({behavior:'smooth'});
  };
}
wireRabattBalken();


/* ============================== THEME-EDITOR-SUPPORT ==============================
   Der Shopify-Customizer rendert bei jeder Einstellungs-Änderung NUR die betroffene
   Section neu und tauscht ihr HTML im DOM aus. Alles, was dieses Skript einmalig beim
   Seitenladen aufbaut, ist in der neuen Section dann weg: .reveal-Elemente bleiben auf
   opacity:0 (kein Observer mehr), [data-panel]-Sections stehen wieder auf hidden,
   Engine-Slots (#kitDeep, #svcDeep, #foerderCard, …) sind leer - die Section "verschwindet".
   Dieser Block hört auf die offiziellen Editor-Events und stellt den Zustand wieder her.
   Er läuft AUSSCHLIESSLICH im Customizer (Shopify.designMode) - die echte Seite bleibt unberührt. */
if(window.Shopify && Shopify.designMode){
  const panelOf=el=>{
    if(!el) return null;
    const p=(el.closest ? el.closest('[data-panel]') : null) || (el.querySelector ? el.querySelector('[data-panel]') : null);
    return p ? p.dataset.panel : null;
  };
  document.addEventListener('shopify:section:load',e=>{
    refreshPanels();
    renderLuLanding(); renderBauteilePanel(); renderKitDeep(); renderKitCompareTable(); renderServiceDeep(); renderFoerderMap(); renderFoerderCard();
    /* renderKitDeep() hat die Kacheln neu gebaut - ohne diese Zeile waere die Empfehlung
       darauf verschwunden, sobald im Theme-Editor irgendeine Section nachlaedt. */
    empfehlungMarkieren();
    initStickyObservers(); syncResume(); wireRabattBalken();
    showPanel(panelOf(e.target) || location.hash.slice(1) || 'rechner');
    e.target.querySelectorAll('.reveal').forEach(el=>el.classList.add('in'));
  });
  /* Klick auf eine Section/einen Block in der Editor-Seitenleiste: zum passenden Panel
     wechseln, sonst schaut der Redakteur auf ein verstecktes Element. */
  const jumpToPanel=e=>{ const id=panelOf(e.target); if(id && id!==(location.hash.slice(1)||'rechner')) showPanel(id); };
  document.addEventListener('shopify:section:select',jumpToPanel);
  document.addEventListener('shopify:block:select',jumpToPanel);
}


/* ================= WARENKORB-SCHUBLADE OBEN RECHTS (14.09.2026) =================
   ZEIGT NICHT DEN SHOPIFY-WARENKORB. Der wird erst beim Kaufabschluss gefuellt
   (/cart/clear.js + /cart/add.js in depositCheckout) - waehrend der Konfiguration ist er
   leer. Ein Symbol, das ihn liest, staende immer auf null und waere schlimmer als keines.

   Gezeigt wird die laufende Auswahl: Kit, Warmwasserspeicher, Zubehoer, Services. Quelle
   sind dieselben Variablen, aus denen auch die Kaufbox rechnet - kein zweiter Zustand, der
   auseinanderlaufen koennte.

   Beide Wege sind beruecksichtigt: der Funnel (chosenCandidate/chosenServices) und der
   Direktkauf auf /pages/produkt (directCand/directServices). chosenExtras teilen sich beide.
   ============================================================================== */
/* DAS BILD EINER WARENKORB-POSITION (12.10.2026, Vorgabe Claras: "links die Produkte mit
   Bildern" - der grosse Warenkorb zeigt seine Positionen seitdem als Kacheln).

   DREI QUELLEN, IN DIESER REIHENFOLGE, UND KEINE VIERTE:
     1. KB_IMG[key]  - die Bauteil-Fotos aus den Herstellerdatenblaettern. Die Schluessel sind
        bewusst dieselben wie in EXTRAS (pump_gem, haus_ober, sp200 ...), deshalb trifft der
        direkte Zugriff ohne eine Zuordnungstabelle, die jemand pflegen muesste.
     2. Das Foto der ERSTEN Position der Stueckliste. Jedes Paket fuehrt sein Hauptprodukt
        vorn (siehe ZUBEHOER_PAKETE) - fuer die Pakete ohne eigenes Datenblattfoto ist das
        genau das Bild, das den Posten zeigt.
     3. Nichts. Dann steht die Kachel leer statt mit einem fremden Bild.

   KEIN PLATZHALTERBILD AUS DEM THEME: Ein erfundenes Foto an einer Position, die wir nicht
   bebildert haben, sagt etwas aus, das wir nicht belegen koennen. Die leere Kachel sagt die
   Wahrheit und faellt beim Pflegen auf. */
function korbBild(key, eintrag){
  if(KB_IMG[key]) return KB_IMG[key];
  const p = (eintrag && eintrag.paket) ? PAKET_VON[eintrag.paket] : null;
  const erste = (p && p.pos && p.pos.length) ? p.pos[0].img : null;
  return (erste && ZUB_IMG[erste]) || null;
}
function korbZeilen(){
  const zeilen=[];
  const kitKey = (typeof chosenCandidate!=='undefined' && chosenCandidate) ? chosenCandidate.kit
               : ((typeof directCand!=='undefined' && directCand) ? directCand : null);
  /* DAS KIT FUEHRT AUF SEINE PRODUKTSEITE (29.09.2026, Vorgabe Claras: "wenn man im Pop-up-
     Warenkorb schon ein Kit drin stehen hat, das klickbar machen - dann kommt man auf die
     jeweilige Produktseite").

     Die Adresse steht schon in PRODUCTS[<kit>].handle; sie ist dieselbe, aus der auch die
     Kit-Karten und das Navigationsmenue ihre Verweise bauen. Fehlt sie einmal, bleibt die
     Zeile Text - ein Verweis ins Leere waere schlechter als keiner. */
  if(kitKey && PRODUCTS[kitKey])
    zeilen.push({gruppe:'Kit', name:PRODUCTS[kitKey].name, menge:1, preis:PRODUCTS[kitKey].price,
      bild: IMG[kitKey]||null,
      url: PRODUCTS[kitKey].handle ? '/products/'+PRODUCTS[kitKey].handle : null});
  /* speicher() liest dieselbe Antwort wie die Kaufbox - so steht hier nie ein anderer
     Speicher als dort. */
  let sp=null; try{ sp=speicher(); }catch(e){}
  if(sp && PRODUCTS[sp])
    /* Eigene Ueberschrift statt unter "Kit" (Vorgabe 15.09.2026): Der Speicher ist eine eigene
       Entscheidung mit eigener Frage - genauso wie Pumpengruppe und Hauseinfuehrung. Unter
       "Kit" sah er aus, als gehoere er zum Lieferumfang und sei nicht abwaehlbar. */
    zeilen.push({gruppe:'Warmwasserspeicher', name:PRODUCTS[sp].name, menge:1, preis:PRODUCTS[sp].price,
      bild: korbBild(sp), entf:{art:'speicher'}});
  /* IN DER REIHENFOLGE DES KONFIGURATORS, NICHT IN DER DES ANKLICKENS (Vorgabe Claras
     25.09.2026: "im Pop-up-Fenster des Warenkorbs bitte so sortieren, wie es auch im
     Konfigurator sortiert ist - Warmwasserspeicher, Hauseinfuehrung, Pumpengruppen,
     hydraulischer Abgleich, Befuellung").

     Gelesen wurde bisher chosenExtras, und dessen Schluessel stehen in der Reihenfolge, in der
     sie gesetzt wurden. Wer erst eine Pumpengruppe und dann die Hauseinfuehrung anhakte, sah
     sie hier genau so - und weil die Schublade eine Ueberschrift setzt, sobald die Gruppe
     wechselt, konnte dieselbe Gruppe sogar zweimal erscheinen: einmal oben, einmal weiter
     unten, nachdem etwas dazwischen gewaehlt wurde.

     Gelaufen wird deshalb ueber EXTRAS. Dessen Reihenfolge ist die der Liste im Kasten -
     dieselbe Quelle, aus der beide Kaufwege ihre Gruppen bauen. Damit gibt es keine zweite
     Sortierregel, die irgendwann von der Liste abweicht: Wer dort eine Gruppe verschiebt,
     verschiebt sie hier mit.

     Der Warmwasserspeicher steht darueber und bleibt dort - er kommt nicht aus EXTRAS,
     sondern aus der Speicherfrage. */
  Object.keys(EXTRAS).forEach(k=>{
    const q=(typeof chosenExtras!=='undefined' && chosenExtras) ? chosenExtras[k] : 0;
    const e=EXTRAS[k]; if(!e || !(q>0)) return;
    zeilen.push({gruppe:e.group, name:e.name, menge:q, bild: korbBild(k,e),
      einheit: e.perMeter?'m':(e.perUnit||''), preis:e.price*q, ohneId:!e.variantId,
      entf:{art:'extra', key:k}});
  });
  const svc = (typeof chosenCandidate!=='undefined' && chosenCandidate)
    ? (typeof chosenServices!=='undefined' ? chosenServices : null)
    : (typeof directServices!=='undefined' ? directServices : null);
  /* Siehe servicesErreicht: vor dem Services-Schritt bleiben sie hier draussen. */
  if(servicesErreicht) [...(svc||[])].forEach(k=>{ const s=SERVICES[k]; if(!s) return;
    /* Die drei Pflicht-Services bekommen KEIN Kreuz: Ohne sie verfaellt die Foerderung, und
       der Konfigurator fragt beim Abwaehlen ausdruecklich nach (guardedUncheck). Dieselbe
       Frage aus der Schublade heraus zu stellen, waere ein Riegel an der falschen Stelle -
       abwaehlen laesst sich das weiterhin dort, wo die Begruendung danebensteht. */
    zeilen.push({gruppe:'Services', name:s.name, menge:1, preis:s.price,
      entf: FOERDER_CRITICAL.includes(k) ? null : {art:'service', key:k}}); });
  return zeilen;
}
/* Die Zahl am Knopf zaehlt POSITIONEN, nicht Stueck: "3" neben dem Symbol heisst drei
   verschiedene Dinge ausgewaehlt. Bei Metern und Stueckzahlen waere die Stueck-Summe
   irrefuehrend - 12 Meter Erdleitung sind kein Warenkorb mit zwoelf Sachen. */
/* Die Schublade faehrt auf, sobald eine POSITION DAZUKOMMT (Vorgabe 14.09.2026) - beim
   ersten Produkt und bei jedem weiteren. So landet das Gewaehlte sichtbar dort, statt nur
   die Zahl am Knopf hochzuzaehlen.

   Ausgeloest wird am Zuwachs, nicht am Stand: Wer etwas abwaehlt oder nur die Menge einer
   schon gewaehlten Position erhoeht, bekommt die Schublade NICHT ins Bild geschoben. Beides
   waere eine Unterbrechung ohne Neuigkeit - und beim Abwaehlen sogar eine, die das Gegenteil
   dessen zeigt, was gerade passiert ist.

   Die erste Zaehlung nach dem Laden oeffnet nie. Ein wiederhergestellter Stand aus einem
   frueheren Besuch haette die Schublade sonst beim Seitenaufbau aufgezogen, ohne dass jemand
   etwas angeklickt hat. */
let __korbZuletzt = 0;
let __korbErstZaehlung = true;
function bwpKorbZahl(){
  const el=document.getElementById('bwpKorbZahl');
  const n=korbZeilen().length;
  if(el){ el.textContent=String(n); el.hidden = n===0; }
  /* KEIN AUFPOPPEN MEHR BEIM ANHAKEN (Vorgabe 15.09.2026). Hier stand: Schublade aufziehen,
     sobald eine Position dazukommt. Jetzt faehrt sie erst am Ende auf - wenn man nach den
     Services alles zusammen in den Warenkorb legt. Waehrend des Auswaehlens unterbricht sie
     niemanden mehr; die Zahl am Knopf zaehlt trotzdem mit. */
  __korbErstZaehlung = false;
  __korbZuletzt = n;
  /* MITLAUFEN, SOLANGE DIE SCHUBLADE OFFEN IST (15.09.2026). Gezeichnet wurde bisher nur
     beim Aufziehen. Wer sie offen stehen liess und im Kasten daneben ein Haekchen wegnahm,
     sah die Position weiter in der Liste - samt Summe, die es nicht mehr gab. Genau der Fall,
     fuer den die Schublade da ist: danebenstehen und mitlaufen.
     Nur bei offener Schublade, sonst waere es Arbeit fuer etwas, das niemand sieht. */
  const dr=document.getElementById('bwpKorbDrawer');
  if(dr && dr.classList.contains('open')) bwpKorbZeichnen();
}
/* Geschuetztes Leerzeichen vor dem Euro-Zeichen. Als Name statt als unsichtbares Zeichen im
   Quelltext: Ein U+00A0 sieht im Editor aus wie ein normales Leerzeichen und faellt beim
   Suchen, Ersetzen und Vergleichen durch - genau das ist beim Umbau dieser Zeilen am
   13.10.2026 zweimal passiert. */
const NBSP=' ';
function bwpKorbZeichnen(){
  const body=document.getElementById('bwpKorbBody'); if(!body) return;
  /* Der Fuss steht AUSSERHALB der Scrollflaeche und traegt Summe, Foerderung und den
     Abschlussknopf (Vorgabe 15.09.2026: der Preisteil bleibt stehen). Fehlt er - aeltere
     Fassung der Topbar -, wandert alles wie vorher ans Ende der Liste. */
  const fuss=document.getElementById('bwpKorbFuss');
  const zeilen=korbZeilen();
  const leerText='<p class="korb-leer">Noch nichts ausgewählt. Stell dir im Rechner dein Kit zusammen – was du wählst, erscheint hier.</p>';
  if(!zeilen.length){
    body.innerHTML=leerText;
    if(fuss) fuss.innerHTML='';
    /* DAS FENSTER MUSS MIT GERAEUMT WERDEN. Bis zum 12.10.2026 kehrte diese Zeile hier um,
       ohne die Flaechen des grossen Warenkorbs anzufassen: Wer dort die letzte Position
       entfernte, sah die Liste samt Summe stehen bleiben - einen Warenkorb, den es nicht
       mehr gab. In der Schublade fiel es nicht auf, weil sie geraeumt wurde. */
    const lListe=document.getElementById('bwpKorbFensterListe');
    const lSumme=document.getElementById('bwpKorbFensterSumme');
    if(lListe) lListe.innerHTML=leerText;
    if(lSumme) lSumme.innerHTML='';
    return;
  }
  let html='', gruppe='';
  zeilen.forEach(z=>{
    if(z.gruppe!==gruppe){ gruppe=z.gruppe; html+=`<div class="korb-gruppe">${esc(gruppe)}</div>`; }
    const menge = (z.menge>1 || z.einheit) ? `<span class="korb-menge">${z.menge}${z.einheit?' '+esc(z.einheit):'×'}</span>` : '';
    /* Kreuz nur, wo es auch etwas zu entfernen gibt. Das Kit selbst traegt keines: Es ist das,
       was hier konfiguriert wird - ohne Kit gibt es keine Zusammenstellung, nur eine leere
       Liste. Wer ein anderes will, waehlt es auf der Kit-Seite. */
    const weg = z.entf
      ? `<button type="button" class="korb-weg" data-art="${z.entf.art}"${z.entf.key?` data-key="${esc(z.entf.key)}"`:''} aria-label="${esc(z.name)} entfernen" title="Entfernen">✕</button>`
      : '<span class="korb-weg-leer" aria-hidden="true"></span>';
    /* Mit Adresse wird aus dem Namen ein Verweis - sonst bleibt er Text. Das Aussehen ist
       dasselbe; nur beim Ueberfahren zeigt die Unterstreichung, dass es weitergeht. */
    const nameHtml = z.url
      ? `<a class="korb-name korb-link" href="${esc(z.url)}">${esc(z.name)}</a>`
      : `<span class="korb-name">${esc(z.name)}</span>`;
    /* DAS BILD STEHT VORN IN DERSELBEN ZEILE (12.10.2026, Vorgabe Claras: "die Produkte bitte
       nicht in einzelne Kacheln tun, sondern tatsaechlich so lassen wie vorher, nur ein
       kleines Bild davor von dem Produkt einfuegen").

       alt="" IST ABSICHT: Der Name steht als Text direkt daneben. Eine Wiederholung im
       Alternativtext liest jedes Vorlesewerkzeug zweimal vor.

       OHNE BILD EIN LEERER PLATZHALTER statt gar nichts: Sonst ruecken die Namen der
       unbebilderten Zeilen nach links aus, und die Liste bekaeme zwei Kanten. */
    const bild = z.bild
      ? `<img class="korb-bild" src="${esc(z.bild)}" alt="" width="44" height="44" loading="lazy">`
      : '<span class="korb-bild korb-bild-leer" aria-hidden="true"></span>';
    html+=`<div class="korb-zeile">
      ${bild}${nameHtml}${menge}
      <span class="korb-preis">${fmt(z.preis,2)} €</span>${weg}
    </div>`;
  });
  const brutto=zeilen.reduce((a,z)=>a+z.preis,0);
  /* DER RABATT MUSS AUCH HIER GREIFEN (portiert 16.09.2026). Die Schublade rechnete ihre Summe
     selbst aus den Zeilen - ohne Abzug. Mit aktiver Aktion stuende hier "Dein Paket gesamt
     12.494 EUR", waehrend die Kaufbox daneben den rabattierten Betrag zeigt: zwei Zahlen auf
     EINEM Bildschirm, die sich widersprechen. Und weil die Foerderung darunter auf derselben
     Summe rechnet, waere auch sie zu hoch - eine Foerderung auf Kosten, die nie entstanden sind.
     Die Liefergebuehr bleibt hier draussen wie bisher: sie steht in der Schublade nicht als
     Zeile und ist ohnehin nicht rabattiert (Claras Begruendung darunter gilt unveraendert). */
  const korbRab=rabattBetrag(brutto);
  const summe=brutto-korbRab;
  /* ===== DER STEHENDE TEIL: DIE ZUSAMMENFASSUNG ================================
     REIHENFOLGE NACH CLARAS VORGABE (13.10.2026), von ihr so aufgeschrieben:

         Deine Zusammenfassung
         Start:
         -------
         *Gesamtsumme des Kits* (in bold)
         Versand + Betrag
         Förderung - Betrag
         ______
         Dein Preis nach Förderung

     DIE BEIDEN STRICHE SIND KEINE EIGENEN ELEMENTE, sondern die Oberkanten der beiden
     Summenzeilen: .korb-summe traegt eine kraeftige Linie, .korb-danach eine feine. So steht
     der Strich immer unmittelbar vor der Zeile, zu der er gehoert, und verrutscht nicht, wenn
     eine Zeile dazwischen wegfaellt.

     ZWISCHENSUMME UND RABATT STEHEN NICHT IN IHRER LISTE, weil es sie meistens nicht gibt.
     Wenn doch, gehoeren sie unmittelbar vor die Gesamtsumme: Sie rechnen auf sie zu.

     DIE SPALTE LIEST SICH VON OBEN NACH UNTEN DURCH (Reihenfolge seit dem 16.10.2026):
     Zwischensumme, minus Rabatt, plus Versand, Gesamtsumme, minus Foerderung, Preis danach.
     Die Foerderung rechnet weiterhin auf dem Paket OHNE Versand - eine Lieferung ist keine
     foerderfaehige Massnahme, und die Zeile sagt mit "x % KfW 458" auch, worauf sie sich
     bezieht. Die Reihenfolge ist eine Lesereihenfolge, keine Rechenreihenfolge. ===== */
  let fhtml='';
  const startTextKorb=startWunschText();
  if(startTextKorb)
    fhtml+=`<div class="korb-zeile korb-start"><span class="korb-name">Voraussichtlicher Start</span><span class="korb-startwert">${esc(startTextKorb)}</span></div>`;
  if(korbRab>0){
    fhtml+=`<div class="korb-summe korb-vorher"><span>Zwischensumme</span><span class="korb-preis">${fmt(brutto,2)}${NBSP}€</span></div>`;
    /* rabattText(): "10 % · Bezug" wie bisher, beim festen Betrag der Code (28.09.2026). */
    fhtml+=`<div class="korb-zeile korb-abzug"><span class="korb-name">Rabatt<small> ${esc(rabattText(NBSP))}</small></span><span class="korb-preis">– ${fmt(korbRab,2)}${NBSP}€</span></div>`;
  }
  /* DER VERSAND GEHOERT IN DIE AUFSCHLUESSELUNG (13.10.2026, Vorgabe Claras: "kannst du auch
     in der Zusammenfassung den Lieferpreis mit angeben"). Er stand bis dahin nicht drin, und
     das war ein echter Unterschied zur Kaufbox: Dort rechnet grandTotal die Gebuehr seit jeher
     mit, hier endete die Spalte ohne sie - bis zu 239,99 EUR zu niedrig.

     ABHOLUNG BEKOMMT AUCH EINE ZEILE, mit "kostenlos" statt eines Betrags: Dass sie nichts
     kostet, ist eine Information - eine fehlende Zeile waere eine Luecke, die man fuer ein
     Versehen halten koennte.

     ER STEHT SEIT DEM 16.10.2026 UEBER DER GESAMTSUMME UND WIRD DARIN MITGERECHNET (Vorgabe
     Claras: "kannst du bitte den Versand unter den Rabatt schieben und da dazurechnen. Das ist
     dann die Gesamtsumme ... darunter dann den Abzug durch die Foerderung und dann den Preis
     nach Foerderung").

     DIE SPALTE LIEST SICH DAMIT VON OBEN NACH UNTEN DURCH: Zwischensumme, minus Rabatt, plus
     Versand, Gesamtsumme - dann der Foerderabzug und der Preis danach. Vorher stand die
     Gesamtsumme VOR dem Versand und war damit eine Zwischenzahl, die man zweimal lesen musste.

     DIE FOERDERUNG RECHNET WEITER AUF summe, ALSO OHNE VERSAND, und das ist kein Versehen:
     Eine Lieferung ist keine foerderfaehige Massnahme. Die Zeile darunter nennt mit "x % KfW
     458" auch, worauf sich der Satz bezieht. Die Reihenfolge in der Spalte ist eine
     Lesereihenfolge, keine Rechenreihenfolge - genau deshalb steht dieser Absatz hier. */
  const lieferBetrag = (typeof deliveryFee==='function') ? deliveryFee() : 0;
  fhtml+=`<div class="korb-zeile korb-lieferung"><span class="korb-name">Versand<small> Lieferung deutschlandweit</small></span><span class="korb-preis">${lieferBetrag>0?'+ '+fmt(lieferBetrag,2)+NBSP+'€':'kostenlos'}</span></div>`;
  /* "Gesamtsumme" ohne "des Kits" (Vorgabe Claras vom 16.10.2026): Seit der Versand darin
     steckt, ist es nicht mehr die Summe des Kits allein. */
  fhtml+=`<div class="korb-summe"><span>Gesamtsumme</span><span class="korb-preis">${fmt(summe+lieferBetrag,2)}${NBSP}€</span></div>`;
  /* FOERDERRECHNUNG IM WARENKORB (Vorgabe 14.09.2026). Sie stand im Konfigurator unter den
     Services; dort ist sie raus, weil die Summe hierher gehoert.

     Dieselbe Formel wie in updateTotal() und cmUpdateTotal(): gedeckelte Kosten mal Quote, auf
     zehn Euro gerundet. DIE GRUNDLAGE IST DAS PAKET OHNE VERSAND - das war schon so, als die
     Liefergebuehr hier gar nicht stand, und bleibt so, seit sie darueber steht. */
  const kQuote = (typeof foerderQuote==='function') ? foerderQuote() : 0;
  if(kQuote && summe>0){
    const kBetrag=Math.round(Math.min(summe,foerderKostenCap())*kQuote/100/10)*10;
    fhtml+=`<div class="korb-zeile korb-abzug"><span class="korb-name">Förderung<small> ${kQuote} % KfW 458</small></span><span class="korb-preis">– ${fmt(kBetrag,2)}${NBSP}€</span></div>`;
    /* DER HINWEIS AUF DIE FEHLENDEN ANGABEN (14.10.2026, Vorgabe Claras).

       ER STEHT SEIT DEM NACHTRAG DIREKT UNTER DER FOERDERZEILE ("den Foerderungshinweis bitte
       im Warenkorb auch unter die Foerderung platzieren"). Zuerst sass er unter der
       Schlusszeile - der Gedanke war, die Rechnung nicht zu unterbrechen. Claras Platz ist der
       bessere: Der Hinweis erklaert EINE Zahl, naemlich den Prozentsatz in der Zeile darueber,
       und zwei Zeilen weiter unten muesste der Leser erst zurueckfinden, worauf er sich
       bezieht. Dass die Summenspalte dadurch einen Einschub bekommt, ist der kleinere Preis.

       ER NENNT DIE ZAHL, die ohne die Angaben verloren geht. "Deine Angaben koennten den Satz
       erhoehen" liest sich wie eine Floskel; "bis zu 80 % statt 30" ist eine Entscheidung.

       UND ER ERSCHEINT NUR, WENN ES WIRKLICH ETWAS ZU HOLEN GIBT: Wer alles beantwortet hat -
       oder beim Einkommen ausdruecklich "keine Angabe" gewaehlt hat - sieht ihn nicht. */
    const kLuecken=(typeof foerderLuecken==='function')?foerderLuecken():[];
    const kMoeglich=(typeof foerderQuoteMoeglich==='function')?foerderQuoteMoeglich():null;
    if(kLuecken.length && kMoeglich>kQuote){
      const kSatz = kLuecken.length>1
        ? `Wir wissen noch nicht, womit du heute heizt und wie hoch euer zu versteuerndes Einkommen ist. Beides zählt für die KfW.`
        : kLuecken[0]==='heizung'
          ? `Wir wissen noch nicht, womit du heute heizt. Eine Gas- oder Ölheizung bringt zusätzlich den Klimabonus.`
          : `Wir wissen noch nicht, wie hoch euer zu versteuerndes Einkommen ist. Darauf hängt der Einkommensbonus.`;
      fhtml+=`<p class="korb-fhinweis"><b>${kQuote} % ist der sichere Mindestsatz.</b> ${kSatz} Mit allen Angaben sind bis zu ${kMoeglich} % möglich &ndash; <a href="${reiterUrl('rechner')}">im Rechner dauert das zwei Minuten</a>.</p>`;
    }
    /* Die letzte Zahl ist die, die der Kunde zahlt - also mit Versand. Ohne ihn waere sie um
       bis zu 239,99 EUR zu niedrig, und zwar genau an der Stelle, auf die das Auge faellt. */
    fhtml+=`<div class="korb-summe korb-danach"><span>Dein Preis nach Förderung<small>voraussichtlich – du zahlst zuerst voll, die KfW erstattet danach</small></span><span class="korb-preis">${fmt(Math.max(summe-kBetrag,0)+lieferBetrag,2)}${NBSP}€</span></div>`;
  }
  /* HIER STAND BIS ZUM 16.10.2026 EIN ZWEITER ZWEIG MIT "Gesamt mit Versand". Er war noetig,
     solange die Gesamtsumme den Versand NICHT enthielt: Ohne Foerderzeile gab es sonst keine
     Zahl, die ihn mitzaehlte. Seit der Versand in der Gesamtsumme steckt, waere das eine
     Wiederholung derselben Zahl eine Zeile tiefer - also ersatzlos weg statt auf false
     gesetzt, ein Zweig, der nie laeuft, ist schlimmer als keiner. */
  /* Die beiden Hinweise haengen an der Liste und wandern mit ihr in beide Ansichten - in der
     Schublade unter die Positionen, im grossen Warenkorb unter die Warenspalte. Sie erklaeren,
     was darueber steht, und gehoeren deshalb nicht in die Summenspalte. */
  let hinweise='<p class="korb-hinweis">Außeneinheit und Inneneinheit (Hydro-Box) sind im Kit enthalten.</p>';
  /* Ehrlich bleiben, solange die Pakete kein Shopify-Produkt haben: Sie stehen in der
     Bestellung als Eigenschaft, werden aber nicht berechnet. Der Hinweis verschwindet von
     selbst, sobald in PAKET_VARIANTE IDs eingetragen sind. */
  if(zeilen.some(z=>z.ohneId))
    hinweise+='<p class="korb-hinweis"><b>Hinweis:</b> Die Bauteil-Pakete sind noch nicht bestellbar. Sie werden in der Bestellung vermerkt, aber noch nicht berechnet.</p>';
  html+=hinweise;
  /* ABSCHLUSS IN DER SCHUBLADE (15.09.2026). Seit der Knopf im Kasten nur noch hierher fuehrt,
     muss der Kauf hier weitergehen - sonst endet der Weg in einer Liste. Es ist derselbe
     Aufruf wie im Dialog (cartAddDirect/checkout), kein zweiter Bestellweg. */
  const kitDa = (typeof directCand!=='undefined' && directCand) || (typeof chosenCandidate!=='undefined' && chosenCandidate);
  /* ZWEI FUSSZEILEN, ZWEI ROLLEN (12.10.2026, Vorgabe Claras). Die Schublade ist seitdem die
     Zwischenuebersicht: Sie zeigt, was drin ist, und fuehrt weiter in den grossen Warenkorb.
     Gekauft wird dort - deshalb traegt nur das Fenster den Reservierungsknopf.

     Der Knopf der Schublade hiess bis heute wie der im Fenster und ging direkt in die Kasse.
     Beides an einer Stelle war genau die Verdichtung, die Clara aufgeloest haben wollte. */
  /* DIE SCHUBLADE TRAEGT SEIT DEM 15.10.2026 BEIDE KNOEPFE (Meldung Claras: "wo ist der
     Checkout-Button bei dem mobilen Warenkorb hin? Fueg den wieder hinzu").

     ES WAR MEIN FEHLER, UND ZWAR EIN LOGISCHER: Auf Claras Vorgabe ist der Weg in den grossen
     Warenkorb auf dem Telefon entfallen - dort war der Kaufknopf aber das EINZIGE, was hinter
     diesem Weg lag. Mit dem Weg verschwand also die Kasse, nicht nur ein Zwischenschritt.

     BEIDE IM MARKUP, EINER JE BREITE SICHTBAR: Auf dem Telefon der Kaufknopf, auf dem Desktop
     "Warenkorb ansehen" wie bisher - das Fenster zeigt dort zwei Spalten und wirklich mehr.
     Welcher erscheint, entscheidet das Stylesheet; so gibt es keinen zweiten Zweig im Code,
     der beim naechsten Umbau vergessen wird.

     EIGENE KENNUNG korbKasseDrawer: Der Knopf im Fenster heisst bwpKorbKasse, und zwei
     Elemente mit derselben id waeren ungueltig - getElementById faende nur das erste, und das
     ist je nach Reihenfolge mal der eine, mal der andere. Beide haengen unten am selben
     Handler. */
  const fussDrawer = fhtml + (kitDa
    ? `<button type="button" class="btn korb-kasse korb-kasse-drawer" id="bwpKorbKasseDrawer">${kaufKnopfText()}</button>`
      + `<button type="button" class="btn korb-weiter" id="bwpKorbWeiter">Warenkorb ansehen</button>`
    : '');
  /* ===== DER GROSSE WARENKORB IN ZWEI SPALTEN (12.10.2026, Vorgabe Claras am Beispiel eines
     Etsy-Warenkorbs: "links die Produkte mit Bildern und rechts den Preis ohne und mit
     Foerderung etc. und den Button 'Kostenlos reservieren'").

     ER TEILT SICH DIE LISTE MIT DER SCHUBLADE, UND ZWAR WIRKLICH DIESELBE. Zwischendurch
     bekam das Fenster ein eigenes Markup mit Kacheln; zurueckgenommen am selben Abend auf
     Vorgabe Claras: "die Produkte bitte nicht in einzelne Kacheln tun, sondern tatsaechlich
     so lassen wie vorher, nur ein kleines Bild davor". Damit ist es wieder EIN Markup fuer
     beide - das Bild steht in der Zeile und faellt in der schmalen Schublade per CSS weg.
     Zwei Aufbauten derselben Liste waeren zwei Stellen, an denen die naechste Aenderung
     haengenbleibt.

     NEU IST ALLEIN DIE AUFTEILUNG: Die Summen stehen rechts statt unten. Als Fuss waren sie
     eine feste Leiste, die mitwachsen musste; als Spalte stehen sie neben der Ware, bleiben
     beim Scrollen stehen - und darunter ist Platz fuer den Heizkosten-Rechner. ===== */
  const fussFenster = `<div class="kf-summe-karte">
    <div class="kf-summe-titel">Deine Zusammenfassung</div>
    ${fhtml}
    ${kitDa?`<button type="button" class="btn korb-kasse" id="bwpKorbKasse">${kaufKnopfText()}</button>`:''}
  </div>`;
  fhtml = fussDrawer;
  /* Die beiden Hinweise bleiben in der Liste: Sie erklaeren, was oben steht, und wuerden den
     stehenden Fuss auf die halbe Schublade wachsen lassen. */
  body.innerHTML=html;
  if(fuss) fuss.innerHTML=fussDrawer; else body.insertAdjacentHTML('beforeend', fussDrawer);
  /* Die beiden Spalten des grossen Warenkorbs. Die Flaechen gibt es nur, wenn die Topbar neu
     genug ist; aeltere Staende rendern einfach weiter nur die Schublade.

     GESCHRIEBEN WIRD IN DIE SPALTEN, NICHT IN IHREN BEHAELTER: Unter ihnen haengt der
     Heizkosten-Rechner, der beim Oeffnen einmal dorthin gezogen wird. Ein innerHTML auf dem
     umschliessenden Koerper wuerde ihn bei jeder Mengenaenderung wegraeumen - samt der
     Zahlen, die jemand gerade eingetippt hat. */
  const fBody=document.getElementById('bwpKorbFensterListe');
  const fFuss=document.getElementById('bwpKorbFensterSumme');
  if(fBody) fBody.innerHTML=html;
  if(fFuss) fFuss.innerHTML=fussFenster;
  /* Entfernen muss in BEIDEN Listen gehen - es ist derselbe Warenkorb. */
  [body, fBody].forEach(fl=>{ if(!fl) return;
    fl.querySelectorAll('.korb-weg').forEach(b=>b.addEventListener('click',()=>
      korbEntfernen(b.dataset.art, b.dataset.key)));
  });
  /* Der Weg aus der Schublade in den grossen Warenkorb. */
  const weiter=document.getElementById('bwpKorbWeiter');
  if(weiter) weiter.onclick=()=>{
    try{ track('korb_weiter',{}); }catch(e){}
    if(typeof bwpKorbFenster==='function') bwpKorbFenster(true);
  };
  /* Beide Kaufknoepfe - der im Fenster und der in der Schublade - haengen an derselben
     Behandlung. Welcher gerade sichtbar ist, entscheidet die Bildschirmbreite. */
  [document.getElementById('bwpKorbKasse'),
   document.getElementById('bwpKorbKasseDrawer')].forEach(kasse=>{
  if(kasse) kasse.onclick=()=>{
    /* WOHER DER KAUF KAM (16.09.2026). checkout_start feuert weiter unten in checkout() bzw.
       cartAddDirect() und sagt WAS gekauft wird, aber nicht, von welcher Flaeche aus. Die
       Schublade ist keine eigene Kaufoberflaeche im Sinne von kaufweg - sie liegt ueber allen.
       Deshalb hier ein eigener Marker davor: folgt auf korb_kasse ein checkout_start, kam der
       Kauf aus der Schublade. Bewusst kein Umbau von checkout(), nur um einen Parameter
       durchzureichen. */
    try{ track('korb_kasse',{}); }catch(e){}
    if(typeof directCand!=='undefined' && directCand) cartAddDirect(directCand, setBusy(kasse,'Checkout wird vorbereitet …'));
    else if(typeof chosenCandidate!=='undefined' && chosenCandidate) checkout();
  };
  });
  /* Die Kacheln auf der Bauteile-Seite zeigen denselben Stand - siehe
     zubKnoepfeAktualisieren(). Hier, weil diese Funktion bei JEDER Aenderung am Korb laeuft. */
  if(typeof zubKnoepfeAktualisieren==='function') zubKnoepfeAktualisieren();
}
/* Entfernt eine Position - moeglichst ueber das Bedienelement im Konfigurator selbst, nicht am
   Zustand vorbei. Ein ausgeloestes change-Ereignis durchlaeuft dieselbe Behandlung wie ein
   Klick von Hand: Menge zurueck auf null, Zeilenpreis geleert, Haken weg, Summen neu, Ereignis
   gemeldet. Wuerde ich hier direkt in chosenExtras schreiben, blieben Haken und Mengenanzeige
   stehen und zeigten etwas, das nicht mehr gilt.

   Der Rueckfall greift, wenn die Schublade ohne offenen Konfigurator benutzt wird - dann gibt
   es kein Bedienelement, und der Zustand wird unmittelbar geaendert. */
function korbEntfernen(art,key){
  /* ABWAHL IN DER SCHUBLADE SICHTBAR MACHEN (16.09.2026). extra_removed und service_removed
     gibt es seit langem fuer die Abwahl im Konfigurator. Die Schublade ist ein zweiter Weg zu
     derselben Handlung - und der interessantere: wer hier etwas herausnimmt, hat die Summe
     vor Augen. Ohne eigenes Ereignis waere genau diese Bewegung nicht von einer Abwahl im
     Kasten zu unterscheiden. */
  try{ track('korb_removed',{art:art, key:key||null}); }catch(e){}
  const neuRechnen=()=>{
    try{
      if(typeof directCand!=='undefined' && directCand) cmUpdateTotal(directCand);
      else if(typeof chosenCandidate!=='undefined' && chosenCandidate) updateTotal(chosenCandidate);
    }catch(e){}
  };
  if(art==='extra'){
    const cb=document.querySelector('input[type=checkbox][data-x="'+key+'"]');
    if(cb && cb.checked){ cb.checked=false; cb.dispatchEvent(new Event('change',{bubbles:true})); }
    else { delete chosenExtras[key]; neuRechnen(); }
  } else if(art==='service'){
    /* Die vier Oeltank-Varianten haben seit dem 02.10.2026 keine eigene Checkbox mehr, sondern
       haengen gemeinsam an einer Zeile mit Auswahlfeld. Ohne diesen Zweig fiele der Griff auf
       den Rueckfall darunter zurueck: Die Summe stimmte, aber im Kasten blieben Haken und
       Auswahl stehen - derselbe stille Fehler wie am 29.09.2026 bei der Speicherwahl. Beide
       Kaufwege koennen gleichzeitig im Dokument liegen, deshalb ALLE Sammelzeilen. */
    const oelRows=istOelKey(key) ? document.querySelectorAll('.oel-row') : [];
    if(oelRows.length){
      oelRows.forEach(row=>{
        const box=row.querySelector('input[data-oel]'), sel=row.querySelector('.oel-select');
        if(sel) sel.value='';
        if(box && box.checked){ box.checked=false; box.dispatchEvent(new Event('change',{bubbles:true})); }
      });
      if(typeof directServices!=='undefined') directServices.delete(key);
      if(typeof chosenServices!=='undefined') chosenServices.delete(key);
      neuRechnen();
      try{ speichereStand(); }catch(e){}
      return;
    }
    const cb=document.querySelector('input[type=checkbox][data-k="'+key+'"]');
    if(cb && cb.checked){ cb.checked=false; cb.dispatchEvent(new Event('change',{bubbles:true})); }
    else {
      if(typeof directServices!=='undefined') directServices.delete(key);
      if(typeof chosenServices!=='undefined') chosenServices.delete(key);
      neuRechnen();
    }
  } else if(art==='speicher'){
    /* "Keiner" ist eine der drei Auswahlmoeglichkeiten - der Klick darauf setzt zugleich die
       Markierung richtig, was ein Schreiben auf A.dhw allein nicht taete.

       DIESER GRIFF WAR SEIT DEM 21.09.2026 INS LEERE GEGANGEN und ist am 29.09.2026 berichtigt
       worden: Gesucht wurde '.spchips .chipbtn' mit dem Text "Kein Speicher" - die Chips tragen
       seit dem Umbau aber .af-chip, und der erste heisst "Keiner". Beides passte nicht mehr,
       also fand die Suche nichts und der Rueckfall lief: A.dhw auf 'nein', neu rechnen. Die
       Summe stimmte damit, die Markierung nicht - im Kasten blieb weiter "200 l" hervorgehoben,
       obwohl der Speicher aus dem Warenkorb genommen war.

       Aufgefallen beim Umstellen der Lieferung auf dieselbe Klasse: Danach haette '.spchips
       .chipbtn' auf der ganzen Seite nichts mehr getroffen. */
    const chip=[...document.querySelectorAll('.spchips .af-chip')]
      .find(b=>b.textContent.trim()==='Keiner');
    if(chip) chip.click();
    else { A.dhw='nein'; neuRechnen(); }
  }
  try{ speichereStand(); }catch(e){}
  bwpKorbZeichnen();
  bwpKorbZahl();
}
window.bwpKorbZeichnen=bwpKorbZeichnen;

/* ===== DER HEIZKOSTEN-RECHNER UEBERNIMMT, WAS SCHON BEANTWORTET IST (13.10.2026) =====
   Vorgabe Claras: "wenn man den Kitgroessen-Rechner schon gemacht hat, sind ja schon ein paar
   Fragen des Heizkostenrechners beantwortet worden. Wenn die im Kitgroessen-Rechner
   beantwortet wurden, fuell sie mit dem Wert direkt auch im Heizkostenrechner aus - im
   Pop-up-Warenkorb und auf dem Rechner-Reiter."

   GEFUELLT WIRD UEBER DIE OBERFLAECHE, NICHT UEBER DEN ZUSTAND DES RECHNERS. Das Skript
   bwp-heizkostenrechner.js haelt seine Zahlen in einem eigenen state und rechnet bei jeder
   Eingabe neu; wer von aussen in diesen state greift, hat eine zweite Stelle, die ihn kennt.
   Hier werden stattdessen die Felder gesetzt und ein input-Ereignis ausgeloest - also genau
   das, was ein Besucher auch tut. Der Rechner braucht dafuer keine Zeile Aenderung.

   WAS UEBERNOMMEN WIRD, und warum nur das:
     Heizart      A.energy kennt sieben Energietraeger, der Heizkostenrechner zwei (Gas, Oel).
                  Alles andere laesst ihn in Ruhe - "Pellets" als Gas zu fuehren waere eine
                  erfundene Antwort.
     Verbrauch    A.consumptionValue mal dem Heizwert der gewaehlten Einheit. Der Kunde darf
                  dort Kubikmeter angeben, der Heizkostenrechner will Kilowattstunden; die
                  Umrechnung steht in HEIZWERT und ist dieselbe, mit der auch die Heizlast
                  gerechnet wird.
     Anschaffung  die Summe des zusammengestellten Pakets, aus korbZeilen() - also genau das,
                  was im Warenkorb daneben steht. Nur mit Kit: ohne Kit waere es die Summe von
                  Zubehoer, und als "Anschaffungspreis laut Angebot" waere das falsch.
     Foerderung   foerderQuote(), aber nur wenn es dazu einen Knopf gibt. Der Rechner kennt
                  die Stufen aus dem Editor (0/30/46/80); eine Quote von 55 waere dort kein
                  Knopf, und einen zu erfinden hiesse, dem Kunden eine Stufe zu zeigen, die
                  die KfW nicht hat.

   ANGEFASSTE FELDER BLEIBEN UNANGETASTET. Verglichen wird gegen defaultValue - den Wert aus
   dem HTML - und gegen das, was zuletzt von hier kam. Weicht beides ab, hat der Besucher
   getippt, und dann gehoert das Feld ihm. Ohne diese Pruefung ueberschriebe der naechste Klick
   im Konfigurator seine Eingabe, waehrend er daneben steht.

   ES LAEUFT MEHRFACH, und das ist Absicht: auf dem Rechner-Reiter stehen beide Rechner auf
   EINER Seite, die Antworten kommen also erst nach dem Laden. Gezeichnet wird aber nur, wenn
   sich wirklich etwas geaendert hat - sonst liefe bei jedem Tastendruck im Verbrauchsfeld ein
   Neuaufbau des Diagramms daneben. */
const __hkrGesetzt = {};
function hkrFeld(wurzel, name, wert){
  const el=wurzel.querySelector('input[name="'+name+'"]'); if(!el) return false;
  const text=String(wert);
  if(el.value===text) return false;
  const vonUns = __hkrGesetzt[name]!==undefined && el.value===__hkrGesetzt[name];
  const unberuehrt = el.value===el.defaultValue;
  if(!vonUns && !unberuehrt) return false;
  el.value=text; __hkrGesetzt[name]=text; return true;
}
function bwpHkrVorbelegen(){
  const wurzel=document.getElementById('bwp-rechner'); if(!wurzel) return;
  /* Der Rechner baut die Foerderknoepfe selbst. Solange sie fehlen, ist sein Skript noch
     nicht durchgelaufen - dann hier nichts anfassen, der naechste Anlass kommt bestimmt. */
  const fWrap=wurzel.querySelector('#bwp-foerder');
  if(!fWrap || !fWrap.children.length) return;
  let geaendert=false;
  const uebernommen=[];

  if(A.energy==='gas' || A.energy==='oel'){
    const ziel = A.energy==='gas' ? 'gas' : 'oil';
    const knopf = wurzel.querySelector('[data-heiz="'+ziel+'"]');
    const aktivEl = wurzel.querySelector('[data-heiz][aria-pressed="true"]');
    const aktiv = aktivEl ? aktivEl.getAttribute('data-heiz') : null;
    /* Umgeschaltet wird nur, wenn der Rechner noch auf seiner Vorgabe steht (gas) oder auf
       dem, was zuletzt von hier kam. Hat der Besucher selbst umgeschaltet, bleibt es dabei.
       Der Klick schaltet die Felder um UND rechnet neu - deshalb vor dem Fuellen. */
    const darfSchalten = (__hkrGesetzt.heiz===undefined) ? (aktiv==='gas') : (__hkrGesetzt.heiz===aktiv);
    if(knopf && aktiv!==ziel && darfSchalten){
      knopf.click(); __hkrGesetzt.heiz=ziel; uebernommen.push('deine Heizart');
    }
    const hw = HEIZWERT[A.unit];
    if(A.consumptionValue>0 && hw){
      if(A.energy==='gas' && String(A.unit).indexOf('gas')===0){
        if(hkrFeld(wurzel,'gasKwh', Math.round(A.consumptionValue*hw.f))){ geaendert=true; uebernommen.push('deinen Gasverbrauch'); }
      } else if(A.energy==='oel' && A.unit==='oel_l'){
        if(hkrFeld(wurzel,'oilL', Math.round(A.consumptionValue))){ geaendert=true; uebernommen.push('deinen Ölverbrauch'); }
      }
    }
  }

  /* Der Preis des zusammengestellten Pakets - nur mit Kit, siehe oben. */
  try{
    const zeilen=korbZeilen();
    const hatKit=zeilen.some(z=>z.gruppe==='Kit');
    if(hatKit){
      const brutto=zeilen.reduce((a,z)=>a+z.preis,0);
      const summe=Math.round(brutto-rabattBetrag(brutto));
      if(summe>0 && hkrFeld(wurzel,'price', summe)){ geaendert=true; uebernommen.push('den Preis deines Pakets'); }
    }
  }catch(e){}

  /* DIE FOERDERQUOTE - UND WAS ZU TUN IST, WENN SIE AUF KEINE STUFE FAELLT.

     Der Heizkosten-Rechner kennt vier Stufen aus dem Editor (0 / 30 / 46 / 80). Der
     Konfigurator rechnet dagegen frei: 30 Grund + Klimabonus (16/12/8/4/0) + Einkommensbonus
     (0/10/30/40), gedeckelt. 46 und 80 fallen oft, aber 56, 42 oder 31 eben auch - und dann
     gibt es dort keinen Knopf.

     EINEN KNOPF ZU ERFINDEN WAERE DER NAHELIEGENDE FEHLER: Das Skript des Rechners sucht zu
     jeder Stufe ihre Beschreibung in seiner Liste und greift auf das erste Ergebnis zu. Eine
     Stufe, die es dort nicht gibt, liefert undefined - der Rechner bliebe beim naechsten
     Zeichnen stehen.

     GEWAEHLT WIRD DESHALB DIE GROESSTE STUFE, DIE DIE QUOTE NICHT UEBERSCHREITET. Nach unten
     und nicht nach oben: Weniger Zuschuss heisst laengere Amortisation - die Rechnung faellt
     also vorsichtiger aus statt schoener. Und der Unterschied wird benannt, nicht verschwiegen
     (siehe die Hinweiszeile am Ende). */
  try{
    const q=(typeof foerderQuote==='function') ? foerderQuote() : null;
    if(q){
      let beste=null;
      fWrap.querySelectorAll('button[data-f]').forEach(b=>{
        const v=+b.getAttribute('data-f');
        if(v<=q && (beste===null || v>+beste.getAttribute('data-f'))) beste=b;
      });
      const aktiv=fWrap.querySelector('button[aria-pressed="true"]');
      const aktivWert=aktiv?aktiv.getAttribute('data-f'):null;
      if(beste && aktivWert!==beste.getAttribute('data-f')
         && (__hkrGesetzt.foerder===undefined || __hkrGesetzt.foerder===aktivWert)){
        const stufe=beste.getAttribute('data-f');
        beste.click(); __hkrGesetzt.foerder=stufe;
        uebernommen.push(+stufe===q
          ? 'deine Förderquote ('+q+' %)'
          : 'deine Förderquote (berechnet '+q+' %, hier die nächstniedrigere Stufe '+stufe+' %)');
      }
    }
  }catch(e){}

  if(geaendert){
    const form=wurzel.querySelector('form');
    if(form) form.dispatchEvent(new Event('input',{bubbles:true}));
  }
  /* Die Zeile sagt, woher die Zahlen kommen. Ohne Ansage haelt der Besucher sie entweder fuer
     seine eigenen oder fuer geraten - beides waere falsch. */
  const hinweis=document.getElementById('bwp-uebernommen');
  if(hinweis && uebernommen.length){
    hinweis.textContent='Aus dem Kitgrößen-Rechner übernommen: '+uebernommen.join(', ')+'. Du kannst alles überschreiben.';
    hinweis.hidden=false;
  }
}
window.bwpHkrVorbelegen=bwpHkrVorbelegen;
/* Beim Laden einmal zaehlen - ein gespeicherter Stand aus localStorage ist dann schon da. */
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',bwpKorbZahl);
else bwpKorbZahl();


/* ============ DER RUECKWEG AUF DER KIT-SEITE (14.10.2026, Vorgabe Claras) ============

   templates/product.liquid liefert "Zurueck zu den Kits" und zeigt damit auf die Uebersicht
   /pages/produkt. Das ist richtig fuer jeden, der von dort kam - und falsch fuer den, der aus
   dem Rechner kommt: Der hat gerade seine Auslegung gemacht und will zu SEINER Auswahl
   zurueck, nicht in die allgemeine Liste.

   DER VERWEIS WIRD UMGEHAENGT UND NICHT VERDOPPELT: Zwei Rueckwege untereinander, die an
   verschiedene Orte fuehren, sind dieselbe Falle wie auf der Bauteile-Seite (siehe dort).

   NUR AUF DER SEITE DES ANGETIPPTEN KITS. Der Merker nennt das Kit, nicht nur "kam aus dem
   Rechner": Wer sich von dort zum 10-kW-Kit durchgeklickt hat und dann ueber die interne
   Verlinkung beim 12-kW-Kit landet, bekommt wieder den normalen Weg zur Uebersicht - der
   Rechnerstand gehoert zur anderen Seite.

   LIQUID KANN DAS NICHT ENTSCHEIDEN: Woher jemand kommt, steht erst im Browser fest. */
(function ergRueckwegVerweis(){
  let kit=null; try{ kit=sessionStorage.getItem(ERG_RUECKWEG); }catch(e){}
  if(!kit) return;
  const u=produktUrl(kit); if(!u) return;
  if(location.pathname!==u.split('?')[0]) return;
  const a=document.querySelector('a.shop-zurueck'); if(!a) return;
  a.setAttribute('href','/pages/rechner');
  a.innerHTML='<span class="sz-pfeil" aria-hidden="true">&larr;</span>Zurück zu deinem Ergebnis';
})();
